export const Items = {
    "None": [
        {
            "NO": 1,
            "EN": "None",
            "JP": "なし",
            "FR": "Aucun",
            "DE": "Kein",
            "ES": "Ningún objeto",
            "IT": "Niente",
            "KOR": "없음",
            "CHS": "无",
            "CHT": "無"
        }
    ],
    "Master Ball": [
        {
            "NO": 2,
            "EN": "Master Ball",
            "JP": "マスターボール",
            "FR": "Master Ball",
            "DE": "Meisterball",
            "ES": "Master Ball",
            "IT": "Master Ball",
            "KOR": "마스터볼",
            "CHS": "大师球",
            "CHT": "大師球"
        }
    ],
    "Ultra Ball": [
        {
            "NO": 3,
            "EN": "Ultra Ball",
            "JP": "ハイパーボール",
            "FR": "Hyper Ball",
            "DE": "Hyperball",
            "ES": "Ultra Ball",
            "IT": "Ultra Ball",
            "KOR": "하이퍼볼",
            "CHS": "高级球",
            "CHT": "高級球"
        },
        {
            "NO": 1589,
            "EN": "Ultra Ball",
            "JP": "ハイパーボール",
            "FR": "Hyper Ball",
            "DE": "Hyperball",
            "ES": "Ultra Ball",
            "IT": "Ultra Ball",
            "KOR": "하이퍼볼",
            "CHS": "高级球",
            "CHT": "高級球"
        },
        {
            "NO": 1652,
            "EN": "Ultra Ball",
            "JP": "ハイパーボール",
            "FR": "Hyper Ball",
            "DE": "Hyperball",
            "ES": "Ultra Ball",
            "IT": "Ultra Ball",
            "KOR": "하이퍼볼",
            "CHS": "高级球",
            "CHT": "高級球"
        }
    ],
    "Great Ball": [
        {
            "NO": 4,
            "EN": "Great Ball",
            "JP": "スーパーボール",
            "FR": "Super Ball",
            "DE": "Superball",
            "ES": "Super Ball",
            "IT": "Mega Ball",
            "KOR": "슈퍼볼",
            "CHS": "超级球",
            "CHT": "超級球"
        },
        {
            "NO": 1588,
            "EN": "Great Ball",
            "JP": "スーパーボール",
            "FR": "Super Ball",
            "DE": "Superball",
            "ES": "Super Ball",
            "IT": "Mega Ball",
            "KOR": "슈퍼볼",
            "CHS": "超级球",
            "CHT": "超級球"
        },
        {
            "NO": 1651,
            "EN": "Great Ball",
            "JP": "スーパーボール",
            "FR": "Super Ball",
            "DE": "Superball",
            "ES": "Super Ball",
            "IT": "Mega Ball",
            "KOR": "슈퍼볼",
            "CHS": "超级球",
            "CHT": "超級球"
        }
    ],
    "Poké Ball": [
        {
            "NO": 5,
            "EN": "Poké Ball",
            "JP": "モンスターボール",
            "FR": "Poké Ball",
            "DE": "Pokéball",
            "ES": "Poké Ball",
            "IT": "Poké Ball",
            "KOR": "몬스터볼",
            "CHS": "精灵球",
            "CHT": "精靈球"
        },
        {
            "NO": 1570,
            "EN": "Poké Ball",
            "JP": "モンスターボール",
            "FR": "Poké Ball",
            "DE": "Pokéball",
            "ES": "Poké Ball",
            "IT": "Poké Ball",
            "KOR": "몬스터볼",
            "CHS": "精灵球",
            "CHT": "精靈球"
        },
        {
            "NO": 1587,
            "EN": "Poké Ball",
            "JP": "モンスターボール",
            "FR": "Poké Ball",
            "DE": "Pokéball",
            "ES": "Poké Ball",
            "IT": "Poké Ball",
            "KOR": "몬스터볼",
            "CHS": "精灵球",
            "CHT": "精靈球"
        },
        {
            "NO": 1650,
            "EN": "Poké Ball",
            "JP": "モンスターボール",
            "FR": "Poké Ball",
            "DE": "Pokéball",
            "ES": "Poké Ball",
            "IT": "Poké Ball",
            "KOR": "몬스터볼",
            "CHS": "精灵球",
            "CHT": "精靈球"
        }
    ],
    "Safari Ball": [
        {
            "NO": 6,
            "EN": "Safari Ball",
            "JP": "サファリボール",
            "FR": "Safari Ball",
            "DE": "Safariball",
            "ES": "Safari Ball",
            "IT": "Safari Ball",
            "KOR": "사파리볼",
            "CHS": "狩猎球",
            "CHT": "狩獵球"
        }
    ],
    "Net Ball": [
        {
            "NO": 7,
            "EN": "Net Ball",
            "JP": "ネットボール",
            "FR": "Filet Ball",
            "DE": "Netzball",
            "ES": "Malla Ball",
            "IT": "Rete Ball",
            "KOR": "네트볼",
            "CHS": "捕网球",
            "CHT": "捕網球"
        }
    ],
    "Dive Ball": [
        {
            "NO": 8,
            "EN": "Dive Ball",
            "JP": "ダイブボール",
            "FR": "Scuba Ball",
            "DE": "Tauchball",
            "ES": "Buceo Ball",
            "IT": "Sub Ball",
            "KOR": "다이브볼",
            "CHS": "潜水球",
            "CHT": "潛水球"
        }
    ],
    "Nest Ball": [
        {
            "NO": 9,
            "EN": "Nest Ball",
            "JP": "ネストボール",
            "FR": "Faiblo Ball",
            "DE": "Nestball",
            "ES": "Nido Ball",
            "IT": "Minor Ball",
            "KOR": "네스트볼",
            "CHS": "巢穴球",
            "CHT": "巢穴球"
        }
    ],
    "Repeat Ball": [
        {
            "NO": 10,
            "EN": "Repeat Ball",
            "JP": "リピートボール",
            "FR": "Bis Ball",
            "DE": "Wiederball",
            "ES": "Acopio Ball",
            "IT": "Bis Ball",
            "KOR": "리피트볼",
            "CHS": "重复球",
            "CHT": "重複球"
        }
    ],
    "Timer Ball": [
        {
            "NO": 11,
            "EN": "Timer Ball",
            "JP": "タイマーボール",
            "FR": "Chrono Ball",
            "DE": "Timerball",
            "ES": "Turno Ball",
            "IT": "Timer Ball",
            "KOR": "타이머볼",
            "CHS": "计时球",
            "CHT": "計時球"
        }
    ],
    "Luxury Ball": [
        {
            "NO": 12,
            "EN": "Luxury Ball",
            "JP": "ゴージャスボール",
            "FR": "Luxe Ball",
            "DE": "Luxusball",
            "ES": "Lujo Ball",
            "IT": "Chic Ball",
            "KOR": "럭셔리볼",
            "CHS": "豪华球",
            "CHT": "豪華球"
        }
    ],
    "Premier Ball": [
        {
            "NO": 13,
            "EN": "Premier Ball",
            "JP": "プレミアボール",
            "FR": "Honor Ball",
            "DE": "Premierball",
            "ES": "Honor Ball",
            "IT": "Premier Ball",
            "KOR": "프리미어볼",
            "CHS": "纪念球",
            "CHT": "紀念球"
        }
    ],
    "Dusk Ball": [
        {
            "NO": 14,
            "EN": "Dusk Ball",
            "JP": "ダークボール",
            "FR": "Sombre Ball",
            "DE": "Finsterball",
            "ES": "Ocaso Ball",
            "IT": "Scuro Ball",
            "KOR": "다크볼",
            "CHS": "黑暗球",
            "CHT": "黑暗球"
        }
    ],
    "Heal Ball": [
        {
            "NO": 15,
            "EN": "Heal Ball",
            "JP": "ヒールボール",
            "FR": "Soin Ball",
            "DE": "Heilball",
            "ES": "Sana Ball",
            "IT": "Cura Ball",
            "KOR": "힐볼",
            "CHS": "治愈球",
            "CHT": "治癒球"
        }
    ],
    "Quick Ball": [
        {
            "NO": 16,
            "EN": "Quick Ball",
            "JP": "クイックボール",
            "FR": "Rapide Ball",
            "DE": "Flottball",
            "ES": "Veloz Ball",
            "IT": "Velox Ball",
            "KOR": "퀵볼",
            "CHS": "先机球",
            "CHT": "先機球"
        }
    ],
    "Cherish Ball": [
        {
            "NO": 17,
            "EN": "Cherish Ball",
            "JP": "プレシャスボール",
            "FR": "Mémoire Ball",
            "DE": "Jubelball",
            "ES": "Gloria Ball",
            "IT": "Pregio Ball",
            "KOR": "프레셔스볼",
            "CHS": "贵重球",
            "CHT": "貴重球"
        }
    ],
    "Potion": [
        {
            "NO": 18,
            "EN": "Potion",
            "JP": "キズぐすり",
            "FR": "Potion",
            "DE": "Trank",
            "ES": "Poción",
            "IT": "Pozione",
            "KOR": "상처약",
            "CHS": "伤药",
            "CHT": "傷藥"
        },
        {
            "NO": 1602,
            "EN": "Potion",
            "JP": "クラフトレシピ１６",
            "FR": "Potion",
            "DE": "Trank",
            "ES": "Poción",
            "IT": "Pozione",
            "KOR": "상처약",
            "CHS": "伤药",
            "CHT": "傷藥"
        }
    ],
    "Antidote": [
        {
            "NO": 19,
            "EN": "Antidote",
            "JP": "どくけし",
            "FR": "Antidote",
            "DE": "Gegengift",
            "ES": "Antídoto",
            "IT": "Antidoto",
            "KOR": "해독제",
            "CHS": "解毒药",
            "CHT": "解毒藥"
        }
    ],
    "Burn Heal": [
        {
            "NO": 20,
            "EN": "Burn Heal",
            "JP": "やけどなおし",
            "FR": "Anti-Brûle",
            "DE": "Feuerheiler",
            "ES": "Antiquemar",
            "IT": "Antiscottatura",
            "KOR": "화상치료제",
            "CHS": "灼伤药",
            "CHT": "灼傷藥"
        }
    ],
    "Ice Heal": [
        {
            "NO": 21,
            "EN": "Ice Heal",
            "JP": "こおりなおし",
            "FR": "Antigel",
            "DE": "Eisheiler",
            "ES": "Antihielo",
            "IT": "Antigelo",
            "KOR": "얼음상태치료제",
            "CHS": "解冻药",
            "CHT": "解凍藥"
        }
    ],
    "Awakening": [
        {
            "NO": 22,
            "EN": "Awakening",
            "JP": "ねむけざまし",
            "FR": "Réveil",
            "DE": "Aufwecker",
            "ES": "Despertar",
            "IT": "Sveglia",
            "KOR": "잠깨는약",
            "CHS": "解眠药",
            "CHT": "解眠藥"
        }
    ],
    "Paralyze Heal": [
        {
            "NO": 23,
            "EN": "Paralyze Heal",
            "JP": "まひなおし",
            "FR": "Anti-Para",
            "DE": "Para-Heiler",
            "ES": "Antiparalizador",
            "IT": "Antiparalisi",
            "KOR": "마비치료제",
            "CHS": "解麻药",
            "CHT": "解麻藥"
        }
    ],
    "Full Restore": [
        {
            "NO": 24,
            "EN": "Full Restore",
            "JP": "かいふくのくすり",
            "FR": "Guérison",
            "DE": "Top-Genesung",
            "ES": "Restaurar Todo",
            "IT": "Ricarica totale",
            "KOR": "회복약",
            "CHS": "全复药",
            "CHT": "全復藥"
        },
        {
            "NO": 1606,
            "EN": "Full Restore",
            "JP": "クラフトレシピ２０",
            "FR": "Guérison",
            "DE": "Top-Genesung",
            "ES": "Restaurar Todo",
            "IT": "Ricarica totale",
            "KOR": "회복약",
            "CHS": "全复药",
            "CHT": "全復藥"
        }
    ],
    "Max Potion": [
        {
            "NO": 25,
            "EN": "Max Potion",
            "JP": "まんたんのくすり",
            "FR": "Potion Max",
            "DE": "Top-Trank",
            "ES": "Poción Máxima",
            "IT": "Pozione max",
            "KOR": "풀회복약",
            "CHS": "全满药",
            "CHT": "全滿藥"
        },
        {
            "NO": 1605,
            "EN": "Max Potion",
            "JP": "クラフトレシピ１９",
            "FR": "Potion Max",
            "DE": "Top-Trank",
            "ES": "Poción Máxima",
            "IT": "Pozione max",
            "KOR": "풀회복약",
            "CHS": "全满药",
            "CHT": "全滿藥"
        }
    ],
    "Hyper Potion": [
        {
            "NO": 26,
            "EN": "Hyper Potion",
            "JP": "すごいキズぐすり",
            "FR": "Hyper Potion",
            "DE": "Hypertrank",
            "ES": "Hiperpoción",
            "IT": "Iperpozione",
            "KOR": "고급상처약",
            "CHS": "厉害伤药",
            "CHT": "厲害傷藥"
        },
        {
            "NO": 1604,
            "EN": "Hyper Potion",
            "JP": "クラフトレシピ１８",
            "FR": "Hyper Potion",
            "DE": "Hypertrank",
            "ES": "Hiperpoción",
            "IT": "Iperpozione",
            "KOR": "고급상처약",
            "CHS": "厉害伤药",
            "CHT": "厲害傷藥"
        }
    ],
    "Super Potion": [
        {
            "NO": 27,
            "EN": "Super Potion",
            "JP": "いいキズぐすり",
            "FR": "Super Potion",
            "DE": "Supertrank",
            "ES": "Superpoción",
            "IT": "Superpozione",
            "KOR": "좋은상처약",
            "CHS": "好伤药",
            "CHT": "好傷藥"
        },
        {
            "NO": 1603,
            "EN": "Super Potion",
            "JP": "クラフトレシピ１７",
            "FR": "Super Potion",
            "DE": "Supertrank",
            "ES": "Superpoción",
            "IT": "Superpozione",
            "KOR": "좋은상처약",
            "CHS": "好伤药",
            "CHT": "好傷藥"
        }
    ],
    "Full Heal": [
        {
            "NO": 28,
            "EN": "Full Heal",
            "JP": "なんでもなおし",
            "FR": "Total Soin",
            "DE": "Hyperheiler",
            "ES": "Cura Total",
            "IT": "Cura totale",
            "KOR": "만병통치제",
            "CHS": "万灵药",
            "CHT": "萬靈藥"
        },
        {
            "NO": 1612,
            "EN": "Full Heal",
            "JP": "クラフトレシピ２６",
            "FR": "Total Soin",
            "DE": "Hyperheiler",
            "ES": "Cura Total",
            "IT": "Cura totale",
            "KOR": "만병통치제",
            "CHS": "万灵药",
            "CHT": "萬靈藥"
        }
    ],
    "Revive": [
        {
            "NO": 29,
            "EN": "Revive",
            "JP": "げんきのかけら",
            "FR": "Rappel",
            "DE": "Beleber",
            "ES": "Revivir",
            "IT": "Revitalizzante",
            "KOR": "기력의조각",
            "CHS": "活力碎片",
            "CHT": "活力碎片"
        },
        {
            "NO": 1613,
            "EN": "Revive",
            "JP": "クラフトレシピ２７",
            "FR": "Rappel",
            "DE": "Beleber",
            "ES": "Revivir",
            "IT": "Revitalizzante",
            "KOR": "기력의조각",
            "CHS": "活力碎片",
            "CHT": "活力碎片"
        }
    ],
    "Max Revive": [
        {
            "NO": 30,
            "EN": "Max Revive",
            "JP": "げんきのかたまり",
            "FR": "Rappel Max",
            "DE": "Top-Beleber",
            "ES": "Revivir Máximo",
            "IT": "Revitalizzante max",
            "KOR": "기력의덩어리",
            "CHS": "活力块",
            "CHT": "活力塊"
        },
        {
            "NO": 1614,
            "EN": "Max Revive",
            "JP": "クラフトレシピ２８",
            "FR": "Rappel Max",
            "DE": "Top-Beleber",
            "ES": "Revivir Máximo",
            "IT": "Revitalizzante max",
            "KOR": "기력의덩어리",
            "CHS": "活力块",
            "CHT": "活力塊"
        }
    ],
    "Fresh Water": [
        {
            "NO": 31,
            "EN": "Fresh Water",
            "JP": "おいしいみず",
            "FR": "Eau Fraîche",
            "DE": "Tafelwasser",
            "ES": "Agua Fresca",
            "IT": "Acqua fresca",
            "KOR": "맛있는물",
            "CHS": "美味之水",
            "CHT": "美味之水"
        }
    ],
    "Soda Pop": [
        {
            "NO": 32,
            "EN": "Soda Pop",
            "JP": "サイコソーダ",
            "FR": "Soda Cool",
            "DE": "Sprudel",
            "ES": "Refresco",
            "IT": "Gassosa",
            "KOR": "미네랄사이다",
            "CHS": "劲爽汽水",
            "CHT": "勁爽汽水"
        }
    ],
    "Lemonade": [
        {
            "NO": 33,
            "EN": "Lemonade",
            "JP": "ミックスオレ",
            "FR": "Limonade",
            "DE": "Limonade",
            "ES": "Limonada",
            "IT": "Lemonsucco",
            "KOR": "후르츠밀크",
            "CHS": "果汁牛奶",
            "CHT": "果汁牛奶"
        }
    ],
    "Moomoo Milk": [
        {
            "NO": 34,
            "EN": "Moomoo Milk",
            "JP": "モーモーミルク",
            "FR": "Lait Meumeu",
            "DE": "Kuhmuh-Milch",
            "ES": "Leche Mu-mu",
            "IT": "Latte Mumu",
            "KOR": "튼튼밀크",
            "CHS": "哞哞鲜奶",
            "CHT": "哞哞鮮奶"
        }
    ],
    "Energy Powder": [
        {
            "NO": 35,
            "EN": "Energy Powder",
            "JP": "ちからのこな",
            "FR": "Poudrénergie",
            "DE": "Energiestaub",
            "ES": "Polvo Energía",
            "IT": "Polvenergia",
            "KOR": "힘의가루",
            "CHS": "元气粉",
            "CHT": "元氣粉"
        }
    ],
    "Energy Root": [
        {
            "NO": 36,
            "EN": "Energy Root",
            "JP": "ちからのねっこ",
            "FR": "Racinénergie",
            "DE": "Kraftwurzel",
            "ES": "Raíz Energía",
            "IT": "Radicenergia",
            "KOR": "힘의뿌리",
            "CHS": "元气根",
            "CHT": "元氣根"
        }
    ],
    "Heal Powder": [
        {
            "NO": 37,
            "EN": "Heal Powder",
            "JP": "ばんのうごな",
            "FR": "Poudre Soin",
            "DE": "Heilpuder",
            "ES": "Polvo Curación",
            "IT": "Polvocura",
            "KOR": "만능가루",
            "CHS": "万能粉",
            "CHT": "萬能粉"
        }
    ],
    "Revival Herb": [
        {
            "NO": 38,
            "EN": "Revival Herb",
            "JP": "ふっかつそう",
            "FR": "Herbe Rappel",
            "DE": "Vitalkraut",
            "ES": "Hierba Revivir",
            "IT": "Vitalerba",
            "KOR": "부활초",
            "CHS": "复活草",
            "CHT": "復活草"
        }
    ],
    "Ether": [
        {
            "NO": 39,
            "EN": "Ether",
            "JP": "ピーピーエイド",
            "FR": "Huile",
            "DE": "Äther",
            "ES": "Éter",
            "IT": "Etere",
            "KOR": "PP에이드",
            "CHS": "ＰＰ单项小补剂",
            "CHT": "ＰＰ單項小補劑"
        }
    ],
    "Max Ether": [
        {
            "NO": 40,
            "EN": "Max Ether",
            "JP": "ピーピーリカバー",
            "FR": "Huile Max",
            "DE": "Top-Äther",
            "ES": "Éter Máximo",
            "IT": "Etere max",
            "KOR": "PP회복",
            "CHS": "ＰＰ单项全补剂",
            "CHT": "ＰＰ單項全補劑"
        },
        {
            "NO": 1615,
            "EN": "Max Ether",
            "JP": "クラフトレシピ２９",
            "FR": "Soin PP",
            "DE": "Ätherpillen",
            "ES": "Píldora Éter",
            "IT": "Tonico PP",
            "KOR": "PP회복",
            "CHS": "ＰＰ单项全补剂",
            "CHT": "ＰＰ單項全補劑"
        }
    ],
    "Elixir": [
        {
            "NO": 41,
            "EN": "Elixir",
            "JP": "ピーピーエイダー",
            "FR": "Élixir",
            "DE": "Elixier",
            "ES": "Elixir",
            "IT": "Elisir",
            "KOR": "PP에이더",
            "CHS": "ＰＰ多项小补剂",
            "CHT": "ＰＰ多項小補劑"
        }
    ],
    "Max Elixir": [
        {
            "NO": 42,
            "EN": "Max Elixir",
            "JP": "ピーピーマックス",
            "FR": "Élixir Max",
            "DE": "Top-Elixier",
            "ES": "Elixir Máximo",
            "IT": "Elisir max",
            "KOR": "PP맥스",
            "CHS": "ＰＰ多项全补剂",
            "CHT": "ＰＰ多項全補劑"
        },
        {
            "NO": 1616,
            "EN": "Max Elixir",
            "JP": "クラフトレシピ３０",
            "FR": "Maxi Soin PP",
            "DE": "Elixierpillen",
            "ES": "Píldora Elixir",
            "IT": "Tonico PP Max",
            "KOR": "PP맥스",
            "CHS": "ＰＰ多项全补剂",
            "CHT": "ＰＰ多項全補劑"
        }
    ],
    "Lava Cookie": [
        {
            "NO": 43,
            "EN": "Lava Cookie",
            "JP": "フエンせんべい",
            "FR": "Lava Cookie",
            "DE": "Lavakeks",
            "ES": "Galleta Lava",
            "IT": "Lavottino",
            "KOR": "용암전병",
            "CHS": "釜炎仙贝",
            "CHT": "釜炎仙貝"
        }
    ],
    "Berry Juice": [
        {
            "NO": 44,
            "EN": "Berry Juice",
            "JP": "きのみジュース",
            "FR": "Jus de Baie",
            "DE": "Beerensaft",
            "ES": "Zumo de Baya",
            "IT": "Succo di bacca",
            "KOR": "나무열매쥬스",
            "CHS": "树果汁",
            "CHT": "樹果汁"
        }
    ],
    "Sacred Ash": [
        {
            "NO": 45,
            "EN": "Sacred Ash",
            "JP": "せいなるはい",
            "FR": "Cendre Sacrée",
            "DE": "Zauberasche",
            "ES": "Ceniza Sagrada",
            "IT": "Cenere magica",
            "KOR": "성스러운분말",
            "CHS": "圣灰",
            "CHT": "聖灰"
        }
    ],
    "HP Up": [
        {
            "NO": 46,
            "EN": "HP Up",
            "JP": "マックスアップ",
            "FR": "PV Plus",
            "DE": "KP-Plus",
            "ES": "Más PS",
            "IT": "PS-su",
            "KOR": "맥스업",
            "CHS": "ＨＰ增强剂",
            "CHT": "ＨＰ增強劑"
        }
    ],
    "Protein": [
        {
            "NO": 47,
            "EN": "Protein",
            "JP": "タウリン",
            "FR": "Protéine",
            "DE": "Protein",
            "ES": "Proteína",
            "IT": "Proteina",
            "KOR": "타우린",
            "CHS": "攻击增强剂",
            "CHT": "攻擊增強劑"
        }
    ],
    "Iron": [
        {
            "NO": 48,
            "EN": "Iron",
            "JP": "ブロムヘキシン",
            "FR": "Fer",
            "DE": "Eisen",
            "ES": "Hierro",
            "IT": "Ferro",
            "KOR": "사포닌",
            "CHS": "防御增强剂",
            "CHT": "防禦增強劑"
        }
    ],
    "Carbos": [
        {
            "NO": 49,
            "EN": "Carbos",
            "JP": "インドメタシン",
            "FR": "Carbone",
            "DE": "Carbon",
            "ES": "Carburante",
            "IT": "Carburante",
            "KOR": "알칼로이드",
            "CHS": "速度增强剂",
            "CHT": "速度增強劑"
        }
    ],
    "Calcium": [
        {
            "NO": 50,
            "EN": "Calcium",
            "JP": "リゾチウム",
            "FR": "Calcium",
            "DE": "Kalzium",
            "ES": "Calcio",
            "IT": "Calcio",
            "KOR": "리보플라빈",
            "CHS": "特攻增强剂",
            "CHT": "特攻增強劑"
        }
    ],
    "Rare Candy": [
        {
            "NO": 51,
            "EN": "Rare Candy",
            "JP": "ふしぎなアメ",
            "FR": "Super Bonbon",
            "DE": "Sonderbonbon",
            "ES": "Caramelo Raro",
            "IT": "Caramella rara",
            "KOR": "이상한사탕",
            "CHS": "神奇糖果",
            "CHT": "神奇糖果"
        }
    ],
    "PP Up": [
        {
            "NO": 52,
            "EN": "PP Up",
            "JP": "ポイントアップ",
            "FR": "PP Plus",
            "DE": "AP-Plus",
            "ES": "Más PP",
            "IT": "PP-su",
            "KOR": "포인트업",
            "CHS": "ＰＰ提升剂",
            "CHT": "ＰＰ提升劑"
        }
    ],
    "Zinc": [
        {
            "NO": 53,
            "EN": "Zinc",
            "JP": "キトサン",
            "FR": "Zinc",
            "DE": "Zink",
            "ES": "Zinc",
            "IT": "Zinco",
            "KOR": "키토산",
            "CHS": "特防增强剂",
            "CHT": "特防增強劑"
        }
    ],
    "PP Max": [
        {
            "NO": 54,
            "EN": "PP Max",
            "JP": "ポイントマックス",
            "FR": "PP Max",
            "DE": "AP-Top",
            "ES": "PP Máximos",
            "IT": "PP-max",
            "KOR": "포인트맥스",
            "CHS": "ＰＰ极限提升剂",
            "CHT": "ＰＰ極限提升劑"
        }
    ],
    "Old Gateau": [
        {
            "NO": 55,
            "EN": "Old Gateau",
            "JP": "もりのヨウカン",
            "FR": "Vieux Gâteau",
            "DE": "Spezialität",
            "ES": "Barrita Plus",
            "IT": "Dolce gateau",
            "KOR": "숲의양갱",
            "CHS": "森之羊羹",
            "CHT": "森之羊羹"
        },
        {
            "NO": 1610,
            "EN": "Old Gateau",
            "JP": "クラフトレシピ２４",
            "FR": "Vieux Gâteau",
            "DE": "Spezialität",
            "ES": "Barrita Plus",
            "IT": "Dolce gateau",
            "KOR": "숲의양갱",
            "CHS": "森之羊羹",
            "CHT": "森之羊羹"
        }
    ],
    "Guard Spec.": [
        {
            "NO": 56,
            "EN": "Guard Spec.",
            "JP": "エフェクトガード",
            "FR": "Garde-Stats",
            "DE": "Megablock",
            "ES": "Protección X",
            "IT": "Superguardia",
            "KOR": "이펙트가드",
            "CHS": "能力防守",
            "CHT": "能力防守"
        }
    ],
    "Dire Hit": [
        {
            "NO": 57,
            "EN": "Dire Hit",
            "JP": "クリティカット",
            "FR": "Muscle +",
            "DE": "X-Volltreffer",
            "ES": "Crítico X",
            "IT": "Supercolpo",
            "KOR": "크리티컬커터",
            "CHS": "要害攻击",
            "CHT": "要害攻擊"
        },
        {
            "NO": 1564,
            "EN": "Dire Hit",
            "JP": "クリティカッター",
            "FR": "Muscle +",
            "DE": "Treffervitamine",
            "ES": "Gragea Crítica",
            "IT": "Supercolpo",
            "KOR": "크리티컬커터",
            "CHS": "要害攻击",
            "CHT": "要害攻擊"
        },
        {
            "NO": 1620,
            "EN": "Dire Hit",
            "JP": "クラフトレシピ３５",
            "FR": "Muscle +",
            "DE": "Treffervitamine",
            "ES": "Gragea Crítica",
            "IT": "Supercolpo",
            "KOR": "크리티컬커터",
            "CHS": "要害攻击",
            "CHT": "要害攻擊"
        }
    ],
    "X Attack": [
        {
            "NO": 58,
            "EN": "X Attack",
            "JP": "プラスパワー",
            "FR": "Attaque +",
            "DE": "X-Angriff",
            "ES": "Ataque X",
            "IT": "Attacco X",
            "KOR": "플러스파워",
            "CHS": "力量强化",
            "CHT": "力量強化"
        }
    ],
    "X Defense": [
        {
            "NO": 59,
            "EN": "X Defense",
            "JP": "ディフェンダー",
            "FR": "Défense +",
            "DE": "X-Verteidigung",
            "ES": "Defensa X",
            "IT": "Difesa X",
            "KOR": "디펜드업",
            "CHS": "防御强化",
            "CHT": "防禦強化"
        }
    ],
    "X Speed": [
        {
            "NO": 60,
            "EN": "X Speed",
            "JP": "スピーダー",
            "FR": "Vitesse +",
            "DE": "X-Initiative",
            "ES": "Velocidad X",
            "IT": "Velocità X",
            "KOR": "스피드업",
            "CHS": "速度强化",
            "CHT": "速度強化"
        }
    ],
    "X Accuracy": [
        {
            "NO": 61,
            "EN": "X Accuracy",
            "JP": "ヨクアタール",
            "FR": "Précision +",
            "DE": "X-Genauigkeit",
            "ES": "Precisión X",
            "IT": "Precisione X",
            "KOR": "잘-맞히기",
            "CHS": "命中强化",
            "CHT": "命中強化"
        }
    ],
    "X Sp. Atk": [
        {
            "NO": 62,
            "EN": "X Sp. Atk",
            "JP": "スペシャルアップ",
            "FR": "Atq. Spé. +",
            "DE": "X-Sp.-Ang.",
            "ES": "Ataque Especial X",
            "IT": "Attacco Speciale X",
            "KOR": "스페셜업",
            "CHS": "特攻强化",
            "CHT": "特攻強化"
        }
    ],
    "X Sp. Def": [
        {
            "NO": 63,
            "EN": "X Sp. Def",
            "JP": "スペシャルガード",
            "FR": "Déf. Spé. +",
            "DE": "X-Sp.-Vert.",
            "ES": "Defensa Especial X",
            "IT": "Difesa Speciale X",
            "KOR": "스페셜가드",
            "CHS": "特防强化",
            "CHT": "特防強化"
        }
    ],
    "Poké Doll": [
        {
            "NO": 64,
            "EN": "Poké Doll",
            "JP": "ピッピにんぎょう",
            "FR": "Poké Poupée",
            "DE": "Poképuppe",
            "ES": "Pokémuñeco",
            "IT": "Pokébambola",
            "KOR": "삐삐인형",
            "CHS": "皮皮玩偶",
            "CHT": "皮皮玩偶"
        }
    ],
    "Fluffy Tail": [
        {
            "NO": 65,
            "EN": "Fluffy Tail",
            "JP": "エネコのシッポ",
            "FR": "Queue Skitty",
            "DE": "Eneco-Rute",
            "ES": "Cola Skitty",
            "IT": "Coda Skitty",
            "KOR": "에나비꼬리",
            "CHS": "向尾喵的尾巴",
            "CHT": "向尾喵的尾巴"
        }
    ],
    "Blue Flute": [
        {
            "NO": 66,
            "EN": "Blue Flute",
            "JP": "あおいビードロ",
            "FR": "Flûte Bleue",
            "DE": "Blaue Flöte",
            "ES": "Flauta Azul",
            "IT": "Flauto blu",
            "KOR": "파랑비드로",
            "CHS": "蓝色玻璃哨",
            "CHT": "藍色玻璃哨"
        }
    ],
    "Yellow Flute": [
        {
            "NO": 67,
            "EN": "Yellow Flute",
            "JP": "きいろビードロ",
            "FR": "Flûte Jaune",
            "DE": "Gelbe Flöte",
            "ES": "Flauta Amarilla",
            "IT": "Flauto giallo",
            "KOR": "노랑비드로",
            "CHS": "黄色玻璃哨",
            "CHT": "黃色玻璃哨"
        }
    ],
    "Red Flute": [
        {
            "NO": 68,
            "EN": "Red Flute",
            "JP": "あかいビードロ",
            "FR": "Flûte Rouge",
            "DE": "Rote Flöte",
            "ES": "Flauta Roja",
            "IT": "Flauto rosso",
            "KOR": "빨강비드로",
            "CHS": "红色玻璃哨",
            "CHT": "紅色玻璃哨"
        }
    ],
    "Black Flute": [
        {
            "NO": 69,
            "EN": "Black Flute",
            "JP": "くろいビードロ",
            "FR": "Flûte Noire",
            "DE": "Schwarze Flöte",
            "ES": "Flauta Negra",
            "IT": "Flauto nero",
            "KOR": "검정비드로",
            "CHS": "黑色玻璃哨",
            "CHT": "黑色玻璃哨"
        }
    ],
    "White Flute": [
        {
            "NO": 70,
            "EN": "White Flute",
            "JP": "しろいビードロ",
            "FR": "Flûte Blanche",
            "DE": "Weiße Flöte",
            "ES": "Flauta Blanca",
            "IT": "Flauto bianco",
            "KOR": "하양비드로",
            "CHS": "白色玻璃哨",
            "CHT": "白色玻璃哨"
        }
    ],
    "Shoal Salt": [
        {
            "NO": 71,
            "EN": "Shoal Salt",
            "JP": "あさせのしお",
            "FR": "Sel Tréfonds",
            "DE": "Küstensalz",
            "ES": "Sal Cardumen",
            "IT": "Sale ondoso",
            "KOR": "여울소금",
            "CHS": "浅滩海盐",
            "CHT": "淺灘海鹽"
        }
    ],
    "Shoal Shell": [
        {
            "NO": 72,
            "EN": "Shoal Shell",
            "JP": "あさせのかいがら",
            "FR": "CoquilleTréfonds",
            "DE": "Küstenschale",
            "ES": "Concha Cardumen",
            "IT": "Gusciondoso",
            "KOR": "여울조개껍질",
            "CHS": "浅滩贝壳",
            "CHT": "淺灘貝殼"
        }
    ],
    "Red Shard": [
        {
            "NO": 73,
            "EN": "Red Shard",
            "JP": "あかいかけら",
            "FR": "Tesson Rouge",
            "DE": "Purpurstück",
            "ES": "Parte Roja",
            "IT": "Coccio rosso",
            "KOR": "빨강조각",
            "CHS": "红色碎片",
            "CHT": "紅色碎片"
        }
    ],
    "Blue Shard": [
        {
            "NO": 74,
            "EN": "Blue Shard",
            "JP": "あおいかけら",
            "FR": "Tesson Bleu",
            "DE": "Indigostück",
            "ES": "Parte Azul",
            "IT": "Coccio blu",
            "KOR": "파랑조각",
            "CHS": "蓝色碎片",
            "CHT": "藍色碎片"
        }
    ],
    "Yellow Shard": [
        {
            "NO": 75,
            "EN": "Yellow Shard",
            "JP": "きいろいかけら",
            "FR": "Tesson Jaune",
            "DE": "Gelbstück",
            "ES": "Parte Amarilla",
            "IT": "Coccio giallo",
            "KOR": "노랑조각",
            "CHS": "黄色碎片",
            "CHT": "黃色碎片"
        }
    ],
    "Green Shard": [
        {
            "NO": 76,
            "EN": "Green Shard",
            "JP": "みどりのかけら",
            "FR": "Tesson Vert",
            "DE": "Grünstück",
            "ES": "Parte Verde",
            "IT": "Coccio verde",
            "KOR": "초록조각",
            "CHS": "绿色碎片",
            "CHT": "綠色碎片"
        }
    ],
    "Super Repel": [
        {
            "NO": 77,
            "EN": "Super Repel",
            "JP": "シルバースプレー",
            "FR": "Super Repousse",
            "DE": "Superschutz",
            "ES": "Superrepelente",
            "IT": "Superrepellente",
            "KOR": "실버스프레이",
            "CHS": "白银喷雾",
            "CHT": "白銀噴霧"
        }
    ],
    "Max Repel": [
        {
            "NO": 78,
            "EN": "Max Repel",
            "JP": "ゴールドスプレー",
            "FR": "Repousse Max",
            "DE": "Top-Schutz",
            "ES": "Repelente Máximo",
            "IT": "Repellente max",
            "KOR": "골드스프레이",
            "CHS": "黄金喷雾",
            "CHT": "黃金噴霧"
        }
    ],
    "Escape Rope": [
        {
            "NO": 79,
            "EN": "Escape Rope",
            "JP": "あなぬけのヒモ",
            "FR": "Corde Sortie",
            "DE": "Fluchtseil",
            "ES": "Cuerda Huida",
            "IT": "Fune di fuga",
            "KOR": "동굴탈출로프",
            "CHS": "离洞绳",
            "CHT": "離洞繩"
        }
    ],
    "Repel": [
        {
            "NO": 80,
            "EN": "Repel",
            "JP": "むしよけスプレー",
            "FR": "Repousse",
            "DE": "Schutz",
            "ES": "Repelente",
            "IT": "Repellente",
            "KOR": "벌레회피스프레이",
            "CHS": "除虫喷雾",
            "CHT": "除蟲噴霧"
        }
    ],
    "Sun Stone": [
        {
            "NO": 81,
            "EN": "Sun Stone",
            "JP": "たいようのいし",
            "FR": "Pierre Soleil",
            "DE": "Sonnenstein",
            "ES": "Piedra Solar",
            "IT": "Pietrasolare",
            "KOR": "태양의돌",
            "CHS": "日之石",
            "CHT": "日之石"
        }
    ],
    "Moon Stone": [
        {
            "NO": 82,
            "EN": "Moon Stone",
            "JP": "つきのいし",
            "FR": "Pierre Lune",
            "DE": "Mondstein",
            "ES": "Piedra Lunar",
            "IT": "Pietralunare",
            "KOR": "달의돌",
            "CHS": "月之石",
            "CHT": "月之石"
        }
    ],
    "Fire Stone": [
        {
            "NO": 83,
            "EN": "Fire Stone",
            "JP": "ほのおのいし",
            "FR": "Pierre Feu",
            "DE": "Feuerstein",
            "ES": "Piedra Fuego",
            "IT": "Pietrafocaia",
            "KOR": "불꽃의돌",
            "CHS": "火之石",
            "CHT": "火之石"
        }
    ],
    "Thunder Stone": [
        {
            "NO": 84,
            "EN": "Thunder Stone",
            "JP": "かみなりのいし",
            "FR": "Pierre Foudre",
            "DE": "Donnerstein",
            "ES": "Piedra Trueno",
            "IT": "Pietratuono",
            "KOR": "천둥의돌",
            "CHS": "雷之石",
            "CHT": "雷之石"
        }
    ],
    "Water Stone": [
        {
            "NO": 85,
            "EN": "Water Stone",
            "JP": "みずのいし",
            "FR": "Pierre Eau",
            "DE": "Wasserstein",
            "ES": "Piedra Agua",
            "IT": "Pietraidrica",
            "KOR": "물의돌",
            "CHS": "水之石",
            "CHT": "水之石"
        }
    ],
    "Leaf Stone": [
        {
            "NO": 86,
            "EN": "Leaf Stone",
            "JP": "リーフのいし",
            "FR": "Pierre Plante",
            "DE": "Blattstein",
            "ES": "Piedra Hoja",
            "IT": "Pietrafoglia",
            "KOR": "리프의돌",
            "CHS": "叶之石",
            "CHT": "葉之石"
        }
    ],
    "Tiny Mushroom": [
        {
            "NO": 87,
            "EN": "Tiny Mushroom",
            "JP": "ちいさなキノコ",
            "FR": "Petit Champi",
            "DE": "Minipilz",
            "ES": "Miniseta",
            "IT": "Minifungo",
            "KOR": "작은버섯",
            "CHS": "小蘑菇",
            "CHT": "小蘑菇"
        }
    ],
    "Big Mushroom": [
        {
            "NO": 88,
            "EN": "Big Mushroom",
            "JP": "おおきなキノコ",
            "FR": "Gros Champi",
            "DE": "Riesenpilz",
            "ES": "Seta Grande",
            "IT": "Grande fungo",
            "KOR": "큰버섯",
            "CHS": "大蘑菇",
            "CHT": "大蘑菇"
        }
    ],
    "Pearl": [
        {
            "NO": 89,
            "EN": "Pearl",
            "JP": "しんじゅ",
            "FR": "Perle",
            "DE": "Perle",
            "ES": "Perla",
            "IT": "Perla",
            "KOR": "진주",
            "CHS": "珍珠",
            "CHT": "珍珠"
        }
    ],
    "Big Pearl": [
        {
            "NO": 90,
            "EN": "Big Pearl",
            "JP": "おおきなしんじゅ",
            "FR": "Grande Perle",
            "DE": "Riesenperle",
            "ES": "Perla Grande",
            "IT": "Grande perla",
            "KOR": "큰진주",
            "CHS": "大珍珠",
            "CHT": "大珍珠"
        }
    ],
    "Stardust": [
        {
            "NO": 91,
            "EN": "Stardust",
            "JP": "ほしのすな",
            "FR": "Poussière Étoile",
            "DE": "Sternenstaub",
            "ES": "Polvo Estelar",
            "IT": "Polvostella",
            "KOR": "별의모래",
            "CHS": "星星沙子",
            "CHT": "星星沙子"
        }
    ],
    "Star Piece": [
        {
            "NO": 92,
            "EN": "Star Piece",
            "JP": "ほしのかけら",
            "FR": "Morceau d’Étoile",
            "DE": "Sternenstück",
            "ES": "Trozo Estrella",
            "IT": "Pezzo stella",
            "KOR": "별의조각",
            "CHS": "星星碎片",
            "CHT": "星星碎片"
        },
        {
            "NO": 1595,
            "EN": "Star Piece",
            "JP": "クラフトレシピ１０",
            "FR": "Morceau d’Étoile",
            "DE": "Sternenstück",
            "ES": "Trozo Estrella",
            "IT": "Pezzo stella",
            "KOR": "별의조각",
            "CHS": "星星碎片",
            "CHT": "星星碎片"
        }
    ],
    "Nugget": [
        {
            "NO": 93,
            "EN": "Nugget",
            "JP": "きんのたま",
            "FR": "Pépite",
            "DE": "Nugget",
            "ES": "Pepita",
            "IT": "Pepita",
            "KOR": "금구슬",
            "CHS": "金珠",
            "CHT": "金珠"
        }
    ],
    "Heart Scale": [
        {
            "NO": 94,
            "EN": "Heart Scale",
            "JP": "ハートのウロコ",
            "FR": "Écaille Cœur",
            "DE": "Herzschuppe",
            "ES": "Escama Corazón",
            "IT": "Squama cuore",
            "KOR": "하트비늘",
            "CHS": "心之鳞片",
            "CHT": "心之鱗片"
        }
    ],
    "Honey": [
        {
            "NO": 95,
            "EN": "Honey",
            "JP": "あまいミツ",
            "FR": "Miel",
            "DE": "Honig",
            "ES": "Miel",
            "IT": "Miele",
            "KOR": "달콤한꿀",
            "CHS": "甜甜蜜",
            "CHT": "甜甜蜜"
        }
    ],
    "Growth Mulch": [
        {
            "NO": 96,
            "EN": "Growth Mulch",
            "JP": "すくすくこやし",
            "FR": "Fertipousse",
            "DE": "Wachsmulch",
            "ES": "Abono Rápido",
            "IT": "Fertilrapido",
            "KOR": "무럭무럭비료",
            "CHS": "速速肥",
            "CHT": "速速肥"
        }
    ],
    "Damp Mulch": [
        {
            "NO": 97,
            "EN": "Damp Mulch",
            "JP": "じめじめこやし",
            "FR": "Fertihumide",
            "DE": "Feuchtmulch",
            "ES": "Abono Lento",
            "IT": "Fertilidro",
            "KOR": "축축이비료",
            "CHS": "湿湿肥",
            "CHT": "濕濕肥"
        }
    ],
    "Stable Mulch": [
        {
            "NO": 98,
            "EN": "Stable Mulch",
            "JP": "ながながこやし",
            "FR": "Fertistable",
            "DE": "Stabilmulch",
            "ES": "Abono Fijador",
            "IT": "Fertilsaldo",
            "KOR": "오래오래비료",
            "CHS": "久久肥",
            "CHT": "久久肥"
        }
    ],
    "Gooey Mulch": [
        {
            "NO": 99,
            "EN": "Gooey Mulch",
            "JP": "ねばねばこやし",
            "FR": "Fertiglu",
            "DE": "Neumulch",
            "ES": "Abono Brote",
            "IT": "Fertilcolla",
            "KOR": "끈적끈적비료",
            "CHS": "粘粘肥",
            "CHT": "黏黏肥"
        }
    ],
    "Root Fossil": [
        {
            "NO": 100,
            "EN": "Root Fossil",
            "JP": "ねっこのカセキ",
            "FR": "Fossile Racine",
            "DE": "Wurzelfossil",
            "ES": "Fósil Raíz",
            "IT": "Radifossile",
            "KOR": "뿌리화석",
            "CHS": "根状化石",
            "CHT": "根狀化石"
        }
    ],
    "Claw Fossil": [
        {
            "NO": 101,
            "EN": "Claw Fossil",
            "JP": "ツメのカセキ",
            "FR": "Fossile Griffe",
            "DE": "Klauenfossil",
            "ES": "Fósil Garra",
            "IT": "Fossilunghia",
            "KOR": "발톱화석",
            "CHS": "爪子化石",
            "CHT": "爪子化石"
        }
    ],
    "Helix Fossil": [
        {
            "NO": 102,
            "EN": "Helix Fossil",
            "JP": "かいのカセキ",
            "FR": "Nautile",
            "DE": "Helixfossil",
            "ES": "Fósil Hélix",
            "IT": "Helixfossile",
            "KOR": "조개화석",
            "CHS": "贝壳化石",
            "CHT": "貝殼化石"
        }
    ],
    "Dome Fossil": [
        {
            "NO": 103,
            "EN": "Dome Fossil",
            "JP": "こうらのカセキ",
            "FR": "Fossile Dôme",
            "DE": "Domfossil",
            "ES": "Fósil Domo",
            "IT": "Domofossile",
            "KOR": "껍질화석",
            "CHS": "甲壳化石",
            "CHT": "甲殼化石"
        }
    ],
    "Old Amber": [
        {
            "NO": 104,
            "EN": "Old Amber",
            "JP": "ひみつのコハク",
            "FR": "Vieil Ambre",
            "DE": "Altbernstein",
            "ES": "Ámbar Viejo",
            "IT": "Ambra antica",
            "KOR": "비밀의호박",
            "CHS": "秘密琥珀",
            "CHT": "秘密琥珀"
        }
    ],
    "Armor Fossil": [
        {
            "NO": 105,
            "EN": "Armor Fossil",
            "JP": "たてのカセキ",
            "FR": "Fossile Armure",
            "DE": "Panzerfossil",
            "ES": "Fósil Coraza",
            "IT": "Fossilscudo",
            "KOR": "방패의화석",
            "CHS": "盾甲化石",
            "CHT": "盾甲化石"
        }
    ],
    "Skull Fossil": [
        {
            "NO": 106,
            "EN": "Skull Fossil",
            "JP": "ずがいのカセキ",
            "FR": "Fossile Crâne",
            "DE": "Kopffossil",
            "ES": "Fósil Cráneo",
            "IT": "Fossilcranio",
            "KOR": "두개의화석",
            "CHS": "头盖化石",
            "CHT": "頭蓋化石"
        }
    ],
    "Rare Bone": [
        {
            "NO": 107,
            "EN": "Rare Bone",
            "JP": "きちょうなホネ",
            "FR": "Os Rare",
            "DE": "Steinknochen",
            "ES": "Hueso Raro",
            "IT": "Osso raro",
            "KOR": "귀중한뼈",
            "CHS": "贵重骨头",
            "CHT": "貴重骨頭"
        }
    ],
    "Shiny Stone": [
        {
            "NO": 108,
            "EN": "Shiny Stone",
            "JP": "ひかりのいし",
            "FR": "Pierre Éclat",
            "DE": "Leuchtstein",
            "ES": "Piedra Día",
            "IT": "Pietrabrillo",
            "KOR": "빛의돌",
            "CHS": "光之石",
            "CHT": "光之石"
        }
    ],
    "Dusk Stone": [
        {
            "NO": 109,
            "EN": "Dusk Stone",
            "JP": "やみのいし",
            "FR": "Pierre Nuit",
            "DE": "Finsterstein",
            "ES": "Piedra Noche",
            "IT": "Neropietra",
            "KOR": "어둠의돌",
            "CHS": "暗之石",
            "CHT": "暗之石"
        }
    ],
    "Dawn Stone": [
        {
            "NO": 110,
            "EN": "Dawn Stone",
            "JP": "めざめいし",
            "FR": "Pierre Aube",
            "DE": "Funkelstein",
            "ES": "Piedra Alba",
            "IT": "Pietralbore",
            "KOR": "각성의돌",
            "CHS": "觉醒之石",
            "CHT": "覺醒之石"
        }
    ],
    "Oval Stone": [
        {
            "NO": 111,
            "EN": "Oval Stone",
            "JP": "まんまるいし",
            "FR": "Pierre Ovale",
            "DE": "Ovaler Stein",
            "ES": "Piedra Oval",
            "IT": "Pietraovale",
            "KOR": "동글동글돌",
            "CHS": "浑圆之石",
            "CHT": "渾圓之石"
        }
    ],
    "Odd Keystone": [
        {
            "NO": 112,
            "EN": "Odd Keystone",
            "JP": "かなめいし",
            "FR": "Clé de Voûte",
            "DE": "Spiritkern",
            "ES": "Piedra Espíritu",
            "IT": "Roccianima",
            "KOR": "쐐기돌",
            "CHS": "楔石",
            "CHT": "楔石"
        }
    ],
    "Griseous Orb": [
        {
            "NO": 113,
            "EN": "Griseous Orb",
            "JP": "はっきんだま",
            "FR": "Orbe Platiné",
            "DE": "Platinum-Orb",
            "ES": "Griseosfera",
            "IT": "Grigiosfera",
            "KOR": "백금옥",
            "CHS": "白金宝珠",
            "CHT": "白金寶珠"
        }
    ],
    "Tea": [
        {
            "NO": 114,
            "EN": "Tea",
            "JP": "おちゃ",
            "FR": "Thé",
            "DE": "Tee",
            "ES": "Té",
            "IT": "Tè",
            "KOR": "차",
            "CHS": "茶",
            "CHT": "茶"
        }
    ],
    "Autograph": [
        {
            "NO": 115,
            "EN": "Autograph",
            "JP": "マチスのサイン",
            "FR": "Dédicace de Bob",
            "DE": "Autogramm",
            "ES": "Autógrafo",
            "IT": "Autografo",
            "KOR": "마티스의사인",
            "CHS": "马志士的签名",
            "CHT": "馬志士的簽名"
        }
    ],
    "Douse Drive": [
        {
            "NO": 116,
            "EN": "Douse Drive",
            "JP": "アクアカセット",
            "FR": "Module Aqua",
            "DE": "Aquamodul",
            "ES": "HidroROM",
            "IT": "Idromodulo",
            "KOR": "아쿠아카세트",
            "CHS": "水流卡带",
            "CHT": "水流卡帶"
        }
    ],
    "Shock Drive": [
        {
            "NO": 117,
            "EN": "Shock Drive",
            "JP": "イナズマカセット",
            "FR": "Module Choc",
            "DE": "Blitzmodul",
            "ES": "FulgoROM",
            "IT": "Voltmodulo",
            "KOR": "번개카세트",
            "CHS": "闪电卡带",
            "CHT": "閃電卡帶"
        }
    ],
    "Burn Drive": [
        {
            "NO": 118,
            "EN": "Burn Drive",
            "JP": "ブレイズカセット",
            "FR": "Module Pyro",
            "DE": "Flammenmodul",
            "ES": "PiroROM",
            "IT": "Piromodulo",
            "KOR": "블레이즈카세트",
            "CHS": "火焰卡带",
            "CHT": "火焰卡帶"
        }
    ],
    "Chill Drive": [
        {
            "NO": 119,
            "EN": "Chill Drive",
            "JP": "フリーズカセット",
            "FR": "Module Cryo",
            "DE": "Gefriermodul",
            "ES": "CrioROM",
            "IT": "Gelomodulo",
            "KOR": "프리즈카세트",
            "CHS": "冰冻卡带",
            "CHT": "冰凍卡帶"
        }
    ],
    "Pokémon Box Link": [
        {
            "NO": 120,
            "EN": "Pokémon Box Link",
            "JP": "ポケモンボックス",
            "FR": "Boîte Pokémon",
            "DE": "Pokémon-Box",
            "ES": "Caja de Pokémon",
            "IT": "Box Pokémon",
            "KOR": "포켓몬 박스",
            "CHS": "宝可梦盒",
            "CHT": "寶可夢盒"
        },
        {
            "NO": 1036,
            "EN": "Pokémon Box Link",
            "JP": "ポケモンボックス",
            "FR": "Boîte Pokémon",
            "DE": "Pokémon-Box",
            "ES": "Caja de Pokémon",
            "IT": "Box Pokémon",
            "KOR": "포켓몬 박스",
            "CHS": "宝可梦盒",
            "CHT": "寶可夢盒"
        }
    ],
    "Medicine Pocket": [
        {
            "NO": 121,
            "EN": "Medicine Pocket",
            "JP": "かいふくポケット",
            "FR": "Trousse de Soins",
            "DE": "Medizintasche",
            "ES": "Botiquín",
            "IT": "Tasca rimedi",
            "KOR": "회복포켓",
            "CHS": "回复口袋",
            "CHT": "回復口袋"
        }
    ],
    "TM Case": [
        {
            "NO": 122,
            "EN": "TM Case",
            "JP": "わざマシンケース",
            "FR": "Boîte CT",
            "DE": "TM-Box",
            "ES": "Estuche de MT",
            "IT": "Porta MT",
            "KOR": "기술머신케이스",
            "CHS": "招式学习器盒",
            "CHT": "招式學習器盒"
        }
    ],
    "Candy Jar": [
        {
            "NO": 123,
            "EN": "Candy Jar",
            "JP": "アメボトル",
            "FR": "Bonbonnière",
            "DE": "Bonbonglas",
            "ES": "Tarro de Caramelos",
            "IT": "Portacaramelle",
            "KOR": "사탕보틀",
            "CHS": "糖果罐",
            "CHT": "糖果罐"
        }
    ],
    "Power-Up Pocket": [
        {
            "NO": 124,
            "EN": "Power-Up Pocket",
            "JP": "きょうかポケット",
            "FR": "Poche à Renforts",
            "DE": "Stärkungstasche",
            "ES": "Bolsillo Mejoras",
            "IT": "Tasca potenziam.",
            "KOR": "강화포켓",
            "CHS": "强化口袋",
            "CHT": "強化口袋"
        }
    ],
    "Clothing Trunk": [
        {
            "NO": 125,
            "EN": "Clothing Trunk",
            "JP": "おきがえトランク",
            "FR": "Malle à Costumes",
            "DE": "Klamottenkoffer",
            "ES": "Maleta",
            "IT": "Valigia vestiti",
            "KOR": "옷갈아입기트렁크",
            "CHS": "换装箱",
            "CHT": "換裝箱"
        }
    ],
    "Catching Pocket": [
        {
            "NO": 126,
            "EN": "Catching Pocket",
            "JP": "ほかくポケット",
            "FR": "Poche de Capture",
            "DE": "Fangtasche",
            "ES": "Bolsillo Captura",
            "IT": "Tasca cattura",
            "KOR": "포획포켓",
            "CHS": "捕捉口袋",
            "CHT": "捕捉口袋"
        }
    ],
    "Battle Pocket": [
        {
            "NO": 127,
            "EN": "Battle Pocket",
            "JP": "バトルポケット",
            "FR": "Poche de Combat",
            "DE": "Kampftasche",
            "ES": "Bolsillo Combate",
            "IT": "Tasca lotta",
            "KOR": "배틀포켓",
            "CHS": "对战口袋",
            "CHT": "對戰口袋"
        }
    ],
    "Sweet Heart": [
        {
            "NO": 128,
            "EN": "Sweet Heart",
            "JP": "ハートスイーツ",
            "FR": "Chococœur",
            "DE": "Herzkonfekt",
            "ES": "Corazón Dulce",
            "IT": "Dolcecuore",
            "KOR": "하트스위트",
            "CHS": "心形甜点",
            "CHT": "心形甜點"
        }
    ],
    "Adamant Orb": [
        {
            "NO": 129,
            "EN": "Adamant Orb",
            "JP": "こんごうだま",
            "FR": "Orbe Adamant",
            "DE": "Adamant-Orb",
            "ES": "Diamansfera",
            "IT": "Adamasfera",
            "KOR": "금강옥",
            "CHS": "金刚宝珠",
            "CHT": "金剛寶珠"
        }
    ],
    "Lustrous Orb": [
        {
            "NO": 130,
            "EN": "Lustrous Orb",
            "JP": "しらたま",
            "FR": "Orbe Perlé",
            "DE": "Weiß-Orb",
            "ES": "Lustresfera",
            "IT": "Splendisfera",
            "KOR": "백옥",
            "CHS": "白玉宝珠",
            "CHT": "白玉寶珠"
        }
    ],
    "Greet Mail": [
        {
            "NO": 131,
            "EN": "Greet Mail",
            "JP": "はじめてメール",
            "FR": "Lettre Salut",
            "DE": "Grußbrief",
            "ES": "Carta Inicial",
            "IT": "Messaggio Inizio",
            "KOR": "첫메일",
            "CHS": "初次邮件",
            "CHT": "初次郵件"
        }
    ],
    "Favored Mail": [
        {
            "NO": 132,
            "EN": "Favored Mail",
            "JP": "だいすきメール",
            "FR": "Lettre Fan",
            "DE": "Faiblebrief",
            "ES": "Carta Favoritos",
            "IT": "Messaggio TVB",
            "KOR": "애호메일",
            "CHS": "喜爱邮件",
            "CHT": "喜愛郵件"
        }
    ],
    "RSVP Mail": [
        {
            "NO": 133,
            "EN": "RSVP Mail",
            "JP": "おさそいメール",
            "FR": "Lettre Invit",
            "DE": "Einladebrief",
            "ES": "Carta Invitar",
            "IT": "Messaggio Invito",
            "KOR": "권유메일",
            "CHS": "邀请邮件",
            "CHT": "邀請郵件"
        }
    ],
    "Thanks Mail": [
        {
            "NO": 134,
            "EN": "Thanks Mail",
            "JP": "かんしゃメール",
            "FR": "Lettre Merci",
            "DE": "Dankesbrief",
            "ES": "Carta Gracias",
            "IT": "Messaggio Grazie",
            "KOR": "감사메일",
            "CHS": "感谢邮件",
            "CHT": "感謝郵件"
        }
    ],
    "Inquiry Mail": [
        {
            "NO": 135,
            "EN": "Inquiry Mail",
            "JP": "しつもんメール",
            "FR": "Lettre Demande",
            "DE": "Fragebrief",
            "ES": "Carta Pregunta",
            "IT": "Messaggio Chiedi",
            "KOR": "질문메일",
            "CHS": "询问邮件",
            "CHT": "詢問郵件"
        }
    ],
    "Like Mail": [
        {
            "NO": 136,
            "EN": "Like Mail",
            "JP": "おすすめメール",
            "FR": "Lettre Avis",
            "DE": "Insiderbrief",
            "ES": "Carta Gustos",
            "IT": "Messaggio Consiglio",
            "KOR": "추천메일",
            "CHS": "推荐邮件",
            "CHT": "推薦郵件"
        }
    ],
    "Reply Mail": [
        {
            "NO": 137,
            "EN": "Reply Mail",
            "JP": "おかえしメール",
            "FR": "Lettre Réponse",
            "DE": "Rückbrief",
            "ES": "Carta Respuesta",
            "IT": "Messaggio Risposta",
            "KOR": "답장메일",
            "CHS": "回复邮件",
            "CHT": "回覆郵件"
        }
    ],
    "Bridge Mail S": [
        {
            "NO": 138,
            "EN": "Bridge Mail S",
            "JP": "ブリッジメールＳ",
            "FR": "Lettre Pont S",
            "DE": "Brückbrief H",
            "ES": "Carta Puente S",
            "IT": "Messaggio Ponte F",
            "KOR": "브리지메일S",
            "CHS": "桥梁邮件Ｓ",
            "CHT": "橋梁郵件Ｓ"
        }
    ],
    "Bridge Mail D": [
        {
            "NO": 139,
            "EN": "Bridge Mail D",
            "JP": "ブリッジメールＨ",
            "FR": "Lettre Pont Y",
            "DE": "Brückbrief M",
            "ES": "Carta Puente F",
            "IT": "Messaggio Ponte L",
            "KOR": "브리지메일M",
            "CHS": "桥梁邮件Ｈ",
            "CHT": "橋梁郵件Ｈ"
        }
    ],
    "Bridge Mail T": [
        {
            "NO": 140,
            "EN": "Bridge Mail T",
            "JP": "ブリッジメールＣ",
            "FR": "Lettre Pont F",
            "DE": "Brückbrief Z",
            "ES": "Carta Puente A",
            "IT": "Messaggio Ponte P",
            "KOR": "브리지메일C",
            "CHS": "桥梁邮件Ｃ",
            "CHT": "橋梁郵件Ｃ"
        }
    ],
    "Bridge Mail V": [
        {
            "NO": 141,
            "EN": "Bridge Mail V",
            "JP": "ブリッジメールＶ",
            "FR": "Lettre Pont H",
            "DE": "Brückbrief D",
            "ES": "Carta Puente V",
            "IT": "Messaggio Ponte V",
            "KOR": "브리지메일V",
            "CHS": "桥梁邮件Ｖ",
            "CHT": "橋梁郵件Ｖ"
        }
    ],
    "Bridge Mail M": [
        {
            "NO": 142,
            "EN": "Bridge Mail M",
            "JP": "ブリッジメールＷ",
            "FR": "Lettre Pont I",
            "DE": "Brückbrief W",
            "ES": "Carta Puente P",
            "IT": "Messaggio Ponte M",
            "KOR": "브리지메일W",
            "CHS": "桥梁邮件Ｗ",
            "CHT": "橋梁郵件Ｗ"
        }
    ],
    "Cheri Berry": [
        {
            "NO": 143,
            "EN": "Cheri Berry",
            "JP": "クラボのみ",
            "FR": "Baie Ceriz",
            "DE": "Amrenabeere",
            "ES": "Baya Zreza",
            "IT": "Baccaliegia",
            "KOR": "버치열매",
            "CHS": "樱子果",
            "CHT": "櫻子果"
        }
    ],
    "Chesto Berry": [
        {
            "NO": 144,
            "EN": "Chesto Berry",
            "JP": "カゴのみ",
            "FR": "Baie Maron",
            "DE": "Maronbeere",
            "ES": "Baya Atania",
            "IT": "Baccastagna",
            "KOR": "유루열매",
            "CHS": "零余果",
            "CHT": "零餘果"
        }
    ],
    "Pecha Berry": [
        {
            "NO": 145,
            "EN": "Pecha Berry",
            "JP": "モモンのみ",
            "FR": "Baie Pêcha",
            "DE": "Pirsifbeere",
            "ES": "Baya Meloc",
            "IT": "Baccapesca",
            "KOR": "복슝열매",
            "CHS": "桃桃果",
            "CHT": "桃桃果"
        }
    ],
    "Rawst Berry": [
        {
            "NO": 146,
            "EN": "Rawst Berry",
            "JP": "チーゴのみ",
            "FR": "Baie Fraive",
            "DE": "Fragiabeere",
            "ES": "Baya Safre",
            "IT": "Baccafrago",
            "KOR": "복분열매",
            "CHS": "莓莓果",
            "CHT": "莓莓果"
        }
    ],
    "Aspear Berry": [
        {
            "NO": 147,
            "EN": "Aspear Berry",
            "JP": "ナナシのみ",
            "FR": "Baie Willia",
            "DE": "Wilbirbeere",
            "ES": "Baya Perasi",
            "IT": "Baccaperina",
            "KOR": "배리열매",
            "CHS": "利木果",
            "CHT": "利木果"
        }
    ],
    "Leppa Berry": [
        {
            "NO": 148,
            "EN": "Leppa Berry",
            "JP": "ヒメリのみ",
            "FR": "Baie Mepo",
            "DE": "Jonagobeere",
            "ES": "Baya Zanama",
            "IT": "Baccamela",
            "KOR": "과사열매",
            "CHS": "苹野果",
            "CHT": "蘋野果"
        }
    ],
    "Oran Berry": [
        {
            "NO": 149,
            "EN": "Oran Berry",
            "JP": "オレンのみ",
            "FR": "Baie Oran",
            "DE": "Sinelbeere",
            "ES": "Baya Aranja",
            "IT": "Baccarancia",
            "KOR": "오랭열매",
            "CHS": "橙橙果",
            "CHT": "橙橙果"
        }
    ],
    "Persim Berry": [
        {
            "NO": 150,
            "EN": "Persim Berry",
            "JP": "キーのみ",
            "FR": "Baie Kika",
            "DE": "Persimbeere",
            "ES": "Baya Caquic",
            "IT": "Baccaki",
            "KOR": "시몬열매",
            "CHS": "柿仔果",
            "CHT": "柿仔果"
        }
    ],
    "Lum Berry": [
        {
            "NO": 151,
            "EN": "Lum Berry",
            "JP": "ラムのみ",
            "FR": "Baie Prine",
            "DE": "Prunusbeere",
            "ES": "Baya Ziuela",
            "IT": "Baccaprugna",
            "KOR": "리샘열매",
            "CHS": "木子果",
            "CHT": "木子果"
        }
    ],
    "Sitrus Berry": [
        {
            "NO": 152,
            "EN": "Sitrus Berry",
            "JP": "オボンのみ",
            "FR": "Baie Sitrus",
            "DE": "Tsitrubeere",
            "ES": "Baya Zidra",
            "IT": "Baccacedro",
            "KOR": "자뭉열매",
            "CHS": "文柚果",
            "CHT": "文柚果"
        }
    ],
    "Figy Berry": [
        {
            "NO": 153,
            "EN": "Figy Berry",
            "JP": "フィラのみ",
            "FR": "Baie Figuy",
            "DE": "Giefebeere",
            "ES": "Baya Higog",
            "IT": "Baccafico",
            "KOR": "무화열매",
            "CHS": "勿花果",
            "CHT": "勿花果"
        }
    ],
    "Wiki Berry": [
        {
            "NO": 154,
            "EN": "Wiki Berry",
            "JP": "ウイのみ",
            "FR": "Baie Wiki",
            "DE": "Wikibeere",
            "ES": "Baya Wiki",
            "IT": "Baccakiwi",
            "KOR": "위키열매",
            "CHS": "异奇果",
            "CHT": "異奇果"
        }
    ],
    "Mago Berry": [
        {
            "NO": 155,
            "EN": "Mago Berry",
            "JP": "マゴのみ",
            "FR": "Baie Mago",
            "DE": "Magobeere",
            "ES": "Baya Ango",
            "IT": "Baccamango",
            "KOR": "마고열매",
            "CHS": "芒芒果",
            "CHT": "芒芒果"
        }
    ],
    "Aguav Berry": [
        {
            "NO": 156,
            "EN": "Aguav Berry",
            "JP": "バンジのみ",
            "FR": "Baie Gowav",
            "DE": "Gauvebeere",
            "ES": "Baya Guaya",
            "IT": "Baccaguava",
            "KOR": "아바열매",
            "CHS": "乐芭果",
            "CHT": "樂芭果"
        }
    ],
    "Iapapa Berry": [
        {
            "NO": 157,
            "EN": "Iapapa Berry",
            "JP": "イアのみ",
            "FR": "Baie Papaya",
            "DE": "Yapabeere",
            "ES": "Baya Pabaya",
            "IT": "Baccapaia",
            "KOR": "파야열매",
            "CHS": "芭亚果",
            "CHT": "芭亞果"
        }
    ],
    "Razz Berry": [
        {
            "NO": 158,
            "EN": "Razz Berry",
            "JP": "ズリのみ",
            "FR": "Baie Framby",
            "DE": "Himmihbeere",
            "ES": "Baya Frambu",
            "IT": "Baccalampon",
            "KOR": "라즈열매",
            "CHS": "蔓莓果",
            "CHT": "蔓莓果"
        }
    ],
    "Bluk Berry": [
        {
            "NO": 159,
            "EN": "Bluk Berry",
            "JP": "ブリーのみ",
            "FR": "Baie Remu",
            "DE": "Morbbeere",
            "ES": "Baya Oram",
            "IT": "Baccamora",
            "KOR": "블리열매",
            "CHS": "墨莓果",
            "CHT": "墨莓果"
        }
    ],
    "Nanab Berry": [
        {
            "NO": 160,
            "EN": "Nanab Berry",
            "JP": "ナナのみ",
            "FR": "Baie Nanab",
            "DE": "Nanabbeere",
            "ES": "Baya Latano",
            "IT": "Baccabana",
            "KOR": "나나열매",
            "CHS": "蕉香果",
            "CHT": "蕉香果"
        }
    ],
    "Wepear Berry": [
        {
            "NO": 161,
            "EN": "Wepear Berry",
            "JP": "セシナのみ",
            "FR": "Baie Repoi",
            "DE": "Nirbebeere",
            "ES": "Baya Peragu",
            "IT": "Baccapera",
            "KOR": "서배열매",
            "CHS": "西梨果",
            "CHT": "西梨果"
        }
    ],
    "Pinap Berry": [
        {
            "NO": 162,
            "EN": "Pinap Berry",
            "JP": "パイルのみ",
            "FR": "Baie Nanana",
            "DE": "Sananabeere",
            "ES": "Baya Pinia",
            "IT": "Baccananas",
            "KOR": "파인열매",
            "CHS": "凰梨果",
            "CHT": "凰梨果"
        }
    ],
    "Pomeg Berry": [
        {
            "NO": 163,
            "EN": "Pomeg Berry",
            "JP": "ザロクのみ",
            "FR": "Baie Grena",
            "DE": "Granabeere",
            "ES": "Baya Grana",
            "IT": "Baccagrana",
            "KOR": "유석열매",
            "CHS": "榴石果",
            "CHT": "榴石果"
        }
    ],
    "Kelpsy Berry": [
        {
            "NO": 164,
            "EN": "Kelpsy Berry",
            "JP": "ネコブのみ",
            "FR": "Baie Alga",
            "DE": "Setangbeere",
            "ES": "Baya Algama",
            "IT": "Baccalga",
            "KOR": "시마열매",
            "CHS": "藻根果",
            "CHT": "藻根果"
        }
    ],
    "Qualot Berry": [
        {
            "NO": 165,
            "EN": "Qualot Berry",
            "JP": "タポルのみ",
            "FR": "Baie Qualot",
            "DE": "Qualotbeere",
            "ES": "Baya Ispero",
            "IT": "Baccaloquat",
            "KOR": "파비열매",
            "CHS": "比巴果",
            "CHT": "比巴果"
        }
    ],
    "Hondew Berry": [
        {
            "NO": 166,
            "EN": "Hondew Berry",
            "JP": "ロメのみ",
            "FR": "Baie Lonme",
            "DE": "Honmelbeere",
            "ES": "Baya Meluce",
            "IT": "Baccamelon",
            "KOR": "로매열매",
            "CHS": "哈密果",
            "CHT": "哈密果"
        }
    ],
    "Grepa Berry": [
        {
            "NO": 167,
            "EN": "Grepa Berry",
            "JP": "ウブのみ",
            "FR": "Baie Résin",
            "DE": "Labrusbeere",
            "ES": "Baya Uvav",
            "IT": "Baccauva",
            "KOR": "또뽀열매",
            "CHS": "萄葡果",
            "CHT": "萄葡果"
        }
    ],
    "Tamato Berry": [
        {
            "NO": 168,
            "EN": "Tamato Berry",
            "JP": "マトマのみ",
            "FR": "Baie Tamato",
            "DE": "Tamotbeere",
            "ES": "Baya Tamate",
            "IT": "Baccamodoro",
            "KOR": "토망열매",
            "CHS": "茄番果",
            "CHT": "茄番果"
        }
    ],
    "Cornn Berry": [
        {
            "NO": 169,
            "EN": "Cornn Berry",
            "JP": "モコシのみ",
            "FR": "Baie Siam",
            "DE": "Saimbeere",
            "ES": "Baya Mais",
            "IT": "Baccavena",
            "KOR": "수숙열매",
            "CHS": "玉黍果",
            "CHT": "玉黍果"
        }
    ],
    "Magost Berry": [
        {
            "NO": 170,
            "EN": "Magost Berry",
            "JP": "ゴスのみ",
            "FR": "Baie Mangou",
            "DE": "Magostbeere",
            "ES": "Baya Aostan",
            "IT": "Baccagostan",
            "KOR": "고스티열매",
            "CHS": "岳竹果",
            "CHT": "岳竹果"
        }
    ],
    "Rabuta Berry": [
        {
            "NO": 171,
            "EN": "Rabuta Berry",
            "JP": "ラブタのみ",
            "FR": "Baie Rabuta",
            "DE": "Rabutabeere",
            "ES": "Baya Rautan",
            "IT": "Baccambutan",
            "KOR": "라부탐열매",
            "CHS": "茸丹果",
            "CHT": "茸丹果"
        }
    ],
    "Nomel Berry": [
        {
            "NO": 172,
            "EN": "Nomel Berry",
            "JP": "ノメルのみ",
            "FR": "Baie Tronci",
            "DE": "Tronzibeere",
            "ES": "Baya Monli",
            "IT": "Baccalemon",
            "KOR": "노멜열매",
            "CHS": "檬柠果",
            "CHT": "檬檸果"
        }
    ],
    "Spelon Berry": [
        {
            "NO": 173,
            "EN": "Spelon Berry",
            "JP": "ノワキのみ",
            "FR": "Baie Kiwan",
            "DE": "Kiwanbeere",
            "ES": "Baya Wikano",
            "IT": "Baccamelos",
            "KOR": "메호키열매",
            "CHS": "刺角果",
            "CHT": "刺角果"
        }
    ],
    "Pamtre Berry": [
        {
            "NO": 174,
            "EN": "Pamtre Berry",
            "JP": "シーヤのみ",
            "FR": "Baie Palma",
            "DE": "Pallmbeere",
            "ES": "Baya Plama",
            "IT": "Baccapalma",
            "KOR": "자야열매",
            "CHS": "椰木果",
            "CHT": "椰木果"
        }
    ],
    "Watmel Berry": [
        {
            "NO": 175,
            "EN": "Watmel Berry",
            "JP": "カイスのみ",
            "FR": "Baie Stekpa",
            "DE": "Wasmelbeere",
            "ES": "Baya Sambia",
            "IT": "Baccacomero",
            "KOR": "슈박열매",
            "CHS": "瓜西果",
            "CHT": "瓜西果"
        }
    ],
    "Durin Berry": [
        {
            "NO": 176,
            "EN": "Durin Berry",
            "JP": "ドリのみ",
            "FR": "Baie Durin",
            "DE": "Durinbeere",
            "ES": "Baya Rudion",
            "IT": "Baccadurian",
            "KOR": "두리열매",
            "CHS": "金枕果",
            "CHT": "金枕果"
        }
    ],
    "Belue Berry": [
        {
            "NO": 177,
            "EN": "Belue Berry",
            "JP": "ベリブのみ",
            "FR": "Baie Myrte",
            "DE": "Myrtilbeere",
            "ES": "Baya Andano",
            "IT": "Baccartillo",
            "KOR": "루베열매",
            "CHS": "靛莓果",
            "CHT": "靛莓果"
        }
    ],
    "Occa Berry": [
        {
            "NO": 178,
            "EN": "Occa Berry",
            "JP": "オッカのみ",
            "FR": "Baie Chocco",
            "DE": "Koakobeere",
            "ES": "Baya Caoca",
            "IT": "Baccacao",
            "KOR": "오카열매",
            "CHS": "巧可果",
            "CHT": "巧可果"
        }
    ],
    "Passho Berry": [
        {
            "NO": 179,
            "EN": "Passho Berry",
            "JP": "イトケのみ",
            "FR": "Baie Pocpoc",
            "DE": "Foepasbeere",
            "ES": "Baya Pasio",
            "IT": "Baccapasflo",
            "KOR": "꼬시개열매",
            "CHS": "千香果",
            "CHT": "千香果"
        }
    ],
    "Wacan Berry": [
        {
            "NO": 180,
            "EN": "Wacan Berry",
            "JP": "ソクノのみ",
            "FR": "Baie Parma",
            "DE": "Kerzalbeere",
            "ES": "Baya Gualot",
            "IT": "Baccaparmen",
            "KOR": "초나열매",
            "CHS": "烛木果",
            "CHT": "燭木果"
        }
    ],
    "Rindo Berry": [
        {
            "NO": 181,
            "EN": "Rindo Berry",
            "JP": "リンドのみ",
            "FR": "Baie Ratam",
            "DE": "Grindobeere",
            "ES": "Baya Tamar",
            "IT": "Baccarindo",
            "KOR": "린드열매",
            "CHS": "罗子果",
            "CHT": "羅子果"
        }
    ],
    "Yache Berry": [
        {
            "NO": 182,
            "EN": "Yache Berry",
            "JP": "ヤチェのみ",
            "FR": "Baie Nanone",
            "DE": "Kiroyabeere",
            "ES": "Baya Rimoya",
            "IT": "Baccamoya",
            "KOR": "플카열매",
            "CHS": "番荔果",
            "CHT": "番荔果"
        }
    ],
    "Chople Berry": [
        {
            "NO": 183,
            "EN": "Chople Berry",
            "JP": "ヨプのみ",
            "FR": "Baie Pomroz",
            "DE": "Rospelbeere",
            "ES": "Baya Pomaro",
            "IT": "Baccarosmel",
            "KOR": "로플열매",
            "CHS": "莲蒲果",
            "CHT": "蓮蒲果"
        }
    ],
    "Kebia Berry": [
        {
            "NO": 184,
            "EN": "Kebia Berry",
            "JP": "ビアーのみ",
            "FR": "Baie Kébia",
            "DE": "Grarzbeere",
            "ES": "Baya Kebia",
            "IT": "Baccakebia",
            "KOR": "으름열매",
            "CHS": "通通果",
            "CHT": "通通果"
        }
    ],
    "Shuca Berry": [
        {
            "NO": 185,
            "EN": "Shuca Berry",
            "JP": "シュカのみ",
            "FR": "Baie Jouca",
            "DE": "Schukebeere",
            "ES": "Baya Acardo",
            "IT": "Baccanaca",
            "KOR": "슈캐열매",
            "CHS": "腰木果",
            "CHT": "腰木果"
        }
    ],
    "Coba Berry": [
        {
            "NO": 186,
            "EN": "Coba Berry",
            "JP": "バコウのみ",
            "FR": "Baie Cobaba",
            "DE": "Kobabeere",
            "ES": "Baya Kouba",
            "IT": "Baccababa",
            "KOR": "바코열매",
            "CHS": "棱瓜果",
            "CHT": "稜瓜果"
        }
    ],
    "Payapa Berry": [
        {
            "NO": 187,
            "EN": "Payapa Berry",
            "JP": "ウタンのみ",
            "FR": "Baie Yapap",
            "DE": "Pyapabeere",
            "ES": "Baya Payapa",
            "IT": "Baccapayapa",
            "KOR": "야파열매",
            "CHS": "福禄果",
            "CHT": "福祿果"
        }
    ],
    "Tanga Berry": [
        {
            "NO": 188,
            "EN": "Tanga Berry",
            "JP": "タンガのみ",
            "FR": "Baie Panga",
            "DE": "Tanigabeere",
            "ES": "Baya Yecana",
            "IT": "Baccaitan",
            "KOR": "리체열매",
            "CHS": "扁樱果",
            "CHT": "扁櫻果"
        }
    ],
    "Charti Berry": [
        {
            "NO": 189,
            "EN": "Charti Berry",
            "JP": "ヨロギのみ",
            "FR": "Baie Charti",
            "DE": "Chiaribeere",
            "ES": "Baya Alcho",
            "IT": "Baccaciofo",
            "KOR": "루미열매",
            "CHS": "草蚕果",
            "CHT": "草蠶果"
        }
    ],
    "Kasib Berry": [
        {
            "NO": 190,
            "EN": "Kasib Berry",
            "JP": "カシブのみ",
            "FR": "Baie Sédra",
            "DE": "Zitarzbeere",
            "ES": "Baya Drasi",
            "IT": "Baccacitrus",
            "KOR": "수불열매",
            "CHS": "佛柑果",
            "CHT": "佛柑果"
        }
    ],
    "Haban Berry": [
        {
            "NO": 191,
            "EN": "Haban Berry",
            "JP": "ハバンのみ",
            "FR": "Baie Fraigo",
            "DE": "Terirobeere",
            "ES": "Baya Anjiro",
            "IT": "Baccahaban",
            "KOR": "하반열매",
            "CHS": "莓榴果",
            "CHT": "莓榴果"
        }
    ],
    "Colbur Berry": [
        {
            "NO": 192,
            "EN": "Colbur Berry",
            "JP": "ナモのみ",
            "FR": "Baie Lampou",
            "DE": "Burleobeere",
            "ES": "Baya Dillo",
            "IT": "Baccaxan",
            "KOR": "마코열매",
            "CHS": "刺耳果",
            "CHT": "刺耳果"
        }
    ],
    "Babiri Berry": [
        {
            "NO": 193,
            "EN": "Babiri Berry",
            "JP": "リリバのみ",
            "FR": "Baie Babiri",
            "DE": "Babiribeere",
            "ES": "Baya Baribá",
            "IT": "Baccababiri",
            "KOR": "바리비열매",
            "CHS": "霹霹果",
            "CHT": "霹霹果"
        }
    ],
    "Chilan Berry": [
        {
            "NO": 194,
            "EN": "Chilan Berry",
            "JP": "ホズのみ",
            "FR": "Baie Zalis",
            "DE": "Latchibeere",
            "ES": "Baya Chilan",
            "IT": "Baccacinlan",
            "KOR": "카리열매",
            "CHS": "灯浆果",
            "CHT": "燈漿果"
        }
    ],
    "Liechi Berry": [
        {
            "NO": 195,
            "EN": "Liechi Berry",
            "JP": "チイラのみ",
            "FR": "Baie Lichii",
            "DE": "Lydzibeere",
            "ES": "Baya Lichi",
            "IT": "Baccalici",
            "KOR": "치리열매",
            "CHS": "枝荔果",
            "CHT": "枝荔果"
        }
    ],
    "Ganlon Berry": [
        {
            "NO": 196,
            "EN": "Ganlon Berry",
            "JP": "リュガのみ",
            "FR": "Baie Lingan",
            "DE": "Linganbeere",
            "ES": "Baya Gonlan",
            "IT": "Baccalongan",
            "KOR": "용아열매",
            "CHS": "龙睛果",
            "CHT": "龍睛果"
        }
    ],
    "Salac Berry": [
        {
            "NO": 197,
            "EN": "Salac Berry",
            "JP": "カムラのみ",
            "FR": "Baie Sailak",
            "DE": "Salkabeere",
            "ES": "Baya Aslac",
            "IT": "Baccasalak",
            "KOR": "캄라열매",
            "CHS": "沙鳞果",
            "CHT": "沙鱗果"
        }
    ],
    "Petaya Berry": [
        {
            "NO": 198,
            "EN": "Petaya Berry",
            "JP": "ヤタピのみ",
            "FR": "Baie Pitaye",
            "DE": "Tahaybeere",
            "ES": "Baya Yapati",
            "IT": "Baccapitaya",
            "KOR": "야타비열매",
            "CHS": "龙火果",
            "CHT": "龍火果"
        }
    ],
    "Apicot Berry": [
        {
            "NO": 199,
            "EN": "Apicot Berry",
            "JP": "ズアのみ",
            "FR": "Baie Abriko",
            "DE": "Apikobeere",
            "ES": "Baya Aricoc",
            "IT": "Baccacocca",
            "KOR": "규살열매",
            "CHS": "杏仔果",
            "CHT": "杏仔果"
        }
    ],
    "Lansat Berry": [
        {
            "NO": 200,
            "EN": "Lansat Berry",
            "JP": "サンのみ",
            "FR": "Baie Lansat",
            "DE": "Lansatbeere",
            "ES": "Baya Zonlan",
            "IT": "Baccalangsa",
            "KOR": "랑사열매",
            "CHS": "兰萨果",
            "CHT": "蘭薩果"
        }
    ],
    "Starf Berry": [
        {
            "NO": 201,
            "EN": "Starf Berry",
            "JP": "スターのみ",
            "FR": "Baie Frista",
            "DE": "Krambobeere",
            "ES": "Baya Arabol",
            "IT": "Baccambola",
            "KOR": "스타열매",
            "CHS": "星桃果",
            "CHT": "星桃果"
        }
    ],
    "Enigma Berry": [
        {
            "NO": 202,
            "EN": "Enigma Berry",
            "JP": "ナゾのみ",
            "FR": "Baie Enigma",
            "DE": "Enigmabeere",
            "ES": "Baya Enigma",
            "IT": "Baccaenigma",
            "KOR": "의문열매",
            "CHS": "谜芝果",
            "CHT": "謎芝果"
        }
    ],
    "Micle Berry": [
        {
            "NO": 203,
            "EN": "Micle Berry",
            "JP": "ミクルのみ",
            "FR": "Baie Micle",
            "DE": "Wunfrubeere",
            "ES": "Baya Lagro",
            "IT": "Baccaracolo",
            "KOR": "미클열매",
            "CHS": "奇秘果",
            "CHT": "奇秘果"
        }
    ],
    "Custap Berry": [
        {
            "NO": 204,
            "EN": "Custap Berry",
            "JP": "イバンのみ",
            "FR": "Baie Chérim",
            "DE": "Eipfelbeere",
            "ES": "Baya Chiri",
            "IT": "Baccacrela",
            "KOR": "애슈열매",
            "CHS": "释陀果",
            "CHT": "釋陀果"
        }
    ],
    "Jaboca Berry": [
        {
            "NO": 205,
            "EN": "Jaboca Berry",
            "JP": "ジャポのみ",
            "FR": "Baie Jaboca",
            "DE": "Jabocabeere",
            "ES": "Baya Jaboca",
            "IT": "Baccajaba",
            "KOR": "자보열매",
            "CHS": "嘉珍果",
            "CHT": "嘉珍果"
        }
    ],
    "Rowap Berry": [
        {
            "NO": 206,
            "EN": "Rowap Berry",
            "JP": "レンブのみ",
            "FR": "Baie Pommo",
            "DE": "Roselbeere",
            "ES": "Baya Magua",
            "IT": "Baccaroam",
            "KOR": "애터열매",
            "CHS": "雾莲果",
            "CHT": "霧蓮果"
        }
    ],
    "Bright Powder": [
        {
            "NO": 207,
            "EN": "Bright Powder",
            "JP": "ひかりのこな",
            "FR": "Poudre Claire",
            "DE": "Blendpuder",
            "ES": "Polvo Brillo",
            "IT": "Luminpolvere",
            "KOR": "반짝가루",
            "CHS": "光粉",
            "CHT": "光粉"
        }
    ],
    "White Herb": [
        {
            "NO": 208,
            "EN": "White Herb",
            "JP": "しろいハーブ",
            "FR": "Herbe Blanche",
            "DE": "Schlohkraut",
            "ES": "Hierba Blanca",
            "IT": "Erbachiara",
            "KOR": "하양허브",
            "CHS": "白色香草",
            "CHT": "白色香草"
        }
    ],
    "Macho Brace": [
        {
            "NO": 209,
            "EN": "Macho Brace",
            "JP": "きょうせいギプス",
            "FR": "Bracelet Macho",
            "DE": "Machoschiene",
            "ES": "Brazal Firme",
            "IT": "Crescicappa",
            "KOR": "교정깁스",
            "CHS": "强制锻炼器",
            "CHT": "強制鍛鍊器"
        }
    ],
    "Exp. Share": [
        {
            "NO": 210,
            "EN": "Exp. Share",
            "JP": "がくしゅうそうち",
            "FR": "Multi Exp",
            "DE": "EP-Teiler",
            "ES": "Repartir Experiencia",
            "IT": "Condividi esperienza",
            "KOR": "학습장치",
            "CHS": "学习装置",
            "CHT": "學習裝置"
        }
    ],
    "Quick Claw": [
        {
            "NO": 211,
            "EN": "Quick Claw",
            "JP": "せんせいのツメ",
            "FR": "Vive Griffe",
            "DE": "Flinkklaue",
            "ES": "Garra Rápida",
            "IT": "Rapidartiglio",
            "KOR": "선제공격손톱",
            "CHS": "先制之爪",
            "CHT": "先制之爪"
        }
    ],
    "Soothe Bell": [
        {
            "NO": 212,
            "EN": "Soothe Bell",
            "JP": "やすらぎのすず",
            "FR": "Grelot Zen",
            "DE": "Sanftglocke",
            "ES": "Cascabel Alivio",
            "IT": "Calmanella",
            "KOR": "평온의방울",
            "CHS": "安抚之铃",
            "CHT": "安撫之鈴"
        }
    ],
    "Mental Herb": [
        {
            "NO": 213,
            "EN": "Mental Herb",
            "JP": "メンタルハーブ",
            "FR": "Herbe Mental",
            "DE": "Mentalkraut",
            "ES": "Hierba Mental",
            "IT": "Mentalerba",
            "KOR": "멘탈허브",
            "CHS": "心灵香草",
            "CHT": "心靈香草"
        }
    ],
    "Choice Band": [
        {
            "NO": 214,
            "EN": "Choice Band",
            "JP": "こだわりハチマキ",
            "FR": "Bandeau Choix",
            "DE": "Wahlband",
            "ES": "Cinta Elección",
            "IT": "Bendascelta",
            "KOR": "구애머리띠",
            "CHS": "讲究头带",
            "CHT": "講究頭帶"
        }
    ],
    "King’s Rock": [
        {
            "NO": 215,
            "EN": "King’s Rock",
            "JP": "おうじゃのしるし",
            "FR": "Roche Royale",
            "DE": "King-Stein",
            "ES": "Roca del Rey",
            "IT": "Roccia di re",
            "KOR": "왕의징표석",
            "CHS": "王者之证",
            "CHT": "王者之證"
        }
    ],
    "Silver Powder": [
        {
            "NO": 216,
            "EN": "Silver Powder",
            "JP": "ぎんのこな",
            "FR": "Poudre Argentée",
            "DE": "Silberstaub",
            "ES": "Polvo Plata",
            "IT": "Argenpolvere",
            "KOR": "은빛가루",
            "CHS": "银粉",
            "CHT": "銀粉"
        }
    ],
    "Amulet Coin": [
        {
            "NO": 217,
            "EN": "Amulet Coin",
            "JP": "おまもりこばん",
            "FR": "Pièce Rune",
            "DE": "Münzamulett",
            "ES": "Moneda Amuleto",
            "IT": "Monetamuleto",
            "KOR": "부적금화",
            "CHS": "护符金币",
            "CHT": "護符金幣"
        }
    ],
    "Cleanse Tag": [
        {
            "NO": 218,
            "EN": "Cleanse Tag",
            "JP": "きよめのおふだ",
            "FR": "Rune Purifiante",
            "DE": "Schutzsticker",
            "ES": "Amuleto",
            "IT": "Velopuro",
            "KOR": "순결의부적",
            "CHS": "洁净之符",
            "CHT": "潔淨之符"
        }
    ],
    "Soul Dew": [
        {
            "NO": 219,
            "EN": "Soul Dew",
            "JP": "こころのしずく",
            "FR": "Rosée Âme",
            "DE": "Seelentau",
            "ES": "Rocío Bondad",
            "IT": "Cuorugiada",
            "KOR": "마음의물방울",
            "CHS": "心之水滴",
            "CHT": "心之水滴"
        }
    ],
    "Deep Sea Tooth": [
        {
            "NO": 220,
            "EN": "Deep Sea Tooth",
            "JP": "しんかいのキバ",
            "FR": "Dent Océan",
            "DE": "Abysszahn",
            "ES": "Diente Marino",
            "IT": "Dente abissi",
            "KOR": "심해의이빨",
            "CHS": "深海之牙",
            "CHT": "深海之牙"
        }
    ],
    "Deep Sea Scale": [
        {
            "NO": 221,
            "EN": "Deep Sea Scale",
            "JP": "しんかいのウロコ",
            "FR": "Écaille Océan",
            "DE": "Abyssschuppe",
            "ES": "Escama Marina",
            "IT": "Squamabissi",
            "KOR": "심해의비늘",
            "CHS": "深海鳞片",
            "CHT": "深海鱗片"
        }
    ],
    "Smoke Ball": [
        {
            "NO": 222,
            "EN": "Smoke Ball",
            "JP": "けむりだま",
            "FR": "Boule Fumée",
            "DE": "Rauchball",
            "ES": "Bola de Humo",
            "IT": "Palla fumo",
            "KOR": "연막탄",
            "CHS": "烟雾球",
            "CHT": "煙霧球"
        }
    ],
    "Everstone": [
        {
            "NO": 223,
            "EN": "Everstone",
            "JP": "かわらずのいし",
            "FR": "Pierre Stase",
            "DE": "Ewigstein",
            "ES": "Piedra Eterna",
            "IT": "Pietrastante",
            "KOR": "변함없는돌",
            "CHS": "不变之石",
            "CHT": "不變之石"
        }
    ],
    "Focus Band": [
        {
            "NO": 224,
            "EN": "Focus Band",
            "JP": "きあいのハチマキ",
            "FR": "Bandeau",
            "DE": "Fokusband",
            "ES": "Cinta Aguante",
            "IT": "Bandana",
            "KOR": "기합의머리띠",
            "CHS": "气势头带",
            "CHT": "氣勢頭帶"
        }
    ],
    "Lucky Egg": [
        {
            "NO": 225,
            "EN": "Lucky Egg",
            "JP": "しあわせタマゴ",
            "FR": "Œuf Chance",
            "DE": "Glücks-Ei",
            "ES": "Huevo Suerte",
            "IT": "Fortunuovo",
            "KOR": "행복의알",
            "CHS": "幸运蛋",
            "CHT": "幸運蛋"
        }
    ],
    "Scope Lens": [
        {
            "NO": 226,
            "EN": "Scope Lens",
            "JP": "ピントレンズ",
            "FR": "Lentilscope",
            "DE": "Scope-Linse",
            "ES": "Periscopio",
            "IT": "Mirino",
            "KOR": "초점렌즈",
            "CHS": "焦点镜",
            "CHT": "焦點鏡"
        }
    ],
    "Metal Coat": [
        {
            "NO": 227,
            "EN": "Metal Coat",
            "JP": "メタルコート",
            "FR": "Peau Métal",
            "DE": "Metallmantel",
            "ES": "Revest. Metálico",
            "IT": "Metalcopertura",
            "KOR": "금속코트",
            "CHS": "金属膜",
            "CHT": "金屬膜"
        }
    ],
    "Leftovers": [
        {
            "NO": 228,
            "EN": "Leftovers",
            "JP": "たべのこし",
            "FR": "Restes",
            "DE": "Überreste",
            "ES": "Restos",
            "IT": "Avanzi",
            "KOR": "먹다남은음식",
            "CHS": "吃剩的东西",
            "CHT": "吃剩的東西"
        }
    ],
    "Dragon Scale": [
        {
            "NO": 229,
            "EN": "Dragon Scale",
            "JP": "りゅうのウロコ",
            "FR": "Écaille Draco",
            "DE": "Drachenschuppe",
            "ES": "Escama Dragón",
            "IT": "Squama drago",
            "KOR": "용의비늘",
            "CHS": "龙之鳞片",
            "CHT": "龍之鱗片"
        }
    ],
    "Light Ball": [
        {
            "NO": 230,
            "EN": "Light Ball",
            "JP": "でんきだま",
            "FR": "Balle Lumière",
            "DE": "Kugelblitz",
            "ES": "Bola Luminosa",
            "IT": "Elettropalla",
            "KOR": "전기구슬",
            "CHS": "电气球",
            "CHT": "電氣球"
        }
    ],
    "Soft Sand": [
        {
            "NO": 231,
            "EN": "Soft Sand",
            "JP": "やわらかいすな",
            "FR": "Sable Doux",
            "DE": "Pudersand",
            "ES": "Arena Fina",
            "IT": "Sabbia soffice",
            "KOR": "부드러운모래",
            "CHS": "柔软沙子",
            "CHT": "柔軟沙子"
        }
    ],
    "Hard Stone": [
        {
            "NO": 232,
            "EN": "Hard Stone",
            "JP": "かたいいし",
            "FR": "Pierre Dure",
            "DE": "Granitstein",
            "ES": "Piedra Dura",
            "IT": "Pietradura",
            "KOR": "딱딱한돌",
            "CHS": "硬石头",
            "CHT": "硬石頭"
        }
    ],
    "Miracle Seed": [
        {
            "NO": 233,
            "EN": "Miracle Seed",
            "JP": "きせきのタネ",
            "FR": "Graine Miracle",
            "DE": "Wundersaat",
            "ES": "Semilla Milagro",
            "IT": "Miracolseme",
            "KOR": "기적의씨",
            "CHS": "奇迹种子",
            "CHT": "奇跡種子"
        }
    ],
    "Black Glasses": [
        {
            "NO": 234,
            "EN": "Black Glasses",
            "JP": "くろいメガネ",
            "FR": "Lunettes Noires",
            "DE": "Schattenbrille",
            "ES": "Gafas de Sol",
            "IT": "Occhialineri",
            "KOR": "검은안경",
            "CHS": "黑色眼镜",
            "CHT": "黑色眼鏡"
        }
    ],
    "Black Belt": [
        {
            "NO": 235,
            "EN": "Black Belt",
            "JP": "くろおび",
            "FR": "Ceinture Noire",
            "DE": "Schwarzgurt",
            "ES": "Cinturón Negro",
            "IT": "Cintura nera",
            "KOR": "검은띠",
            "CHS": "黑带",
            "CHT": "黑帶"
        }
    ],
    "Magnet": [
        {
            "NO": 236,
            "EN": "Magnet",
            "JP": "じしゃく",
            "FR": "Aimant",
            "DE": "Magnet",
            "ES": "Imán",
            "IT": "Calamita",
            "KOR": "자석",
            "CHS": "磁铁",
            "CHT": "磁鐵"
        }
    ],
    "Mystic Water": [
        {
            "NO": 237,
            "EN": "Mystic Water",
            "JP": "しんぴのしずく",
            "FR": "Eau Mystique",
            "DE": "Zauberwasser",
            "ES": "Agua Mística",
            "IT": "Acqua magica",
            "KOR": "신비의물방울",
            "CHS": "神秘水滴",
            "CHT": "神秘水滴"
        }
    ],
    "Sharp Beak": [
        {
            "NO": 238,
            "EN": "Sharp Beak",
            "JP": "するどいくちばし",
            "FR": "Bec Pointu",
            "DE": "Spitzer Schnabel",
            "ES": "Pico Afilado",
            "IT": "Beccaffilato",
            "KOR": "예리한부리",
            "CHS": "锐利鸟嘴",
            "CHT": "銳利鳥嘴"
        }
    ],
    "Poison Barb": [
        {
            "NO": 239,
            "EN": "Poison Barb",
            "JP": "どくバリ",
            "FR": "Pic Venin",
            "DE": "Giftstich",
            "ES": "Flecha Venenosa",
            "IT": "Velenaculeo",
            "KOR": "독바늘",
            "CHS": "毒针",
            "CHT": "毒針"
        }
    ],
    "Never-Melt Ice": [
        {
            "NO": 240,
            "EN": "Never-Melt Ice",
            "JP": "とけないこおり",
            "FR": "Glace Éternelle",
            "DE": "Ewiges Eis",
            "ES": "Antiderretir",
            "IT": "Gelomai",
            "KOR": "녹지않는얼음",
            "CHS": "不融冰",
            "CHT": "不融冰"
        }
    ],
    "Spell Tag": [
        {
            "NO": 241,
            "EN": "Spell Tag",
            "JP": "のろいのおふだ",
            "FR": "Rune Sort",
            "DE": "Bannsticker",
            "ES": "Hechizo",
            "IT": "Spettrotarga",
            "KOR": "저주의부적",
            "CHS": "咒术之符",
            "CHT": "詛咒之符"
        }
    ],
    "Twisted Spoon": [
        {
            "NO": 242,
            "EN": "Twisted Spoon",
            "JP": "まがったスプーン",
            "FR": "Cuillère Tordue",
            "DE": "Krummlöffel",
            "ES": "Cuchara Torcida",
            "IT": "Cucchiaio torto",
            "KOR": "휘어진스푼",
            "CHS": "弯曲的汤匙",
            "CHT": "彎曲的湯匙"
        }
    ],
    "Charcoal": [
        {
            "NO": 243,
            "EN": "Charcoal",
            "JP": "もくたん",
            "FR": "Charbon",
            "DE": "Holzkohle",
            "ES": "Carbón",
            "IT": "Carbonella",
            "KOR": "목탄",
            "CHS": "木炭",
            "CHT": "木炭"
        }
    ],
    "Dragon Fang": [
        {
            "NO": 244,
            "EN": "Dragon Fang",
            "JP": "りゅうのキバ",
            "FR": "Croc Dragon",
            "DE": "Drachenzahn",
            "ES": "Colmillo Dragón",
            "IT": "Dente di drago",
            "KOR": "용의이빨",
            "CHS": "龙之牙",
            "CHT": "龍之牙"
        }
    ],
    "Silk Scarf": [
        {
            "NO": 245,
            "EN": "Silk Scarf",
            "JP": "シルクのスカーフ",
            "FR": "Mouchoir Soie",
            "DE": "Seidenschal",
            "ES": "Pañuelo de Seda",
            "IT": "Sciarpa seta",
            "KOR": "실크스카프",
            "CHS": "丝绸围巾",
            "CHT": "絲綢圍巾"
        }
    ],
    "Upgrade": [
        {
            "NO": 246,
            "EN": "Upgrade",
            "JP": "アップグレード",
            "FR": "Améliorator",
            "DE": "Upgrade",
            "ES": "Mejora",
            "IT": "Upgrade",
            "KOR": "업그레이드",
            "CHS": "升级数据",
            "CHT": "升級資料"
        }
    ],
    "Shell Bell": [
        {
            "NO": 247,
            "EN": "Shell Bell",
            "JP": "かいがらのすず",
            "FR": "Grelot Coque",
            "DE": "Muschelglocke",
            "ES": "Cascabel Concha",
            "IT": "Conchinella",
            "KOR": "조개껍질방울",
            "CHS": "贝壳之铃",
            "CHT": "貝殼之鈴"
        }
    ],
    "Sea Incense": [
        {
            "NO": 248,
            "EN": "Sea Incense",
            "JP": "うしおのおこう",
            "FR": "Encens Mer",
            "DE": "Seerauch",
            "ES": "Incienso Marino",
            "IT": "Marearoma",
            "KOR": "바닷물향로",
            "CHS": "海潮薰香",
            "CHT": "海潮薰香"
        }
    ],
    "Lax Incense": [
        {
            "NO": 249,
            "EN": "Lax Incense",
            "JP": "のんきのおこう",
            "FR": "Encens Doux",
            "DE": "Laxrauch",
            "ES": "Incienso Suave",
            "IT": "Distraroma",
            "KOR": "무사태평향로",
            "CHS": "悠闲薰香",
            "CHT": "悠閒薰香"
        }
    ],
    "Lucky Punch": [
        {
            "NO": 250,
            "EN": "Lucky Punch",
            "JP": "ラッキーパンチ",
            "FR": "Poing Chance",
            "DE": "Lucky Punch",
            "ES": "Puño Suerte",
            "IT": "Fortunpugno",
            "KOR": "럭키펀치",
            "CHS": "吉利拳",
            "CHT": "吉利拳"
        }
    ],
    "Metal Powder": [
        {
            "NO": 251,
            "EN": "Metal Powder",
            "JP": "メタルパウダー",
            "FR": "Poudre Métal",
            "DE": "Metallstaub",
            "ES": "Polvo Metálico",
            "IT": "Metalpolvere",
            "KOR": "금속파우더",
            "CHS": "金属粉",
            "CHT": "金屬粉"
        }
    ],
    "Thick Club": [
        {
            "NO": 252,
            "EN": "Thick Club",
            "JP": "ふといホネ",
            "FR": "Masse Os",
            "DE": "Kampfknochen",
            "ES": "Hueso Grueso",
            "IT": "Osso spesso",
            "KOR": "굵은뼈",
            "CHS": "粗骨头",
            "CHT": "粗骨頭"
        }
    ],
    "Leek": [
        {
            "NO": 253,
            "EN": "Leek",
            "JP": "ながねぎ",
            "FR": "Poireau",
            "DE": "Lauchstange",
            "ES": "Puerro",
            "IT": "Porro",
            "KOR": "대파",
            "CHS": "大葱",
            "CHT": "大蔥"
        }
    ],
    "Red Scarf": [
        {
            "NO": 254,
            "EN": "Red Scarf",
            "JP": "あかいバンダナ",
            "FR": "Foulard Rouge",
            "DE": "Roter Schal",
            "ES": "Pañuelo Rojo",
            "IT": "Fascia rossa",
            "KOR": "빨강밴드",
            "CHS": "红色头巾",
            "CHT": "紅色頭巾"
        }
    ],
    "Blue Scarf": [
        {
            "NO": 255,
            "EN": "Blue Scarf",
            "JP": "あおいバンダナ",
            "FR": "Foulard Bleu",
            "DE": "Blauer Schal",
            "ES": "Pañuelo Azul",
            "IT": "Fascia blu",
            "KOR": "파랑밴드",
            "CHS": "蓝色头巾",
            "CHT": "藍色頭巾"
        }
    ],
    "Pink Scarf": [
        {
            "NO": 256,
            "EN": "Pink Scarf",
            "JP": "ピンクのバンダナ",
            "FR": "Foulard Rose",
            "DE": "Rosa Schal",
            "ES": "Pañuelo Rosa",
            "IT": "Fascia rosa",
            "KOR": "분홍밴드",
            "CHS": "粉红头巾",
            "CHT": "粉紅頭巾"
        }
    ],
    "Green Scarf": [
        {
            "NO": 257,
            "EN": "Green Scarf",
            "JP": "みどりのバンダナ",
            "FR": "Foulard Vert",
            "DE": "Grüner Schal",
            "ES": "Pañuelo Verde",
            "IT": "Fascia verde",
            "KOR": "초록밴드",
            "CHS": "绿色头巾",
            "CHT": "綠色頭巾"
        }
    ],
    "Yellow Scarf": [
        {
            "NO": 258,
            "EN": "Yellow Scarf",
            "JP": "きいろのバンダナ",
            "FR": "Foulard Jaune",
            "DE": "Gelber Schal",
            "ES": "Pañuelo Amarillo",
            "IT": "Fascia gialla",
            "KOR": "노랑밴드",
            "CHS": "黄色头巾",
            "CHT": "黃色頭巾"
        }
    ],
    "Wide Lens": [
        {
            "NO": 259,
            "EN": "Wide Lens",
            "JP": "こうかくレンズ",
            "FR": "Loupe",
            "DE": "Großlinse",
            "ES": "Lupa",
            "IT": "Grandelente",
            "KOR": "광각렌즈",
            "CHS": "广角镜",
            "CHT": "廣角鏡"
        }
    ],
    "Muscle Band": [
        {
            "NO": 260,
            "EN": "Muscle Band",
            "JP": "ちからのハチマキ",
            "FR": "Bandeau Muscle",
            "DE": "Muskelband",
            "ES": "Cinta Fuerte",
            "IT": "Muscolbanda",
            "KOR": "힘의머리띠",
            "CHS": "力量头带",
            "CHT": "力量頭帶"
        }
    ],
    "Wise Glasses": [
        {
            "NO": 261,
            "EN": "Wise Glasses",
            "JP": "ものしりメガネ",
            "FR": "Lunettes Sages",
            "DE": "Schlaubrille",
            "ES": "Gafas Especiales",
            "IT": "Saviocchiali",
            "KOR": "박식안경",
            "CHS": "博识眼镜",
            "CHT": "博識眼鏡"
        }
    ],
    "Expert Belt": [
        {
            "NO": 262,
            "EN": "Expert Belt",
            "JP": "たつじんのおび",
            "FR": "Ceinture Pro",
            "DE": "Expertengurt",
            "ES": "Cinta Experto",
            "IT": "Abilcintura",
            "KOR": "달인의띠",
            "CHS": "达人带",
            "CHT": "達人帶"
        }
    ],
    "Light Clay": [
        {
            "NO": 263,
            "EN": "Light Clay",
            "JP": "ひかりのねんど",
            "FR": "Lumargile",
            "DE": "Lichtlehm",
            "ES": "Refleluz",
            "IT": "Creta luce",
            "KOR": "빛의점토",
            "CHS": "光之黏土",
            "CHT": "光之黏土"
        }
    ],
    "Life Orb": [
        {
            "NO": 264,
            "EN": "Life Orb",
            "JP": "いのちのたま",
            "FR": "Orbe Vie",
            "DE": "Leben-Orb",
            "ES": "Vidasfera",
            "IT": "Assorbisfera",
            "KOR": "생명의구슬",
            "CHS": "生命宝珠",
            "CHT": "生命寶珠"
        }
    ],
    "Power Herb": [
        {
            "NO": 265,
            "EN": "Power Herb",
            "JP": "パワフルハーブ",
            "FR": "Herbe Pouvoir",
            "DE": "Energiekraut",
            "ES": "Hierba Única",
            "IT": "Vigorerba",
            "KOR": "파워풀허브",
            "CHS": "强力香草",
            "CHT": "強力香草"
        }
    ],
    "Toxic Orb": [
        {
            "NO": 266,
            "EN": "Toxic Orb",
            "JP": "どくどくだま",
            "FR": "Orbe Toxique",
            "DE": "Toxik-Orb",
            "ES": "Toxisfera",
            "IT": "Tossicsfera",
            "KOR": "맹독구슬",
            "CHS": "剧毒宝珠",
            "CHT": "劇毒寶珠"
        }
    ],
    "Flame Orb": [
        {
            "NO": 267,
            "EN": "Flame Orb",
            "JP": "かえんだま",
            "FR": "Orbe Flamme",
            "DE": "Heiß-Orb",
            "ES": "Llamasfera",
            "IT": "Fiammosfera",
            "KOR": "화염구슬",
            "CHS": "火焰宝珠",
            "CHT": "火焰寶珠"
        }
    ],
    "Quick Powder": [
        {
            "NO": 268,
            "EN": "Quick Powder",
            "JP": "スピードパウダー",
            "FR": "Poudre Vite",
            "DE": "Flottstaub",
            "ES": "Polvo Veloz",
            "IT": "Velopolvere",
            "KOR": "스피드파우더",
            "CHS": "速度粉",
            "CHT": "速度粉"
        }
    ],
    "Focus Sash": [
        {
            "NO": 269,
            "EN": "Focus Sash",
            "JP": "きあいのタスキ",
            "FR": "Ceinture Force",
            "DE": "Fokusgurt",
            "ES": "Banda Aguante",
            "IT": "Focalnastro",
            "KOR": "기합의띠",
            "CHS": "气势披带",
            "CHT": "氣勢披帶"
        }
    ],
    "Zoom Lens": [
        {
            "NO": 270,
            "EN": "Zoom Lens",
            "JP": "フォーカスレンズ",
            "FR": "Lentille Zoom",
            "DE": "Zoomlinse",
            "ES": "Telescopio",
            "IT": "Zoomlente",
            "KOR": "포커스렌즈",
            "CHS": "对焦镜",
            "CHT": "對焦鏡"
        }
    ],
    "Metronome": [
        {
            "NO": 271,
            "EN": "Metronome",
            "JP": "メトロノーム",
            "FR": "Métronome",
            "DE": "Metronom",
            "ES": "Metrónomo",
            "IT": "Plessimetro",
            "KOR": "메트로놈",
            "CHS": "节拍器",
            "CHT": "節拍器"
        }
    ],
    "Iron Ball": [
        {
            "NO": 272,
            "EN": "Iron Ball",
            "JP": "くろいてっきゅう",
            "FR": "Balle Fer",
            "DE": "Eisenkugel",
            "ES": "Bola Férrea",
            "IT": "Ferropalla",
            "KOR": "검은철구",
            "CHS": "黑色铁球",
            "CHT": "黑色鐵球"
        }
    ],
    "Lagging Tail": [
        {
            "NO": 273,
            "EN": "Lagging Tail",
            "JP": "こうこうのしっぽ",
            "FR": "Ralentiqueue",
            "DE": "Schwerschweif",
            "ES": "Cola Plúmbea",
            "IT": "Rallentocoda",
            "KOR": "느림보꼬리",
            "CHS": "后攻之尾",
            "CHT": "後攻之尾"
        }
    ],
    "Destiny Knot": [
        {
            "NO": 274,
            "EN": "Destiny Knot",
            "JP": "あかいいと",
            "FR": "Nœud Destin",
            "DE": "Fatumknoten",
            "ES": "Lazo Destino",
            "IT": "Destincomune",
            "KOR": "빨간실",
            "CHS": "红线",
            "CHT": "紅線"
        }
    ],
    "Black Sludge": [
        {
            "NO": 275,
            "EN": "Black Sludge",
            "JP": "くろいヘドロ",
            "FR": "Boue Noire",
            "DE": "Giftschleim",
            "ES": "Lodo Negro",
            "IT": "Fangopece",
            "KOR": "검은오물",
            "CHS": "黑色污泥",
            "CHT": "黑色污泥"
        }
    ],
    "Icy Rock": [
        {
            "NO": 276,
            "EN": "Icy Rock",
            "JP": "つめたいいわ",
            "FR": "Roche Glace",
            "DE": "Eisbrocken",
            "ES": "Roca Helada",
            "IT": "Rocciafredda",
            "KOR": "차가운바위",
            "CHS": "冰冷岩石",
            "CHT": "冰冷岩石"
        }
    ],
    "Smooth Rock": [
        {
            "NO": 277,
            "EN": "Smooth Rock",
            "JP": "さらさらいわ",
            "FR": "Roche Lisse",
            "DE": "Glattbrocken",
            "ES": "Roca Suave",
            "IT": "Roccialiscia",
            "KOR": "보송보송바위",
            "CHS": "沙沙岩石",
            "CHT": "沙沙岩石"
        }
    ],
    "Heat Rock": [
        {
            "NO": 278,
            "EN": "Heat Rock",
            "JP": "あついいわ",
            "FR": "Roche Chaude",
            "DE": "Heißbrocken",
            "ES": "Roca Calor",
            "IT": "Rocciacalda",
            "KOR": "뜨거운바위",
            "CHS": "炽热岩石",
            "CHT": "熾熱岩石"
        }
    ],
    "Damp Rock": [
        {
            "NO": 279,
            "EN": "Damp Rock",
            "JP": "しめったいわ",
            "FR": "Roche Humide",
            "DE": "Nassbrocken",
            "ES": "Roca Lluvia",
            "IT": "Rocciaumida",
            "KOR": "축축한바위",
            "CHS": "潮湿岩石",
            "CHT": "潮濕岩石"
        }
    ],
    "Grip Claw": [
        {
            "NO": 280,
            "EN": "Grip Claw",
            "JP": "ねばりのかぎづめ",
            "FR": "Accro Griffe",
            "DE": "Griffklaue",
            "ES": "Garra Garfio",
            "IT": "Presartiglio",
            "KOR": "끈기갈고리손톱",
            "CHS": "紧缠钩爪",
            "CHT": "緊纏鉤爪"
        }
    ],
    "Choice Scarf": [
        {
            "NO": 281,
            "EN": "Choice Scarf",
            "JP": "こだわりスカーフ",
            "FR": "Mouchoir Choix",
            "DE": "Wahlschal",
            "ES": "Pañuelo Elección",
            "IT": "Stolascelta",
            "KOR": "구애스카프",
            "CHS": "讲究围巾",
            "CHT": "講究圍巾"
        }
    ],
    "Sticky Barb": [
        {
            "NO": 282,
            "EN": "Sticky Barb",
            "JP": "くっつきバリ",
            "FR": "Piquants",
            "DE": "Klettdorn",
            "ES": "Toxiestrella",
            "IT": "Vischiopunta",
            "KOR": "끈적끈적바늘",
            "CHS": "附着针",
            "CHT": "附著針"
        }
    ],
    "Power Bracer": [
        {
            "NO": 283,
            "EN": "Power Bracer",
            "JP": "パワーリスト",
            "FR": "Poignet Pouvoir",
            "DE": "Machtreif",
            "ES": "Brazal Recio",
            "IT": "Vigorcerchio",
            "KOR": "파워리스트",
            "CHS": "力量护腕",
            "CHT": "力量護腕"
        }
    ],
    "Power Belt": [
        {
            "NO": 284,
            "EN": "Power Belt",
            "JP": "パワーベルト",
            "FR": "Ceinture Pouvoir",
            "DE": "Machtgurt",
            "ES": "Cinto Recio",
            "IT": "Vigorfascia",
            "KOR": "파워벨트",
            "CHS": "力量腰带",
            "CHT": "力量腰帶"
        }
    ],
    "Power Lens": [
        {
            "NO": 285,
            "EN": "Power Lens",
            "JP": "パワーレンズ",
            "FR": "Lentille Pouvoir",
            "DE": "Machtlinse",
            "ES": "Lente Recia",
            "IT": "Vigorlente",
            "KOR": "파워렌즈",
            "CHS": "力量镜",
            "CHT": "力量鏡"
        }
    ],
    "Power Band": [
        {
            "NO": 286,
            "EN": "Power Band",
            "JP": "パワーバンド",
            "FR": "Bandeau Pouvoir",
            "DE": "Machtband",
            "ES": "Banda Recia",
            "IT": "Vigorbanda",
            "KOR": "파워밴드",
            "CHS": "力量束带",
            "CHT": "力量束帶"
        }
    ],
    "Power Anklet": [
        {
            "NO": 287,
            "EN": "Power Anklet",
            "JP": "パワーアンクル",
            "FR": "Chaîne Pouvoir",
            "DE": "Machtkette",
            "ES": "Franja Recia",
            "IT": "Vigorgliera",
            "KOR": "파워앵클릿",
            "CHS": "力量护踝",
            "CHT": "力量護踝"
        }
    ],
    "Power Weight": [
        {
            "NO": 288,
            "EN": "Power Weight",
            "JP": "パワーウエイト",
            "FR": "Poids Pouvoir",
            "DE": "Machtgewicht",
            "ES": "Pesa Recia",
            "IT": "Vigorpeso",
            "KOR": "파워웨이트",
            "CHS": "力量负重",
            "CHT": "力量負重"
        }
    ],
    "Shed Shell": [
        {
            "NO": 289,
            "EN": "Shed Shell",
            "JP": "きれいなぬけがら",
            "FR": "Carapace Mue",
            "DE": "Wechselhülle",
            "ES": "Muda Concha",
            "IT": "Disfoguscio",
            "KOR": "아름다운허물",
            "CHS": "美丽空壳",
            "CHT": "美麗空殼"
        }
    ],
    "Big Root": [
        {
            "NO": 290,
            "EN": "Big Root",
            "JP": "おおきなねっこ",
            "FR": "Grosse Racine",
            "DE": "Großwurzel",
            "ES": "Raíz Grande",
            "IT": "Granradice",
            "KOR": "큰뿌리",
            "CHS": "大根茎",
            "CHT": "大根莖"
        }
    ],
    "Choice Specs": [
        {
            "NO": 291,
            "EN": "Choice Specs",
            "JP": "こだわりメガネ",
            "FR": "Lunettes Choix",
            "DE": "Wahlbrille",
            "ES": "Gafas Elección",
            "IT": "Lentiscelta",
            "KOR": "구애안경",
            "CHS": "讲究眼镜",
            "CHT": "講究眼鏡"
        }
    ],
    "Flame Plate": [
        {
            "NO": 292,
            "EN": "Flame Plate",
            "JP": "ひのたまプレート",
            "FR": "Plaque Flamme",
            "DE": "Feuertafel",
            "ES": "Tabla Llama",
            "IT": "Lastrarogo",
            "KOR": "불구슬플레이트",
            "CHS": "火球石板",
            "CHT": "火球石板"
        }
    ],
    "Splash Plate": [
        {
            "NO": 293,
            "EN": "Splash Plate",
            "JP": "しずくプレート",
            "FR": "Plaque Hydro",
            "DE": "Wassertafel",
            "ES": "Tabla Linfa",
            "IT": "Lastraidro",
            "KOR": "물방울플레이트",
            "CHS": "水滴石板",
            "CHT": "水滴石板"
        }
    ],
    "Zap Plate": [
        {
            "NO": 294,
            "EN": "Zap Plate",
            "JP": "いかずちプレート",
            "FR": "Plaque Volt",
            "DE": "Blitztafel",
            "ES": "Tabla Trueno",
            "IT": "Lastrasaetta",
            "KOR": "우레플레이트",
            "CHS": "雷电石板",
            "CHT": "雷電石板"
        }
    ],
    "Meadow Plate": [
        {
            "NO": 295,
            "EN": "Meadow Plate",
            "JP": "みどりのプレート",
            "FR": "Plaque Herbe",
            "DE": "Wiesentafel",
            "ES": "Tabla Pradal",
            "IT": "Lastraprato",
            "KOR": "초록플레이트",
            "CHS": "碧绿石板",
            "CHT": "碧綠石板"
        }
    ],
    "Icicle Plate": [
        {
            "NO": 296,
            "EN": "Icicle Plate",
            "JP": "つららのプレート",
            "FR": "Plaque Glace",
            "DE": "Frosttafel",
            "ES": "Tabla Helada",
            "IT": "Lastragelo",
            "KOR": "고드름플레이트",
            "CHS": "冰柱石板",
            "CHT": "冰柱石板"
        }
    ],
    "Fist Plate": [
        {
            "NO": 297,
            "EN": "Fist Plate",
            "JP": "こぶしのプレート",
            "FR": "Plaque Poing",
            "DE": "Fausttafel",
            "ES": "Tabla Fuerte",
            "IT": "Lastrapugno",
            "KOR": "주먹플레이트",
            "CHS": "拳头石板",
            "CHT": "拳頭石板"
        }
    ],
    "Toxic Plate": [
        {
            "NO": 298,
            "EN": "Toxic Plate",
            "JP": "もうどくプレート",
            "FR": "Plaque Toxicité",
            "DE": "Gifttafel",
            "ES": "Tabla Tóxica",
            "IT": "Lastrafiele",
            "KOR": "맹독플레이트",
            "CHS": "剧毒石板",
            "CHT": "劇毒石板"
        }
    ],
    "Earth Plate": [
        {
            "NO": 299,
            "EN": "Earth Plate",
            "JP": "だいちのプレート",
            "FR": "Plaque Terre",
            "DE": "Erdtafel",
            "ES": "Tabla Terrax",
            "IT": "Lastrageo",
            "KOR": "대지플레이트",
            "CHS": "大地石板",
            "CHT": "大地石板"
        }
    ],
    "Sky Plate": [
        {
            "NO": 300,
            "EN": "Sky Plate",
            "JP": "あおぞらプレート",
            "FR": "Plaque Ciel",
            "DE": "Wolkentafel",
            "ES": "Tabla Cielo",
            "IT": "Lastracielo",
            "KOR": "푸른하늘플레이트",
            "CHS": "蓝天石板",
            "CHT": "藍天石板"
        }
    ],
    "Mind Plate": [
        {
            "NO": 301,
            "EN": "Mind Plate",
            "JP": "ふしぎのプレート",
            "FR": "Plaque Esprit",
            "DE": "Hirntafel",
            "ES": "Tabla Mental",
            "IT": "Lastramente",
            "KOR": "이상한플레이트",
            "CHS": "神奇石板",
            "CHT": "神奇石板"
        }
    ],
    "Insect Plate": [
        {
            "NO": 302,
            "EN": "Insect Plate",
            "JP": "たまむしプレート",
            "FR": "Plaque Insecte",
            "DE": "Käfertafel",
            "ES": "Tabla Bicho",
            "IT": "Lastrabaco",
            "KOR": "비단벌레플레이트",
            "CHS": "玉虫石板",
            "CHT": "玉蟲石板"
        }
    ],
    "Stone Plate": [
        {
            "NO": 303,
            "EN": "Stone Plate",
            "JP": "がんせきプレート",
            "FR": "Plaque Roc",
            "DE": "Steintafel",
            "ES": "Tabla Pétrea",
            "IT": "Lastrapietra",
            "KOR": "암석플레이트",
            "CHS": "岩石石板",
            "CHT": "岩石石板"
        }
    ],
    "Spooky Plate": [
        {
            "NO": 304,
            "EN": "Spooky Plate",
            "JP": "もののけプレート",
            "FR": "Plaque Fantôme",
            "DE": "Spuktafel",
            "ES": "Tabla Terror",
            "IT": "Lastratetra",
            "KOR": "원령플레이트",
            "CHS": "妖怪石板",
            "CHT": "妖怪石板"
        }
    ],
    "Draco Plate": [
        {
            "NO": 305,
            "EN": "Draco Plate",
            "JP": "りゅうのプレート",
            "FR": "Plaque Draco",
            "DE": "Dracotafel",
            "ES": "Tabla Draco",
            "IT": "Lastradrakon",
            "KOR": "용의플레이트",
            "CHS": "龙之石板",
            "CHT": "龍之石板"
        }
    ],
    "Dread Plate": [
        {
            "NO": 306,
            "EN": "Dread Plate",
            "JP": "こわもてプレート",
            "FR": "Plaque Ombre",
            "DE": "Furchttafel",
            "ES": "Tabla Oscura",
            "IT": "Lastratimore",
            "KOR": "공포플레이트",
            "CHS": "恶颜石板",
            "CHT": "惡顏石板"
        }
    ],
    "Iron Plate": [
        {
            "NO": 307,
            "EN": "Iron Plate",
            "JP": "こうてつプレート",
            "FR": "Plaque Fer",
            "DE": "Eisentafel",
            "ES": "Tabla Acero",
            "IT": "Lastraferro",
            "KOR": "강철플레이트",
            "CHS": "钢铁石板",
            "CHT": "鋼鐵石板"
        }
    ],
    "Odd Incense": [
        {
            "NO": 308,
            "EN": "Odd Incense",
            "JP": "あやしいおこう",
            "FR": "Encens Bizarre",
            "DE": "Schrägrauch",
            "ES": "Incienso Raro",
            "IT": "Bizzoaroma",
            "KOR": "괴상한향로",
            "CHS": "奇异薰香",
            "CHT": "奇異薰香"
        }
    ],
    "Rock Incense": [
        {
            "NO": 309,
            "EN": "Rock Incense",
            "JP": "がんせきおこう",
            "FR": "Encens Roc",
            "DE": "Steinrauch",
            "ES": "Incienso Roca",
            "IT": "Roccioaroma",
            "KOR": "암석향로",
            "CHS": "岩石薰香",
            "CHT": "岩石薰香"
        }
    ],
    "Full Incense": [
        {
            "NO": 310,
            "EN": "Full Incense",
            "JP": "まんぷくおこう",
            "FR": "Encens Plein",
            "DE": "Lahmrauch",
            "ES": "Incienso Lento",
            "IT": "Gonfioaroma",
            "KOR": "만복향로",
            "CHS": "饱腹薰香",
            "CHT": "飽腹薰香"
        }
    ],
    "Wave Incense": [
        {
            "NO": 311,
            "EN": "Wave Incense",
            "JP": "さざなみのおこう",
            "FR": "Encens Vague",
            "DE": "Wellenrauch",
            "ES": "Incienso Acua",
            "IT": "Ondaroma",
            "KOR": "잔물결향로",
            "CHS": "涟漪薰香",
            "CHT": "漣漪薰香"
        }
    ],
    "Rose Incense": [
        {
            "NO": 312,
            "EN": "Rose Incense",
            "JP": "おはなのおこう",
            "FR": "Encens Fleur",
            "DE": "Rosenrauch",
            "ES": "Incienso Floral",
            "IT": "Rosaroma",
            "KOR": "꽃향로",
            "CHS": "花朵薰香",
            "CHT": "花朵薰香"
        }
    ],
    "Luck Incense": [
        {
            "NO": 313,
            "EN": "Luck Incense",
            "JP": "こううんのおこう",
            "FR": "Encens Veine",
            "DE": "Glücksrauch",
            "ES": "Incienso Duplo",
            "IT": "Fortunaroma",
            "KOR": "행운의향로",
            "CHS": "幸运薰香",
            "CHT": "幸運薰香"
        }
    ],
    "Pure Incense": [
        {
            "NO": 314,
            "EN": "Pure Incense",
            "JP": "きよめのおこう",
            "FR": "Encens Pur",
            "DE": "Scheuchrauch",
            "ES": "Incienso Puro",
            "IT": "Puroaroma",
            "KOR": "순결의향로",
            "CHS": "洁净薰香",
            "CHT": "潔淨薰香"
        }
    ],
    "Protector": [
        {
            "NO": 315,
            "EN": "Protector",
            "JP": "プロテクター",
            "FR": "Protecteur",
            "DE": "Schützer",
            "ES": "Protector",
            "IT": "Copertura",
            "KOR": "프로텍터",
            "CHS": "护具",
            "CHT": "護具"
        }
    ],
    "Electirizer": [
        {
            "NO": 316,
            "EN": "Electirizer",
            "JP": "エレキブースター",
            "FR": "Électriseur",
            "DE": "Stromisierer",
            "ES": "Electrizador",
            "IT": "Elettritore",
            "KOR": "에레키부스터",
            "CHS": "电力增幅器",
            "CHT": "電力增幅器"
        }
    ],
    "Magmarizer": [
        {
            "NO": 317,
            "EN": "Magmarizer",
            "JP": "マグマブースター",
            "FR": "Magmariseur",
            "DE": "Magmaisierer",
            "ES": "Magmatizador",
            "IT": "Magmatore",
            "KOR": "마그마부스터",
            "CHS": "熔岩增幅器",
            "CHT": "熔岩增幅器"
        }
    ],
    "Dubious Disc": [
        {
            "NO": 318,
            "EN": "Dubious Disc",
            "JP": "あやしいパッチ",
            "FR": "CD Douteux",
            "DE": "Dubiosdisc",
            "ES": "Disco Extraño",
            "IT": "Dubbiodisco",
            "KOR": "괴상한패치",
            "CHS": "可疑补丁",
            "CHT": "可疑修正檔"
        }
    ],
    "Reaper Cloth": [
        {
            "NO": 319,
            "EN": "Reaper Cloth",
            "JP": "れいかいのぬの",
            "FR": "Tissu Fauche",
            "DE": "Düsterumhang",
            "ES": "Tela Terrible",
            "IT": "Terrorpanno",
            "KOR": "영계의천",
            "CHS": "灵界之布",
            "CHT": "靈界之布"
        }
    ],
    "Razor Claw": [
        {
            "NO": 320,
            "EN": "Razor Claw",
            "JP": "するどいツメ",
            "FR": "Griffe Rasoir",
            "DE": "Scharfklaue",
            "ES": "Garra Afilada",
            "IT": "Affilartiglio",
            "KOR": "예리한손톱",
            "CHS": "锐利之爪",
            "CHT": "銳利之爪"
        }
    ],
    "Razor Fang": [
        {
            "NO": 321,
            "EN": "Razor Fang",
            "JP": "するどいキバ",
            "FR": "Croc Rasoir",
            "DE": "Scharfzahn",
            "ES": "Colmillo Agudo",
            "IT": "Affilodente",
            "KOR": "예리한이빨",
            "CHS": "锐利之牙",
            "CHT": "銳利之牙"
        }
    ],
    "TM01": [
        {
            "NO": 322,
            "EN": "TM01",
            "JP": "わざマシン０１",
            "FR": "CT01",
            "DE": "TM01",
            "ES": "MT01",
            "IT": "MT01",
            "KOR": "기술머신01",
            "CHS": "招式学习器０１",
            "CHT": "招式學習器０１"
        }
    ],
    "TM02": [
        {
            "NO": 323,
            "EN": "TM02",
            "JP": "わざマシン０２",
            "FR": "CT02",
            "DE": "TM02",
            "ES": "MT02",
            "IT": "MT02",
            "KOR": "기술머신02",
            "CHS": "招式学习器０２",
            "CHT": "招式學習器０２"
        }
    ],
    "TM03": [
        {
            "NO": 324,
            "EN": "TM03",
            "JP": "わざマシン０３",
            "FR": "CT03",
            "DE": "TM03",
            "ES": "MT03",
            "IT": "MT03",
            "KOR": "기술머신03",
            "CHS": "招式学习器０３",
            "CHT": "招式學習器０３"
        }
    ],
    "TM04": [
        {
            "NO": 325,
            "EN": "TM04",
            "JP": "わざマシン０４",
            "FR": "CT04",
            "DE": "TM04",
            "ES": "MT04",
            "IT": "MT04",
            "KOR": "기술머신04",
            "CHS": "招式学习器０４",
            "CHT": "招式學習器０４"
        }
    ],
    "TM05": [
        {
            "NO": 326,
            "EN": "TM05",
            "JP": "わざマシン０５",
            "FR": "CT05",
            "DE": "TM05",
            "ES": "MT05",
            "IT": "MT05",
            "KOR": "기술머신05",
            "CHS": "招式学习器０５",
            "CHT": "招式學習器０５"
        }
    ],
    "TM06": [
        {
            "NO": 327,
            "EN": "TM06",
            "JP": "わざマシン０６",
            "FR": "CT06",
            "DE": "TM06",
            "ES": "MT06",
            "IT": "MT06",
            "KOR": "기술머신06",
            "CHS": "招式学习器０６",
            "CHT": "招式學習器０６"
        }
    ],
    "TM07": [
        {
            "NO": 328,
            "EN": "TM07",
            "JP": "わざマシン０７",
            "FR": "CT07",
            "DE": "TM07",
            "ES": "MT07",
            "IT": "MT07",
            "KOR": "기술머신07",
            "CHS": "招式学习器０７",
            "CHT": "招式學習器０７"
        }
    ],
    "TM08": [
        {
            "NO": 329,
            "EN": "TM08",
            "JP": "わざマシン０８",
            "FR": "CT08",
            "DE": "TM08",
            "ES": "MT08",
            "IT": "MT08",
            "KOR": "기술머신08",
            "CHS": "招式学习器０８",
            "CHT": "招式學習器０８"
        }
    ],
    "TM09": [
        {
            "NO": 330,
            "EN": "TM09",
            "JP": "わざマシン０９",
            "FR": "CT09",
            "DE": "TM09",
            "ES": "MT09",
            "IT": "MT09",
            "KOR": "기술머신09",
            "CHS": "招式学习器０９",
            "CHT": "招式學習器０９"
        }
    ],
    "TM10": [
        {
            "NO": 331,
            "EN": "TM10",
            "JP": "わざマシン１０",
            "FR": "CT10",
            "DE": "TM10",
            "ES": "MT10",
            "IT": "MT10",
            "KOR": "기술머신10",
            "CHS": "招式学习器１０",
            "CHT": "招式學習器１０"
        }
    ],
    "TM11": [
        {
            "NO": 332,
            "EN": "TM11",
            "JP": "わざマシン１１",
            "FR": "CT11",
            "DE": "TM11",
            "ES": "MT11",
            "IT": "MT11",
            "KOR": "기술머신11",
            "CHS": "招式学习器１１",
            "CHT": "招式學習器１１"
        }
    ],
    "TM12": [
        {
            "NO": 333,
            "EN": "TM12",
            "JP": "わざマシン１２",
            "FR": "CT12",
            "DE": "TM12",
            "ES": "MT12",
            "IT": "MT12",
            "KOR": "기술머신12",
            "CHS": "招式学习器１２",
            "CHT": "招式學習器１２"
        }
    ],
    "TM13": [
        {
            "NO": 334,
            "EN": "TM13",
            "JP": "わざマシン１３",
            "FR": "CT13",
            "DE": "TM13",
            "ES": "MT13",
            "IT": "MT13",
            "KOR": "기술머신13",
            "CHS": "招式学习器１３",
            "CHT": "招式學習器１３"
        }
    ],
    "TM14": [
        {
            "NO": 335,
            "EN": "TM14",
            "JP": "わざマシン１４",
            "FR": "CT14",
            "DE": "TM14",
            "ES": "MT14",
            "IT": "MT14",
            "KOR": "기술머신14",
            "CHS": "招式学习器１４",
            "CHT": "招式學習器１４"
        }
    ],
    "TM15": [
        {
            "NO": 336,
            "EN": "TM15",
            "JP": "わざマシン１５",
            "FR": "CT15",
            "DE": "TM15",
            "ES": "MT15",
            "IT": "MT15",
            "KOR": "기술머신15",
            "CHS": "招式学习器１５",
            "CHT": "招式學習器１５"
        }
    ],
    "TM16": [
        {
            "NO": 337,
            "EN": "TM16",
            "JP": "わざマシン１６",
            "FR": "CT16",
            "DE": "TM16",
            "ES": "MT16",
            "IT": "MT16",
            "KOR": "기술머신16",
            "CHS": "招式学习器１６",
            "CHT": "招式學習器１６"
        }
    ],
    "TM17": [
        {
            "NO": 338,
            "EN": "TM17",
            "JP": "わざマシン１７",
            "FR": "CT17",
            "DE": "TM17",
            "ES": "MT17",
            "IT": "MT17",
            "KOR": "기술머신17",
            "CHS": "招式学习器１７",
            "CHT": "招式學習器１７"
        }
    ],
    "TM18": [
        {
            "NO": 339,
            "EN": "TM18",
            "JP": "わざマシン１８",
            "FR": "CT18",
            "DE": "TM18",
            "ES": "MT18",
            "IT": "MT18",
            "KOR": "기술머신18",
            "CHS": "招式学习器１８",
            "CHT": "招式學習器１８"
        }
    ],
    "TM19": [
        {
            "NO": 340,
            "EN": "TM19",
            "JP": "わざマシン１９",
            "FR": "CT19",
            "DE": "TM19",
            "ES": "MT19",
            "IT": "MT19",
            "KOR": "기술머신19",
            "CHS": "招式学习器１９",
            "CHT": "招式學習器１９"
        }
    ],
    "TM20": [
        {
            "NO": 341,
            "EN": "TM20",
            "JP": "わざマシン２０",
            "FR": "CT20",
            "DE": "TM20",
            "ES": "MT20",
            "IT": "MT20",
            "KOR": "기술머신20",
            "CHS": "招式学习器２０",
            "CHT": "招式學習器２０"
        }
    ],
    "TM21": [
        {
            "NO": 342,
            "EN": "TM21",
            "JP": "わざマシン２１",
            "FR": "CT21",
            "DE": "TM21",
            "ES": "MT21",
            "IT": "MT21",
            "KOR": "기술머신21",
            "CHS": "招式学习器２１",
            "CHT": "招式學習器２１"
        }
    ],
    "TM22": [
        {
            "NO": 343,
            "EN": "TM22",
            "JP": "わざマシン２２",
            "FR": "CT22",
            "DE": "TM22",
            "ES": "MT22",
            "IT": "MT22",
            "KOR": "기술머신22",
            "CHS": "招式学习器２２",
            "CHT": "招式學習器２２"
        }
    ],
    "TM23": [
        {
            "NO": 344,
            "EN": "TM23",
            "JP": "わざマシン２３",
            "FR": "CT23",
            "DE": "TM23",
            "ES": "MT23",
            "IT": "MT23",
            "KOR": "기술머신23",
            "CHS": "招式学习器２３",
            "CHT": "招式學習器２３"
        }
    ],
    "TM24": [
        {
            "NO": 345,
            "EN": "TM24",
            "JP": "わざマシン２４",
            "FR": "CT24",
            "DE": "TM24",
            "ES": "MT24",
            "IT": "MT24",
            "KOR": "기술머신24",
            "CHS": "招式学习器２４",
            "CHT": "招式學習器２４"
        }
    ],
    "TM25": [
        {
            "NO": 346,
            "EN": "TM25",
            "JP": "わざマシン２５",
            "FR": "CT25",
            "DE": "TM25",
            "ES": "MT25",
            "IT": "MT25",
            "KOR": "기술머신25",
            "CHS": "招式学习器２５",
            "CHT": "招式學習器２５"
        }
    ],
    "TM26": [
        {
            "NO": 347,
            "EN": "TM26",
            "JP": "わざマシン２６",
            "FR": "CT26",
            "DE": "TM26",
            "ES": "MT26",
            "IT": "MT26",
            "KOR": "기술머신26",
            "CHS": "招式学习器２６",
            "CHT": "招式學習器２６"
        }
    ],
    "TM27": [
        {
            "NO": 348,
            "EN": "TM27",
            "JP": "わざマシン２７",
            "FR": "CT27",
            "DE": "TM27",
            "ES": "MT27",
            "IT": "MT27",
            "KOR": "기술머신27",
            "CHS": "招式学习器２７",
            "CHT": "招式學習器２７"
        }
    ],
    "TM28": [
        {
            "NO": 349,
            "EN": "TM28",
            "JP": "わざマシン２８",
            "FR": "CT28",
            "DE": "TM28",
            "ES": "MT28",
            "IT": "MT28",
            "KOR": "기술머신28",
            "CHS": "招式学习器２８",
            "CHT": "招式學習器２８"
        }
    ],
    "TM29": [
        {
            "NO": 350,
            "EN": "TM29",
            "JP": "わざマシン２９",
            "FR": "CT29",
            "DE": "TM29",
            "ES": "MT29",
            "IT": "MT29",
            "KOR": "기술머신29",
            "CHS": "招式学习器２９",
            "CHT": "招式學習器２９"
        }
    ],
    "TM30": [
        {
            "NO": 351,
            "EN": "TM30",
            "JP": "わざマシン３０",
            "FR": "CT30",
            "DE": "TM30",
            "ES": "MT30",
            "IT": "MT30",
            "KOR": "기술머신30",
            "CHS": "招式学习器３０",
            "CHT": "招式學習器３０"
        }
    ],
    "TM31": [
        {
            "NO": 352,
            "EN": "TM31",
            "JP": "わざマシン３１",
            "FR": "CT31",
            "DE": "TM31",
            "ES": "MT31",
            "IT": "MT31",
            "KOR": "기술머신31",
            "CHS": "招式学习器３１",
            "CHT": "招式學習器３１"
        }
    ],
    "TM32": [
        {
            "NO": 353,
            "EN": "TM32",
            "JP": "わざマシン３２",
            "FR": "CT32",
            "DE": "TM32",
            "ES": "MT32",
            "IT": "MT32",
            "KOR": "기술머신32",
            "CHS": "招式学习器３２",
            "CHT": "招式學習器３２"
        }
    ],
    "TM33": [
        {
            "NO": 354,
            "EN": "TM33",
            "JP": "わざマシン３３",
            "FR": "CT33",
            "DE": "TM33",
            "ES": "MT33",
            "IT": "MT33",
            "KOR": "기술머신33",
            "CHS": "招式学习器３３",
            "CHT": "招式學習器３３"
        }
    ],
    "TM34": [
        {
            "NO": 355,
            "EN": "TM34",
            "JP": "わざマシン３４",
            "FR": "CT34",
            "DE": "TM34",
            "ES": "MT34",
            "IT": "MT34",
            "KOR": "기술머신34",
            "CHS": "招式学习器３４",
            "CHT": "招式學習器３４"
        }
    ],
    "TM35": [
        {
            "NO": 356,
            "EN": "TM35",
            "JP": "わざマシン３５",
            "FR": "CT35",
            "DE": "TM35",
            "ES": "MT35",
            "IT": "MT35",
            "KOR": "기술머신35",
            "CHS": "招式学习器３５",
            "CHT": "招式學習器３５"
        }
    ],
    "TM36": [
        {
            "NO": 357,
            "EN": "TM36",
            "JP": "わざマシン３６",
            "FR": "CT36",
            "DE": "TM36",
            "ES": "MT36",
            "IT": "MT36",
            "KOR": "기술머신36",
            "CHS": "招式学习器３６",
            "CHT": "招式學習器３６"
        }
    ],
    "TM37": [
        {
            "NO": 358,
            "EN": "TM37",
            "JP": "わざマシン３７",
            "FR": "CT37",
            "DE": "TM37",
            "ES": "MT37",
            "IT": "MT37",
            "KOR": "기술머신37",
            "CHS": "招式学习器３７",
            "CHT": "招式學習器３７"
        }
    ],
    "TM38": [
        {
            "NO": 359,
            "EN": "TM38",
            "JP": "わざマシン３８",
            "FR": "CT38",
            "DE": "TM38",
            "ES": "MT38",
            "IT": "MT38",
            "KOR": "기술머신38",
            "CHS": "招式学习器３８",
            "CHT": "招式學習器３８"
        }
    ],
    "TM39": [
        {
            "NO": 360,
            "EN": "TM39",
            "JP": "わざマシン３９",
            "FR": "CT39",
            "DE": "TM39",
            "ES": "MT39",
            "IT": "MT39",
            "KOR": "기술머신39",
            "CHS": "招式学习器３９",
            "CHT": "招式學習器３９"
        }
    ],
    "TM40": [
        {
            "NO": 361,
            "EN": "TM40",
            "JP": "わざマシン４０",
            "FR": "CT40",
            "DE": "TM40",
            "ES": "MT40",
            "IT": "MT40",
            "KOR": "기술머신40",
            "CHS": "招式学习器４０",
            "CHT": "招式學習器４０"
        }
    ],
    "TM41": [
        {
            "NO": 362,
            "EN": "TM41",
            "JP": "わざマシン４１",
            "FR": "CT41",
            "DE": "TM41",
            "ES": "MT41",
            "IT": "MT41",
            "KOR": "기술머신41",
            "CHS": "招式学习器４１",
            "CHT": "招式學習器４１"
        }
    ],
    "TM42": [
        {
            "NO": 363,
            "EN": "TM42",
            "JP": "わざマシン４２",
            "FR": "CT42",
            "DE": "TM42",
            "ES": "MT42",
            "IT": "MT42",
            "KOR": "기술머신42",
            "CHS": "招式学习器４２",
            "CHT": "招式學習器４２"
        }
    ],
    "TM43": [
        {
            "NO": 364,
            "EN": "TM43",
            "JP": "わざマシン４３",
            "FR": "CT43",
            "DE": "TM43",
            "ES": "MT43",
            "IT": "MT43",
            "KOR": "기술머신43",
            "CHS": "招式学习器４３",
            "CHT": "招式學習器４３"
        }
    ],
    "TM44": [
        {
            "NO": 365,
            "EN": "TM44",
            "JP": "わざマシン４４",
            "FR": "CT44",
            "DE": "TM44",
            "ES": "MT44",
            "IT": "MT44",
            "KOR": "기술머신44",
            "CHS": "招式学习器４４",
            "CHT": "招式學習器４４"
        }
    ],
    "TM45": [
        {
            "NO": 366,
            "EN": "TM45",
            "JP": "わざマシン４５",
            "FR": "CT45",
            "DE": "TM45",
            "ES": "MT45",
            "IT": "MT45",
            "KOR": "기술머신45",
            "CHS": "招式学习器４５",
            "CHT": "招式學習器４５"
        }
    ],
    "TM46": [
        {
            "NO": 367,
            "EN": "TM46",
            "JP": "わざマシン４６",
            "FR": "CT46",
            "DE": "TM46",
            "ES": "MT46",
            "IT": "MT46",
            "KOR": "기술머신46",
            "CHS": "招式学习器４６",
            "CHT": "招式學習器４６"
        }
    ],
    "TM47": [
        {
            "NO": 368,
            "EN": "TM47",
            "JP": "わざマシン４７",
            "FR": "CT47",
            "DE": "TM47",
            "ES": "MT47",
            "IT": "MT47",
            "KOR": "기술머신47",
            "CHS": "招式学习器４７",
            "CHT": "招式學習器４７"
        }
    ],
    "TM48": [
        {
            "NO": 369,
            "EN": "TM48",
            "JP": "わざマシン４８",
            "FR": "CT48",
            "DE": "TM48",
            "ES": "MT48",
            "IT": "MT48",
            "KOR": "기술머신48",
            "CHS": "招式学习器４８",
            "CHT": "招式學習器４８"
        }
    ],
    "TM49": [
        {
            "NO": 370,
            "EN": "TM49",
            "JP": "わざマシン４９",
            "FR": "CT49",
            "DE": "TM49",
            "ES": "MT49",
            "IT": "MT49",
            "KOR": "기술머신49",
            "CHS": "招式学习器４９",
            "CHT": "招式學習器４９"
        }
    ],
    "TM50": [
        {
            "NO": 371,
            "EN": "TM50",
            "JP": "わざマシン５０",
            "FR": "CT50",
            "DE": "TM50",
            "ES": "MT50",
            "IT": "MT50",
            "KOR": "기술머신50",
            "CHS": "招式学习器５０",
            "CHT": "招式學習器５０"
        }
    ],
    "TM51": [
        {
            "NO": 372,
            "EN": "TM51",
            "JP": "わざマシン５１",
            "FR": "CT51",
            "DE": "TM51",
            "ES": "MT51",
            "IT": "MT51",
            "KOR": "기술머신51",
            "CHS": "招式学习器５１",
            "CHT": "招式學習器５１"
        }
    ],
    "TM52": [
        {
            "NO": 373,
            "EN": "TM52",
            "JP": "わざマシン５２",
            "FR": "CT52",
            "DE": "TM52",
            "ES": "MT52",
            "IT": "MT52",
            "KOR": "기술머신52",
            "CHS": "招式学习器５２",
            "CHT": "招式學習器５２"
        }
    ],
    "TM53": [
        {
            "NO": 374,
            "EN": "TM53",
            "JP": "わざマシン５３",
            "FR": "CT53",
            "DE": "TM53",
            "ES": "MT53",
            "IT": "MT53",
            "KOR": "기술머신53",
            "CHS": "招式学习器５３",
            "CHT": "招式學習器５３"
        }
    ],
    "TM54": [
        {
            "NO": 375,
            "EN": "TM54",
            "JP": "わざマシン５４",
            "FR": "CT54",
            "DE": "TM54",
            "ES": "MT54",
            "IT": "MT54",
            "KOR": "기술머신54",
            "CHS": "招式学习器５４",
            "CHT": "招式學習器５４"
        }
    ],
    "TM55": [
        {
            "NO": 376,
            "EN": "TM55",
            "JP": "わざマシン５５",
            "FR": "CT55",
            "DE": "TM55",
            "ES": "MT55",
            "IT": "MT55",
            "KOR": "기술머신55",
            "CHS": "招式学习器５５",
            "CHT": "招式學習器５５"
        }
    ],
    "TM56": [
        {
            "NO": 377,
            "EN": "TM56",
            "JP": "わざマシン５６",
            "FR": "CT56",
            "DE": "TM56",
            "ES": "MT56",
            "IT": "MT56",
            "KOR": "기술머신56",
            "CHS": "招式学习器５６",
            "CHT": "招式學習器５６"
        }
    ],
    "TM57": [
        {
            "NO": 378,
            "EN": "TM57",
            "JP": "わざマシン５７",
            "FR": "CT57",
            "DE": "TM57",
            "ES": "MT57",
            "IT": "MT57",
            "KOR": "기술머신57",
            "CHS": "招式学习器５７",
            "CHT": "招式學習器５７"
        }
    ],
    "TM58": [
        {
            "NO": 379,
            "EN": "TM58",
            "JP": "わざマシン５８",
            "FR": "CT58",
            "DE": "TM58",
            "ES": "MT58",
            "IT": "MT58",
            "KOR": "기술머신58",
            "CHS": "招式学习器５８",
            "CHT": "招式學習器５８"
        }
    ],
    "TM59": [
        {
            "NO": 380,
            "EN": "TM59",
            "JP": "わざマシン５９",
            "FR": "CT59",
            "DE": "TM59",
            "ES": "MT59",
            "IT": "MT59",
            "KOR": "기술머신59",
            "CHS": "招式学习器５９",
            "CHT": "招式學習器５９"
        }
    ],
    "TM60": [
        {
            "NO": 381,
            "EN": "TM60",
            "JP": "わざマシン６０",
            "FR": "CT60",
            "DE": "TM60",
            "ES": "MT60",
            "IT": "MT60",
            "KOR": "기술머신60",
            "CHS": "招式学习器６０",
            "CHT": "招式學習器６０"
        }
    ],
    "TM61": [
        {
            "NO": 382,
            "EN": "TM61",
            "JP": "わざマシン６１",
            "FR": "CT61",
            "DE": "TM61",
            "ES": "MT61",
            "IT": "MT61",
            "KOR": "기술머신61",
            "CHS": "招式学习器６１",
            "CHT": "招式學習器６１"
        }
    ],
    "TM62": [
        {
            "NO": 383,
            "EN": "TM62",
            "JP": "わざマシン６２",
            "FR": "CT62",
            "DE": "TM62",
            "ES": "MT62",
            "IT": "MT62",
            "KOR": "기술머신62",
            "CHS": "招式学习器６２",
            "CHT": "招式學習器６２"
        }
    ],
    "TM63": [
        {
            "NO": 384,
            "EN": "TM63",
            "JP": "わざマシン６３",
            "FR": "CT63",
            "DE": "TM63",
            "ES": "MT63",
            "IT": "MT63",
            "KOR": "기술머신63",
            "CHS": "招式学习器６３",
            "CHT": "招式學習器６３"
        }
    ],
    "TM64": [
        {
            "NO": 385,
            "EN": "TM64",
            "JP": "わざマシン６４",
            "FR": "CT64",
            "DE": "TM64",
            "ES": "MT64",
            "IT": "MT64",
            "KOR": "기술머신64",
            "CHS": "招式学习器６４",
            "CHT": "招式學習器６４"
        }
    ],
    "TM65": [
        {
            "NO": 386,
            "EN": "TM65",
            "JP": "わざマシン６５",
            "FR": "CT65",
            "DE": "TM65",
            "ES": "MT65",
            "IT": "MT65",
            "KOR": "기술머신65",
            "CHS": "招式学习器６５",
            "CHT": "招式學習器６５"
        }
    ],
    "TM66": [
        {
            "NO": 387,
            "EN": "TM66",
            "JP": "わざマシン６６",
            "FR": "CT66",
            "DE": "TM66",
            "ES": "MT66",
            "IT": "MT66",
            "KOR": "기술머신66",
            "CHS": "招式学习器６６",
            "CHT": "招式學習器６６"
        }
    ],
    "TM67": [
        {
            "NO": 388,
            "EN": "TM67",
            "JP": "わざマシン６７",
            "FR": "CT67",
            "DE": "TM67",
            "ES": "MT67",
            "IT": "MT67",
            "KOR": "기술머신67",
            "CHS": "招式学习器６７",
            "CHT": "招式學習器６７"
        }
    ],
    "TM68": [
        {
            "NO": 389,
            "EN": "TM68",
            "JP": "わざマシン６８",
            "FR": "CT68",
            "DE": "TM68",
            "ES": "MT68",
            "IT": "MT68",
            "KOR": "기술머신68",
            "CHS": "招式学习器６８",
            "CHT": "招式學習器６８"
        }
    ],
    "TM69": [
        {
            "NO": 390,
            "EN": "TM69",
            "JP": "わざマシン６９",
            "FR": "CT69",
            "DE": "TM69",
            "ES": "MT69",
            "IT": "MT69",
            "KOR": "기술머신69",
            "CHS": "招式学习器６９",
            "CHT": "招式學習器６９"
        }
    ],
    "TM70": [
        {
            "NO": 391,
            "EN": "TM70",
            "JP": "わざマシン７０",
            "FR": "CT70",
            "DE": "TM70",
            "ES": "MT70",
            "IT": "MT70",
            "KOR": "기술머신70",
            "CHS": "招式学习器７０",
            "CHT": "招式學習器７０"
        }
    ],
    "TM71": [
        {
            "NO": 392,
            "EN": "TM71",
            "JP": "わざマシン７１",
            "FR": "CT71",
            "DE": "TM71",
            "ES": "MT71",
            "IT": "MT71",
            "KOR": "기술머신71",
            "CHS": "招式学习器７１",
            "CHT": "招式學習器７１"
        }
    ],
    "TM72": [
        {
            "NO": 393,
            "EN": "TM72",
            "JP": "わざマシン７２",
            "FR": "CT72",
            "DE": "TM72",
            "ES": "MT72",
            "IT": "MT72",
            "KOR": "기술머신72",
            "CHS": "招式学习器７２",
            "CHT": "招式學習器７２"
        }
    ],
    "TM73": [
        {
            "NO": 394,
            "EN": "TM73",
            "JP": "わざマシン７３",
            "FR": "CT73",
            "DE": "TM73",
            "ES": "MT73",
            "IT": "MT73",
            "KOR": "기술머신73",
            "CHS": "招式学习器７３",
            "CHT": "招式學習器７３"
        }
    ],
    "TM74": [
        {
            "NO": 395,
            "EN": "TM74",
            "JP": "わざマシン７４",
            "FR": "CT74",
            "DE": "TM74",
            "ES": "MT74",
            "IT": "MT74",
            "KOR": "기술머신74",
            "CHS": "招式学习器７４",
            "CHT": "招式學習器７４"
        }
    ],
    "TM75": [
        {
            "NO": 396,
            "EN": "TM75",
            "JP": "わざマシン７５",
            "FR": "CT75",
            "DE": "TM75",
            "ES": "MT75",
            "IT": "MT75",
            "KOR": "기술머신75",
            "CHS": "招式学习器７５",
            "CHT": "招式學習器７５"
        }
    ],
    "TM76": [
        {
            "NO": 397,
            "EN": "TM76",
            "JP": "わざマシン７６",
            "FR": "CT76",
            "DE": "TM76",
            "ES": "MT76",
            "IT": "MT76",
            "KOR": "기술머신76",
            "CHS": "招式学习器７６",
            "CHT": "招式學習器７６"
        }
    ],
    "TM77": [
        {
            "NO": 398,
            "EN": "TM77",
            "JP": "わざマシン７７",
            "FR": "CT77",
            "DE": "TM77",
            "ES": "MT77",
            "IT": "MT77",
            "KOR": "기술머신77",
            "CHS": "招式学习器７７",
            "CHT": "招式學習器７７"
        }
    ],
    "TM78": [
        {
            "NO": 399,
            "EN": "TM78",
            "JP": "わざマシン７８",
            "FR": "CT78",
            "DE": "TM78",
            "ES": "MT78",
            "IT": "MT78",
            "KOR": "기술머신78",
            "CHS": "招式学习器７８",
            "CHT": "招式學習器７８"
        }
    ],
    "TM79": [
        {
            "NO": 400,
            "EN": "TM79",
            "JP": "わざマシン７９",
            "FR": "CT79",
            "DE": "TM79",
            "ES": "MT79",
            "IT": "MT79",
            "KOR": "기술머신79",
            "CHS": "招式学习器７９",
            "CHT": "招式學習器７９"
        }
    ],
    "TM80": [
        {
            "NO": 401,
            "EN": "TM80",
            "JP": "わざマシン８０",
            "FR": "CT80",
            "DE": "TM80",
            "ES": "MT80",
            "IT": "MT80",
            "KOR": "기술머신80",
            "CHS": "招式学习器８０",
            "CHT": "招式學習器８０"
        }
    ],
    "TM81": [
        {
            "NO": 402,
            "EN": "TM81",
            "JP": "わざマシン８１",
            "FR": "CT81",
            "DE": "TM81",
            "ES": "MT81",
            "IT": "MT81",
            "KOR": "기술머신81",
            "CHS": "招式学习器８１",
            "CHT": "招式學習器８１"
        }
    ],
    "TM82": [
        {
            "NO": 403,
            "EN": "TM82",
            "JP": "わざマシン８２",
            "FR": "CT82",
            "DE": "TM82",
            "ES": "MT82",
            "IT": "MT82",
            "KOR": "기술머신82",
            "CHS": "招式学习器８２",
            "CHT": "招式學習器８２"
        }
    ],
    "TM83": [
        {
            "NO": 404,
            "EN": "TM83",
            "JP": "わざマシン８３",
            "FR": "CT83",
            "DE": "TM83",
            "ES": "MT83",
            "IT": "MT83",
            "KOR": "기술머신83",
            "CHS": "招式学习器８３",
            "CHT": "招式學習器８３"
        }
    ],
    "TM84": [
        {
            "NO": 405,
            "EN": "TM84",
            "JP": "わざマシン８４",
            "FR": "CT84",
            "DE": "TM84",
            "ES": "MT84",
            "IT": "MT84",
            "KOR": "기술머신84",
            "CHS": "招式学习器８４",
            "CHT": "招式學習器８４"
        }
    ],
    "TM85": [
        {
            "NO": 406,
            "EN": "TM85",
            "JP": "わざマシン８５",
            "FR": "CT85",
            "DE": "TM85",
            "ES": "MT85",
            "IT": "MT85",
            "KOR": "기술머신85",
            "CHS": "招式学习器８５",
            "CHT": "招式學習器８５"
        }
    ],
    "TM86": [
        {
            "NO": 407,
            "EN": "TM86",
            "JP": "わざマシン８６",
            "FR": "CT86",
            "DE": "TM86",
            "ES": "MT86",
            "IT": "MT86",
            "KOR": "기술머신86",
            "CHS": "招式学习器８６",
            "CHT": "招式學習器８６"
        }
    ],
    "TM87": [
        {
            "NO": 408,
            "EN": "TM87",
            "JP": "わざマシン８７",
            "FR": "CT87",
            "DE": "TM87",
            "ES": "MT87",
            "IT": "MT87",
            "KOR": "기술머신87",
            "CHS": "招式学习器８７",
            "CHT": "招式學習器８７"
        }
    ],
    "TM88": [
        {
            "NO": 409,
            "EN": "TM88",
            "JP": "わざマシン８８",
            "FR": "CT88",
            "DE": "TM88",
            "ES": "MT88",
            "IT": "MT88",
            "KOR": "기술머신88",
            "CHS": "招式学习器８８",
            "CHT": "招式學習器８８"
        }
    ],
    "TM89": [
        {
            "NO": 410,
            "EN": "TM89",
            "JP": "わざマシン８９",
            "FR": "CT89",
            "DE": "TM89",
            "ES": "MT89",
            "IT": "MT89",
            "KOR": "기술머신89",
            "CHS": "招式学习器８９",
            "CHT": "招式學習器８９"
        }
    ],
    "TM90": [
        {
            "NO": 411,
            "EN": "TM90",
            "JP": "わざマシン９０",
            "FR": "CT90",
            "DE": "TM90",
            "ES": "MT90",
            "IT": "MT90",
            "KOR": "기술머신90",
            "CHS": "招式学习器９０",
            "CHT": "招式學習器９０"
        }
    ],
    "TM91": [
        {
            "NO": 412,
            "EN": "TM91",
            "JP": "わざマシン９１",
            "FR": "CT91",
            "DE": "TM91",
            "ES": "MT91",
            "IT": "MT91",
            "KOR": "기술머신91",
            "CHS": "招式学习器９１",
            "CHT": "招式學習器９１"
        }
    ],
    "TM92": [
        {
            "NO": 413,
            "EN": "TM92",
            "JP": "わざマシン９２",
            "FR": "CT92",
            "DE": "TM92",
            "ES": "MT92",
            "IT": "MT92",
            "KOR": "기술머신92",
            "CHS": "招式学习器９２",
            "CHT": "招式學習器９２"
        }
    ],
    "HM01": [
        {
            "NO": 414,
            "EN": "HM01",
            "JP": "ひでんマシン０１",
            "FR": "CS01",
            "DE": "VM01",
            "ES": "MO01",
            "IT": "MN01",
            "KOR": "비전머신01",
            "CHS": "秘传学习器０１",
            "CHT": "秘傳學習器０１"
        }
    ],
    "HM02": [
        {
            "NO": 415,
            "EN": "HM02",
            "JP": "ひでんマシン０２",
            "FR": "CS02",
            "DE": "VM02",
            "ES": "MO02",
            "IT": "MN02",
            "KOR": "비전머신02",
            "CHS": "秘传学习器０２",
            "CHT": "秘傳學習器０２"
        }
    ],
    "HM03": [
        {
            "NO": 416,
            "EN": "HM03",
            "JP": "ひでんマシン０３",
            "FR": "CS03",
            "DE": "VM03",
            "ES": "MO03",
            "IT": "MN03",
            "KOR": "비전머신03",
            "CHS": "秘传学习器０３",
            "CHT": "秘傳學習器０３"
        }
    ],
    "HM04": [
        {
            "NO": 417,
            "EN": "HM04",
            "JP": "ひでんマシン０４",
            "FR": "CS04",
            "DE": "VM04",
            "ES": "MO04",
            "IT": "MN04",
            "KOR": "비전머신04",
            "CHS": "秘传学习器０４",
            "CHT": "秘傳學習器０４"
        }
    ],
    "HM05": [
        {
            "NO": 418,
            "EN": "HM05",
            "JP": "ひでんマシン０５",
            "FR": "CS05",
            "DE": "VM05",
            "ES": "MO05",
            "IT": "MN05",
            "KOR": "비전머신05",
            "CHS": "秘传学习器０５",
            "CHT": "秘傳學習器０５"
        }
    ],
    "HM06": [
        {
            "NO": 419,
            "EN": "HM06",
            "JP": "ひでんマシン０６",
            "FR": "CS06",
            "DE": "VM06",
            "ES": "MO06",
            "IT": "MN06",
            "KOR": "비전머신06",
            "CHS": "秘传学习器０６",
            "CHT": "秘傳學習器０６"
        }
    ],
    "Explorer Kit": [
        {
            "NO": 420,
            "EN": "Explorer Kit",
            "JP": "たんけんセット",
            "FR": "Explorakit",
            "DE": "Erkundungs-Set",
            "ES": "Kit de Explorador",
            "IT": "Esplorokit",
            "KOR": "탐험세트",
            "CHS": "探险套装",
            "CHT": "探險組合"
        }
    ],
    "Loot Sack": [
        {
            "NO": 421,
            "EN": "Loot Sack",
            "JP": "たからぶくろ",
            "FR": "Sac Butin",
            "DE": "Beutesack",
            "ES": "Saca Botín",
            "IT": "Bottinosacca",
            "KOR": "보물주머니",
            "CHS": "宝物袋",
            "CHT": "寶物袋"
        }
    ],
    "Rule Book": [
        {
            "NO": 422,
            "EN": "Rule Book",
            "JP": "ルールブック",
            "FR": "Livre Règles",
            "DE": "Regelbuch",
            "ES": "Reglamento",
            "IT": "Libro regole",
            "KOR": "룰북",
            "CHS": "规则书",
            "CHT": "規則書"
        }
    ],
    "Poké Radar": [
        {
            "NO": 423,
            "EN": "Poké Radar",
            "JP": "ポケトレ",
            "FR": "Poké Radar",
            "DE": "Pokéradar",
            "ES": "Poké Radar",
            "IT": "Poké Radar",
            "KOR": "포켓트레",
            "CHS": "宝可追踪",
            "CHT": "寶可追蹤"
        }
    ],
    "Point Card": [
        {
            "NO": 424,
            "EN": "Point Card",
            "JP": "ポイントカード",
            "FR": "Carte à Points",
            "DE": "Punktekarte",
            "ES": "Tarjeta de Puntos",
            "IT": "Scheda punti",
            "KOR": "포인트카드",
            "CHS": "点数卡",
            "CHT": "點數卡"
        }
    ],
    "Guidebook": [
        {
            "NO": 425,
            "EN": "Guidebook",
            "JP": "ぼうけんノート",
            "FR": "Notes d’Aventure",
            "DE": "Abenteuernotizen",
            "ES": "Guía de Viaje",
            "IT": "Note di viaggio",
            "KOR": "모험노트",
            "CHS": "冒险笔记",
            "CHT": "冒險筆記"
        }
    ],
    "Sticker Case": [
        {
            "NO": 426,
            "EN": "Sticker Case",
            "JP": "シールいれ",
            "FR": "Boîte à Sceaux",
            "DE": "Stickerkoffer",
            "ES": "Caja de Sellos",
            "IT": "Portabolli",
            "KOR": "실상자",
            "CHS": "贴纸盒",
            "CHT": "貼紙盒"
        }
    ],
    "Fashion Case": [
        {
            "NO": 427,
            "EN": "Fashion Case",
            "JP": "アクセサリーいれ",
            "FR": "Coffret Mode",
            "DE": "Modekoffer",
            "ES": "Caja Corazón",
            "IT": "Scatola chic",
            "KOR": "액세서리상자",
            "CHS": "饰品盒",
            "CHT": "飾品盒"
        }
    ],
    "Sticker Bag": [
        {
            "NO": 428,
            "EN": "Sticker Bag",
            "JP": "シールぶくろ",
            "FR": "Sac Sceaux",
            "DE": "Stickertüte",
            "ES": "Bolsa de Sellos",
            "IT": "Bollosacca",
            "KOR": "실주머니",
            "CHS": "贴纸袋",
            "CHT": "貼紙袋"
        }
    ],
    "Pal Pad": [
        {
            "NO": 429,
            "EN": "Pal Pad",
            "JP": "ともだちてちょう",
            "FR": "Registre Ami",
            "DE": "Adressbuch",
            "ES": "Bloc de Amigos",
            "IT": "Blocco amici",
            "KOR": "친구수첩",
            "CHS": "朋友手册",
            "CHT": "朋友手冊"
        }
    ],
    "Works Key": [
        {
            "NO": 430,
            "EN": "Works Key",
            "JP": "はつでんしょキー",
            "FR": "Clé Parc Éolien",
            "DE": "K-Schlüssel",
            "ES": "Llave de la Central",
            "IT": "Chiave impianto",
            "KOR": "발전소키",
            "CHS": "发电厂钥匙",
            "CHT": "發電廠鑰匙"
        }
    ],
    "Old Charm": [
        {
            "NO": 431,
            "EN": "Old Charm",
            "JP": "こだいのおまもり",
            "FR": "Vieux Grigri",
            "DE": "Talisman",
            "ES": "Talismán",
            "IT": "Amuleto antico",
            "KOR": "고대의부적",
            "CHS": "古代护符",
            "CHT": "古代護符"
        }
    ],
    "Galactic Key": [
        {
            "NO": 432,
            "EN": "Galactic Key",
            "JP": "ギンガだんのカギ",
            "FR": "Clé Galaxie",
            "DE": "G-Schlüssel",
            "ES": "Llave Galaxia",
            "IT": "Chiave Galassia",
            "KOR": "갤럭시단의열쇠",
            "CHS": "银河队钥匙",
            "CHT": "銀河隊鑰匙"
        }
    ],
    "Red Chain": [
        {
            "NO": 433,
            "EN": "Red Chain",
            "JP": "あかいくさり",
            "FR": "Chaîne Rouge",
            "DE": "Rote Kette",
            "ES": "Cadena Roja",
            "IT": "Catena rossa",
            "KOR": "빨강사슬",
            "CHS": "红色锁链",
            "CHT": "紅色鎖鏈"
        }
    ],
    "Town Map": [
        {
            "NO": 434,
            "EN": "Town Map",
            "JP": "タウンマップ",
            "FR": "Carte",
            "DE": "Karte",
            "ES": "Mapa",
            "IT": "Mappa città",
            "KOR": "타운맵",
            "CHS": "城镇地图",
            "CHT": "城鎮地圖"
        }
    ],
    "Vs. Seeker": [
        {
            "NO": 435,
            "EN": "Vs. Seeker",
            "JP": "バトルサーチャー",
            "FR": "Cherch’Combat",
            "DE": "Kampffahnder",
            "ES": "Buscapelea",
            "IT": "Cercasfide",
            "KOR": "배틀서처",
            "CHS": "对战搜寻器",
            "CHT": "對戰搜尋器"
        }
    ],
    "Coin Case": [
        {
            "NO": 436,
            "EN": "Coin Case",
            "JP": "コインケース",
            "FR": "Boîte Jetons",
            "DE": "Münzkorb",
            "ES": "Monedero",
            "IT": "Salvadanaio",
            "KOR": "동전케이스",
            "CHS": "代币盒",
            "CHT": "代幣盒"
        }
    ],
    "Old Rod": [
        {
            "NO": 437,
            "EN": "Old Rod",
            "JP": "ボロのつりざお",
            "FR": "Canne",
            "DE": "Angel",
            "ES": "Caña Vieja",
            "IT": "Canna da pesca usata",
            "KOR": "낡은낚싯대",
            "CHS": "破旧钓竿",
            "CHT": "破舊釣竿"
        }
    ],
    "Good Rod": [
        {
            "NO": 438,
            "EN": "Good Rod",
            "JP": "いいつりざお",
            "FR": "Super Canne",
            "DE": "Profiangel",
            "ES": "Caña Buena",
            "IT": "Canna da pesca buona",
            "KOR": "좋은낚싯대",
            "CHS": "好钓竿",
            "CHT": "好釣竿"
        }
    ],
    "Super Rod": [
        {
            "NO": 439,
            "EN": "Super Rod",
            "JP": "すごいつりざお",
            "FR": "Méga Canne",
            "DE": "Superangel",
            "ES": "Supercaña",
            "IT": "Canna da pesca super",
            "KOR": "대단한낚싯대",
            "CHS": "厉害钓竿",
            "CHT": "厲害釣竿"
        }
    ],
    "Sprayduck": [
        {
            "NO": 440,
            "EN": "Sprayduck",
            "JP": "コダックじょうろ",
            "FR": "Kwakarrosoir",
            "DE": "Enton-Kanne",
            "ES": "Psydugadera",
            "IT": "Sprayduck",
            "KOR": "고라파덕물뿌리개",
            "CHS": "可达鸭喷壶",
            "CHT": "可達鴨噴壺"
        }
    ],
    "Poffin Case": [
        {
            "NO": 441,
            "EN": "Poffin Case",
            "JP": "ポフィンケース",
            "FR": "Boîte à Poffins",
            "DE": "Knurspbox",
            "ES": "Pokochera",
            "IT": "Portapoffin",
            "KOR": "포핀케이스",
            "CHS": "宝芬盒",
            "CHT": "寶芬盒"
        }
    ],
    "Bike": [
        {
            "NO": 442,
            "EN": "Bike",
            "JP": "じてんしゃ",
            "FR": "Bicyclette",
            "DE": "Fahrrad",
            "ES": "Bici",
            "IT": "Bicicletta",
            "KOR": "자전거",
            "CHS": "自行车",
            "CHT": "自行車"
        },
        {
            "NO": 704,
            "EN": "Bike",
            "JP": "じてんしゃ",
            "FR": "Bicyclette",
            "DE": "Fahrrad",
            "ES": "Bici",
            "IT": "Bicicletta",
            "KOR": "자전거",
            "CHS": "自行车",
            "CHT": "自行車"
        }
    ],
    "Suite Key": [
        {
            "NO": 443,
            "EN": "Suite Key",
            "JP": "ルームキー",
            "FR": "Clé de Chambre",
            "DE": "Hotelschlüssel",
            "ES": "Llave Suite",
            "IT": "Chiave suite",
            "KOR": "룸키",
            "CHS": "房间钥匙",
            "CHT": "房間鑰匙"
        }
    ],
    "Oak’s Letter": [
        {
            "NO": 444,
            "EN": "Oak’s Letter",
            "JP": "オーキドのてがみ",
            "FR": "Lettre Chen",
            "DE": "Eichs Brief",
            "ES": "Carta Prof. Oak",
            "IT": "Lettera Oak",
            "KOR": "오박사의편지",
            "CHS": "大木的信",
            "CHT": "大木的信"
        }
    ],
    "Lunar Feather": [
        {
            "NO": 445,
            "EN": "Lunar Feather",
            "JP": "みかづきのはね",
            "FR": "Plume Lune",
            "DE": "Lunarfeder",
            "ES": "Pluma Lunar",
            "IT": "Piumalunare",
            "KOR": "초승달깃털",
            "CHS": "新月之羽",
            "CHT": "新月之羽"
        }
    ],
    "Member Card": [
        {
            "NO": 446,
            "EN": "Member Card",
            "JP": "メンバーズカード",
            "FR": "Carte Membre",
            "DE": "Mitgliedskarte",
            "ES": "Carné de Socio",
            "IT": "Scheda soci",
            "KOR": "멤버스카드",
            "CHS": "会员卡",
            "CHT": "會員卡"
        }
    ],
    "Azure Flute": [
        {
            "NO": 447,
            "EN": "Azure Flute",
            "JP": "てんかいのふえ",
            "FR": "Flûte Azur",
            "DE": "Azurflöte",
            "ES": "Flauta Azur",
            "IT": "Flauto cielo",
            "KOR": "천계의피리",
            "CHS": "天界之笛",
            "CHT": "天界之笛"
        }
    ],
    "S.S. Ticket": [
        {
            "NO": 448,
            "EN": "S.S. Ticket",
            "JP": "ふねのチケット",
            "FR": "Passe Bateau",
            "DE": "Bootsticket",
            "ES": "Ticket del Barco",
            "IT": "Biglietto nave",
            "KOR": "승선티켓",
            "CHS": "船票",
            "CHT": "船票"
        },
        {
            "NO": 727,
            "EN": "S.S. Ticket",
            "JP": "ふねのチケット",
            "FR": "Passe Bateau",
            "DE": "Bootsticket",
            "ES": "Ticket del Barco",
            "IT": "Biglietto nave",
            "KOR": "승선티켓",
            "CHS": "船票",
            "CHT": "船票"
        },
        {
            "NO": 853,
            "EN": "S.S. Ticket",
            "JP": "ふねのチケット",
            "FR": "Passe Bateau",
            "DE": "Bootsticket",
            "ES": "Ticket del Barco",
            "IT": "Biglietto nave",
            "KOR": "승선티켓",
            "CHS": "船票",
            "CHT": "船票"
        }
    ],
    "Contest Pass": [
        {
            "NO": 449,
            "EN": "Contest Pass",
            "JP": "コンテストパス",
            "FR": "Passe Concours",
            "DE": "Wettbewerbskarte",
            "ES": "Pase de Concurso",
            "IT": "Tessera Gare",
            "KOR": "콘테스트패스",
            "CHS": "华丽大赛参加证",
            "CHT": "華麗大賽參加證"
        }
    ],
    "Magma Stone": [
        {
            "NO": 450,
            "EN": "Magma Stone",
            "JP": "かざんのおきいし",
            "FR": "Pierre Magma",
            "DE": "Magmastein",
            "ES": "Piedra Magma",
            "IT": "Magmapietra",
            "KOR": "화산의돌",
            "CHS": "火山镇石",
            "CHT": "火山鎮石"
        }
    ],
    "Parcel": [
        {
            "NO": 451,
            "EN": "Parcel",
            "JP": "おとどけもの",
            "FR": "Colis",
            "DE": "Paket",
            "ES": "Paquete",
            "IT": "Pacco",
            "KOR": "전해줄물건",
            "CHS": "包裹",
            "CHT": "包裹"
        },
        {
            "NO": 855,
            "EN": "Parcel",
            "JP": "おとどけもの",
            "FR": "Colis",
            "DE": "Paket",
            "ES": "Paquete",
            "IT": "Pacco",
            "KOR": "전해줄물건",
            "CHS": "包裹",
            "CHT": "包裹"
        }
    ],
    "Coupon 1": [
        {
            "NO": 452,
            "EN": "Coupon 1",
            "JP": "ひきかえけん１",
            "FR": "Bon 1",
            "DE": "Coupon 1",
            "ES": "Cupón 1",
            "IT": "Coupon 1",
            "KOR": "교환권1",
            "CHS": "兑换券１",
            "CHT": "兌換券１"
        }
    ],
    "Coupon 2": [
        {
            "NO": 453,
            "EN": "Coupon 2",
            "JP": "ひきかえけん２",
            "FR": "Bon 2",
            "DE": "Coupon 2",
            "ES": "Cupón 2",
            "IT": "Coupon 2",
            "KOR": "교환권2",
            "CHS": "兑换券２",
            "CHT": "兌換券２"
        }
    ],
    "Coupon 3": [
        {
            "NO": 454,
            "EN": "Coupon 3",
            "JP": "ひきかえけん３",
            "FR": "Bon 3",
            "DE": "Coupon 3",
            "ES": "Cupón 3",
            "IT": "Coupon 3",
            "KOR": "교환권3",
            "CHS": "兑换券３",
            "CHT": "兌換券３"
        }
    ],
    "Storage Key": [
        {
            "NO": 455,
            "EN": "Storage Key",
            "JP": "そうこのカギ",
            "FR": "Clé du Hangar",
            "DE": "Lagerschlüssel",
            "ES": "Llave del Almacén",
            "IT": "Chiave magazzino",
            "KOR": "창고열쇠",
            "CHS": "仓库钥匙",
            "CHT": "倉庫鑰匙"
        },
        {
            "NO": 725,
            "EN": "Storage Key",
            "JP": "そうこのカギ",
            "FR": "Clé du Hangar",
            "DE": "Lagerschlüssel",
            "ES": "Llave del Almacén",
            "IT": "Chiave magazzino",
            "KOR": "창고열쇠",
            "CHS": "仓库钥匙",
            "CHT": "倉庫鑰匙"
        }
    ],
    "Secret Medicine": [
        {
            "NO": 456,
            "EN": "Secret Medicine",
            "JP": "ひでんのくすり",
            "FR": "Remède Secret",
            "DE": "Geheimmedizin",
            "ES": "Medicina Secreta",
            "IT": "Rimedio segreto",
            "KOR": "비전신약",
            "CHS": "秘传之药",
            "CHT": "秘傳之藥"
        },
        {
            "NO": 1699,
            "EN": "Secret Medicine",
            "JP": "ガンバリセット",
            "FR": "Remède Secret",
            "DE": "Geheimmedizin",
            "ES": "Medicina Secreta",
            "IT": "Rimedio segreto",
            "KOR": "비전신약",
            "CHS": "秘传之药",
            "CHT": "秘傳之藥"
        }
    ],
    "Vs. Recorder": [
        {
            "NO": 457,
            "EN": "Vs. Recorder",
            "JP": "バトルレコーダー",
            "FR": "Magnéto VS",
            "DE": "Kampfkamera",
            "ES": "Cámara Lucha",
            "IT": "Registradati",
            "KOR": "배틀레코더",
            "CHS": "对战记录器",
            "CHT": "對戰記錄器"
        }
    ],
    "Gracidea": [
        {
            "NO": 458,
            "EN": "Gracidea",
            "JP": "グラシデアのはな",
            "FR": "Gracidée",
            "DE": "Gracidea",
            "ES": "Gracídea",
            "IT": "Gracidea",
            "KOR": "그라시데아꽃",
            "CHS": "葛拉西蒂亚花",
            "CHT": "葛拉西蒂亞花"
        }
    ],
    "Secret Key": [
        {
            "NO": 459,
            "EN": "Secret Key",
            "JP": "ひみつのカギ",
            "FR": "Clé Secrète",
            "DE": "Geheimschlüssel",
            "ES": "Llave Secreta",
            "IT": "Chiave segreta",
            "KOR": "비밀의열쇠",
            "CHS": "秘密钥匙",
            "CHT": "秘密鑰匙"
        },
        {
            "NO": 852,
            "EN": "Secret Key",
            "JP": "ひみつのカギ",
            "FR": "Clé Secrète",
            "DE": "Geheimschlüssel",
            "ES": "Llave Secreta",
            "IT": "Chiave segreta",
            "KOR": "비밀의열쇠",
            "CHS": "秘密钥匙",
            "CHT": "秘密鑰匙"
        }
    ],
    "Apricorn Box": [
        {
            "NO": 460,
            "EN": "Apricorn Box",
            "JP": "ぼんぐりケース",
            "FR": "Boîte Noigrume",
            "DE": "Aprikokobox",
            "ES": "Caja Bonguri",
            "IT": "Ghicobox",
            "KOR": "규토리케이스",
            "CHS": "球果盒",
            "CHT": "球果盒"
        }
    ],
    "Unown Report": [
        {
            "NO": 461,
            "EN": "Unown Report",
            "JP": "アンノーンノート",
            "FR": "Carnet Zarbi",
            "DE": "Icognitoheft",
            "ES": "Bloc Unown",
            "IT": "Registro Unown",
            "KOR": "안농노트",
            "CHS": "未知图腾笔记",
            "CHT": "未知圖騰筆記"
        }
    ],
    "Berry Pots": [
        {
            "NO": 462,
            "EN": "Berry Pots",
            "JP": "きのみプランター",
            "FR": "Plante-Baies",
            "DE": "Pflanzset",
            "ES": "Plantabayas",
            "IT": "Piantabacche",
            "KOR": "나무열매플랜터",
            "CHS": "树果种植盆",
            "CHT": "樹果種植盆"
        }
    ],
    "Dowsing Machine": [
        {
            "NO": 463,
            "EN": "Dowsing Machine",
            "JP": "ダウジングマシン",
            "FR": "Cherch’Objet",
            "DE": "Itemradar",
            "ES": "Zahorí",
            "IT": "Ricerca strumenti",
            "KOR": "다우징머신",
            "CHS": "探宝器",
            "CHT": "探寶器"
        }
    ],
    "Blue Card": [
        {
            "NO": 464,
            "EN": "Blue Card",
            "JP": "ブルーカード",
            "FR": "Carte Bleue",
            "DE": "Blaue Karte",
            "ES": "Tarjeta Azul",
            "IT": "Carta blu",
            "KOR": "블루카드",
            "CHS": "蓝卡",
            "CHT": "藍卡"
        }
    ],
    "Slowpoke Tail": [
        {
            "NO": 465,
            "EN": "Slowpoke Tail",
            "JP": "おいしいシッポ",
            "FR": "Queue Ramoloss",
            "DE": "Flegmon-Rute",
            "ES": "Cola Slowpoke",
            "IT": "Coda Slowpoke",
            "KOR": "맛있는꼬리",
            "CHS": "美味尾巴",
            "CHT": "美味尾巴"
        }
    ],
    "Clear Bell": [
        {
            "NO": 466,
            "EN": "Clear Bell",
            "JP": "とうめいなスズ",
            "FR": "Glas Transparent",
            "DE": "Klarglocke",
            "ES": "Cascabel Claro",
            "IT": "Campana chiara",
            "KOR": "크리스탈방울",
            "CHS": "透明铃铛",
            "CHT": "透明鈴鐺"
        }
    ],
    "Card Key": [
        {
            "NO": 467,
            "EN": "Card Key",
            "JP": "カードキー",
            "FR": "Carte Magnétique",
            "DE": "Schlüsselkarte",
            "ES": "Llave Magnética",
            "IT": "Apriporta",
            "KOR": "카드키",
            "CHS": "钥匙卡",
            "CHT": "鑰匙卡"
        },
        {
            "NO": 856,
            "EN": "Card Key",
            "JP": "カードキー",
            "FR": "Carte Magnétique",
            "DE": "Schlüsselkarte",
            "ES": "Llave Magnética",
            "IT": "Apriporta",
            "KOR": "카드키",
            "CHS": "钥匙卡",
            "CHT": "鑰匙卡"
        }
    ],
    "Basement Key": [
        {
            "NO": 468,
            "EN": "Basement Key",
            "JP": "ちかのかぎ",
            "FR": "Clé Sous-Sol",
            "DE": "Kelleröffner",
            "ES": "Llave del Sótano",
            "IT": "Chiave sotterr.",
            "KOR": "지하의열쇠",
            "CHS": "地下钥匙",
            "CHT": "地下鑰匙"
        },
        {
            "NO": 714,
            "EN": "Basement Key",
            "JP": "ちかのカギ",
            "FR": "Clé Sous-Sol",
            "DE": "Kelleröffner",
            "ES": "Llave del Sótano",
            "IT": "Chiave sotterr.",
            "KOR": "지하열쇠",
            "CHS": "地下钥匙",
            "CHT": "地下鑰匙"
        }
    ],
    "Squirt Bottle": [
        {
            "NO": 469,
            "EN": "Squirt Bottle",
            "JP": "ゼニガメじょうろ",
            "FR": "Carapuce à O",
            "DE": "Schiggykanne",
            "ES": "Squirgadera",
            "IT": "Annaffiatoio",
            "KOR": "꼬부기물뿌리개",
            "CHS": "杰尼龟喷壶",
            "CHT": "傑尼龜噴壺"
        }
    ],
    "Red Scale": [
        {
            "NO": 470,
            "EN": "Red Scale",
            "JP": "あかいウロコ",
            "FR": "Écaille Rouge",
            "DE": "Rote Schuppe",
            "ES": "Escama Roja",
            "IT": "Squama rossa",
            "KOR": "빨간비늘",
            "CHS": "红色鳞片",
            "CHT": "紅色鱗片"
        }
    ],
    "Lost Item": [
        {
            "NO": 471,
            "EN": "Lost Item",
            "JP": "おとしもの",
            "FR": "Objet perdu",
            "DE": "Fundsache",
            "ES": "Objeto Perdido",
            "IT": "Strumento perso",
            "KOR": "분실물",
            "CHS": "遗失物",
            "CHT": "遺失物"
        }
    ],
    "Pass": [
        {
            "NO": 472,
            "EN": "Pass",
            "JP": "リニアパス",
            "FR": "Passe Train",
            "DE": "Fahrschein",
            "ES": "Magnetopase",
            "IT": "Superpass",
            "KOR": "리니어패스",
            "CHS": "磁浮列车自由票",
            "CHT": "磁浮列車自由票"
        }
    ],
    "Machine Part": [
        {
            "NO": 473,
            "EN": "Machine Part",
            "JP": "きかいのぶひん",
            "FR": "Partie Machine",
            "DE": "Spule",
            "ES": "Maquinaria",
            "IT": "Pezzo di macchinario",
            "KOR": "기계부품",
            "CHS": "机械零件",
            "CHT": "機械零件"
        }
    ],
    "Silver Feather": [
        {
            "NO": 474,
            "EN": "Silver Feather",
            "JP": "ぎんいろのはね",
            "FR": "Argent’Aile",
            "DE": "Silberflügel",
            "ES": "Pluma Plateada",
            "IT": "Ala d’argento",
            "KOR": "은빛깃털",
            "CHS": "银色之羽",
            "CHT": "銀色之羽"
        }
    ],
    "Rainbow Feather": [
        {
            "NO": 475,
            "EN": "Rainbow Feather",
            "JP": "にじいろのはね",
            "FR": "Arc-en-Ci’Aile",
            "DE": "Buntschwinge",
            "ES": "Pluma Arcoíris",
            "IT": "Ala d’iride",
            "KOR": "무지갯빛깃털",
            "CHS": "虹色之羽",
            "CHT": "虹色之羽"
        }
    ],
    "Mystery Egg": [
        {
            "NO": 476,
            "EN": "Mystery Egg",
            "JP": "ふしぎなタマゴ",
            "FR": "Œuf Mystère",
            "DE": "Rätsel-Ei",
            "ES": "Huevo Misterioso",
            "IT": "Uovo mistero",
            "KOR": "이상한알",
            "CHS": "神奇蛋",
            "CHT": "神奇蛋"
        }
    ],
    "Red Apricorn": [
        {
            "NO": 477,
            "EN": "Red Apricorn",
            "JP": "あかぼんぐり",
            "FR": "Noigrume Rouge",
            "DE": "Aprikoko Rot",
            "ES": "Bonguri Rojo",
            "IT": "Ghicocca rossa",
            "KOR": "빨간규토리",
            "CHS": "红球果",
            "CHT": "紅球果"
        }
    ],
    "Blue Apricorn": [
        {
            "NO": 478,
            "EN": "Blue Apricorn",
            "JP": "あおぼんぐり",
            "FR": "Noigrume Bleu",
            "DE": "Aprikoko Blau",
            "ES": "Bonguri Azul",
            "IT": "Ghicocca blu",
            "KOR": "파란규토리",
            "CHS": "蓝球果",
            "CHT": "藍球果"
        }
    ],
    "Yellow Apricorn": [
        {
            "NO": 479,
            "EN": "Yellow Apricorn",
            "JP": "きぼんぐり",
            "FR": "Noigrume Jaune",
            "DE": "Aprikoko Gelb",
            "ES": "Bonguri Amarillo",
            "IT": "Ghicocca gialla",
            "KOR": "노랑규토리",
            "CHS": "黄球果",
            "CHT": "黃球果"
        }
    ],
    "Green Apricorn": [
        {
            "NO": 480,
            "EN": "Green Apricorn",
            "JP": "みどぼんぐり",
            "FR": "Noigrume Vert",
            "DE": "Aprikoko Grün",
            "ES": "Bonguri Verde",
            "IT": "Ghicocca verde",
            "KOR": "초록규토리",
            "CHS": "绿球果",
            "CHT": "綠球果"
        }
    ],
    "Pink Apricorn": [
        {
            "NO": 481,
            "EN": "Pink Apricorn",
            "JP": "ももぼんぐり",
            "FR": "Noigrume Rose",
            "DE": "Aprikoko Pink",
            "ES": "Bonguri Rosa",
            "IT": "Ghicocca rosa",
            "KOR": "담홍규토리",
            "CHS": "粉球果",
            "CHT": "粉球果"
        }
    ],
    "White Apricorn": [
        {
            "NO": 482,
            "EN": "White Apricorn",
            "JP": "しろぼんぐり",
            "FR": "Noigrume Blanc",
            "DE": "Aprikoko Weiß",
            "ES": "Bonguri Blanco",
            "IT": "Ghicocca bianca",
            "KOR": "하얀규토리",
            "CHS": "白球果",
            "CHT": "白球果"
        }
    ],
    "Black Apricorn": [
        {
            "NO": 483,
            "EN": "Black Apricorn",
            "JP": "くろぼんぐり",
            "FR": "Noigrume Noir",
            "DE": "Aprikoko Schwarz",
            "ES": "Bonguri Negro",
            "IT": "Ghicocca nera",
            "KOR": "검은규토리",
            "CHS": "黑球果",
            "CHT": "黑球果"
        }
    ],
    "Fast Ball": [
        {
            "NO": 484,
            "EN": "Fast Ball",
            "JP": "スピードボール",
            "FR": "Speed Ball",
            "DE": "Turboball",
            "ES": "Rapid Ball",
            "IT": "Rapid Ball",
            "KOR": "스피드볼",
            "CHS": "速度球",
            "CHT": "速度球"
        }
    ],
    "Level Ball": [
        {
            "NO": 485,
            "EN": "Level Ball",
            "JP": "レベルボール",
            "FR": "Niveau Ball",
            "DE": "Levelball",
            "ES": "Nivel Ball",
            "IT": "Level Ball",
            "KOR": "레벨볼",
            "CHS": "等级球",
            "CHT": "等級球"
        }
    ],
    "Lure Ball": [
        {
            "NO": 486,
            "EN": "Lure Ball",
            "JP": "ルアーボール",
            "FR": "Appât Ball",
            "DE": "Köderball",
            "ES": "Cebo Ball",
            "IT": "Esca Ball",
            "KOR": "루어볼",
            "CHS": "诱饵球",
            "CHT": "誘餌球"
        }
    ],
    "Heavy Ball": [
        {
            "NO": 487,
            "EN": "Heavy Ball",
            "JP": "ヘビーボール",
            "FR": "Masse Ball",
            "DE": "Schwerball",
            "ES": "Peso Ball",
            "IT": "Peso Ball",
            "KOR": "헤비볼",
            "CHS": "沉重球",
            "CHT": "沉重球"
        },
        {
            "NO": 1684,
            "EN": "Heavy Ball",
            "JP": "ヘビーボール",
            "FR": "Masse Ball",
            "DE": "Schwerball",
            "ES": "Peso Ball",
            "IT": "Peso Ball",
            "KOR": "헤비볼",
            "CHS": "沉重球",
            "CHT": "沉重球"
        },
        {
            "NO": 1689,
            "EN": "Heavy Ball",
            "JP": "クラフトレシピ４３",
            "FR": "Masse Ball",
            "DE": "Schwerball",
            "ES": "Peso Ball",
            "IT": "Peso Ball",
            "KOR": "헤비볼",
            "CHS": "沉重球",
            "CHT": "沉重球"
        }
    ],
    "Love Ball": [
        {
            "NO": 488,
            "EN": "Love Ball",
            "JP": "ラブラブボール",
            "FR": "Love Ball",
            "DE": "Sympaball",
            "ES": "Amor Ball",
            "IT": "Love Ball",
            "KOR": "러브러브볼",
            "CHS": "甜蜜球",
            "CHT": "甜蜜球"
        }
    ],
    "Friend Ball": [
        {
            "NO": 489,
            "EN": "Friend Ball",
            "JP": "フレンドボール",
            "FR": "Copain Ball",
            "DE": "Freundesball",
            "ES": "Amigo Ball",
            "IT": "Friend Ball",
            "KOR": "프렌드볼",
            "CHS": "友友球",
            "CHT": "友友球"
        }
    ],
    "Moon Ball": [
        {
            "NO": 490,
            "EN": "Moon Ball",
            "JP": "ムーンボール",
            "FR": "Lune Ball",
            "DE": "Mondball",
            "ES": "Luna Ball",
            "IT": "Luna Ball",
            "KOR": "문볼",
            "CHS": "月亮球",
            "CHT": "月亮球"
        }
    ],
    "Sport Ball": [
        {
            "NO": 491,
            "EN": "Sport Ball",
            "JP": "コンペボール",
            "FR": "Compét’Ball",
            "DE": "Turnierball",
            "ES": "Competi Ball",
            "IT": "Gara Ball",
            "KOR": "컴퍼티션볼",
            "CHS": "竞赛球",
            "CHT": "競賽球"
        }
    ],
    "Park Ball": [
        {
            "NO": 492,
            "EN": "Park Ball",
            "JP": "パークボール",
            "FR": "Parc Ball",
            "DE": "Parkball",
            "ES": "Parque Ball",
            "IT": "Parco Ball",
            "KOR": "파크볼",
            "CHS": "公园球",
            "CHT": "公園球"
        }
    ],
    "Photo Album": [
        {
            "NO": 493,
            "EN": "Photo Album",
            "JP": "フォトアルバム",
            "FR": "Album Photo",
            "DE": "Fotoalbum",
            "ES": "Álbum",
            "IT": "Album",
            "KOR": "포토앨범",
            "CHS": "相册",
            "CHT": "相簿"
        }
    ],
    "GB Sounds": [
        {
            "NO": 494,
            "EN": "GB Sounds",
            "JP": "ＧＢプレイヤー",
            "FR": "Lecteur GB",
            "DE": "GB-Player",
            "ES": "Reproductor GB",
            "IT": "Lettore GB",
            "KOR": "GB플레이어",
            "CHS": "ＧＢ播放器",
            "CHT": "ＧＢ播放器"
        }
    ],
    "Tidal Bell": [
        {
            "NO": 495,
            "EN": "Tidal Bell",
            "JP": "うみなりのスズ",
            "FR": "Glas Tempête",
            "DE": "Gischtglocke",
            "ES": "Cascabel Oleaje",
            "IT": "Campana onda",
            "KOR": "해명의방울",
            "CHS": "海声铃铛",
            "CHT": "海聲鈴鐺"
        }
    ],
    "Rage Candy Bar": [
        {
            "NO": 496,
            "EN": "Rage Candy Bar",
            "JP": "いかりまんじゅう",
            "FR": "Bonbon Rage",
            "DE": "Wutkeks",
            "ES": "Caramelo Furia",
            "IT": "Iramella",
            "KOR": "분노의호두과자",
            "CHS": "愤怒馒头",
            "CHT": "憤怒饅頭"
        }
    ],
    "Data Card 01": [
        {
            "NO": 497,
            "EN": "Data Card 01",
            "JP": "データカード０１",
            "FR": "Carte Mémo01",
            "DE": "Datenkarte01",
            "ES": "Tarjeta Datos 01",
            "IT": "Scheda dati 01",
            "KOR": "데이터카드01",
            "CHS": "数据卡０１",
            "CHT": "資料卡０１"
        }
    ],
    "Data Card 02": [
        {
            "NO": 498,
            "EN": "Data Card 02",
            "JP": "データカード０２",
            "FR": "Carte Mémo02",
            "DE": "Datenkarte02",
            "ES": "Tarjeta Datos 02",
            "IT": "Scheda dati 02",
            "KOR": "데이터카드02",
            "CHS": "数据卡０２",
            "CHT": "資料卡０２"
        }
    ],
    "Data Card 03": [
        {
            "NO": 499,
            "EN": "Data Card 03",
            "JP": "データカード０３",
            "FR": "Carte Mémo03",
            "DE": "Datenkarte03",
            "ES": "Tarjeta Datos 03",
            "IT": "Scheda dati 03",
            "KOR": "데이터카드03",
            "CHS": "数据卡０３",
            "CHT": "資料卡０３"
        }
    ],
    "Data Card 04": [
        {
            "NO": 500,
            "EN": "Data Card 04",
            "JP": "データカード０４",
            "FR": "Carte Mémo04",
            "DE": "Datenkarte04",
            "ES": "Tarjeta Datos 04",
            "IT": "Scheda dati 04",
            "KOR": "데이터카드04",
            "CHS": "数据卡０４",
            "CHT": "資料卡０４"
        }
    ],
    "Data Card 05": [
        {
            "NO": 501,
            "EN": "Data Card 05",
            "JP": "データカード０５",
            "FR": "Carte Mémo05",
            "DE": "Datenkarte05",
            "ES": "Tarjeta Datos 05",
            "IT": "Scheda dati 05",
            "KOR": "데이터카드05",
            "CHS": "数据卡０５",
            "CHT": "資料卡０５"
        }
    ],
    "Data Card 06": [
        {
            "NO": 502,
            "EN": "Data Card 06",
            "JP": "データカード０６",
            "FR": "Carte Mémo06",
            "DE": "Datenkarte06",
            "ES": "Tarjeta Datos 06",
            "IT": "Scheda dati 06",
            "KOR": "데이터카드06",
            "CHS": "数据卡０６",
            "CHT": "資料卡０６"
        }
    ],
    "Data Card 07": [
        {
            "NO": 503,
            "EN": "Data Card 07",
            "JP": "データカード０７",
            "FR": "Carte Mémo07",
            "DE": "Datenkarte07",
            "ES": "Tarjeta Datos 07",
            "IT": "Scheda dati 07",
            "KOR": "데이터카드07",
            "CHS": "数据卡０７",
            "CHT": "資料卡０７"
        }
    ],
    "Data Card 08": [
        {
            "NO": 504,
            "EN": "Data Card 08",
            "JP": "データカード０８",
            "FR": "Carte Mémo08",
            "DE": "Datenkarte08",
            "ES": "Tarjeta Datos 08",
            "IT": "Scheda dati 08",
            "KOR": "데이터카드08",
            "CHS": "数据卡０８",
            "CHT": "資料卡０８"
        }
    ],
    "Data Card 09": [
        {
            "NO": 505,
            "EN": "Data Card 09",
            "JP": "データカード０９",
            "FR": "Carte Mémo09",
            "DE": "Datenkarte09",
            "ES": "Tarjeta Datos 09",
            "IT": "Scheda dati 09",
            "KOR": "데이터카드09",
            "CHS": "数据卡０９",
            "CHT": "資料卡０９"
        }
    ],
    "Data Card 10": [
        {
            "NO": 506,
            "EN": "Data Card 10",
            "JP": "データカード１０",
            "FR": "Carte Mémo10",
            "DE": "Datenkarte10",
            "ES": "Tarjeta Datos 10",
            "IT": "Scheda dati 10",
            "KOR": "데이터카드10",
            "CHS": "数据卡１０",
            "CHT": "資料卡１０"
        }
    ],
    "Data Card 11": [
        {
            "NO": 507,
            "EN": "Data Card 11",
            "JP": "データカード１１",
            "FR": "Carte Mémo11",
            "DE": "Datenkarte11",
            "ES": "Tarjeta Datos 11",
            "IT": "Scheda dati 11",
            "KOR": "데이터카드11",
            "CHS": "数据卡１１",
            "CHT": "資料卡１１"
        }
    ],
    "Data Card 12": [
        {
            "NO": 508,
            "EN": "Data Card 12",
            "JP": "データカード１２",
            "FR": "Carte Mémo12",
            "DE": "Datenkarte12",
            "ES": "Tarjeta Datos 12",
            "IT": "Scheda dati 12",
            "KOR": "데이터카드12",
            "CHS": "数据卡１２",
            "CHT": "資料卡１２"
        }
    ],
    "Data Card 13": [
        {
            "NO": 509,
            "EN": "Data Card 13",
            "JP": "データカード１３",
            "FR": "Carte Mémo13",
            "DE": "Datenkarte13",
            "ES": "Tarjeta Datos 13",
            "IT": "Scheda dati 13",
            "KOR": "데이터카드13",
            "CHS": "数据卡１３",
            "CHT": "資料卡１３"
        }
    ],
    "Data Card 14": [
        {
            "NO": 510,
            "EN": "Data Card 14",
            "JP": "データカード１４",
            "FR": "Carte Mémo14",
            "DE": "Datenkarte14",
            "ES": "Tarjeta Datos 14",
            "IT": "Scheda dati 14",
            "KOR": "데이터카드14",
            "CHS": "数据卡１４",
            "CHT": "資料卡１４"
        }
    ],
    "Data Card 15": [
        {
            "NO": 511,
            "EN": "Data Card 15",
            "JP": "データカード１５",
            "FR": "Carte Mémo15",
            "DE": "Datenkarte15",
            "ES": "Tarjeta Datos 15",
            "IT": "Scheda dati 15",
            "KOR": "데이터카드15",
            "CHS": "数据卡１５",
            "CHT": "資料卡１５"
        }
    ],
    "Data Card 16": [
        {
            "NO": 512,
            "EN": "Data Card 16",
            "JP": "データカード１６",
            "FR": "Carte Mémo16",
            "DE": "Datenkarte16",
            "ES": "Tarjeta Datos 16",
            "IT": "Scheda dati 16",
            "KOR": "데이터카드16",
            "CHS": "数据卡１６",
            "CHT": "資料卡１６"
        }
    ],
    "Data Card 17": [
        {
            "NO": 513,
            "EN": "Data Card 17",
            "JP": "データカード１７",
            "FR": "Carte Mémo17",
            "DE": "Datenkarte17",
            "ES": "Tarjeta Datos 17",
            "IT": "Scheda dati 17",
            "KOR": "데이터카드17",
            "CHS": "数据卡１７",
            "CHT": "資料卡１７"
        }
    ],
    "Data Card 18": [
        {
            "NO": 514,
            "EN": "Data Card 18",
            "JP": "データカード１８",
            "FR": "Carte Mémo18",
            "DE": "Datenkarte18",
            "ES": "Tarjeta Datos 18",
            "IT": "Scheda dati 18",
            "KOR": "데이터카드18",
            "CHS": "数据卡１８",
            "CHT": "資料卡１８"
        }
    ],
    "Data Card 19": [
        {
            "NO": 515,
            "EN": "Data Card 19",
            "JP": "データカード１９",
            "FR": "Carte Mémo19",
            "DE": "Datenkarte19",
            "ES": "Tarjeta Datos 19",
            "IT": "Scheda dati 19",
            "KOR": "데이터카드19",
            "CHS": "数据卡１９",
            "CHT": "資料卡１９"
        }
    ],
    "Data Card 20": [
        {
            "NO": 516,
            "EN": "Data Card 20",
            "JP": "データカード２０",
            "FR": "Carte Mémo20",
            "DE": "Datenkarte20",
            "ES": "Tarjeta Datos 20",
            "IT": "Scheda dati 20",
            "KOR": "데이터카드20",
            "CHS": "数据卡２０",
            "CHT": "資料卡２０"
        }
    ],
    "Data Card 21": [
        {
            "NO": 517,
            "EN": "Data Card 21",
            "JP": "データカード２１",
            "FR": "Carte Mémo21",
            "DE": "Datenkarte21",
            "ES": "Tarjeta Datos 21",
            "IT": "Scheda dati 21",
            "KOR": "데이터카드21",
            "CHS": "数据卡２１",
            "CHT": "資料卡２１"
        }
    ],
    "Data Card 22": [
        {
            "NO": 518,
            "EN": "Data Card 22",
            "JP": "データカード２２",
            "FR": "Carte Mémo22",
            "DE": "Datenkarte22",
            "ES": "Tarjeta Datos 22",
            "IT": "Scheda dati 22",
            "KOR": "데이터카드22",
            "CHS": "数据卡２２",
            "CHT": "資料卡２２"
        }
    ],
    "Data Card 23": [
        {
            "NO": 519,
            "EN": "Data Card 23",
            "JP": "データカード２３",
            "FR": "Carte Mémo23",
            "DE": "Datenkarte23",
            "ES": "Tarjeta Datos 23",
            "IT": "Scheda dati 23",
            "KOR": "데이터카드23",
            "CHS": "数据卡２３",
            "CHT": "資料卡２３"
        }
    ],
    "Data Card 24": [
        {
            "NO": 520,
            "EN": "Data Card 24",
            "JP": "データカード２４",
            "FR": "Carte Mémo24",
            "DE": "Datenkarte24",
            "ES": "Tarjeta Datos 24",
            "IT": "Scheda dati 24",
            "KOR": "데이터카드24",
            "CHS": "数据卡２４",
            "CHT": "資料卡２４"
        }
    ],
    "Data Card 25": [
        {
            "NO": 521,
            "EN": "Data Card 25",
            "JP": "データカード２５",
            "FR": "Carte Mémo25",
            "DE": "Datenkarte25",
            "ES": "Tarjeta Datos 25",
            "IT": "Scheda dati 25",
            "KOR": "데이터카드25",
            "CHS": "数据卡２５",
            "CHT": "資料卡２５"
        }
    ],
    "Data Card 26": [
        {
            "NO": 522,
            "EN": "Data Card 26",
            "JP": "データカード２６",
            "FR": "Carte Mémo26",
            "DE": "Datenkarte26",
            "ES": "Tarjeta Datos 26",
            "IT": "Scheda dati 26",
            "KOR": "데이터카드26",
            "CHS": "数据卡２６",
            "CHT": "資料卡２６"
        }
    ],
    "Data Card 27": [
        {
            "NO": 523,
            "EN": "Data Card 27",
            "JP": "データカード２７",
            "FR": "Carte Mémo27",
            "DE": "Datenkarte27",
            "ES": "Tarjeta Datos 27",
            "IT": "Scheda dati 27",
            "KOR": "데이터카드27",
            "CHS": "数据卡２７",
            "CHT": "資料卡２７"
        }
    ],
    "Jade Orb": [
        {
            "NO": 524,
            "EN": "Jade Orb",
            "JP": "もえぎいろのたま",
            "FR": "Orbe Vert",
            "DE": "Grüne Kugel",
            "ES": "Esfera Verde",
            "IT": "Sfera verde",
            "KOR": "연둣빛구슬",
            "CHS": "草绿色宝珠",
            "CHT": "草綠色寶珠"
        }
    ],
    "Lock Capsule": [
        {
            "NO": 525,
            "EN": "Lock Capsule",
            "JP": "ロックカプセル",
            "FR": "Poké Écrin",
            "DE": "Tresorkapsel",
            "ES": "Cápsula Candado",
            "IT": "Capsula scrigno",
            "KOR": "록캡슐",
            "CHS": "上锁的容器",
            "CHT": "上鎖的容器"
        }
    ],
    "Red Orb": [
        {
            "NO": 526,
            "EN": "Red Orb",
            "JP": "べにいろのたま",
            "FR": "Gemme Rouge",
            "DE": "Roter Edelstein",
            "ES": "Prisma Rojo",
            "IT": "Gemma rossa",
            "KOR": "주홍구슬",
            "CHS": "朱红色宝珠",
            "CHT": "朱紅色寶珠"
        }
    ],
    "Blue Orb": [
        {
            "NO": 527,
            "EN": "Blue Orb",
            "JP": "あいいろのたま",
            "FR": "Gemme Bleue",
            "DE": "Blauer Edelstein",
            "ES": "Prisma Azul",
            "IT": "Gemma blu",
            "KOR": "쪽빛구슬",
            "CHS": "靛蓝色宝珠",
            "CHT": "靛藍色寶珠"
        }
    ],
    "Enigma Stone": [
        {
            "NO": 528,
            "EN": "Enigma Stone",
            "JP": "なぞのすいしょう",
            "FR": "Mystécristal",
            "DE": "Mytokristall",
            "ES": "Misticristal",
            "IT": "Misticristal",
            "KOR": "수수께끼의수정",
            "CHS": "谜之水晶",
            "CHT": "謎之水晶"
        }
    ],
    "Prism Scale": [
        {
            "NO": 529,
            "EN": "Prism Scale",
            "JP": "きれいなウロコ",
            "FR": "Bel’Écaille",
            "DE": "Schönschuppe",
            "ES": "Escama Bella",
            "IT": "Squama bella",
            "KOR": "고운비늘",
            "CHS": "美丽鳞片",
            "CHT": "美麗鱗片"
        }
    ],
    "Eviolite": [
        {
            "NO": 530,
            "EN": "Eviolite",
            "JP": "しんかのきせき",
            "FR": "Évoluroc",
            "DE": "Evolith",
            "ES": "Mineral Evolutivo",
            "IT": "Evolcondensa",
            "KOR": "진화의휘석",
            "CHS": "进化奇石",
            "CHT": "進化奇石"
        }
    ],
    "Float Stone": [
        {
            "NO": 531,
            "EN": "Float Stone",
            "JP": "かるいし",
            "FR": "Pierrallégée",
            "DE": "Leichtstein",
            "ES": "Piedra Pómez",
            "IT": "Pietralieve",
            "KOR": "가벼운돌",
            "CHS": "轻石",
            "CHT": "輕石"
        }
    ],
    "Rocky Helmet": [
        {
            "NO": 532,
            "EN": "Rocky Helmet",
            "JP": "ゴツゴツメット",
            "FR": "Casque Brut",
            "DE": "Beulenhelm",
            "ES": "Casco Dentado",
            "IT": "Bitorzolelmo",
            "KOR": "울퉁불퉁멧",
            "CHS": "凸凸头盔",
            "CHT": "凸凸頭盔"
        }
    ],
    "Air Balloon": [
        {
            "NO": 533,
            "EN": "Air Balloon",
            "JP": "ふうせん",
            "FR": "Ballon",
            "DE": "Luftballon",
            "ES": "Globo Helio",
            "IT": "Palloncino",
            "KOR": "풍선",
            "CHS": "气球",
            "CHT": "氣球"
        }
    ],
    "Red Card": [
        {
            "NO": 534,
            "EN": "Red Card",
            "JP": "レッドカード",
            "FR": "Carton Rouge",
            "DE": "Rote Karte",
            "ES": "Tarjeta Roja",
            "IT": "Cartelrosso",
            "KOR": "레드카드",
            "CHS": "红牌",
            "CHT": "紅牌"
        }
    ],
    "Ring Target": [
        {
            "NO": 535,
            "EN": "Ring Target",
            "JP": "ねらいのまと",
            "FR": "Point de Mire",
            "DE": "Zielscheibe",
            "ES": "Blanco",
            "IT": "Facilsaglio",
            "KOR": "겨냥표적",
            "CHS": "标靶",
            "CHT": "標靶"
        }
    ],
    "Binding Band": [
        {
            "NO": 536,
            "EN": "Binding Band",
            "JP": "しめつけバンド",
            "FR": "Bande Étreinte",
            "DE": "Klammerband",
            "ES": "Banda Atadura",
            "IT": "Legafascia",
            "KOR": "조임밴드",
            "CHS": "紧绑束带",
            "CHT": "緊綁束帶"
        }
    ],
    "Absorb Bulb": [
        {
            "NO": 537,
            "EN": "Absorb Bulb",
            "JP": "きゅうこん",
            "FR": "Bulbe",
            "DE": "Knolle",
            "ES": "Tubérculo",
            "IT": "Bulbo",
            "KOR": "구근",
            "CHS": "球根",
            "CHT": "球根"
        }
    ],
    "Cell Battery": [
        {
            "NO": 538,
            "EN": "Cell Battery",
            "JP": "じゅうでんち",
            "FR": "Pile",
            "DE": "Akku",
            "ES": "Pila",
            "IT": "Ricaripila",
            "KOR": "충전지",
            "CHS": "充电电池",
            "CHT": "充電電池"
        }
    ],
    "Eject Button": [
        {
            "NO": 539,
            "EN": "Eject Button",
            "JP": "だっしゅつボタン",
            "FR": "Bouton Fuite",
            "DE": "Fluchtknopf",
            "ES": "Botón Escape",
            "IT": "Pulsantefuga",
            "KOR": "탈출버튼",
            "CHS": "逃脱按键",
            "CHT": "逃脫按鍵"
        }
    ],
    "Fire Gem": [
        {
            "NO": 540,
            "EN": "Fire Gem",
            "JP": "ほのおのジュエル",
            "FR": "Joyau Feu",
            "DE": "Feuerjuwel",
            "ES": "Gema Fuego",
            "IT": "Bijoufuoco",
            "KOR": "불꽃주얼",
            "CHS": "火之宝石",
            "CHT": "火之寶石"
        }
    ],
    "Water Gem": [
        {
            "NO": 541,
            "EN": "Water Gem",
            "JP": "みずのジュエル",
            "FR": "Joyau Eau",
            "DE": "Wasserjuwel",
            "ES": "Gema Agua",
            "IT": "Bijouacqua",
            "KOR": "물주얼",
            "CHS": "水之宝石",
            "CHT": "水之寶石"
        }
    ],
    "Electric Gem": [
        {
            "NO": 542,
            "EN": "Electric Gem",
            "JP": "でんきのジュエル",
            "FR": "Joyau Électrik",
            "DE": "Elektrojuwel",
            "ES": "Gema Eléctrico",
            "IT": "Bijouelettro",
            "KOR": "전기주얼",
            "CHS": "电之宝石",
            "CHT": "電之寶石"
        }
    ],
    "Grass Gem": [
        {
            "NO": 543,
            "EN": "Grass Gem",
            "JP": "くさのジュエル",
            "FR": "Joyau Plante",
            "DE": "Pflanzenjuwel",
            "ES": "Gema Planta",
            "IT": "Bijouerba",
            "KOR": "풀주얼",
            "CHS": "草之宝石",
            "CHT": "草之寶石"
        }
    ],
    "Ice Gem": [
        {
            "NO": 544,
            "EN": "Ice Gem",
            "JP": "こおりのジュエル",
            "FR": "Joyau Glace",
            "DE": "Eisjuwel",
            "ES": "Gema Hielo",
            "IT": "Bijoughiaccio",
            "KOR": "얼음주얼",
            "CHS": "冰之宝石",
            "CHT": "冰之寶石"
        }
    ],
    "Fighting Gem": [
        {
            "NO": 545,
            "EN": "Fighting Gem",
            "JP": "かくとうジュエル",
            "FR": "Joyau Combat",
            "DE": "Kampfjuwel",
            "ES": "Gema Lucha",
            "IT": "Bijoulotta",
            "KOR": "격투주얼",
            "CHS": "格斗宝石",
            "CHT": "格鬥寶石"
        }
    ],
    "Poison Gem": [
        {
            "NO": 546,
            "EN": "Poison Gem",
            "JP": "どくのジュエル",
            "FR": "Joyau Poison",
            "DE": "Giftjuwel",
            "ES": "Gema Veneno",
            "IT": "Bijouveleno",
            "KOR": "독주얼",
            "CHS": "毒之宝石",
            "CHT": "毒之寶石"
        }
    ],
    "Ground Gem": [
        {
            "NO": 547,
            "EN": "Ground Gem",
            "JP": "じめんのジュエル",
            "FR": "Joyau Sol",
            "DE": "Bodenjuwel",
            "ES": "Gema Tierra",
            "IT": "Bijouterra",
            "KOR": "땅주얼",
            "CHS": "地面宝石",
            "CHT": "地面寶石"
        }
    ],
    "Flying Gem": [
        {
            "NO": 548,
            "EN": "Flying Gem",
            "JP": "ひこうのジュエル",
            "FR": "Joyau Vol",
            "DE": "Flugjuwel",
            "ES": "Gema Volador",
            "IT": "Bijouvolante",
            "KOR": "비행주얼",
            "CHS": "飞行宝石",
            "CHT": "飛行寶石"
        }
    ],
    "Psychic Gem": [
        {
            "NO": 549,
            "EN": "Psychic Gem",
            "JP": "エスパージュエル",
            "FR": "Joyau Psy",
            "DE": "Psychojuwel",
            "ES": "Gema Psíquico",
            "IT": "Bijoupsico",
            "KOR": "에스퍼주얼",
            "CHS": "超能力宝石",
            "CHT": "超能力寶石"
        }
    ],
    "Bug Gem": [
        {
            "NO": 550,
            "EN": "Bug Gem",
            "JP": "むしのジュエル",
            "FR": "Joyau Insecte",
            "DE": "Käferjuwel",
            "ES": "Gema Bicho",
            "IT": "Bijoucoleottero",
            "KOR": "벌레주얼",
            "CHS": "虫之宝石",
            "CHT": "蟲之寶石"
        }
    ],
    "Rock Gem": [
        {
            "NO": 551,
            "EN": "Rock Gem",
            "JP": "いわのジュエル",
            "FR": "Joyau Roche",
            "DE": "Gesteinsjuwel",
            "ES": "Gema Roca",
            "IT": "Bijouroccia",
            "KOR": "바위주얼",
            "CHS": "岩石宝石",
            "CHT": "岩石寶石"
        }
    ],
    "Ghost Gem": [
        {
            "NO": 552,
            "EN": "Ghost Gem",
            "JP": "ゴーストジュエル",
            "FR": "Joyau Spectre",
            "DE": "Geisterjuwel",
            "ES": "Gema Fantasma",
            "IT": "Bijouspettro",
            "KOR": "고스트주얼",
            "CHS": "幽灵宝石",
            "CHT": "幽靈寶石"
        }
    ],
    "Dragon Gem": [
        {
            "NO": 553,
            "EN": "Dragon Gem",
            "JP": "ドラゴンジュエル",
            "FR": "Joyau Dragon",
            "DE": "Drakojuwel",
            "ES": "Gema Dragón",
            "IT": "Bijoudrago",
            "KOR": "드래곤주얼",
            "CHS": "龙之宝石",
            "CHT": "龍之寶石"
        }
    ],
    "Dark Gem": [
        {
            "NO": 554,
            "EN": "Dark Gem",
            "JP": "あくのジュエル",
            "FR": "Joyau Ténèbres",
            "DE": "Unlichtjuwel",
            "ES": "Gema Siniestro",
            "IT": "Bijoubuio",
            "KOR": "악주얼",
            "CHS": "恶之宝石",
            "CHT": "惡之寶石"
        }
    ],
    "Steel Gem": [
        {
            "NO": 555,
            "EN": "Steel Gem",
            "JP": "はがねのジュエル",
            "FR": "Joyau Acier",
            "DE": "Stahljuwel",
            "ES": "Gema Acero",
            "IT": "Bijouacciaio",
            "KOR": "강철주얼",
            "CHS": "钢之宝石",
            "CHT": "鋼之寶石"
        }
    ],
    "Normal Gem": [
        {
            "NO": 556,
            "EN": "Normal Gem",
            "JP": "ノーマルジュエル",
            "FR": "Joyau Normal",
            "DE": "Normaljuwel",
            "ES": "Gema Normal",
            "IT": "Bijounormale",
            "KOR": "노말주얼",
            "CHS": "一般宝石",
            "CHT": "一般寶石"
        }
    ],
    "Health Feather": [
        {
            "NO": 557,
            "EN": "Health Feather",
            "JP": "たいりょくのハネ",
            "FR": "Plume Santé",
            "DE": "Heilfeder",
            "ES": "Pluma Vigor",
            "IT": "Piumsalute",
            "KOR": "체력깃털",
            "CHS": "体力之羽",
            "CHT": "體力之羽"
        }
    ],
    "Muscle Feather": [
        {
            "NO": 558,
            "EN": "Muscle Feather",
            "JP": "きんりょくのハネ",
            "FR": "Plume Force",
            "DE": "Kraftfeder",
            "ES": "Pluma Músculo",
            "IT": "Piumpotenza",
            "KOR": "근력깃털",
            "CHS": "肌力之羽",
            "CHT": "肌力之羽"
        }
    ],
    "Resist Feather": [
        {
            "NO": 559,
            "EN": "Resist Feather",
            "JP": "ていこうのハネ",
            "FR": "Plume Armure",
            "DE": "Abwehrfeder",
            "ES": "Pluma Aguante",
            "IT": "Piumtutela",
            "KOR": "저항력깃털",
            "CHS": "抵抗之羽",
            "CHT": "抵抗之羽"
        }
    ],
    "Genius Feather": [
        {
            "NO": 560,
            "EN": "Genius Feather",
            "JP": "ちりょくのハネ",
            "FR": "Plume Esprit",
            "DE": "Geniefeder",
            "ES": "Pluma Intelecto",
            "IT": "Piumingegno",
            "KOR": "지력깃털",
            "CHS": "智力之羽",
            "CHT": "智力之羽"
        }
    ],
    "Clever Feather": [
        {
            "NO": 561,
            "EN": "Clever Feather",
            "JP": "せいしんのハネ",
            "FR": "Plume Mental",
            "DE": "Espritfeder",
            "ES": "Pluma Mente",
            "IT": "Piumintuito",
            "KOR": "정신력깃털",
            "CHS": "精神之羽",
            "CHT": "精神之羽"
        }
    ],
    "Swift Feather": [
        {
            "NO": 562,
            "EN": "Swift Feather",
            "JP": "しゅんぱつのハネ",
            "FR": "Plume Sprint",
            "DE": "Flinkfeder",
            "ES": "Pluma Ímpetu",
            "IT": "Piumreazione",
            "KOR": "순발력깃털",
            "CHS": "瞬发之羽",
            "CHT": "瞬發之羽"
        }
    ],
    "Pretty Feather": [
        {
            "NO": 563,
            "EN": "Pretty Feather",
            "JP": "きれいなハネ",
            "FR": "Jolie Plume",
            "DE": "Prachtfeder",
            "ES": "Pluma Bella",
            "IT": "Piumabella",
            "KOR": "고운깃털",
            "CHS": "美丽之羽",
            "CHT": "美麗之羽"
        }
    ],
    "Cover Fossil": [
        {
            "NO": 564,
            "EN": "Cover Fossil",
            "JP": "ふたのカセキ",
            "FR": "Fossile Plaque",
            "DE": "Schildfossil",
            "ES": "Fósil Tapa",
            "IT": "Fossiltappo",
            "KOR": "덮개화석",
            "CHS": "背盖化石",
            "CHT": "背蓋化石"
        }
    ],
    "Plume Fossil": [
        {
            "NO": 565,
            "EN": "Plume Fossil",
            "JP": "はねのカセキ",
            "FR": "Fossile Plume",
            "DE": "Federfossil",
            "ES": "Fósil Pluma",
            "IT": "Fossilpiuma",
            "KOR": "깃털화석",
            "CHS": "羽毛化石",
            "CHT": "羽毛化石"
        }
    ],
    "Liberty Pass": [
        {
            "NO": 566,
            "EN": "Liberty Pass",
            "JP": "リバティチケット",
            "FR": "Passe Liberté",
            "DE": "Gartenpass",
            "ES": "Tarjeta Libertad",
            "IT": "Liberticket",
            "KOR": "리버티티켓",
            "CHS": "自由船票",
            "CHT": "自由船票"
        }
    ],
    "Pass Orb": [
        {
            "NO": 567,
            "EN": "Pass Orb",
            "JP": "デルダマ",
            "FR": "Offrisphère",
            "DE": "Transfer-Orb",
            "ES": "Regalosfera",
            "IT": "Passabilia",
            "KOR": "딜구슬",
            "CHS": "释出之玉",
            "CHT": "釋出之玉"
        }
    ],
    "Dream Ball": [
        {
            "NO": 568,
            "EN": "Dream Ball",
            "JP": "ドリームボール",
            "FR": "Rêve Ball",
            "DE": "Traumball",
            "ES": "Ensueño Ball",
            "IT": "Dream Ball",
            "KOR": "드림볼",
            "CHS": "梦境球",
            "CHT": "夢境球"
        }
    ],
    "Poké Toy": [
        {
            "NO": 569,
            "EN": "Poké Toy",
            "JP": "ポケじゃらし",
            "FR": "Poké Plumet",
            "DE": "Pokéwedel",
            "ES": "Pokéseñuelo",
            "IT": "Pokégingillo",
            "KOR": "포켓풀",
            "CHS": "宝可尾草",
            "CHT": "寶可尾草"
        }
    ],
    "Prop Case": [
        {
            "NO": 570,
            "EN": "Prop Case",
            "JP": "グッズケース",
            "FR": "Boîte Parure",
            "DE": "Deko-Box",
            "ES": "Neceser",
            "IT": "Portagadget",
            "KOR": "굿즈케이스",
            "CHS": "物品箱",
            "CHT": "物品箱"
        }
    ],
    "Dragon Skull": [
        {
            "NO": 571,
            "EN": "Dragon Skull",
            "JP": "ドラゴンのホネ",
            "FR": "Crâne Dragon",
            "DE": "Drakoschädel",
            "ES": "Cráneo Dragón",
            "IT": "Teschio",
            "KOR": "드래곤의뼈",
            "CHS": "龙之骨",
            "CHT": "龍之骨"
        }
    ],
    "Balm Mushroom": [
        {
            "NO": 572,
            "EN": "Balm Mushroom",
            "JP": "かおるキノコ",
            "FR": "Champi Suave",
            "DE": "Duftpilz",
            "ES": "Seta Aroma",
            "IT": "Profumfungo",
            "KOR": "향기버섯",
            "CHS": "芳香蘑菇",
            "CHT": "芳香蘑菇"
        }
    ],
    "Big Nugget": [
        {
            "NO": 573,
            "EN": "Big Nugget",
            "JP": "でかいきんのたま",
            "FR": "Maxi Pépite",
            "DE": "Riesennugget",
            "ES": "Maxipepita",
            "IT": "Granpepita",
            "KOR": "큰금구슬",
            "CHS": "巨大金珠",
            "CHT": "巨大金珠"
        }
    ],
    "Pearl String": [
        {
            "NO": 574,
            "EN": "Pearl String",
            "JP": "おだんごしんじゅ",
            "FR": "Perle Triple",
            "DE": "Triperle",
            "ES": "Sarta de Perlas",
            "IT": "Trittiperla",
            "KOR": "경단진주",
            "CHS": "丸子珍珠",
            "CHT": "丸子珍珠"
        }
    ],
    "Comet Shard": [
        {
            "NO": 575,
            "EN": "Comet Shard",
            "JP": "すいせいのかけら",
            "FR": "Morceau Comète",
            "DE": "Kometstück",
            "ES": "Fragmento Cometa",
            "IT": "Pezzo cometa",
            "KOR": "혜성조각",
            "CHS": "彗星碎片",
            "CHT": "彗星碎片"
        }
    ],
    "Relic Copper": [
        {
            "NO": 576,
            "EN": "Relic Copper",
            "JP": "こだいのどうか",
            "FR": "Vieux Sou",
            "DE": "Alter Heller",
            "ES": "Real de Cobre",
            "IT": "Soldantico",
            "KOR": "고대의동화",
            "CHS": "古代铜币",
            "CHT": "古代銅幣"
        }
    ],
    "Relic Silver": [
        {
            "NO": 577,
            "EN": "Relic Silver",
            "JP": "こだいのぎんか",
            "FR": "Vieil Écu",
            "DE": "Alter Taler",
            "ES": "Real de Plata",
            "IT": "Ducatantico",
            "KOR": "고대의은화",
            "CHS": "古代银币",
            "CHT": "古代銀幣"
        }
    ],
    "Relic Gold": [
        {
            "NO": 578,
            "EN": "Relic Gold",
            "JP": "こだいのきんか",
            "FR": "Vieux Ducat",
            "DE": "Alter Dukat",
            "ES": "Real de Oro",
            "IT": "Doblonantico",
            "KOR": "고대의금화",
            "CHS": "古代金币",
            "CHT": "古代金幣"
        }
    ],
    "Relic Vase": [
        {
            "NO": 579,
            "EN": "Relic Vase",
            "JP": "こだいのツボ",
            "FR": "Vieux Vase",
            "DE": "Alte Vase",
            "ES": "Ánfora Antigua",
            "IT": "Vasantico",
            "KOR": "고대의항아리",
            "CHS": "古代之壶",
            "CHT": "古代之壺"
        }
    ],
    "Relic Band": [
        {
            "NO": 580,
            "EN": "Relic Band",
            "JP": "こだいのうでわ",
            "FR": "Vieux Bijou",
            "DE": "Alter Reif",
            "ES": "Brazal Antiguo",
            "IT": "Bracciantico",
            "KOR": "고대의팔찌",
            "CHS": "古代手镯",
            "CHT": "古代手鐲"
        }
    ],
    "Relic Statue": [
        {
            "NO": 581,
            "EN": "Relic Statue",
            "JP": "こだいのせきぞう",
            "FR": "Vieux Santon",
            "DE": "Alte Statue",
            "ES": "Efigie Antigua",
            "IT": "Statuantica",
            "KOR": "고대의석상",
            "CHS": "古代石像",
            "CHT": "古代石像"
        }
    ],
    "Relic Crown": [
        {
            "NO": 582,
            "EN": "Relic Crown",
            "JP": "こだいのおうかん",
            "FR": "Vieux Tortil",
            "DE": "Alte Krone",
            "ES": "Corona Antigua",
            "IT": "Coronantica",
            "KOR": "고대의왕관",
            "CHS": "古代王冠",
            "CHT": "古代王冠"
        }
    ],
    "Casteliacone": [
        {
            "NO": 583,
            "EN": "Casteliacone",
            "JP": "ヒウンアイス",
            "FR": "Glace Volute",
            "DE": "Stratos-Eis",
            "ES": "Porcehelado",
            "IT": "Conostropoli",
            "KOR": "구름아이스",
            "CHS": "飞云冰淇淋",
            "CHT": "飛雲冰淇淋"
        }
    ],
    "Dire Hit 2": [
        {
            "NO": 584,
            "EN": "Dire Hit 2",
            "JP": "クリティカット２",
            "FR": "Muscle 2",
            "DE": "X-Volltreffer 2",
            "ES": "Crítico X 2",
            "IT": "Supercolpo 2",
            "KOR": "크리티컬커터2",
            "CHS": "要害攻击２",
            "CHT": "要害攻擊２"
        }
    ],
    "X Speed 2": [
        {
            "NO": 585,
            "EN": "X Speed 2",
            "JP": "スピーダー２",
            "FR": "Vitesse 2",
            "DE": "X-Initiative 2",
            "ES": "Velocidad X 2",
            "IT": "Velocità X-2",
            "KOR": "스피드업2",
            "CHS": "速度强化２",
            "CHT": "速度強化２"
        }
    ],
    "X Sp. Atk 2": [
        {
            "NO": 586,
            "EN": "X Sp. Atk 2",
            "JP": "ＳＰアップ２",
            "FR": "Atq. Spé. 2",
            "DE": "X-Sp.-Ang. 2",
            "ES": "Ataque Especial X 2",
            "IT": "Attacco Speciale X-2",
            "KOR": "스페셜업2",
            "CHS": "特攻强化２",
            "CHT": "特攻強化２"
        }
    ],
    "X Sp. Def 2": [
        {
            "NO": 587,
            "EN": "X Sp. Def 2",
            "JP": "ＳＰガード２",
            "FR": "Déf. Spé. 2",
            "DE": "X-Sp.-Vert. 2",
            "ES": "Defensa Especial X 2",
            "IT": "Difesa Speciale X-2",
            "KOR": "스페셜가드2",
            "CHS": "特防强化２",
            "CHT": "特防強化２"
        }
    ],
    "X Defense 2": [
        {
            "NO": 588,
            "EN": "X Defense 2",
            "JP": "ディフェンダー２",
            "FR": "Défense 2",
            "DE": "X-Verteidigung 2",
            "ES": "Defensa X 2",
            "IT": "Difesa X-2",
            "KOR": "디펜드업2",
            "CHS": "防御强化２",
            "CHT": "防禦強化２"
        }
    ],
    "X Attack 2": [
        {
            "NO": 589,
            "EN": "X Attack 2",
            "JP": "プラスパワー２",
            "FR": "Attaque 2",
            "DE": "X-Angriff 2",
            "ES": "Ataque X 2",
            "IT": "Attacco X-2",
            "KOR": "플러스파워2",
            "CHS": "力量强化２",
            "CHT": "力量強化２"
        }
    ],
    "X Accuracy 2": [
        {
            "NO": 590,
            "EN": "X Accuracy 2",
            "JP": "ヨクアタール２",
            "FR": "Précision 2",
            "DE": "X-Genauigkeit 2",
            "ES": "Precisión X 2",
            "IT": "Precisione X-2",
            "KOR": "잘-맞히기2",
            "CHS": "命中强化２",
            "CHT": "命中強化２"
        }
    ],
    "X Speed 3": [
        {
            "NO": 591,
            "EN": "X Speed 3",
            "JP": "スピーダー３",
            "FR": "Vitesse 3",
            "DE": "X-Initiative 3",
            "ES": "Velocidad X 3",
            "IT": "Velocità X-3",
            "KOR": "스피드업3",
            "CHS": "速度强化３",
            "CHT": "速度強化３"
        }
    ],
    "X Sp. Atk 3": [
        {
            "NO": 592,
            "EN": "X Sp. Atk 3",
            "JP": "ＳＰアップ３",
            "FR": "Atq. Spé. 3",
            "DE": "X-Sp.-Ang. 3",
            "ES": "Ataque Especial X 3",
            "IT": "Attacco Speciale X-3",
            "KOR": "스페셜업3",
            "CHS": "特攻强化３",
            "CHT": "特攻強化３"
        }
    ],
    "X Sp. Def 3": [
        {
            "NO": 593,
            "EN": "X Sp. Def 3",
            "JP": "ＳＰガード３",
            "FR": "Déf. Spé. 3",
            "DE": "X-Sp.-Vert. 3",
            "ES": "Defensa Especial X 3",
            "IT": "Difesa Speciale X-3",
            "KOR": "스페셜가드3",
            "CHS": "特防强化３",
            "CHT": "特防強化３"
        }
    ],
    "X Defense 3": [
        {
            "NO": 594,
            "EN": "X Defense 3",
            "JP": "ディフェンダー３",
            "FR": "Défense 3",
            "DE": "X-Verteidigung 3",
            "ES": "Defensa X 3",
            "IT": "Difesa X-3",
            "KOR": "디펜드업3",
            "CHS": "防御强化３",
            "CHT": "防禦強化３"
        }
    ],
    "X Attack 3": [
        {
            "NO": 595,
            "EN": "X Attack 3",
            "JP": "プラスパワー３",
            "FR": "Attaque 3",
            "DE": "X-Angriff 3",
            "ES": "Ataque X 3",
            "IT": "Attacco X-3",
            "KOR": "플러스파워3",
            "CHS": "力量强化３",
            "CHT": "力量強化３"
        }
    ],
    "X Accuracy 3": [
        {
            "NO": 596,
            "EN": "X Accuracy 3",
            "JP": "ヨクアタール３",
            "FR": "Précision 3",
            "DE": "X-Genauigkeit 3",
            "ES": "Precisión X 3",
            "IT": "Precisione X-3",
            "KOR": "잘-맞히기3",
            "CHS": "命中强化３",
            "CHT": "命中強化３"
        }
    ],
    "X Speed 6": [
        {
            "NO": 597,
            "EN": "X Speed 6",
            "JP": "スピーダー６",
            "FR": "Vitesse 6",
            "DE": "X-Initiative 6",
            "ES": "Velocidad X 6",
            "IT": "Velocità X-6",
            "KOR": "스피드업6",
            "CHS": "速度强化６",
            "CHT": "速度強化６"
        }
    ],
    "X Sp. Atk 6": [
        {
            "NO": 598,
            "EN": "X Sp. Atk 6",
            "JP": "ＳＰアップ６",
            "FR": "Atq. Spé. 6",
            "DE": "X-Sp.-Ang. 6",
            "ES": "Ataque Especial X 6",
            "IT": "Attacco Speciale X-6",
            "KOR": "스페셜업6",
            "CHS": "特攻强化６",
            "CHT": "特攻強化６"
        }
    ],
    "X Sp. Def 6": [
        {
            "NO": 599,
            "EN": "X Sp. Def 6",
            "JP": "ＳＰガード６",
            "FR": "Déf. Spé. 6",
            "DE": "X-Sp.-Vert. 6",
            "ES": "Defensa Especial X 6",
            "IT": "Difesa Speciale X-6",
            "KOR": "스페셜가드6",
            "CHS": "特防强化６",
            "CHT": "特防強化６"
        }
    ],
    "X Defense 6": [
        {
            "NO": 600,
            "EN": "X Defense 6",
            "JP": "ディフェンダー６",
            "FR": "Défense 6",
            "DE": "X-Verteidigung 6",
            "ES": "Defensa X 6",
            "IT": "Difesa X-6",
            "KOR": "디펜드업6",
            "CHS": "防御强化６",
            "CHT": "防禦強化６"
        }
    ],
    "X Attack 6": [
        {
            "NO": 601,
            "EN": "X Attack 6",
            "JP": "プラスパワー６",
            "FR": "Attaque 6",
            "DE": "X-Angriff 6",
            "ES": "Ataque X 6",
            "IT": "Attacco X-6",
            "KOR": "플러스파워6",
            "CHS": "力量强化６",
            "CHT": "力量強化６"
        }
    ],
    "X Accuracy 6": [
        {
            "NO": 602,
            "EN": "X Accuracy 6",
            "JP": "ヨクアタール６",
            "FR": "Précision 6",
            "DE": "X-Genauigkeit 6",
            "ES": "Precisión X 6",
            "IT": "Precisione X-6",
            "KOR": "잘-맞히기6",
            "CHS": "命中强化６",
            "CHT": "命中強化６"
        }
    ],
    "Ability Urge": [
        {
            "NO": 603,
            "EN": "Ability Urge",
            "JP": "スキルコール",
            "FR": "Appel Talent",
            "DE": "Fähigkeiten-Appell",
            "ES": "Habilitador",
            "IT": "Chiamabilità",
            "KOR": "스킬콜",
            "CHS": "？？？",
            "CHT": "？？？"
        }
    ],
    "Item Drop": [
        {
            "NO": 604,
            "EN": "Item Drop",
            "JP": "アイテムドロップ",
            "FR": "Jette Objet",
            "DE": "Itemabwurf",
            "ES": "Tiraobjeto",
            "IT": "Lascioggetto",
            "KOR": "아이템드롭",
            "CHS": "？？？",
            "CHT": "？？？"
        }
    ],
    "Item Urge": [
        {
            "NO": 605,
            "EN": "Item Urge",
            "JP": "アイテムコール",
            "FR": "Appel Objet",
            "DE": "Itemappell",
            "ES": "Activaobjeto",
            "IT": "Chiamoggetto",
            "KOR": "아이템콜",
            "CHS": "？？？",
            "CHT": "？？？"
        }
    ],
    "Reset Urge": [
        {
            "NO": 606,
            "EN": "Reset Urge",
            "JP": "フラットコール",
            "FR": "Réamorçage",
            "DE": "Umkehrappell",
            "ES": "Quitaestado",
            "IT": "Ripristino",
            "KOR": "플랫콜",
            "CHS": "？？？",
            "CHT": "？？？"
        }
    ],
    "Dire Hit 3": [
        {
            "NO": 607,
            "EN": "Dire Hit 3",
            "JP": "クリティカット３",
            "FR": "Muscle 3",
            "DE": "X-Volltreffer 3",
            "ES": "Crítico X 3",
            "IT": "Supercolpo 3",
            "KOR": "크리티컬커터3",
            "CHS": "要害攻击３",
            "CHT": "要害攻擊３"
        }
    ],
    "Light Stone": [
        {
            "NO": 608,
            "EN": "Light Stone",
            "JP": "ライトストーン",
            "FR": "Galet Blanc",
            "DE": "Lichtstein",
            "ES": "Orbe Claro",
            "IT": "Chiarolite",
            "KOR": "라이트스톤",
            "CHS": "光明石",
            "CHT": "光明石"
        }
    ],
    "Dark Stone": [
        {
            "NO": 609,
            "EN": "Dark Stone",
            "JP": "ダークストーン",
            "FR": "Galet Noir",
            "DE": "Dunkelstein",
            "ES": "Orbe Oscuro",
            "IT": "Scurolite",
            "KOR": "다크스톤",
            "CHS": "黑暗石",
            "CHT": "黑闇石"
        }
    ],
    "TM93": [
        {
            "NO": 610,
            "EN": "TM93",
            "JP": "わざマシン９３",
            "FR": "CT93",
            "DE": "TM93",
            "ES": "MT93",
            "IT": "MT93",
            "KOR": "기술머신93",
            "CHS": "招式学习器９３",
            "CHT": "招式學習器９３"
        }
    ],
    "TM94": [
        {
            "NO": 611,
            "EN": "TM94",
            "JP": "わざマシン９４",
            "FR": "CT94",
            "DE": "TM94",
            "ES": "MT94",
            "IT": "MT94",
            "KOR": "기술머신94",
            "CHS": "招式学习器９４",
            "CHT": "招式學習器９４"
        }
    ],
    "TM95": [
        {
            "NO": 612,
            "EN": "TM95",
            "JP": "わざマシン９５",
            "FR": "CT95",
            "DE": "TM95",
            "ES": "MT95",
            "IT": "MT95",
            "KOR": "기술머신95",
            "CHS": "招式学习器９５",
            "CHT": "招式學習器９５"
        }
    ],
    "Xtransceiver": [
        {
            "NO": 613,
            "EN": "Xtransceiver",
            "JP": "ライブキャスター",
            "FR": "Vokit",
            "DE": "Viso-Caster",
            "ES": "Videomisor",
            "IT": "Interpoké",
            "KOR": "라이브캐스터",
            "CHS": "即时通讯器",
            "CHT": "即時通訊器"
        },
        {
            "NO": 617,
            "EN": "Xtransceiver",
            "JP": "ライブキャスター",
            "FR": "Vokit",
            "DE": "Viso-Caster",
            "ES": "Videomisor",
            "IT": "Interpoké",
            "KOR": "라이브캐스터",
            "CHS": "即时通讯器",
            "CHT": "即時通訊器"
        }
    ],
    "Gram 1": [
        {
            "NO": 614,
            "EN": "Gram 1",
            "JP": "はいたつぶつ１",
            "FR": "Courrier 1",
            "DE": "Briefpost 1",
            "ES": "Envío 1",
            "IT": "Missiva 1",
            "KOR": "배달물1",
            "CHS": "配送物品１",
            "CHT": "配送物品１"
        }
    ],
    "Gram 2": [
        {
            "NO": 615,
            "EN": "Gram 2",
            "JP": "はいたつぶつ２",
            "FR": "Courrier 2",
            "DE": "Briefpost 2",
            "ES": "Envío 2",
            "IT": "Missiva 2",
            "KOR": "배달물2",
            "CHS": "配送物品２",
            "CHT": "配送物品２"
        }
    ],
    "Gram 3": [
        {
            "NO": 616,
            "EN": "Gram 3",
            "JP": "はいたつぶつ３",
            "FR": "Courrier 3",
            "DE": "Briefpost 3",
            "ES": "Envío 3",
            "IT": "Missiva 3",
            "KOR": "배달물3",
            "CHS": "配送物品３",
            "CHT": "配送物品３"
        }
    ],
    "Medal Box": [
        {
            "NO": 618,
            "EN": "Medal Box",
            "JP": "メダルボックス",
            "FR": "Boîte Médailles",
            "DE": "Medaillenbox",
            "ES": "Caja de Insignias",
            "IT": "Box premi",
            "KOR": "메달박스",
            "CHS": "奖牌盒",
            "CHT": "獎牌盒"
        }
    ],
    "DNA Splicers": [
        {
            "NO": 619,
            "EN": "DNA Splicers",
            "JP": "いでんしのくさび",
            "FR": "Pointeau ADN",
            "DE": "DNS-Keil",
            "ES": "Punta ADN",
            "IT": "Cuneo DNA",
            "KOR": "유전자쐐기",
            "CHS": "基因之楔",
            "CHT": "基因之楔"
        },
        {
            "NO": 620,
            "EN": "DNA Splicers",
            "JP": "いでんしのくさび",
            "FR": "Pointeau ADN",
            "DE": "DNS-Keil",
            "ES": "Punta ADN",
            "IT": "Cuneo DNA",
            "KOR": "유전자쐐기",
            "CHS": "基因之楔",
            "CHT": "基因之楔"
        }
    ],
    "Permit": [
        {
            "NO": 621,
            "EN": "Permit",
            "JP": "きょかしょう",
            "FR": "Permis",
            "DE": "Genehmigung",
            "ES": "Pase",
            "IT": "Permesso",
            "KOR": "허가증",
            "CHS": "许可证",
            "CHT": "許可證"
        }
    ],
    "Oval Charm": [
        {
            "NO": 622,
            "EN": "Oval Charm",
            "JP": "まるいおまもり",
            "FR": "Charme Ovale",
            "DE": "Ovalpin",
            "ES": "Amuleto Oval",
            "IT": "Ovamuleto",
            "KOR": "둥근부적",
            "CHS": "圆形护符",
            "CHT": "圓形護符"
        }
    ],
    "Shiny Charm": [
        {
            "NO": 623,
            "EN": "Shiny Charm",
            "JP": "ひかるおまもり",
            "FR": "Charme Chroma",
            "DE": "Schillerpin",
            "ES": "Amuleto Iris",
            "IT": "Cromamuleto",
            "KOR": "빛나는부적",
            "CHS": "闪耀护符",
            "CHT": "閃耀護符"
        }
    ],
    "Plasma Card": [
        {
            "NO": 624,
            "EN": "Plasma Card",
            "JP": "プラズマカード",
            "FR": "Carte Plasma",
            "DE": "Plasmakarte",
            "ES": "Tarjeta Plasma",
            "IT": "Carta Plasma",
            "KOR": "플라스마카드",
            "CHS": "等离子卡",
            "CHT": "等離子卡"
        }
    ],
    "Grubby Hanky": [
        {
            "NO": 625,
            "EN": "Grubby Hanky",
            "JP": "よごれたハンカチ",
            "FR": "Mouchoir Sale",
            "DE": "Schnäuztuch",
            "ES": "Pañuelo Sucio",
            "IT": "Pezza sporca",
            "KOR": "더러운손수건",
            "CHS": "脏手帕",
            "CHT": "髒手帕"
        }
    ],
    "Colress Machine": [
        {
            "NO": 626,
            "EN": "Colress Machine",
            "JP": "アクロママシーン",
            "FR": "Nikodule",
            "DE": "Achromat",
            "ES": "Acromáquina",
            "IT": "Acrocongegno",
            "KOR": "아크로마머신",
            "CHS": "阿克罗玛机器",
            "CHT": "阿克羅瑪機器"
        }
    ],
    "Dropped Item": [
        {
            "NO": 627,
            "EN": "Dropped Item",
            "JP": "わすれもの",
            "FR": "Objet Trouvé",
            "DE": "Fundsache",
            "ES": "Objeto Perdido",
            "IT": "Oggetto perso",
            "KOR": "잊은물건",
            "CHS": "遗忘物",
            "CHT": "遺忘物"
        },
        {
            "NO": 628,
            "EN": "Dropped Item",
            "JP": "わすれもの",
            "FR": "Objet Trouvé",
            "DE": "Fundsache",
            "ES": "Objeto Perdido",
            "IT": "Oggetto perso",
            "KOR": "잊은물건",
            "CHS": "遗忘物",
            "CHT": "遺忘物"
        }
    ],
    "Reveal Glass": [
        {
            "NO": 629,
            "EN": "Reveal Glass",
            "JP": "うつしかがみ",
            "FR": "Miroir Sacré",
            "DE": "Wahrspiegel",
            "ES": "Espejo Veraz",
            "IT": "Verispecchio",
            "KOR": "비추는거울",
            "CHS": "现形镜",
            "CHT": "現形鏡"
        }
    ],
    "Weakness Policy": [
        {
            "NO": 630,
            "EN": "Weakness Policy",
            "JP": "じゃくてんほけん",
            "FR": "Vulné-Assurance",
            "DE": "Schwächenschutz",
            "ES": "Seguro Debilidad",
            "IT": "Vulneropolizza",
            "KOR": "약점보험",
            "CHS": "弱点保险",
            "CHT": "弱點保險"
        }
    ],
    "Assault Vest": [
        {
            "NO": 631,
            "EN": "Assault Vest",
            "JP": "とつげきチョッキ",
            "FR": "Veste de Combat",
            "DE": "Offensivweste",
            "ES": "Chaleco Asalto",
            "IT": "Corpetto assalto",
            "KOR": "돌격조끼",
            "CHS": "突击背心",
            "CHT": "突擊背心"
        }
    ],
    "Holo Caster": [
        {
            "NO": 632,
            "EN": "Holo Caster",
            "JP": "ホロキャスター",
            "FR": "Holokit",
            "DE": "Holo-Log",
            "ES": "Holomisor",
            "IT": "Holovox",
            "KOR": "홀로캐스터",
            "CHS": "全息影像通讯器",
            "CHT": "全像投影通訊器"
        },
        {
            "NO": 705,
            "EN": "Holo Caster",
            "JP": "ホロキャスター",
            "FR": "Holokit",
            "DE": "Holo-Log",
            "ES": "Holomisor",
            "IT": "Holovox",
            "KOR": "홀로캐스터",
            "CHS": "全息影像通讯器",
            "CHT": "全像投影通訊器"
        }
    ],
    "Prof’s Letter": [
        {
            "NO": 633,
            "EN": "Prof’s Letter",
            "JP": "はかせのてがみ",
            "FR": "Lettre du Prof",
            "DE": "Brief vom Prof",
            "ES": "Carta Profesor",
            "IT": "Lettera del Prof",
            "KOR": "박사의편지",
            "CHS": "博士的信",
            "CHT": "博士的信"
        }
    ],
    "Roller Skates": [
        {
            "NO": 634,
            "EN": "Roller Skates",
            "JP": "ローラースケート",
            "FR": "Rollers",
            "DE": "Rollerskates",
            "ES": "Patines",
            "IT": "Pattini",
            "KOR": "롤러스케이트",
            "CHS": "轮滑鞋",
            "CHT": "溜冰鞋"
        }
    ],
    "Pixie Plate": [
        {
            "NO": 635,
            "EN": "Pixie Plate",
            "JP": "せいれいプレート",
            "FR": "Plaque Pixie",
            "DE": "Feentafel",
            "ES": "Tabla Duende",
            "IT": "Lastraspiritello",
            "KOR": "정령플레이트",
            "CHS": "妖精石板",
            "CHT": "妖精石板"
        }
    ],
    "Ability Capsule": [
        {
            "NO": 636,
            "EN": "Ability Capsule",
            "JP": "とくせいカプセル",
            "FR": "Pilule Talent",
            "DE": "Fähigkeiten-Kapsel",
            "ES": "Cápsula Habilidad",
            "IT": "Capsula abilità",
            "KOR": "특성캡슐",
            "CHS": "特性胶囊",
            "CHT": "特性膠囊"
        }
    ],
    "Whipped Dream": [
        {
            "NO": 637,
            "EN": "Whipped Dream",
            "JP": "ホイップポップ",
            "FR": "Chantibonbon",
            "DE": "Sahnehäubchen",
            "ES": "Dulce de Nata",
            "IT": "Dolcespuma",
            "KOR": "휘핑팝",
            "CHS": "泡沫奶油",
            "CHT": "泡沫奶油"
        }
    ],
    "Sachet": [
        {
            "NO": 638,
            "EN": "Sachet",
            "JP": "においぶくろ",
            "FR": "Sachet Senteur",
            "DE": "Duftbeutel",
            "ES": "Saquito Fragante",
            "IT": "Bustina aromi",
            "KOR": "향기주머니",
            "CHS": "香袋",
            "CHT": "香袋"
        }
    ],
    "Luminous Moss": [
        {
            "NO": 639,
            "EN": "Luminous Moss",
            "JP": "ひかりごけ",
            "FR": "Lichen Lumineux",
            "DE": "Leuchtmoos",
            "ES": "Musgo Brillante",
            "IT": "Muschioluce",
            "KOR": "빛이끼",
            "CHS": "光苔",
            "CHT": "光苔"
        }
    ],
    "Snowball": [
        {
            "NO": 640,
            "EN": "Snowball",
            "JP": "ゆきだま",
            "FR": "Boule de Neige",
            "DE": "Schneeball",
            "ES": "Bola de Nieve",
            "IT": "Palla di neve",
            "KOR": "눈덩이",
            "CHS": "雪球",
            "CHT": "雪球"
        },
        {
            "NO": 1631,
            "EN": "Snowball",
            "JP": "ゆきだま",
            "FR": "Boule de Neige",
            "DE": "Schneeball",
            "ES": "Bola de Nieve",
            "IT": "Palla di neve",
            "KOR": "눈덩이",
            "CHS": "雪丸",
            "CHT": "雪丸"
        }
    ],
    "Safety Goggles": [
        {
            "NO": 641,
            "EN": "Safety Goggles",
            "JP": "ぼうじんゴーグル",
            "FR": "Lunettes Filtre",
            "DE": "Schutzbrille",
            "ES": "Gafa Protectora",
            "IT": "Visierantisabbia",
            "KOR": "방진고글",
            "CHS": "防尘护目镜",
            "CHT": "防塵護目鏡"
        }
    ],
    "Poké Flute": [
        {
            "NO": 642,
            "EN": "Poké Flute",
            "JP": "ポケモンのふえ",
            "FR": "Poké Flûte",
            "DE": "Pokéflöte",
            "ES": "Pokéflauta",
            "IT": "Pokéflauto",
            "KOR": "포켓몬피리",
            "CHS": "宝可梦之笛",
            "CHT": "寶可夢之笛"
        }
    ],
    "Rich Mulch": [
        {
            "NO": 643,
            "EN": "Rich Mulch",
            "JP": "たわわこやし",
            "FR": "Fertibondance",
            "DE": "Sprießmulch",
            "ES": "Abono Fértil",
            "IT": "Fertilflorido",
            "KOR": "주렁주렁비료",
            "CHS": "硕果肥",
            "CHT": "碩果肥"
        }
    ],
    "Surprise Mulch": [
        {
            "NO": 644,
            "EN": "Surprise Mulch",
            "JP": "びっくりこやし",
            "FR": "Fertistantané",
            "DE": "Wundermulch",
            "ES": "Abono Sorpresa",
            "IT": "Fertilsorpresa",
            "KOR": "깜놀비료",
            "CHS": "吃惊肥",
            "CHT": "吃驚肥"
        }
    ],
    "Boost Mulch": [
        {
            "NO": 645,
            "EN": "Boost Mulch",
            "JP": "ぐんぐんこやし",
            "FR": "Fertibérance",
            "DE": "Wuchermulch",
            "ES": "Abono Fructífero",
            "IT": "Fertilcopioso",
            "KOR": "부쩍부쩍비료",
            "CHS": "劲劲肥",
            "CHT": "勁勁肥"
        }
    ],
    "Amaze Mulch": [
        {
            "NO": 646,
            "EN": "Amaze Mulch",
            "JP": "とんでもこやし",
            "FR": "Fertiprodige",
            "DE": "Ultramulch",
            "ES": "Abono Insólito",
            "IT": "Fertilprodigio",
            "KOR": "기절초풍비료",
            "CHS": "超效肥",
            "CHT": "超效肥"
        }
    ],
    "Gengarite": [
        {
            "NO": 647,
            "EN": "Gengarite",
            "JP": "ゲンガナイト",
            "FR": "Ectoplasmite",
            "DE": "Gengarnit",
            "ES": "Gengarita",
            "IT": "Gengarite",
            "KOR": "팬텀나이트",
            "CHS": "耿鬼进化石",
            "CHT": "耿鬼進化石"
        }
    ],
    "Gardevoirite": [
        {
            "NO": 648,
            "EN": "Gardevoirite",
            "JP": "サーナイトナイト",
            "FR": "Gardevoirite",
            "DE": "Guardevoirnit",
            "ES": "Gardevoirita",
            "IT": "Gardevoirite",
            "KOR": "가디안나이트",
            "CHS": "沙奈朵进化石",
            "CHT": "沙奈朵進化石"
        }
    ],
    "Ampharosite": [
        {
            "NO": 649,
            "EN": "Ampharosite",
            "JP": "デンリュウナイト",
            "FR": "Pharampite",
            "DE": "Ampharosnit",
            "ES": "Ampharosita",
            "IT": "Ampharosite",
            "KOR": "전룡나이트",
            "CHS": "电龙进化石",
            "CHT": "電龍進化石"
        }
    ],
    "Venusaurite": [
        {
            "NO": 650,
            "EN": "Venusaurite",
            "JP": "フシギバナイト",
            "FR": "Florizarrite",
            "DE": "Bisaflornit",
            "ES": "Venusaurita",
            "IT": "Venusaurite",
            "KOR": "이상해꽃나이트",
            "CHS": "妙蛙花进化石",
            "CHT": "妙蛙花進化石"
        }
    ],
    "Charizardite X": [
        {
            "NO": 651,
            "EN": "Charizardite X",
            "JP": "リザードナイトＸ",
            "FR": "Dracaufite X",
            "DE": "Gluraknit X",
            "ES": "Charizardita X",
            "IT": "Charizardite X",
            "KOR": "리자몽나이트X",
            "CHS": "喷火龙进化石Ｘ",
            "CHT": "噴火龍進化石Ｘ"
        }
    ],
    "Blastoisinite": [
        {
            "NO": 652,
            "EN": "Blastoisinite",
            "JP": "カメックスナイト",
            "FR": "Tortankite",
            "DE": "Turtoknit",
            "ES": "Blastoisita",
            "IT": "Blastoisite",
            "KOR": "거북왕나이트",
            "CHS": "水箭龟进化石",
            "CHT": "水箭龜進化石"
        }
    ],
    "Mewtwonite X": [
        {
            "NO": 653,
            "EN": "Mewtwonite X",
            "JP": "ミュウツナイトＸ",
            "FR": "Mewtwoïte X",
            "DE": "Mewtunit X",
            "ES": "Mewtwoita X",
            "IT": "Mewtwoite X",
            "KOR": "뮤츠나이트X",
            "CHS": "超梦进化石Ｘ",
            "CHT": "超夢進化石Ｘ"
        }
    ],
    "Mewtwonite Y": [
        {
            "NO": 654,
            "EN": "Mewtwonite Y",
            "JP": "ミュウツナイトＹ",
            "FR": "Mewtwoïte Y",
            "DE": "Mewtunit Y",
            "ES": "Mewtwoita Y",
            "IT": "Mewtwoite Y",
            "KOR": "뮤츠나이트Y",
            "CHS": "超梦进化石Ｙ",
            "CHT": "超夢進化石Ｙ"
        }
    ],
    "Blazikenite": [
        {
            "NO": 655,
            "EN": "Blazikenite",
            "JP": "バシャーモナイト",
            "FR": "Braségalite",
            "DE": "Lohgocknit",
            "ES": "Blazikenita",
            "IT": "Blazikenite",
            "KOR": "번치코나이트",
            "CHS": "火焰鸡进化石",
            "CHT": "火焰雞進化石"
        }
    ],
    "Medichamite": [
        {
            "NO": 656,
            "EN": "Medichamite",
            "JP": "チャーレムナイト",
            "FR": "Charminite",
            "DE": "Meditalisnit",
            "ES": "Medichamita",
            "IT": "Medichamite",
            "KOR": "요가램나이트",
            "CHS": "恰雷姆进化石",
            "CHT": "恰雷姆進化石"
        }
    ],
    "Houndoominite": [
        {
            "NO": 657,
            "EN": "Houndoominite",
            "JP": "ヘルガナイト",
            "FR": "Démolossite",
            "DE": "Hundemonit",
            "ES": "Houndoomita",
            "IT": "Houndoomite",
            "KOR": "헬가나이트",
            "CHS": "黑鲁加进化石",
            "CHT": "黑魯加進化石"
        }
    ],
    "Aggronite": [
        {
            "NO": 658,
            "EN": "Aggronite",
            "JP": "ボスゴドラナイト",
            "FR": "Galekingite",
            "DE": "Stollossnit",
            "ES": "Aggronita",
            "IT": "Aggronite",
            "KOR": "보스로라나이트",
            "CHS": "波士可多拉进化石",
            "CHT": "波士可多拉進化石"
        }
    ],
    "Banettite": [
        {
            "NO": 659,
            "EN": "Banettite",
            "JP": "ジュペッタナイト",
            "FR": "Branettite",
            "DE": "Banetteonit",
            "ES": "Banettita",
            "IT": "Banettite",
            "KOR": "다크펫나이트",
            "CHS": "诅咒娃娃进化石",
            "CHT": "詛咒娃娃進化石"
        }
    ],
    "Tyranitarite": [
        {
            "NO": 660,
            "EN": "Tyranitarite",
            "JP": "バンギラスナイト",
            "FR": "Tyranocivite",
            "DE": "Despotarnit",
            "ES": "Tyranitarita",
            "IT": "Tyranitarite",
            "KOR": "마기라스나이트",
            "CHS": "班基拉斯进化石",
            "CHT": "班基拉斯進化石"
        }
    ],
    "Scizorite": [
        {
            "NO": 661,
            "EN": "Scizorite",
            "JP": "ハッサムナイト",
            "FR": "Cizayoxite",
            "DE": "Scheroxnit",
            "ES": "Scizorita",
            "IT": "Scizorite",
            "KOR": "핫삼나이트",
            "CHS": "巨钳螳螂进化石",
            "CHT": "巨鉗螳螂進化石"
        }
    ],
    "Pinsirite": [
        {
            "NO": 662,
            "EN": "Pinsirite",
            "JP": "カイロスナイト",
            "FR": "Scarabruite",
            "DE": "Pinsirnit",
            "ES": "Pinsirita",
            "IT": "Pinsirite",
            "KOR": "쁘사이저나이트",
            "CHS": "凯罗斯进化石",
            "CHT": "凱羅斯進化石"
        }
    ],
    "Aerodactylite": [
        {
            "NO": 663,
            "EN": "Aerodactylite",
            "JP": "プテラナイト",
            "FR": "Ptéraïte",
            "DE": "Aerodactylonit",
            "ES": "Aerodactylita",
            "IT": "Aerodactylite",
            "KOR": "프테라나이트",
            "CHS": "化石翼龙进化石",
            "CHT": "化石翼龍進化石"
        }
    ],
    "Lucarionite": [
        {
            "NO": 664,
            "EN": "Lucarionite",
            "JP": "ルカリオナイト",
            "FR": "Lucarite",
            "DE": "Lucarionit",
            "ES": "Lucarita",
            "IT": "Lucarite",
            "KOR": "루카리오나이트",
            "CHS": "路卡利欧进化石",
            "CHT": "路卡利歐進化石"
        }
    ],
    "Abomasite": [
        {
            "NO": 665,
            "EN": "Abomasite",
            "JP": "ユキノオナイト",
            "FR": "Blizzarite",
            "DE": "Rexblisarnit",
            "ES": "Abomasnowita",
            "IT": "Abomasnowite",
            "KOR": "눈설왕나이트",
            "CHS": "暴雪王进化石",
            "CHT": "暴雪王進化石"
        }
    ],
    "Kangaskhanite": [
        {
            "NO": 666,
            "EN": "Kangaskhanite",
            "JP": "ガルーラナイト",
            "FR": "Kangourexite",
            "DE": "Kangamanit",
            "ES": "Kangaskhanita",
            "IT": "Kangaskhanite",
            "KOR": "캥카나이트",
            "CHS": "袋兽进化石",
            "CHT": "袋獸進化石"
        }
    ],
    "Gyaradosite": [
        {
            "NO": 667,
            "EN": "Gyaradosite",
            "JP": "ギャラドスナイト",
            "FR": "Léviatorite",
            "DE": "Garadosnit",
            "ES": "Gyaradosita",
            "IT": "Gyaradosite",
            "KOR": "갸라도스나이트",
            "CHS": "暴鲤龙进化石",
            "CHT": "暴鯉龍進化石"
        }
    ],
    "Absolite": [
        {
            "NO": 668,
            "EN": "Absolite",
            "JP": "アブソルナイト",
            "FR": "Absolite",
            "DE": "Absolnit",
            "ES": "Absolita",
            "IT": "Absolite",
            "KOR": "앱솔나이트",
            "CHS": "阿勃梭鲁进化石",
            "CHT": "阿勃梭魯進化石"
        }
    ],
    "Charizardite Y": [
        {
            "NO": 669,
            "EN": "Charizardite Y",
            "JP": "リザードナイトＹ",
            "FR": "Dracaufite Y",
            "DE": "Gluraknit Y",
            "ES": "Charizardita Y",
            "IT": "Charizardite Y",
            "KOR": "리자몽나이트Y",
            "CHS": "喷火龙进化石Ｙ",
            "CHT": "噴火龍進化石Ｙ"
        }
    ],
    "Alakazite": [
        {
            "NO": 670,
            "EN": "Alakazite",
            "JP": "フーディナイト",
            "FR": "Alakazamite",
            "DE": "Simsalanit",
            "ES": "Alakazamita",
            "IT": "Alakazamite",
            "KOR": "후디나이트",
            "CHS": "胡地进化石",
            "CHT": "胡地進化石"
        }
    ],
    "Heracronite": [
        {
            "NO": 671,
            "EN": "Heracronite",
            "JP": "ヘラクロスナイト",
            "FR": "Scarhinoïte",
            "DE": "Skarabornit",
            "ES": "Heracrossita",
            "IT": "Heracrossite",
            "KOR": "헤라크로스나이트",
            "CHS": "赫拉克罗斯进化石",
            "CHT": "赫拉克羅斯進化石"
        }
    ],
    "Mawilite": [
        {
            "NO": 672,
            "EN": "Mawilite",
            "JP": "クチートナイト",
            "FR": "Mysdibulite",
            "DE": "Flunkifernit",
            "ES": "Mawilita",
            "IT": "Mawilite",
            "KOR": "입치트나이트",
            "CHS": "大嘴娃进化石",
            "CHT": "大嘴娃進化石"
        }
    ],
    "Manectite": [
        {
            "NO": 673,
            "EN": "Manectite",
            "JP": "ライボルトナイト",
            "FR": "Élecsprintite",
            "DE": "Voltensonit",
            "ES": "Manectricita",
            "IT": "Manectricite",
            "KOR": "썬더볼트나이트",
            "CHS": "雷电兽进化石",
            "CHT": "雷電獸進化石"
        }
    ],
    "Garchompite": [
        {
            "NO": 674,
            "EN": "Garchompite",
            "JP": "ガブリアスナイト",
            "FR": "Carchacrokite",
            "DE": "Knakracknit",
            "ES": "Garchompita",
            "IT": "Garchompite",
            "KOR": "한카리아스나이트",
            "CHS": "烈咬陆鲨进化石",
            "CHT": "烈咬陸鯊進化石"
        }
    ],
    "Latiasite": [
        {
            "NO": 675,
            "EN": "Latiasite",
            "JP": "ラティアスナイト",
            "FR": "Latiasite",
            "DE": "Latiasnit",
            "ES": "Latiasita",
            "IT": "Latiasite",
            "KOR": "라티아스나이트",
            "CHS": "拉帝亚斯进化石",
            "CHT": "拉帝亞斯進化石"
        }
    ],
    "Latiosite": [
        {
            "NO": 676,
            "EN": "Latiosite",
            "JP": "ラティオスナイト",
            "FR": "Latiosite",
            "DE": "Latiosnit",
            "ES": "Latiosita",
            "IT": "Latiosite",
            "KOR": "라티오스나이트",
            "CHS": "拉帝欧斯进化石",
            "CHT": "拉帝歐斯進化石"
        }
    ],
    "Roseli Berry": [
        {
            "NO": 677,
            "EN": "Roseli Berry",
            "JP": "ロゼルのみ",
            "FR": "Baie Selro",
            "DE": "Hibisbeere",
            "ES": "Baya Hibis",
            "IT": "Baccarcadè",
            "KOR": "로셀열매",
            "CHS": "洛玫果",
            "CHT": "洛玫果"
        }
    ],
    "Kee Berry": [
        {
            "NO": 678,
            "EN": "Kee Berry",
            "JP": "アッキのみ",
            "FR": "Baie Éka",
            "DE": "Akibeere",
            "ES": "Baya Biglia",
            "IT": "Baccalighia",
            "KOR": "악키열매",
            "CHS": "亚开果",
            "CHT": "亞開果"
        }
    ],
    "Maranga Berry": [
        {
            "NO": 679,
            "EN": "Maranga Berry",
            "JP": "タラプのみ",
            "FR": "Baie Rangma",
            "DE": "Tarabeere",
            "ES": "Baya Maranga",
            "IT": "Baccapane",
            "KOR": "타라프열매",
            "CHS": "香罗果",
            "CHT": "香羅果"
        }
    ],
    "Sprinklotad": [
        {
            "NO": 680,
            "EN": "Sprinklotad",
            "JP": "ハスボーじょうろ",
            "FR": "Nénurrosoir",
            "DE": "Loturzelkanne",
            "ES": "Lotadgadera",
            "IT": "Irrigalotad",
            "KOR": "연꽃몬물뿌리개",
            "CHS": "莲叶童子喷壶",
            "CHT": "蓮葉童子噴壺"
        }
    ],
    "TM96": [
        {
            "NO": 681,
            "EN": "TM96",
            "JP": "わざマシン９６",
            "FR": "CT96",
            "DE": "TM96",
            "ES": "MT96",
            "IT": "MT96",
            "KOR": "기술머신96",
            "CHS": "招式学习器９６",
            "CHT": "招式學習器９６"
        }
    ],
    "TM97": [
        {
            "NO": 682,
            "EN": "TM97",
            "JP": "わざマシン９７",
            "FR": "CT97",
            "DE": "TM97",
            "ES": "MT97",
            "IT": "MT97",
            "KOR": "기술머신97",
            "CHS": "招式学习器９７",
            "CHT": "招式學習器９７"
        }
    ],
    "TM98": [
        {
            "NO": 683,
            "EN": "TM98",
            "JP": "わざマシン９８",
            "FR": "CT98",
            "DE": "TM98",
            "ES": "MT98",
            "IT": "MT98",
            "KOR": "기술머신98",
            "CHS": "招式学习器９８",
            "CHT": "招式學習器９８"
        }
    ],
    "TM99": [
        {
            "NO": 684,
            "EN": "TM99",
            "JP": "わざマシン９９",
            "FR": "CT99",
            "DE": "TM99",
            "ES": "MT99",
            "IT": "MT99",
            "KOR": "기술머신99",
            "CHS": "招式学习器９９",
            "CHT": "招式學習器９９"
        }
    ],
    "TM100": [
        {
            "NO": 685,
            "EN": "TM100",
            "JP": "わざマシン１００",
            "FR": "CT100",
            "DE": "TM100",
            "ES": "MT100",
            "IT": "MT100",
            "KOR": "기술머신100",
            "CHS": "招式学习器１００",
            "CHT": "招式學習器１００"
        },
        {
            "NO": 2031,
            "EN": "TM100",
            "JP": "わざマシン１００",
            "FR": "CT100",
            "DE": "TM100",
            "ES": "MT100",
            "IT": "MT100",
            "KOR": "기술머신100",
            "CHS": "招式学习器１００",
            "CHT": "招式學習器１００"
        }
    ],
    "Power Plant Pass": [
        {
            "NO": 686,
            "EN": "Power Plant Pass",
            "JP": "はつでんしょパス",
            "FR": "Passe Centrale",
            "DE": "Kraftwerks-Pass",
            "ES": "Pase de la Central",
            "IT": "Pass centrale",
            "KOR": "발전소패스",
            "CHS": "发电厂通行证",
            "CHT": "發電廠通行證"
        }
    ],
    "Mega Ring": [
        {
            "NO": 687,
            "EN": "Mega Ring",
            "JP": "メガリング",
            "FR": "Méga-Anneau",
            "DE": "Mega-Ring",
            "ES": "Mega-Aro",
            "IT": "Megacerchio",
            "KOR": "메가링",
            "CHS": "超级环",
            "CHT": "超級環"
        }
    ],
    "Intriguing Stone": [
        {
            "NO": 688,
            "EN": "Intriguing Stone",
            "JP": "すごそうないし",
            "FR": "Pierre Insolite",
            "DE": "Kurioser Stein",
            "ES": "Piedra Insólita",
            "IT": "Sasso suggestivo",
            "KOR": "대단할듯한돌",
            "CHS": "似珍石",
            "CHT": "似珍石"
        }
    ],
    "Common Stone": [
        {
            "NO": 689,
            "EN": "Common Stone",
            "JP": "ありふれたいし",
            "FR": "Pierre Ordinaire",
            "DE": "Normaler Stein",
            "ES": "Piedra Común",
            "IT": "Sasso qualsiasi",
            "KOR": "흔해빠진돌",
            "CHS": "常见石",
            "CHT": "常見石"
        }
    ],
    "Discount Coupon": [
        {
            "NO": 690,
            "EN": "Discount Coupon",
            "JP": "バーゲンチケット",
            "FR": "Bon Réduction",
            "DE": "Rabattmarke",
            "ES": "Vale Descuento",
            "IT": "Buono sconto",
            "KOR": "바겐세일티켓",
            "CHS": "折价券",
            "CHT": "折價券"
        }
    ],
    "Elevator Key": [
        {
            "NO": 691,
            "EN": "Elevator Key",
            "JP": "エレベータのキー",
            "FR": "Clé Ascenseur",
            "DE": "Liftschlüssel",
            "ES": "Llave del Ascensor",
            "IT": "Chiave ascensore",
            "KOR": "엘리베이터키",
            "CHS": "电梯钥匙",
            "CHT": "電梯鑰匙"
        }
    ],
    "TMV Pass": [
        {
            "NO": 692,
            "EN": "TMV Pass",
            "JP": "ＴＭＶパス",
            "FR": "Passe TMV",
            "DE": "TMV-Pass",
            "ES": "Abono del TMV",
            "IT": "Pass TMV",
            "KOR": "TMV패스",
            "CHS": "ＴＭＶ自由票",
            "CHT": "ＴＭＶ自由票"
        }
    ],
    "Honor of Kalos": [
        {
            "NO": 693,
            "EN": "Honor of Kalos",
            "JP": "カロスエンブレム",
            "FR": "Insigne de Kalos",
            "DE": "Kalos-Emblem",
            "ES": "Emblema de Kalos",
            "IT": "Emblema di Kalos",
            "KOR": "칼로스엠블럼",
            "CHS": "卡洛斯勋章",
            "CHT": "卡洛斯勳章"
        }
    ],
    "Adventure Guide": [
        {
            "NO": 694,
            "EN": "Adventure Guide",
            "JP": "たんけんこころえ",
            "FR": "ABC Aventure",
            "DE": "Abenteuerfibel",
            "ES": "Guía de Aventura",
            "IT": "Guida avventura",
            "KOR": "탐험수칙",
            "CHS": "探险心得",
            "CHT": "探險心得"
        }
    ],
    "Strange Souvenir": [
        {
            "NO": 695,
            "EN": "Strange Souvenir",
            "JP": "ふしぎなおきもの",
            "FR": "Bibelot Bizarre",
            "DE": "Skurriloskulptur",
            "ES": "Estatuilla Rara",
            "IT": "Strano ninnolo",
            "KOR": "이상한장식품",
            "CHS": "神秘摆设",
            "CHT": "神秘擺設"
        }
    ],
    "Lens Case": [
        {
            "NO": 696,
            "EN": "Lens Case",
            "JP": "レンズケース",
            "FR": "Boîte Lentilles",
            "DE": "Linsenetui",
            "ES": "Portalentillas",
            "IT": "Portalenti",
            "KOR": "렌즈케이스",
            "CHS": "隐形眼镜盒",
            "CHT": "隱形眼鏡盒"
        }
    ],
    "Makeup Bag": [
        {
            "NO": 697,
            "EN": "Makeup Bag",
            "JP": "コスメポーチ",
            "FR": "Trousse Beauté",
            "DE": "Kosmetiketui",
            "ES": "Kit Maquillaje",
            "IT": "Trousse",
            "KOR": "코스메틱파우치",
            "CHS": "化妆包",
            "CHT": "化妝包"
        }
    ],
    "Travel Trunk": [
        {
            "NO": 698,
            "EN": "Travel Trunk",
            "JP": "いしょうトランク",
            "FR": "Malle Penderie",
            "DE": "Kleiderkoffer",
            "ES": "Maleta",
            "IT": "Baule per abiti",
            "KOR": "의상트렁크",
            "CHS": "衣物箱",
            "CHT": "衣物箱"
        }
    ],
    "Lumiose Galette": [
        {
            "NO": 699,
            "EN": "Lumiose Galette",
            "JP": "ミアレガレット",
            "FR": "Galette Illumis",
            "DE": "Illumina-Galette",
            "ES": "Crêpe Luminalia",
            "IT": "Pan di Lumi",
            "KOR": "미르갈레트",
            "CHS": "密阿雷格雷派饼",
            "CHT": "密阿雷格雷派餅"
        }
    ],
    "Shalour Sable": [
        {
            "NO": 700,
            "EN": "Shalour Sable",
            "JP": "シャラサブレ",
            "FR": "Sablé Yantreizh",
            "DE": "Yantara-Sablé",
            "ES": "Galleta Yantra",
            "IT": "Yantafrollino",
            "KOR": "사라사블레",
            "CHS": "娑罗沙布蕾",
            "CHT": "娑羅沙布蕾"
        }
    ],
    "Jaw Fossil": [
        {
            "NO": 701,
            "EN": "Jaw Fossil",
            "JP": "アゴのカセキ",
            "FR": "Fossile Mâchoire",
            "DE": "Kieferfossil",
            "ES": "Fósil Mandíbula",
            "IT": "Fossilmascella",
            "KOR": "턱화석",
            "CHS": "颚之化石",
            "CHT": "顎之化石"
        }
    ],
    "Sail Fossil": [
        {
            "NO": 702,
            "EN": "Sail Fossil",
            "JP": "ヒレのカセキ",
            "FR": "Fossile Nageoire",
            "DE": "Flossenfossil",
            "ES": "Fósil Aleta",
            "IT": "Fossilpinna",
            "KOR": "지느러미화석",
            "CHS": "鳍之化石",
            "CHT": "鰭之化石"
        }
    ],
    "Looker Ticket": [
        {
            "NO": 703,
            "EN": "Looker Ticket",
            "JP": "ハンサムチケット",
            "FR": "Ticket Beladonis",
            "DE": "LeBelle-Ticket",
            "ES": "Boleto Handsome",
            "IT": "Carta Bellocchio",
            "KOR": "핸섬티켓",
            "CHS": "帅哥券",
            "CHT": "帥哥券"
        }
    ],
    "Fairy Gem": [
        {
            "NO": 706,
            "EN": "Fairy Gem",
            "JP": "ようせいジュエル",
            "FR": "Joyau Fée",
            "DE": "Feenjuwel",
            "ES": "Gema Hada",
            "IT": "Bijoufolletto",
            "KOR": "페어리주얼",
            "CHS": "妖精宝石",
            "CHT": "妖精寶石"
        }
    ],
    "Mega Charm": [
        {
            "NO": 707,
            "EN": "Mega Charm",
            "JP": "メガチャーム",
            "FR": "Méga-Charme",
            "DE": "Megaillon",
            "ES": "Megacolgante",
            "IT": "Megaciondolo",
            "KOR": "메가참",
            "CHS": "超级坠饰",
            "CHT": "超級墜飾"
        }
    ],
    "Mega Glove": [
        {
            "NO": 708,
            "EN": "Mega Glove",
            "JP": "メガグローブ",
            "FR": "Méga-Gant",
            "DE": "Mega-Handschuh",
            "ES": "Megaguante",
            "IT": "Megaguanto",
            "KOR": "메가글러브",
            "CHS": "超级手套",
            "CHT": "超級手套"
        }
    ],
    "Mach Bike": [
        {
            "NO": 709,
            "EN": "Mach Bike",
            "JP": "マッハじてんしゃ",
            "FR": "Vélo de Course",
            "DE": "Eilrad",
            "ES": "Bici de Carreras",
            "IT": "Bici da corsa",
            "KOR": "마하자전거",
            "CHS": "音速自行车",
            "CHT": "音速自行車"
        }
    ],
    "Acro Bike": [
        {
            "NO": 710,
            "EN": "Acro Bike",
            "JP": "ダートじてんしゃ",
            "FR": "Vélo Cross",
            "DE": "Kunstrad",
            "ES": "Bici Acrobática",
            "IT": "Bici da cross",
            "KOR": "더트자전거",
            "CHS": "越野自行车",
            "CHT": "越野自行車"
        }
    ],
    "Wailmer Pail": [
        {
            "NO": 711,
            "EN": "Wailmer Pail",
            "JP": "ホエルコじょうろ",
            "FR": "Wailmerrosoir",
            "DE": "Wailmerkanne",
            "ES": "Wailmegadera",
            "IT": "Vaso Wailmer",
            "KOR": "고래왕자물뿌리개",
            "CHS": "吼吼鲸喷壶",
            "CHT": "吼吼鯨噴壺"
        }
    ],
    "Devon Parts": [
        {
            "NO": 712,
            "EN": "Devon Parts",
            "JP": "デボンのにもつ",
            "FR": "Pack Devon",
            "DE": "Devon-Waren",
            "ES": "Piezas Devon",
            "IT": "Merce Devon",
            "KOR": "데봉화물",
            "CHS": "得文的物品",
            "CHT": "得文的物品"
        }
    ],
    "Soot Sack": [
        {
            "NO": 713,
            "EN": "Soot Sack",
            "JP": "はいぶくろ",
            "FR": "Sac à Suie",
            "DE": "Aschetasche",
            "ES": "Saco Hollín",
            "IT": "Sacco cenere",
            "KOR": "재주머니",
            "CHS": "集灰袋",
            "CHT": "集灰袋"
        }
    ],
    "Pokéblock Kit": [
        {
            "NO": 715,
            "EN": "Pokéblock Kit",
            "JP": "ポロックキット",
            "FR": "Kit Pokébloc",
            "DE": "Pokériegel-Set",
            "ES": "Kit de Pokécubos",
            "IT": "Kit Pokémelle",
            "KOR": "포켓몬스낵키트",
            "CHS": "宝可方块套装",
            "CHT": "寶可方塊組合"
        }
    ],
    "Letter": [
        {
            "NO": 716,
            "EN": "Letter",
            "JP": "ダイゴへのてがみ",
            "FR": "Lettre à Pierre",
            "DE": "Brief an Troy",
            "ES": "Carta a Máximo",
            "IT": "Lettera",
            "KOR": "성호에게줄편지",
            "CHS": "给大吾的信",
            "CHT": "給大吾的信"
        }
    ],
    "Eon Ticket": [
        {
            "NO": 717,
            "EN": "Eon Ticket",
            "JP": "むげんのチケット",
            "FR": "Passe Éon",
            "DE": "Äon-Ticket",
            "ES": "Ticket Eón",
            "IT": "Biglietto Eone",
            "KOR": "무한티켓",
            "CHS": "无限船票",
            "CHT": "無限船票"
        }
    ],
    "Scanner": [
        {
            "NO": 718,
            "EN": "Scanner",
            "JP": "たんちき",
            "FR": "Scanner",
            "DE": "Scanner",
            "ES": "Escáner",
            "IT": "Scanner",
            "KOR": "탐지기",
            "CHS": "探测器",
            "CHT": "探測器"
        }
    ],
    "Go-Goggles": [
        {
            "NO": 719,
            "EN": "Go-Goggles",
            "JP": "ゴーゴーゴーグル",
            "FR": "Lunettes Sable",
            "DE": "Wüstenbrille",
            "ES": "Gafas Aislantes",
            "IT": "Occhialoni",
            "KOR": "고고고글",
            "CHS": "ＧＯＧＯ护目镜",
            "CHT": "ＧＯＧＯ護目鏡"
        }
    ],
    "Meteorite": [
        {
            "NO": 720,
            "EN": "Meteorite",
            "JP": "いんせき",
            "FR": "Météorite",
            "DE": "Meteorit",
            "ES": "Meteorito",
            "IT": "Meteorite",
            "KOR": "운석",
            "CHS": "陨石",
            "CHT": "隕石"
        },
        {
            "NO": 742,
            "EN": "Meteorite",
            "JP": "いんせき",
            "FR": "Météorite",
            "DE": "Meteorit",
            "ES": "Meteorito",
            "IT": "Meteorite",
            "KOR": "운석",
            "CHS": "陨石",
            "CHT": "隕石"
        },
        {
            "NO": 762,
            "EN": "Meteorite",
            "JP": "いんせき",
            "FR": "Météorite",
            "DE": "Meteorit",
            "ES": "Meteorito",
            "IT": "Meteorite",
            "KOR": "운석",
            "CHS": "陨石",
            "CHT": "隕石"
        },
        {
            "NO": 763,
            "EN": "Meteorite",
            "JP": "いんせき",
            "FR": "Météorite",
            "DE": "Meteorit",
            "ES": "Meteorito",
            "IT": "Meteorite",
            "KOR": "운석",
            "CHS": "陨石",
            "CHT": "隕石"
        }
    ],
    "Key to Room 1": [
        {
            "NO": 721,
            "EN": "Key to Room 1",
            "JP": "１ごうしつのカギ",
            "FR": "Clé Salle 1",
            "DE": "R1-Schlüssel",
            "ES": "Ll. Habitación 1",
            "IT": "Chiave stanza 1",
            "KOR": "1호실열쇠",
            "CHS": "１号客房的钥匙",
            "CHT": "１號客房的鑰匙"
        }
    ],
    "Key to Room 2": [
        {
            "NO": 722,
            "EN": "Key to Room 2",
            "JP": "２ごうしつのカギ",
            "FR": "Clé Salle 2",
            "DE": "R2-Schlüssel",
            "ES": "Ll. Habitación 2",
            "IT": "Chiave stanza 2",
            "KOR": "2호실열쇠",
            "CHS": "２号客房的钥匙",
            "CHT": "２號客房的鑰匙"
        }
    ],
    "Key to Room 4": [
        {
            "NO": 723,
            "EN": "Key to Room 4",
            "JP": "４ごうしつのカギ",
            "FR": "Clé Salle 4",
            "DE": "R4-Schlüssel",
            "ES": "Ll. Habitación 4",
            "IT": "Chiave stanza 4",
            "KOR": "4호실열쇠",
            "CHS": "４号客房的钥匙",
            "CHT": "４號客房的鑰匙"
        }
    ],
    "Key to Room 6": [
        {
            "NO": 724,
            "EN": "Key to Room 6",
            "JP": "６ごうしつのカギ",
            "FR": "Clé Salle 6",
            "DE": "R6-Schlüssel",
            "ES": "Ll. Habitación 6",
            "IT": "Chiave stanza 6",
            "KOR": "6호실열쇠",
            "CHS": "６号客房的钥匙",
            "CHT": "６號客房的鑰匙"
        }
    ],
    "Devon Scope": [
        {
            "NO": 726,
            "EN": "Devon Scope",
            "JP": "デボンスコープ",
            "FR": "Devon Scope",
            "DE": "Devon-Scope",
            "ES": "Detector Devon",
            "IT": "Devonscopio",
            "KOR": "데봉스코프",
            "CHS": "得文侦测镜",
            "CHT": "得文偵測鏡"
        }
    ],
    "HM07": [
        {
            "NO": 728,
            "EN": "HM07",
            "JP": "ひでんマシン０７",
            "FR": "CS07",
            "DE": "VM07",
            "ES": "MO07",
            "IT": "MN07",
            "KOR": "비전머신07",
            "CHS": "秘传学习器０７",
            "CHT": "秘傳學習器０７"
        }
    ],
    "Devon Scuba Gear": [
        {
            "NO": 729,
            "EN": "Devon Scuba Gear",
            "JP": "デボンボンベ",
            "FR": "Plongeur Devon",
            "DE": "Devon-Atemgerät",
            "ES": "Bombona Devon",
            "IT": "Maschera Devon",
            "KOR": "데봉봄베",
            "CHS": "得文潜水装备",
            "CHT": "得文潛水裝備"
        }
    ],
    "Contest Costume": [
        {
            "NO": 730,
            "EN": "Contest Costume",
            "JP": "ライブスーツ",
            "FR": "Costume Live",
            "DE": "Live-Anzug",
            "ES": "Traje de Gala",
            "IT": "Costume Live",
            "KOR": "라이브슈트",
            "CHS": "演出礼服",
            "CHT": "演出禮服"
        },
        {
            "NO": 731,
            "EN": "Contest Costume",
            "JP": "ライブドレス",
            "FR": "Robe Live",
            "DE": "Live-Kleid",
            "ES": "Vestido de Gala",
            "IT": "Vestito Live",
            "KOR": "라이브드레스",
            "CHS": "演出礼裙",
            "CHT": "演出禮裙"
        }
    ],
    "Magma Suit": [
        {
            "NO": 732,
            "EN": "Magma Suit",
            "JP": "マグマスーツ",
            "FR": "Scaph. Magma",
            "DE": "Magma-Anzug",
            "ES": "Traje Magma",
            "IT": "Tuta Magma",
            "KOR": "마그마슈트",
            "CHS": "熔岩装",
            "CHT": "熔岩裝"
        }
    ],
    "Aqua Suit": [
        {
            "NO": 733,
            "EN": "Aqua Suit",
            "JP": "アクアスーツ",
            "FR": "Scaphandre Aqua",
            "DE": "Aqua-Anzug",
            "ES": "Traje Aqua",
            "IT": "Tuta Idro",
            "KOR": "아쿠아슈트",
            "CHS": "海洋装",
            "CHT": "海洋裝"
        }
    ],
    "Pair of Tickets": [
        {
            "NO": 734,
            "EN": "Pair of Tickets",
            "JP": "ペアチケット",
            "FR": "Ticket Duo",
            "DE": "Zweierticket",
            "ES": "Entrada para Dos",
            "IT": "Biglietto doppio",
            "KOR": "페어티켓",
            "CHS": "双人票",
            "CHT": "雙人票"
        }
    ],
    "Mega Bracelet": [
        {
            "NO": 735,
            "EN": "Mega Bracelet",
            "JP": "メガバングル",
            "FR": "Méga-Bracelet",
            "DE": "Mega-Armreif",
            "ES": "Megapulsera",
            "IT": "Megabracciale",
            "KOR": "메가뱅글",
            "CHS": "超级手镯",
            "CHT": "超級手鐲"
        }
    ],
    "Mega Pendant": [
        {
            "NO": 736,
            "EN": "Mega Pendant",
            "JP": "メガペンダント",
            "FR": "Méga-Pendentif",
            "DE": "Mega-Anhänger",
            "ES": "Megacollar",
            "IT": "Megapendente",
            "KOR": "메가펜던트",
            "CHS": "超级吊坠",
            "CHT": "超級吊墜"
        }
    ],
    "Mega Glasses": [
        {
            "NO": 737,
            "EN": "Mega Glasses",
            "JP": "メガメガネ",
            "FR": "Méga-Lunettes",
            "DE": "Mega-Brille",
            "ES": "Megagafas",
            "IT": "Megaocchiali",
            "KOR": "메가글라스",
            "CHS": "超级眼镜",
            "CHT": "超級眼鏡"
        }
    ],
    "Mega Anchor": [
        {
            "NO": 738,
            "EN": "Mega Anchor",
            "JP": "メガイカリ",
            "FR": "Méga-Ancre",
            "DE": "Mega-Anker",
            "ES": "Megaancla",
            "IT": "Megaancora",
            "KOR": "메가앵커",
            "CHS": "超级船锚",
            "CHT": "超級船錨"
        }
    ],
    "Mega Stickpin": [
        {
            "NO": 739,
            "EN": "Mega Stickpin",
            "JP": "メガラペルピン",
            "FR": "Méga-Pin’s",
            "DE": "Mega-Anstecker",
            "ES": "Megabroche",
            "IT": "Megaspilla",
            "KOR": "메가라펠핀",
            "CHS": "超级领针",
            "CHT": "超級領針"
        }
    ],
    "Mega Tiara": [
        {
            "NO": 740,
            "EN": "Mega Tiara",
            "JP": "メガティアラ",
            "FR": "Méga-Tiare",
            "DE": "Mega-Diadem",
            "ES": "Megatiara",
            "IT": "Megadiadema",
            "KOR": "메가티아라",
            "CHS": "超级头冠",
            "CHT": "超級頭冠"
        }
    ],
    "Mega Anklet": [
        {
            "NO": 741,
            "EN": "Mega Anklet",
            "JP": "メガアンクレット",
            "FR": "Méga-Grève",
            "DE": "Mega-Beinreif",
            "ES": "Megatobillera",
            "IT": "Megagambale",
            "KOR": "메가앵클릿",
            "CHS": "超级脚镯",
            "CHT": "超級腳鐲"
        }
    ],
    "Swampertite": [
        {
            "NO": 743,
            "EN": "Swampertite",
            "JP": "ラグラージナイト",
            "FR": "Laggronite",
            "DE": "Sumpexnit",
            "ES": "Swampertita",
            "IT": "Swampertite",
            "KOR": "대짱이나이트",
            "CHS": "巨沼怪进化石",
            "CHT": "巨沼怪進化石"
        }
    ],
    "Sceptilite": [
        {
            "NO": 744,
            "EN": "Sceptilite",
            "JP": "ジュカインナイト",
            "FR": "Jungkite",
            "DE": "Gewaldronit",
            "ES": "Sceptilita",
            "IT": "Sceptilite",
            "KOR": "나무킹나이트",
            "CHS": "蜥蜴王进化石",
            "CHT": "蜥蜴王進化石"
        }
    ],
    "Sablenite": [
        {
            "NO": 745,
            "EN": "Sablenite",
            "JP": "ヤミラミナイト",
            "FR": "Ténéfixite",
            "DE": "Zobirisnit",
            "ES": "Sableynita",
            "IT": "Sableyite",
            "KOR": "깜까미나이트",
            "CHS": "勾魂眼进化石",
            "CHT": "勾魂眼進化石"
        }
    ],
    "Altarianite": [
        {
            "NO": 746,
            "EN": "Altarianite",
            "JP": "チルタリスナイト",
            "FR": "Altarite",
            "DE": "Altarianit",
            "ES": "Altarianita",
            "IT": "Altarite",
            "KOR": "파비코리나이트",
            "CHS": "七夕青鸟进化石",
            "CHT": "七夕青鳥進化石"
        }
    ],
    "Galladite": [
        {
            "NO": 747,
            "EN": "Galladite",
            "JP": "エルレイドナイト",
            "FR": "Gallamite",
            "DE": "Galagladinit",
            "ES": "Galladita",
            "IT": "Galladite",
            "KOR": "엘레이드나이트",
            "CHS": "艾路雷朵进化石",
            "CHT": "艾路雷朵進化石"
        }
    ],
    "Audinite": [
        {
            "NO": 748,
            "EN": "Audinite",
            "JP": "タブンネナイト",
            "FR": "Nanméouïte",
            "DE": "Ohrdochnit",
            "ES": "Audinita",
            "IT": "Audinite",
            "KOR": "다부니나이트",
            "CHS": "差不多娃娃进化石",
            "CHT": "差不多娃娃進化石"
        }
    ],
    "Metagrossite": [
        {
            "NO": 749,
            "EN": "Metagrossite",
            "JP": "メタグロスナイト",
            "FR": "Métalossite",
            "DE": "Metagrossnit",
            "ES": "Metagrossita",
            "IT": "Metagrossite",
            "KOR": "메타그로스나이트",
            "CHS": "巨金怪进化石",
            "CHT": "巨金怪進化石"
        }
    ],
    "Sharpedonite": [
        {
            "NO": 750,
            "EN": "Sharpedonite",
            "JP": "サメハダナイト",
            "FR": "Sharpedite",
            "DE": "Tohaidonit",
            "ES": "Sharpedonita",
            "IT": "Sharpedite",
            "KOR": "샤크니아나이트",
            "CHS": "巨牙鲨进化石",
            "CHT": "巨牙鯊進化石"
        }
    ],
    "Slowbronite": [
        {
            "NO": 751,
            "EN": "Slowbronite",
            "JP": "ヤドランナイト",
            "FR": "Flagadossite",
            "DE": "Lahmusnit",
            "ES": "Slowbronita",
            "IT": "Slowbroite",
            "KOR": "야도란나이트",
            "CHS": "呆壳兽进化石",
            "CHT": "呆殼獸進化石"
        }
    ],
    "Steelixite": [
        {
            "NO": 752,
            "EN": "Steelixite",
            "JP": "ハガネールナイト",
            "FR": "Steelixite",
            "DE": "Stahlosnit",
            "ES": "Steelixita",
            "IT": "Steelixite",
            "KOR": "강철톤나이트",
            "CHS": "大钢蛇进化石",
            "CHT": "大鋼蛇進化石"
        }
    ],
    "Pidgeotite": [
        {
            "NO": 753,
            "EN": "Pidgeotite",
            "JP": "ピジョットナイト",
            "FR": "Roucarnagite",
            "DE": "Taubossnit",
            "ES": "Pidgeotita",
            "IT": "Pidgeotite",
            "KOR": "피죤투나이트",
            "CHS": "大比鸟进化石",
            "CHT": "大比鳥進化石"
        }
    ],
    "Glalitite": [
        {
            "NO": 754,
            "EN": "Glalitite",
            "JP": "オニゴーリナイト",
            "FR": "Oniglalite",
            "DE": "Firnontornit",
            "ES": "Glalita",
            "IT": "Glalite",
            "KOR": "얼음귀신나이트",
            "CHS": "冰鬼护进化石",
            "CHT": "冰鬼護進化石"
        }
    ],
    "Diancite": [
        {
            "NO": 755,
            "EN": "Diancite",
            "JP": "ディアンシナイト",
            "FR": "Diancite",
            "DE": "Diancienit",
            "ES": "Diancita",
            "IT": "Diancite",
            "KOR": "디안시나이트",
            "CHS": "蒂安希进化石",
            "CHT": "蒂安希進化石"
        }
    ],
    "Prison Bottle": [
        {
            "NO": 756,
            "EN": "Prison Bottle",
            "JP": "いましめのツボ",
            "FR": "Vase Scellé",
            "DE": "Banngefäß",
            "ES": "Vasija Castigo",
            "IT": "Vaso del vincolo",
            "KOR": "굴레의항아리",
            "CHS": "惩戒之壶",
            "CHT": "懲戒之壺"
        }
    ],
    "Mega Cuff": [
        {
            "NO": 757,
            "EN": "Mega Cuff",
            "JP": "メガブレス",
            "FR": "Méga-Manchette",
            "DE": "Mega-Armband",
            "ES": "Megabrazalete",
            "IT": "Megapolsiera",
            "KOR": "메가브레스",
            "CHS": "超级护腕",
            "CHT": "超級護腕"
        }
    ],
    "Cameruptite": [
        {
            "NO": 758,
            "EN": "Cameruptite",
            "JP": "バクーダナイト",
            "FR": "Caméruptite",
            "DE": "Cameruptnit",
            "ES": "Cameruptita",
            "IT": "Cameruptite",
            "KOR": "폭타나이트",
            "CHS": "喷火驼进化石",
            "CHT": "噴火駝進化石"
        }
    ],
    "Lopunnite": [
        {
            "NO": 759,
            "EN": "Lopunnite",
            "JP": "ミミロップナイト",
            "FR": "Lockpinite",
            "DE": "Schlapornit",
            "ES": "Lopunnita",
            "IT": "Lopunnite",
            "KOR": "이어롭나이트",
            "CHS": "长耳兔进化石",
            "CHT": "長耳兔進化石"
        }
    ],
    "Salamencite": [
        {
            "NO": 760,
            "EN": "Salamencite",
            "JP": "ボーマンダナイト",
            "FR": "Drattakite",
            "DE": "Brutalandanit",
            "ES": "Salamencita",
            "IT": "Salamencite",
            "KOR": "보만다나이트",
            "CHS": "暴飞龙进化石",
            "CHT": "暴飛龍進化石"
        }
    ],
    "Beedrillite": [
        {
            "NO": 761,
            "EN": "Beedrillite",
            "JP": "スピアナイト",
            "FR": "Dardargnite",
            "DE": "Bibornit",
            "ES": "Beedrillita",
            "IT": "Beedrillite",
            "KOR": "독침붕나이트",
            "CHS": "大针蜂进化石",
            "CHT": "大針蜂進化石"
        }
    ],
    "Key Stone": [
        {
            "NO": 764,
            "EN": "Key Stone",
            "JP": "キーストーン",
            "FR": "Gemme Sésame",
            "DE": "Schlüssel-Stein",
            "ES": "Piedra Activadora",
            "IT": "Pietrachiave",
            "KOR": "키스톤",
            "CHS": "钥石",
            "CHT": "鑰石"
        }
    ],
    "Meteorite Shard": [
        {
            "NO": 765,
            "EN": "Meteorite Shard",
            "JP": "いんせきのかけら",
            "FR": "Éclat Météorite",
            "DE": "Meteoritenstück",
            "ES": "Fragmento Meteorito",
            "IT": "Framm. meteorite",
            "KOR": "운석조각",
            "CHS": "陨石碎片",
            "CHT": "隕石碎片"
        }
    ],
    "Eon Flute": [
        {
            "NO": 766,
            "EN": "Eon Flute",
            "JP": "むげんのふえ",
            "FR": "Flûte Éon",
            "DE": "Äon-Flöte",
            "ES": "Flauta Eón",
            "IT": "Flauto Eone",
            "KOR": "무한의피리",
            "CHS": "无限之笛",
            "CHT": "無限之笛"
        }
    ],
    "Normalium Z": [
        {
            "NO": 767,
            "EN": "Normalium Z",
            "JP": "ノーマルＺ",
            "FR": "Normazélite",
            "DE": "Normium Z",
            "ES": "Normastal Z",
            "IT": "Normium Z",
            "KOR": "노말Z",
            "CHS": "一般Ｚ",
            "CHT": "一般Ｚ"
        },
        {
            "NO": 798,
            "EN": "Normalium Z",
            "JP": "ノーマルＺ",
            "FR": "Normazélite",
            "DE": "Normium Z",
            "ES": "Normastal Z",
            "IT": "Normium Z",
            "KOR": "노말Z",
            "CHS": "一般Ｚ",
            "CHT": "一般Ｚ"
        }
    ],
    "Firium Z": [
        {
            "NO": 768,
            "EN": "Firium Z",
            "JP": "ホノオＺ",
            "FR": "Pyrozélite",
            "DE": "Pyrium Z",
            "ES": "Pirostal Z",
            "IT": "Pirium Z",
            "KOR": "불꽃Z",
            "CHS": "火Ｚ",
            "CHT": "火Ｚ"
        },
        {
            "NO": 799,
            "EN": "Firium Z",
            "JP": "ホノオＺ",
            "FR": "Pyrozélite",
            "DE": "Pyrium Z",
            "ES": "Pirostal Z",
            "IT": "Pirium Z",
            "KOR": "불꽃Z",
            "CHS": "火Ｚ",
            "CHT": "火Ｚ"
        }
    ],
    "Waterium Z": [
        {
            "NO": 769,
            "EN": "Waterium Z",
            "JP": "ミズＺ",
            "FR": "Aquazélite",
            "DE": "Aquium Z",
            "ES": "Hidrostal Z",
            "IT": "Idrium Z",
            "KOR": "물Z",
            "CHS": "水Ｚ",
            "CHT": "水Ｚ"
        },
        {
            "NO": 800,
            "EN": "Waterium Z",
            "JP": "ミズＺ",
            "FR": "Aquazélite",
            "DE": "Aquium Z",
            "ES": "Hidrostal Z",
            "IT": "Idrium Z",
            "KOR": "물Z",
            "CHS": "水Ｚ",
            "CHT": "水Ｚ"
        }
    ],
    "Electrium Z": [
        {
            "NO": 770,
            "EN": "Electrium Z",
            "JP": "デンキＺ",
            "FR": "Voltazélite",
            "DE": "Voltium Z",
            "ES": "Electrostal Z",
            "IT": "Electrium Z",
            "KOR": "전기Z",
            "CHS": "电Ｚ",
            "CHT": "電Ｚ"
        },
        {
            "NO": 801,
            "EN": "Electrium Z",
            "JP": "デンキＺ",
            "FR": "Voltazélite",
            "DE": "Voltium Z",
            "ES": "Electrostal Z",
            "IT": "Electrium Z",
            "KOR": "전기Z",
            "CHS": "电Ｚ",
            "CHT": "電Ｚ"
        }
    ],
    "Grassium Z": [
        {
            "NO": 771,
            "EN": "Grassium Z",
            "JP": "クサＺ",
            "FR": "Florazélite",
            "DE": "Botanium Z",
            "ES": "Fitostal Z",
            "IT": "Herbium Z",
            "KOR": "풀Z",
            "CHS": "草Ｚ",
            "CHT": "草Ｚ"
        },
        {
            "NO": 802,
            "EN": "Grassium Z",
            "JP": "クサＺ",
            "FR": "Florazélite",
            "DE": "Botanium Z",
            "ES": "Fitostal Z",
            "IT": "Herbium Z",
            "KOR": "풀Z",
            "CHS": "草Ｚ",
            "CHT": "草Ｚ"
        }
    ],
    "Icium Z": [
        {
            "NO": 772,
            "EN": "Icium Z",
            "JP": "コオリＺ",
            "FR": "Cryozélite",
            "DE": "Glacium Z",
            "ES": "Criostal Z",
            "IT": "Glacium Z",
            "KOR": "얼음Z",
            "CHS": "冰Ｚ",
            "CHT": "冰Ｚ"
        },
        {
            "NO": 803,
            "EN": "Icium Z",
            "JP": "コオリＺ",
            "FR": "Cryozélite",
            "DE": "Glacium Z",
            "ES": "Criostal Z",
            "IT": "Glacium Z",
            "KOR": "얼음Z",
            "CHS": "冰Ｚ",
            "CHT": "冰Ｚ"
        }
    ],
    "Fightinium Z": [
        {
            "NO": 773,
            "EN": "Fightinium Z",
            "JP": "カクトウＺ",
            "FR": "Combazélite",
            "DE": "Battalium Z",
            "ES": "Lizastal Z",
            "IT": "Luctium Z",
            "KOR": "격투Z",
            "CHS": "格斗Ｚ",
            "CHT": "格鬥Ｚ"
        },
        {
            "NO": 804,
            "EN": "Fightinium Z",
            "JP": "カクトウＺ",
            "FR": "Combazélite",
            "DE": "Battalium Z",
            "ES": "Lizastal Z",
            "IT": "Luctium Z",
            "KOR": "격투Z",
            "CHS": "格斗Ｚ",
            "CHT": "格鬥Ｚ"
        }
    ],
    "Poisonium Z": [
        {
            "NO": 774,
            "EN": "Poisonium Z",
            "JP": "ドクＺ",
            "FR": "Toxizélite",
            "DE": "Toxium Z",
            "ES": "Toxistal Z",
            "IT": "Venenium Z",
            "KOR": "독Z",
            "CHS": "毒Ｚ",
            "CHT": "毒Ｚ"
        },
        {
            "NO": 805,
            "EN": "Poisonium Z",
            "JP": "ドクＺ",
            "FR": "Toxizélite",
            "DE": "Toxium Z",
            "ES": "Toxistal Z",
            "IT": "Venenium Z",
            "KOR": "독Z",
            "CHS": "毒Ｚ",
            "CHT": "毒Ｚ"
        }
    ],
    "Groundium Z": [
        {
            "NO": 775,
            "EN": "Groundium Z",
            "JP": "ジメンＺ",
            "FR": "Terrazélite",
            "DE": "Terrium Z",
            "ES": "Geostal Z",
            "IT": "Terrium Z",
            "KOR": "땅Z",
            "CHS": "地面Ｚ",
            "CHT": "地面Ｚ"
        },
        {
            "NO": 806,
            "EN": "Groundium Z",
            "JP": "ジメンＺ",
            "FR": "Terrazélite",
            "DE": "Terrium Z",
            "ES": "Geostal Z",
            "IT": "Terrium Z",
            "KOR": "땅Z",
            "CHS": "地面Ｚ",
            "CHT": "地面Ｚ"
        }
    ],
    "Flyinium Z": [
        {
            "NO": 776,
            "EN": "Flyinium Z",
            "JP": "ヒコウＺ",
            "FR": "Aérozélite",
            "DE": "Aerium Z",
            "ES": "Aerostal Z",
            "IT": "Volantium Z",
            "KOR": "비행Z",
            "CHS": "飞行Ｚ",
            "CHT": "飛行Ｚ"
        },
        {
            "NO": 807,
            "EN": "Flyinium Z",
            "JP": "ヒコウＺ",
            "FR": "Aérozélite",
            "DE": "Aerium Z",
            "ES": "Aerostal Z",
            "IT": "Volantium Z",
            "KOR": "비행Z",
            "CHS": "飞行Ｚ",
            "CHT": "飛行Ｚ"
        }
    ],
    "Psychium Z": [
        {
            "NO": 777,
            "EN": "Psychium Z",
            "JP": "エスパーＺ",
            "FR": "Psychézélite",
            "DE": "Psium Z",
            "ES": "Psicostal Z",
            "IT": "Psichium Z",
            "KOR": "에스퍼Z",
            "CHS": "超能力Ｚ",
            "CHT": "超能力Ｚ"
        },
        {
            "NO": 808,
            "EN": "Psychium Z",
            "JP": "エスパーＺ",
            "FR": "Psychézélite",
            "DE": "Psium Z",
            "ES": "Psicostal Z",
            "IT": "Psichium Z",
            "KOR": "에스퍼Z",
            "CHS": "超能力Ｚ",
            "CHT": "超能力Ｚ"
        }
    ],
    "Buginium Z": [
        {
            "NO": 778,
            "EN": "Buginium Z",
            "JP": "ムシＺ",
            "FR": "Insectozélite",
            "DE": "Insectium Z",
            "ES": "Insectostal Z",
            "IT": "Insectium Z",
            "KOR": "벌레Z",
            "CHS": "虫Ｚ",
            "CHT": "蟲Ｚ"
        },
        {
            "NO": 809,
            "EN": "Buginium Z",
            "JP": "ムシＺ",
            "FR": "Insectozélite",
            "DE": "Insectium Z",
            "ES": "Insectostal Z",
            "IT": "Insectium Z",
            "KOR": "벌레Z",
            "CHS": "虫Ｚ",
            "CHT": "蟲Ｚ"
        }
    ],
    "Rockium Z": [
        {
            "NO": 779,
            "EN": "Rockium Z",
            "JP": "イワＺ",
            "FR": "Rocazélite",
            "DE": "Petrium Z",
            "ES": "Litostal Z",
            "IT": "Petrium Z",
            "KOR": "바위Z",
            "CHS": "岩石Ｚ",
            "CHT": "岩石Ｚ"
        },
        {
            "NO": 810,
            "EN": "Rockium Z",
            "JP": "イワＺ",
            "FR": "Rocazélite",
            "DE": "Petrium Z",
            "ES": "Litostal Z",
            "IT": "Petrium Z",
            "KOR": "바위Z",
            "CHS": "岩石Ｚ",
            "CHT": "岩石Ｚ"
        }
    ],
    "Ghostium Z": [
        {
            "NO": 780,
            "EN": "Ghostium Z",
            "JP": "ゴーストＺ",
            "FR": "Spectrozélite",
            "DE": "Phantomium Z",
            "ES": "Espectrostal Z",
            "IT": "Spectrium Z",
            "KOR": "고스트Z",
            "CHS": "幽灵Ｚ",
            "CHT": "幽靈Ｚ"
        },
        {
            "NO": 811,
            "EN": "Ghostium Z",
            "JP": "ゴーストＺ",
            "FR": "Spectrozélite",
            "DE": "Phantomium Z",
            "ES": "Espectrostal Z",
            "IT": "Spectrium Z",
            "KOR": "고스트Z",
            "CHS": "幽灵Ｚ",
            "CHT": "幽靈Ｚ"
        }
    ],
    "Dragonium Z": [
        {
            "NO": 781,
            "EN": "Dragonium Z",
            "JP": "ドラゴンＺ",
            "FR": "Dracozélite",
            "DE": "Dracium Z",
            "ES": "Dracostal Z",
            "IT": "Draconium Z",
            "KOR": "드래곤Z",
            "CHS": "龙Ｚ",
            "CHT": "龍Ｚ"
        },
        {
            "NO": 812,
            "EN": "Dragonium Z",
            "JP": "ドラゴンＺ",
            "FR": "Dracozélite",
            "DE": "Dracium Z",
            "ES": "Dracostal Z",
            "IT": "Draconium Z",
            "KOR": "드래곤Z",
            "CHS": "龙Ｚ",
            "CHT": "龍Ｚ"
        }
    ],
    "Darkinium Z": [
        {
            "NO": 782,
            "EN": "Darkinium Z",
            "JP": "アクＺ",
            "FR": "Ténébrozélite",
            "DE": "Noctium Z",
            "ES": "Nictostal Z",
            "IT": "Obscurium Z",
            "KOR": "악Z",
            "CHS": "恶Ｚ",
            "CHT": "惡Ｚ"
        },
        {
            "NO": 813,
            "EN": "Darkinium Z",
            "JP": "アクＺ",
            "FR": "Ténébrozélite",
            "DE": "Noctium Z",
            "ES": "Nictostal Z",
            "IT": "Obscurium Z",
            "KOR": "악Z",
            "CHS": "恶Ｚ",
            "CHT": "惡Ｚ"
        }
    ],
    "Steelium Z": [
        {
            "NO": 783,
            "EN": "Steelium Z",
            "JP": "ハガネＺ",
            "FR": "Métallozélite",
            "DE": "Metallium Z",
            "ES": "Metalostal Z",
            "IT": "Metallium Z",
            "KOR": "강철Z",
            "CHS": "钢Ｚ",
            "CHT": "鋼Ｚ"
        },
        {
            "NO": 814,
            "EN": "Steelium Z",
            "JP": "ハガネＺ",
            "FR": "Métallozélite",
            "DE": "Metallium Z",
            "ES": "Metalostal Z",
            "IT": "Metallium Z",
            "KOR": "강철Z",
            "CHS": "钢Ｚ",
            "CHT": "鋼Ｚ"
        }
    ],
    "Fairium Z": [
        {
            "NO": 784,
            "EN": "Fairium Z",
            "JP": "フェアリーＺ",
            "FR": "Nymphézélite",
            "DE": "Sylphium Z",
            "ES": "Feeristal Z",
            "IT": "Follectium Z",
            "KOR": "페어리Z",
            "CHS": "妖精Ｚ",
            "CHT": "妖精Ｚ"
        },
        {
            "NO": 815,
            "EN": "Fairium Z",
            "JP": "フェアリーＺ",
            "FR": "Nymphézélite",
            "DE": "Sylphium Z",
            "ES": "Feeristal Z",
            "IT": "Follectium Z",
            "KOR": "페어리Z",
            "CHS": "妖精Ｚ",
            "CHT": "妖精Ｚ"
        }
    ],
    "Pikanium Z": [
        {
            "NO": 785,
            "EN": "Pikanium Z",
            "JP": "ピカチュウＺ",
            "FR": "Pikazélite",
            "DE": "Pikachium Z",
            "ES": "Pikastal Z",
            "IT": "Pikacium Z",
            "KOR": "피카츄Z",
            "CHS": "皮卡丘Ｚ",
            "CHT": "皮卡丘Ｚ"
        },
        {
            "NO": 816,
            "EN": "Pikanium Z",
            "JP": "ピカチュウＺ",
            "FR": "Pikazélite",
            "DE": "Pikachium Z",
            "ES": "Pikastal Z",
            "IT": "Pikacium Z",
            "KOR": "피카츄Z",
            "CHS": "皮卡丘Ｚ",
            "CHT": "皮卡丘Ｚ"
        }
    ],
    "Bottle Cap": [
        {
            "NO": 786,
            "EN": "Bottle Cap",
            "JP": "ぎんのおうかん",
            "FR": "Capsule d’Argent",
            "DE": "Silberkronkorken",
            "ES": "Chapa Plateada",
            "IT": "Tappo d’argento",
            "KOR": "은색병뚜껑",
            "CHS": "银色王冠",
            "CHT": "銀色王冠"
        }
    ],
    "Gold Bottle Cap": [
        {
            "NO": 787,
            "EN": "Gold Bottle Cap",
            "JP": "きんのおうかん",
            "FR": "Capsule d’Or",
            "DE": "Goldkronkorken",
            "ES": "Chapa Dorada",
            "IT": "Tappo d’oro",
            "KOR": "금색병뚜껑",
            "CHS": "金色王冠",
            "CHT": "金色王冠"
        }
    ],
    "Z-Ring": [
        {
            "NO": 788,
            "EN": "Z-Ring",
            "JP": "Ｚリング",
            "FR": "Bracelet Z",
            "DE": "Z-Ring",
            "ES": "Pulsera Z",
            "IT": "Cerchio Z",
            "KOR": "Z링",
            "CHS": "Ｚ手环",
            "CHT": "Ｚ手環"
        }
    ],
    "Decidium Z": [
        {
            "NO": 789,
            "EN": "Decidium Z",
            "JP": "ジュナイパーＺ",
            "FR": "Archézélite",
            "DE": "Silvarronium Z",
            "ES": "Dueyestal Z",
            "IT": "Deciduenium Z",
            "KOR": "모크나이퍼Z",
            "CHS": "狙射树枭Ｚ",
            "CHT": "狙射樹梟Ｚ"
        },
        {
            "NO": 817,
            "EN": "Decidium Z",
            "JP": "ジュナイパーＺ",
            "FR": "Archézélite",
            "DE": "Silvarronium Z",
            "ES": "Dueyestal Z",
            "IT": "Deciduenium Z",
            "KOR": "모크나이퍼Z",
            "CHS": "狙射树枭Ｚ",
            "CHT": "狙射樹梟Ｚ"
        }
    ],
    "Incinium Z": [
        {
            "NO": 790,
            "EN": "Incinium Z",
            "JP": "ガオガエンＺ",
            "FR": "Félinozélite",
            "DE": "Fuegronium Z",
            "ES": "Incinostal Z",
            "IT": "Incineronium Z",
            "KOR": "어흥염Z",
            "CHS": "炽焰咆哮虎Ｚ",
            "CHT": "熾焰咆哮虎Ｚ"
        },
        {
            "NO": 818,
            "EN": "Incinium Z",
            "JP": "ガオガエンＺ",
            "FR": "Félinozélite",
            "DE": "Fuegronium Z",
            "ES": "Incinostal Z",
            "IT": "Incineronium Z",
            "KOR": "어흥염Z",
            "CHS": "炽焰咆哮虎Ｚ",
            "CHT": "熾焰咆哮虎Ｚ"
        }
    ],
    "Primarium Z": [
        {
            "NO": 791,
            "EN": "Primarium Z",
            "JP": "アシレーヌＺ",
            "FR": "Oratozélite",
            "DE": "Primarenium Z",
            "ES": "Primastal Z",
            "IT": "Primarinium Z",
            "KOR": "누리레느Z",
            "CHS": "西狮海壬Ｚ",
            "CHT": "西獅海壬Ｚ"
        },
        {
            "NO": 819,
            "EN": "Primarium Z",
            "JP": "アシレーヌＺ",
            "FR": "Oratozélite",
            "DE": "Primarenium Z",
            "ES": "Primastal Z",
            "IT": "Primarinium Z",
            "KOR": "누리레느Z",
            "CHS": "西狮海壬Ｚ",
            "CHT": "西獅海壬Ｚ"
        }
    ],
    "Tapunium Z": [
        {
            "NO": 792,
            "EN": "Tapunium Z",
            "JP": "カプＺ",
            "FR": "Tokozélite",
            "DE": "Kapium Z",
            "ES": "Tapistal Z",
            "IT": "Tapium Z",
            "KOR": "카푸Z",
            "CHS": "卡璞Ｚ",
            "CHT": "卡璞Ｚ"
        },
        {
            "NO": 820,
            "EN": "Tapunium Z",
            "JP": "カプＺ",
            "FR": "Tokozélite",
            "DE": "Kapium Z",
            "ES": "Tapistal Z",
            "IT": "Tapium Z",
            "KOR": "카푸Z",
            "CHS": "卡璞Ｚ",
            "CHT": "卡璞Ｚ"
        }
    ],
    "Marshadium Z": [
        {
            "NO": 793,
            "EN": "Marshadium Z",
            "JP": "マーシャドーＺ",
            "FR": "Marshadozélite",
            "DE": "Marshadownium Z",
            "ES": "Marshastal Z",
            "IT": "Marshadium Z",
            "KOR": "마샤도Z",
            "CHS": "玛夏多Ｚ",
            "CHT": "瑪夏多Ｚ"
        },
        {
            "NO": 821,
            "EN": "Marshadium Z",
            "JP": "マーシャドーＺ",
            "FR": "Marshadozélite",
            "DE": "Marshadownium Z",
            "ES": "Marshastal Z",
            "IT": "Marshadium Z",
            "KOR": "마샤도Z",
            "CHS": "玛夏多Ｚ",
            "CHT": "瑪夏多Ｚ"
        }
    ],
    "Aloraichium Z": [
        {
            "NO": 794,
            "EN": "Aloraichium Z",
            "JP": "アロライＺ",
            "FR": "Aloraïzélite",
            "DE": "A-Raichunium Z",
            "ES": "Alo-Raistal Z",
            "IT": "Aloraicium Z",
            "KOR": "알로라이Z",
            "CHS": "阿罗雷Ｚ",
            "CHT": "阿羅雷Ｚ"
        },
        {
            "NO": 822,
            "EN": "Aloraichium Z",
            "JP": "アロライＺ",
            "FR": "Aloraïzélite",
            "DE": "A-Raichunium Z",
            "ES": "Alo-Raistal Z",
            "IT": "Aloraicium Z",
            "KOR": "알로라이Z",
            "CHS": "阿罗雷Ｚ",
            "CHT": "阿羅雷Ｚ"
        }
    ],
    "Snorlium Z": [
        {
            "NO": 795,
            "EN": "Snorlium Z",
            "JP": "カビゴンＺ",
            "FR": "Ronflézélite",
            "DE": "Relaxonium Z",
            "ES": "Snorlastal Z",
            "IT": "Snorlactium Z",
            "KOR": "잠만보Z",
            "CHS": "卡比兽Ｚ",
            "CHT": "卡比獸Ｚ"
        },
        {
            "NO": 823,
            "EN": "Snorlium Z",
            "JP": "カビゴンＺ",
            "FR": "Ronflézélite",
            "DE": "Relaxonium Z",
            "ES": "Snorlastal Z",
            "IT": "Snorlactium Z",
            "KOR": "잠만보Z",
            "CHS": "卡比兽Ｚ",
            "CHT": "卡比獸Ｚ"
        }
    ],
    "Eevium Z": [
        {
            "NO": 796,
            "EN": "Eevium Z",
            "JP": "イーブイＺ",
            "FR": "Évolizélite",
            "DE": "Evolium Z",
            "ES": "Eeveestal Z",
            "IT": "Eevium Z",
            "KOR": "이브이Z",
            "CHS": "伊布Ｚ",
            "CHT": "伊布Ｚ"
        },
        {
            "NO": 824,
            "EN": "Eevium Z",
            "JP": "イーブイＺ",
            "FR": "Évolizélite",
            "DE": "Evolium Z",
            "ES": "Eeveestal Z",
            "IT": "Eevium Z",
            "KOR": "이브이Z",
            "CHS": "伊布Ｚ",
            "CHT": "伊布Ｚ"
        }
    ],
    "Mewnium Z": [
        {
            "NO": 797,
            "EN": "Mewnium Z",
            "JP": "ミュウＺ",
            "FR": "Mewzélite",
            "DE": "Mewnium Z",
            "ES": "Mewstal Z",
            "IT": "Mewnium Z",
            "KOR": "뮤Z",
            "CHS": "梦幻Ｚ",
            "CHT": "夢幻Ｚ"
        },
        {
            "NO": 825,
            "EN": "Mewnium Z",
            "JP": "ミュウＺ",
            "FR": "Mewzélite",
            "DE": "Mewnium Z",
            "ES": "Mewstal Z",
            "IT": "Mewnium Z",
            "KOR": "뮤Z",
            "CHS": "梦幻Ｚ",
            "CHT": "夢幻Ｚ"
        }
    ],
    "Pikashunium Z": [
        {
            "NO": 826,
            "EN": "Pikashunium Z",
            "JP": "サトピカＺ",
            "FR": "Pikachazélite",
            "DE": "Ash-Pikachium Z",
            "ES": "Ash-Pikastal Z",
            "IT": "Ashpikacium Z",
            "KOR": "지우피카Z",
            "CHS": "智皮卡Ｚ",
            "CHT": "智皮卡Ｚ"
        },
        {
            "NO": 827,
            "EN": "Pikashunium Z",
            "JP": "サトピカＺ",
            "FR": "Pikachazélite",
            "DE": "Ash-Pikachium Z",
            "ES": "Ash-Pikastal Z",
            "IT": "Ashpikacium Z",
            "KOR": "지우피카Z",
            "CHS": "智皮卡Ｚ",
            "CHT": "智皮卡Ｚ"
        }
    ],
    "Forage Bag": [
        {
            "NO": 828,
            "EN": "Forage Bag",
            "JP": "ざいりょうぶくろ",
            "FR": "Sac Ingrédients",
            "DE": "Zutatenbeutel",
            "ES": "Zurrón",
            "IT": "Portaingredienti",
            "KOR": "재료주머니",
            "CHS": "材料袋",
            "CHT": "材料袋"
        }
    ],
    "Fishing Rod": [
        {
            "NO": 829,
            "EN": "Fishing Rod",
            "JP": "つりざお",
            "FR": "Canne à Pêche",
            "DE": "Angel",
            "ES": "Caña",
            "IT": "Canna da pesca",
            "KOR": "낚싯대",
            "CHS": "钓竿",
            "CHT": "釣竿"
        },
        {
            "NO": 1039,
            "EN": "Fishing Rod",
            "JP": "つりざお",
            "FR": "Canne à Pêche",
            "DE": "Angel",
            "ES": "Caña",
            "IT": "Canna da pesca",
            "KOR": "낚싯대",
            "CHS": "钓竿",
            "CHT": "釣竿"
        }
    ],
    "Professor’s Mask": [
        {
            "NO": 830,
            "EN": "Professor’s Mask",
            "JP": "はかせのふくめん",
            "FR": "Masque du Prof",
            "DE": "Maske des Profs",
            "ES": "Máscara Profesor",
            "IT": "Maschera del Prof",
            "KOR": "박사의복면",
            "CHS": "博士的面罩",
            "CHT": "博士的面罩"
        }
    ],
    "Festival Ticket": [
        {
            "NO": 831,
            "EN": "Festival Ticket",
            "JP": "フェスチケット",
            "FR": "Festicket",
            "DE": "Festival-Ticket",
            "ES": "Festicupón",
            "IT": "Festicket",
            "KOR": "페스티켓",
            "CHS": "圆庆票",
            "CHT": "圓慶票"
        }
    ],
    "Sparkling Stone": [
        {
            "NO": 832,
            "EN": "Sparkling Stone",
            "JP": "かがやくいし",
            "FR": "Gemme Lumière",
            "DE": "Glitzerstein",
            "ES": "Piedra Brillante",
            "IT": "Pietra lucente",
            "KOR": "빛나는돌",
            "CHS": "光辉石",
            "CHT": "光輝石"
        }
    ],
    "Adrenaline Orb": [
        {
            "NO": 833,
            "EN": "Adrenaline Orb",
            "JP": "ビビリだま",
            "FR": "Orbe Frousse",
            "DE": "Zitter-Orb",
            "ES": "Nerviosfera",
            "IT": "Fifasfera",
            "KOR": "주눅구슬",
            "CHS": "胆怯球",
            "CHT": "膽怯球"
        }
    ],
    "Zygarde Cube": [
        {
            "NO": 834,
            "EN": "Zygarde Cube",
            "JP": "ジガルデキューブ",
            "FR": "Boîte Zygarde",
            "DE": "Zygarde-Würfel",
            "ES": "Arca de Zygarde",
            "IT": "Teca Zygarde",
            "KOR": "지가르데큐브",
            "CHS": "基格尔德多面体",
            "CHT": "基格爾德多面體"
        }
    ],
    "Ice Stone": [
        {
            "NO": 835,
            "EN": "Ice Stone",
            "JP": "こおりのいし",
            "FR": "Pierre Glace",
            "DE": "Eisstein",
            "ES": "Piedra Hielo",
            "IT": "Pietragelo",
            "KOR": "얼음의돌",
            "CHS": "冰之石",
            "CHT": "冰之石"
        }
    ],
    "Ride Pager": [
        {
            "NO": 836,
            "EN": "Ride Pager",
            "JP": "ライドギア",
            "FR": "Appel-Monture",
            "DE": "PokéMobil-Funk",
            "ES": "Buscamontura",
            "IT": "Chiamapassaggio",
            "KOR": "라이드기어",
            "CHS": "骑行装置",
            "CHT": "騎行裝置"
        }
    ],
    "Beast Ball": [
        {
            "NO": 837,
            "EN": "Beast Ball",
            "JP": "ウルトラボール",
            "FR": "Ultra Ball",
            "DE": "Ultraball",
            "ES": "Ente Ball",
            "IT": "UC Ball",
            "KOR": "울트라볼",
            "CHS": "究极球",
            "CHT": "究極球"
        }
    ],
    "Big Malasada": [
        {
            "NO": 838,
            "EN": "Big Malasada",
            "JP": "おおきいマラサダ",
            "FR": "Malasada Maxi",
            "DE": "Maxi-Malasada",
            "ES": "Malasada Maxi",
            "IT": "Malasada maxi",
            "KOR": "큰 말라사다",
            "CHS": "大马拉萨达",
            "CHT": "大馬拉薩達"
        }
    ],
    "Red Nectar": [
        {
            "NO": 839,
            "EN": "Red Nectar",
            "JP": "くれないのミツ",
            "FR": "Nectar Rouge",
            "DE": "Roter Nektar",
            "ES": "Néctar Rojo",
            "IT": "Nettare rosso",
            "KOR": "다홍꿀",
            "CHS": "朱红色花蜜",
            "CHT": "朱紅色花蜜"
        }
    ],
    "Yellow Nectar": [
        {
            "NO": 840,
            "EN": "Yellow Nectar",
            "JP": "やまぶきのミツ",
            "FR": "Nectar Jaune",
            "DE": "Gelber Nektar",
            "ES": "Néctar Amarillo",
            "IT": "Nettare giallo",
            "KOR": "진노랑꿀",
            "CHS": "金黄色花蜜",
            "CHT": "金黃色花蜜"
        }
    ],
    "Pink Nectar": [
        {
            "NO": 841,
            "EN": "Pink Nectar",
            "JP": "うすもものミツ",
            "FR": "Nectar Rose",
            "DE": "Rosa Nektar",
            "ES": "Néctar Rosa",
            "IT": "Nettare rosa",
            "KOR": "연분홍꿀",
            "CHS": "桃粉色花蜜",
            "CHT": "桃粉色花蜜"
        }
    ],
    "Purple Nectar": [
        {
            "NO": 842,
            "EN": "Purple Nectar",
            "JP": "むらさきのミツ",
            "FR": "Nectar Mauve",
            "DE": "Purpurner Nektar",
            "ES": "Néctar Violeta",
            "IT": "Nettare viola",
            "KOR": "보라꿀",
            "CHS": "兰紫色花蜜",
            "CHT": "蘭紫色花蜜"
        }
    ],
    "Sun Flute": [
        {
            "NO": 843,
            "EN": "Sun Flute",
            "JP": "たいようのふえ",
            "FR": "Flûte du Soleil",
            "DE": "Sonnenflöte",
            "ES": "Flauta Solar",
            "IT": "Flauto solare",
            "KOR": "태양의피리",
            "CHS": "太阳之笛",
            "CHT": "太陽之笛"
        }
    ],
    "Moon Flute": [
        {
            "NO": 844,
            "EN": "Moon Flute",
            "JP": "つきのふえ",
            "FR": "Flûte de la Lune",
            "DE": "Mondflöte",
            "ES": "Flauta Lunar",
            "IT": "Flauto lunare",
            "KOR": "달의피리",
            "CHS": "月亮之笛",
            "CHT": "月亮之笛"
        }
    ],
    "Enigmatic Card": [
        {
            "NO": 845,
            "EN": "Enigmatic Card",
            "JP": "あやしいカード",
            "FR": "Message Mystère",
            "DE": "Seltsame Karte",
            "ES": "Nota Intrigante",
            "IT": "Lettera segreta",
            "KOR": "괴상한카드",
            "CHS": "奇异卡片",
            "CHT": "奇異卡片"
        }
    ],
    "Silver Razz Berry": [
        {
            "NO": 846,
            "EN": "Silver Razz Berry",
            "JP": "ぎんのズリのみ",
            "FR": "Baie Framby argentée",
            "DE": "Silberne Himmihbeere",
            "ES": "Baya Frambu Plateada",
            "IT": "Baccalampon argentata",
            "KOR": "은 라즈열매",
            "CHS": "银色蔓莓果",
            "CHT": "銀色蔓莓果"
        }
    ],
    "Golden Razz Berry": [
        {
            "NO": 847,
            "EN": "Golden Razz Berry",
            "JP": "きんのズリのみ",
            "FR": "Baie Framby dorée",
            "DE": "Goldene Himmihbeere",
            "ES": "Baya Frambu Dorada",
            "IT": "Baccalampon dorata",
            "KOR": "황금 라즈열매",
            "CHS": "金色蔓莓果",
            "CHT": "金色蔓莓果"
        }
    ],
    "Silver Nanab Berry": [
        {
            "NO": 848,
            "EN": "Silver Nanab Berry",
            "JP": "ぎんのナナのみ",
            "FR": "Baie Nanab argentée",
            "DE": "Silberne Nanabbeere",
            "ES": "Baya Latano Plateada",
            "IT": "Baccabana argentata",
            "KOR": "은 나나열매",
            "CHS": "银色蕉香果",
            "CHT": "銀色蕉香果"
        }
    ],
    "Golden Nanab Berry": [
        {
            "NO": 849,
            "EN": "Golden Nanab Berry",
            "JP": "きんのナナのみ",
            "FR": "Baie Nanab dorée",
            "DE": "Goldene Nanabbeere",
            "ES": "Baya Latano Dorada",
            "IT": "Baccabana dorata",
            "KOR": "황금 나나열매",
            "CHS": "金色蕉香果",
            "CHT": "金色蕉香果"
        }
    ],
    "Silver Pinap Berry": [
        {
            "NO": 850,
            "EN": "Silver Pinap Berry",
            "JP": "ぎんのパイルのみ",
            "FR": "Baie Nanana argentée",
            "DE": "Silberne Sananabeere",
            "ES": "Baya Pinia Plateada",
            "IT": "Baccananas argentata",
            "KOR": "은 파인열매",
            "CHS": "银色凰梨果",
            "CHT": "銀色凰梨果"
        }
    ],
    "Golden Pinap Berry": [
        {
            "NO": 851,
            "EN": "Golden Pinap Berry",
            "JP": "きんのパイルのみ",
            "FR": "Baie Nanana dorée",
            "DE": "Goldene Sananabeere",
            "ES": "Baya Pinia Dorada",
            "IT": "Baccananas dorata",
            "KOR": "황금 파인열매",
            "CHS": "金色凰梨果",
            "CHT": "金色凰梨果"
        }
    ],
    "Silph Scope": [
        {
            "NO": 854,
            "EN": "Silph Scope",
            "JP": "シルフスコープ",
            "FR": "Scope Sylphe",
            "DE": "Silph Scope",
            "ES": "Visor Silph",
            "IT": "Spettrosonda",
            "KOR": "실프스코프",
            "CHS": "西尔佛检视镜",
            "CHT": "西爾佛檢視鏡"
        }
    ],
    "Gold Teeth": [
        {
            "NO": 857,
            "EN": "Gold Teeth",
            "JP": "きんのいれば",
            "FR": "Dentier en Or",
            "DE": "Goldenes Gebiss",
            "ES": "Dentadura de Oro",
            "IT": "Denti d’oro",
            "KOR": "금틀니",
            "CHS": "金假牙",
            "CHT": "金假牙"
        }
    ],
    "Lift Key": [
        {
            "NO": 858,
            "EN": "Lift Key",
            "JP": "エレベータのカギ",
            "FR": "Clé Ascenseur",
            "DE": "Aufzugsschlüssel",
            "ES": "Llave del Ascensor",
            "IT": "Chiave ascensore",
            "KOR": "엘리베이터열쇠",
            "CHS": "电梯钥匙",
            "CHT": "電梯鑰匙"
        }
    ],
    "Terrain Extender": [
        {
            "NO": 859,
            "EN": "Terrain Extender",
            "JP": "グランドコート",
            "FR": "Champ’Duit",
            "DE": "Feldbeschichtung",
            "ES": "Cubresuelos",
            "IT": "Fissacampo",
            "KOR": "그라운드코트",
            "CHS": "大地膜",
            "CHT": "大地膜"
        }
    ],
    "Protective Pads": [
        {
            "NO": 860,
            "EN": "Protective Pads",
            "JP": "ぼうごパット",
            "FR": "Pare-Effet",
            "DE": "Schutzpolster",
            "ES": "Paracontacto",
            "IT": "Smorzaurti",
            "KOR": "방호패드",
            "CHS": "部位护具",
            "CHT": "部位護具"
        }
    ],
    "Electric Seed": [
        {
            "NO": 861,
            "EN": "Electric Seed",
            "JP": "エレキシード",
            "FR": "Graine Électrik",
            "DE": "Elektro-Samen",
            "ES": "Semilla Electro",
            "IT": "Elettroseme",
            "KOR": "일렉트릭시드",
            "CHS": "电气种子",
            "CHT": "電氣種子"
        }
    ],
    "Psychic Seed": [
        {
            "NO": 862,
            "EN": "Psychic Seed",
            "JP": "サイコシード",
            "FR": "Graine Psychique",
            "DE": "Psycho-Samen",
            "ES": "Semilla Psique",
            "IT": "Psicoseme",
            "KOR": "사이코시드",
            "CHS": "精神种子",
            "CHT": "精神種子"
        }
    ],
    "Misty Seed": [
        {
            "NO": 863,
            "EN": "Misty Seed",
            "JP": "ミストシード",
            "FR": "Graine Brume",
            "DE": "Nebel-Samen",
            "ES": "Semilla Bruma",
            "IT": "Nebbiaseme",
            "KOR": "미스트시드",
            "CHS": "薄雾种子",
            "CHT": "薄霧種子"
        }
    ],
    "Grassy Seed": [
        {
            "NO": 864,
            "EN": "Grassy Seed",
            "JP": "グラスシード",
            "FR": "Graine Herbe",
            "DE": "Gras-Samen",
            "ES": "Semilla Hierba",
            "IT": "Erbaseme",
            "KOR": "그래스시드",
            "CHS": "青草种子",
            "CHT": "青草種子"
        }
    ],
    "Stretchy Spring": [
        {
            "NO": 865,
            "EN": "Stretchy Spring",
            "JP": "のびたバネ",
            "FR": "Ressort Détendu",
            "DE": "Spiralfeder",
            "ES": "Muelle Estirado",
            "IT": "Molla elastica",
            "KOR": "늘어난용수철",
            "CHS": "松掉的弹簧",
            "CHT": "鬆掉的彈簧"
        }
    ],
    "Chalky Stone": [
        {
            "NO": 866,
            "EN": "Chalky Stone",
            "JP": "チョークいし",
            "FR": "Craie",
            "DE": "Kreidestein",
            "ES": "Tiza",
            "IT": "Gessetto",
            "KOR": "초크돌",
            "CHS": "粉笔石",
            "CHT": "粉筆石"
        }
    ],
    "Marble": [
        {
            "NO": 867,
            "EN": "Marble",
            "JP": "ビーだま",
            "FR": "Bille",
            "DE": "Glasmurmel",
            "ES": "Canica",
            "IT": "Biglia",
            "KOR": "유리구슬",
            "CHS": "弹珠",
            "CHT": "彈珠"
        }
    ],
    "Lone Earring": [
        {
            "NO": 868,
            "EN": "Lone Earring",
            "JP": "かたっぽピアス",
            "FR": "Boucle d’Oreille",
            "DE": "Ohrring",
            "ES": "Pendiente",
            "IT": "Orecchino",
            "KOR": "한쪽귀고리",
            "CHS": "一边的耳环",
            "CHT": "一邊的耳環"
        }
    ],
    "Beach Glass": [
        {
            "NO": 869,
            "EN": "Beach Glass",
            "JP": "うみべのガラス",
            "FR": "Galet de Verre",
            "DE": "Strandscherbe",
            "ES": "Cristal Marino",
            "IT": "Vetro marino",
            "KOR": "바닷가유리",
            "CHS": "海边的玻璃",
            "CHT": "海邊的玻璃"
        }
    ],
    "Gold Leaf": [
        {
            "NO": 870,
            "EN": "Gold Leaf",
            "JP": "きんのはっぱ",
            "FR": "Feuille Dorée",
            "DE": "Goldblatt",
            "ES": "Hoja de Oro",
            "IT": "Fogliadoro",
            "KOR": "금빛잎사귀",
            "CHS": "金色叶子",
            "CHT": "金色葉子"
        }
    ],
    "Silver Leaf": [
        {
            "NO": 871,
            "EN": "Silver Leaf",
            "JP": "ぎんのはっぱ",
            "FR": "Feuille Argentée",
            "DE": "Silberblatt",
            "ES": "Hoja de Plata",
            "IT": "Fogliargento",
            "KOR": "은빛잎사귀",
            "CHS": "银色叶子",
            "CHT": "銀色葉子"
        }
    ],
    "Polished Mud Ball": [
        {
            "NO": 872,
            "EN": "Polished Mud Ball",
            "JP": "ピカピカだんご",
            "FR": "Boulette de Boue",
            "DE": "Glanzkugel",
            "ES": "Bola de Arcilla",
            "IT": "Pallina di fango",
            "KOR": "반짝반짝경단",
            "CHS": "光滑泥球",
            "CHT": "光滑泥球"
        }
    ],
    "Tropical Shell": [
        {
            "NO": 873,
            "EN": "Tropical Shell",
            "JP": "なんごくかいがら",
            "FR": "Coquille du Sud",
            "DE": "Tropenmuschel",
            "ES": "Concha Tropical",
            "IT": "Tropiconchiglia",
            "KOR": "트로피컬조개껍질",
            "CHS": "南国贝壳",
            "CHT": "南國貝殼"
        }
    ],
    "Leaf Letter": [
        {
            "NO": 874,
            "EN": "Leaf Letter",
            "JP": "このはのおてがみ",
            "FR": "Lettre Végétale",
            "DE": "Blattbrief",
            "ES": "Hoja Escrita",
            "IT": "Foglialettera",
            "KOR": "나뭇잎편지",
            "CHS": "树叶信",
            "CHT": "樹葉信"
        },
        {
            "NO": 875,
            "EN": "Leaf Letter",
            "JP": "このはのおてがみ",
            "FR": "Lettre Végétale",
            "DE": "Blattbrief",
            "ES": "Hoja Escrita",
            "IT": "Foglialettera",
            "KOR": "나뭇잎편지",
            "CHS": "树叶信",
            "CHT": "樹葉信"
        }
    ],
    "Small Bouquet": [
        {
            "NO": 876,
            "EN": "Small Bouquet",
            "JP": "ちいさなはなたば",
            "FR": "Petit Bouquet",
            "DE": "Ministrauß",
            "ES": "Ramo Pequeño",
            "IT": "Bouquet",
            "KOR": "작은꽃다발",
            "CHS": "小小花束",
            "CHT": "小小花束"
        }
    ],
    "Lure": [
        {
            "NO": 877,
            "EN": "Lure",
            "JP": "むしよせコロン",
            "FR": "Parfum",
            "DE": "Lockparfüm",
            "ES": "Colonia",
            "IT": "Profumo invito",
            "KOR": "벌레유인코롱",
            "CHS": "引虫香水",
            "CHT": "引蟲香水"
        }
    ],
    "Super Lure": [
        {
            "NO": 878,
            "EN": "Super Lure",
            "JP": "シルバーコロン",
            "FR": "Super Parfum",
            "DE": "Super-Lockparfüm",
            "ES": "Supercolonia",
            "IT": "Superprofumo",
            "KOR": "실버코롱",
            "CHS": "白银香水",
            "CHT": "白銀香水"
        }
    ],
    "Max Lure": [
        {
            "NO": 879,
            "EN": "Max Lure",
            "JP": "ゴールドコロン",
            "FR": "Parfum Max",
            "DE": "Top-Lockparfüm",
            "ES": "Colonia Máxima",
            "IT": "Profumo max",
            "KOR": "골드코롱",
            "CHS": "黄金香水",
            "CHT": "黃金香水"
        }
    ],
    "Pewter Crunchies": [
        {
            "NO": 880,
            "EN": "Pewter Crunchies",
            "JP": "ニビあられ",
            "FR": "Crok’Argenta",
            "DE": "Marmoria-Kräcker",
            "ES": "Rokikos",
            "IT": "Plumbeosalatini",
            "KOR": "회색강정",
            "CHS": "深灰米果",
            "CHT": "深灰米果"
        }
    ],
    "Fighting Memory": [
        {
            "NO": 881,
            "EN": "Fighting Memory",
            "JP": "ファイトメモリ",
            "FR": "ROM Combat",
            "DE": "Kampf-Disc",
            "ES": "Disco Lucha",
            "IT": "ROM Lotta",
            "KOR": "파이팅메모리",
            "CHS": "战斗存储碟",
            "CHT": "戰鬥記憶碟"
        }
    ],
    "Flying Memory": [
        {
            "NO": 882,
            "EN": "Flying Memory",
            "JP": "フライングメモリ",
            "FR": "ROM Vol",
            "DE": "Flug-Disc",
            "ES": "Disco Volador",
            "IT": "ROM Volante",
            "KOR": "플라잉메모리",
            "CHS": "飞翔存储碟",
            "CHT": "飛翔記憶碟"
        }
    ],
    "Poison Memory": [
        {
            "NO": 883,
            "EN": "Poison Memory",
            "JP": "ポイズンメモリ",
            "FR": "ROM Poison",
            "DE": "Gift-Disc",
            "ES": "Disco Veneno",
            "IT": "ROM Veleno",
            "KOR": "포이즌메모리",
            "CHS": "毒存储碟",
            "CHT": "毒記憶碟"
        }
    ],
    "Ground Memory": [
        {
            "NO": 884,
            "EN": "Ground Memory",
            "JP": "グラウンドメモリ",
            "FR": "ROM Sol",
            "DE": "Boden-Disc",
            "ES": "Disco Tierra",
            "IT": "ROM Terra",
            "KOR": "그라운드메모리",
            "CHS": "大地存储碟",
            "CHT": "大地記憶碟"
        }
    ],
    "Rock Memory": [
        {
            "NO": 885,
            "EN": "Rock Memory",
            "JP": "ロックメモリ",
            "FR": "ROM Roche",
            "DE": "Gesteins-Disc",
            "ES": "Disco Roca",
            "IT": "ROM Roccia",
            "KOR": "록메모리",
            "CHS": "岩石存储碟",
            "CHT": "岩石記憶碟"
        }
    ],
    "Bug Memory": [
        {
            "NO": 886,
            "EN": "Bug Memory",
            "JP": "バグメモリ",
            "FR": "ROM Insecte",
            "DE": "Käfer-Disc",
            "ES": "Disco Bicho",
            "IT": "ROM Coleottero",
            "KOR": "버그메모리",
            "CHS": "虫子存储碟",
            "CHT": "蟲子記憶碟"
        }
    ],
    "Ghost Memory": [
        {
            "NO": 887,
            "EN": "Ghost Memory",
            "JP": "ゴーストメモリ",
            "FR": "ROM Spectre",
            "DE": "Geister-Disc",
            "ES": "Disco Fantasma",
            "IT": "ROM Spettro",
            "KOR": "고스트메모리",
            "CHS": "幽灵存储碟",
            "CHT": "幽靈記憶碟"
        }
    ],
    "Steel Memory": [
        {
            "NO": 888,
            "EN": "Steel Memory",
            "JP": "スチールメモリ",
            "FR": "ROM Acier",
            "DE": "Stahl-Disc",
            "ES": "Disco Acero",
            "IT": "ROM Acciaio",
            "KOR": "스틸메모리",
            "CHS": "钢铁存储碟",
            "CHT": "鋼鐵記憶碟"
        }
    ],
    "Fire Memory": [
        {
            "NO": 889,
            "EN": "Fire Memory",
            "JP": "ファイヤーメモリ",
            "FR": "ROM Feu",
            "DE": "Feuer-Disc",
            "ES": "Disco Fuego",
            "IT": "ROM Fuoco",
            "KOR": "파이어메모리",
            "CHS": "火焰存储碟",
            "CHT": "火焰記憶碟"
        }
    ],
    "Water Memory": [
        {
            "NO": 890,
            "EN": "Water Memory",
            "JP": "ウオーターメモリ",
            "FR": "ROM Eau",
            "DE": "Wasser-Disc",
            "ES": "Disco Agua",
            "IT": "ROM Acqua",
            "KOR": "워터메모리",
            "CHS": "清水存储碟",
            "CHT": "清水記憶碟"
        }
    ],
    "Grass Memory": [
        {
            "NO": 891,
            "EN": "Grass Memory",
            "JP": "グラスメモリ",
            "FR": "ROM Plante",
            "DE": "Pflanzen-Disc",
            "ES": "Disco Planta",
            "IT": "ROM Erba",
            "KOR": "그래스메모리",
            "CHS": "青草存储碟",
            "CHT": "青草記憶碟"
        }
    ],
    "Electric Memory": [
        {
            "NO": 892,
            "EN": "Electric Memory",
            "JP": "エレクトロメモリ",
            "FR": "ROM Électrik",
            "DE": "Elektro-Disc",
            "ES": "Disco Eléctrico",
            "IT": "ROM Elettro",
            "KOR": "일렉트릭메모리",
            "CHS": "电子存储碟",
            "CHT": "電子記憶碟"
        }
    ],
    "Psychic Memory": [
        {
            "NO": 893,
            "EN": "Psychic Memory",
            "JP": "サイキックメモリ",
            "FR": "ROM Psy",
            "DE": "Psycho-Disc",
            "ES": "Disco Psíquico",
            "IT": "ROM Psico",
            "KOR": "사이킥메모리",
            "CHS": "精神存储碟",
            "CHT": "精神記憶碟"
        }
    ],
    "Ice Memory": [
        {
            "NO": 894,
            "EN": "Ice Memory",
            "JP": "アイスメモリ",
            "FR": "ROM Glace",
            "DE": "Eis-Disc",
            "ES": "Disco Hielo",
            "IT": "ROM Ghiaccio",
            "KOR": "아이스메모리",
            "CHS": "冰雪存储碟",
            "CHT": "冰雪記憶碟"
        }
    ],
    "Dragon Memory": [
        {
            "NO": 895,
            "EN": "Dragon Memory",
            "JP": "ドラゴンメモリ",
            "FR": "ROM Dragon",
            "DE": "Drachen-Disc",
            "ES": "Disco Dragón",
            "IT": "ROM Drago",
            "KOR": "드래곤메모리",
            "CHS": "龙存储碟",
            "CHT": "龍記憶碟"
        }
    ],
    "Dark Memory": [
        {
            "NO": 896,
            "EN": "Dark Memory",
            "JP": "ダークメモリ",
            "FR": "ROM Ténèbres",
            "DE": "Unlicht-Disc",
            "ES": "Disco Siniestro",
            "IT": "ROM Buio",
            "KOR": "다크메모리",
            "CHS": "黑暗存储碟",
            "CHT": "黑暗記憶碟"
        }
    ],
    "Fairy Memory": [
        {
            "NO": 897,
            "EN": "Fairy Memory",
            "JP": "フェアリーメモリ",
            "FR": "ROM Fée",
            "DE": "Feen-Disc",
            "ES": "Disco Hada",
            "IT": "ROM Folletto",
            "KOR": "페어리메모리",
            "CHS": "妖精存储碟",
            "CHT": "妖精記憶碟"
        }
    ],
    "Solganium Z": [
        {
            "NO": 898,
            "EN": "Solganium Z",
            "JP": "ソルガレオＺ",
            "FR": "Solgazélite",
            "DE": "Solgalium Z",
            "ES": "Solgaleostal Z",
            "IT": "Solgaleium Z",
            "KOR": "솔가레오Z",
            "CHS": "索尔迦雷欧Ｚ",
            "CHT": "索爾迦雷歐Ｚ"
        },
        {
            "NO": 904,
            "EN": "Solganium Z",
            "JP": "ソルガレオＺ",
            "FR": "Solgazélite",
            "DE": "Solgalium Z",
            "ES": "Solgaleostal Z",
            "IT": "Solgaleium Z",
            "KOR": "솔가레오Z",
            "CHS": "索尔迦雷欧Ｚ",
            "CHT": "索爾迦雷歐Ｚ"
        }
    ],
    "Lunalium Z": [
        {
            "NO": 899,
            "EN": "Lunalium Z",
            "JP": "ルナアーラＺ",
            "FR": "Lunazélite",
            "DE": "Lunalium Z",
            "ES": "Lunalastal Z",
            "IT": "Lunalium Z",
            "KOR": "루나아라Z",
            "CHS": "露奈雅拉Ｚ",
            "CHT": "露奈雅拉Ｚ"
        },
        {
            "NO": 905,
            "EN": "Lunalium Z",
            "JP": "ルナアーラＺ",
            "FR": "Lunazélite",
            "DE": "Lunalium Z",
            "ES": "Lunalastal Z",
            "IT": "Lunalium Z",
            "KOR": "루나아라Z",
            "CHS": "露奈雅拉Ｚ",
            "CHT": "露奈雅拉Ｚ"
        }
    ],
    "Ultranecrozium Z": [
        {
            "NO": 900,
            "EN": "Ultranecrozium Z",
            "JP": "ウルトラネクロＺ",
            "FR": "Ultranécrozélite",
            "DE": "Ultranecronium Z",
            "ES": "Ultranecrostal Z",
            "IT": "Ultranecrozium Z",
            "KOR": "울트라네크로Z",
            "CHS": "究极奈克洛Ｚ",
            "CHT": "究極奈克洛Ｚ"
        },
        {
            "NO": 906,
            "EN": "Ultranecrozium Z",
            "JP": "ウルトラネクロＺ",
            "FR": "Ultranécrozélite",
            "DE": "Ultranecronium Z",
            "ES": "Ultranecrostal Z",
            "IT": "Ultranecrozium Z",
            "KOR": "울트라네크로Z",
            "CHS": "究极奈克洛Ｚ",
            "CHT": "究極奈克洛Ｚ"
        }
    ],
    "Mimikium Z": [
        {
            "NO": 901,
            "EN": "Mimikium Z",
            "JP": "ミミッキュＺ",
            "FR": "Mimiquizélite",
            "DE": "Mimigmium Z",
            "ES": "Mimikyustal Z",
            "IT": "Mimikyum Z",
            "KOR": "따라큐Z",
            "CHS": "谜拟ＱＺ",
            "CHT": "謎擬ＱＺ"
        },
        {
            "NO": 907,
            "EN": "Mimikium Z",
            "JP": "ミミッキュＺ",
            "FR": "Mimiquizélite",
            "DE": "Mimigmium Z",
            "ES": "Mimikyustal Z",
            "IT": "Mimikyum Z",
            "KOR": "따라큐Z",
            "CHS": "谜拟ＱＺ",
            "CHT": "謎擬ＱＺ"
        }
    ],
    "Lycanium Z": [
        {
            "NO": 902,
            "EN": "Lycanium Z",
            "JP": "ルガルガンＺ",
            "FR": "Lougarozélite",
            "DE": "Wolwerockium Z",
            "ES": "Lycanrostal Z",
            "IT": "Lycanrochium Z",
            "KOR": "루가루암Z",
            "CHS": "鬃岩狼人Ｚ",
            "CHT": "鬃岩狼人Ｚ"
        },
        {
            "NO": 908,
            "EN": "Lycanium Z",
            "JP": "ルガルガンＺ",
            "FR": "Lougarozélite",
            "DE": "Wolwerockium Z",
            "ES": "Lycanrostal Z",
            "IT": "Lycanrochium Z",
            "KOR": "루가루암Z",
            "CHS": "鬃岩狼人Ｚ",
            "CHT": "鬃岩狼人Ｚ"
        }
    ],
    "Kommonium Z": [
        {
            "NO": 903,
            "EN": "Kommonium Z",
            "JP": "ジャラランガＺ",
            "FR": "Ékaïzélite",
            "DE": "Grandirasium Z",
            "ES": "Kommostal Z",
            "IT": "Kommonium Z",
            "KOR": "짜랑고우거Z",
            "CHS": "杖尾鳞甲龙Ｚ",
            "CHT": "杖尾鱗甲龍Ｚ"
        },
        {
            "NO": 909,
            "EN": "Kommonium Z",
            "JP": "ジャラランガＺ",
            "FR": "Ékaïzélite",
            "DE": "Grandirasium Z",
            "ES": "Kommostal Z",
            "IT": "Kommonium Z",
            "KOR": "짜랑고우거Z",
            "CHS": "杖尾鳞甲龙Ｚ",
            "CHT": "杖尾鱗甲龍Ｚ"
        }
    ],
    "Z-Power Ring": [
        {
            "NO": 910,
            "EN": "Z-Power Ring",
            "JP": "Ｚパワーリング",
            "FR": "Super Bracelet Z",
            "DE": "Z-Kraftring",
            "ES": "Superpulsera Z",
            "IT": "Supercerchio Z",
            "KOR": "Z파워링",
            "CHS": "Ｚ强力手环",
            "CHT": "Ｚ強力手環"
        }
    ],
    "Pink Petal": [
        {
            "NO": 911,
            "EN": "Pink Petal",
            "JP": "ももいろはなびら",
            "FR": "Pétale Rose",
            "DE": "Rosa Blatt",
            "ES": "Pétalo Rosa",
            "IT": "Petalo rosa",
            "KOR": "담홍꽃잎",
            "CHS": "粉红花瓣",
            "CHT": "粉紅花瓣"
        }
    ],
    "Orange Petal": [
        {
            "NO": 912,
            "EN": "Orange Petal",
            "JP": "だいだいはなびら",
            "FR": "Pétale Orange",
            "DE": "Oranges Blatt",
            "ES": "Pétalo Naranja",
            "IT": "Petalo arancione",
            "KOR": "주황꽃잎",
            "CHS": "橙色花瓣",
            "CHT": "橙色花瓣"
        }
    ],
    "Blue Petal": [
        {
            "NO": 913,
            "EN": "Blue Petal",
            "JP": "あおのはなびら",
            "FR": "Pétale Bleu",
            "DE": "Blaues Blatt",
            "ES": "Pétalo Azul",
            "IT": "Petalo azzurro",
            "KOR": "파랑꽃잎",
            "CHS": "蓝色花瓣",
            "CHT": "藍色花瓣"
        }
    ],
    "Red Petal": [
        {
            "NO": 914,
            "EN": "Red Petal",
            "JP": "あかのはなびら",
            "FR": "Pétale Rouge",
            "DE": "Rotes Blatt",
            "ES": "Pétalo Rojo",
            "IT": "Petalo rosso",
            "KOR": "빨강꽃잎",
            "CHS": "红色花瓣",
            "CHT": "紅色花瓣"
        }
    ],
    "Green Petal": [
        {
            "NO": 915,
            "EN": "Green Petal",
            "JP": "みどりのはなびら",
            "FR": "Pétale Vert",
            "DE": "Grünes Blatt",
            "ES": "Pétalo Verde",
            "IT": "Petalo verde",
            "KOR": "초록꽃잎",
            "CHS": "绿色花瓣",
            "CHT": "綠色花瓣"
        }
    ],
    "Yellow Petal": [
        {
            "NO": 916,
            "EN": "Yellow Petal",
            "JP": "きいろのはなびら",
            "FR": "Pétale Jaune",
            "DE": "Gelbes Blatt",
            "ES": "Pétalo Amarillo",
            "IT": "Petalo giallo",
            "KOR": "노랑꽃잎",
            "CHS": "黄色花瓣",
            "CHT": "黃色花瓣"
        }
    ],
    "Purple Petal": [
        {
            "NO": 917,
            "EN": "Purple Petal",
            "JP": "むらさきはなびら",
            "FR": "Pétale Violet",
            "DE": "Violettes Blatt",
            "ES": "Pétalo Violeta",
            "IT": "Petalo violetto",
            "KOR": "보라꽃잎",
            "CHS": "紫色花瓣",
            "CHT": "紫色花瓣"
        }
    ],
    "Rainbow Flower": [
        {
            "NO": 918,
            "EN": "Rainbow Flower",
            "JP": "にじいろのはな",
            "FR": "Fleur 7 Couleurs",
            "DE": "Regenbogenblüte",
            "ES": "Flor Irisada",
            "IT": "Fiore arcobaleno",
            "KOR": "무지개꽃",
            "CHS": "虹色之花",
            "CHT": "虹色之花"
        }
    ],
    "Surge Badge": [
        {
            "NO": 919,
            "EN": "Surge Badge",
            "JP": "だいだいバッジ",
            "FR": "Fulguro-Badge",
            "DE": "Gewitterorden",
            "ES": "Medalla Fulgor",
            "IT": "Medaglia Tonante",
            "KOR": "주황배지",
            "CHS": "桔色徽章",
            "CHT": "橘色徽章"
        }
    ],
    "N-Solarizer": [
        {
            "NO": 920,
            "EN": "N-Solarizer",
            "JP": "ネクロプラスソル",
            "FR": "Necrosol",
            "DE": "Necrosol",
            "ES": "Necrosol",
            "IT": "Necrosolix",
            "KOR": "네크로플러스솔",
            "CHS": "奈克洛索尔合体器",
            "CHT": "奈克洛索爾合體器"
        },
        {
            "NO": 922,
            "EN": "N-Solarizer",
            "JP": "ネクロプラスソル",
            "FR": "Necrosol",
            "DE": "Necrosol",
            "ES": "Necrosol",
            "IT": "Necrosolix",
            "KOR": "네크로플러스솔",
            "CHS": "奈克洛索尔合体器",
            "CHT": "奈克洛索爾合體器"
        }
    ],
    "N-Lunarizer": [
        {
            "NO": 921,
            "EN": "N-Lunarizer",
            "JP": "ネクロプラスルナ",
            "FR": "Necroluna",
            "DE": "Necrolun",
            "ES": "Necroluna",
            "IT": "Necrolunix",
            "KOR": "네크로플러스루나",
            "CHS": "奈克洛露奈合体器",
            "CHT": "奈克洛露奈合體器"
        },
        {
            "NO": 923,
            "EN": "N-Lunarizer",
            "JP": "ネクロプラスルナ",
            "FR": "Necroluna",
            "DE": "Necrolun",
            "ES": "Necroluna",
            "IT": "Necrolunix",
            "KOR": "네크로플러스루나",
            "CHS": "奈克洛露奈合体器",
            "CHT": "奈克洛露奈合體器"
        }
    ],
    "Ilima’s Normalium Z": [
        {
            "NO": 924,
            "EN": "Ilima’s Normalium Z",
            "JP": "イリマノーマルＺ",
            "FR": "Cristal Z Althéo",
            "DE": "Elimas Normium Z",
            "ES": "Cristal Z (Liam)",
            "IT": "Normium Z Liam",
            "KOR": "일리마의 노말Z",
            "CHS": "伊利马一般Ｚ",
            "CHT": "伊利馬一般Ｚ"
        }
    ],
    "Left Poké Ball": [
        {
            "NO": 925,
            "EN": "Left Poké Ball",
            "JP": "のこされたボール",
            "FR": "Poké Ball donnée",
            "DE": "Nachlassball",
            "ES": "Poké Ball Ajena",
            "IT": "Poké Ball altrui",
            "KOR": "남겨진 볼",
            "CHS": "留下的精灵球",
            "CHT": "留下的精靈球"
        }
    ],
    "Roto Hatch": [
        {
            "NO": 926,
            "EN": "Roto Hatch",
            "JP": "タマゴふかポン",
            "FR": "Moti-Couveuse",
            "DE": "Brutbon",
            "ES": "Cupón Eclosión",
            "IT": "Cova’n’roll",
            "KOR": "알부화캡슐토이",
            "CHS": "孵蛋碰碰",
            "CHT": "孵蛋碰碰"
        }
    ],
    "Roto Bargain": [
        {
            "NO": 927,
            "EN": "Roto Bargain",
            "JP": "やすうりポン",
            "FR": "Moti-Promo",
            "DE": "Schnäppchenbon",
            "ES": "Cupón Rebaja",
            "IT": "Sconto’n’roll",
            "KOR": "할인캡슐토이",
            "CHS": "优惠碰碰",
            "CHT": "優惠碰碰"
        }
    ],
    "Roto Prize Money": [
        {
            "NO": 928,
            "EN": "Roto Prize Money",
            "JP": "おこづかいポン",
            "FR": "Moti-Magot",
            "DE": "Preisgeldbon",
            "ES": "Cupón Botín",
            "IT": "Soldi’n’roll",
            "KOR": "용돈캡슐토이",
            "CHS": "零花钱碰碰",
            "CHT": "零用錢碰碰"
        }
    ],
    "Roto Exp. Points": [
        {
            "NO": 929,
            "EN": "Roto Exp. Points",
            "JP": "けいけんポン",
            "FR": "Moti-Exp",
            "DE": "EP-Bon",
            "ES": "Cupón Exp",
            "IT": "Esp’n’roll",
            "KOR": "경험캡슐토이",
            "CHS": "经验碰碰",
            "CHT": "經驗碰碰"
        }
    ],
    "Roto Friendship": [
        {
            "NO": 930,
            "EN": "Roto Friendship",
            "JP": "なつきポン",
            "FR": "Moti-Cœur",
            "DE": "Freundschaftsbon",
            "ES": "Cupón Amistad",
            "IT": "Affetto’n’roll",
            "KOR": "친밀도캡슐토이",
            "CHS": "亲密碰碰",
            "CHT": "親密碰碰"
        }
    ],
    "Roto Encounter": [
        {
            "NO": 931,
            "EN": "Roto Encounter",
            "JP": "みっけポン",
            "FR": "Moti-Appât",
            "DE": "Lockbon",
            "ES": "Cupón Reclamo",
            "IT": "Incontra’n’roll",
            "KOR": "발견캡슐토이",
            "CHS": "相遇碰碰",
            "CHT": "相遇碰碰"
        }
    ],
    "Roto Stealth": [
        {
            "NO": 932,
            "EN": "Roto Stealth",
            "JP": "かくれポン",
            "FR": "Moti-Camouflage",
            "DE": "Schutzbon",
            "ES": "Cupón Sigilo",
            "IT": "Repelle’n’roll",
            "KOR": "숨기캡슐토이",
            "CHS": "隐身碰碰",
            "CHT": "隱身碰碰"
        }
    ],
    "Roto HP Restore": [
        {
            "NO": 933,
            "EN": "Roto HP Restore",
            "JP": "ＨＰかいふくポン",
            "FR": "Moti-Récup’ PV",
            "DE": "KP-Bon",
            "ES": "Cupón PS",
            "IT": "PS’n’roll",
            "KOR": "HP회복캡슐토이",
            "CHS": "ＨＰ回复碰碰",
            "CHT": "ＨＰ回復碰碰"
        }
    ],
    "Roto PP Restore": [
        {
            "NO": 934,
            "EN": "Roto PP Restore",
            "JP": "ＰＰかいふくポン",
            "FR": "Moti-Récup’ PP",
            "DE": "AP-Bon",
            "ES": "Cupón PP",
            "IT": "PP’n’roll",
            "KOR": "PP회복캡슐토이",
            "CHS": "ＰＰ回复碰碰",
            "CHT": "ＰＰ回復碰碰"
        }
    ],
    "Roto Boost": [
        {
            "NO": 935,
            "EN": "Roto Boost",
            "JP": "おうえんポン",
            "FR": "Moti-Soutien",
            "DE": "Statuswertebon",
            "ES": "Cupón Refuerzo",
            "IT": "Stat’n’roll",
            "KOR": "응원캡슐토이",
            "CHS": "加油碰碰",
            "CHT": "加油碰碰"
        }
    ],
    "Roto Catch": [
        {
            "NO": 936,
            "EN": "Roto Catch",
            "JP": "つかまえポン",
            "FR": "Moti-Capture",
            "DE": "Fangbon",
            "ES": "Cupón Captura",
            "IT": "Acchiappa’n’roll",
            "KOR": "잡기캡슐토이",
            "CHS": "捕捉碰碰",
            "CHT": "捕捉碰碰"
        }
    ],
    "Health Candy": [
        {
            "NO": 937,
            "EN": "Health Candy",
            "JP": "げんきのアメ",
            "FR": "Bonbon Santé S",
            "DE": "Energiebonbon",
            "ES": "Caramelo Vigor",
            "IT": "Caramella vitalità S",
            "KOR": "기력의사탕",
            "CHS": "元气糖果",
            "CHT": "元氣糖果"
        }
    ],
    "Mighty Candy": [
        {
            "NO": 938,
            "EN": "Mighty Candy",
            "JP": "ちからのアメ",
            "FR": "Bonbon Force S",
            "DE": "Stärkebonbon",
            "ES": "Caramelo Músculo",
            "IT": "Caramella potenza S",
            "KOR": "힘의사탕",
            "CHS": "力量糖果",
            "CHT": "力量糖果"
        }
    ],
    "Tough Candy": [
        {
            "NO": 939,
            "EN": "Tough Candy",
            "JP": "まもりのアメ",
            "FR": "Bonbon Armure S",
            "DE": "Robustbonbon",
            "ES": "Caramelo Aguante",
            "IT": "Caramella protezione S",
            "KOR": "수비의사탕",
            "CHS": "守护糖果",
            "CHT": "守護糖果"
        }
    ],
    "Smart Candy": [
        {
            "NO": 940,
            "EN": "Smart Candy",
            "JP": "ちしきのアメ",
            "FR": "Bonbon Esprit S",
            "DE": "Gripsbonbon",
            "ES": "Caramelo Intelecto",
            "IT": "Caramella acume S",
            "KOR": "지식의사탕",
            "CHS": "知识糖果",
            "CHT": "知識糖果"
        }
    ],
    "Courage Candy": [
        {
            "NO": 941,
            "EN": "Courage Candy",
            "JP": "こころのアメ",
            "FR": "Bonbon Mental S",
            "DE": "Mentalbonbon",
            "ES": "Caramelo Mente",
            "IT": "Caramella intuito S",
            "KOR": "마음의사탕",
            "CHS": "心灵糖果",
            "CHT": "心靈糖果"
        }
    ],
    "Quick Candy": [
        {
            "NO": 942,
            "EN": "Quick Candy",
            "JP": "はやさのアメ",
            "FR": "Bonbon Sprint S",
            "DE": "Flottbonbon",
            "ES": "Caramelo Ímpetu",
            "IT": "Caramella rapidità S",
            "KOR": "속도의사탕",
            "CHS": "敏捷糖果",
            "CHT": "敏捷糖果"
        }
    ],
    "Health Candy L": [
        {
            "NO": 943,
            "EN": "Health Candy L",
            "JP": "げんきのアメＬ",
            "FR": "Bonbon Santé M",
            "DE": "Energiebonbon+",
            "ES": "Caramelo Vigor +",
            "IT": "Caramella vitalità M",
            "KOR": "기력의사탕L",
            "CHS": "元气糖果Ｌ",
            "CHT": "元氣糖果Ｌ"
        }
    ],
    "Mighty Candy L": [
        {
            "NO": 944,
            "EN": "Mighty Candy L",
            "JP": "ちからのアメＬ",
            "FR": "Bonbon Force M",
            "DE": "Stärkebonbon+",
            "ES": "Caramelo Músculo +",
            "IT": "Caramella potenza M",
            "KOR": "힘의사탕L",
            "CHS": "力量糖果Ｌ",
            "CHT": "力量糖果Ｌ"
        }
    ],
    "Tough Candy L": [
        {
            "NO": 945,
            "EN": "Tough Candy L",
            "JP": "まもりのアメＬ",
            "FR": "Bonbon Armure M",
            "DE": "Robustbonbon+",
            "ES": "Caramelo Aguante +",
            "IT": "Caramella protezione M",
            "KOR": "수비의사탕L",
            "CHS": "守护糖果Ｌ",
            "CHT": "守護糖果Ｌ"
        }
    ],
    "Smart Candy L": [
        {
            "NO": 946,
            "EN": "Smart Candy L",
            "JP": "ちしきのアメＬ",
            "FR": "Bonbon Esprit M",
            "DE": "Gripsbonbon+",
            "ES": "Caramelo Intelecto +",
            "IT": "Caramella acume M",
            "KOR": "지식의사탕L",
            "CHS": "知识糖果Ｌ",
            "CHT": "知識糖果Ｌ"
        }
    ],
    "Courage Candy L": [
        {
            "NO": 947,
            "EN": "Courage Candy L",
            "JP": "こころのアメＬ",
            "FR": "Bonbon Mental M",
            "DE": "Mentalbonbon+",
            "ES": "Caramelo Mente +",
            "IT": "Caramella intuito M",
            "KOR": "마음의사탕L",
            "CHS": "心灵糖果Ｌ",
            "CHT": "心靈糖果Ｌ"
        }
    ],
    "Quick Candy L": [
        {
            "NO": 948,
            "EN": "Quick Candy L",
            "JP": "はやさのアメＬ",
            "FR": "Bonbon Sprint M",
            "DE": "Flottbonbon+",
            "ES": "Caramelo Ímpetu +",
            "IT": "Caramella rapidità M",
            "KOR": "속도의사탕L",
            "CHS": "敏捷糖果Ｌ",
            "CHT": "敏捷糖果Ｌ"
        }
    ],
    "Health Candy XL": [
        {
            "NO": 949,
            "EN": "Health Candy XL",
            "JP": "げんきのアメＸＬ",
            "FR": "Bonbon Santé L",
            "DE": "Energiebonbon++",
            "ES": "Caramelo Vigor ++",
            "IT": "Caramella vitalità L",
            "KOR": "기력의사탕XL",
            "CHS": "元气糖果ＸＬ",
            "CHT": "元氣糖果ＸＬ"
        }
    ],
    "Mighty Candy XL": [
        {
            "NO": 950,
            "EN": "Mighty Candy XL",
            "JP": "ちからのアメＸＬ",
            "FR": "Bonbon Force L",
            "DE": "Stärkebonbon++",
            "ES": "Caramelo Músculo ++",
            "IT": "Caramella potenza L",
            "KOR": "힘의사탕XL",
            "CHS": "力量糖果ＸＬ",
            "CHT": "力量糖果ＸＬ"
        }
    ],
    "Tough Candy XL": [
        {
            "NO": 951,
            "EN": "Tough Candy XL",
            "JP": "まもりのアメＸＬ",
            "FR": "Bonbon Armure L",
            "DE": "Robustbonbon++",
            "ES": "Caramelo Aguante ++",
            "IT": "Caramella protezione L",
            "KOR": "수비의사탕XL",
            "CHS": "守护糖果ＸＬ",
            "CHT": "守護糖果ＸＬ"
        }
    ],
    "Smart Candy XL": [
        {
            "NO": 952,
            "EN": "Smart Candy XL",
            "JP": "ちしきのアメＸＬ",
            "FR": "Bonbon Esprit L",
            "DE": "Gripsbonbon++",
            "ES": "Caramelo Intelecto ++",
            "IT": "Caramella acume L",
            "KOR": "지식의사탕XL",
            "CHS": "知识糖果ＸＬ",
            "CHT": "知識糖果ＸＬ"
        }
    ],
    "Courage Candy XL": [
        {
            "NO": 953,
            "EN": "Courage Candy XL",
            "JP": "こころのアメＸＬ",
            "FR": "Bonbon Mental L",
            "DE": "Mentalbonbon++",
            "ES": "Caramelo Mente ++",
            "IT": "Caramella intuito L",
            "KOR": "마음의사탕XL",
            "CHS": "心灵糖果ＸＬ",
            "CHT": "心靈糖果ＸＬ"
        }
    ],
    "Quick Candy XL": [
        {
            "NO": 954,
            "EN": "Quick Candy XL",
            "JP": "はやさのアメＸＬ",
            "FR": "Bonbon Sprint L",
            "DE": "Flottbonbon++",
            "ES": "Caramelo Ímpetu ++",
            "IT": "Caramella rapidità L",
            "KOR": "속도의사탕XL",
            "CHS": "敏捷糖果ＸＬ",
            "CHT": "敏捷糖果ＸＬ"
        }
    ],
    "Bulbasaur Candy": [
        {
            "NO": 955,
            "EN": "Bulbasaur Candy",
            "JP": "フシギダネのアメ",
            "FR": "Bonbon Bulbizarre",
            "DE": "Bisasam-Bonbon",
            "ES": "Caramelo Bulbasaur",
            "IT": "Caramella Bulbasaur",
            "KOR": "이상해씨의사탕",
            "CHS": "妙蛙种子的糖果",
            "CHT": "妙蛙種子的糖果"
        }
    ],
    "Charmander Candy": [
        {
            "NO": 956,
            "EN": "Charmander Candy",
            "JP": "ヒトカゲのアメ",
            "FR": "Bonbon Salamèche",
            "DE": "Glumanda-Bonbon",
            "ES": "Caramelo Charmander",
            "IT": "Caramella Charmander",
            "KOR": "파이리의사탕",
            "CHS": "小火龙的糖果",
            "CHT": "小火龍的糖果"
        }
    ],
    "Squirtle Candy": [
        {
            "NO": 957,
            "EN": "Squirtle Candy",
            "JP": "ゼニガメのアメ",
            "FR": "Bonbon Carapuce",
            "DE": "Schiggy-Bonbon",
            "ES": "Caramelo Squirtle",
            "IT": "Caramella Squirtle",
            "KOR": "꼬부기의사탕",
            "CHS": "杰尼龟的糖果",
            "CHT": "傑尼龜的糖果"
        }
    ],
    "Caterpie Candy": [
        {
            "NO": 958,
            "EN": "Caterpie Candy",
            "JP": "キャタピーのアメ",
            "FR": "Bonbon Chenipan",
            "DE": "Raupy-Bonbon",
            "ES": "Caramelo Caterpie",
            "IT": "Caramella Caterpie",
            "KOR": "캐터피의사탕",
            "CHS": "绿毛虫的糖果",
            "CHT": "綠毛蟲的糖果"
        }
    ],
    "Weedle Candy": [
        {
            "NO": 959,
            "EN": "Weedle Candy",
            "JP": "ビードルのアメ",
            "FR": "Bonbon Aspicot",
            "DE": "Hornliu-Bonbon",
            "ES": "Caramelo Weedle",
            "IT": "Caramella Weedle",
            "KOR": "뿔충이의사탕",
            "CHS": "独角虫的糖果",
            "CHT": "獨角蟲的糖果"
        }
    ],
    "Pidgey Candy": [
        {
            "NO": 960,
            "EN": "Pidgey Candy",
            "JP": "ポッポのアメ",
            "FR": "Bonbon Roucool",
            "DE": "Taubsi-Bonbon",
            "ES": "Caramelo Pidgey",
            "IT": "Caramella Pidgey",
            "KOR": "구구의사탕",
            "CHS": "波波的糖果",
            "CHT": "波波的糖果"
        }
    ],
    "Rattata Candy": [
        {
            "NO": 961,
            "EN": "Rattata Candy",
            "JP": "コラッタのアメ",
            "FR": "Bonbon Rattata",
            "DE": "Rattfratz-Bonbon",
            "ES": "Caramelo Rattata",
            "IT": "Caramella Rattata",
            "KOR": "꼬렛의사탕",
            "CHS": "小拉达的糖果",
            "CHT": "小拉達的糖果"
        }
    ],
    "Spearow Candy": [
        {
            "NO": 962,
            "EN": "Spearow Candy",
            "JP": "オニスズメのアメ",
            "FR": "Bonbon Piafabec",
            "DE": "Habitak-Bonbon",
            "ES": "Caramelo Spearow",
            "IT": "Caramella Spearow",
            "KOR": "깨비참의사탕",
            "CHS": "烈雀的糖果",
            "CHT": "烈雀的糖果"
        }
    ],
    "Ekans Candy": [
        {
            "NO": 963,
            "EN": "Ekans Candy",
            "JP": "アーボのアメ",
            "FR": "Bonbon Abo",
            "DE": "Rettan-Bonbon",
            "ES": "Caramelo Ekans",
            "IT": "Caramella Ekans",
            "KOR": "아보의사탕",
            "CHS": "阿柏蛇的糖果",
            "CHT": "阿柏蛇的糖果"
        }
    ],
    "Pikachu Candy": [
        {
            "NO": 964,
            "EN": "Pikachu Candy",
            "JP": "ピカチュウのアメ",
            "FR": "Bonbon Pikachu",
            "DE": "Pikachu-Bonbon",
            "ES": "Caramelo Pikachu",
            "IT": "Caramella Pikachu",
            "KOR": "피카츄의사탕",
            "CHS": "皮卡丘的糖果",
            "CHT": "皮卡丘的糖果"
        }
    ],
    "Sandshrew Candy": [
        {
            "NO": 965,
            "EN": "Sandshrew Candy",
            "JP": "サンドのアメ",
            "FR": "Bonbon Sabelette",
            "DE": "Sandan-Bonbon",
            "ES": "Caramelo Sandshrew",
            "IT": "Caramella Sandshrew",
            "KOR": "모래두지의사탕",
            "CHS": "穿山鼠的糖果",
            "CHT": "穿山鼠的糖果"
        }
    ],
    "Nidoran♀ Candy": [
        {
            "NO": 966,
            "EN": "Nidoran♀ Candy",
            "JP": "ニドラン♀のアメ",
            "FR": "Bonbon Nidoran♀",
            "DE": "Nidoran♀-Bonbon",
            "ES": "Caramelo Nidoran♀",
            "IT": "Caramella Nidoran♀",
            "KOR": "니드런♀의사탕",
            "CHS": "尼多兰的糖果",
            "CHT": "尼多蘭的糖果"
        }
    ],
    "Nidoran♂ Candy": [
        {
            "NO": 967,
            "EN": "Nidoran♂ Candy",
            "JP": "ニドラン♂のアメ",
            "FR": "Bonbon Nidoran♂",
            "DE": "Nidoran♂-Bonbon",
            "ES": "Caramelo Nidoran♂",
            "IT": "Caramella Nidoran♂",
            "KOR": "니드런♂의사탕",
            "CHS": "尼多朗的糖果",
            "CHT": "尼多朗的糖果"
        }
    ],
    "Clefairy Candy": [
        {
            "NO": 968,
            "EN": "Clefairy Candy",
            "JP": "ピッピのアメ",
            "FR": "Bonbon Mélofée",
            "DE": "Piepi-Bonbon",
            "ES": "Caramelo Clefairy",
            "IT": "Caramella Clefairy",
            "KOR": "삐삐의사탕",
            "CHS": "皮皮的糖果",
            "CHT": "皮皮的糖果"
        }
    ],
    "Vulpix Candy": [
        {
            "NO": 969,
            "EN": "Vulpix Candy",
            "JP": "ロコンのアメ",
            "FR": "Bonbon Goupix",
            "DE": "Vulpix-Bonbon",
            "ES": "Caramelo Vulpix",
            "IT": "Caramella Vulpix",
            "KOR": "식스테일의사탕",
            "CHS": "六尾的糖果",
            "CHT": "六尾的糖果"
        }
    ],
    "Jigglypuff Candy": [
        {
            "NO": 970,
            "EN": "Jigglypuff Candy",
            "JP": "プリンのアメ",
            "FR": "Bonbon Rondoudou",
            "DE": "Pummeluff-Bonbon",
            "ES": "Caramelo Jigglypuff",
            "IT": "Caramella Jigglypuff",
            "KOR": "푸린의사탕",
            "CHS": "胖丁的糖果",
            "CHT": "胖丁的糖果"
        }
    ],
    "Zubat Candy": [
        {
            "NO": 971,
            "EN": "Zubat Candy",
            "JP": "ズバットのアメ",
            "FR": "Bonbon Nosferapti",
            "DE": "Zubat-Bonbon",
            "ES": "Caramelo Zubat",
            "IT": "Caramella Zubat",
            "KOR": "주뱃의사탕",
            "CHS": "超音蝠的糖果",
            "CHT": "超音蝠的糖果"
        }
    ],
    "Oddish Candy": [
        {
            "NO": 972,
            "EN": "Oddish Candy",
            "JP": "ナゾノクサのアメ",
            "FR": "Bonbon Mystherbe",
            "DE": "Myrapla-Bonbon",
            "ES": "Caramelo Oddish",
            "IT": "Caramella Oddish",
            "KOR": "뚜벅쵸의사탕",
            "CHS": "走路草的糖果",
            "CHT": "走路草的糖果"
        }
    ],
    "Paras Candy": [
        {
            "NO": 973,
            "EN": "Paras Candy",
            "JP": "パラスのアメ",
            "FR": "Bonbon Paras",
            "DE": "Paras-Bonbon",
            "ES": "Caramelo Paras",
            "IT": "Caramella Paras",
            "KOR": "파라스의사탕",
            "CHS": "派拉斯的糖果",
            "CHT": "派拉斯的糖果"
        }
    ],
    "Venonat Candy": [
        {
            "NO": 974,
            "EN": "Venonat Candy",
            "JP": "コンパンのアメ",
            "FR": "Bonbon Mimitoss",
            "DE": "Bluzuk-Bonbon",
            "ES": "Caramelo Venonat",
            "IT": "Caramella Venonat",
            "KOR": "콘팡의사탕",
            "CHS": "毛球的糖果",
            "CHT": "毛球的糖果"
        }
    ],
    "Diglett Candy": [
        {
            "NO": 975,
            "EN": "Diglett Candy",
            "JP": "ディグダのアメ",
            "FR": "Bonbon Taupiqueur",
            "DE": "Digda-Bonbon",
            "ES": "Caramelo Diglett",
            "IT": "Caramella Diglett",
            "KOR": "디그다의사탕",
            "CHS": "地鼠的糖果",
            "CHT": "地鼠的糖果"
        }
    ],
    "Meowth Candy": [
        {
            "NO": 976,
            "EN": "Meowth Candy",
            "JP": "ニャースのアメ",
            "FR": "Bonbon Miaouss",
            "DE": "Mauzi-Bonbon",
            "ES": "Caramelo Meowth",
            "IT": "Caramella Meowth",
            "KOR": "나옹의사탕",
            "CHS": "喵喵的糖果",
            "CHT": "喵喵的糖果"
        }
    ],
    "Psyduck Candy": [
        {
            "NO": 977,
            "EN": "Psyduck Candy",
            "JP": "コダックのアメ",
            "FR": "Bonbon Psykokwak",
            "DE": "Enton-Bonbon",
            "ES": "Caramelo Psyduck",
            "IT": "Caramella Psyduck",
            "KOR": "고라파덕의사탕",
            "CHS": "可达鸭的糖果",
            "CHT": "可達鴨的糖果"
        }
    ],
    "Mankey Candy": [
        {
            "NO": 978,
            "EN": "Mankey Candy",
            "JP": "マンキーのアメ",
            "FR": "Bonbon Férosinge",
            "DE": "Menki-Bonbon",
            "ES": "Caramelo Mankey",
            "IT": "Caramella Mankey",
            "KOR": "망키의사탕",
            "CHS": "猴怪的糖果",
            "CHT": "猴怪的糖果"
        }
    ],
    "Growlithe Candy": [
        {
            "NO": 979,
            "EN": "Growlithe Candy",
            "JP": "ガーディのアメ",
            "FR": "Bonbon Caninos",
            "DE": "Fukano-Bonbon",
            "ES": "Caramelo Growlithe",
            "IT": "Caramella Growlithe",
            "KOR": "가디의사탕",
            "CHS": "卡蒂狗的糖果",
            "CHT": "卡蒂狗的糖果"
        }
    ],
    "Poliwag Candy": [
        {
            "NO": 980,
            "EN": "Poliwag Candy",
            "JP": "ニョロモのアメ",
            "FR": "Bonbon Ptitard",
            "DE": "Quapsel-Bonbon",
            "ES": "Caramelo Poliwag",
            "IT": "Caramella Poliwag",
            "KOR": "발챙이의사탕",
            "CHS": "蚊香蝌蚪的糖果",
            "CHT": "蚊香蝌蚪的糖果"
        }
    ],
    "Abra Candy": [
        {
            "NO": 981,
            "EN": "Abra Candy",
            "JP": "ケーシィのアメ",
            "FR": "Bonbon Abra",
            "DE": "Abra-Bonbon",
            "ES": "Caramelo Abra",
            "IT": "Caramella Abra",
            "KOR": "캐이시의사탕",
            "CHS": "凯西的糖果",
            "CHT": "凱西的糖果"
        }
    ],
    "Machop Candy": [
        {
            "NO": 982,
            "EN": "Machop Candy",
            "JP": "ワンリキーのアメ",
            "FR": "Bonbon Machoc",
            "DE": "Machollo-Bonbon",
            "ES": "Caramelo Machop",
            "IT": "Caramella Machop",
            "KOR": "알통몬의사탕",
            "CHS": "腕力的糖果",
            "CHT": "腕力的糖果"
        }
    ],
    "Bellsprout Candy": [
        {
            "NO": 983,
            "EN": "Bellsprout Candy",
            "JP": "マダツボミのアメ",
            "FR": "Bonbon Chétiflor",
            "DE": "Knofensa-Bonbon",
            "ES": "Caramelo Bellsprout",
            "IT": "Caramella Bellsprout",
            "KOR": "모다피의사탕",
            "CHS": "喇叭芽的糖果",
            "CHT": "喇叭芽的糖果"
        }
    ],
    "Tentacool Candy": [
        {
            "NO": 984,
            "EN": "Tentacool Candy",
            "JP": "メノクラゲのアメ",
            "FR": "Bonbon Tentacool",
            "DE": "Tentacha-Bonbon",
            "ES": "Caramelo Tentacool",
            "IT": "Caramella Tentacool",
            "KOR": "왕눈해의사탕",
            "CHS": "玛瑙水母的糖果",
            "CHT": "瑪瑙水母的糖果"
        }
    ],
    "Geodude Candy": [
        {
            "NO": 985,
            "EN": "Geodude Candy",
            "JP": "イシツブテのアメ",
            "FR": "Bonbon Racaillou",
            "DE": "Kleinstein-Bonbon",
            "ES": "Caramelo Geodude",
            "IT": "Caramella Geodude",
            "KOR": "꼬마돌의사탕",
            "CHS": "小拳石的糖果",
            "CHT": "小拳石的糖果"
        }
    ],
    "Ponyta Candy": [
        {
            "NO": 986,
            "EN": "Ponyta Candy",
            "JP": "ポニータのアメ",
            "FR": "Bonbon Ponyta",
            "DE": "Ponita-Bonbon",
            "ES": "Caramelo Ponyta",
            "IT": "Caramella Ponyta",
            "KOR": "포니타의사탕",
            "CHS": "小火马的糖果",
            "CHT": "小火馬的糖果"
        }
    ],
    "Slowpoke Candy": [
        {
            "NO": 987,
            "EN": "Slowpoke Candy",
            "JP": "ヤドンのアメ",
            "FR": "Bonbon Ramoloss",
            "DE": "Flegmon-Bonbon",
            "ES": "Caramelo Slowpoke",
            "IT": "Caramella Slowpoke",
            "KOR": "야돈의사탕",
            "CHS": "呆呆兽的糖果",
            "CHT": "呆呆獸的糖果"
        }
    ],
    "Magnemite Candy": [
        {
            "NO": 988,
            "EN": "Magnemite Candy",
            "JP": "コイルのアメ",
            "FR": "Bonbon Magnéti",
            "DE": "Magnetilo-Bonbon",
            "ES": "Caramelo Magnemite",
            "IT": "Caramella Magnemite",
            "KOR": "코일의사탕",
            "CHS": "小磁怪的糖果",
            "CHT": "小磁怪的糖果"
        }
    ],
    "Farfetch’d Candy": [
        {
            "NO": 989,
            "EN": "Farfetch’d Candy",
            "JP": "カモネギのアメ",
            "FR": "Bonbon Canarticho",
            "DE": "Porenta-Bonbon",
            "ES": "Caramelo Farfetch’d",
            "IT": "Caramella Farfetch’d",
            "KOR": "파오리의사탕",
            "CHS": "大葱鸭的糖果",
            "CHT": "大蔥鴨的糖果"
        }
    ],
    "Doduo Candy": [
        {
            "NO": 990,
            "EN": "Doduo Candy",
            "JP": "ドードーのアメ",
            "FR": "Bonbon Doduo",
            "DE": "Dodu-Bonbon",
            "ES": "Caramelo Doduo",
            "IT": "Caramella Doduo",
            "KOR": "두두의사탕",
            "CHS": "嘟嘟的糖果",
            "CHT": "嘟嘟的糖果"
        }
    ],
    "Seel Candy": [
        {
            "NO": 991,
            "EN": "Seel Candy",
            "JP": "パウワウのアメ",
            "FR": "Bonbon Otaria",
            "DE": "Jurob-Bonbon",
            "ES": "Caramelo Seel",
            "IT": "Caramella Seel",
            "KOR": "쥬쥬의사탕",
            "CHS": "小海狮的糖果",
            "CHT": "小海獅的糖果"
        }
    ],
    "Grimer Candy": [
        {
            "NO": 992,
            "EN": "Grimer Candy",
            "JP": "ベトベターのアメ",
            "FR": "Bonbon Tadmorv",
            "DE": "Sleima-Bonbon",
            "ES": "Caramelo Grimer",
            "IT": "Caramella Grimer",
            "KOR": "질퍽이의사탕",
            "CHS": "臭泥的糖果",
            "CHT": "臭泥的糖果"
        }
    ],
    "Shellder Candy": [
        {
            "NO": 993,
            "EN": "Shellder Candy",
            "JP": "シェルダーのアメ",
            "FR": "Bonbon Kokiyas",
            "DE": "Muschas-Bonbon",
            "ES": "Caramelo Shellder",
            "IT": "Caramella Shellder",
            "KOR": "셀러의사탕",
            "CHS": "大舌贝的糖果",
            "CHT": "大舌貝的糖果"
        }
    ],
    "Gastly Candy": [
        {
            "NO": 994,
            "EN": "Gastly Candy",
            "JP": "ゴースのアメ",
            "FR": "Bonbon Fantominus",
            "DE": "Nebulak-Bonbon",
            "ES": "Caramelo Gastly",
            "IT": "Caramella Gastly",
            "KOR": "고오스의사탕",
            "CHS": "鬼斯的糖果",
            "CHT": "鬼斯的糖果"
        }
    ],
    "Onix Candy": [
        {
            "NO": 995,
            "EN": "Onix Candy",
            "JP": "イワークのアメ",
            "FR": "Bonbon Onix",
            "DE": "Onix-Bonbon",
            "ES": "Caramelo Onix",
            "IT": "Caramella Onix",
            "KOR": "롱스톤의사탕",
            "CHS": "大岩蛇的糖果",
            "CHT": "大岩蛇的糖果"
        }
    ],
    "Drowzee Candy": [
        {
            "NO": 996,
            "EN": "Drowzee Candy",
            "JP": "スリープのアメ",
            "FR": "Bonbon Soporifik",
            "DE": "Traumato-Bonbon",
            "ES": "Caramelo Drowzee",
            "IT": "Caramella Drowzee",
            "KOR": "슬리프의사탕",
            "CHS": "催眠貘的糖果",
            "CHT": "催眠貘的糖果"
        }
    ],
    "Krabby Candy": [
        {
            "NO": 997,
            "EN": "Krabby Candy",
            "JP": "クラブのアメ",
            "FR": "Bonbon Krabby",
            "DE": "Krabby-Bonbon",
            "ES": "Caramelo Krabby",
            "IT": "Caramella Krabby",
            "KOR": "크랩의사탕",
            "CHS": "大钳蟹的糖果",
            "CHT": "大鉗蟹的糖果"
        }
    ],
    "Voltorb Candy": [
        {
            "NO": 998,
            "EN": "Voltorb Candy",
            "JP": "ビリリダマのアメ",
            "FR": "Bonbon Voltorbe",
            "DE": "Voltobal-Bonbon",
            "ES": "Caramelo Voltorb",
            "IT": "Caramella Voltorb",
            "KOR": "찌리리공의사탕",
            "CHS": "霹雳电球的糖果",
            "CHT": "霹靂電球的糖果"
        }
    ],
    "Exeggcute Candy": [
        {
            "NO": 999,
            "EN": "Exeggcute Candy",
            "JP": "タマタマのアメ",
            "FR": "Bonbon Noeunoeuf",
            "DE": "Owei-Bonbon",
            "ES": "Caramelo Exeggcute",
            "IT": "Caramella Exeggcute",
            "KOR": "아라리의사탕",
            "CHS": "蛋蛋的糖果",
            "CHT": "蛋蛋的糖果"
        }
    ],
    "Cubone Candy": [
        {
            "NO": 1000,
            "EN": "Cubone Candy",
            "JP": "カラカラのアメ",
            "FR": "Bonbon Osselait",
            "DE": "Tragosso-Bonbon",
            "ES": "Caramelo Cubone",
            "IT": "Caramella Cubone",
            "KOR": "탕구리의사탕",
            "CHS": "卡拉卡拉的糖果",
            "CHT": "卡拉卡拉的糖果"
        }
    ],
    "Hitmonlee Candy": [
        {
            "NO": 1001,
            "EN": "Hitmonlee Candy",
            "JP": "サワムラーのアメ",
            "FR": "Bonbon Kicklee",
            "DE": "Kicklee-Bonbon",
            "ES": "Caramelo Hitmonlee",
            "IT": "Caramella Hitmonlee",
            "KOR": "시라소몬의사탕",
            "CHS": "飞腿郎的糖果",
            "CHT": "飛腿郎的糖果"
        }
    ],
    "Hitmonchan Candy": [
        {
            "NO": 1002,
            "EN": "Hitmonchan Candy",
            "JP": "エビワラーのアメ",
            "FR": "Bonbon Tygnon",
            "DE": "Nockchan-Bonbon",
            "ES": "Caramelo Hitmonchan",
            "IT": "Caramella Hitmonchan",
            "KOR": "홍수몬의사탕",
            "CHS": "快拳郎的糖果",
            "CHT": "快拳郎的糖果"
        }
    ],
    "Lickitung Candy": [
        {
            "NO": 1003,
            "EN": "Lickitung Candy",
            "JP": "ベロリンガのアメ",
            "FR": "Bonbon Excelangue",
            "DE": "Schlurp-Bonbon",
            "ES": "Caramelo Lickitung",
            "IT": "Caramella Lickitung",
            "KOR": "내루미의사탕",
            "CHS": "大舌头的糖果",
            "CHT": "大舌頭的糖果"
        }
    ],
    "Koffing Candy": [
        {
            "NO": 1004,
            "EN": "Koffing Candy",
            "JP": "ドガースのアメ",
            "FR": "Bonbon Smogo",
            "DE": "Smogon-Bonbon",
            "ES": "Caramelo Koffing",
            "IT": "Caramella Koffing",
            "KOR": "또가스의사탕",
            "CHS": "瓦斯弹的糖果",
            "CHT": "瓦斯彈的糖果"
        }
    ],
    "Rhyhorn Candy": [
        {
            "NO": 1005,
            "EN": "Rhyhorn Candy",
            "JP": "サイホーンのアメ",
            "FR": "Bonbon Rhinocorne",
            "DE": "Rihorn-Bonbon",
            "ES": "Caramelo Rhyhorn",
            "IT": "Caramella Rhyhorn",
            "KOR": "뿔카노의사탕",
            "CHS": "独角犀牛的糖果",
            "CHT": "獨角犀牛的糖果"
        }
    ],
    "Chansey Candy": [
        {
            "NO": 1006,
            "EN": "Chansey Candy",
            "JP": "ラッキーのアメ",
            "FR": "Bonbon Leveinard",
            "DE": "Chaneira-Bonbon",
            "ES": "Caramelo Chansey",
            "IT": "Caramella Chansey",
            "KOR": "럭키의사탕",
            "CHS": "吉利蛋的糖果",
            "CHT": "吉利蛋的糖果"
        }
    ],
    "Tangela Candy": [
        {
            "NO": 1007,
            "EN": "Tangela Candy",
            "JP": "モンジャラのアメ",
            "FR": "Bonbon Saquedeneu",
            "DE": "Tangela-Bonbon",
            "ES": "Caramelo Tangela",
            "IT": "Caramella Tangela",
            "KOR": "덩쿠리의사탕",
            "CHS": "蔓藤怪的糖果",
            "CHT": "蔓藤怪的糖果"
        }
    ],
    "Kangaskhan Candy": [
        {
            "NO": 1008,
            "EN": "Kangaskhan Candy",
            "JP": "ガルーラのアメ",
            "FR": "Bonbon Kangourex",
            "DE": "Kangama-Bonbon",
            "ES": "Caramelo Kangaskhan",
            "IT": "Caramella Kangaskhan",
            "KOR": "캥카의사탕",
            "CHS": "袋兽的糖果",
            "CHT": "袋獸的糖果"
        }
    ],
    "Horsea Candy": [
        {
            "NO": 1009,
            "EN": "Horsea Candy",
            "JP": "タッツーのアメ",
            "FR": "Bonbon Hypotrempe",
            "DE": "Seeper-Bonbon",
            "ES": "Caramelo Horsea",
            "IT": "Caramella Horsea",
            "KOR": "쏘드라의사탕",
            "CHS": "墨海马的糖果",
            "CHT": "墨海馬的糖果"
        }
    ],
    "Goldeen Candy": [
        {
            "NO": 1010,
            "EN": "Goldeen Candy",
            "JP": "トサキントのアメ",
            "FR": "Bonbon Poissirène",
            "DE": "Goldini-Bonbon",
            "ES": "Caramelo Goldeen",
            "IT": "Caramella Goldeen",
            "KOR": "콘치의사탕",
            "CHS": "角金鱼的糖果",
            "CHT": "角金魚的糖果"
        }
    ],
    "Staryu Candy": [
        {
            "NO": 1011,
            "EN": "Staryu Candy",
            "JP": "ヒトデマンのアメ",
            "FR": "Bonbon Stari",
            "DE": "Sterndu-Bonbon",
            "ES": "Caramelo Staryu",
            "IT": "Caramella Staryu",
            "KOR": "별가사리의사탕",
            "CHS": "海星星的糖果",
            "CHT": "海星星的糖果"
        }
    ],
    "Mr. Mime Candy": [
        {
            "NO": 1012,
            "EN": "Mr. Mime Candy",
            "JP": "バリヤードのアメ",
            "FR": "Bonbon M. Mime",
            "DE": "Pantimos-Bonbon",
            "ES": "Caramelo Mr. Mime",
            "IT": "Caramella Mr. Mime",
            "KOR": "마임맨의사탕",
            "CHS": "魔墙人偶的糖果",
            "CHT": "魔牆人偶的糖果"
        }
    ],
    "Scyther Candy": [
        {
            "NO": 1013,
            "EN": "Scyther Candy",
            "JP": "ストライクのアメ",
            "FR": "Bonbon Insécateur",
            "DE": "Sichlor-Bonbon",
            "ES": "Caramelo Scyther",
            "IT": "Caramella Scyther",
            "KOR": "스라크의사탕",
            "CHS": "飞天螳螂的糖果",
            "CHT": "飛天螳螂的糖果"
        }
    ],
    "Jynx Candy": [
        {
            "NO": 1014,
            "EN": "Jynx Candy",
            "JP": "ルージュラのアメ",
            "FR": "Bonbon Lippoutou",
            "DE": "Rossana-Bonbon",
            "ES": "Caramelo Jynx",
            "IT": "Caramella Jynx",
            "KOR": "루주라의사탕",
            "CHS": "迷唇姐的糖果",
            "CHT": "迷唇姐的糖果"
        }
    ],
    "Electabuzz Candy": [
        {
            "NO": 1015,
            "EN": "Electabuzz Candy",
            "JP": "エレブーのアメ",
            "FR": "Bonbon Élektek",
            "DE": "Elektek-Bonbon",
            "ES": "Caramelo Electabuzz",
            "IT": "Caramella Electabuzz",
            "KOR": "에레브의사탕",
            "CHS": "电击兽的糖果",
            "CHT": "電擊獸的糖果"
        }
    ],
    "Pinsir Candy": [
        {
            "NO": 1016,
            "EN": "Pinsir Candy",
            "JP": "カイロスのアメ",
            "FR": "Bonbon Scarabrute",
            "DE": "Pinsir-Bonbon",
            "ES": "Caramelo Pinsir",
            "IT": "Caramella Pinsir",
            "KOR": "쁘사이저의사탕",
            "CHS": "凯罗斯的糖果",
            "CHT": "凱羅斯的糖果"
        }
    ],
    "Tauros Candy": [
        {
            "NO": 1017,
            "EN": "Tauros Candy",
            "JP": "ケンタロスのアメ",
            "FR": "Bonbon Tauros",
            "DE": "Tauros-Bonbon",
            "ES": "Caramelo Tauros",
            "IT": "Caramella Tauros",
            "KOR": "켄타로스의사탕",
            "CHS": "肯泰罗的糖果",
            "CHT": "肯泰羅的糖果"
        }
    ],
    "Magikarp Candy": [
        {
            "NO": 1018,
            "EN": "Magikarp Candy",
            "JP": "コイキングのアメ",
            "FR": "Bonbon Magicarpe",
            "DE": "Karpador-Bonbon",
            "ES": "Caramelo Magikarp",
            "IT": "Caramella Magikarp",
            "KOR": "잉어킹의사탕",
            "CHS": "鲤鱼王的糖果",
            "CHT": "鯉魚王的糖果"
        }
    ],
    "Lapras Candy": [
        {
            "NO": 1019,
            "EN": "Lapras Candy",
            "JP": "ラプラスのアメ",
            "FR": "Bonbon Lokhlass",
            "DE": "Lapras-Bonbon",
            "ES": "Caramelo Lapras",
            "IT": "Caramella Lapras",
            "KOR": "라프라스의사탕",
            "CHS": "拉普拉斯的糖果",
            "CHT": "拉普拉斯的糖果"
        }
    ],
    "Ditto Candy": [
        {
            "NO": 1020,
            "EN": "Ditto Candy",
            "JP": "メタモンのアメ",
            "FR": "Bonbon Métamorph",
            "DE": "Ditto-Bonbon",
            "ES": "Caramelo Ditto",
            "IT": "Caramella Ditto",
            "KOR": "메타몽의사탕",
            "CHS": "百变怪的糖果",
            "CHT": "百變怪的糖果"
        }
    ],
    "Eevee Candy": [
        {
            "NO": 1021,
            "EN": "Eevee Candy",
            "JP": "イーブイのアメ",
            "FR": "Bonbon Évoli",
            "DE": "Evoli-Bonbon",
            "ES": "Caramelo Eevee",
            "IT": "Caramella Eevee",
            "KOR": "이브이의사탕",
            "CHS": "伊布的糖果",
            "CHT": "伊布的糖果"
        }
    ],
    "Porygon Candy": [
        {
            "NO": 1022,
            "EN": "Porygon Candy",
            "JP": "ポリゴンのアメ",
            "FR": "Bonbon Porygon",
            "DE": "Porygon-Bonbon",
            "ES": "Caramelo Porygon",
            "IT": "Caramella Porygon",
            "KOR": "폴리곤의사탕",
            "CHS": "多边兽的糖果",
            "CHT": "多邊獸的糖果"
        }
    ],
    "Omanyte Candy": [
        {
            "NO": 1023,
            "EN": "Omanyte Candy",
            "JP": "オムナイトのアメ",
            "FR": "Bonbon Amonita",
            "DE": "Amonitas-Bonbon",
            "ES": "Caramelo Omanyte",
            "IT": "Caramella Omanyte",
            "KOR": "암나이트의사탕",
            "CHS": "菊石兽的糖果",
            "CHT": "菊石獸的糖果"
        }
    ],
    "Kabuto Candy": [
        {
            "NO": 1024,
            "EN": "Kabuto Candy",
            "JP": "カブトのアメ",
            "FR": "Bonbon Kabuto",
            "DE": "Kabuto-Bonbon",
            "ES": "Caramelo Kabuto",
            "IT": "Caramella Kabuto",
            "KOR": "투구의사탕",
            "CHS": "化石盔的糖果",
            "CHT": "化石盔的糖果"
        }
    ],
    "Aerodactyl Candy": [
        {
            "NO": 1025,
            "EN": "Aerodactyl Candy",
            "JP": "プテラのアメ",
            "FR": "Bonbon Ptéra",
            "DE": "Aerodactyl-Bonbon",
            "ES": "Caramelo Aerodactyl",
            "IT": "Caramella Aerodactyl",
            "KOR": "프테라의사탕",
            "CHS": "化石翼龙的糖果",
            "CHT": "化石翼龍的糖果"
        }
    ],
    "Snorlax Candy": [
        {
            "NO": 1026,
            "EN": "Snorlax Candy",
            "JP": "カビゴンのアメ",
            "FR": "Bonbon Ronflex",
            "DE": "Relaxo-Bonbon",
            "ES": "Caramelo Snorlax",
            "IT": "Caramella Snorlax",
            "KOR": "잠만보의사탕",
            "CHS": "卡比兽的糖果",
            "CHT": "卡比獸的糖果"
        }
    ],
    "Articuno Candy": [
        {
            "NO": 1027,
            "EN": "Articuno Candy",
            "JP": "フリーザーのアメ",
            "FR": "Bonbon Artikodin",
            "DE": "Arktos-Bonbon",
            "ES": "Caramelo Articuno",
            "IT": "Caramella Articuno",
            "KOR": "프리져의사탕",
            "CHS": "急冻鸟的糖果",
            "CHT": "急凍鳥的糖果"
        }
    ],
    "Zapdos Candy": [
        {
            "NO": 1028,
            "EN": "Zapdos Candy",
            "JP": "サンダーのアメ",
            "FR": "Bonbon Électhor",
            "DE": "Zapdos-Bonbon",
            "ES": "Caramelo Zapdos",
            "IT": "Caramella Zapdos",
            "KOR": "썬더의사탕",
            "CHS": "闪电鸟的糖果",
            "CHT": "閃電鳥的糖果"
        }
    ],
    "Moltres Candy": [
        {
            "NO": 1029,
            "EN": "Moltres Candy",
            "JP": "ファイヤーのアメ",
            "FR": "Bonbon Sulfura",
            "DE": "Lavados-Bonbon",
            "ES": "Caramelo Moltres",
            "IT": "Caramella Moltres",
            "KOR": "파이어의사탕",
            "CHS": "火焰鸟的糖果",
            "CHT": "火焰鳥的糖果"
        }
    ],
    "Dratini Candy": [
        {
            "NO": 1030,
            "EN": "Dratini Candy",
            "JP": "ミニリュウのアメ",
            "FR": "Bonbon Minidraco",
            "DE": "Dratini-Bonbon",
            "ES": "Caramelo Dratini",
            "IT": "Caramella Dratini",
            "KOR": "미뇽의사탕",
            "CHS": "迷你龙的糖果",
            "CHT": "迷你龍的糖果"
        }
    ],
    "Mewtwo Candy": [
        {
            "NO": 1031,
            "EN": "Mewtwo Candy",
            "JP": "ミュウツーのアメ",
            "FR": "Bonbon Mewtwo",
            "DE": "Mewtu-Bonbon",
            "ES": "Caramelo Mewtwo",
            "IT": "Caramella Mewtwo",
            "KOR": "뮤츠의사탕",
            "CHS": "超梦的糖果",
            "CHT": "超夢的糖果"
        }
    ],
    "Mew Candy": [
        {
            "NO": 1032,
            "EN": "Mew Candy",
            "JP": "ミュウのアメ",
            "FR": "Bonbon Mew",
            "DE": "Mew-Bonbon",
            "ES": "Caramelo Mew",
            "IT": "Caramella Mew",
            "KOR": "뮤의사탕",
            "CHS": "梦幻的糖果",
            "CHT": "夢幻的糖果"
        }
    ],
    "Meltan Candy": [
        {
            "NO": 1033,
            "EN": "Meltan Candy",
            "JP": "メルタンのアメ",
            "FR": "Bonbon Meltan",
            "DE": "Meltan-Bonbon",
            "ES": "Caramelo Meltan",
            "IT": "Caramella Meltan",
            "KOR": "멜탄의사탕",
            "CHS": "美录坦的糖果",
            "CHT": "美錄坦的糖果"
        }
    ],
    "Magmar Candy": [
        {
            "NO": 1034,
            "EN": "Magmar Candy",
            "JP": "ブーバーのアメ",
            "FR": "Bonbon Magmar",
            "DE": "Magmar-Bonbon",
            "ES": "Caramelo Magmar",
            "IT": "Caramella Magmar",
            "KOR": "마그마의사탕",
            "CHS": "鸭嘴火兽的糖果",
            "CHT": "鴨嘴火獸的糖果"
        }
    ],
    "Endorsement": [
        {
            "NO": 1035,
            "EN": "Endorsement",
            "JP": "すいせんじょう",
            "FR": "Recommandation",
            "DE": "Empfehlungsbrief",
            "ES": "Recomendación",
            "IT": "Referenze",
            "KOR": "추천장",
            "CHS": "推荐函",
            "CHT": "推薦函"
        }
    ],
    "Wishing Star": [
        {
            "NO": 1037,
            "EN": "Wishing Star",
            "JP": "ねがいぼし",
            "FR": "Étoile Vœu",
            "DE": "Wunschstern",
            "ES": "Estrella Deseo",
            "IT": "Desiostella",
            "KOR": "소원의별",
            "CHS": "许愿星",
            "CHT": "許願星"
        }
    ],
    "Dynamax Band": [
        {
            "NO": 1038,
            "EN": "Dynamax Band",
            "JP": "ダイマックスＢ",
            "FR": "Poignet Dynamax",
            "DE": "Dynamax-Band",
            "ES": "Maximuñequera",
            "IT": "Polsino Dynamax",
            "KOR": "다이맥스 밴드",
            "CHS": "极巨腕带",
            "CHT": "極巨腕帶"
        }
    ],
    "Rotom Bike": [
        {
            "NO": 1040,
            "EN": "Rotom Bike",
            "JP": "ロトムじてんしゃ",
            "FR": "Moticyclette",
            "DE": "Rotom-Rad",
            "ES": "Bici Rotom",
            "IT": "Bici Rotom",
            "KOR": "로토무자전거",
            "CHS": "洛托姆自行车",
            "CHT": "洛托姆自行車"
        },
        {
            "NO": 1221,
            "EN": "Rotom Bike",
            "JP": "ロトムじてんしゃ",
            "FR": "Moticyclette",
            "DE": "Rotom-Rad",
            "ES": "Bici Rotom",
            "IT": "Bici Rotom",
            "KOR": "로토무자전거",
            "CHS": "洛托姆自行车",
            "CHT": "洛托姆自行車"
        },
        {
            "NO": 1533,
            "EN": "Rotom Bike",
            "JP": "ロトムじてんしゃ",
            "FR": "Moticyclette",
            "DE": "Rotom-Rad",
            "ES": "Bici Rotom",
            "IT": "Bici Rotom",
            "KOR": "로토무자전거",
            "CHS": "洛托姆自行车",
            "CHT": "洛托姆自行車"
        },
        {
            "NO": 1534,
            "EN": "Rotom Bike",
            "JP": "ロトムじてんしゃ",
            "FR": "Moticyclette",
            "DE": "Rotom-Rad",
            "ES": "Bici Rotom",
            "IT": "Bici Rotom",
            "KOR": "로토무자전거",
            "CHS": "洛托姆自行车",
            "CHT": "洛托姆自行車"
        }
    ],
    "Sausages": [
        {
            "NO": 1041,
            "EN": "Sausages",
            "JP": "あらびきヴルスト",
            "FR": "Saucisses",
            "DE": "Würstchen",
            "ES": "Salchichas",
            "IT": "Salsicce",
            "KOR": "탱글탱글부어스트",
            "CHS": "粗绞肉香肠",
            "CHT": "粗絞肉香腸"
        }
    ],
    "Bob’s Food Tin": [
        {
            "NO": 1042,
            "EN": "Bob’s Food Tin",
            "JP": "ボブのかんづめ",
            "FR": "Conserve de Bob",
            "DE": "Pauls Feinkost",
            "ES": "Lata de Darren",
            "IT": "Lattina Gustavo",
            "KOR": "밥의통조림",
            "CHS": "饱伯罐头",
            "CHT": "飽伯罐頭"
        }
    ],
    "Bach’s Food Tin": [
        {
            "NO": 1043,
            "EN": "Bach’s Food Tin",
            "JP": "バックのかんづめ",
            "FR": "Conserve de Bach",
            "DE": "Bachs Feinkost",
            "ES": "Lata de Bach",
            "IT": "Scatoletta Bach",
            "KOR": "바크의통조림",
            "CHS": "巴哈罐头",
            "CHT": "巴哈罐頭"
        }
    ],
    "Tin of Beans": [
        {
            "NO": 1044,
            "EN": "Tin of Beans",
            "JP": "マメかん",
            "FR": "Haricots",
            "DE": "Dosenbohnen",
            "ES": "Lata de Habas",
            "IT": "Lattina fagioli",
            "KOR": "콩통조림",
            "CHS": "豆子罐头",
            "CHT": "豆子罐頭"
        }
    ],
    "Bread": [
        {
            "NO": 1045,
            "EN": "Bread",
            "JP": "しょくパン",
            "FR": "Pain de Mie",
            "DE": "Toastbrot",
            "ES": "Pan de Molde",
            "IT": "Pan carré",
            "KOR": "식빵",
            "CHS": "吐司面包",
            "CHT": "吐司麵包"
        }
    ],
    "Pasta": [
        {
            "NO": 1046,
            "EN": "Pasta",
            "JP": "パスタ",
            "FR": "Pâtes",
            "DE": "Spaghetti",
            "ES": "Pasta",
            "IT": "Pasta",
            "KOR": "파스타",
            "CHS": "通心粉",
            "CHT": "通心麵"
        }
    ],
    "Mixed Mushrooms": [
        {
            "NO": 1047,
            "EN": "Mixed Mushrooms",
            "JP": "キノコパック",
            "FR": "Champignons",
            "DE": "Pilzmix",
            "ES": "Setas",
            "IT": "Funghi",
            "KOR": "버섯팩",
            "CHS": "袋装蕈菇",
            "CHT": "袋裝蕈菇"
        }
    ],
    "Smoke-Poke Tail": [
        {
            "NO": 1048,
            "EN": "Smoke-Poke Tail",
            "JP": "しっぽのくんせい",
            "FR": "Queue Fumée",
            "DE": "Röstrute",
            "ES": "Cola Ahumada",
            "IT": "Coda affumicata",
            "KOR": "꼬리훈제",
            "CHS": "烟熏尾巴",
            "CHT": "煙燻尾巴"
        }
    ],
    "Large Leek": [
        {
            "NO": 1049,
            "EN": "Large Leek",
            "JP": "ふといながねぎ",
            "FR": "Gros Poireau",
            "DE": "Dicker Lauch",
            "ES": "Puerro Grueso",
            "IT": "Grosso porro",
            "KOR": "굵은대파",
            "CHS": "粗枝大葱",
            "CHT": "粗枝大蔥"
        }
    ],
    "Fancy Apple": [
        {
            "NO": 1050,
            "EN": "Fancy Apple",
            "JP": "とくせんリンゴ",
            "FR": "Pomme Juteuse",
            "DE": "Luxusapfel",
            "ES": "Manzana Selecta",
            "IT": "Mela prelibata",
            "KOR": "특선사과",
            "CHS": "特选苹果",
            "CHT": "特選蘋果"
        }
    ],
    "Brittle Bones": [
        {
            "NO": 1051,
            "EN": "Brittle Bones",
            "JP": "かぼそいホネ",
            "FR": "Os à Moelle",
            "DE": "Feine Knochen",
            "ES": "Huesos Finos",
            "IT": "Ossi sottili",
            "KOR": "가느다란뼈",
            "CHS": "细骨",
            "CHT": "細骨"
        }
    ],
    "Pack of Potatoes": [
        {
            "NO": 1052,
            "EN": "Pack of Potatoes",
            "JP": "ポテトパック",
            "FR": "Pommes de Terre",
            "DE": "Kartoffeln",
            "ES": "Patatas",
            "IT": "Patate",
            "KOR": "포테이토팩",
            "CHS": "袋装土豆",
            "CHT": "袋裝洋芋"
        }
    ],
    "Pungent Root": [
        {
            "NO": 1053,
            "EN": "Pungent Root",
            "JP": "みずべのハーブ",
            "FR": "Tubercule",
            "DE": "Uferkraut",
            "ES": "Hierba Intensa",
            "IT": "Erbe acquatiche",
            "KOR": "물가허브팩",
            "CHS": "水边香草",
            "CHT": "水邊香草"
        }
    ],
    "Salad Mix": [
        {
            "NO": 1054,
            "EN": "Salad Mix",
            "JP": "やさいパック",
            "FR": "Légumes",
            "DE": "Gemüse",
            "ES": "Verduras",
            "IT": "Verdure",
            "KOR": "채소팩",
            "CHS": "袋装蔬菜",
            "CHT": "袋裝蔬菜"
        }
    ],
    "Fried Food": [
        {
            "NO": 1055,
            "EN": "Fried Food",
            "JP": "フライもりあわせ",
            "FR": "Fritures",
            "DE": "Frittiertes",
            "ES": "Frituras",
            "IT": "Fritto misto",
            "KOR": "모둠튀김",
            "CHS": "炸物拼盘",
            "CHT": "炸物拼盤"
        }
    ],
    "Boiled Egg": [
        {
            "NO": 1056,
            "EN": "Boiled Egg",
            "JP": "ゆでタマゴ",
            "FR": "Œuf Dur",
            "DE": "Gekochtes Ei",
            "ES": "Huevo Duro",
            "IT": "Uovo sodo",
            "KOR": "삶은알",
            "CHS": "水煮蛋",
            "CHT": "水煮蛋"
        }
    ],
    "Camping Gear": [
        {
            "NO": 1057,
            "EN": "Camping Gear",
            "JP": "キャンプセット",
            "FR": "Kit de Camping",
            "DE": "Camping-Set",
            "ES": "Kit de Acampada",
            "IT": "Kit da campeggio",
            "KOR": "캠프세트",
            "CHS": "露营组合",
            "CHT": "露營組合"
        }
    ],
    "Rusted Sword": [
        {
            "NO": 1058,
            "EN": "Rusted Sword",
            "JP": "くちたけん",
            "FR": "Épée Rouillée",
            "DE": "Rostiges Schwert",
            "ES": "Espada Oxidada",
            "IT": "Spada rovinata",
            "KOR": "녹슨검",
            "CHS": "腐朽的剑",
            "CHT": "腐朽的劍"
        }
    ],
    "Rusted Shield": [
        {
            "NO": 1059,
            "EN": "Rusted Shield",
            "JP": "くちたたて",
            "FR": "Bouclier Rouillé",
            "DE": "Rostiger Schild",
            "ES": "Escudo Oxidado",
            "IT": "Scudo rovinato",
            "KOR": "녹슨방패",
            "CHS": "腐朽的盾",
            "CHT": "腐朽的盾"
        }
    ],
    "Fossilized Bird": [
        {
            "NO": 1060,
            "EN": "Fossilized Bird",
            "JP": "カセキのトリ",
            "FR": "Fossile Oiseau",
            "DE": "Vogelfossil",
            "ES": "Ornitofósil",
            "IT": "Ornitofossile",
            "KOR": "화석새",
            "CHS": "化石鸟",
            "CHT": "化石鳥"
        }
    ],
    "Fossilized Fish": [
        {
            "NO": 1061,
            "EN": "Fossilized Fish",
            "JP": "カセキのサカナ",
            "FR": "Fossile Poisson",
            "DE": "Fischfossil",
            "ES": "Ictiofósil",
            "IT": "Ittiofossile",
            "KOR": "화석물고기",
            "CHS": "化石鱼",
            "CHT": "化石魚"
        }
    ],
    "Fossilized Drake": [
        {
            "NO": 1062,
            "EN": "Fossilized Drake",
            "JP": "カセキのリュウ",
            "FR": "Fossile Dragon",
            "DE": "Drachenfossil",
            "ES": "Dracofósil",
            "IT": "Dracofossile",
            "KOR": "화석용",
            "CHS": "化石龙",
            "CHT": "化石龍"
        }
    ],
    "Fossilized Dino": [
        {
            "NO": 1063,
            "EN": "Fossilized Dino",
            "JP": "カセキのクビナガ",
            "FR": "Fossile Aileron",
            "DE": "Paddelfossil",
            "ES": "Plesiofósil",
            "IT": "Plesiofossile",
            "KOR": "화석긴목",
            "CHS": "化石海兽",
            "CHT": "化石海獸"
        }
    ],
    "Strawberry Sweet": [
        {
            "NO": 1064,
            "EN": "Strawberry Sweet",
            "JP": "いちごアメざいく",
            "FR": "Fraise en Sucre",
            "DE": "Zucker-Erdbeere",
            "ES": "Confite Fresa",
            "IT": "Bonbonfragola",
            "KOR": "딸기사탕공예",
            "CHS": "草莓糖饰",
            "CHT": "草莓糖飾"
        }
    ],
    "Love Sweet": [
        {
            "NO": 1065,
            "EN": "Love Sweet",
            "JP": "ハートアメざいく",
            "FR": "Cœur en Sucre",
            "DE": "Zucker-Herz",
            "ES": "Confite Corazón",
            "IT": "Bonboncuore",
            "KOR": "하트사탕공예",
            "CHS": "爱心糖饰",
            "CHT": "愛心糖飾"
        }
    ],
    "Berry Sweet": [
        {
            "NO": 1066,
            "EN": "Berry Sweet",
            "JP": "ベリーアメざいく",
            "FR": "Baie en Sucre",
            "DE": "Zucker-Beere",
            "ES": "Confite Fruto",
            "IT": "Bonbonbosco",
            "KOR": "베리사탕공예",
            "CHS": "野莓糖饰",
            "CHT": "野莓糖飾"
        }
    ],
    "Clover Sweet": [
        {
            "NO": 1067,
            "EN": "Clover Sweet",
            "JP": "よつばアメざいく",
            "FR": "Trèfle en Sucre",
            "DE": "Zucker-Kleeblatt",
            "ES": "Confite Trébol",
            "IT": "Bonbonfoglio",
            "KOR": "네잎사탕공예",
            "CHS": "幸运草糖饰",
            "CHT": "幸運草糖飾"
        }
    ],
    "Flower Sweet": [
        {
            "NO": 1068,
            "EN": "Flower Sweet",
            "JP": "おはなアメざいく",
            "FR": "Fleur en Sucre",
            "DE": "Zucker-Blume",
            "ES": "Confite Flor",
            "IT": "Bonbonfiore",
            "KOR": "꽃사탕공예",
            "CHS": "花朵糖饰",
            "CHT": "花朵糖飾"
        }
    ],
    "Star Sweet": [
        {
            "NO": 1069,
            "EN": "Star Sweet",
            "JP": "スターアメざいく",
            "FR": "Étoile en Sucre",
            "DE": "Zucker-Stern",
            "ES": "Confite Estrella",
            "IT": "Bonbonstella",
            "KOR": "스타사탕공예",
            "CHS": "星星糖饰",
            "CHT": "星星糖飾"
        }
    ],
    "Ribbon Sweet": [
        {
            "NO": 1070,
            "EN": "Ribbon Sweet",
            "JP": "リボンアメざいく",
            "FR": "Ruban en Sucre",
            "DE": "Zucker-Schleife",
            "ES": "Confite Lazo",
            "IT": "Bonbonfiocco",
            "KOR": "리본사탕공예",
            "CHS": "蝴蝶结糖饰",
            "CHT": "蝴蝶結糖飾"
        }
    ],
    "Sweet Apple": [
        {
            "NO": 1071,
            "EN": "Sweet Apple",
            "JP": "あまーいりんご",
            "FR": "Pomme Sucrée",
            "DE": "Süßer Apfel",
            "ES": "Manzana Dulce",
            "IT": "Dolcepomo",
            "KOR": "달콤한사과",
            "CHS": "甜甜苹果",
            "CHT": "甜甜蘋果"
        }
    ],
    "Tart Apple": [
        {
            "NO": 1072,
            "EN": "Tart Apple",
            "JP": "すっぱいりんご",
            "FR": "Pomme Acidulée",
            "DE": "Saurer Apfel",
            "ES": "Manzana Ácida",
            "IT": "Aspropomo",
            "KOR": "새콤한사과",
            "CHS": "酸酸苹果",
            "CHT": "酸酸蘋果"
        }
    ],
    "Throat Spray": [
        {
            "NO": 1073,
            "EN": "Throat Spray",
            "JP": "のどスプレー",
            "FR": "Spray Gorge",
            "DE": "Halsspray",
            "ES": "Espray Bucal",
            "IT": "Spray gola",
            "KOR": "목스프레이",
            "CHS": "爽喉喷雾",
            "CHT": "爽喉噴霧"
        }
    ],
    "Eject Pack": [
        {
            "NO": 1074,
            "EN": "Eject Pack",
            "JP": "だっしゅつパック",
            "FR": "Sac Fuite",
            "DE": "Fluchttasche",
            "ES": "Mochila Escape",
            "IT": "Zainofuga",
            "KOR": "탈출팩",
            "CHS": "避难背包",
            "CHT": "避難背包"
        }
    ],
    "Heavy-Duty Boots": [
        {
            "NO": 1075,
            "EN": "Heavy-Duty Boots",
            "JP": "あつぞこブーツ",
            "FR": "Grosses Bottes",
            "DE": "Plateauschuhe",
            "ES": "Botas Gruesas",
            "IT": "Scarponi robusti",
            "KOR": "통굽부츠",
            "CHS": "厚底靴",
            "CHT": "厚底靴"
        }
    ],
    "Blunder Policy": [
        {
            "NO": 1076,
            "EN": "Blunder Policy",
            "JP": "からぶりほけん",
            "FR": "Assurance Échec",
            "DE": "Fehlschlagschutz",
            "ES": "Seguro Fallo",
            "IT": "Fiascopolizza",
            "KOR": "허탕보험",
            "CHS": "打空保险",
            "CHT": "打空保險"
        }
    ],
    "Room Service": [
        {
            "NO": 1077,
            "EN": "Room Service",
            "JP": "ルームサービス",
            "FR": "Chariot Distordu",
            "DE": "Bizarroservice",
            "ES": "Servicio Raro",
            "IT": "Distorservizio",
            "KOR": "룸서비스",
            "CHS": "客房服务",
            "CHT": "客房服務"
        }
    ],
    "Utility Umbrella": [
        {
            "NO": 1078,
            "EN": "Utility Umbrella",
            "JP": "ばんのうがさ",
            "FR": "Parapluie Solide",
            "DE": "Allzweckschirm",
            "ES": "Parasol Multiuso",
            "IT": "Superombrello",
            "KOR": "만능우산",
            "CHS": "万能伞",
            "CHT": "萬能傘"
        }
    ],
    "Exp. Candy XS": [
        {
            "NO": 1079,
            "EN": "Exp. Candy XS",
            "JP": "けいけんアメＸＳ",
            "FR": "Bonbon Exp. XS",
            "DE": "EP-Bonbon XS",
            "ES": "Caramelo Exp. XS",
            "IT": "Caram. esp. XS",
            "KOR": "경험사탕XS",
            "CHS": "经验糖果ＸＳ",
            "CHT": "經驗糖果ＸＳ"
        }
    ],
    "Exp. Candy S": [
        {
            "NO": 1080,
            "EN": "Exp. Candy S",
            "JP": "けいけんアメＳ",
            "FR": "Bonbon Exp. S",
            "DE": "EP-Bonbon S",
            "ES": "Caramelo Exp. S",
            "IT": "Caram. esp. S",
            "KOR": "경험사탕S",
            "CHS": "经验糖果Ｓ",
            "CHT": "經驗糖果Ｓ"
        }
    ],
    "Exp. Candy M": [
        {
            "NO": 1081,
            "EN": "Exp. Candy M",
            "JP": "けいけんアメＭ",
            "FR": "Bonbon Exp. M",
            "DE": "EP-Bonbon M",
            "ES": "Caramelo Exp. M",
            "IT": "Caram. esp. M",
            "KOR": "경험사탕M",
            "CHS": "经验糖果Ｍ",
            "CHT": "經驗糖果Ｍ"
        }
    ],
    "Exp. Candy L": [
        {
            "NO": 1082,
            "EN": "Exp. Candy L",
            "JP": "けいけんアメＬ",
            "FR": "Bonbon Exp. L",
            "DE": "EP-Bonbon L",
            "ES": "Caramelo Exp. L",
            "IT": "Caram. esp. L",
            "KOR": "경험사탕L",
            "CHS": "经验糖果Ｌ",
            "CHT": "經驗糖果Ｌ"
        }
    ],
    "Exp. Candy XL": [
        {
            "NO": 1083,
            "EN": "Exp. Candy XL",
            "JP": "けいけんアメＸＬ",
            "FR": "Bonbon Exp. XL",
            "DE": "EP-Bonbon XL",
            "ES": "Caramelo Exp. XL",
            "IT": "Caram. esp. XL",
            "KOR": "경험사탕XL",
            "CHS": "经验糖果ＸＬ",
            "CHT": "經驗糖果ＸＬ"
        }
    ],
    "Dynamax Candy": [
        {
            "NO": 1084,
            "EN": "Dynamax Candy",
            "JP": "ダイマックスアメ",
            "FR": "Bonbon Dynamax",
            "DE": "Dynamax-Bonbon",
            "ES": "Caramelo Dinamax",
            "IT": "Caramella Dynamax",
            "KOR": "다이맥스사탕",
            "CHS": "极巨糖果",
            "CHT": "極巨糖果"
        }
    ],
    "TR00": [
        {
            "NO": 1085,
            "EN": "TR00",
            "JP": "わざレコード００",
            "FR": "DT00",
            "DE": "TP00",
            "ES": "DT00",
            "IT": "DT00",
            "KOR": "기술레코드00",
            "CHS": "招式记录００",
            "CHT": "招式紀錄００"
        }
    ],
    "TR01": [
        {
            "NO": 1086,
            "EN": "TR01",
            "JP": "わざレコード０１",
            "FR": "DT01",
            "DE": "TP01",
            "ES": "DT01",
            "IT": "DT01",
            "KOR": "기술레코드01",
            "CHS": "招式记录０１",
            "CHT": "招式紀錄０１"
        }
    ],
    "TR02": [
        {
            "NO": 1087,
            "EN": "TR02",
            "JP": "わざレコード０２",
            "FR": "DT02",
            "DE": "TP02",
            "ES": "DT02",
            "IT": "DT02",
            "KOR": "기술레코드02",
            "CHS": "招式记录０２",
            "CHT": "招式紀錄０２"
        }
    ],
    "TR03": [
        {
            "NO": 1088,
            "EN": "TR03",
            "JP": "わざレコード０３",
            "FR": "DT03",
            "DE": "TP03",
            "ES": "DT03",
            "IT": "DT03",
            "KOR": "기술레코드03",
            "CHS": "招式记录０３",
            "CHT": "招式紀錄０３"
        }
    ],
    "TR04": [
        {
            "NO": 1089,
            "EN": "TR04",
            "JP": "わざレコード０４",
            "FR": "DT04",
            "DE": "TP04",
            "ES": "DT04",
            "IT": "DT04",
            "KOR": "기술레코드04",
            "CHS": "招式记录０４",
            "CHT": "招式紀錄０４"
        }
    ],
    "TR05": [
        {
            "NO": 1090,
            "EN": "TR05",
            "JP": "わざレコード０５",
            "FR": "DT05",
            "DE": "TP05",
            "ES": "DT05",
            "IT": "DT05",
            "KOR": "기술레코드05",
            "CHS": "招式记录０５",
            "CHT": "招式紀錄０５"
        }
    ],
    "TR06": [
        {
            "NO": 1091,
            "EN": "TR06",
            "JP": "わざレコード０６",
            "FR": "DT06",
            "DE": "TP06",
            "ES": "DT06",
            "IT": "DT06",
            "KOR": "기술레코드06",
            "CHS": "招式记录０６",
            "CHT": "招式紀錄０６"
        }
    ],
    "TR07": [
        {
            "NO": 1092,
            "EN": "TR07",
            "JP": "わざレコード０７",
            "FR": "DT07",
            "DE": "TP07",
            "ES": "DT07",
            "IT": "DT07",
            "KOR": "기술레코드07",
            "CHS": "招式记录０７",
            "CHT": "招式紀錄０７"
        }
    ],
    "TR08": [
        {
            "NO": 1093,
            "EN": "TR08",
            "JP": "わざレコード０８",
            "FR": "DT08",
            "DE": "TP08",
            "ES": "DT08",
            "IT": "DT08",
            "KOR": "기술레코드08",
            "CHS": "招式记录０８",
            "CHT": "招式紀錄０８"
        }
    ],
    "TR09": [
        {
            "NO": 1094,
            "EN": "TR09",
            "JP": "わざレコード０９",
            "FR": "DT09",
            "DE": "TP09",
            "ES": "DT09",
            "IT": "DT09",
            "KOR": "기술레코드09",
            "CHS": "招式记录０９",
            "CHT": "招式紀錄０９"
        }
    ],
    "TR10": [
        {
            "NO": 1095,
            "EN": "TR10",
            "JP": "わざレコード１０",
            "FR": "DT10",
            "DE": "TP10",
            "ES": "DT10",
            "IT": "DT10",
            "KOR": "기술레코드10",
            "CHS": "招式记录１０",
            "CHT": "招式紀錄１０"
        }
    ],
    "TR11": [
        {
            "NO": 1096,
            "EN": "TR11",
            "JP": "わざレコード１１",
            "FR": "DT11",
            "DE": "TP11",
            "ES": "DT11",
            "IT": "DT11",
            "KOR": "기술레코드11",
            "CHS": "招式记录１１",
            "CHT": "招式紀錄１１"
        }
    ],
    "TR12": [
        {
            "NO": 1097,
            "EN": "TR12",
            "JP": "わざレコード１２",
            "FR": "DT12",
            "DE": "TP12",
            "ES": "DT12",
            "IT": "DT12",
            "KOR": "기술레코드12",
            "CHS": "招式记录１２",
            "CHT": "招式紀錄１２"
        }
    ],
    "TR13": [
        {
            "NO": 1098,
            "EN": "TR13",
            "JP": "わざレコード１３",
            "FR": "DT13",
            "DE": "TP13",
            "ES": "DT13",
            "IT": "DT13",
            "KOR": "기술레코드13",
            "CHS": "招式记录１３",
            "CHT": "招式紀錄１３"
        }
    ],
    "TR14": [
        {
            "NO": 1099,
            "EN": "TR14",
            "JP": "わざレコード１４",
            "FR": "DT14",
            "DE": "TP14",
            "ES": "DT14",
            "IT": "DT14",
            "KOR": "기술레코드14",
            "CHS": "招式记录１４",
            "CHT": "招式紀錄１４"
        }
    ],
    "TR15": [
        {
            "NO": 1100,
            "EN": "TR15",
            "JP": "わざレコード１５",
            "FR": "DT15",
            "DE": "TP15",
            "ES": "DT15",
            "IT": "DT15",
            "KOR": "기술레코드15",
            "CHS": "招式记录１５",
            "CHT": "招式紀錄１５"
        }
    ],
    "TR16": [
        {
            "NO": 1101,
            "EN": "TR16",
            "JP": "わざレコード１６",
            "FR": "DT16",
            "DE": "TP16",
            "ES": "DT16",
            "IT": "DT16",
            "KOR": "기술레코드16",
            "CHS": "招式记录１６",
            "CHT": "招式紀錄１６"
        }
    ],
    "TR17": [
        {
            "NO": 1102,
            "EN": "TR17",
            "JP": "わざレコード１７",
            "FR": "DT17",
            "DE": "TP17",
            "ES": "DT17",
            "IT": "DT17",
            "KOR": "기술레코드17",
            "CHS": "招式记录１７",
            "CHT": "招式紀錄１７"
        }
    ],
    "TR18": [
        {
            "NO": 1103,
            "EN": "TR18",
            "JP": "わざレコード１８",
            "FR": "DT18",
            "DE": "TP18",
            "ES": "DT18",
            "IT": "DT18",
            "KOR": "기술레코드18",
            "CHS": "招式记录１８",
            "CHT": "招式紀錄１８"
        }
    ],
    "TR19": [
        {
            "NO": 1104,
            "EN": "TR19",
            "JP": "わざレコード１９",
            "FR": "DT19",
            "DE": "TP19",
            "ES": "DT19",
            "IT": "DT19",
            "KOR": "기술레코드19",
            "CHS": "招式记录１９",
            "CHT": "招式紀錄１９"
        }
    ],
    "TR20": [
        {
            "NO": 1105,
            "EN": "TR20",
            "JP": "わざレコード２０",
            "FR": "DT20",
            "DE": "TP20",
            "ES": "DT20",
            "IT": "DT20",
            "KOR": "기술레코드20",
            "CHS": "招式记录２０",
            "CHT": "招式紀錄２０"
        }
    ],
    "TR21": [
        {
            "NO": 1106,
            "EN": "TR21",
            "JP": "わざレコード２１",
            "FR": "DT21",
            "DE": "TP21",
            "ES": "DT21",
            "IT": "DT21",
            "KOR": "기술레코드21",
            "CHS": "招式记录２１",
            "CHT": "招式紀錄２１"
        }
    ],
    "TR22": [
        {
            "NO": 1107,
            "EN": "TR22",
            "JP": "わざレコード２２",
            "FR": "DT22",
            "DE": "TP22",
            "ES": "DT22",
            "IT": "DT22",
            "KOR": "기술레코드22",
            "CHS": "招式记录２２",
            "CHT": "招式紀錄２２"
        }
    ],
    "TR23": [
        {
            "NO": 1108,
            "EN": "TR23",
            "JP": "わざレコード２３",
            "FR": "DT23",
            "DE": "TP23",
            "ES": "DT23",
            "IT": "DT23",
            "KOR": "기술레코드23",
            "CHS": "招式记录２３",
            "CHT": "招式紀錄２３"
        }
    ],
    "TR24": [
        {
            "NO": 1109,
            "EN": "TR24",
            "JP": "わざレコード２４",
            "FR": "DT24",
            "DE": "TP24",
            "ES": "DT24",
            "IT": "DT24",
            "KOR": "기술레코드24",
            "CHS": "招式记录２４",
            "CHT": "招式紀錄２４"
        }
    ],
    "TR25": [
        {
            "NO": 1110,
            "EN": "TR25",
            "JP": "わざレコード２５",
            "FR": "DT25",
            "DE": "TP25",
            "ES": "DT25",
            "IT": "DT25",
            "KOR": "기술레코드25",
            "CHS": "招式记录２５",
            "CHT": "招式紀錄２５"
        }
    ],
    "TR26": [
        {
            "NO": 1111,
            "EN": "TR26",
            "JP": "わざレコード２６",
            "FR": "DT26",
            "DE": "TP26",
            "ES": "DT26",
            "IT": "DT26",
            "KOR": "기술레코드26",
            "CHS": "招式记录２６",
            "CHT": "招式紀錄２６"
        }
    ],
    "TR27": [
        {
            "NO": 1112,
            "EN": "TR27",
            "JP": "わざレコード２７",
            "FR": "DT27",
            "DE": "TP27",
            "ES": "DT27",
            "IT": "DT27",
            "KOR": "기술레코드27",
            "CHS": "招式记录２７",
            "CHT": "招式紀錄２７"
        }
    ],
    "TR28": [
        {
            "NO": 1113,
            "EN": "TR28",
            "JP": "わざレコード２８",
            "FR": "DT28",
            "DE": "TP28",
            "ES": "DT28",
            "IT": "DT28",
            "KOR": "기술레코드28",
            "CHS": "招式记录２８",
            "CHT": "招式紀錄２８"
        }
    ],
    "TR29": [
        {
            "NO": 1114,
            "EN": "TR29",
            "JP": "わざレコード２９",
            "FR": "DT29",
            "DE": "TP29",
            "ES": "DT29",
            "IT": "DT29",
            "KOR": "기술레코드29",
            "CHS": "招式记录２９",
            "CHT": "招式紀錄２９"
        }
    ],
    "TR30": [
        {
            "NO": 1115,
            "EN": "TR30",
            "JP": "わざレコード３０",
            "FR": "DT30",
            "DE": "TP30",
            "ES": "DT30",
            "IT": "DT30",
            "KOR": "기술레코드30",
            "CHS": "招式记录３０",
            "CHT": "招式紀錄３０"
        }
    ],
    "TR31": [
        {
            "NO": 1116,
            "EN": "TR31",
            "JP": "わざレコード３１",
            "FR": "DT31",
            "DE": "TP31",
            "ES": "DT31",
            "IT": "DT31",
            "KOR": "기술레코드31",
            "CHS": "招式记录３１",
            "CHT": "招式紀錄３１"
        }
    ],
    "TR32": [
        {
            "NO": 1117,
            "EN": "TR32",
            "JP": "わざレコード３２",
            "FR": "DT32",
            "DE": "TP32",
            "ES": "DT32",
            "IT": "DT32",
            "KOR": "기술레코드32",
            "CHS": "招式记录３２",
            "CHT": "招式紀錄３２"
        }
    ],
    "TR33": [
        {
            "NO": 1118,
            "EN": "TR33",
            "JP": "わざレコード３３",
            "FR": "DT33",
            "DE": "TP33",
            "ES": "DT33",
            "IT": "DT33",
            "KOR": "기술레코드33",
            "CHS": "招式记录３３",
            "CHT": "招式紀錄３３"
        }
    ],
    "TR34": [
        {
            "NO": 1119,
            "EN": "TR34",
            "JP": "わざレコード３４",
            "FR": "DT34",
            "DE": "TP34",
            "ES": "DT34",
            "IT": "DT34",
            "KOR": "기술레코드34",
            "CHS": "招式记录３４",
            "CHT": "招式紀錄３４"
        }
    ],
    "TR35": [
        {
            "NO": 1120,
            "EN": "TR35",
            "JP": "わざレコード３５",
            "FR": "DT35",
            "DE": "TP35",
            "ES": "DT35",
            "IT": "DT35",
            "KOR": "기술레코드35",
            "CHS": "招式记录３５",
            "CHT": "招式紀錄３５"
        }
    ],
    "TR36": [
        {
            "NO": 1121,
            "EN": "TR36",
            "JP": "わざレコード３６",
            "FR": "DT36",
            "DE": "TP36",
            "ES": "DT36",
            "IT": "DT36",
            "KOR": "기술레코드36",
            "CHS": "招式记录３６",
            "CHT": "招式紀錄３６"
        }
    ],
    "TR37": [
        {
            "NO": 1122,
            "EN": "TR37",
            "JP": "わざレコード３７",
            "FR": "DT37",
            "DE": "TP37",
            "ES": "DT37",
            "IT": "DT37",
            "KOR": "기술레코드37",
            "CHS": "招式记录３７",
            "CHT": "招式紀錄３７"
        }
    ],
    "TR38": [
        {
            "NO": 1123,
            "EN": "TR38",
            "JP": "わざレコード３８",
            "FR": "DT38",
            "DE": "TP38",
            "ES": "DT38",
            "IT": "DT38",
            "KOR": "기술레코드38",
            "CHS": "招式记录３８",
            "CHT": "招式紀錄３８"
        }
    ],
    "TR39": [
        {
            "NO": 1124,
            "EN": "TR39",
            "JP": "わざレコード３９",
            "FR": "DT39",
            "DE": "TP39",
            "ES": "DT39",
            "IT": "DT39",
            "KOR": "기술레코드39",
            "CHS": "招式记录３９",
            "CHT": "招式紀錄３９"
        }
    ],
    "TR40": [
        {
            "NO": 1125,
            "EN": "TR40",
            "JP": "わざレコード４０",
            "FR": "DT40",
            "DE": "TP40",
            "ES": "DT40",
            "IT": "DT40",
            "KOR": "기술레코드40",
            "CHS": "招式记录４０",
            "CHT": "招式紀錄４０"
        }
    ],
    "TR41": [
        {
            "NO": 1126,
            "EN": "TR41",
            "JP": "わざレコード４１",
            "FR": "DT41",
            "DE": "TP41",
            "ES": "DT41",
            "IT": "DT41",
            "KOR": "기술레코드41",
            "CHS": "招式记录４１",
            "CHT": "招式紀錄４１"
        }
    ],
    "TR42": [
        {
            "NO": 1127,
            "EN": "TR42",
            "JP": "わざレコード４２",
            "FR": "DT42",
            "DE": "TP42",
            "ES": "DT42",
            "IT": "DT42",
            "KOR": "기술레코드42",
            "CHS": "招式记录４２",
            "CHT": "招式紀錄４２"
        }
    ],
    "TR43": [
        {
            "NO": 1128,
            "EN": "TR43",
            "JP": "わざレコード４３",
            "FR": "DT43",
            "DE": "TP43",
            "ES": "DT43",
            "IT": "DT43",
            "KOR": "기술레코드43",
            "CHS": "招式记录４３",
            "CHT": "招式紀錄４３"
        }
    ],
    "TR44": [
        {
            "NO": 1129,
            "EN": "TR44",
            "JP": "わざレコード４４",
            "FR": "DT44",
            "DE": "TP44",
            "ES": "DT44",
            "IT": "DT44",
            "KOR": "기술레코드44",
            "CHS": "招式记录４４",
            "CHT": "招式紀錄４４"
        }
    ],
    "TR45": [
        {
            "NO": 1130,
            "EN": "TR45",
            "JP": "わざレコード４５",
            "FR": "DT45",
            "DE": "TP45",
            "ES": "DT45",
            "IT": "DT45",
            "KOR": "기술레코드45",
            "CHS": "招式记录４５",
            "CHT": "招式紀錄４５"
        }
    ],
    "TR46": [
        {
            "NO": 1131,
            "EN": "TR46",
            "JP": "わざレコード４６",
            "FR": "DT46",
            "DE": "TP46",
            "ES": "DT46",
            "IT": "DT46",
            "KOR": "기술레코드46",
            "CHS": "招式记录４６",
            "CHT": "招式紀錄４６"
        }
    ],
    "TR47": [
        {
            "NO": 1132,
            "EN": "TR47",
            "JP": "わざレコード４７",
            "FR": "DT47",
            "DE": "TP47",
            "ES": "DT47",
            "IT": "DT47",
            "KOR": "기술레코드47",
            "CHS": "招式记录４７",
            "CHT": "招式紀錄４７"
        }
    ],
    "TR48": [
        {
            "NO": 1133,
            "EN": "TR48",
            "JP": "わざレコード４８",
            "FR": "DT48",
            "DE": "TP48",
            "ES": "DT48",
            "IT": "DT48",
            "KOR": "기술레코드48",
            "CHS": "招式记录４８",
            "CHT": "招式紀錄４８"
        }
    ],
    "TR49": [
        {
            "NO": 1134,
            "EN": "TR49",
            "JP": "わざレコード４９",
            "FR": "DT49",
            "DE": "TP49",
            "ES": "DT49",
            "IT": "DT49",
            "KOR": "기술레코드49",
            "CHS": "招式记录４９",
            "CHT": "招式紀錄４９"
        }
    ],
    "TR50": [
        {
            "NO": 1135,
            "EN": "TR50",
            "JP": "わざレコード５０",
            "FR": "DT50",
            "DE": "TP50",
            "ES": "DT50",
            "IT": "DT50",
            "KOR": "기술레코드50",
            "CHS": "招式记录５０",
            "CHT": "招式紀錄５０"
        }
    ],
    "TR51": [
        {
            "NO": 1136,
            "EN": "TR51",
            "JP": "わざレコード５１",
            "FR": "DT51",
            "DE": "TP51",
            "ES": "DT51",
            "IT": "DT51",
            "KOR": "기술레코드51",
            "CHS": "招式记录５１",
            "CHT": "招式紀錄５１"
        }
    ],
    "TR52": [
        {
            "NO": 1137,
            "EN": "TR52",
            "JP": "わざレコード５２",
            "FR": "DT52",
            "DE": "TP52",
            "ES": "DT52",
            "IT": "DT52",
            "KOR": "기술레코드52",
            "CHS": "招式记录５２",
            "CHT": "招式紀錄５２"
        }
    ],
    "TR53": [
        {
            "NO": 1138,
            "EN": "TR53",
            "JP": "わざレコード５３",
            "FR": "DT53",
            "DE": "TP53",
            "ES": "DT53",
            "IT": "DT53",
            "KOR": "기술레코드53",
            "CHS": "招式记录５３",
            "CHT": "招式紀錄５３"
        }
    ],
    "TR54": [
        {
            "NO": 1139,
            "EN": "TR54",
            "JP": "わざレコード５４",
            "FR": "DT54",
            "DE": "TP54",
            "ES": "DT54",
            "IT": "DT54",
            "KOR": "기술레코드54",
            "CHS": "招式记录５４",
            "CHT": "招式紀錄５４"
        }
    ],
    "TR55": [
        {
            "NO": 1140,
            "EN": "TR55",
            "JP": "わざレコード５５",
            "FR": "DT55",
            "DE": "TP55",
            "ES": "DT55",
            "IT": "DT55",
            "KOR": "기술레코드55",
            "CHS": "招式记录５５",
            "CHT": "招式紀錄５５"
        }
    ],
    "TR56": [
        {
            "NO": 1141,
            "EN": "TR56",
            "JP": "わざレコード５６",
            "FR": "DT56",
            "DE": "TP56",
            "ES": "DT56",
            "IT": "DT56",
            "KOR": "기술레코드56",
            "CHS": "招式记录５６",
            "CHT": "招式紀錄５６"
        }
    ],
    "TR57": [
        {
            "NO": 1142,
            "EN": "TR57",
            "JP": "わざレコード５７",
            "FR": "DT57",
            "DE": "TP57",
            "ES": "DT57",
            "IT": "DT57",
            "KOR": "기술레코드57",
            "CHS": "招式记录５７",
            "CHT": "招式紀錄５７"
        }
    ],
    "TR58": [
        {
            "NO": 1143,
            "EN": "TR58",
            "JP": "わざレコード５８",
            "FR": "DT58",
            "DE": "TP58",
            "ES": "DT58",
            "IT": "DT58",
            "KOR": "기술레코드58",
            "CHS": "招式记录５８",
            "CHT": "招式紀錄５８"
        }
    ],
    "TR59": [
        {
            "NO": 1144,
            "EN": "TR59",
            "JP": "わざレコード５９",
            "FR": "DT59",
            "DE": "TP59",
            "ES": "DT59",
            "IT": "DT59",
            "KOR": "기술레코드59",
            "CHS": "招式记录５９",
            "CHT": "招式紀錄５９"
        }
    ],
    "TR60": [
        {
            "NO": 1145,
            "EN": "TR60",
            "JP": "わざレコード６０",
            "FR": "DT60",
            "DE": "TP60",
            "ES": "DT60",
            "IT": "DT60",
            "KOR": "기술레코드60",
            "CHS": "招式记录６０",
            "CHT": "招式紀錄６０"
        }
    ],
    "TR61": [
        {
            "NO": 1146,
            "EN": "TR61",
            "JP": "わざレコード６１",
            "FR": "DT61",
            "DE": "TP61",
            "ES": "DT61",
            "IT": "DT61",
            "KOR": "기술레코드61",
            "CHS": "招式记录６１",
            "CHT": "招式紀錄６１"
        }
    ],
    "TR62": [
        {
            "NO": 1147,
            "EN": "TR62",
            "JP": "わざレコード６２",
            "FR": "DT62",
            "DE": "TP62",
            "ES": "DT62",
            "IT": "DT62",
            "KOR": "기술레코드62",
            "CHS": "招式记录６２",
            "CHT": "招式紀錄６２"
        }
    ],
    "TR63": [
        {
            "NO": 1148,
            "EN": "TR63",
            "JP": "わざレコード６３",
            "FR": "DT63",
            "DE": "TP63",
            "ES": "DT63",
            "IT": "DT63",
            "KOR": "기술레코드63",
            "CHS": "招式记录６３",
            "CHT": "招式紀錄６３"
        }
    ],
    "TR64": [
        {
            "NO": 1149,
            "EN": "TR64",
            "JP": "わざレコード６４",
            "FR": "DT64",
            "DE": "TP64",
            "ES": "DT64",
            "IT": "DT64",
            "KOR": "기술레코드64",
            "CHS": "招式记录６４",
            "CHT": "招式紀錄６４"
        }
    ],
    "TR65": [
        {
            "NO": 1150,
            "EN": "TR65",
            "JP": "わざレコード６５",
            "FR": "DT65",
            "DE": "TP65",
            "ES": "DT65",
            "IT": "DT65",
            "KOR": "기술레코드65",
            "CHS": "招式记录６５",
            "CHT": "招式紀錄６５"
        }
    ],
    "TR66": [
        {
            "NO": 1151,
            "EN": "TR66",
            "JP": "わざレコード６６",
            "FR": "DT66",
            "DE": "TP66",
            "ES": "DT66",
            "IT": "DT66",
            "KOR": "기술레코드66",
            "CHS": "招式记录６６",
            "CHT": "招式紀錄６６"
        }
    ],
    "TR67": [
        {
            "NO": 1152,
            "EN": "TR67",
            "JP": "わざレコード６７",
            "FR": "DT67",
            "DE": "TP67",
            "ES": "DT67",
            "IT": "DT67",
            "KOR": "기술레코드67",
            "CHS": "招式记录６７",
            "CHT": "招式紀錄６７"
        }
    ],
    "TR68": [
        {
            "NO": 1153,
            "EN": "TR68",
            "JP": "わざレコード６８",
            "FR": "DT68",
            "DE": "TP68",
            "ES": "DT68",
            "IT": "DT68",
            "KOR": "기술레코드68",
            "CHS": "招式记录６８",
            "CHT": "招式紀錄６８"
        }
    ],
    "TR69": [
        {
            "NO": 1154,
            "EN": "TR69",
            "JP": "わざレコード６９",
            "FR": "DT69",
            "DE": "TP69",
            "ES": "DT69",
            "IT": "DT69",
            "KOR": "기술레코드69",
            "CHS": "招式记录６９",
            "CHT": "招式紀錄６９"
        }
    ],
    "TR70": [
        {
            "NO": 1155,
            "EN": "TR70",
            "JP": "わざレコード７０",
            "FR": "DT70",
            "DE": "TP70",
            "ES": "DT70",
            "IT": "DT70",
            "KOR": "기술레코드70",
            "CHS": "招式记录７０",
            "CHT": "招式紀錄７０"
        }
    ],
    "TR71": [
        {
            "NO": 1156,
            "EN": "TR71",
            "JP": "わざレコード７１",
            "FR": "DT71",
            "DE": "TP71",
            "ES": "DT71",
            "IT": "DT71",
            "KOR": "기술레코드71",
            "CHS": "招式记录７１",
            "CHT": "招式紀錄７１"
        }
    ],
    "TR72": [
        {
            "NO": 1157,
            "EN": "TR72",
            "JP": "わざレコード７２",
            "FR": "DT72",
            "DE": "TP72",
            "ES": "DT72",
            "IT": "DT72",
            "KOR": "기술레코드72",
            "CHS": "招式记录７２",
            "CHT": "招式紀錄７２"
        }
    ],
    "TR73": [
        {
            "NO": 1158,
            "EN": "TR73",
            "JP": "わざレコード７３",
            "FR": "DT73",
            "DE": "TP73",
            "ES": "DT73",
            "IT": "DT73",
            "KOR": "기술레코드73",
            "CHS": "招式记录７３",
            "CHT": "招式紀錄７３"
        }
    ],
    "TR74": [
        {
            "NO": 1159,
            "EN": "TR74",
            "JP": "わざレコード７４",
            "FR": "DT74",
            "DE": "TP74",
            "ES": "DT74",
            "IT": "DT74",
            "KOR": "기술레코드74",
            "CHS": "招式记录７４",
            "CHT": "招式紀錄７４"
        }
    ],
    "TR75": [
        {
            "NO": 1160,
            "EN": "TR75",
            "JP": "わざレコード７５",
            "FR": "DT75",
            "DE": "TP75",
            "ES": "DT75",
            "IT": "DT75",
            "KOR": "기술레코드75",
            "CHS": "招式记录７５",
            "CHT": "招式紀錄７５"
        }
    ],
    "TR76": [
        {
            "NO": 1161,
            "EN": "TR76",
            "JP": "わざレコード７６",
            "FR": "DT76",
            "DE": "TP76",
            "ES": "DT76",
            "IT": "DT76",
            "KOR": "기술레코드76",
            "CHS": "招式记录７６",
            "CHT": "招式紀錄７６"
        }
    ],
    "TR77": [
        {
            "NO": 1162,
            "EN": "TR77",
            "JP": "わざレコード７７",
            "FR": "DT77",
            "DE": "TP77",
            "ES": "DT77",
            "IT": "DT77",
            "KOR": "기술레코드77",
            "CHS": "招式记录７７",
            "CHT": "招式紀錄７７"
        }
    ],
    "TR78": [
        {
            "NO": 1163,
            "EN": "TR78",
            "JP": "わざレコード７８",
            "FR": "DT78",
            "DE": "TP78",
            "ES": "DT78",
            "IT": "DT78",
            "KOR": "기술레코드78",
            "CHS": "招式记录７８",
            "CHT": "招式紀錄７８"
        }
    ],
    "TR79": [
        {
            "NO": 1164,
            "EN": "TR79",
            "JP": "わざレコード７９",
            "FR": "DT79",
            "DE": "TP79",
            "ES": "DT79",
            "IT": "DT79",
            "KOR": "기술레코드79",
            "CHS": "招式记录７９",
            "CHT": "招式紀錄７９"
        }
    ],
    "TR80": [
        {
            "NO": 1165,
            "EN": "TR80",
            "JP": "わざレコード８０",
            "FR": "DT80",
            "DE": "TP80",
            "ES": "DT80",
            "IT": "DT80",
            "KOR": "기술레코드80",
            "CHS": "招式记录８０",
            "CHT": "招式紀錄８０"
        }
    ],
    "TR81": [
        {
            "NO": 1166,
            "EN": "TR81",
            "JP": "わざレコード８１",
            "FR": "DT81",
            "DE": "TP81",
            "ES": "DT81",
            "IT": "DT81",
            "KOR": "기술레코드81",
            "CHS": "招式记录８１",
            "CHT": "招式紀錄８１"
        }
    ],
    "TR82": [
        {
            "NO": 1167,
            "EN": "TR82",
            "JP": "わざレコード８２",
            "FR": "DT82",
            "DE": "TP82",
            "ES": "DT82",
            "IT": "DT82",
            "KOR": "기술레코드82",
            "CHS": "招式记录８２",
            "CHT": "招式紀錄８２"
        }
    ],
    "TR83": [
        {
            "NO": 1168,
            "EN": "TR83",
            "JP": "わざレコード８３",
            "FR": "DT83",
            "DE": "TP83",
            "ES": "DT83",
            "IT": "DT83",
            "KOR": "기술레코드83",
            "CHS": "招式记录８３",
            "CHT": "招式紀錄８３"
        }
    ],
    "TR84": [
        {
            "NO": 1169,
            "EN": "TR84",
            "JP": "わざレコード８４",
            "FR": "DT84",
            "DE": "TP84",
            "ES": "DT84",
            "IT": "DT84",
            "KOR": "기술레코드84",
            "CHS": "招式记录８４",
            "CHT": "招式紀錄８４"
        }
    ],
    "TR85": [
        {
            "NO": 1170,
            "EN": "TR85",
            "JP": "わざレコード８５",
            "FR": "DT85",
            "DE": "TP85",
            "ES": "DT85",
            "IT": "DT85",
            "KOR": "기술레코드85",
            "CHS": "招式记录８５",
            "CHT": "招式紀錄８５"
        }
    ],
    "TR86": [
        {
            "NO": 1171,
            "EN": "TR86",
            "JP": "わざレコード８６",
            "FR": "DT86",
            "DE": "TP86",
            "ES": "DT86",
            "IT": "DT86",
            "KOR": "기술레코드86",
            "CHS": "招式记录８６",
            "CHT": "招式紀錄８６"
        }
    ],
    "TR87": [
        {
            "NO": 1172,
            "EN": "TR87",
            "JP": "わざレコード８７",
            "FR": "DT87",
            "DE": "TP87",
            "ES": "DT87",
            "IT": "DT87",
            "KOR": "기술레코드87",
            "CHS": "招式记录８７",
            "CHT": "招式紀錄８７"
        }
    ],
    "TR88": [
        {
            "NO": 1173,
            "EN": "TR88",
            "JP": "わざレコード８８",
            "FR": "DT88",
            "DE": "TP88",
            "ES": "DT88",
            "IT": "DT88",
            "KOR": "기술레코드88",
            "CHS": "招式记录８８",
            "CHT": "招式紀錄８８"
        }
    ],
    "TR89": [
        {
            "NO": 1174,
            "EN": "TR89",
            "JP": "わざレコード８９",
            "FR": "DT89",
            "DE": "TP89",
            "ES": "DT89",
            "IT": "DT89",
            "KOR": "기술레코드89",
            "CHS": "招式记录８９",
            "CHT": "招式紀錄８９"
        }
    ],
    "TR90": [
        {
            "NO": 1175,
            "EN": "TR90",
            "JP": "わざレコード９０",
            "FR": "DT90",
            "DE": "TP90",
            "ES": "DT90",
            "IT": "DT90",
            "KOR": "기술레코드90",
            "CHS": "招式记录９０",
            "CHT": "招式紀錄９０"
        }
    ],
    "TR91": [
        {
            "NO": 1176,
            "EN": "TR91",
            "JP": "わざレコード９１",
            "FR": "DT91",
            "DE": "TP91",
            "ES": "DT91",
            "IT": "DT91",
            "KOR": "기술레코드91",
            "CHS": "招式记录９１",
            "CHT": "招式紀錄９１"
        }
    ],
    "TR92": [
        {
            "NO": 1177,
            "EN": "TR92",
            "JP": "わざレコード９２",
            "FR": "DT92",
            "DE": "TP92",
            "ES": "DT92",
            "IT": "DT92",
            "KOR": "기술레코드92",
            "CHS": "招式记录９２",
            "CHT": "招式紀錄９２"
        }
    ],
    "TR93": [
        {
            "NO": 1178,
            "EN": "TR93",
            "JP": "わざレコード９３",
            "FR": "DT93",
            "DE": "TP93",
            "ES": "DT93",
            "IT": "DT93",
            "KOR": "기술레코드93",
            "CHS": "招式记录９３",
            "CHT": "招式紀錄９３"
        }
    ],
    "TR94": [
        {
            "NO": 1179,
            "EN": "TR94",
            "JP": "わざレコード９４",
            "FR": "DT94",
            "DE": "TP94",
            "ES": "DT94",
            "IT": "DT94",
            "KOR": "기술레코드94",
            "CHS": "招式记录９４",
            "CHT": "招式紀錄９４"
        }
    ],
    "TR95": [
        {
            "NO": 1180,
            "EN": "TR95",
            "JP": "わざレコード９５",
            "FR": "DT95",
            "DE": "TP95",
            "ES": "DT95",
            "IT": "DT95",
            "KOR": "기술레코드95",
            "CHS": "招式记录９５",
            "CHT": "招式紀錄９５"
        }
    ],
    "TR96": [
        {
            "NO": 1181,
            "EN": "TR96",
            "JP": "わざレコード９６",
            "FR": "DT96",
            "DE": "TP96",
            "ES": "DT96",
            "IT": "DT96",
            "KOR": "기술레코드96",
            "CHS": "招式记录９６",
            "CHT": "招式紀錄９６"
        }
    ],
    "TR97": [
        {
            "NO": 1182,
            "EN": "TR97",
            "JP": "わざレコード９７",
            "FR": "DT97",
            "DE": "TP97",
            "ES": "DT97",
            "IT": "DT97",
            "KOR": "기술레코드97",
            "CHS": "招式记录９７",
            "CHT": "招式紀錄９７"
        }
    ],
    "TR98": [
        {
            "NO": 1183,
            "EN": "TR98",
            "JP": "わざレコード９８",
            "FR": "DT98",
            "DE": "TP98",
            "ES": "DT98",
            "IT": "DT98",
            "KOR": "기술레코드98",
            "CHS": "招式记录９８",
            "CHT": "招式紀錄９８"
        }
    ],
    "TR99": [
        {
            "NO": 1184,
            "EN": "TR99",
            "JP": "わざレコード９９",
            "FR": "DT99",
            "DE": "TP99",
            "ES": "DT99",
            "IT": "DT99",
            "KOR": "기술레코드99",
            "CHS": "招式记录９９",
            "CHT": "招式紀錄９９"
        }
    ],
    "TM00": [
        {
            "NO": 1185,
            "EN": "TM00",
            "JP": "わざマシン００",
            "FR": "CT00",
            "DE": "TM00",
            "ES": "MT00",
            "IT": "MT00",
            "KOR": "기술머신00",
            "CHS": "招式学习器００",
            "CHT": "招式學習器００"
        }
    ],
    "Lonely Mint": [
        {
            "NO": 1186,
            "EN": "Lonely Mint",
            "JP": "さみしがりミント",
            "FR": "Aromate Solo",
            "DE": "Solo-Minze",
            "ES": "Menta Huraña",
            "IT": "Menta Schiva",
            "KOR": "외로움민트",
            "CHS": "怕寂寞薄荷",
            "CHT": "怕寂寞薄荷"
        }
    ],
    "Adamant Mint": [
        {
            "NO": 1187,
            "EN": "Adamant Mint",
            "JP": "いじっぱりミント",
            "FR": "Aromate Rigide",
            "DE": "Hart-Minze",
            "ES": "Menta Firme",
            "IT": "Menta Decisa",
            "KOR": "고집민트",
            "CHS": "固执薄荷",
            "CHT": "固執薄荷"
        }
    ],
    "Naughty Mint": [
        {
            "NO": 1188,
            "EN": "Naughty Mint",
            "JP": "やんちゃミント",
            "FR": "Aromate Mauvais",
            "DE": "Frech-Minze",
            "ES": "Menta Pícara",
            "IT": "Menta Birbona",
            "KOR": "개구쟁이민트",
            "CHS": "顽皮薄荷",
            "CHT": "頑皮薄荷"
        }
    ],
    "Brave Mint": [
        {
            "NO": 1189,
            "EN": "Brave Mint",
            "JP": "ゆうかんミント",
            "FR": "Aromate Brave",
            "DE": "Mutig-Minze",
            "ES": "Menta Audaz",
            "IT": "Menta Audace",
            "KOR": "용감민트",
            "CHS": "勇敢薄荷",
            "CHT": "勇敢薄荷"
        }
    ],
    "Bold Mint": [
        {
            "NO": 1190,
            "EN": "Bold Mint",
            "JP": "ずぶといミント",
            "FR": "Aromate Assuré",
            "DE": "Kühn-Minze",
            "ES": "Menta Osada",
            "IT": "Menta Sicura",
            "KOR": "대담민트",
            "CHS": "大胆薄荷",
            "CHT": "大膽薄荷"
        }
    ],
    "Impish Mint": [
        {
            "NO": 1191,
            "EN": "Impish Mint",
            "JP": "わんぱくミント",
            "FR": "Aromate Malin",
            "DE": "Pfiffig-Minze",
            "ES": "Menta Agitada",
            "IT": "Menta Scaltra",
            "KOR": "장난꾸러기민트",
            "CHS": "淘气薄荷",
            "CHT": "淘氣薄荷"
        }
    ],
    "Lax Mint": [
        {
            "NO": 1192,
            "EN": "Lax Mint",
            "JP": "のうてんきミント",
            "FR": "Aromate Lâche",
            "DE": "Lasch-Minze",
            "ES": "Menta Floja",
            "IT": "Menta Fiacca",
            "KOR": "촐랑민트",
            "CHS": "乐天薄荷",
            "CHT": "樂天薄荷"
        }
    ],
    "Relaxed Mint": [
        {
            "NO": 1193,
            "EN": "Relaxed Mint",
            "JP": "のんきミント",
            "FR": "Aromate Relax",
            "DE": "Locker-Minze",
            "ES": "Menta Plácida",
            "IT": "Menta Placida",
            "KOR": "무사태평민트",
            "CHS": "悠闲薄荷",
            "CHT": "悠閒薄荷"
        }
    ],
    "Modest Mint": [
        {
            "NO": 1194,
            "EN": "Modest Mint",
            "JP": "ひかえめミント",
            "FR": "Aromate Modeste",
            "DE": "Mäßig-Minze",
            "ES": "Menta Modesta",
            "IT": "Menta Modesta",
            "KOR": "조심민트",
            "CHS": "内敛薄荷",
            "CHT": "內斂薄荷"
        }
    ],
    "Mild Mint": [
        {
            "NO": 1195,
            "EN": "Mild Mint",
            "JP": "おっとりミント",
            "FR": "Aromate Doux",
            "DE": "Mild-Minze",
            "ES": "Menta Afable",
            "IT": "Menta Mite",
            "KOR": "의젓민트",
            "CHS": "慢吞吞薄荷",
            "CHT": "慢吞吞薄荷"
        }
    ],
    "Rash Mint": [
        {
            "NO": 1196,
            "EN": "Rash Mint",
            "JP": "うっかりやミント",
            "FR": "Aromate Foufou",
            "DE": "Hitzig-Minze",
            "ES": "Menta Alocada",
            "IT": "Menta Ardente",
            "KOR": "덜렁민트",
            "CHS": "马虎薄荷",
            "CHT": "馬虎薄荷"
        }
    ],
    "Quiet Mint": [
        {
            "NO": 1197,
            "EN": "Quiet Mint",
            "JP": "れいせいミント",
            "FR": "Aromate Discret",
            "DE": "Ruhig-Minze",
            "ES": "Menta Mansa",
            "IT": "Menta Quieta",
            "KOR": "냉정민트",
            "CHS": "冷静薄荷",
            "CHT": "冷靜薄荷"
        }
    ],
    "Calm Mint": [
        {
            "NO": 1198,
            "EN": "Calm Mint",
            "JP": "おだやかミント",
            "FR": "Aromate Calme",
            "DE": "Still-Minze",
            "ES": "Menta Serena",
            "IT": "Menta Calma",
            "KOR": "차분민트",
            "CHS": "温和薄荷",
            "CHT": "溫和薄荷"
        }
    ],
    "Gentle Mint": [
        {
            "NO": 1199,
            "EN": "Gentle Mint",
            "JP": "おとなしいミント",
            "FR": "Aromate Gentil",
            "DE": "Zart-Minze",
            "ES": "Menta Amable",
            "IT": "Menta Gentile",
            "KOR": "얌전민트",
            "CHS": "温顺薄荷",
            "CHT": "溫順薄荷"
        }
    ],
    "Careful Mint": [
        {
            "NO": 1200,
            "EN": "Careful Mint",
            "JP": "しんちょうミント",
            "FR": "Aromate Prudent",
            "DE": "Sacht-Minze",
            "ES": "Menta Cauta",
            "IT": "Menta Cauta",
            "KOR": "신중민트",
            "CHS": "慎重薄荷",
            "CHT": "慎重薄荷"
        }
    ],
    "Sassy Mint": [
        {
            "NO": 1201,
            "EN": "Sassy Mint",
            "JP": "なまいきミント",
            "FR": "Aromate Malpoli",
            "DE": "Forsch-Minze",
            "ES": "Menta Grosera",
            "IT": "Menta Vivace",
            "KOR": "건방민트",
            "CHS": "自大薄荷",
            "CHT": "自大薄荷"
        }
    ],
    "Timid Mint": [
        {
            "NO": 1202,
            "EN": "Timid Mint",
            "JP": "おくびょうミント",
            "FR": "Aromate Timide",
            "DE": "Scheu-Minze",
            "ES": "Menta Miedosa",
            "IT": "Menta Timida",
            "KOR": "겁쟁이민트",
            "CHS": "胆小薄荷",
            "CHT": "膽小薄荷"
        }
    ],
    "Hasty Mint": [
        {
            "NO": 1203,
            "EN": "Hasty Mint",
            "JP": "せっかちミント",
            "FR": "Aromate Pressé",
            "DE": "Hastig-Minze",
            "ES": "Menta Activa",
            "IT": "Menta Lesta",
            "KOR": "성급민트",
            "CHS": "急躁薄荷",
            "CHT": "急躁薄荷"
        }
    ],
    "Jolly Mint": [
        {
            "NO": 1204,
            "EN": "Jolly Mint",
            "JP": "ようきミント",
            "FR": "Aromate Jovial",
            "DE": "Froh-Minze",
            "ES": "Menta Alegre",
            "IT": "Menta Allegra",
            "KOR": "명랑민트",
            "CHS": "爽朗薄荷",
            "CHT": "爽朗薄荷"
        }
    ],
    "Naive Mint": [
        {
            "NO": 1205,
            "EN": "Naive Mint",
            "JP": "むじゃきミント",
            "FR": "Aromate Naïf",
            "DE": "Naiv-Minze",
            "ES": "Menta Ingenua",
            "IT": "Menta Ingenua",
            "KOR": "천진난만민트",
            "CHS": "天真薄荷",
            "CHT": "天真薄荷"
        }
    ],
    "Serious Mint": [
        {
            "NO": 1206,
            "EN": "Serious Mint",
            "JP": "まじめミント",
            "FR": "Aromate Sérieux",
            "DE": "Ernst-Minze",
            "ES": "Menta Seria",
            "IT": "Menta Seria",
            "KOR": "성실민트",
            "CHS": "认真薄荷",
            "CHT": "認真薄荷"
        }
    ],
    "Wishing Piece": [
        {
            "NO": 1207,
            "EN": "Wishing Piece",
            "JP": "ねがいのかたまり",
            "FR": "Morceau Vœu",
            "DE": "Wunschbrocken",
            "ES": "Trozo Deseo",
            "IT": "Desioblocco",
            "KOR": "소원의덩어리",
            "CHS": "许愿星块",
            "CHT": "許願星塊"
        }
    ],
    "Cracked Pot": [
        {
            "NO": 1208,
            "EN": "Cracked Pot",
            "JP": "われたポット",
            "FR": "Théière Fêlée",
            "DE": "Rissige Kanne",
            "ES": "Tetera Agrietada",
            "IT": "Teiera rotta",
            "KOR": "깨진포트",
            "CHS": "破裂的茶壶",
            "CHT": "破裂的茶壺"
        }
    ],
    "Chipped Pot": [
        {
            "NO": 1209,
            "EN": "Chipped Pot",
            "JP": "かけたポット",
            "FR": "Théière Ébréchée",
            "DE": "Löchrige Kanne",
            "ES": "Tetera Rota",
            "IT": "Teiera crepata",
            "KOR": "이빠진포트",
            "CHS": "缺损的茶壶",
            "CHT": "缺損的茶壺"
        }
    ],
    "Hi-tech Earbuds": [
        {
            "NO": 1210,
            "EN": "Hi-tech Earbuds",
            "JP": "すごいみみせん",
            "FR": "Bouchons Audio",
            "DE": "Top-Ohrenstöpsel",
            "ES": "Supertapones",
            "IT": "Supertappi",
            "KOR": "대단한귀마개",
            "CHS": "厉害耳塞",
            "CHT": "厲害耳塞"
        }
    ],
    "Fruit Bunch": [
        {
            "NO": 1211,
            "EN": "Fruit Bunch",
            "JP": "フサパック",
            "FR": "Fruits",
            "DE": "Früchte",
            "ES": "Fruta Tropical",
            "IT": "Frutti",
            "KOR": "송이팩",
            "CHS": "袋装果实",
            "CHT": "袋裝果實"
        }
    ],
    "Moomoo Cheese": [
        {
            "NO": 1212,
            "EN": "Moomoo Cheese",
            "JP": "モーモーチーズ",
            "FR": "Fromage Meumeu",
            "DE": "Kuhmuh-Käse",
            "ES": "Queso Mu-mu",
            "IT": "Formaggio Mumu",
            "KOR": "튼튼치즈",
            "CHS": "哞哞乳酪",
            "CHT": "哞哞乳酪"
        }
    ],
    "Spice Mix": [
        {
            "NO": 1213,
            "EN": "Spice Mix",
            "JP": "スパイスセット",
            "FR": "Épices",
            "DE": "Gewürzmix",
            "ES": "Especias",
            "IT": "Spezie assortite",
            "KOR": "스파이스세트",
            "CHS": "香料组合",
            "CHT": "香料組合"
        }
    ],
    "Fresh Cream": [
        {
            "NO": 1214,
            "EN": "Fresh Cream",
            "JP": "しんせんクリーム",
            "FR": "Crème Fraîche",
            "DE": "Frische Sahne",
            "ES": "Nata Fresca",
            "IT": "Panna da cucina",
            "KOR": "신선한크림",
            "CHS": "鲜鲜奶油",
            "CHT": "鮮鮮奶油"
        }
    ],
    "Packaged Curry": [
        {
            "NO": 1215,
            "EN": "Packaged Curry",
            "JP": "レトルトカレー",
            "FR": "Curry Instantané",
            "DE": "Fertigcurry",
            "ES": "Curri de Bote",
            "IT": "Curry precotto",
            "KOR": "레토르트카레",
            "CHS": "即食咖喱",
            "CHT": "即食咖哩"
        }
    ],
    "Coconut Milk": [
        {
            "NO": 1216,
            "EN": "Coconut Milk",
            "JP": "ヤシのミルク",
            "FR": "Lait de Coco",
            "DE": "Kokosmilch",
            "ES": "Leche de Coco",
            "IT": "Latte di cocco",
            "KOR": "야자밀크",
            "CHS": "椰奶",
            "CHT": "椰奶"
        }
    ],
    "Instant Noodles": [
        {
            "NO": 1217,
            "EN": "Instant Noodles",
            "JP": "レトルトめん",
            "FR": "Nouilles",
            "DE": "Fertignudeln",
            "ES": "Fideos de Bote",
            "IT": "Noodle precotti",
            "KOR": "레토르트면",
            "CHS": "即食面",
            "CHT": "即食麵"
        }
    ],
    "Precooked Burger": [
        {
            "NO": 1218,
            "EN": "Precooked Burger",
            "JP": "レトルトバーグ",
            "FR": "Steak Haché",
            "DE": "Frikadellen",
            "ES": "Hamburguesas",
            "IT": "Hamburger",
            "KOR": "레토르트햄버그",
            "CHS": "即食肉排",
            "CHT": "即食肉排"
        }
    ],
    "Gigantamix": [
        {
            "NO": 1219,
            "EN": "Gigantamix",
            "JP": "キョダイパウダー",
            "FR": "Poudre Gigamax",
            "DE": "Giga-Pulver",
            "ES": "Especias Gigamax",
            "IT": "Gigaspezia",
            "KOR": "거대파우더",
            "CHS": "超极粉",
            "CHT": "超極粉"
        }
    ],
    "Wishing Chip": [
        {
            "NO": 1220,
            "EN": "Wishing Chip",
            "JP": "ねがいのかけら",
            "FR": "Fragment Vœu",
            "DE": "Wunschsplitter",
            "ES": "Trocito Deseo",
            "IT": "Desioframmento",
            "KOR": "소원의조각",
            "CHS": "许愿星碎片",
            "CHT": "許願星碎片"
        }
    ],
    "Catching Charm": [
        {
            "NO": 1222,
            "EN": "Catching Charm",
            "JP": "ゆれないおまもり",
            "FR": "Charme Stabilité",
            "DE": "Superfangpin",
            "ES": "Amuleto Captura",
            "IT": "Catturamuleto",
            "KOR": "흔들림없는부적",
            "CHS": "防晃护符",
            "CHT": "防晃護符"
        }
    ],
    "Old Letter": [
        {
            "NO": 1223,
            "EN": "Old Letter",
            "JP": "ふるびたてがみ",
            "FR": "Lettre Jaunie",
            "DE": "Vergilbter Brief",
            "ES": "Carta Ajada",
            "IT": "Vecchia lettera",
            "KOR": "낡은편지",
            "CHS": "陈旧的信",
            "CHT": "陳舊的信"
        }
    ],
    "Band Autograph": [
        {
            "NO": 1224,
            "EN": "Band Autograph",
            "JP": "バンドのサイン",
            "FR": "Dédicace",
            "DE": "Band-Autogramm",
            "ES": "Autógrafo Grupo",
            "IT": "Autografo band",
            "KOR": "밴드의사인",
            "CHS": "乐队的签名",
            "CHT": "樂團的簽名"
        }
    ],
    "Sonia’s Book": [
        {
            "NO": 1225,
            "EN": "Sonia’s Book",
            "JP": "ソニアのほん",
            "FR": "Livre de Sonya",
            "DE": "Sanias Buch",
            "ES": "Libro de Sonia",
            "IT": "Libro di Sonia",
            "KOR": "소니아의책",
            "CHS": "索妮亚的书",
            "CHT": "索妮亞的書"
        }
    ],
    "Rotom Catalog": [
        {
            "NO": 1226,
            "EN": "Rotom Catalog",
            "JP": "ロトムのカタログ",
            "FR": "Moti-Catalogue",
            "DE": "Rotom-Katalog",
            "ES": "Catálogo Rotom",
            "IT": "Catalogo Rotom",
            "KOR": "로토무카탈로그",
            "CHS": "洛托姆型录",
            "CHT": "洛托姆型錄"
        }
    ],
    "★And458": [
        {
            "NO": 1227,
            "EN": "★And458",
            "JP": "★And458",
            "FR": "★And458",
            "DE": "★And458",
            "ES": "★And458",
            "IT": "★And458",
            "KOR": "★And458",
            "CHS": "★And458",
            "CHT": "★And458"
        }
    ],
    "★And15": [
        {
            "NO": 1228,
            "EN": "★And15",
            "JP": "★And15",
            "FR": "★And15",
            "DE": "★And15",
            "ES": "★And15",
            "IT": "★And15",
            "KOR": "★And15",
            "CHS": "★And15",
            "CHT": "★And15"
        }
    ],
    "★And337": [
        {
            "NO": 1229,
            "EN": "★And337",
            "JP": "★And337",
            "FR": "★And337",
            "DE": "★And337",
            "ES": "★And337",
            "IT": "★And337",
            "KOR": "★And337",
            "CHS": "★And337",
            "CHT": "★And337"
        }
    ],
    "★And603": [
        {
            "NO": 1230,
            "EN": "★And603",
            "JP": "★And603",
            "FR": "★And603",
            "DE": "★And603",
            "ES": "★And603",
            "IT": "★And603",
            "KOR": "★And603",
            "CHS": "★And603",
            "CHT": "★And603"
        }
    ],
    "★And390": [
        {
            "NO": 1231,
            "EN": "★And390",
            "JP": "★And390",
            "FR": "★And390",
            "DE": "★And390",
            "ES": "★And390",
            "IT": "★And390",
            "KOR": "★And390",
            "CHS": "★And390",
            "CHT": "★And390"
        }
    ],
    "★Sgr6879": [
        {
            "NO": 1232,
            "EN": "★Sgr6879",
            "JP": "★Sgr6879",
            "FR": "★Sgr6879",
            "DE": "★Sgr6879",
            "ES": "★Sgr6879",
            "IT": "★Sgr6879",
            "KOR": "★Sgr6879",
            "CHS": "★Sgr6879",
            "CHT": "★Sgr6879"
        }
    ],
    "★Sgr6859": [
        {
            "NO": 1233,
            "EN": "★Sgr6859",
            "JP": "★Sgr6859",
            "FR": "★Sgr6859",
            "DE": "★Sgr6859",
            "ES": "★Sgr6859",
            "IT": "★Sgr6859",
            "KOR": "★Sgr6859",
            "CHS": "★Sgr6859",
            "CHT": "★Sgr6859"
        }
    ],
    "★Sgr6913": [
        {
            "NO": 1234,
            "EN": "★Sgr6913",
            "JP": "★Sgr6913",
            "FR": "★Sgr6913",
            "DE": "★Sgr6913",
            "ES": "★Sgr6913",
            "IT": "★Sgr6913",
            "KOR": "★Sgr6913",
            "CHS": "★Sgr6913",
            "CHT": "★Sgr6913"
        }
    ],
    "★Sgr7348": [
        {
            "NO": 1235,
            "EN": "★Sgr7348",
            "JP": "★Sgr7348",
            "FR": "★Sgr7348",
            "DE": "★Sgr7348",
            "ES": "★Sgr7348",
            "IT": "★Sgr7348",
            "KOR": "★Sgr7348",
            "CHS": "★Sgr7348",
            "CHT": "★Sgr7348"
        }
    ],
    "★Sgr7121": [
        {
            "NO": 1236,
            "EN": "★Sgr7121",
            "JP": "★Sgr7121",
            "FR": "★Sgr7121",
            "DE": "★Sgr7121",
            "ES": "★Sgr7121",
            "IT": "★Sgr7121",
            "KOR": "★Sgr7121",
            "CHS": "★Sgr7121",
            "CHT": "★Sgr7121"
        }
    ],
    "★Sgr6746": [
        {
            "NO": 1237,
            "EN": "★Sgr6746",
            "JP": "★Sgr6746",
            "FR": "★Sgr6746",
            "DE": "★Sgr6746",
            "ES": "★Sgr6746",
            "IT": "★Sgr6746",
            "KOR": "★Sgr6746",
            "CHS": "★Sgr6746",
            "CHT": "★Sgr6746"
        }
    ],
    "★Sgr7194": [
        {
            "NO": 1238,
            "EN": "★Sgr7194",
            "JP": "★Sgr7194",
            "FR": "★Sgr7194",
            "DE": "★Sgr7194",
            "ES": "★Sgr7194",
            "IT": "★Sgr7194",
            "KOR": "★Sgr7194",
            "CHS": "★Sgr7194",
            "CHT": "★Sgr7194"
        }
    ],
    "★Sgr7337": [
        {
            "NO": 1239,
            "EN": "★Sgr7337",
            "JP": "★Sgr7337",
            "FR": "★Sgr7337",
            "DE": "★Sgr7337",
            "ES": "★Sgr7337",
            "IT": "★Sgr7337",
            "KOR": "★Sgr7337",
            "CHS": "★Sgr7337",
            "CHT": "★Sgr7337"
        }
    ],
    "★Sgr7343": [
        {
            "NO": 1240,
            "EN": "★Sgr7343",
            "JP": "★Sgr7343",
            "FR": "★Sgr7343",
            "DE": "★Sgr7343",
            "ES": "★Sgr7343",
            "IT": "★Sgr7343",
            "KOR": "★Sgr7343",
            "CHS": "★Sgr7343",
            "CHT": "★Sgr7343"
        }
    ],
    "★Sgr6812": [
        {
            "NO": 1241,
            "EN": "★Sgr6812",
            "JP": "★Sgr6812",
            "FR": "★Sgr6812",
            "DE": "★Sgr6812",
            "ES": "★Sgr6812",
            "IT": "★Sgr6812",
            "KOR": "★Sgr6812",
            "CHS": "★Sgr6812",
            "CHT": "★Sgr6812"
        }
    ],
    "★Sgr7116": [
        {
            "NO": 1242,
            "EN": "★Sgr7116",
            "JP": "★Sgr7116",
            "FR": "★Sgr7116",
            "DE": "★Sgr7116",
            "ES": "★Sgr7116",
            "IT": "★Sgr7116",
            "KOR": "★Sgr7116",
            "CHS": "★Sgr7116",
            "CHT": "★Sgr7116"
        }
    ],
    "★Sgr7264": [
        {
            "NO": 1243,
            "EN": "★Sgr7264",
            "JP": "★Sgr7264",
            "FR": "★Sgr7264",
            "DE": "★Sgr7264",
            "ES": "★Sgr7264",
            "IT": "★Sgr7264",
            "KOR": "★Sgr7264",
            "CHS": "★Sgr7264",
            "CHT": "★Sgr7264"
        }
    ],
    "★Sgr7597": [
        {
            "NO": 1244,
            "EN": "★Sgr7597",
            "JP": "★Sgr7597",
            "FR": "★Sgr7597",
            "DE": "★Sgr7597",
            "ES": "★Sgr7597",
            "IT": "★Sgr7597",
            "KOR": "★Sgr7597",
            "CHS": "★Sgr7597",
            "CHT": "★Sgr7597"
        }
    ],
    "★Del7882": [
        {
            "NO": 1245,
            "EN": "★Del7882",
            "JP": "★Del7882",
            "FR": "★Del7882",
            "DE": "★Del7882",
            "ES": "★Del7882",
            "IT": "★Del7882",
            "KOR": "★Del7882",
            "CHS": "★Del7882",
            "CHT": "★Del7882"
        }
    ],
    "★Del7906": [
        {
            "NO": 1246,
            "EN": "★Del7906",
            "JP": "★Del7906",
            "FR": "★Del7906",
            "DE": "★Del7906",
            "ES": "★Del7906",
            "IT": "★Del7906",
            "KOR": "★Del7906",
            "CHS": "★Del7906",
            "CHT": "★Del7906"
        }
    ],
    "★Del7852": [
        {
            "NO": 1247,
            "EN": "★Del7852",
            "JP": "★Del7852",
            "FR": "★Del7852",
            "DE": "★Del7852",
            "ES": "★Del7852",
            "IT": "★Del7852",
            "KOR": "★Del7852",
            "CHS": "★Del7852",
            "CHT": "★Del7852"
        }
    ],
    "★Psc596": [
        {
            "NO": 1248,
            "EN": "★Psc596",
            "JP": "★Psc596",
            "FR": "★Psc596",
            "DE": "★Psc596",
            "ES": "★Psc596",
            "IT": "★Psc596",
            "KOR": "★Psc596",
            "CHS": "★Psc596",
            "CHT": "★Psc596"
        }
    ],
    "★Psc361": [
        {
            "NO": 1249,
            "EN": "★Psc361",
            "JP": "★Psc361",
            "FR": "★Psc361",
            "DE": "★Psc361",
            "ES": "★Psc361",
            "IT": "★Psc361",
            "KOR": "★Psc361",
            "CHS": "★Psc361",
            "CHT": "★Psc361"
        }
    ],
    "★Psc510": [
        {
            "NO": 1250,
            "EN": "★Psc510",
            "JP": "★Psc510",
            "FR": "★Psc510",
            "DE": "★Psc510",
            "ES": "★Psc510",
            "IT": "★Psc510",
            "KOR": "★Psc510",
            "CHS": "★Psc510",
            "CHT": "★Psc510"
        }
    ],
    "★Psc437": [
        {
            "NO": 1251,
            "EN": "★Psc437",
            "JP": "★Psc437",
            "FR": "★Psc437",
            "DE": "★Psc437",
            "ES": "★Psc437",
            "IT": "★Psc437",
            "KOR": "★Psc437",
            "CHS": "★Psc437",
            "CHT": "★Psc437"
        }
    ],
    "★Psc8773": [
        {
            "NO": 1252,
            "EN": "★Psc8773",
            "JP": "★Psc8773",
            "FR": "★Psc8773",
            "DE": "★Psc8773",
            "ES": "★Psc8773",
            "IT": "★Psc8773",
            "KOR": "★Psc8773",
            "CHS": "★Psc8773",
            "CHT": "★Psc8773"
        }
    ],
    "★Lep1865": [
        {
            "NO": 1253,
            "EN": "★Lep1865",
            "JP": "★Lep1865",
            "FR": "★Lep1865",
            "DE": "★Lep1865",
            "ES": "★Lep1865",
            "IT": "★Lep1865",
            "KOR": "★Lep1865",
            "CHS": "★Lep1865",
            "CHT": "★Lep1865"
        }
    ],
    "★Lep1829": [
        {
            "NO": 1254,
            "EN": "★Lep1829",
            "JP": "★Lep1829",
            "FR": "★Lep1829",
            "DE": "★Lep1829",
            "ES": "★Lep1829",
            "IT": "★Lep1829",
            "KOR": "★Lep1829",
            "CHS": "★Lep1829",
            "CHT": "★Lep1829"
        }
    ],
    "★Boo5340": [
        {
            "NO": 1255,
            "EN": "★Boo5340",
            "JP": "★Boo5340",
            "FR": "★Boo5340",
            "DE": "★Boo5340",
            "ES": "★Boo5340",
            "IT": "★Boo5340",
            "KOR": "★Boo5340",
            "CHS": "★Boo5340",
            "CHT": "★Boo5340"
        }
    ],
    "★Boo5506": [
        {
            "NO": 1256,
            "EN": "★Boo5506",
            "JP": "★Boo5506",
            "FR": "★Boo5506",
            "DE": "★Boo5506",
            "ES": "★Boo5506",
            "IT": "★Boo5506",
            "KOR": "★Boo5506",
            "CHS": "★Boo5506",
            "CHT": "★Boo5506"
        }
    ],
    "★Boo5435": [
        {
            "NO": 1257,
            "EN": "★Boo5435",
            "JP": "★Boo5435",
            "FR": "★Boo5435",
            "DE": "★Boo5435",
            "ES": "★Boo5435",
            "IT": "★Boo5435",
            "KOR": "★Boo5435",
            "CHS": "★Boo5435",
            "CHT": "★Boo5435"
        }
    ],
    "★Boo5602": [
        {
            "NO": 1258,
            "EN": "★Boo5602",
            "JP": "★Boo5602",
            "FR": "★Boo5602",
            "DE": "★Boo5602",
            "ES": "★Boo5602",
            "IT": "★Boo5602",
            "KOR": "★Boo5602",
            "CHS": "★Boo5602",
            "CHT": "★Boo5602"
        }
    ],
    "★Boo5733": [
        {
            "NO": 1259,
            "EN": "★Boo5733",
            "JP": "★Boo5733",
            "FR": "★Boo5733",
            "DE": "★Boo5733",
            "ES": "★Boo5733",
            "IT": "★Boo5733",
            "KOR": "★Boo5733",
            "CHS": "★Boo5733",
            "CHT": "★Boo5733"
        }
    ],
    "★Boo5235": [
        {
            "NO": 1260,
            "EN": "★Boo5235",
            "JP": "★Boo5235",
            "FR": "★Boo5235",
            "DE": "★Boo5235",
            "ES": "★Boo5235",
            "IT": "★Boo5235",
            "KOR": "★Boo5235",
            "CHS": "★Boo5235",
            "CHT": "★Boo5235"
        }
    ],
    "★Boo5351": [
        {
            "NO": 1261,
            "EN": "★Boo5351",
            "JP": "★Boo5351",
            "FR": "★Boo5351",
            "DE": "★Boo5351",
            "ES": "★Boo5351",
            "IT": "★Boo5351",
            "KOR": "★Boo5351",
            "CHS": "★Boo5351",
            "CHT": "★Boo5351"
        }
    ],
    "★Hya3748": [
        {
            "NO": 1262,
            "EN": "★Hya3748",
            "JP": "★Hya3748",
            "FR": "★Hya3748",
            "DE": "★Hya3748",
            "ES": "★Hya3748",
            "IT": "★Hya3748",
            "KOR": "★Hya3748",
            "CHS": "★Hya3748",
            "CHT": "★Hya3748"
        }
    ],
    "★Hya3903": [
        {
            "NO": 1263,
            "EN": "★Hya3903",
            "JP": "★Hya3903",
            "FR": "★Hya3903",
            "DE": "★Hya3903",
            "ES": "★Hya3903",
            "IT": "★Hya3903",
            "KOR": "★Hya3903",
            "CHS": "★Hya3903",
            "CHT": "★Hya3903"
        }
    ],
    "★Hya3418": [
        {
            "NO": 1264,
            "EN": "★Hya3418",
            "JP": "★Hya3418",
            "FR": "★Hya3418",
            "DE": "★Hya3418",
            "ES": "★Hya3418",
            "IT": "★Hya3418",
            "KOR": "★Hya3418",
            "CHS": "★Hya3418",
            "CHT": "★Hya3418"
        }
    ],
    "★Hya3482": [
        {
            "NO": 1265,
            "EN": "★Hya3482",
            "JP": "★Hya3482",
            "FR": "★Hya3482",
            "DE": "★Hya3482",
            "ES": "★Hya3482",
            "IT": "★Hya3482",
            "KOR": "★Hya3482",
            "CHS": "★Hya3482",
            "CHT": "★Hya3482"
        }
    ],
    "★Hya3845": [
        {
            "NO": 1266,
            "EN": "★Hya3845",
            "JP": "★Hya3845",
            "FR": "★Hya3845",
            "DE": "★Hya3845",
            "ES": "★Hya3845",
            "IT": "★Hya3845",
            "KOR": "★Hya3845",
            "CHS": "★Hya3845",
            "CHT": "★Hya3845"
        }
    ],
    "★Eri1084": [
        {
            "NO": 1267,
            "EN": "★Eri1084",
            "JP": "★Eri1084",
            "FR": "★Eri1084",
            "DE": "★Eri1084",
            "ES": "★Eri1084",
            "IT": "★Eri1084",
            "KOR": "★Eri1084",
            "CHS": "★Eri1084",
            "CHT": "★Eri1084"
        }
    ],
    "★Eri472": [
        {
            "NO": 1268,
            "EN": "★Eri472",
            "JP": "★Eri472",
            "FR": "★Eri472",
            "DE": "★Eri472",
            "ES": "★Eri472",
            "IT": "★Eri472",
            "KOR": "★Eri472",
            "CHS": "★Eri472",
            "CHT": "★Eri472"
        }
    ],
    "★Eri1666": [
        {
            "NO": 1269,
            "EN": "★Eri1666",
            "JP": "★Eri1666",
            "FR": "★Eri1666",
            "DE": "★Eri1666",
            "ES": "★Eri1666",
            "IT": "★Eri1666",
            "KOR": "★Eri1666",
            "CHS": "★Eri1666",
            "CHT": "★Eri1666"
        }
    ],
    "★Eri897": [
        {
            "NO": 1270,
            "EN": "★Eri897",
            "JP": "★Eri897",
            "FR": "★Eri897",
            "DE": "★Eri897",
            "ES": "★Eri897",
            "IT": "★Eri897",
            "KOR": "★Eri897",
            "CHS": "★Eri897",
            "CHT": "★Eri897"
        }
    ],
    "★Eri1231": [
        {
            "NO": 1271,
            "EN": "★Eri1231",
            "JP": "★Eri1231",
            "FR": "★Eri1231",
            "DE": "★Eri1231",
            "ES": "★Eri1231",
            "IT": "★Eri1231",
            "KOR": "★Eri1231",
            "CHS": "★Eri1231",
            "CHT": "★Eri1231"
        }
    ],
    "★Eri874": [
        {
            "NO": 1272,
            "EN": "★Eri874",
            "JP": "★Eri874",
            "FR": "★Eri874",
            "DE": "★Eri874",
            "ES": "★Eri874",
            "IT": "★Eri874",
            "KOR": "★Eri874",
            "CHS": "★Eri874",
            "CHT": "★Eri874"
        }
    ],
    "★Eri1298": [
        {
            "NO": 1273,
            "EN": "★Eri1298",
            "JP": "★Eri1298",
            "FR": "★Eri1298",
            "DE": "★Eri1298",
            "ES": "★Eri1298",
            "IT": "★Eri1298",
            "KOR": "★Eri1298",
            "CHS": "★Eri1298",
            "CHT": "★Eri1298"
        }
    ],
    "★Eri1325": [
        {
            "NO": 1274,
            "EN": "★Eri1325",
            "JP": "★Eri1325",
            "FR": "★Eri1325",
            "DE": "★Eri1325",
            "ES": "★Eri1325",
            "IT": "★Eri1325",
            "KOR": "★Eri1325",
            "CHS": "★Eri1325",
            "CHT": "★Eri1325"
        }
    ],
    "★Eri984": [
        {
            "NO": 1275,
            "EN": "★Eri984",
            "JP": "★Eri984",
            "FR": "★Eri984",
            "DE": "★Eri984",
            "ES": "★Eri984",
            "IT": "★Eri984",
            "KOR": "★Eri984",
            "CHS": "★Eri984",
            "CHT": "★Eri984"
        }
    ],
    "★Eri1464": [
        {
            "NO": 1276,
            "EN": "★Eri1464",
            "JP": "★Eri1464",
            "FR": "★Eri1464",
            "DE": "★Eri1464",
            "ES": "★Eri1464",
            "IT": "★Eri1464",
            "KOR": "★Eri1464",
            "CHS": "★Eri1464",
            "CHT": "★Eri1464"
        }
    ],
    "★Eri1393": [
        {
            "NO": 1277,
            "EN": "★Eri1393",
            "JP": "★Eri1393",
            "FR": "★Eri1393",
            "DE": "★Eri1393",
            "ES": "★Eri1393",
            "IT": "★Eri1393",
            "KOR": "★Eri1393",
            "CHS": "★Eri1393",
            "CHT": "★Eri1393"
        }
    ],
    "★Eri850": [
        {
            "NO": 1278,
            "EN": "★Eri850",
            "JP": "★Eri850",
            "FR": "★Eri850",
            "DE": "★Eri850",
            "ES": "★Eri850",
            "IT": "★Eri850",
            "KOR": "★Eri850",
            "CHS": "★Eri850",
            "CHT": "★Eri850"
        }
    ],
    "★Tau1409": [
        {
            "NO": 1279,
            "EN": "★Tau1409",
            "JP": "★Tau1409",
            "FR": "★Tau1409",
            "DE": "★Tau1409",
            "ES": "★Tau1409",
            "IT": "★Tau1409",
            "KOR": "★Tau1409",
            "CHS": "★Tau1409",
            "CHT": "★Tau1409"
        }
    ],
    "★Tau1457": [
        {
            "NO": 1280,
            "EN": "★Tau1457",
            "JP": "★Tau1457",
            "FR": "★Tau1457",
            "DE": "★Tau1457",
            "ES": "★Tau1457",
            "IT": "★Tau1457",
            "KOR": "★Tau1457",
            "CHS": "★Tau1457",
            "CHT": "★Tau1457"
        }
    ],
    "★Tau1165": [
        {
            "NO": 1281,
            "EN": "★Tau1165",
            "JP": "★Tau1165",
            "FR": "★Tau1165",
            "DE": "★Tau1165",
            "ES": "★Tau1165",
            "IT": "★Tau1165",
            "KOR": "★Tau1165",
            "CHS": "★Tau1165",
            "CHT": "★Tau1165"
        }
    ],
    "★Tau1791": [
        {
            "NO": 1282,
            "EN": "★Tau1791",
            "JP": "★Tau1791",
            "FR": "★Tau1791",
            "DE": "★Tau1791",
            "ES": "★Tau1791",
            "IT": "★Tau1791",
            "KOR": "★Tau1791",
            "CHS": "★Tau1791",
            "CHT": "★Tau1791"
        }
    ],
    "★Tau1910": [
        {
            "NO": 1283,
            "EN": "★Tau1910",
            "JP": "★Tau1910",
            "FR": "★Tau1910",
            "DE": "★Tau1910",
            "ES": "★Tau1910",
            "IT": "★Tau1910",
            "KOR": "★Tau1910",
            "CHS": "★Tau1910",
            "CHT": "★Tau1910"
        }
    ],
    "★Tau1346": [
        {
            "NO": 1284,
            "EN": "★Tau1346",
            "JP": "★Tau1346",
            "FR": "★Tau1346",
            "DE": "★Tau1346",
            "ES": "★Tau1346",
            "IT": "★Tau1346",
            "KOR": "★Tau1346",
            "CHS": "★Tau1346",
            "CHT": "★Tau1346"
        }
    ],
    "★Tau1373": [
        {
            "NO": 1285,
            "EN": "★Tau1373",
            "JP": "★Tau1373",
            "FR": "★Tau1373",
            "DE": "★Tau1373",
            "ES": "★Tau1373",
            "IT": "★Tau1373",
            "KOR": "★Tau1373",
            "CHS": "★Tau1373",
            "CHT": "★Tau1373"
        }
    ],
    "★Tau1412": [
        {
            "NO": 1286,
            "EN": "★Tau1412",
            "JP": "★Tau1412",
            "FR": "★Tau1412",
            "DE": "★Tau1412",
            "ES": "★Tau1412",
            "IT": "★Tau1412",
            "KOR": "★Tau1412",
            "CHS": "★Tau1412",
            "CHT": "★Tau1412"
        }
    ],
    "★CMa2491": [
        {
            "NO": 1287,
            "EN": "★CMa2491",
            "JP": "★CMa2491",
            "FR": "★CMa2491",
            "DE": "★CMa2491",
            "ES": "★CMa2491",
            "IT": "★CMa2491",
            "KOR": "★CMa2491",
            "CHS": "★CMa2491",
            "CHT": "★CMa2491"
        }
    ],
    "★CMa2693": [
        {
            "NO": 1288,
            "EN": "★CMa2693",
            "JP": "★CMa2693",
            "FR": "★CMa2693",
            "DE": "★CMa2693",
            "ES": "★CMa2693",
            "IT": "★CMa2693",
            "KOR": "★CMa2693",
            "CHS": "★CMa2693",
            "CHT": "★CMa2693"
        }
    ],
    "★CMa2294": [
        {
            "NO": 1289,
            "EN": "★CMa2294",
            "JP": "★CMa2294",
            "FR": "★CMa2294",
            "DE": "★CMa2294",
            "ES": "★CMa2294",
            "IT": "★CMa2294",
            "KOR": "★CMa2294",
            "CHS": "★CMa2294",
            "CHT": "★CMa2294"
        }
    ],
    "★CMa2827": [
        {
            "NO": 1290,
            "EN": "★CMa2827",
            "JP": "★CMa2827",
            "FR": "★CMa2827",
            "DE": "★CMa2827",
            "ES": "★CMa2827",
            "IT": "★CMa2827",
            "KOR": "★CMa2827",
            "CHS": "★CMa2827",
            "CHT": "★CMa2827"
        }
    ],
    "★CMa2282": [
        {
            "NO": 1291,
            "EN": "★CMa2282",
            "JP": "★CMa2282",
            "FR": "★CMa2282",
            "DE": "★CMa2282",
            "ES": "★CMa2282",
            "IT": "★CMa2282",
            "KOR": "★CMa2282",
            "CHS": "★CMa2282",
            "CHT": "★CMa2282"
        }
    ],
    "★CMa2618": [
        {
            "NO": 1292,
            "EN": "★CMa2618",
            "JP": "★CMa2618",
            "FR": "★CMa2618",
            "DE": "★CMa2618",
            "ES": "★CMa2618",
            "IT": "★CMa2618",
            "KOR": "★CMa2618",
            "CHS": "★CMa2618",
            "CHT": "★CMa2618"
        }
    ],
    "★CMa2657": [
        {
            "NO": 1293,
            "EN": "★CMa2657",
            "JP": "★CMa2657",
            "FR": "★CMa2657",
            "DE": "★CMa2657",
            "ES": "★CMa2657",
            "IT": "★CMa2657",
            "KOR": "★CMa2657",
            "CHS": "★CMa2657",
            "CHT": "★CMa2657"
        }
    ],
    "★CMa2646": [
        {
            "NO": 1294,
            "EN": "★CMa2646",
            "JP": "★CMa2646",
            "FR": "★CMa2646",
            "DE": "★CMa2646",
            "ES": "★CMa2646",
            "IT": "★CMa2646",
            "KOR": "★CMa2646",
            "CHS": "★CMa2646",
            "CHT": "★CMa2646"
        }
    ],
    "★UMa4905": [
        {
            "NO": 1295,
            "EN": "★UMa4905",
            "JP": "★UMa4905",
            "FR": "★UMa4905",
            "DE": "★UMa4905",
            "ES": "★UMa4905",
            "IT": "★UMa4905",
            "KOR": "★UMa4905",
            "CHS": "★UMa4905",
            "CHT": "★UMa4905"
        }
    ],
    "★UMa4301": [
        {
            "NO": 1296,
            "EN": "★UMa4301",
            "JP": "★UMa4301",
            "FR": "★UMa4301",
            "DE": "★UMa4301",
            "ES": "★UMa4301",
            "IT": "★UMa4301",
            "KOR": "★UMa4301",
            "CHS": "★UMa4301",
            "CHT": "★UMa4301"
        }
    ],
    "★UMa5191": [
        {
            "NO": 1297,
            "EN": "★UMa5191",
            "JP": "★UMa5191",
            "FR": "★UMa5191",
            "DE": "★UMa5191",
            "ES": "★UMa5191",
            "IT": "★UMa5191",
            "KOR": "★UMa5191",
            "CHS": "★UMa5191",
            "CHT": "★UMa5191"
        }
    ],
    "★UMa5054": [
        {
            "NO": 1298,
            "EN": "★UMa5054",
            "JP": "★UMa5054",
            "FR": "★UMa5054",
            "DE": "★UMa5054",
            "ES": "★UMa5054",
            "IT": "★UMa5054",
            "KOR": "★UMa5054",
            "CHS": "★UMa5054",
            "CHT": "★UMa5054"
        }
    ],
    "★UMa4295": [
        {
            "NO": 1299,
            "EN": "★UMa4295",
            "JP": "★UMa4295",
            "FR": "★UMa4295",
            "DE": "★UMa4295",
            "ES": "★UMa4295",
            "IT": "★UMa4295",
            "KOR": "★UMa4295",
            "CHS": "★UMa4295",
            "CHT": "★UMa4295"
        }
    ],
    "★UMa4660": [
        {
            "NO": 1300,
            "EN": "★UMa4660",
            "JP": "★UMa4660",
            "FR": "★UMa4660",
            "DE": "★UMa4660",
            "ES": "★UMa4660",
            "IT": "★UMa4660",
            "KOR": "★UMa4660",
            "CHS": "★UMa4660",
            "CHT": "★UMa4660"
        }
    ],
    "★UMa4554": [
        {
            "NO": 1301,
            "EN": "★UMa4554",
            "JP": "★UMa4554",
            "FR": "★UMa4554",
            "DE": "★UMa4554",
            "ES": "★UMa4554",
            "IT": "★UMa4554",
            "KOR": "★UMa4554",
            "CHS": "★UMa4554",
            "CHT": "★UMa4554"
        }
    ],
    "★UMa4069": [
        {
            "NO": 1302,
            "EN": "★UMa4069",
            "JP": "★UMa4069",
            "FR": "★UMa4069",
            "DE": "★UMa4069",
            "ES": "★UMa4069",
            "IT": "★UMa4069",
            "KOR": "★UMa4069",
            "CHS": "★UMa4069",
            "CHT": "★UMa4069"
        }
    ],
    "★UMa3569": [
        {
            "NO": 1303,
            "EN": "★UMa3569",
            "JP": "★UMa3569",
            "FR": "★UMa3569",
            "DE": "★UMa3569",
            "ES": "★UMa3569",
            "IT": "★UMa3569",
            "KOR": "★UMa3569",
            "CHS": "★UMa3569",
            "CHT": "★UMa3569"
        }
    ],
    "★UMa3323": [
        {
            "NO": 1304,
            "EN": "★UMa3323",
            "JP": "★UMa3323",
            "FR": "★UMa3323",
            "DE": "★UMa3323",
            "ES": "★UMa3323",
            "IT": "★UMa3323",
            "KOR": "★UMa3323",
            "CHS": "★UMa3323",
            "CHT": "★UMa3323"
        }
    ],
    "★UMa4033": [
        {
            "NO": 1305,
            "EN": "★UMa4033",
            "JP": "★UMa4033",
            "FR": "★UMa4033",
            "DE": "★UMa4033",
            "ES": "★UMa4033",
            "IT": "★UMa4033",
            "KOR": "★UMa4033",
            "CHS": "★UMa4033",
            "CHT": "★UMa4033"
        }
    ],
    "★UMa4377": [
        {
            "NO": 1306,
            "EN": "★UMa4377",
            "JP": "★UMa4377",
            "FR": "★UMa4377",
            "DE": "★UMa4377",
            "ES": "★UMa4377",
            "IT": "★UMa4377",
            "KOR": "★UMa4377",
            "CHS": "★UMa4377",
            "CHT": "★UMa4377"
        }
    ],
    "★UMa4375": [
        {
            "NO": 1307,
            "EN": "★UMa4375",
            "JP": "★UMa4375",
            "FR": "★UMa4375",
            "DE": "★UMa4375",
            "ES": "★UMa4375",
            "IT": "★UMa4375",
            "KOR": "★UMa4375",
            "CHS": "★UMa4375",
            "CHT": "★UMa4375"
        }
    ],
    "★UMa4518": [
        {
            "NO": 1308,
            "EN": "★UMa4518",
            "JP": "★UMa4518",
            "FR": "★UMa4518",
            "DE": "★UMa4518",
            "ES": "★UMa4518",
            "IT": "★UMa4518",
            "KOR": "★UMa4518",
            "CHS": "★UMa4518",
            "CHT": "★UMa4518"
        }
    ],
    "★UMa3594": [
        {
            "NO": 1309,
            "EN": "★UMa3594",
            "JP": "★UMa3594",
            "FR": "★UMa3594",
            "DE": "★UMa3594",
            "ES": "★UMa3594",
            "IT": "★UMa3594",
            "KOR": "★UMa3594",
            "CHS": "★UMa3594",
            "CHT": "★UMa3594"
        }
    ],
    "★Vir5056": [
        {
            "NO": 1310,
            "EN": "★Vir5056",
            "JP": "★Vir5056",
            "FR": "★Vir5056",
            "DE": "★Vir5056",
            "ES": "★Vir5056",
            "IT": "★Vir5056",
            "KOR": "★Vir5056",
            "CHS": "★Vir5056",
            "CHT": "★Vir5056"
        }
    ],
    "★Vir4825": [
        {
            "NO": 1311,
            "EN": "★Vir4825",
            "JP": "★Vir4825",
            "FR": "★Vir4825",
            "DE": "★Vir4825",
            "ES": "★Vir4825",
            "IT": "★Vir4825",
            "KOR": "★Vir4825",
            "CHS": "★Vir4825",
            "CHT": "★Vir4825"
        }
    ],
    "★Vir4932": [
        {
            "NO": 1312,
            "EN": "★Vir4932",
            "JP": "★Vir4932",
            "FR": "★Vir4932",
            "DE": "★Vir4932",
            "ES": "★Vir4932",
            "IT": "★Vir4932",
            "KOR": "★Vir4932",
            "CHS": "★Vir4932",
            "CHT": "★Vir4932"
        }
    ],
    "★Vir4540": [
        {
            "NO": 1313,
            "EN": "★Vir4540",
            "JP": "★Vir4540",
            "FR": "★Vir4540",
            "DE": "★Vir4540",
            "ES": "★Vir4540",
            "IT": "★Vir4540",
            "KOR": "★Vir4540",
            "CHS": "★Vir4540",
            "CHT": "★Vir4540"
        }
    ],
    "★Vir4689": [
        {
            "NO": 1314,
            "EN": "★Vir4689",
            "JP": "★Vir4689",
            "FR": "★Vir4689",
            "DE": "★Vir4689",
            "ES": "★Vir4689",
            "IT": "★Vir4689",
            "KOR": "★Vir4689",
            "CHS": "★Vir4689",
            "CHT": "★Vir4689"
        }
    ],
    "★Vir5338": [
        {
            "NO": 1315,
            "EN": "★Vir5338",
            "JP": "★Vir5338",
            "FR": "★Vir5338",
            "DE": "★Vir5338",
            "ES": "★Vir5338",
            "IT": "★Vir5338",
            "KOR": "★Vir5338",
            "CHS": "★Vir5338",
            "CHT": "★Vir5338"
        }
    ],
    "★Vir4910": [
        {
            "NO": 1316,
            "EN": "★Vir4910",
            "JP": "★Vir4910",
            "FR": "★Vir4910",
            "DE": "★Vir4910",
            "ES": "★Vir4910",
            "IT": "★Vir4910",
            "KOR": "★Vir4910",
            "CHS": "★Vir4910",
            "CHT": "★Vir4910"
        }
    ],
    "★Vir5315": [
        {
            "NO": 1317,
            "EN": "★Vir5315",
            "JP": "★Vir5315",
            "FR": "★Vir5315",
            "DE": "★Vir5315",
            "ES": "★Vir5315",
            "IT": "★Vir5315",
            "KOR": "★Vir5315",
            "CHS": "★Vir5315",
            "CHT": "★Vir5315"
        }
    ],
    "★Vir5359": [
        {
            "NO": 1318,
            "EN": "★Vir5359",
            "JP": "★Vir5359",
            "FR": "★Vir5359",
            "DE": "★Vir5359",
            "ES": "★Vir5359",
            "IT": "★Vir5359",
            "KOR": "★Vir5359",
            "CHS": "★Vir5359",
            "CHT": "★Vir5359"
        }
    ],
    "★Vir5409": [
        {
            "NO": 1319,
            "EN": "★Vir5409",
            "JP": "★Vir5409",
            "FR": "★Vir5409",
            "DE": "★Vir5409",
            "ES": "★Vir5409",
            "IT": "★Vir5409",
            "KOR": "★Vir5409",
            "CHS": "★Vir5409",
            "CHT": "★Vir5409"
        }
    ],
    "★Vir5107": [
        {
            "NO": 1320,
            "EN": "★Vir5107",
            "JP": "★Vir5107",
            "FR": "★Vir5107",
            "DE": "★Vir5107",
            "ES": "★Vir5107",
            "IT": "★Vir5107",
            "KOR": "★Vir5107",
            "CHS": "★Vir5107",
            "CHT": "★Vir5107"
        }
    ],
    "★Ari617": [
        {
            "NO": 1321,
            "EN": "★Ari617",
            "JP": "★Ari617",
            "FR": "★Ari617",
            "DE": "★Ari617",
            "ES": "★Ari617",
            "IT": "★Ari617",
            "KOR": "★Ari617",
            "CHS": "★Ari617",
            "CHT": "★Ari617"
        }
    ],
    "★Ari553": [
        {
            "NO": 1322,
            "EN": "★Ari553",
            "JP": "★Ari553",
            "FR": "★Ari553",
            "DE": "★Ari553",
            "ES": "★Ari553",
            "IT": "★Ari553",
            "KOR": "★Ari553",
            "CHS": "★Ari553",
            "CHT": "★Ari553"
        }
    ],
    "★Ari546": [
        {
            "NO": 1323,
            "EN": "★Ari546",
            "JP": "★Ari546",
            "FR": "★Ari546",
            "DE": "★Ari546",
            "ES": "★Ari546",
            "IT": "★Ari546",
            "KOR": "★Ari546",
            "CHS": "★Ari546",
            "CHT": "★Ari546"
        }
    ],
    "★Ari951": [
        {
            "NO": 1324,
            "EN": "★Ari951",
            "JP": "★Ari951",
            "FR": "★Ari951",
            "DE": "★Ari951",
            "ES": "★Ari951",
            "IT": "★Ari951",
            "KOR": "★Ari951",
            "CHS": "★Ari951",
            "CHT": "★Ari951"
        }
    ],
    "★Ori1713": [
        {
            "NO": 1325,
            "EN": "★Ori1713",
            "JP": "★Ori1713",
            "FR": "★Ori1713",
            "DE": "★Ori1713",
            "ES": "★Ori1713",
            "IT": "★Ori1713",
            "KOR": "★Ori1713",
            "CHS": "★Ori1713",
            "CHT": "★Ori1713"
        }
    ],
    "★Ori2061": [
        {
            "NO": 1326,
            "EN": "★Ori2061",
            "JP": "★Ori2061",
            "FR": "★Ori2061",
            "DE": "★Ori2061",
            "ES": "★Ori2061",
            "IT": "★Ori2061",
            "KOR": "★Ori2061",
            "CHS": "★Ori2061",
            "CHT": "★Ori2061"
        }
    ],
    "★Ori1790": [
        {
            "NO": 1327,
            "EN": "★Ori1790",
            "JP": "★Ori1790",
            "FR": "★Ori1790",
            "DE": "★Ori1790",
            "ES": "★Ori1790",
            "IT": "★Ori1790",
            "KOR": "★Ori1790",
            "CHS": "★Ori1790",
            "CHT": "★Ori1790"
        }
    ],
    "★Ori1903": [
        {
            "NO": 1328,
            "EN": "★Ori1903",
            "JP": "★Ori1903",
            "FR": "★Ori1903",
            "DE": "★Ori1903",
            "ES": "★Ori1903",
            "IT": "★Ori1903",
            "KOR": "★Ori1903",
            "CHS": "★Ori1903",
            "CHT": "★Ori1903"
        }
    ],
    "★Ori1948": [
        {
            "NO": 1329,
            "EN": "★Ori1948",
            "JP": "★Ori1948",
            "FR": "★Ori1948",
            "DE": "★Ori1948",
            "ES": "★Ori1948",
            "IT": "★Ori1948",
            "KOR": "★Ori1948",
            "CHS": "★Ori1948",
            "CHT": "★Ori1948"
        }
    ],
    "★Ori2004": [
        {
            "NO": 1330,
            "EN": "★Ori2004",
            "JP": "★Ori2004",
            "FR": "★Ori2004",
            "DE": "★Ori2004",
            "ES": "★Ori2004",
            "IT": "★Ori2004",
            "KOR": "★Ori2004",
            "CHS": "★Ori2004",
            "CHT": "★Ori2004"
        }
    ],
    "★Ori1852": [
        {
            "NO": 1331,
            "EN": "★Ori1852",
            "JP": "★Ori1852",
            "FR": "★Ori1852",
            "DE": "★Ori1852",
            "ES": "★Ori1852",
            "IT": "★Ori1852",
            "KOR": "★Ori1852",
            "CHS": "★Ori1852",
            "CHT": "★Ori1852"
        }
    ],
    "★Ori1879": [
        {
            "NO": 1332,
            "EN": "★Ori1879",
            "JP": "★Ori1879",
            "FR": "★Ori1879",
            "DE": "★Ori1879",
            "ES": "★Ori1879",
            "IT": "★Ori1879",
            "KOR": "★Ori1879",
            "CHS": "★Ori1879",
            "CHT": "★Ori1879"
        }
    ],
    "★Ori1899": [
        {
            "NO": 1333,
            "EN": "★Ori1899",
            "JP": "★Ori1899",
            "FR": "★Ori1899",
            "DE": "★Ori1899",
            "ES": "★Ori1899",
            "IT": "★Ori1899",
            "KOR": "★Ori1899",
            "CHS": "★Ori1899",
            "CHT": "★Ori1899"
        }
    ],
    "★Ori1543": [
        {
            "NO": 1334,
            "EN": "★Ori1543",
            "JP": "★Ori1543",
            "FR": "★Ori1543",
            "DE": "★Ori1543",
            "ES": "★Ori1543",
            "IT": "★Ori1543",
            "KOR": "★Ori1543",
            "CHS": "★Ori1543",
            "CHT": "★Ori1543"
        }
    ],
    "★Cas21": [
        {
            "NO": 1335,
            "EN": "★Cas21",
            "JP": "★Cas21",
            "FR": "★Cas21",
            "DE": "★Cas21",
            "ES": "★Cas21",
            "IT": "★Cas21",
            "KOR": "★Cas21",
            "CHS": "★Cas21",
            "CHT": "★Cas21"
        }
    ],
    "★Cas168": [
        {
            "NO": 1336,
            "EN": "★Cas168",
            "JP": "★Cas168",
            "FR": "★Cas168",
            "DE": "★Cas168",
            "ES": "★Cas168",
            "IT": "★Cas168",
            "KOR": "★Cas168",
            "CHS": "★Cas168",
            "CHT": "★Cas168"
        }
    ],
    "★Cas403": [
        {
            "NO": 1337,
            "EN": "★Cas403",
            "JP": "★Cas403",
            "FR": "★Cas403",
            "DE": "★Cas403",
            "ES": "★Cas403",
            "IT": "★Cas403",
            "KOR": "★Cas403",
            "CHS": "★Cas403",
            "CHT": "★Cas403"
        }
    ],
    "★Cas153": [
        {
            "NO": 1338,
            "EN": "★Cas153",
            "JP": "★Cas153",
            "FR": "★Cas153",
            "DE": "★Cas153",
            "ES": "★Cas153",
            "IT": "★Cas153",
            "KOR": "★Cas153",
            "CHS": "★Cas153",
            "CHT": "★Cas153"
        }
    ],
    "★Cas542": [
        {
            "NO": 1339,
            "EN": "★Cas542",
            "JP": "★Cas542",
            "FR": "★Cas542",
            "DE": "★Cas542",
            "ES": "★Cas542",
            "IT": "★Cas542",
            "KOR": "★Cas542",
            "CHS": "★Cas542",
            "CHT": "★Cas542"
        }
    ],
    "★Cas219": [
        {
            "NO": 1340,
            "EN": "★Cas219",
            "JP": "★Cas219",
            "FR": "★Cas219",
            "DE": "★Cas219",
            "ES": "★Cas219",
            "IT": "★Cas219",
            "KOR": "★Cas219",
            "CHS": "★Cas219",
            "CHT": "★Cas219"
        }
    ],
    "★Cas265": [
        {
            "NO": 1341,
            "EN": "★Cas265",
            "JP": "★Cas265",
            "FR": "★Cas265",
            "DE": "★Cas265",
            "ES": "★Cas265",
            "IT": "★Cas265",
            "KOR": "★Cas265",
            "CHS": "★Cas265",
            "CHT": "★Cas265"
        }
    ],
    "★Cnc3572": [
        {
            "NO": 1342,
            "EN": "★Cnc3572",
            "JP": "★Cnc3572",
            "FR": "★Cnc3572",
            "DE": "★Cnc3572",
            "ES": "★Cnc3572",
            "IT": "★Cnc3572",
            "KOR": "★Cnc3572",
            "CHS": "★Cnc3572",
            "CHT": "★Cnc3572"
        }
    ],
    "★Cnc3208": [
        {
            "NO": 1343,
            "EN": "★Cnc3208",
            "JP": "★Cnc3208",
            "FR": "★Cnc3208",
            "DE": "★Cnc3208",
            "ES": "★Cnc3208",
            "IT": "★Cnc3208",
            "KOR": "★Cnc3208",
            "CHS": "★Cnc3208",
            "CHT": "★Cnc3208"
        }
    ],
    "★Cnc3461": [
        {
            "NO": 1344,
            "EN": "★Cnc3461",
            "JP": "★Cnc3461",
            "FR": "★Cnc3461",
            "DE": "★Cnc3461",
            "ES": "★Cnc3461",
            "IT": "★Cnc3461",
            "KOR": "★Cnc3461",
            "CHS": "★Cnc3461",
            "CHT": "★Cnc3461"
        }
    ],
    "★Cnc3449": [
        {
            "NO": 1345,
            "EN": "★Cnc3449",
            "JP": "★Cnc3449",
            "FR": "★Cnc3449",
            "DE": "★Cnc3449",
            "ES": "★Cnc3449",
            "IT": "★Cnc3449",
            "KOR": "★Cnc3449",
            "CHS": "★Cnc3449",
            "CHT": "★Cnc3449"
        }
    ],
    "★Cnc3429": [
        {
            "NO": 1346,
            "EN": "★Cnc3429",
            "JP": "★Cnc3429",
            "FR": "★Cnc3429",
            "DE": "★Cnc3429",
            "ES": "★Cnc3429",
            "IT": "★Cnc3429",
            "KOR": "★Cnc3429",
            "CHS": "★Cnc3429",
            "CHT": "★Cnc3429"
        }
    ],
    "★Cnc3627": [
        {
            "NO": 1347,
            "EN": "★Cnc3627",
            "JP": "★Cnc3627",
            "FR": "★Cnc3627",
            "DE": "★Cnc3627",
            "ES": "★Cnc3627",
            "IT": "★Cnc3627",
            "KOR": "★Cnc3627",
            "CHS": "★Cnc3627",
            "CHT": "★Cnc3627"
        }
    ],
    "★Cnc3268": [
        {
            "NO": 1348,
            "EN": "★Cnc3268",
            "JP": "★Cnc3268",
            "FR": "★Cnc3268",
            "DE": "★Cnc3268",
            "ES": "★Cnc3268",
            "IT": "★Cnc3268",
            "KOR": "★Cnc3268",
            "CHS": "★Cnc3268",
            "CHT": "★Cnc3268"
        }
    ],
    "★Cnc3249": [
        {
            "NO": 1349,
            "EN": "★Cnc3249",
            "JP": "★Cnc3249",
            "FR": "★Cnc3249",
            "DE": "★Cnc3249",
            "ES": "★Cnc3249",
            "IT": "★Cnc3249",
            "KOR": "★Cnc3249",
            "CHS": "★Cnc3249",
            "CHT": "★Cnc3249"
        }
    ],
    "★Com4968": [
        {
            "NO": 1350,
            "EN": "★Com4968",
            "JP": "★Com4968",
            "FR": "★Com4968",
            "DE": "★Com4968",
            "ES": "★Com4968",
            "IT": "★Com4968",
            "KOR": "★Com4968",
            "CHS": "★Com4968",
            "CHT": "★Com4968"
        }
    ],
    "★Crv4757": [
        {
            "NO": 1351,
            "EN": "★Crv4757",
            "JP": "★Crv4757",
            "FR": "★Crv4757",
            "DE": "★Crv4757",
            "ES": "★Crv4757",
            "IT": "★Crv4757",
            "KOR": "★Crv4757",
            "CHS": "★Crv4757",
            "CHT": "★Crv4757"
        }
    ],
    "★Crv4623": [
        {
            "NO": 1352,
            "EN": "★Crv4623",
            "JP": "★Crv4623",
            "FR": "★Crv4623",
            "DE": "★Crv4623",
            "ES": "★Crv4623",
            "IT": "★Crv4623",
            "KOR": "★Crv4623",
            "CHS": "★Crv4623",
            "CHT": "★Crv4623"
        }
    ],
    "★Crv4662": [
        {
            "NO": 1353,
            "EN": "★Crv4662",
            "JP": "★Crv4662",
            "FR": "★Crv4662",
            "DE": "★Crv4662",
            "ES": "★Crv4662",
            "IT": "★Crv4662",
            "KOR": "★Crv4662",
            "CHS": "★Crv4662",
            "CHT": "★Crv4662"
        }
    ],
    "★Crv4786": [
        {
            "NO": 1354,
            "EN": "★Crv4786",
            "JP": "★Crv4786",
            "FR": "★Crv4786",
            "DE": "★Crv4786",
            "ES": "★Crv4786",
            "IT": "★Crv4786",
            "KOR": "★Crv4786",
            "CHS": "★Crv4786",
            "CHT": "★Crv4786"
        }
    ],
    "★Aur1708": [
        {
            "NO": 1355,
            "EN": "★Aur1708",
            "JP": "★Aur1708",
            "FR": "★Aur1708",
            "DE": "★Aur1708",
            "ES": "★Aur1708",
            "IT": "★Aur1708",
            "KOR": "★Aur1708",
            "CHS": "★Aur1708",
            "CHT": "★Aur1708"
        }
    ],
    "★Aur2088": [
        {
            "NO": 1356,
            "EN": "★Aur2088",
            "JP": "★Aur2088",
            "FR": "★Aur2088",
            "DE": "★Aur2088",
            "ES": "★Aur2088",
            "IT": "★Aur2088",
            "KOR": "★Aur2088",
            "CHS": "★Aur2088",
            "CHT": "★Aur2088"
        }
    ],
    "★Aur1605": [
        {
            "NO": 1357,
            "EN": "★Aur1605",
            "JP": "★Aur1605",
            "FR": "★Aur1605",
            "DE": "★Aur1605",
            "ES": "★Aur1605",
            "IT": "★Aur1605",
            "KOR": "★Aur1605",
            "CHS": "★Aur1605",
            "CHT": "★Aur1605"
        }
    ],
    "★Aur2095": [
        {
            "NO": 1358,
            "EN": "★Aur2095",
            "JP": "★Aur2095",
            "FR": "★Aur2095",
            "DE": "★Aur2095",
            "ES": "★Aur2095",
            "IT": "★Aur2095",
            "KOR": "★Aur2095",
            "CHS": "★Aur2095",
            "CHT": "★Aur2095"
        }
    ],
    "★Aur1577": [
        {
            "NO": 1359,
            "EN": "★Aur1577",
            "JP": "★Aur1577",
            "FR": "★Aur1577",
            "DE": "★Aur1577",
            "ES": "★Aur1577",
            "IT": "★Aur1577",
            "KOR": "★Aur1577",
            "CHS": "★Aur1577",
            "CHT": "★Aur1577"
        }
    ],
    "★Aur1641": [
        {
            "NO": 1360,
            "EN": "★Aur1641",
            "JP": "★Aur1641",
            "FR": "★Aur1641",
            "DE": "★Aur1641",
            "ES": "★Aur1641",
            "IT": "★Aur1641",
            "KOR": "★Aur1641",
            "CHS": "★Aur1641",
            "CHT": "★Aur1641"
        }
    ],
    "★Aur1612": [
        {
            "NO": 1361,
            "EN": "★Aur1612",
            "JP": "★Aur1612",
            "FR": "★Aur1612",
            "DE": "★Aur1612",
            "ES": "★Aur1612",
            "IT": "★Aur1612",
            "KOR": "★Aur1612",
            "CHS": "★Aur1612",
            "CHT": "★Aur1612"
        }
    ],
    "★Pav7790": [
        {
            "NO": 1362,
            "EN": "★Pav7790",
            "JP": "★Pav7790",
            "FR": "★Pav7790",
            "DE": "★Pav7790",
            "ES": "★Pav7790",
            "IT": "★Pav7790",
            "KOR": "★Pav7790",
            "CHS": "★Pav7790",
            "CHT": "★Pav7790"
        }
    ],
    "★Cet911": [
        {
            "NO": 1363,
            "EN": "★Cet911",
            "JP": "★Cet911",
            "FR": "★Cet911",
            "DE": "★Cet911",
            "ES": "★Cet911",
            "IT": "★Cet911",
            "KOR": "★Cet911",
            "CHS": "★Cet911",
            "CHT": "★Cet911"
        }
    ],
    "★Cet681": [
        {
            "NO": 1364,
            "EN": "★Cet681",
            "JP": "★Cet681",
            "FR": "★Cet681",
            "DE": "★Cet681",
            "ES": "★Cet681",
            "IT": "★Cet681",
            "KOR": "★Cet681",
            "CHS": "★Cet681",
            "CHT": "★Cet681"
        }
    ],
    "★Cet188": [
        {
            "NO": 1365,
            "EN": "★Cet188",
            "JP": "★Cet188",
            "FR": "★Cet188",
            "DE": "★Cet188",
            "ES": "★Cet188",
            "IT": "★Cet188",
            "KOR": "★Cet188",
            "CHS": "★Cet188",
            "CHT": "★Cet188"
        }
    ],
    "★Cet539": [
        {
            "NO": 1366,
            "EN": "★Cet539",
            "JP": "★Cet539",
            "FR": "★Cet539",
            "DE": "★Cet539",
            "ES": "★Cet539",
            "IT": "★Cet539",
            "KOR": "★Cet539",
            "CHS": "★Cet539",
            "CHT": "★Cet539"
        }
    ],
    "★Cet804": [
        {
            "NO": 1367,
            "EN": "★Cet804",
            "JP": "★Cet804",
            "FR": "★Cet804",
            "DE": "★Cet804",
            "ES": "★Cet804",
            "IT": "★Cet804",
            "KOR": "★Cet804",
            "CHS": "★Cet804",
            "CHT": "★Cet804"
        }
    ],
    "★Cep8974": [
        {
            "NO": 1368,
            "EN": "★Cep8974",
            "JP": "★Cep8974",
            "FR": "★Cep8974",
            "DE": "★Cep8974",
            "ES": "★Cep8974",
            "IT": "★Cep8974",
            "KOR": "★Cep8974",
            "CHS": "★Cep8974",
            "CHT": "★Cep8974"
        }
    ],
    "★Cep8162": [
        {
            "NO": 1369,
            "EN": "★Cep8162",
            "JP": "★Cep8162",
            "FR": "★Cep8162",
            "DE": "★Cep8162",
            "ES": "★Cep8162",
            "IT": "★Cep8162",
            "KOR": "★Cep8162",
            "CHS": "★Cep8162",
            "CHT": "★Cep8162"
        }
    ],
    "★Cep8238": [
        {
            "NO": 1370,
            "EN": "★Cep8238",
            "JP": "★Cep8238",
            "FR": "★Cep8238",
            "DE": "★Cep8238",
            "ES": "★Cep8238",
            "IT": "★Cep8238",
            "KOR": "★Cep8238",
            "CHS": "★Cep8238",
            "CHT": "★Cep8238"
        }
    ],
    "★Cep8417": [
        {
            "NO": 1371,
            "EN": "★Cep8417",
            "JP": "★Cep8417",
            "FR": "★Cep8417",
            "DE": "★Cep8417",
            "ES": "★Cep8417",
            "IT": "★Cep8417",
            "KOR": "★Cep8417",
            "CHS": "★Cep8417",
            "CHT": "★Cep8417"
        }
    ],
    "★Cen5267": [
        {
            "NO": 1372,
            "EN": "★Cen5267",
            "JP": "★Cen5267",
            "FR": "★Cen5267",
            "DE": "★Cen5267",
            "ES": "★Cen5267",
            "IT": "★Cen5267",
            "KOR": "★Cen5267",
            "CHS": "★Cen5267",
            "CHT": "★Cen5267"
        }
    ],
    "★Cen5288": [
        {
            "NO": 1373,
            "EN": "★Cen5288",
            "JP": "★Cen5288",
            "FR": "★Cen5288",
            "DE": "★Cen5288",
            "ES": "★Cen5288",
            "IT": "★Cen5288",
            "KOR": "★Cen5288",
            "CHS": "★Cen5288",
            "CHT": "★Cen5288"
        }
    ],
    "★Cen551": [
        {
            "NO": 1374,
            "EN": "★Cen551",
            "JP": "★Cen551",
            "FR": "★Cen551",
            "DE": "★Cen551",
            "ES": "★Cen551",
            "IT": "★Cen551",
            "KOR": "★Cen551",
            "CHS": "★Cen551",
            "CHT": "★Cen551"
        }
    ],
    "★Cen5459": [
        {
            "NO": 1375,
            "EN": "★Cen5459",
            "JP": "★Cen5459",
            "FR": "★Cen5459",
            "DE": "★Cen5459",
            "ES": "★Cen5459",
            "IT": "★Cen5459",
            "KOR": "★Cen5459",
            "CHS": "★Cen5459",
            "CHT": "★Cen5459"
        }
    ],
    "★Cen5460": [
        {
            "NO": 1376,
            "EN": "★Cen5460",
            "JP": "★Cen5460",
            "FR": "★Cen5460",
            "DE": "★Cen5460",
            "ES": "★Cen5460",
            "IT": "★Cen5460",
            "KOR": "★Cen5460",
            "CHS": "★Cen5460",
            "CHT": "★Cen5460"
        }
    ],
    "★CMi2943": [
        {
            "NO": 1377,
            "EN": "★CMi2943",
            "JP": "★CMi2943",
            "FR": "★CMi2943",
            "DE": "★CMi2943",
            "ES": "★CMi2943",
            "IT": "★CMi2943",
            "KOR": "★CMi2943",
            "CHS": "★CMi2943",
            "CHT": "★CMi2943"
        }
    ],
    "★CMi2845": [
        {
            "NO": 1378,
            "EN": "★CMi2845",
            "JP": "★CMi2845",
            "FR": "★CMi2845",
            "DE": "★CMi2845",
            "ES": "★CMi2845",
            "IT": "★CMi2845",
            "KOR": "★CMi2845",
            "CHS": "★CMi2845",
            "CHT": "★CMi2845"
        }
    ],
    "★Equ8131": [
        {
            "NO": 1379,
            "EN": "★Equ8131",
            "JP": "★Equ8131",
            "FR": "★Equ8131",
            "DE": "★Equ8131",
            "ES": "★Equ8131",
            "IT": "★Equ8131",
            "KOR": "★Equ8131",
            "CHS": "★Equ8131",
            "CHT": "★Equ8131"
        }
    ],
    "★Vul7405": [
        {
            "NO": 1380,
            "EN": "★Vul7405",
            "JP": "★Vul7405",
            "FR": "★Vul7405",
            "DE": "★Vul7405",
            "ES": "★Vul7405",
            "IT": "★Vul7405",
            "KOR": "★Vul7405",
            "CHS": "★Vul7405",
            "CHT": "★Vul7405"
        }
    ],
    "★UMi424": [
        {
            "NO": 1381,
            "EN": "★UMi424",
            "JP": "★UMi424",
            "FR": "★UMi424",
            "DE": "★UMi424",
            "ES": "★UMi424",
            "IT": "★UMi424",
            "KOR": "★UMi424",
            "CHS": "★UMi424",
            "CHT": "★UMi424"
        }
    ],
    "★UMi5563": [
        {
            "NO": 1382,
            "EN": "★UMi5563",
            "JP": "★UMi5563",
            "FR": "★UMi5563",
            "DE": "★UMi5563",
            "ES": "★UMi5563",
            "IT": "★UMi5563",
            "KOR": "★UMi5563",
            "CHS": "★UMi5563",
            "CHT": "★UMi5563"
        }
    ],
    "★UMi5735": [
        {
            "NO": 1383,
            "EN": "★UMi5735",
            "JP": "★UMi5735",
            "FR": "★UMi5735",
            "DE": "★UMi5735",
            "ES": "★UMi5735",
            "IT": "★UMi5735",
            "KOR": "★UMi5735",
            "CHS": "★UMi5735",
            "CHT": "★UMi5735"
        }
    ],
    "★UMi6789": [
        {
            "NO": 1384,
            "EN": "★UMi6789",
            "JP": "★UMi6789",
            "FR": "★UMi6789",
            "DE": "★UMi6789",
            "ES": "★UMi6789",
            "IT": "★UMi6789",
            "KOR": "★UMi6789",
            "CHS": "★UMi6789",
            "CHT": "★UMi6789"
        }
    ],
    "★Crt4287": [
        {
            "NO": 1385,
            "EN": "★Crt4287",
            "JP": "★Crt4287",
            "FR": "★Crt4287",
            "DE": "★Crt4287",
            "ES": "★Crt4287",
            "IT": "★Crt4287",
            "KOR": "★Crt4287",
            "CHS": "★Crt4287",
            "CHT": "★Crt4287"
        }
    ],
    "★Lyr7001": [
        {
            "NO": 1386,
            "EN": "★Lyr7001",
            "JP": "★Lyr7001",
            "FR": "★Lyr7001",
            "DE": "★Lyr7001",
            "ES": "★Lyr7001",
            "IT": "★Lyr7001",
            "KOR": "★Lyr7001",
            "CHS": "★Lyr7001",
            "CHT": "★Lyr7001"
        }
    ],
    "★Lyr7178": [
        {
            "NO": 1387,
            "EN": "★Lyr7178",
            "JP": "★Lyr7178",
            "FR": "★Lyr7178",
            "DE": "★Lyr7178",
            "ES": "★Lyr7178",
            "IT": "★Lyr7178",
            "KOR": "★Lyr7178",
            "CHS": "★Lyr7178",
            "CHT": "★Lyr7178"
        }
    ],
    "★Lyr7106": [
        {
            "NO": 1388,
            "EN": "★Lyr7106",
            "JP": "★Lyr7106",
            "FR": "★Lyr7106",
            "DE": "★Lyr7106",
            "ES": "★Lyr7106",
            "IT": "★Lyr7106",
            "KOR": "★Lyr7106",
            "CHS": "★Lyr7106",
            "CHT": "★Lyr7106"
        }
    ],
    "★Lyr7298": [
        {
            "NO": 1389,
            "EN": "★Lyr7298",
            "JP": "★Lyr7298",
            "FR": "★Lyr7298",
            "DE": "★Lyr7298",
            "ES": "★Lyr7298",
            "IT": "★Lyr7298",
            "KOR": "★Lyr7298",
            "CHS": "★Lyr7298",
            "CHT": "★Lyr7298"
        }
    ],
    "★Ara6585": [
        {
            "NO": 1390,
            "EN": "★Ara6585",
            "JP": "★Ara6585",
            "FR": "★Ara6585",
            "DE": "★Ara6585",
            "ES": "★Ara6585",
            "IT": "★Ara6585",
            "KOR": "★Ara6585",
            "CHS": "★Ara6585",
            "CHT": "★Ara6585"
        }
    ],
    "★Sco6134": [
        {
            "NO": 1391,
            "EN": "★Sco6134",
            "JP": "★Sco6134",
            "FR": "★Sco6134",
            "DE": "★Sco6134",
            "ES": "★Sco6134",
            "IT": "★Sco6134",
            "KOR": "★Sco6134",
            "CHS": "★Sco6134",
            "CHT": "★Sco6134"
        }
    ],
    "★Sco6527": [
        {
            "NO": 1392,
            "EN": "★Sco6527",
            "JP": "★Sco6527",
            "FR": "★Sco6527",
            "DE": "★Sco6527",
            "ES": "★Sco6527",
            "IT": "★Sco6527",
            "KOR": "★Sco6527",
            "CHS": "★Sco6527",
            "CHT": "★Sco6527"
        }
    ],
    "★Sco6553": [
        {
            "NO": 1393,
            "EN": "★Sco6553",
            "JP": "★Sco6553",
            "FR": "★Sco6553",
            "DE": "★Sco6553",
            "ES": "★Sco6553",
            "IT": "★Sco6553",
            "KOR": "★Sco6553",
            "CHS": "★Sco6553",
            "CHT": "★Sco6553"
        }
    ],
    "★Sco5953": [
        {
            "NO": 1394,
            "EN": "★Sco5953",
            "JP": "★Sco5953",
            "FR": "★Sco5953",
            "DE": "★Sco5953",
            "ES": "★Sco5953",
            "IT": "★Sco5953",
            "KOR": "★Sco5953",
            "CHS": "★Sco5953",
            "CHT": "★Sco5953"
        }
    ],
    "★Sco5984": [
        {
            "NO": 1395,
            "EN": "★Sco5984",
            "JP": "★Sco5984",
            "FR": "★Sco5984",
            "DE": "★Sco5984",
            "ES": "★Sco5984",
            "IT": "★Sco5984",
            "KOR": "★Sco5984",
            "CHS": "★Sco5984",
            "CHT": "★Sco5984"
        }
    ],
    "★Sco6508": [
        {
            "NO": 1396,
            "EN": "★Sco6508",
            "JP": "★Sco6508",
            "FR": "★Sco6508",
            "DE": "★Sco6508",
            "ES": "★Sco6508",
            "IT": "★Sco6508",
            "KOR": "★Sco6508",
            "CHS": "★Sco6508",
            "CHT": "★Sco6508"
        }
    ],
    "★Sco6084": [
        {
            "NO": 1397,
            "EN": "★Sco6084",
            "JP": "★Sco6084",
            "FR": "★Sco6084",
            "DE": "★Sco6084",
            "ES": "★Sco6084",
            "IT": "★Sco6084",
            "KOR": "★Sco6084",
            "CHS": "★Sco6084",
            "CHT": "★Sco6084"
        }
    ],
    "★Sco5944": [
        {
            "NO": 1398,
            "EN": "★Sco5944",
            "JP": "★Sco5944",
            "FR": "★Sco5944",
            "DE": "★Sco5944",
            "ES": "★Sco5944",
            "IT": "★Sco5944",
            "KOR": "★Sco5944",
            "CHS": "★Sco5944",
            "CHT": "★Sco5944"
        }
    ],
    "★Sco6630": [
        {
            "NO": 1399,
            "EN": "★Sco6630",
            "JP": "★Sco6630",
            "FR": "★Sco6630",
            "DE": "★Sco6630",
            "ES": "★Sco6630",
            "IT": "★Sco6630",
            "KOR": "★Sco6630",
            "CHS": "★Sco6630",
            "CHT": "★Sco6630"
        }
    ],
    "★Sco6027": [
        {
            "NO": 1400,
            "EN": "★Sco6027",
            "JP": "★Sco6027",
            "FR": "★Sco6027",
            "DE": "★Sco6027",
            "ES": "★Sco6027",
            "IT": "★Sco6027",
            "KOR": "★Sco6027",
            "CHS": "★Sco6027",
            "CHT": "★Sco6027"
        }
    ],
    "★Sco6247": [
        {
            "NO": 1401,
            "EN": "★Sco6247",
            "JP": "★Sco6247",
            "FR": "★Sco6247",
            "DE": "★Sco6247",
            "ES": "★Sco6247",
            "IT": "★Sco6247",
            "KOR": "★Sco6247",
            "CHS": "★Sco6247",
            "CHT": "★Sco6247"
        }
    ],
    "★Sco6252": [
        {
            "NO": 1402,
            "EN": "★Sco6252",
            "JP": "★Sco6252",
            "FR": "★Sco6252",
            "DE": "★Sco6252",
            "ES": "★Sco6252",
            "IT": "★Sco6252",
            "KOR": "★Sco6252",
            "CHS": "★Sco6252",
            "CHT": "★Sco6252"
        }
    ],
    "★Sco5928": [
        {
            "NO": 1403,
            "EN": "★Sco5928",
            "JP": "★Sco5928",
            "FR": "★Sco5928",
            "DE": "★Sco5928",
            "ES": "★Sco5928",
            "IT": "★Sco5928",
            "KOR": "★Sco5928",
            "CHS": "★Sco5928",
            "CHT": "★Sco5928"
        }
    ],
    "★Sco6241": [
        {
            "NO": 1404,
            "EN": "★Sco6241",
            "JP": "★Sco6241",
            "FR": "★Sco6241",
            "DE": "★Sco6241",
            "ES": "★Sco6241",
            "IT": "★Sco6241",
            "KOR": "★Sco6241",
            "CHS": "★Sco6241",
            "CHT": "★Sco6241"
        }
    ],
    "★Sco6165": [
        {
            "NO": 1405,
            "EN": "★Sco6165",
            "JP": "★Sco6165",
            "FR": "★Sco6165",
            "DE": "★Sco6165",
            "ES": "★Sco6165",
            "IT": "★Sco6165",
            "KOR": "★Sco6165",
            "CHS": "★Sco6165",
            "CHT": "★Sco6165"
        }
    ],
    "★Tri544": [
        {
            "NO": 1406,
            "EN": "★Tri544",
            "JP": "★Tri544",
            "FR": "★Tri544",
            "DE": "★Tri544",
            "ES": "★Tri544",
            "IT": "★Tri544",
            "KOR": "★Tri544",
            "CHS": "★Tri544",
            "CHT": "★Tri544"
        }
    ],
    "★Leo3982": [
        {
            "NO": 1407,
            "EN": "★Leo3982",
            "JP": "★Leo3982",
            "FR": "★Leo3982",
            "DE": "★Leo3982",
            "ES": "★Leo3982",
            "IT": "★Leo3982",
            "KOR": "★Leo3982",
            "CHS": "★Leo3982",
            "CHT": "★Leo3982"
        }
    ],
    "★Leo4534": [
        {
            "NO": 1408,
            "EN": "★Leo4534",
            "JP": "★Leo4534",
            "FR": "★Leo4534",
            "DE": "★Leo4534",
            "ES": "★Leo4534",
            "IT": "★Leo4534",
            "KOR": "★Leo4534",
            "CHS": "★Leo4534",
            "CHT": "★Leo4534"
        }
    ],
    "★Leo4357": [
        {
            "NO": 1409,
            "EN": "★Leo4357",
            "JP": "★Leo4357",
            "FR": "★Leo4357",
            "DE": "★Leo4357",
            "ES": "★Leo4357",
            "IT": "★Leo4357",
            "KOR": "★Leo4357",
            "CHS": "★Leo4357",
            "CHT": "★Leo4357"
        }
    ],
    "★Leo4057": [
        {
            "NO": 1410,
            "EN": "★Leo4057",
            "JP": "★Leo4057",
            "FR": "★Leo4057",
            "DE": "★Leo4057",
            "ES": "★Leo4057",
            "IT": "★Leo4057",
            "KOR": "★Leo4057",
            "CHS": "★Leo4057",
            "CHT": "★Leo4057"
        }
    ],
    "★Leo4359": [
        {
            "NO": 1411,
            "EN": "★Leo4359",
            "JP": "★Leo4359",
            "FR": "★Leo4359",
            "DE": "★Leo4359",
            "ES": "★Leo4359",
            "IT": "★Leo4359",
            "KOR": "★Leo4359",
            "CHS": "★Leo4359",
            "CHT": "★Leo4359"
        }
    ],
    "★Leo4031": [
        {
            "NO": 1412,
            "EN": "★Leo4031",
            "JP": "★Leo4031",
            "FR": "★Leo4031",
            "DE": "★Leo4031",
            "ES": "★Leo4031",
            "IT": "★Leo4031",
            "KOR": "★Leo4031",
            "CHS": "★Leo4031",
            "CHT": "★Leo4031"
        }
    ],
    "★Leo3852": [
        {
            "NO": 1413,
            "EN": "★Leo3852",
            "JP": "★Leo3852",
            "FR": "★Leo3852",
            "DE": "★Leo3852",
            "ES": "★Leo3852",
            "IT": "★Leo3852",
            "KOR": "★Leo3852",
            "CHS": "★Leo3852",
            "CHT": "★Leo3852"
        }
    ],
    "★Leo3905": [
        {
            "NO": 1414,
            "EN": "★Leo3905",
            "JP": "★Leo3905",
            "FR": "★Leo3905",
            "DE": "★Leo3905",
            "ES": "★Leo3905",
            "IT": "★Leo3905",
            "KOR": "★Leo3905",
            "CHS": "★Leo3905",
            "CHT": "★Leo3905"
        }
    ],
    "★Leo3773": [
        {
            "NO": 1415,
            "EN": "★Leo3773",
            "JP": "★Leo3773",
            "FR": "★Leo3773",
            "DE": "★Leo3773",
            "ES": "★Leo3773",
            "IT": "★Leo3773",
            "KOR": "★Leo3773",
            "CHS": "★Leo3773",
            "CHT": "★Leo3773"
        }
    ],
    "★Gru8425": [
        {
            "NO": 1416,
            "EN": "★Gru8425",
            "JP": "★Gru8425",
            "FR": "★Gru8425",
            "DE": "★Gru8425",
            "ES": "★Gru8425",
            "IT": "★Gru8425",
            "KOR": "★Gru8425",
            "CHS": "★Gru8425",
            "CHT": "★Gru8425"
        }
    ],
    "★Gru8636": [
        {
            "NO": 1417,
            "EN": "★Gru8636",
            "JP": "★Gru8636",
            "FR": "★Gru8636",
            "DE": "★Gru8636",
            "ES": "★Gru8636",
            "IT": "★Gru8636",
            "KOR": "★Gru8636",
            "CHS": "★Gru8636",
            "CHT": "★Gru8636"
        }
    ],
    "★Gru8353": [
        {
            "NO": 1418,
            "EN": "★Gru8353",
            "JP": "★Gru8353",
            "FR": "★Gru8353",
            "DE": "★Gru8353",
            "ES": "★Gru8353",
            "IT": "★Gru8353",
            "KOR": "★Gru8353",
            "CHS": "★Gru8353",
            "CHT": "★Gru8353"
        }
    ],
    "★Lib5685": [
        {
            "NO": 1419,
            "EN": "★Lib5685",
            "JP": "★Lib5685",
            "FR": "★Lib5685",
            "DE": "★Lib5685",
            "ES": "★Lib5685",
            "IT": "★Lib5685",
            "KOR": "★Lib5685",
            "CHS": "★Lib5685",
            "CHT": "★Lib5685"
        }
    ],
    "★Lib5531": [
        {
            "NO": 1420,
            "EN": "★Lib5531",
            "JP": "★Lib5531",
            "FR": "★Lib5531",
            "DE": "★Lib5531",
            "ES": "★Lib5531",
            "IT": "★Lib5531",
            "KOR": "★Lib5531",
            "CHS": "★Lib5531",
            "CHT": "★Lib5531"
        }
    ],
    "★Lib5787": [
        {
            "NO": 1421,
            "EN": "★Lib5787",
            "JP": "★Lib5787",
            "FR": "★Lib5787",
            "DE": "★Lib5787",
            "ES": "★Lib5787",
            "IT": "★Lib5787",
            "KOR": "★Lib5787",
            "CHS": "★Lib5787",
            "CHT": "★Lib5787"
        }
    ],
    "★Lib5603": [
        {
            "NO": 1422,
            "EN": "★Lib5603",
            "JP": "★Lib5603",
            "FR": "★Lib5603",
            "DE": "★Lib5603",
            "ES": "★Lib5603",
            "IT": "★Lib5603",
            "KOR": "★Lib5603",
            "CHS": "★Lib5603",
            "CHT": "★Lib5603"
        }
    ],
    "★Pup3165": [
        {
            "NO": 1423,
            "EN": "★Pup3165",
            "JP": "★Pup3165",
            "FR": "★Pup3165",
            "DE": "★Pup3165",
            "ES": "★Pup3165",
            "IT": "★Pup3165",
            "KOR": "★Pup3165",
            "CHS": "★Pup3165",
            "CHT": "★Pup3165"
        }
    ],
    "★Pup3185": [
        {
            "NO": 1424,
            "EN": "★Pup3185",
            "JP": "★Pup3185",
            "FR": "★Pup3185",
            "DE": "★Pup3185",
            "ES": "★Pup3185",
            "IT": "★Pup3185",
            "KOR": "★Pup3185",
            "CHS": "★Pup3185",
            "CHT": "★Pup3185"
        }
    ],
    "★Pup3045": [
        {
            "NO": 1425,
            "EN": "★Pup3045",
            "JP": "★Pup3045",
            "FR": "★Pup3045",
            "DE": "★Pup3045",
            "ES": "★Pup3045",
            "IT": "★Pup3045",
            "KOR": "★Pup3045",
            "CHS": "★Pup3045",
            "CHT": "★Pup3045"
        }
    ],
    "★Cyg7924": [
        {
            "NO": 1426,
            "EN": "★Cyg7924",
            "JP": "★Cyg7924",
            "FR": "★Cyg7924",
            "DE": "★Cyg7924",
            "ES": "★Cyg7924",
            "IT": "★Cyg7924",
            "KOR": "★Cyg7924",
            "CHS": "★Cyg7924",
            "CHT": "★Cyg7924"
        }
    ],
    "★Cyg7417": [
        {
            "NO": 1427,
            "EN": "★Cyg7417",
            "JP": "★Cyg7417",
            "FR": "★Cyg7417",
            "DE": "★Cyg7417",
            "ES": "★Cyg7417",
            "IT": "★Cyg7417",
            "KOR": "★Cyg7417",
            "CHS": "★Cyg7417",
            "CHT": "★Cyg7417"
        }
    ],
    "★Cyg7796": [
        {
            "NO": 1428,
            "EN": "★Cyg7796",
            "JP": "★Cyg7796",
            "FR": "★Cyg7796",
            "DE": "★Cyg7796",
            "ES": "★Cyg7796",
            "IT": "★Cyg7796",
            "KOR": "★Cyg7796",
            "CHS": "★Cyg7796",
            "CHT": "★Cyg7796"
        }
    ],
    "★Cyg8301": [
        {
            "NO": 1429,
            "EN": "★Cyg8301",
            "JP": "★Cyg8301",
            "FR": "★Cyg8301",
            "DE": "★Cyg8301",
            "ES": "★Cyg8301",
            "IT": "★Cyg8301",
            "KOR": "★Cyg8301",
            "CHS": "★Cyg8301",
            "CHT": "★Cyg8301"
        }
    ],
    "★Cyg7949": [
        {
            "NO": 1430,
            "EN": "★Cyg7949",
            "JP": "★Cyg7949",
            "FR": "★Cyg7949",
            "DE": "★Cyg7949",
            "ES": "★Cyg7949",
            "IT": "★Cyg7949",
            "KOR": "★Cyg7949",
            "CHS": "★Cyg7949",
            "CHT": "★Cyg7949"
        }
    ],
    "★Cyg7528": [
        {
            "NO": 1431,
            "EN": "★Cyg7528",
            "JP": "★Cyg7528",
            "FR": "★Cyg7528",
            "DE": "★Cyg7528",
            "ES": "★Cyg7528",
            "IT": "★Cyg7528",
            "KOR": "★Cyg7528",
            "CHS": "★Cyg7528",
            "CHT": "★Cyg7528"
        }
    ],
    "★Oct7228": [
        {
            "NO": 1432,
            "EN": "★Oct7228",
            "JP": "★Oct7228",
            "FR": "★Oct7228",
            "DE": "★Oct7228",
            "ES": "★Oct7228",
            "IT": "★Oct7228",
            "KOR": "★Oct7228",
            "CHS": "★Oct7228",
            "CHT": "★Oct7228"
        }
    ],
    "★Col1956": [
        {
            "NO": 1433,
            "EN": "★Col1956",
            "JP": "★Col1956",
            "FR": "★Col1956",
            "DE": "★Col1956",
            "ES": "★Col1956",
            "IT": "★Col1956",
            "KOR": "★Col1956",
            "CHS": "★Col1956",
            "CHT": "★Col1956"
        }
    ],
    "★Col2040": [
        {
            "NO": 1434,
            "EN": "★Col2040",
            "JP": "★Col2040",
            "FR": "★Col2040",
            "DE": "★Col2040",
            "ES": "★Col2040",
            "IT": "★Col2040",
            "KOR": "★Col2040",
            "CHS": "★Col2040",
            "CHT": "★Col2040"
        }
    ],
    "★Col2177": [
        {
            "NO": 1435,
            "EN": "★Col2177",
            "JP": "★Col2177",
            "FR": "★Col2177",
            "DE": "★Col2177",
            "ES": "★Col2177",
            "IT": "★Col2177",
            "KOR": "★Col2177",
            "CHS": "★Col2177",
            "CHT": "★Col2177"
        }
    ],
    "★Gem2990": [
        {
            "NO": 1436,
            "EN": "★Gem2990",
            "JP": "★Gem2990",
            "FR": "★Gem2990",
            "DE": "★Gem2990",
            "ES": "★Gem2990",
            "IT": "★Gem2990",
            "KOR": "★Gem2990",
            "CHS": "★Gem2990",
            "CHT": "★Gem2990"
        }
    ],
    "★Gem2891": [
        {
            "NO": 1437,
            "EN": "★Gem2891",
            "JP": "★Gem2891",
            "FR": "★Gem2891",
            "DE": "★Gem2891",
            "ES": "★Gem2891",
            "IT": "★Gem2891",
            "KOR": "★Gem2891",
            "CHS": "★Gem2891",
            "CHT": "★Gem2891"
        }
    ],
    "★Gem2421": [
        {
            "NO": 1438,
            "EN": "★Gem2421",
            "JP": "★Gem2421",
            "FR": "★Gem2421",
            "DE": "★Gem2421",
            "ES": "★Gem2421",
            "IT": "★Gem2421",
            "KOR": "★Gem2421",
            "CHS": "★Gem2421",
            "CHT": "★Gem2421"
        }
    ],
    "★Gem2473": [
        {
            "NO": 1439,
            "EN": "★Gem2473",
            "JP": "★Gem2473",
            "FR": "★Gem2473",
            "DE": "★Gem2473",
            "ES": "★Gem2473",
            "IT": "★Gem2473",
            "KOR": "★Gem2473",
            "CHS": "★Gem2473",
            "CHT": "★Gem2473"
        }
    ],
    "★Gem2216": [
        {
            "NO": 1440,
            "EN": "★Gem2216",
            "JP": "★Gem2216",
            "FR": "★Gem2216",
            "DE": "★Gem2216",
            "ES": "★Gem2216",
            "IT": "★Gem2216",
            "KOR": "★Gem2216",
            "CHS": "★Gem2216",
            "CHT": "★Gem2216"
        }
    ],
    "★Gem2777": [
        {
            "NO": 1441,
            "EN": "★Gem2777",
            "JP": "★Gem2777",
            "FR": "★Gem2777",
            "DE": "★Gem2777",
            "ES": "★Gem2777",
            "IT": "★Gem2777",
            "KOR": "★Gem2777",
            "CHS": "★Gem2777",
            "CHT": "★Gem2777"
        }
    ],
    "★Gem2650": [
        {
            "NO": 1442,
            "EN": "★Gem2650",
            "JP": "★Gem2650",
            "FR": "★Gem2650",
            "DE": "★Gem2650",
            "ES": "★Gem2650",
            "IT": "★Gem2650",
            "KOR": "★Gem2650",
            "CHS": "★Gem2650",
            "CHT": "★Gem2650"
        }
    ],
    "★Gem2286": [
        {
            "NO": 1443,
            "EN": "★Gem2286",
            "JP": "★Gem2286",
            "FR": "★Gem2286",
            "DE": "★Gem2286",
            "ES": "★Gem2286",
            "IT": "★Gem2286",
            "KOR": "★Gem2286",
            "CHS": "★Gem2286",
            "CHT": "★Gem2286"
        }
    ],
    "★Gem2484": [
        {
            "NO": 1444,
            "EN": "★Gem2484",
            "JP": "★Gem2484",
            "FR": "★Gem2484",
            "DE": "★Gem2484",
            "ES": "★Gem2484",
            "IT": "★Gem2484",
            "KOR": "★Gem2484",
            "CHS": "★Gem2484",
            "CHT": "★Gem2484"
        }
    ],
    "★Gem2930": [
        {
            "NO": 1445,
            "EN": "★Gem2930",
            "JP": "★Gem2930",
            "FR": "★Gem2930",
            "DE": "★Gem2930",
            "ES": "★Gem2930",
            "IT": "★Gem2930",
            "KOR": "★Gem2930",
            "CHS": "★Gem2930",
            "CHT": "★Gem2930"
        }
    ],
    "★Peg8775": [
        {
            "NO": 1446,
            "EN": "★Peg8775",
            "JP": "★Peg8775",
            "FR": "★Peg8775",
            "DE": "★Peg8775",
            "ES": "★Peg8775",
            "IT": "★Peg8775",
            "KOR": "★Peg8775",
            "CHS": "★Peg8775",
            "CHT": "★Peg8775"
        }
    ],
    "★Peg8781": [
        {
            "NO": 1447,
            "EN": "★Peg8781",
            "JP": "★Peg8781",
            "FR": "★Peg8781",
            "DE": "★Peg8781",
            "ES": "★Peg8781",
            "IT": "★Peg8781",
            "KOR": "★Peg8781",
            "CHS": "★Peg8781",
            "CHT": "★Peg8781"
        }
    ],
    "★Peg39": [
        {
            "NO": 1448,
            "EN": "★Peg39",
            "JP": "★Peg39",
            "FR": "★Peg39",
            "DE": "★Peg39",
            "ES": "★Peg39",
            "IT": "★Peg39",
            "KOR": "★Peg39",
            "CHS": "★Peg39",
            "CHT": "★Peg39"
        }
    ],
    "★Peg8308": [
        {
            "NO": 1449,
            "EN": "★Peg8308",
            "JP": "★Peg8308",
            "FR": "★Peg8308",
            "DE": "★Peg8308",
            "ES": "★Peg8308",
            "IT": "★Peg8308",
            "KOR": "★Peg8308",
            "CHS": "★Peg8308",
            "CHT": "★Peg8308"
        }
    ],
    "★Peg8650": [
        {
            "NO": 1450,
            "EN": "★Peg8650",
            "JP": "★Peg8650",
            "FR": "★Peg8650",
            "DE": "★Peg8650",
            "ES": "★Peg8650",
            "IT": "★Peg8650",
            "KOR": "★Peg8650",
            "CHS": "★Peg8650",
            "CHT": "★Peg8650"
        }
    ],
    "★Peg8634": [
        {
            "NO": 1451,
            "EN": "★Peg8634",
            "JP": "★Peg8634",
            "FR": "★Peg8634",
            "DE": "★Peg8634",
            "ES": "★Peg8634",
            "IT": "★Peg8634",
            "KOR": "★Peg8634",
            "CHS": "★Peg8634",
            "CHT": "★Peg8634"
        }
    ],
    "★Peg8684": [
        {
            "NO": 1452,
            "EN": "★Peg8684",
            "JP": "★Peg8684",
            "FR": "★Peg8684",
            "DE": "★Peg8684",
            "ES": "★Peg8684",
            "IT": "★Peg8684",
            "KOR": "★Peg8684",
            "CHS": "★Peg8684",
            "CHT": "★Peg8684"
        }
    ],
    "★Peg8450": [
        {
            "NO": 1453,
            "EN": "★Peg8450",
            "JP": "★Peg8450",
            "FR": "★Peg8450",
            "DE": "★Peg8450",
            "ES": "★Peg8450",
            "IT": "★Peg8450",
            "KOR": "★Peg8450",
            "CHS": "★Peg8450",
            "CHT": "★Peg8450"
        }
    ],
    "★Peg8880": [
        {
            "NO": 1454,
            "EN": "★Peg8880",
            "JP": "★Peg8880",
            "FR": "★Peg8880",
            "DE": "★Peg8880",
            "ES": "★Peg8880",
            "IT": "★Peg8880",
            "KOR": "★Peg8880",
            "CHS": "★Peg8880",
            "CHT": "★Peg8880"
        }
    ],
    "★Peg8905": [
        {
            "NO": 1455,
            "EN": "★Peg8905",
            "JP": "★Peg8905",
            "FR": "★Peg8905",
            "DE": "★Peg8905",
            "ES": "★Peg8905",
            "IT": "★Peg8905",
            "KOR": "★Peg8905",
            "CHS": "★Peg8905",
            "CHT": "★Peg8905"
        }
    ],
    "★Oph6556": [
        {
            "NO": 1456,
            "EN": "★Oph6556",
            "JP": "★Oph6556",
            "FR": "★Oph6556",
            "DE": "★Oph6556",
            "ES": "★Oph6556",
            "IT": "★Oph6556",
            "KOR": "★Oph6556",
            "CHS": "★Oph6556",
            "CHT": "★Oph6556"
        }
    ],
    "★Oph6378": [
        {
            "NO": 1457,
            "EN": "★Oph6378",
            "JP": "★Oph6378",
            "FR": "★Oph6378",
            "DE": "★Oph6378",
            "ES": "★Oph6378",
            "IT": "★Oph6378",
            "KOR": "★Oph6378",
            "CHS": "★Oph6378",
            "CHT": "★Oph6378"
        }
    ],
    "★Oph6603": [
        {
            "NO": 1458,
            "EN": "★Oph6603",
            "JP": "★Oph6603",
            "FR": "★Oph6603",
            "DE": "★Oph6603",
            "ES": "★Oph6603",
            "IT": "★Oph6603",
            "KOR": "★Oph6603",
            "CHS": "★Oph6603",
            "CHT": "★Oph6603"
        }
    ],
    "★Oph6149": [
        {
            "NO": 1459,
            "EN": "★Oph6149",
            "JP": "★Oph6149",
            "FR": "★Oph6149",
            "DE": "★Oph6149",
            "ES": "★Oph6149",
            "IT": "★Oph6149",
            "KOR": "★Oph6149",
            "CHS": "★Oph6149",
            "CHT": "★Oph6149"
        }
    ],
    "★Oph6056": [
        {
            "NO": 1460,
            "EN": "★Oph6056",
            "JP": "★Oph6056",
            "FR": "★Oph6056",
            "DE": "★Oph6056",
            "ES": "★Oph6056",
            "IT": "★Oph6056",
            "KOR": "★Oph6056",
            "CHS": "★Oph6056",
            "CHT": "★Oph6056"
        }
    ],
    "★Oph6075": [
        {
            "NO": 1461,
            "EN": "★Oph6075",
            "JP": "★Oph6075",
            "FR": "★Oph6075",
            "DE": "★Oph6075",
            "ES": "★Oph6075",
            "IT": "★Oph6075",
            "KOR": "★Oph6075",
            "CHS": "★Oph6075",
            "CHT": "★Oph6075"
        }
    ],
    "★Ser5854": [
        {
            "NO": 1462,
            "EN": "★Ser5854",
            "JP": "★Ser5854",
            "FR": "★Ser5854",
            "DE": "★Ser5854",
            "ES": "★Ser5854",
            "IT": "★Ser5854",
            "KOR": "★Ser5854",
            "CHS": "★Ser5854",
            "CHT": "★Ser5854"
        }
    ],
    "★Ser7141": [
        {
            "NO": 1463,
            "EN": "★Ser7141",
            "JP": "★Ser7141",
            "FR": "★Ser7141",
            "DE": "★Ser7141",
            "ES": "★Ser7141",
            "IT": "★Ser7141",
            "KOR": "★Ser7141",
            "CHS": "★Ser7141",
            "CHT": "★Ser7141"
        }
    ],
    "★Ser5879": [
        {
            "NO": 1464,
            "EN": "★Ser5879",
            "JP": "★Ser5879",
            "FR": "★Ser5879",
            "DE": "★Ser5879",
            "ES": "★Ser5879",
            "IT": "★Ser5879",
            "KOR": "★Ser5879",
            "CHS": "★Ser5879",
            "CHT": "★Ser5879"
        }
    ],
    "★Her6406": [
        {
            "NO": 1465,
            "EN": "★Her6406",
            "JP": "★Her6406",
            "FR": "★Her6406",
            "DE": "★Her6406",
            "ES": "★Her6406",
            "IT": "★Her6406",
            "KOR": "★Her6406",
            "CHS": "★Her6406",
            "CHT": "★Her6406"
        }
    ],
    "★Her6148": [
        {
            "NO": 1466,
            "EN": "★Her6148",
            "JP": "★Her6148",
            "FR": "★Her6148",
            "DE": "★Her6148",
            "ES": "★Her6148",
            "IT": "★Her6148",
            "KOR": "★Her6148",
            "CHS": "★Her6148",
            "CHT": "★Her6148"
        }
    ],
    "★Her6410": [
        {
            "NO": 1467,
            "EN": "★Her6410",
            "JP": "★Her6410",
            "FR": "★Her6410",
            "DE": "★Her6410",
            "ES": "★Her6410",
            "IT": "★Her6410",
            "KOR": "★Her6410",
            "CHS": "★Her6410",
            "CHT": "★Her6410"
        }
    ],
    "★Her6526": [
        {
            "NO": 1468,
            "EN": "★Her6526",
            "JP": "★Her6526",
            "FR": "★Her6526",
            "DE": "★Her6526",
            "ES": "★Her6526",
            "IT": "★Her6526",
            "KOR": "★Her6526",
            "CHS": "★Her6526",
            "CHT": "★Her6526"
        }
    ],
    "★Her6117": [
        {
            "NO": 1469,
            "EN": "★Her6117",
            "JP": "★Her6117",
            "FR": "★Her6117",
            "DE": "★Her6117",
            "ES": "★Her6117",
            "IT": "★Her6117",
            "KOR": "★Her6117",
            "CHS": "★Her6117",
            "CHT": "★Her6117"
        }
    ],
    "★Her6008": [
        {
            "NO": 1470,
            "EN": "★Her6008",
            "JP": "★Her6008",
            "FR": "★Her6008",
            "DE": "★Her6008",
            "ES": "★Her6008",
            "IT": "★Her6008",
            "KOR": "★Her6008",
            "CHS": "★Her6008",
            "CHT": "★Her6008"
        }
    ],
    "★Per936": [
        {
            "NO": 1471,
            "EN": "★Per936",
            "JP": "★Per936",
            "FR": "★Per936",
            "DE": "★Per936",
            "ES": "★Per936",
            "IT": "★Per936",
            "KOR": "★Per936",
            "CHS": "★Per936",
            "CHT": "★Per936"
        }
    ],
    "★Per1017": [
        {
            "NO": 1472,
            "EN": "★Per1017",
            "JP": "★Per1017",
            "FR": "★Per1017",
            "DE": "★Per1017",
            "ES": "★Per1017",
            "IT": "★Per1017",
            "KOR": "★Per1017",
            "CHS": "★Per1017",
            "CHT": "★Per1017"
        }
    ],
    "★Per1131": [
        {
            "NO": 1473,
            "EN": "★Per1131",
            "JP": "★Per1131",
            "FR": "★Per1131",
            "DE": "★Per1131",
            "ES": "★Per1131",
            "IT": "★Per1131",
            "KOR": "★Per1131",
            "CHS": "★Per1131",
            "CHT": "★Per1131"
        }
    ],
    "★Per1228": [
        {
            "NO": 1474,
            "EN": "★Per1228",
            "JP": "★Per1228",
            "FR": "★Per1228",
            "DE": "★Per1228",
            "ES": "★Per1228",
            "IT": "★Per1228",
            "KOR": "★Per1228",
            "CHS": "★Per1228",
            "CHT": "★Per1228"
        }
    ],
    "★Per834": [
        {
            "NO": 1475,
            "EN": "★Per834",
            "JP": "★Per834",
            "FR": "★Per834",
            "DE": "★Per834",
            "ES": "★Per834",
            "IT": "★Per834",
            "KOR": "★Per834",
            "CHS": "★Per834",
            "CHT": "★Per834"
        }
    ],
    "★Per941": [
        {
            "NO": 1476,
            "EN": "★Per941",
            "JP": "★Per941",
            "FR": "★Per941",
            "DE": "★Per941",
            "ES": "★Per941",
            "IT": "★Per941",
            "KOR": "★Per941",
            "CHS": "★Per941",
            "CHT": "★Per941"
        }
    ],
    "★Phe99": [
        {
            "NO": 1477,
            "EN": "★Phe99",
            "JP": "★Phe99",
            "FR": "★Phe99",
            "DE": "★Phe99",
            "ES": "★Phe99",
            "IT": "★Phe99",
            "KOR": "★Phe99",
            "CHS": "★Phe99",
            "CHT": "★Phe99"
        }
    ],
    "★Phe338": [
        {
            "NO": 1478,
            "EN": "★Phe338",
            "JP": "★Phe338",
            "FR": "★Phe338",
            "DE": "★Phe338",
            "ES": "★Phe338",
            "IT": "★Phe338",
            "KOR": "★Phe338",
            "CHS": "★Phe338",
            "CHT": "★Phe338"
        }
    ],
    "★Vel3634": [
        {
            "NO": 1479,
            "EN": "★Vel3634",
            "JP": "★Vel3634",
            "FR": "★Vel3634",
            "DE": "★Vel3634",
            "ES": "★Vel3634",
            "IT": "★Vel3634",
            "KOR": "★Vel3634",
            "CHS": "★Vel3634",
            "CHT": "★Vel3634"
        }
    ],
    "★Vel3485": [
        {
            "NO": 1480,
            "EN": "★Vel3485",
            "JP": "★Vel3485",
            "FR": "★Vel3485",
            "DE": "★Vel3485",
            "ES": "★Vel3485",
            "IT": "★Vel3485",
            "KOR": "★Vel3485",
            "CHS": "★Vel3485",
            "CHT": "★Vel3485"
        }
    ],
    "★Vel3734": [
        {
            "NO": 1481,
            "EN": "★Vel3734",
            "JP": "★Vel3734",
            "FR": "★Vel3734",
            "DE": "★Vel3734",
            "ES": "★Vel3734",
            "IT": "★Vel3734",
            "KOR": "★Vel3734",
            "CHS": "★Vel3734",
            "CHT": "★Vel3734"
        }
    ],
    "★Aqr8232": [
        {
            "NO": 1482,
            "EN": "★Aqr8232",
            "JP": "★Aqr8232",
            "FR": "★Aqr8232",
            "DE": "★Aqr8232",
            "ES": "★Aqr8232",
            "IT": "★Aqr8232",
            "KOR": "★Aqr8232",
            "CHS": "★Aqr8232",
            "CHT": "★Aqr8232"
        }
    ],
    "★Aqr8414": [
        {
            "NO": 1483,
            "EN": "★Aqr8414",
            "JP": "★Aqr8414",
            "FR": "★Aqr8414",
            "DE": "★Aqr8414",
            "ES": "★Aqr8414",
            "IT": "★Aqr8414",
            "KOR": "★Aqr8414",
            "CHS": "★Aqr8414",
            "CHT": "★Aqr8414"
        }
    ],
    "★Aqr8709": [
        {
            "NO": 1484,
            "EN": "★Aqr8709",
            "JP": "★Aqr8709",
            "FR": "★Aqr8709",
            "DE": "★Aqr8709",
            "ES": "★Aqr8709",
            "IT": "★Aqr8709",
            "KOR": "★Aqr8709",
            "CHS": "★Aqr8709",
            "CHT": "★Aqr8709"
        }
    ],
    "★Aqr8518": [
        {
            "NO": 1485,
            "EN": "★Aqr8518",
            "JP": "★Aqr8518",
            "FR": "★Aqr8518",
            "DE": "★Aqr8518",
            "ES": "★Aqr8518",
            "IT": "★Aqr8518",
            "KOR": "★Aqr8518",
            "CHS": "★Aqr8518",
            "CHT": "★Aqr8518"
        }
    ],
    "★Aqr7950": [
        {
            "NO": 1486,
            "EN": "★Aqr7950",
            "JP": "★Aqr7950",
            "FR": "★Aqr7950",
            "DE": "★Aqr7950",
            "ES": "★Aqr7950",
            "IT": "★Aqr7950",
            "KOR": "★Aqr7950",
            "CHS": "★Aqr7950",
            "CHT": "★Aqr7950"
        }
    ],
    "★Aqr8499": [
        {
            "NO": 1487,
            "EN": "★Aqr8499",
            "JP": "★Aqr8499",
            "FR": "★Aqr8499",
            "DE": "★Aqr8499",
            "ES": "★Aqr8499",
            "IT": "★Aqr8499",
            "KOR": "★Aqr8499",
            "CHS": "★Aqr8499",
            "CHT": "★Aqr8499"
        }
    ],
    "★Aqr8610": [
        {
            "NO": 1488,
            "EN": "★Aqr8610",
            "JP": "★Aqr8610",
            "FR": "★Aqr8610",
            "DE": "★Aqr8610",
            "ES": "★Aqr8610",
            "IT": "★Aqr8610",
            "KOR": "★Aqr8610",
            "CHS": "★Aqr8610",
            "CHT": "★Aqr8610"
        }
    ],
    "★Aqr8264": [
        {
            "NO": 1489,
            "EN": "★Aqr8264",
            "JP": "★Aqr8264",
            "FR": "★Aqr8264",
            "DE": "★Aqr8264",
            "ES": "★Aqr8264",
            "IT": "★Aqr8264",
            "KOR": "★Aqr8264",
            "CHS": "★Aqr8264",
            "CHT": "★Aqr8264"
        }
    ],
    "★Cru4853": [
        {
            "NO": 1490,
            "EN": "★Cru4853",
            "JP": "★Cru4853",
            "FR": "★Cru4853",
            "DE": "★Cru4853",
            "ES": "★Cru4853",
            "IT": "★Cru4853",
            "KOR": "★Cru4853",
            "CHS": "★Cru4853",
            "CHT": "★Cru4853"
        }
    ],
    "★Cru4730": [
        {
            "NO": 1491,
            "EN": "★Cru4730",
            "JP": "★Cru4730",
            "FR": "★Cru4730",
            "DE": "★Cru4730",
            "ES": "★Cru4730",
            "IT": "★Cru4730",
            "KOR": "★Cru4730",
            "CHS": "★Cru4730",
            "CHT": "★Cru4730"
        }
    ],
    "★Cru4763": [
        {
            "NO": 1492,
            "EN": "★Cru4763",
            "JP": "★Cru4763",
            "FR": "★Cru4763",
            "DE": "★Cru4763",
            "ES": "★Cru4763",
            "IT": "★Cru4763",
            "KOR": "★Cru4763",
            "CHS": "★Cru4763",
            "CHT": "★Cru4763"
        }
    ],
    "★Cru4700": [
        {
            "NO": 1493,
            "EN": "★Cru4700",
            "JP": "★Cru4700",
            "FR": "★Cru4700",
            "DE": "★Cru4700",
            "ES": "★Cru4700",
            "IT": "★Cru4700",
            "KOR": "★Cru4700",
            "CHS": "★Cru4700",
            "CHT": "★Cru4700"
        }
    ],
    "★Cru4656": [
        {
            "NO": 1494,
            "EN": "★Cru4656",
            "JP": "★Cru4656",
            "FR": "★Cru4656",
            "DE": "★Cru4656",
            "ES": "★Cru4656",
            "IT": "★Cru4656",
            "KOR": "★Cru4656",
            "CHS": "★Cru4656",
            "CHT": "★Cru4656"
        }
    ],
    "★PsA8728": [
        {
            "NO": 1495,
            "EN": "★PsA8728",
            "JP": "★PsA8728",
            "FR": "★PsA8728",
            "DE": "★PsA8728",
            "ES": "★PsA8728",
            "IT": "★PsA8728",
            "KOR": "★PsA8728",
            "CHS": "★PsA8728",
            "CHT": "★PsA8728"
        }
    ],
    "★TrA6217": [
        {
            "NO": 1496,
            "EN": "★TrA6217",
            "JP": "★TrA6217",
            "FR": "★TrA6217",
            "DE": "★TrA6217",
            "ES": "★TrA6217",
            "IT": "★TrA6217",
            "KOR": "★TrA6217",
            "CHS": "★TrA6217",
            "CHT": "★TrA6217"
        }
    ],
    "★Cap7776": [
        {
            "NO": 1497,
            "EN": "★Cap7776",
            "JP": "★Cap7776",
            "FR": "★Cap7776",
            "DE": "★Cap7776",
            "ES": "★Cap7776",
            "IT": "★Cap7776",
            "KOR": "★Cap7776",
            "CHS": "★Cap7776",
            "CHT": "★Cap7776"
        }
    ],
    "★Cap7754": [
        {
            "NO": 1498,
            "EN": "★Cap7754",
            "JP": "★Cap7754",
            "FR": "★Cap7754",
            "DE": "★Cap7754",
            "ES": "★Cap7754",
            "IT": "★Cap7754",
            "KOR": "★Cap7754",
            "CHS": "★Cap7754",
            "CHT": "★Cap7754"
        }
    ],
    "★Cap8278": [
        {
            "NO": 1499,
            "EN": "★Cap8278",
            "JP": "★Cap8278",
            "FR": "★Cap8278",
            "DE": "★Cap8278",
            "ES": "★Cap8278",
            "IT": "★Cap8278",
            "KOR": "★Cap8278",
            "CHS": "★Cap8278",
            "CHT": "★Cap8278"
        }
    ],
    "★Cap8322": [
        {
            "NO": 1500,
            "EN": "★Cap8322",
            "JP": "★Cap8322",
            "FR": "★Cap8322",
            "DE": "★Cap8322",
            "ES": "★Cap8322",
            "IT": "★Cap8322",
            "KOR": "★Cap8322",
            "CHS": "★Cap8322",
            "CHT": "★Cap8322"
        }
    ],
    "★Cap7773": [
        {
            "NO": 1501,
            "EN": "★Cap7773",
            "JP": "★Cap7773",
            "FR": "★Cap7773",
            "DE": "★Cap7773",
            "ES": "★Cap7773",
            "IT": "★Cap7773",
            "KOR": "★Cap7773",
            "CHS": "★Cap7773",
            "CHT": "★Cap7773"
        }
    ],
    "★Sge7479": [
        {
            "NO": 1502,
            "EN": "★Sge7479",
            "JP": "★Sge7479",
            "FR": "★Sge7479",
            "DE": "★Sge7479",
            "ES": "★Sge7479",
            "IT": "★Sge7479",
            "KOR": "★Sge7479",
            "CHS": "★Sge7479",
            "CHT": "★Sge7479"
        }
    ],
    "★Car2326": [
        {
            "NO": 1503,
            "EN": "★Car2326",
            "JP": "★Car2326",
            "FR": "★Car2326",
            "DE": "★Car2326",
            "ES": "★Car2326",
            "IT": "★Car2326",
            "KOR": "★Car2326",
            "CHS": "★Car2326",
            "CHT": "★Car2326"
        }
    ],
    "★Car3685": [
        {
            "NO": 1504,
            "EN": "★Car3685",
            "JP": "★Car3685",
            "FR": "★Car3685",
            "DE": "★Car3685",
            "ES": "★Car3685",
            "IT": "★Car3685",
            "KOR": "★Car3685",
            "CHS": "★Car3685",
            "CHT": "★Car3685"
        }
    ],
    "★Car3307": [
        {
            "NO": 1505,
            "EN": "★Car3307",
            "JP": "★Car3307",
            "FR": "★Car3307",
            "DE": "★Car3307",
            "ES": "★Car3307",
            "IT": "★Car3307",
            "KOR": "★Car3307",
            "CHS": "★Car3307",
            "CHT": "★Car3307"
        }
    ],
    "★Car3699": [
        {
            "NO": 1506,
            "EN": "★Car3699",
            "JP": "★Car3699",
            "FR": "★Car3699",
            "DE": "★Car3699",
            "ES": "★Car3699",
            "IT": "★Car3699",
            "KOR": "★Car3699",
            "CHS": "★Car3699",
            "CHT": "★Car3699"
        }
    ],
    "★Dra5744": [
        {
            "NO": 1507,
            "EN": "★Dra5744",
            "JP": "★Dra5744",
            "FR": "★Dra5744",
            "DE": "★Dra5744",
            "ES": "★Dra5744",
            "IT": "★Dra5744",
            "KOR": "★Dra5744",
            "CHS": "★Dra5744",
            "CHT": "★Dra5744"
        }
    ],
    "★Dra5291": [
        {
            "NO": 1508,
            "EN": "★Dra5291",
            "JP": "★Dra5291",
            "FR": "★Dra5291",
            "DE": "★Dra5291",
            "ES": "★Dra5291",
            "IT": "★Dra5291",
            "KOR": "★Dra5291",
            "CHS": "★Dra5291",
            "CHT": "★Dra5291"
        }
    ],
    "★Dra6705": [
        {
            "NO": 1509,
            "EN": "★Dra6705",
            "JP": "★Dra6705",
            "FR": "★Dra6705",
            "DE": "★Dra6705",
            "ES": "★Dra6705",
            "IT": "★Dra6705",
            "KOR": "★Dra6705",
            "CHS": "★Dra6705",
            "CHT": "★Dra6705"
        }
    ],
    "★Dra6536": [
        {
            "NO": 1510,
            "EN": "★Dra6536",
            "JP": "★Dra6536",
            "FR": "★Dra6536",
            "DE": "★Dra6536",
            "ES": "★Dra6536",
            "IT": "★Dra6536",
            "KOR": "★Dra6536",
            "CHS": "★Dra6536",
            "CHT": "★Dra6536"
        }
    ],
    "★Dra7310": [
        {
            "NO": 1511,
            "EN": "★Dra7310",
            "JP": "★Dra7310",
            "FR": "★Dra7310",
            "DE": "★Dra7310",
            "ES": "★Dra7310",
            "IT": "★Dra7310",
            "KOR": "★Dra7310",
            "CHS": "★Dra7310",
            "CHT": "★Dra7310"
        }
    ],
    "★Dra6688": [
        {
            "NO": 1512,
            "EN": "★Dra6688",
            "JP": "★Dra6688",
            "FR": "★Dra6688",
            "DE": "★Dra6688",
            "ES": "★Dra6688",
            "IT": "★Dra6688",
            "KOR": "★Dra6688",
            "CHS": "★Dra6688",
            "CHT": "★Dra6688"
        }
    ],
    "★Dra4434": [
        {
            "NO": 1513,
            "EN": "★Dra4434",
            "JP": "★Dra4434",
            "FR": "★Dra4434",
            "DE": "★Dra4434",
            "ES": "★Dra4434",
            "IT": "★Dra4434",
            "KOR": "★Dra4434",
            "CHS": "★Dra4434",
            "CHT": "★Dra4434"
        }
    ],
    "★Dra6370": [
        {
            "NO": 1514,
            "EN": "★Dra6370",
            "JP": "★Dra6370",
            "FR": "★Dra6370",
            "DE": "★Dra6370",
            "ES": "★Dra6370",
            "IT": "★Dra6370",
            "KOR": "★Dra6370",
            "CHS": "★Dra6370",
            "CHT": "★Dra6370"
        }
    ],
    "★Dra7462": [
        {
            "NO": 1515,
            "EN": "★Dra7462",
            "JP": "★Dra7462",
            "FR": "★Dra7462",
            "DE": "★Dra7462",
            "ES": "★Dra7462",
            "IT": "★Dra7462",
            "KOR": "★Dra7462",
            "CHS": "★Dra7462",
            "CHT": "★Dra7462"
        }
    ],
    "★Dra6396": [
        {
            "NO": 1516,
            "EN": "★Dra6396",
            "JP": "★Dra6396",
            "FR": "★Dra6396",
            "DE": "★Dra6396",
            "ES": "★Dra6396",
            "IT": "★Dra6396",
            "KOR": "★Dra6396",
            "CHS": "★Dra6396",
            "CHT": "★Dra6396"
        }
    ],
    "★Dra6132": [
        {
            "NO": 1517,
            "EN": "★Dra6132",
            "JP": "★Dra6132",
            "FR": "★Dra6132",
            "DE": "★Dra6132",
            "ES": "★Dra6132",
            "IT": "★Dra6132",
            "KOR": "★Dra6132",
            "CHS": "★Dra6132",
            "CHT": "★Dra6132"
        }
    ],
    "★Dra6636": [
        {
            "NO": 1518,
            "EN": "★Dra6636",
            "JP": "★Dra6636",
            "FR": "★Dra6636",
            "DE": "★Dra6636",
            "ES": "★Dra6636",
            "IT": "★Dra6636",
            "KOR": "★Dra6636",
            "CHS": "★Dra6636",
            "CHT": "★Dra6636"
        }
    ],
    "★CVn4915": [
        {
            "NO": 1519,
            "EN": "★CVn4915",
            "JP": "★CVn4915",
            "FR": "★CVn4915",
            "DE": "★CVn4915",
            "ES": "★CVn4915",
            "IT": "★CVn4915",
            "KOR": "★CVn4915",
            "CHS": "★CVn4915",
            "CHT": "★CVn4915"
        }
    ],
    "★CVn4785": [
        {
            "NO": 1520,
            "EN": "★CVn4785",
            "JP": "★CVn4785",
            "FR": "★CVn4785",
            "DE": "★CVn4785",
            "ES": "★CVn4785",
            "IT": "★CVn4785",
            "KOR": "★CVn4785",
            "CHS": "★CVn4785",
            "CHT": "★CVn4785"
        }
    ],
    "★CVn4846": [
        {
            "NO": 1521,
            "EN": "★CVn4846",
            "JP": "★CVn4846",
            "FR": "★CVn4846",
            "DE": "★CVn4846",
            "ES": "★CVn4846",
            "IT": "★CVn4846",
            "KOR": "★CVn4846",
            "CHS": "★CVn4846",
            "CHT": "★CVn4846"
        }
    ],
    "★Aql7595": [
        {
            "NO": 1522,
            "EN": "★Aql7595",
            "JP": "★Aql7595",
            "FR": "★Aql7595",
            "DE": "★Aql7595",
            "ES": "★Aql7595",
            "IT": "★Aql7595",
            "KOR": "★Aql7595",
            "CHS": "★Aql7595",
            "CHT": "★Aql7595"
        }
    ],
    "★Aql7557": [
        {
            "NO": 1523,
            "EN": "★Aql7557",
            "JP": "★Aql7557",
            "FR": "★Aql7557",
            "DE": "★Aql7557",
            "ES": "★Aql7557",
            "IT": "★Aql7557",
            "KOR": "★Aql7557",
            "CHS": "★Aql7557",
            "CHT": "★Aql7557"
        }
    ],
    "★Aql7525": [
        {
            "NO": 1524,
            "EN": "★Aql7525",
            "JP": "★Aql7525",
            "FR": "★Aql7525",
            "DE": "★Aql7525",
            "ES": "★Aql7525",
            "IT": "★Aql7525",
            "KOR": "★Aql7525",
            "CHS": "★Aql7525",
            "CHT": "★Aql7525"
        }
    ],
    "★Aql7602": [
        {
            "NO": 1525,
            "EN": "★Aql7602",
            "JP": "★Aql7602",
            "FR": "★Aql7602",
            "DE": "★Aql7602",
            "ES": "★Aql7602",
            "IT": "★Aql7602",
            "KOR": "★Aql7602",
            "CHS": "★Aql7602",
            "CHT": "★Aql7602"
        }
    ],
    "★Aql7235": [
        {
            "NO": 1526,
            "EN": "★Aql7235",
            "JP": "★Aql7235",
            "FR": "★Aql7235",
            "DE": "★Aql7235",
            "ES": "★Aql7235",
            "IT": "★Aql7235",
            "KOR": "★Aql7235",
            "CHS": "★Aql7235",
            "CHT": "★Aql7235"
        }
    ],
    "Max Honey": [
        {
            "NO": 1527,
            "EN": "Max Honey",
            "JP": "ダイミツ",
            "FR": "Maxi Miel",
            "DE": "Dyna-Honig",
            "ES": "Maxipanal",
            "IT": "Mielemax",
            "KOR": "다이꿀",
            "CHS": "极巨甜蜜",
            "CHT": "極巨甜蜜"
        }
    ],
    "Max Mushrooms": [
        {
            "NO": 1528,
            "EN": "Max Mushrooms",
            "JP": "ダイキノコ",
            "FR": "Maxi Champi",
            "DE": "Dyna-Pilz",
            "ES": "Maxiseta",
            "IT": "Fungomax",
            "KOR": "다이버섯",
            "CHS": "极巨菇菇",
            "CHT": "極巨菇菇"
        }
    ],
    "Galarica Twig": [
        {
            "NO": 1529,
            "EN": "Galarica Twig",
            "JP": "ガラナツのえだ",
            "FR": "Branche Galanoa",
            "DE": "Galarnuss-Zweig",
            "ES": "Rama de Galanuez",
            "IT": "Ramo Galarnoce",
            "KOR": "가라두구가지",
            "CHS": "伽勒豆蔻枝",
            "CHT": "伽勒荳蔻枝"
        }
    ],
    "Galarica Cuff": [
        {
            "NO": 1530,
            "EN": "Galarica Cuff",
            "JP": "ガラナツブレス",
            "FR": "Bracelet Galanoa",
            "DE": "Galarnuss-Reif",
            "ES": "Brazal Galanuez",
            "IT": "Fascia Galarnoce",
            "KOR": "가라두구팔찌",
            "CHS": "伽勒豆蔻手环",
            "CHT": "伽勒荳蔻手環"
        }
    ],
    "Style Card": [
        {
            "NO": 1531,
            "EN": "Style Card",
            "JP": "おしゃれカード",
            "FR": "Carte Élégance",
            "DE": "Style-Karte",
            "ES": "Tarjeta Chic",
            "IT": "Tessera chic",
            "KOR": "멋쟁이카드",
            "CHS": "时尚名人卡",
            "CHT": "時尚名人卡"
        }
    ],
    "Armor Pass": [
        {
            "NO": 1532,
            "EN": "Armor Pass",
            "JP": "ヨロイパス",
            "FR": "Pass Isolarmure",
            "DE": "Rüstungspass",
            "ES": "Pase Armadura",
            "IT": "Pass Armatura",
            "KOR": "갑옷패스",
            "CHS": "铠甲车票",
            "CHT": "鎧甲車票"
        }
    ],
    "Exp. Charm": [
        {
            "NO": 1535,
            "EN": "Exp. Charm",
            "JP": "けいけんおまもり",
            "FR": "Charme Exp",
            "DE": "EP-Pin",
            "ES": "Amuleto Experiencia",
            "IT": "Esperienzamuleto",
            "KOR": "경험부적",
            "CHS": "经验护符",
            "CHT": "經驗護符"
        }
    ],
    "Armorite Ore": [
        {
            "NO": 1536,
            "EN": "Armorite Ore",
            "JP": "ヨロイこうせき",
            "FR": "Armurium",
            "DE": "Rüstungserz",
            "ES": "Duralium",
            "IT": "Rocciarmatura",
            "KOR": "갑옷광석",
            "CHS": "铠甲矿石",
            "CHT": "鎧甲礦石"
        }
    ],
    "Mark Charm": [
        {
            "NO": 1537,
            "EN": "Mark Charm",
            "JP": "あかしのおまもり",
            "FR": "Charme Insigne",
            "DE": "Zeichenpin",
            "ES": "Amuleto Emblema",
            "IT": "Emblemamuleto",
            "KOR": "증표의부적",
            "CHS": "证章护符",
            "CHT": "證章護符"
        }
    ],
    "Reins of Unity": [
        {
            "NO": 1538,
            "EN": "Reins of Unity",
            "JP": "キズナのタヅナ",
            "FR": "Rênes de l’Unité",
            "DE": "Zügel des Bundes",
            "ES": "Riendas Unión",
            "IT": "Briglie legame",
            "KOR": "유대의고삐",
            "CHS": "牵绊缰绳",
            "CHT": "牽絆韁繩"
        },
        {
            "NO": 1539,
            "EN": "Reins of Unity",
            "JP": "キズナのタヅナ",
            "FR": "Rênes de l’Unité",
            "DE": "Zügel des Bundes",
            "ES": "Riendas Unión",
            "IT": "Briglie legame",
            "KOR": "유대의고삐",
            "CHS": "牵绊缰绳",
            "CHT": "牽絆韁繩"
        },
        {
            "NO": 1555,
            "EN": "Reins of Unity",
            "JP": "キズナのタヅナ",
            "FR": "Rênes de l’Unité",
            "DE": "Zügel des Bundes",
            "ES": "Riendas Unión",
            "IT": "Briglie legame",
            "KOR": "유대의고삐",
            "CHS": "牵绊缰绳",
            "CHT": "牽絆韁繩"
        }
    ],
    "Galarica Wreath": [
        {
            "NO": 1540,
            "EN": "Galarica Wreath",
            "JP": "ガラナツリース",
            "FR": "Couronne Galanoa",
            "DE": "Galarnuss-Kranz",
            "ES": "Corona Galanuez",
            "IT": "Corona Galarnoce",
            "KOR": "가라두구머리장식",
            "CHS": "伽勒豆蔻花圈",
            "CHT": "伽勒荳蔻花圈"
        }
    ],
    "Legendary Clue 1": [
        {
            "NO": 1541,
            "EN": "Legendary Clue 1",
            "JP": "でんせつのメモ１",
            "FR": "Note Légende 1",
            "DE": "Legenden-Notiz 1",
            "ES": "Leyenda 1",
            "IT": "Leggenda 1",
            "KOR": "전설의메모1",
            "CHS": "传说笔记１",
            "CHT": "傳說筆記１"
        }
    ],
    "Legendary Clue 2": [
        {
            "NO": 1542,
            "EN": "Legendary Clue 2",
            "JP": "でんせつのメモ２",
            "FR": "Note Légende 2",
            "DE": "Legenden-Notiz 2",
            "ES": "Leyenda 2",
            "IT": "Leggenda 2",
            "KOR": "전설의메모2",
            "CHS": "传说笔记２",
            "CHT": "傳說筆記２"
        }
    ],
    "Legendary Clue 3": [
        {
            "NO": 1543,
            "EN": "Legendary Clue 3",
            "JP": "でんせつのメモ３",
            "FR": "Note Légende 3",
            "DE": "Legenden-Notiz 3",
            "ES": "Leyenda 3",
            "IT": "Leggenda 3",
            "KOR": "전설의메모3",
            "CHS": "传说笔记３",
            "CHT": "傳說筆記３"
        }
    ],
    "Legendary Clue?": [
        {
            "NO": 1544,
            "EN": "Legendary Clue?",
            "JP": "でんせつのメモ？",
            "FR": "Note Légende (?)",
            "DE": "Legenden-Notiz X",
            "ES": "Leyenda (?)",
            "IT": "Leggenda ?",
            "KOR": "전설의메모?",
            "CHS": "传说笔记？",
            "CHT": "傳說筆記？"
        }
    ],
    "Crown Pass": [
        {
            "NO": 1545,
            "EN": "Crown Pass",
            "JP": "カンムリパス",
            "FR": "Pass Couronneige",
            "DE": "Kronenpass",
            "ES": "Pase Corona",
            "IT": "Pass Corona",
            "KOR": "왕관패스",
            "CHS": "王冠车票",
            "CHT": "王冠車票"
        }
    ],
    "Wooden Crown": [
        {
            "NO": 1546,
            "EN": "Wooden Crown",
            "JP": "きぼりのかんむり",
            "FR": "Couronne en Bois",
            "DE": "Holzkrone",
            "ES": "Corona Tallada",
            "IT": "Corona di legno",
            "KOR": "목각왕관",
            "CHS": "木雕王冠",
            "CHT": "木雕王冠"
        }
    ],
    "Radiant Petal": [
        {
            "NO": 1547,
            "EN": "Radiant Petal",
            "JP": "かがやくはなびら",
            "FR": "Pétale Brillant",
            "DE": "Kronblatt",
            "ES": "Pétalo Fulgor",
            "IT": "Petalo lucente",
            "KOR": "빛나는꽃잎",
            "CHS": "光辉花瓣",
            "CHT": "光輝花瓣"
        }
    ],
    "White Mane Hair": [
        {
            "NO": 1548,
            "EN": "White Mane Hair",
            "JP": "しろいたてがみ",
            "FR": "Crins Blancs",
            "DE": "Helles Rosshaar",
            "ES": "Crin Blanca",
            "IT": "Crini bianchi",
            "KOR": "하얀갈기",
            "CHS": "白色鬃毛",
            "CHT": "白色鬃毛"
        }
    ],
    "Black Mane Hair": [
        {
            "NO": 1549,
            "EN": "Black Mane Hair",
            "JP": "くろいたてがみ",
            "FR": "Crins Sombres",
            "DE": "Dunkles Rosshaar",
            "ES": "Crin Negra",
            "IT": "Crini neri",
            "KOR": "검은갈기",
            "CHS": "黑色鬃毛",
            "CHT": "黑色鬃毛"
        }
    ],
    "Iceroot Carrot": [
        {
            "NO": 1550,
            "EN": "Iceroot Carrot",
            "JP": "つめたいにんじん",
            "FR": "Carotte Gelée",
            "DE": "Polarkarotte",
            "ES": "Zanahoria Nívea",
            "IT": "Carota algida",
            "KOR": "차가운당근",
            "CHS": "冰萝卜",
            "CHT": "冰蘿蔔"
        }
    ],
    "Shaderoot Carrot": [
        {
            "NO": 1551,
            "EN": "Shaderoot Carrot",
            "JP": "くろいにんじん",
            "FR": "Carotte Sombre",
            "DE": "Phantomkarotte",
            "ES": "Zanahoria Oscura",
            "IT": "Carota oscura",
            "KOR": "검은당근",
            "CHS": "黑萝卜",
            "CHT": "黑蘿蔔"
        }
    ],
    "Dynite Ore": [
        {
            "NO": 1552,
            "EN": "Dynite Ore",
            "JP": "マックスこうせき",
            "FR": "Dynamaxium",
            "DE": "Dyna-Erz",
            "ES": "Maxinium",
            "IT": "Rocciamax",
            "KOR": "맥스광석",
            "CHS": "极矿石",
            "CHT": "極礦石"
        }
    ],
    "Carrot Seeds": [
        {
            "NO": 1553,
            "EN": "Carrot Seeds",
            "JP": "にんじんのタネ",
            "FR": "Graines Carotte",
            "DE": "Karottensamen",
            "ES": "Sem. Zanahoria",
            "IT": "Semi di carota",
            "KOR": "당근씨",
            "CHS": "萝卜种子",
            "CHT": "蘿蔔種子"
        }
    ],
    "Ability Patch": [
        {
            "NO": 1554,
            "EN": "Ability Patch",
            "JP": "とくせいパッチ",
            "FR": "Patch Talent",
            "DE": "Fähigkeiten-Pflaster",
            "ES": "Parche Habilidad",
            "IT": "Cerotto abilità",
            "KOR": "특성패치",
            "CHS": "特性膏药",
            "CHT": "特性膏藥"
        }
    ],
    "Time Balm": [
        {
            "NO": 1556,
            "EN": "Time Balm",
            "JP": "ときのシズメダマ",
            "FR": "Pacifi-Temps",
            "DE": "Zeitruhegabe",
            "ES": "Calmasfera Tiempo",
            "IT": "Sferazen tempo",
            "KOR": "시간의진정환",
            "CHS": "时之镇宝",
            "CHT": "時之鎮寶"
        }
    ],
    "Space Balm": [
        {
            "NO": 1557,
            "EN": "Space Balm",
            "JP": "そらのシズメダマ",
            "FR": "Pacifi-Espace",
            "DE": "Raumruhegabe",
            "ES": "Calmasfera Espacio",
            "IT": "Sferazen spazio",
            "KOR": "공간의진정환",
            "CHS": "空之镇宝",
            "CHT": "空之鎮寶"
        }
    ],
    "Mysterious Balm": [
        {
            "NO": 1558,
            "EN": "Mysterious Balm",
            "JP": "しずめだま",
            "FR": "Pacifisphère",
            "DE": "Ruhegabe",
            "ES": "Calmasfera",
            "IT": "Sferazen",
            "KOR": "진정환",
            "CHS": "镇宝",
            "CHT": "鎮寶"
        }
    ],
    "Linking Cord": [
        {
            "NO": 1559,
            "EN": "Linking Cord",
            "JP": "つながりのヒモ",
            "FR": "Fil de Liaison",
            "DE": "Verbindungsschnur",
            "ES": "Cordón Unión",
            "IT": "Filo dell’unione",
            "KOR": "연결의끈",
            "CHS": "联系绳",
            "CHT": "聯繫繩"
        }
    ],
    "Hometown Muffin": [
        {
            "NO": 1560,
            "EN": "Hometown Muffin",
            "JP": "ふるさとマフィン",
            "FR": "Muffin Tradition",
            "DE": "Heimatmuffin",
            "ES": "Bizcocho Clásico",
            "IT": "Muffin classico",
            "KOR": "고향머핀",
            "CHS": "家乡玛芬",
            "CHT": "家鄉瑪芬"
        }
    ],
    "Apricorn": [
        {
            "NO": 1561,
            "EN": "Apricorn",
            "JP": "ぼんぐりのみ",
            "FR": "Noigrume",
            "DE": "Aprikoko",
            "ES": "Bonguri",
            "IT": "Bacca ghicocca",
            "KOR": "규토리열매",
            "CHS": "球果果",
            "CHT": "球果果"
        }
    ],
    "Jubilife Muffin": [
        {
            "NO": 1562,
            "EN": "Jubilife Muffin",
            "JP": "コトブキマフィン",
            "FR": "Rusti-Muffin",
            "DE": "Jubelmuffin",
            "ES": "Bizcocho Jubileo",
            "IT": "Muffin Giubilo",
            "KOR": "축복머핀",
            "CHS": "祝庆玛芬",
            "CHT": "祝慶瑪芬"
        },
        {
            "NO": 1611,
            "EN": "Jubilife Muffin",
            "JP": "クラフトレシピ２５",
            "FR": "Rusti-Muffin",
            "DE": "Jubelmuffin",
            "ES": "Bizcocho Jubileo",
            "IT": "Muffin Giubilo",
            "KOR": "축복머핀",
            "CHS": "祝庆玛芬",
            "CHT": "祝慶瑪芬"
        }
    ],
    "Aux Powerguard": [
        {
            "NO": 1563,
            "EN": "Aux Powerguard",
            "JP": "ビルドアッパー",
            "FR": "Double Extra",
            "DE": "Kombivitamine",
            "ES": "Gragea Multi",
            "IT": "Multi extra",
            "KOR": "멀티업",
            "CHS": "多重强化",
            "CHT": "多重強化"
        },
        {
            "NO": 1622,
            "EN": "Aux Powerguard",
            "JP": "クラフトレシピ３７",
            "FR": "Double Extra",
            "DE": "Kombivitamine",
            "ES": "Gragea Multi",
            "IT": "Multi extra",
            "KOR": "멀티업",
            "CHS": "多重强化",
            "CHT": "多重強化"
        }
    ],
    "Choice Dumpling": [
        {
            "NO": 1565,
            "EN": "Choice Dumpling",
            "JP": "こだわりちまき",
            "FR": "Papillote Choix",
            "DE": "Wahlreishappen",
            "ES": "Aperitivo Elección",
            "IT": "Involtoscelta",
            "KOR": "구애잎사귀떡",
            "CHS": "讲究粽",
            "CHT": "講究粽"
        },
        {
            "NO": 1666,
            "EN": "Choice Dumpling",
            "JP": "クラフトレシピ３９",
            "FR": "Papillote Choix",
            "DE": "Wahlreishappen",
            "ES": "Aperitivo Elección",
            "IT": "Involtoscelta",
            "KOR": "구애잎사귀떡",
            "CHS": "讲究粽",
            "CHT": "講究粽"
        }
    ],
    "Twice-Spiced Radish": [
        {
            "NO": 1566,
            "EN": "Twice-Spiced Radish",
            "JP": "にばいづけ",
            "FR": "Bouchée Double",
            "DE": "Doppelrettich",
            "ES": "Encurtidoble",
            "IT": "Doppiaceto",
            "KOR": "두배절임",
            "CHS": "双倍腌菜",
            "CHT": "雙倍醃菜"
        },
        {
            "NO": 1667,
            "EN": "Twice-Spiced Radish",
            "JP": "クラフトレシピ４０",
            "FR": "Bouchée Double",
            "DE": "Doppelrettich",
            "ES": "Encurtidoble",
            "IT": "Doppiaceto",
            "KOR": "두배절임",
            "CHS": "双倍腌菜",
            "CHT": "雙倍醃菜"
        }
    ],
    "Swap Snack": [
        {
            "NO": 1567,
            "EN": "Swap Snack",
            "JP": "あべこべやき",
            "FR": "En-cas Contraire",
            "DE": "Umkehrbratling",
            "ES": "Bocadito Inversión",
            "IT": "Invertigratin",
            "KOR": "뒤바뀜구이",
            "CHS": "颠倒烧",
            "CHT": "顛倒燒"
        },
        {
            "NO": 1665,
            "EN": "Swap Snack",
            "JP": "クラフトレシピ３８",
            "FR": "En-cas Contraire",
            "DE": "Umkehrbratling",
            "ES": "Bocadito Inversión",
            "IT": "Invertigratin",
            "KOR": "뒤바뀜구이",
            "CHS": "颠倒烧",
            "CHT": "顛倒燒"
        }
    ],
    "Caster Fern": [
        {
            "NO": 1568,
            "EN": "Caster Fern",
            "JP": "まるいはっぱ",
            "FR": "Feuille Ronde",
            "DE": "Rundblatt",
            "ES": "Helecho Rizado",
            "IT": "Felcetonda",
            "KOR": "둥근고비",
            "CHS": "弹子萁",
            "CHT": "彈子萁"
        }
    ],
    "Seed of Mastery": [
        {
            "NO": 1569,
            "EN": "Seed of Mastery",
            "JP": "たくみのえまき",
            "FR": "Graine Maîtrise",
            "DE": "Meistersamen",
            "ES": "Semilla Dominio",
            "IT": "Seme padronanza",
            "KOR": "숙달의씨",
            "CHS": "精通种子",
            "CHT": "精通種子"
        }
    ],
    "Eternal Ice": [
        {
            "NO": 1571,
            "EN": "Eternal Ice",
            "JP": "こだいのこおり",
            "FR": "Glaçon Éternel",
            "DE": "Perma-Eis",
            "ES": "Hielo Eterno",
            "IT": "Ghiaccio perenne",
            "KOR": "영원한얼음",
            "CHS": "永恒之冰",
            "CHT": "永恆之冰"
        }
    ],
    "Uxie’s Claw": [
        {
            "NO": 1572,
            "EN": "Uxie’s Claw",
            "JP": "ユクシーのつめ",
            "FR": "Griffe de Créhelf",
            "DE": "Selfe-Kralle",
            "ES": "Garra de Uxie",
            "IT": "Artiglio di Uxie",
            "KOR": "유크시의손톱",
            "CHS": "由克希之爪",
            "CHT": "由克希之爪"
        }
    ],
    "Azelf’s Fang": [
        {
            "NO": 1573,
            "EN": "Azelf’s Fang",
            "JP": "アグノムのきば",
            "FR": "Croc de Créfadet",
            "DE": "Tobutz-Fangzahn",
            "ES": "Diente de Azelf",
            "IT": "Zanna di Azelf",
            "KOR": "아그놈의이빨",
            "CHS": "亚克诺姆之牙",
            "CHT": "亞克諾姆之牙"
        }
    ],
    "Mesprit’s Plume": [
        {
            "NO": 1574,
            "EN": "Mesprit’s Plume",
            "JP": "エムリットのはね",
            "FR": "Aile de Créfollet",
            "DE": "Vesprit-Feder",
            "ES": "Pluma de Mesprit",
            "IT": "Piuma di Mesprit",
            "KOR": "엠라이트의깃털",
            "CHS": "艾姆利多之翅",
            "CHT": "艾姆利多之翅"
        }
    ],
    "Tumblestone": [
        {
            "NO": 1575,
            "EN": "Tumblestone",
            "JP": "たまいし",
            "FR": "Galet",
            "DE": "Glanzstein",
            "ES": "Guijarro Rojo",
            "IT": "Ciottolo",
            "KOR": "옥돌",
            "CHS": "玉石",
            "CHT": "玉石"
        }
    ],
    "Celestica Flute": [
        {
            "NO": 1576,
            "EN": "Celestica Flute",
            "JP": "カミナギのふえ",
            "FR": "Flûte Céleste",
            "DE": "Elysien-Flöte",
            "ES": "Flauta Celestial",
            "IT": "Flauto memordei",
            "KOR": "공신의피리",
            "CHS": "神阖之笛",
            "CHT": "神闔之笛"
        }
    ],
    "Remedy": [
        {
            "NO": 1577,
            "EN": "Remedy",
            "JP": "カンポーやく",
            "FR": "Remède",
            "DE": "Arznei",
            "ES": "Remedio",
            "IT": "Preparato",
            "KOR": "한방약",
            "CHS": "中药",
            "CHT": "中藥"
        },
        {
            "NO": 1607,
            "EN": "Remedy",
            "JP": "クラフトレシピ２１",
            "FR": "Remède",
            "DE": "Arznei",
            "ES": "Remedio",
            "IT": "Preparato",
            "KOR": "한방약",
            "CHS": "中药",
            "CHT": "中藥"
        }
    ],
    "Fine Remedy": [
        {
            "NO": 1578,
            "EN": "Fine Remedy",
            "JP": "いいカンポーやく",
            "FR": "Super Remède",
            "DE": "Superarznei",
            "ES": "Superremedio",
            "IT": "Preparato buono",
            "KOR": "좋은한방약",
            "CHS": "好中药",
            "CHT": "好中藥"
        },
        {
            "NO": 1608,
            "EN": "Fine Remedy",
            "JP": "クラフトレシピ２２",
            "FR": "Super Remède",
            "DE": "Superarznei",
            "ES": "Superremedio",
            "IT": "Preparato buono",
            "KOR": "좋은한방약",
            "CHS": "好中药",
            "CHT": "好中藥"
        }
    ],
    "Dazzling Honey": [
        {
            "NO": 1579,
            "EN": "Dazzling Honey",
            "JP": "きらきらミツ",
            "FR": "Miel Kibrille",
            "DE": "Funkelhonig",
            "ES": "Miel Brillante",
            "IT": "Miele luccicante",
            "KOR": "반짝반짝꿀",
            "CHS": "晶晶蜜",
            "CHT": "晶晶蜜"
        }
    ],
    "Hearty Grains": [
        {
            "NO": 1580,
            "EN": "Hearty Grains",
            "JP": "いきいきイナホ",
            "FR": "Riz Zélé",
            "DE": "Munterreis",
            "ES": "Espiga Vivaz",
            "IT": "Spiga rigogliosa",
            "KOR": "싱싱이삭",
            "CHS": "旺旺谷",
            "CHT": "旺旺穀"
        }
    ],
    "Plump Beans": [
        {
            "NO": 1581,
            "EN": "Plump Beans",
            "JP": "ころころマメ",
            "FR": "Fève Dodue",
            "DE": "Kullerbohne",
            "ES": "Haba Suculenta",
            "IT": "Fagiolo paffuto",
            "KOR": "통통콩",
            "CHS": "滚滚豆",
            "CHT": "滾滾豆"
        }
    ],
    "Springy Mushroom": [
        {
            "NO": 1582,
            "EN": "Springy Mushroom",
            "JP": "もちもちキノコ",
            "FR": "Champi Toumou",
            "DE": "Zähpilz",
            "ES": "Seta Esponjosa",
            "IT": "Fungo gommoso",
            "KOR": "쫄깃쫄깃버섯",
            "CHS": "糯糯菇",
            "CHT": "糯糯菇"
        }
    ],
    "Crunchy Salt": [
        {
            "NO": 1583,
            "EN": "Crunchy Salt",
            "JP": "ごりごりミネラル",
            "FR": "Sel Rochedur",
            "DE": "Knirschmineral",
            "ES": "Mineral Crocante",
            "IT": "Minerale duro",
            "KOR": "단단미네랄",
            "CHS": "坚坚矿",
            "CHT": "堅堅礦"
        }
    ],
    "Wood": [
        {
            "NO": 1584,
            "EN": "Wood",
            "JP": "もくざい",
            "FR": "Bois",
            "DE": "Holz",
            "ES": "Madera",
            "IT": "Legno",
            "KOR": "목재",
            "CHS": "木材",
            "CHT": "木材"
        }
    ],
    "King’s Leaf": [
        {
            "NO": 1585,
            "EN": "King’s Leaf",
            "JP": "キングリーフ",
            "FR": "Herbe Souveraine",
            "DE": "Königsblatt",
            "ES": "Hierba Regia",
            "IT": "Foglia regina",
            "KOR": "킹리프",
            "CHS": "皇叶",
            "CHT": "皇葉"
        }
    ],
    "Marsh Balm": [
        {
            "NO": 1586,
            "EN": "Marsh Balm",
            "JP": "シズメダマ２",
            "FR": "Pacifi-Marais",
            "DE": "Moorruhegabe",
            "ES": "Calmasfera Pantano",
            "IT": "Sferazen palude",
            "KOR": "늪의진정환",
            "CHS": "沼之镇宝",
            "CHT": "沼之鎮寶"
        }
    ],
    "Feather Ball": [
        {
            "NO": 1590,
            "EN": "Feather Ball",
            "JP": "クラフトレシピ４１",
            "FR": "Plume Ball",
            "DE": "Federball",
            "ES": "Pluma Ball",
            "IT": "Piuma Ball",
            "KOR": "페더볼",
            "CHS": "飞羽球",
            "CHT": "飛羽球"
        },
        {
            "NO": 1653,
            "EN": "Feather Ball",
            "JP": "フェザーボール",
            "FR": "Plume Ball",
            "DE": "Federball",
            "ES": "Pluma Ball",
            "IT": "Piuma Ball",
            "KOR": "페더볼",
            "CHS": "飞羽球",
            "CHT": "飛羽球"
        }
    ],
    "Pokéshi Doll": [
        {
            "NO": 1591,
            "EN": "Pokéshi Doll",
            "JP": "ポケモンこけし",
            "FR": "Poupée Pokéshi",
            "DE": "Pokémon-Kokeshi",
            "ES": "Pokémuñeca",
            "IT": "Pokékokeshi",
            "KOR": "포켓몬목각인형",
            "CHS": "宝可梦木娃娃",
            "CHT": "寶可夢木娃娃"
        },
        {
            "NO": 1656,
            "EN": "Pokéshi Doll",
            "JP": "ポケモンこけし",
            "FR": "Poupée Pokéshi",
            "DE": "Pokémon-Kokeshi",
            "ES": "Pokémuñeca",
            "IT": "Pokékokeshi",
            "KOR": "포켓몬목각인형",
            "CHS": "宝可梦木娃娃",
            "CHT": "寶可夢木娃娃"
        }
    ],
    "Smoke Bomb": [
        {
            "NO": 1592,
            "EN": "Smoke Bomb",
            "JP": "クラフトレシピ０７",
            "FR": "Bombe Aveuglante",
            "DE": "Rauchkugel",
            "ES": "Bola Humareda",
            "IT": "Palla orba",
            "KOR": "눈속임환",
            "CHS": "烟弹",
            "CHT": "煙彈"
        },
        {
            "NO": 1655,
            "EN": "Smoke Bomb",
            "JP": "けむりだま",
            "FR": "Bombe Aveuglante",
            "DE": "Rauchkugel",
            "ES": "Bola Humareda",
            "IT": "Palla orba",
            "KOR": "눈속임환",
            "CHS": "烟弹",
            "CHT": "煙彈"
        }
    ],
    "Scatter Bang": [
        {
            "NO": 1593,
            "EN": "Scatter Bang",
            "JP": "ばりばりだま",
            "FR": "Sachet Pétarade",
            "DE": "Knallkugel",
            "ES": "Bola Ruidosa",
            "IT": "Scoppiosfera",
            "KOR": "팡팡환",
            "CHS": "声弹",
            "CHT": "聲彈"
        },
        {
            "NO": 1654,
            "EN": "Scatter Bang",
            "JP": "ビビリだま",
            "FR": "Sachet Pétarade",
            "DE": "Knallkugel",
            "ES": "Bola Ruidosa",
            "IT": "Scoppiosfera",
            "KOR": "팡팡환",
            "CHS": "声弹",
            "CHT": "聲彈"
        }
    ],
    "Sticky Glob": [
        {
            "NO": 1594,
            "EN": "Sticky Glob",
            "JP": "ねばりだま",
            "FR": "Boule Gluante",
            "DE": "Klebkugel",
            "ES": "Bola Pegajosa",
            "IT": "Sfera viscosa",
            "KOR": "끈끈환",
            "CHS": "黏丸",
            "CHT": "黏丸"
        },
        {
            "NO": 1632,
            "EN": "Sticky Glob",
            "JP": "ねばりだま",
            "FR": "Boule Gluante",
            "DE": "Klebkugel",
            "ES": "Bola Pegajosa",
            "IT": "Sfera viscosa",
            "KOR": "끈끈환",
            "CHS": "黏丸",
            "CHT": "黏丸"
        }
    ],
    "Mushroom Cake": [
        {
            "NO": 1596,
            "EN": "Mushroom Cake",
            "JP": "クラフトレシピ１１",
            "FR": "Appât Toumou",
            "DE": "Pilzköder",
            "ES": "Cebo de Setas",
            "IT": "Polpetta funghi",
            "KOR": "버섯유인환",
            "CHS": "菇诱团",
            "CHT": "菇誘糰"
        },
        {
            "NO": 1663,
            "EN": "Mushroom Cake",
            "JP": "キノコよせだま",
            "FR": "Appât Toumou",
            "DE": "Pilzköder",
            "ES": "Cebo de Setas",
            "IT": "Polpetta funghi",
            "KOR": "버섯유인환",
            "CHS": "菇诱团",
            "CHT": "菇誘糰"
        }
    ],
    "Bugwort": [
        {
            "NO": 1597,
            "EN": "Bugwort",
            "JP": "むらさきハーブ",
            "FR": "Plante Répulsive",
            "DE": "Schutzblume",
            "ES": "Hierba Repelente",
            "IT": "Erba repellente",
            "KOR": "벌레회피풀",
            "CHS": "除虫草",
            "CHT": "除蟲草"
        }
    ],
    "Honey Cake": [
        {
            "NO": 1598,
            "EN": "Honey Cake",
            "JP": "クラフトレシピ１２",
            "FR": "Appât Kibrille",
            "DE": "Honigköder",
            "ES": "Cebo Meloso",
            "IT": "Polpetta miele",
            "KOR": "꿀유인환",
            "CHS": "蜜诱团",
            "CHT": "蜜誘糰"
        },
        {
            "NO": 1660,
            "EN": "Honey Cake",
            "JP": "ミツよせだま",
            "FR": "Appât Kibrille",
            "DE": "Honigköder",
            "ES": "Cebo Meloso",
            "IT": "Polpetta miele",
            "KOR": "꿀유인환",
            "CHS": "蜜诱团",
            "CHT": "蜜誘糰"
        }
    ],
    "Grain Cake": [
        {
            "NO": 1599,
            "EN": "Grain Cake",
            "JP": "クラフトレシピ１３",
            "FR": "Appât Zélé",
            "DE": "Reisköder",
            "ES": "Cebo de Grano",
            "IT": "Polpetta spighe",
            "KOR": "이삭유인환",
            "CHS": "谷诱团",
            "CHT": "穀誘糰"
        },
        {
            "NO": 1661,
            "EN": "Grain Cake",
            "JP": "イナホよせだま",
            "FR": "Appât Zélé",
            "DE": "Reisköder",
            "ES": "Cebo de Grano",
            "IT": "Polpetta spighe",
            "KOR": "이삭유인환",
            "CHS": "谷诱团",
            "CHT": "穀誘糰"
        }
    ],
    "Bean Cake": [
        {
            "NO": 1600,
            "EN": "Bean Cake",
            "JP": "クラフトレシピ１４",
            "FR": "Appât Dodu",
            "DE": "Bohnenköder",
            "ES": "Cebo de Habas",
            "IT": "Polpetta fagioli",
            "KOR": "콩유인환",
            "CHS": "豆诱团",
            "CHT": "豆誘糰"
        },
        {
            "NO": 1662,
            "EN": "Bean Cake",
            "JP": "マメよせだま",
            "FR": "Appât Dodu",
            "DE": "Bohnenköder",
            "ES": "Cebo de Habas",
            "IT": "Polpetta fagioli",
            "KOR": "콩유인환",
            "CHS": "豆诱团",
            "CHT": "豆誘糰"
        }
    ],
    "Salt Cake": [
        {
            "NO": 1601,
            "EN": "Salt Cake",
            "JP": "クラフトレシピ１５",
            "FR": "Appât Rochedur",
            "DE": "Mineralköder",
            "ES": "Cebo Mineral",
            "IT": "Polpetta minerale",
            "KOR": "미네랄유인환",
            "CHS": "矿诱团",
            "CHT": "礦誘糰"
        },
        {
            "NO": 1664,
            "EN": "Salt Cake",
            "JP": "ミネラルよせだま",
            "FR": "Appât Rochedur",
            "DE": "Mineralköder",
            "ES": "Cebo Mineral",
            "IT": "Polpetta minerale",
            "KOR": "미네랄유인환",
            "CHS": "矿诱团",
            "CHT": "礦誘糰"
        }
    ],
    "Superb Remedy": [
        {
            "NO": 1609,
            "EN": "Superb Remedy",
            "JP": "クラフトレシピ２３",
            "FR": "Hyper Remède",
            "DE": "Hyperarznei",
            "ES": "Hiperremedio",
            "IT": "Preparato ottimo",
            "KOR": "고급한방약",
            "CHS": "厉害中药",
            "CHT": "厲害中藥"
        },
        {
            "NO": 1691,
            "EN": "Superb Remedy",
            "JP": "すごいカンポーやく",
            "FR": "Hyper Remède",
            "DE": "Hyperarznei",
            "ES": "Hiperremedio",
            "IT": "Preparato ottimo",
            "KOR": "고급한방약",
            "CHS": "厉害中药",
            "CHT": "厲害中藥"
        }
    ],
    "Stealth Spray": [
        {
            "NO": 1617,
            "EN": "Stealth Spray",
            "JP": "クラフトレシピ３１",
            "FR": "Solution Furtive",
            "DE": "Schleichspray",
            "ES": "Aerosol Sigilo",
            "IT": "Furtivizzante",
            "KOR": "살금살금스프레이",
            "CHS": "匿声喷雾",
            "CHT": "匿聲噴霧"
        },
        {
            "NO": 1635,
            "EN": "Stealth Spray",
            "JP": "むしよけスプレー",
            "FR": "Solution Furtive",
            "DE": "Schleichspray",
            "ES": "Aerosol Sigilo",
            "IT": "Furtivizzante",
            "KOR": "살금살금스프레이",
            "CHS": "匿声喷雾",
            "CHT": "匿聲噴霧"
        }
    ],
    "Aux Power": [
        {
            "NO": 1618,
            "EN": "Aux Power",
            "JP": "クラフトレシピ３３",
            "FR": "Offensive Extra",
            "DE": "Offensivvitamine",
            "ES": "Gragea Ofensiva",
            "IT": "Offensiva extra",
            "KOR": "공격의환약",
            "CHS": "进攻药丸",
            "CHT": "進攻藥丸"
        },
        {
            "NO": 1692,
            "EN": "Aux Power",
            "JP": "アタックアップ",
            "FR": "Offensive Extra",
            "DE": "Offensivvitamine",
            "ES": "Gragea Ofensiva",
            "IT": "Offensiva extra",
            "KOR": "공격의환약",
            "CHS": "进攻药丸",
            "CHT": "進攻藥丸"
        }
    ],
    "Aux Guard": [
        {
            "NO": 1619,
            "EN": "Aux Guard",
            "JP": "クラフトレシピ３４",
            "FR": "Défense Extra",
            "DE": "Defensivvitamine",
            "ES": "Gragea Defensiva",
            "IT": "Difensiva extra",
            "KOR": "방어의환약",
            "CHS": "防守药丸",
            "CHT": "防守藥丸"
        },
        {
            "NO": 1693,
            "EN": "Aux Guard",
            "JP": "ディフェンスアップ",
            "FR": "Défense Extra",
            "DE": "Defensivvitamine",
            "ES": "Gragea Defensiva",
            "IT": "Difensiva extra",
            "KOR": "방어의환약",
            "CHS": "防守药丸",
            "CHT": "防守藥丸"
        }
    ],
    "Aux Evasion": [
        {
            "NO": 1621,
            "EN": "Aux Evasion",
            "JP": "クラフトレシピ３６",
            "FR": "Esquive Extra",
            "DE": "Ausweichvitamine",
            "ES": "Gragea Evasiva",
            "IT": "Elusione X",
            "KOR": "잘-안맞기",
            "CHS": "闪避强化",
            "CHT": "閃避強化"
        },
        {
            "NO": 1694,
            "EN": "Aux Evasion",
            "JP": "ヨクアタラーヌ",
            "FR": "Esquive Extra",
            "DE": "Ausweichvitamine",
            "ES": "Gragea Evasiva",
            "IT": "Elusione X",
            "KOR": "잘-안맞기",
            "CHS": "闪避强化",
            "CHT": "閃避強化"
        }
    ],
    "Forest Balm": [
        {
            "NO": 1623,
            "EN": "Forest Balm",
            "JP": "しずめダマ",
            "FR": "Pacifi-Forêt",
            "DE": "Waldruhegabe",
            "ES": "Calmasfera Bosque",
            "IT": "Sferazen foresta",
            "KOR": "숲의진정환",
            "CHS": "森之镇宝",
            "CHT": "森之鎮寶"
        }
    ],
    "Iron Chunk": [
        {
            "NO": 1624,
            "EN": "Iron Chunk",
            "JP": "てつのかけら",
            "FR": "Fragment de Fer",
            "DE": "Eisenbrocken",
            "ES": "Pepita de Hierro",
            "IT": "Pezzo di ferro",
            "KOR": "철조각",
            "CHS": "碎铁",
            "CHT": "碎鐵"
        }
    ],
    "Black Tumblestone": [
        {
            "NO": 1625,
            "EN": "Black Tumblestone",
            "JP": "くろいろたまいし",
            "FR": "Galet Noir",
            "DE": "Schwarzglanzstein",
            "ES": "Guijarro Negro",
            "IT": "Ciottolo nero",
            "KOR": "검은옥돌",
            "CHS": "黑玉石",
            "CHT": "黑玉石"
        }
    ],
    "Sky Tumblestone": [
        {
            "NO": 1626,
            "EN": "Sky Tumblestone",
            "JP": "そらいろたまいし",
            "FR": "Galet Azur",
            "DE": "Azurglanzstein",
            "ES": "Guijarro Celeste",
            "IT": "Ciottolo celeste",
            "KOR": "하늘색옥돌",
            "CHS": "天蓝玉石",
            "CHT": "天藍玉石"
        }
    ],
    "Ball of Mud": [
        {
            "NO": 1627,
            "EN": "Ball of Mud",
            "JP": "どろだんご",
            "FR": "Boule de Boue",
            "DE": "Lehmball",
            "ES": "Bola de Lodo",
            "IT": "Palla di fango",
            "KOR": "진흙경단",
            "CHS": "泥丸",
            "CHT": "泥丸"
        }
    ],
    "Pop Pod": [
        {
            "NO": 1628,
            "EN": "Pop Pod",
            "JP": "バリバリモズク",
            "FR": "Pétaralgue",
            "DE": "Knallmoos",
            "ES": "Marimo Ruidoso",
            "IT": "Scoppiettalga",
            "KOR": "팡팡마리모",
            "CHS": "惊声藻",
            "CHT": "驚聲藻"
        }
    ],
    "Sootfoot Root": [
        {
            "NO": 1629,
            "EN": "Sootfoot Root",
            "JP": "ケムリイモ",
            "FR": "Rutabagaz",
            "DE": "Rauchknolle",
            "ES": "Fumibulbo",
            "IT": "Patata fumosa",
            "KOR": "연기토란",
            "CHS": "烟芋",
            "CHT": "煙芋"
        }
    ],
    "Spoiled Apricorn": [
        {
            "NO": 1630,
            "EN": "Spoiled Apricorn",
            "JP": "むしくいぼんぐり",
            "FR": "Noigrume Rongé",
            "DE": "Löchrige Aprikoko",
            "ES": "Bonguri Pocho",
            "IT": "Ghicocca bacata",
            "KOR": "벌레먹은규토리",
            "CHS": "蛀球果",
            "CHT": "蛀球果"
        }
    ],
    "Black Augurite": [
        {
            "NO": 1633,
            "EN": "Black Augurite",
            "JP": "くろのきせき",
            "FR": "Obsidienne",
            "DE": "Schwarzaugit",
            "ES": "Mineral Negro",
            "IT": "Augite nera",
            "KOR": "검은휘석",
            "CHS": "黑奇石",
            "CHT": "黑奇石"
        }
    ],
    "Peat Block": [
        {
            "NO": 1634,
            "EN": "Peat Block",
            "JP": "ピートブロック",
            "FR": "Bloc de Tourbe",
            "DE": "Torfblock",
            "ES": "Bloque de Turba",
            "IT": "Blocco di torba",
            "KOR": "피트블록",
            "CHS": "泥炭块",
            "CHT": "泥炭塊"
        }
    ],
    "Medicinal Leek": [
        {
            "NO": 1636,
            "EN": "Medicinal Leek",
            "JP": "クスリソウ",
            "FR": "Soignon",
            "DE": "Fitlauch",
            "ES": "Puerro Medicinal",
            "IT": "Porro officinale",
            "KOR": "약초",
            "CHS": "疗草",
            "CHT": "療草"
        }
    ],
    "Vivichoke": [
        {
            "NO": 1637,
            "EN": "Vivichoke",
            "JP": "ゲンキツボミ",
            "FR": "Bourgeon Vivace",
            "DE": "Vitalknospe",
            "ES": "Revibrote",
            "IT": "Revitalboccio",
            "KOR": "기력의봉오리",
            "CHS": "活力蕾",
            "CHT": "活力蕾"
        }
    ],
    "Pep-Up Plant": [
        {
            "NO": 1638,
            "EN": "Pep-Up Plant",
            "JP": "ピーピーグサ",
            "FR": "Plante PP",
            "DE": "Ätherkraut",
            "ES": "Hierba Éter",
            "IT": "Erba PP",
            "KOR": "PP풀",
            "CHS": "ＰＰ草",
            "CHT": "ＰＰ草"
        }
    ],
    "Tempting Charm B": [
        {
            "NO": 1639,
            "EN": "Tempting Charm B",
            "JP": "ふしぎなおまもり２（仮）",
            "FR": "Remplamulette 2",
            "DE": "Wahrungstalisman 2",
            "ES": "Amuleto Sustituto 2",
            "IT": "Amuleto Sostituto 2",
            "KOR": "대타부적2",
            "CHS": "替身护符２",
            "CHT": "替身護符２"
        }
    ],
    "Tempting Charm P": [
        {
            "NO": 1640,
            "EN": "Tempting Charm P",
            "JP": "ふしぎなおまもり３（仮）",
            "FR": "Remplamulette 3",
            "DE": "Wahrungstalisman 3",
            "ES": "Amuleto Sustituto 3",
            "IT": "Amuleto Sostituto 3",
            "KOR": "대타부적3",
            "CHS": "替身护符３",
            "CHT": "替身護符３"
        }
    ],
    "Swordcap": [
        {
            "NO": 1641,
            "EN": "Swordcap",
            "JP": "ツルギマイタケ",
            "FR": "Fortichampi",
            "DE": "Schwertling",
            "ES": "Seta Espada",
            "IT": "Danzaspaditola",
            "KOR": "칼춤버섯",
            "CHS": "剑舞菇",
            "CHT": "劍舞菇"
        }
    ],
    "Iron Barktongue": [
        {
            "NO": 1642,
            "EN": "Iron Barktongue",
            "JP": "テッペキクラゲ",
            "FR": "Carapachampi",
            "DE": "Schildling",
            "ES": "Seta Férrea",
            "IT": "Ferroscudino",
            "KOR": "철벽버섯",
            "CHS": "铁壁木耳",
            "CHT": "鐵壁木耳"
        }
    ],
    "Doppel Bonnets": [
        {
            "NO": 1643,
            "EN": "Doppel Bonnets",
            "JP": "カゲブンシメジ（仮）",
            "FR": "Champinja",
            "DE": "Flinkling",
            "ES": "Seta Evasiva",
            "IT": "Doppioteamillo",
            "KOR": "그림자분신버섯",
            "CHS": "影分菇",
            "CHT": "影分菇"
        }
    ],
    "Direshroom": [
        {
            "NO": 1644,
            "EN": "Direshroom",
            "JP": "キュウショウロ（仮）",
            "FR": "Champiscoto",
            "DE": "Volltrefferling",
            "ES": "Seta Crítica",
            "IT": "Colpogone",
            "KOR": "급소버섯",
            "CHS": "要害松露",
            "CHT": "要害松露"
        }
    ],
    "Sand Radish": [
        {
            "NO": 1645,
            "EN": "Sand Radish",
            "JP": "すなはまダイコン",
            "FR": "Radis des Plages",
            "DE": "Strandrettich",
            "ES": "Rábano Arenero",
            "IT": "Rafano costiero",
            "KOR": "모래해변무",
            "CHS": "沙滩萝卜",
            "CHT": "沙灘蘿蔔"
        }
    ],
    "Tempting Charm T": [
        {
            "NO": 1646,
            "EN": "Tempting Charm T",
            "JP": "ふしぎなおまもり４（仮）",
            "FR": "Remplamulette 4",
            "DE": "Wahrungstalisman 4",
            "ES": "Amuleto Sustituto 4",
            "IT": "Amuleto Sostituto 4",
            "KOR": "대타부적4",
            "CHS": "替身护符４",
            "CHT": "替身護符４"
        }
    ],
    "Tempting Charm Y": [
        {
            "NO": 1647,
            "EN": "Tempting Charm Y",
            "JP": "ふしぎなおまもり５（仮）",
            "FR": "Remplamulette 5",
            "DE": "Wahrungstalisman 5",
            "ES": "Amuleto Sustituto 5",
            "IT": "Amuleto Sostituto 5",
            "KOR": "대타부적5",
            "CHS": "替身护符５",
            "CHT": "替身護符５"
        }
    ],
    "Candy Truffle": [
        {
            "NO": 1648,
            "EN": "Candy Truffle",
            "JP": "スイートトリュフ",
            "FR": "Truffe Sucrée",
            "DE": "Süßtrüffel",
            "ES": "Trufa Dulce",
            "IT": "Tartufo dolce",
            "KOR": "스위트러플",
            "CHS": "甜松露",
            "CHT": "甜松露"
        }
    ],
    "Cake-Lure Base": [
        {
            "NO": 1649,
            "EN": "Cake-Lure Base",
            "JP": "よせだまのもと",
            "FR": "Appâte",
            "DE": "Köderteig",
            "ES": "Masa para Cebo",
            "IT": "Polpetta base",
            "KOR": "유인환반죽",
            "CHS": "诱团原料",
            "CHT": "誘糰原料"
        }
    ],
    "Volcano Balm": [
        {
            "NO": 1657,
            "EN": "Volcano Balm",
            "JP": "かざんのシズメダマ",
            "FR": "Pacifi-Volcan",
            "DE": "Vulkanruhegabe",
            "ES": "Calmasfera Volcán",
            "IT": "Sferazen vulcano",
            "KOR": "화산의진정환",
            "CHS": "火山镇宝",
            "CHT": "火山鎮寶"
        }
    ],
    "Mountain Balm": [
        {
            "NO": 1658,
            "EN": "Mountain Balm",
            "JP": "やまのシズメダマ",
            "FR": "Pacifi-Montagne",
            "DE": "Bergruhegabe",
            "ES": "Calmasfera Montaña",
            "IT": "Sferazen monte",
            "KOR": "산의진정환",
            "CHS": "山之镇宝",
            "CHT": "山之鎮寶"
        }
    ],
    "Snow Balm": [
        {
            "NO": 1659,
            "EN": "Snow Balm",
            "JP": "ゆきのシズメダマ",
            "FR": "Pacifi-Neige",
            "DE": "Schneeruhegabe",
            "ES": "Calmasfera Nieve",
            "IT": "Sferazen neve",
            "KOR": "눈의진정환",
            "CHS": "雪之镇宝",
            "CHT": "雪之鎮寶"
        }
    ],
    "Survival Charm R": [
        {
            "NO": 1668,
            "EN": "Survival Charm R",
            "JP": "あんぜんおまもり１",
            "FR": "Enduramulette 1",
            "DE": "Schutztalisman 1",
            "ES": "Amuleto Protector 1",
            "IT": "Amuleto tutela 1",
            "KOR": "안전부적1",
            "CHS": "安全护符１",
            "CHT": "安全護符１"
        }
    ],
    "Survival Charm B": [
        {
            "NO": 1669,
            "EN": "Survival Charm B",
            "JP": "あんぜんおまもり２",
            "FR": "Enduramulette 2",
            "DE": "Schutztalisman 2",
            "ES": "Amuleto Protector 2",
            "IT": "Amuleto tutela 2",
            "KOR": "안전부적2",
            "CHS": "安全护符２",
            "CHT": "安全護符２"
        }
    ],
    "Survival Charm P": [
        {
            "NO": 1670,
            "EN": "Survival Charm P",
            "JP": "あんぜんおまもり３",
            "FR": "Enduramulette 3",
            "DE": "Schutztalisman 3",
            "ES": "Amuleto Protector 3",
            "IT": "Amuleto tutela 3",
            "KOR": "안전부적3",
            "CHS": "安全护符３",
            "CHT": "安全護符３"
        }
    ],
    "Survival Charm T": [
        {
            "NO": 1671,
            "EN": "Survival Charm T",
            "JP": "あんぜんおまもり４",
            "FR": "Enduramulette 4",
            "DE": "Schutztalisman 4",
            "ES": "Amuleto Protector 4",
            "IT": "Amuleto tutela 4",
            "KOR": "안전부적4",
            "CHS": "安全护符４",
            "CHT": "安全護符４"
        }
    ],
    "Survival Charm Y": [
        {
            "NO": 1672,
            "EN": "Survival Charm Y",
            "JP": "あんぜんおまもり５",
            "FR": "Enduramulette 5",
            "DE": "Schutztalisman 5",
            "ES": "Amuleto Protector 5",
            "IT": "Amuleto tutela 5",
            "KOR": "안전부적5",
            "CHS": "安全护符５",
            "CHT": "安全護符５"
        }
    ],
    "Torn Journal": [
        {
            "NO": 1673,
            "EN": "Torn Journal",
            "JP": "やぶれたにっき",
            "FR": "Journal Déchiré",
            "DE": "Kaputtes Journal",
            "ES": "Diario Rasgado",
            "IT": "Diario rovinato",
            "KOR": "찢어진일기",
            "CHS": "破损日记",
            "CHT": "破損日記"
        }
    ],
    "Warding Charm R": [
        {
            "NO": 1674,
            "EN": "Warding Charm R",
            "JP": "けんこうおまもり１",
            "FR": "Zenamulette 1",
            "DE": "Statustalisman 1",
            "ES": "Amuleto Salud 1",
            "IT": "Amuleto salute 1",
            "KOR": "건강부적1",
            "CHS": "健康护符１",
            "CHT": "健康護符１"
        }
    ],
    "Warding Charm B": [
        {
            "NO": 1675,
            "EN": "Warding Charm B",
            "JP": "けんこうおまもり２",
            "FR": "Zenamulette 2",
            "DE": "Statustalisman 2",
            "ES": "Amuleto Salud 2",
            "IT": "Amuleto salute 2",
            "KOR": "건강부적2",
            "CHS": "健康护符２",
            "CHT": "健康護符２"
        }
    ],
    "Warding Charm P": [
        {
            "NO": 1676,
            "EN": "Warding Charm P",
            "JP": "けんこうおまもり３",
            "FR": "Zenamulette 3",
            "DE": "Statustalisman 3",
            "ES": "Amuleto Salud 3",
            "IT": "Amuleto salute 3",
            "KOR": "건강부적3",
            "CHS": "健康护符３",
            "CHT": "健康護符３"
        }
    ],
    "Warding Charm T": [
        {
            "NO": 1677,
            "EN": "Warding Charm T",
            "JP": "けんこうおまもり４",
            "FR": "Zenamulette 4",
            "DE": "Statustalisman 4",
            "ES": "Amuleto Salud 4",
            "IT": "Amuleto salute 4",
            "KOR": "건강부적4",
            "CHS": "健康护符４",
            "CHT": "健康護符４"
        }
    ],
    "Warding Charm Y": [
        {
            "NO": 1678,
            "EN": "Warding Charm Y",
            "JP": "けんこうおまもり５",
            "FR": "Zenamulette 5",
            "DE": "Statustalisman 5",
            "ES": "Amuleto Salud 5",
            "IT": "Amuleto salute 5",
            "KOR": "건강부적5",
            "CHS": "健康护符５",
            "CHT": "健康護符５"
        }
    ],
    "Wall Fragment": [
        {
            "NO": 1679,
            "EN": "Wall Fragment",
            "JP": "せきばんのかけら",
            "FR": "Fragment de Mur",
            "DE": "Plattenfragment",
            "ES": "Trozo de Losa",
            "IT": "Pezzo di lastra",
            "KOR": "석판조각",
            "CHS": "石板碎块",
            "CHT": "石板碎塊"
        }
    ],
    "Basculegion Food": [
        {
            "NO": 1680,
            "EN": "Basculegion Food",
            "JP": "イダイトウだんご",
            "FR": "Appâragruel",
            "DE": "Salmagnis-Kloß",
            "ES": "Cebo Basculegion",
            "IT": "Esca Basculegion",
            "KOR": "대쓰여너경단",
            "CHS": "幽尾玄鱼丸",
            "CHT": "幽尾玄魚丸"
        }
    ],
    "Old Journal": [
        {
            "NO": 1681,
            "EN": "Old Journal",
            "JP": "ふるいにっき",
            "FR": "Vieux Journal",
            "DE": "Altes Journal",
            "ES": "Diario Antiguo",
            "IT": "Vecchio diario",
            "KOR": "낡은일기",
            "CHS": "古老日记",
            "CHT": "古老日記"
        }
    ],
    "Wing Ball": [
        {
            "NO": 1682,
            "EN": "Wing Ball",
            "JP": "ウイングボール",
            "FR": "Envol Ball",
            "DE": "Flügelball",
            "ES": "Ala Ball",
            "IT": "Wing Ball",
            "KOR": "윙볼",
            "CHS": "飞翼球",
            "CHT": "飛翼球"
        },
        {
            "NO": 1687,
            "EN": "Wing Ball",
            "JP": "ウイングボール",
            "FR": "Envol Ball",
            "DE": "Flügelball",
            "ES": "Ala Ball",
            "IT": "Wing Ball",
            "KOR": "윙볼",
            "CHS": "飞翼球",
            "CHT": "飛翼球"
        }
    ],
    "Jet Ball": [
        {
            "NO": 1683,
            "EN": "Jet Ball",
            "JP": "ジェットボール",
            "FR": "Propulse Ball",
            "DE": "Düsenball",
            "ES": "Aero Ball",
            "IT": "Jet Ball",
            "KOR": "제트볼",
            "CHS": "飞梭球",
            "CHT": "飛梭球"
        },
        {
            "NO": 1688,
            "EN": "Jet Ball",
            "JP": "クラフトレシピ４２",
            "FR": "Propulse Ball",
            "DE": "Düsenball",
            "ES": "Aero Ball",
            "IT": "Jet Ball",
            "KOR": "제트볼",
            "CHS": "飞梭球",
            "CHT": "飛梭球"
        }
    ],
    "Leaden Ball": [
        {
            "NO": 1685,
            "EN": "Leaden Ball",
            "JP": "メガトンボール",
            "FR": "Mégamasse Ball",
            "DE": "Zentnerball",
            "ES": "Kilo Ball",
            "IT": "Megaton Ball",
            "KOR": "메가톤볼",
            "CHS": "超重球",
            "CHT": "超重球"
        },
        {
            "NO": 1713,
            "EN": "Leaden Ball",
            "JP": "クラフトレシピ４４",
            "FR": "Mégamasse Ball",
            "DE": "Zentnerball",
            "ES": "Kilo Ball",
            "IT": "Megaton Ball",
            "KOR": "메가톤볼",
            "CHS": "超重球",
            "CHT": "超重球"
        }
    ],
    "Gigaton Ball": [
        {
            "NO": 1686,
            "EN": "Gigaton Ball",
            "JP": "ギガトンボール",
            "FR": "Gigamasse Ball",
            "DE": "Tonnenball",
            "ES": "Quintal Ball",
            "IT": "Gigaton Ball",
            "KOR": "기가톤볼",
            "CHS": "巨重球",
            "CHT": "巨重球"
        },
        {
            "NO": 1714,
            "EN": "Gigaton Ball",
            "JP": "クラフトレシピ４５",
            "FR": "Gigamasse Ball",
            "DE": "Tonnenball",
            "ES": "Quintal Ball",
            "IT": "Gigaton Ball",
            "KOR": "기가톤볼",
            "CHS": "巨重球",
            "CHT": "巨重球"
        }
    ],
    "Hopo Berry": [
        {
            "NO": 1690,
            "EN": "Hopo Berry",
            "JP": "ポフのみ",
            "FR": "Baie Bouhlon",
            "DE": "Pfohbeere",
            "ES": "Baya Lupu",
            "IT": "Baccaluppo",
            "KOR": "포흐열매",
            "CHS": "花啤果",
            "CHT": "花啤果"
        }
    ],
    "Grit Dust": [
        {
            "NO": 1695,
            "EN": "Grit Dust",
            "JP": "ガンバリのすな",
            "FR": "Sable Effort",
            "DE": "Leistungssand",
            "ES": "Polvo Esfuerzo",
            "IT": "Sabbia impegno",
            "KOR": "노력의모래",
            "CHS": "奋斗沙",
            "CHT": "奮鬥沙"
        }
    ],
    "Grit Gravel": [
        {
            "NO": 1696,
            "EN": "Grit Gravel",
            "JP": "ガンバリのじゃり",
            "FR": "Cailloux Effort",
            "DE": "Leistungskies",
            "ES": "Grava Esfuerzo",
            "IT": "Ghiaia impegno",
            "KOR": "노력의자갈",
            "CHS": "奋斗砾",
            "CHT": "奮鬥礫"
        }
    ],
    "Grit Pebble": [
        {
            "NO": 1697,
            "EN": "Grit Pebble",
            "JP": "ガンバリのいし",
            "FR": "Pierre Effort",
            "DE": "Leistungsstein",
            "ES": "Piedra Esfuerzo",
            "IT": "Pietra impegno",
            "KOR": "노력의돌",
            "CHS": "奋斗石",
            "CHT": "奮鬥石"
        }
    ],
    "Grit Rock": [
        {
            "NO": 1698,
            "EN": "Grit Rock",
            "JP": "ガンバリのいわ",
            "FR": "Rocher Effort",
            "DE": "Leistungsfels",
            "ES": "Roca Esfuerzo",
            "IT": "Roccia impegno",
            "KOR": "노력의바위",
            "CHS": "奋斗岩",
            "CHT": "奮鬥岩"
        }
    ],
    "Tempting Charm R": [
        {
            "NO": 1700,
            "EN": "Tempting Charm R",
            "JP": "ふしぎなおまもり",
            "FR": "Remplamulette 1",
            "DE": "Wahrungstalisman 1",
            "ES": "Amuleto Sustituto 1",
            "IT": "Amuleto Sostituto 1",
            "KOR": "대타부적1",
            "CHS": "替身护符１",
            "CHT": "替身護符１"
        }
    ],
    "Lost Satchel": [
        {
            "NO": 1701,
            "EN": "Lost Satchel",
            "JP": "だれかのポーチ",
            "FR": "Objet Perdu",
            "DE": "Verlorene Items",
            "ES": "Objeto perdido",
            "IT": "Oggetto smarrito",
            "KOR": "누군가의분실물",
            "CHS": "他人的遗失物",
            "CHT": "某人的遺失物"
        },
        {
            "NO": 1702,
            "EN": "Lost Satchel",
            "JP": "だれかのポーチ",
            "FR": "Objet Perdu",
            "DE": "Verlorene Items",
            "ES": "Objeto perdido",
            "IT": "Oggetto smarrito",
            "KOR": "누군가의분실물",
            "CHS": "他人的遗失物",
            "CHT": "某人的遺失物"
        },
        {
            "NO": 1703,
            "EN": "Lost Satchel",
            "JP": "だれかのポーチ",
            "FR": "Objet Perdu",
            "DE": "Verlorene Items",
            "ES": "Objeto perdido",
            "IT": "Oggetto smarrito",
            "KOR": "누군가의분실물",
            "CHS": "他人的遗失物",
            "CHT": "某人的遺失物"
        },
        {
            "NO": 1704,
            "EN": "Lost Satchel",
            "JP": "だれかのポーチ",
            "FR": "Objet Perdu",
            "DE": "Verlorene Items",
            "ES": "Objeto perdido",
            "IT": "Oggetto smarrito",
            "KOR": "누군가의분실물",
            "CHS": "他人的遗失物",
            "CHT": "某人的遺失物"
        },
        {
            "NO": 1705,
            "EN": "Lost Satchel",
            "JP": "だれかのポーチ",
            "FR": "Objet Perdu",
            "DE": "Verlorene Items",
            "ES": "Objeto perdido",
            "IT": "Oggetto smarrito",
            "KOR": "누군가의분실물",
            "CHS": "他人的遗失物",
            "CHT": "某人的遺失物"
        }
    ],
    "Origin Ball": [
        {
            "NO": 1706,
            "EN": "Origin Ball",
            "JP": "オリジンボール",
            "FR": "Origine Ball",
            "DE": "Urball",
            "ES": "Origen Ball",
            "IT": "Origin Ball",
            "KOR": "오리진볼",
            "CHS": "起源球",
            "CHT": "起源球"
        }
    ],
    "Origin Ore": [
        {
            "NO": 1707,
            "EN": "Origin Ore",
            "JP": "オリジンこうせき",
            "FR": "Minerai Origine",
            "DE": "Urerz",
            "ES": "Mena Origen",
            "IT": "Rocciorigine",
            "KOR": "오리진광석",
            "CHS": "起源矿石",
            "CHT": "起源礦石"
        }
    ],
    "Adamant Crystal": [
        {
            "NO": 1708,
            "EN": "Adamant Crystal",
            "JP": "だいこんごうだま",
            "FR": "Globe Adamant",
            "DE": "Adamantkristall",
            "ES": "Gran Diamansfera",
            "IT": "Adamasferoide",
            "KOR": "큰금강옥",
            "CHS": "大金刚宝玉",
            "CHT": "大金剛寶玉"
        }
    ],
    "Lustrous Globe": [
        {
            "NO": 1709,
            "EN": "Lustrous Globe",
            "JP": "だいしらたま",
            "FR": "Globe Perlé",
            "DE": "Weißkristall",
            "ES": "Gran Lustresfera",
            "IT": "Splendisferoide",
            "KOR": "큰백옥",
            "CHS": "大白宝玉",
            "CHT": "大白寶玉"
        }
    ],
    "Griseous Core": [
        {
            "NO": 1710,
            "EN": "Griseous Core",
            "JP": "だいはっきんだま",
            "FR": "Globe Platiné",
            "DE": "Platinumkristall",
            "ES": "Gran Griseosfera",
            "IT": "Grigiosferoide",
            "KOR": "큰백금옥",
            "CHS": "大白金宝玉",
            "CHT": "大白金寶玉"
        }
    ],
    "Blank Plate": [
        {
            "NO": 1711,
            "EN": "Blank Plate",
            "JP": "まっさらプレート",
            "FR": "Plaque Renouveau",
            "DE": "Neutraltafel",
            "ES": "Tabla Neutra",
            "IT": "Lastraripristino",
            "KOR": "순백플레이트",
            "CHS": "净空石板",
            "CHT": "淨空石板"
        }
    ],
    "Crafting Kit": [
        {
            "NO": 1712,
            "EN": "Crafting Kit",
            "JP": "クラフトキット",
            "FR": "Boîte à Outils",
            "DE": "Handwerkskiste",
            "ES": "Kit de Artesanía",
            "IT": "Kit faidaté",
            "KOR": "공작키트",
            "CHS": "工艺套组",
            "CHT": "工藝套組"
        }
    ],
    "Strange Ball": [
        {
            "NO": 1715,
            "EN": "Strange Ball",
            "JP": "ストレンジボール",
            "FR": "Étrange Ball",
            "DE": "Rätselball",
            "ES": "Extraña Ball",
            "IT": "Strange Ball",
            "KOR": "스트레인지볼",
            "CHS": "奇异球",
            "CHT": "奇異球"
        }
    ],
    "Pokédex": [
        {
            "NO": 1716,
            "EN": "Pokédex",
            "JP": "ポケモンずかん",
            "FR": "Pokédex",
            "DE": "Pokédex",
            "ES": "Pokédex",
            "IT": "Pokédex",
            "KOR": "포켓몬 도감",
            "CHS": "宝可梦图鉴",
            "CHT": "寶可夢圖鑑"
        }
    ],
    "Old Verse 1": [
        {
            "NO": 1717,
            "EN": "Old Verse 1",
            "JP": "ふるいポエム１",
            "FR": "Vieux Poème (1)",
            "DE": "Altes Gedicht 1",
            "ES": "Poema Antiguo 1",
            "IT": "Antica poesia 1",
            "KOR": "오래된 시1",
            "CHS": "古老诗文１",
            "CHT": "古老詩文１"
        }
    ],
    "Old Verse 2": [
        {
            "NO": 1718,
            "EN": "Old Verse 2",
            "JP": "ふるいポエム２",
            "FR": "Vieux Poème (2)",
            "DE": "Altes Gedicht 2",
            "ES": "Poema Antiguo 2",
            "IT": "Antica poesia 2",
            "KOR": "오래된 시2",
            "CHS": "古老诗文２",
            "CHT": "古老詩文２"
        }
    ],
    "Old Verse 3": [
        {
            "NO": 1719,
            "EN": "Old Verse 3",
            "JP": "ふるいポエム３",
            "FR": "Vieux Poème (3)",
            "DE": "Altes Gedicht 3",
            "ES": "Poema Antiguo 3",
            "IT": "Antica poesia 3",
            "KOR": "오래된 시3",
            "CHS": "古老诗文３",
            "CHT": "古老詩文３"
        }
    ],
    "Old Verse 4": [
        {
            "NO": 1720,
            "EN": "Old Verse 4",
            "JP": "ふるいポエム４",
            "FR": "Vieux Poème (4)",
            "DE": "Altes Gedicht 4",
            "ES": "Poema Antiguo 4",
            "IT": "Antica poesia 4",
            "KOR": "오래된 시4",
            "CHS": "古老诗文４",
            "CHT": "古老詩文４"
        }
    ],
    "Old Verse 5": [
        {
            "NO": 1721,
            "EN": "Old Verse 5",
            "JP": "ふるいポエム５",
            "FR": "Vieux Poème (5)",
            "DE": "Altes Gedicht 5",
            "ES": "Poema Antiguo 5",
            "IT": "Antica poesia 5",
            "KOR": "오래된 시5",
            "CHS": "古老诗文５",
            "CHT": "古老詩文５"
        }
    ],
    "Old Verse 6": [
        {
            "NO": 1722,
            "EN": "Old Verse 6",
            "JP": "ふるいポエム６",
            "FR": "Vieux Poème (6)",
            "DE": "Altes Gedicht 6",
            "ES": "Poema Antiguo 6",
            "IT": "Antica poesia 6",
            "KOR": "오래된 시6",
            "CHS": "古老诗文６",
            "CHT": "古老詩文６"
        }
    ],
    "Old Verse 7": [
        {
            "NO": 1723,
            "EN": "Old Verse 7",
            "JP": "ふるいポエム７",
            "FR": "Vieux Poème (7)",
            "DE": "Altes Gedicht 7",
            "ES": "Poema Antiguo 7",
            "IT": "Antica poesia 7",
            "KOR": "오래된 시7",
            "CHS": "古老诗文７",
            "CHT": "古老詩文７"
        }
    ],
    "Old Verse 8": [
        {
            "NO": 1724,
            "EN": "Old Verse 8",
            "JP": "ふるいポエム８",
            "FR": "Vieux Poème (8)",
            "DE": "Altes Gedicht 8",
            "ES": "Poema Antiguo 8",
            "IT": "Antica poesia 8",
            "KOR": "오래된 시8",
            "CHS": "古老诗文８",
            "CHT": "古老詩文８"
        }
    ],
    "Old Verse 9": [
        {
            "NO": 1725,
            "EN": "Old Verse 9",
            "JP": "ふるいポエム９",
            "FR": "Vieux Poème (9)",
            "DE": "Altes Gedicht 9",
            "ES": "Poema Antiguo 9",
            "IT": "Antica poesia 9",
            "KOR": "오래된 시9",
            "CHS": "古老诗文９",
            "CHT": "古老詩文９"
        }
    ],
    "Old Verse 10": [
        {
            "NO": 1726,
            "EN": "Old Verse 10",
            "JP": "ふるいポエム１０",
            "FR": "Vieux Poème (10)",
            "DE": "Altes Gedicht 10",
            "ES": "Poema Antiguo 10",
            "IT": "Antica poesia 10",
            "KOR": "오래된 시10",
            "CHS": "古老诗文１０",
            "CHT": "古老詩文１０"
        }
    ],
    "Old Verse 11": [
        {
            "NO": 1727,
            "EN": "Old Verse 11",
            "JP": "ふるいポエム１１",
            "FR": "Vieux Poème (11)",
            "DE": "Altes Gedicht 11",
            "ES": "Poema Antiguo 11",
            "IT": "Antica poesia 11",
            "KOR": "오래된 시11",
            "CHS": "古老诗文１１",
            "CHT": "古老詩文１１"
        }
    ],
    "Old Verse 12": [
        {
            "NO": 1728,
            "EN": "Old Verse 12",
            "JP": "ふるいポエム１２",
            "FR": "Vieux Poème (12)",
            "DE": "Altes Gedicht 12",
            "ES": "Poema Antiguo 12",
            "IT": "Antica poesia 12",
            "KOR": "오래된 시12",
            "CHS": "古老诗文１２",
            "CHT": "古老詩文１２"
        }
    ],
    "Old Verse 13": [
        {
            "NO": 1729,
            "EN": "Old Verse 13",
            "JP": "ふるいポエム１３",
            "FR": "Vieux Poème (13)",
            "DE": "Altes Gedicht 13",
            "ES": "Poema Antiguo 13",
            "IT": "Antica poesia 13",
            "KOR": "오래된 시13",
            "CHS": "古老诗文１３",
            "CHT": "古老詩文１３"
        }
    ],
    "Old Verse 14": [
        {
            "NO": 1730,
            "EN": "Old Verse 14",
            "JP": "ふるいポエム１４",
            "FR": "Vieux Poème (14)",
            "DE": "Altes Gedicht 14",
            "ES": "Poema Antiguo 14",
            "IT": "Antica poesia 14",
            "KOR": "오래된 시14",
            "CHS": "古老诗文１４",
            "CHT": "古老詩文１４"
        }
    ],
    "Old Verse 15": [
        {
            "NO": 1731,
            "EN": "Old Verse 15",
            "JP": "ふるいポエム１５",
            "FR": "Vieux Poème (15)",
            "DE": "Altes Gedicht 15",
            "ES": "Poema Antiguo 15",
            "IT": "Antica poesia 15",
            "KOR": "오래된 시15",
            "CHS": "古老诗文１５",
            "CHT": "古老詩文１５"
        }
    ],
    "Old Verse 16": [
        {
            "NO": 1732,
            "EN": "Old Verse 16",
            "JP": "ふるいポエム１６",
            "FR": "Vieux Poème (16)",
            "DE": "Altes Gedicht 16",
            "ES": "Poema Antiguo 16",
            "IT": "Antica poesia 16",
            "KOR": "오래된 시16",
            "CHS": "古老诗文１６",
            "CHT": "古老詩文１６"
        }
    ],
    "Old Verse 17": [
        {
            "NO": 1733,
            "EN": "Old Verse 17",
            "JP": "ふるいポエム１７",
            "FR": "Vieux Poème (17)",
            "DE": "Altes Gedicht 17",
            "ES": "Poema Antiguo 17",
            "IT": "Antica poesia 17",
            "KOR": "오래된 시17",
            "CHS": "古老诗文１７",
            "CHT": "古老詩文１７"
        }
    ],
    "Old Verse 18": [
        {
            "NO": 1734,
            "EN": "Old Verse 18",
            "JP": "ふるいポエム１８",
            "FR": "Vieux Poème (18)",
            "DE": "Altes Gedicht 18",
            "ES": "Poema Antiguo 18",
            "IT": "Antica poesia 18",
            "KOR": "오래된 시18",
            "CHS": "古老诗文１８",
            "CHT": "古老詩文１８"
        }
    ],
    "Old Verse 19": [
        {
            "NO": 1735,
            "EN": "Old Verse 19",
            "JP": "ふるいポエム１９",
            "FR": "Vieux Poème (19)",
            "DE": "Altes Gedicht 19",
            "ES": "Poema Antiguo 19",
            "IT": "Antica poesia 19",
            "KOR": "오래된 시19",
            "CHS": "古老诗文１９",
            "CHT": "古老詩文１９"
        }
    ],
    "Old Verse 20": [
        {
            "NO": 1736,
            "EN": "Old Verse 20",
            "JP": "ふるいポエム２０",
            "FR": "Vieux Poème (20)",
            "DE": "Altes Gedicht 20",
            "ES": "Poema Antiguo 20",
            "IT": "Antica poesia 20",
            "KOR": "오래된 시20",
            "CHS": "古老诗文２０",
            "CHT": "古老詩文２０"
        }
    ],
    "Mysterious Shard S": [
        {
            "NO": 1737,
            "EN": "Mysterious Shard S",
            "JP": "なぞのかけらＳ",
            "FR": "Éclat Étrange S",
            "DE": "Enigmafragment S",
            "ES": "Esquirla Extraña S",
            "IT": "Frammento insolito S",
            "KOR": "수수께끼의조각S",
            "CHS": "谜之碎片Ｓ",
            "CHT": "謎之碎片Ｓ"
        }
    ],
    "Mysterious Shard L": [
        {
            "NO": 1738,
            "EN": "Mysterious Shard L",
            "JP": "なぞのかけらＬ",
            "FR": "Éclat Étrange L",
            "DE": "Enigmafragment L",
            "ES": "Esquirla Extraña L",
            "IT": "Frammento insolito L",
            "KOR": "수수께끼의조각L",
            "CHS": "谜之碎片Ｌ",
            "CHT": "謎之碎片Ｌ"
        }
    ],
    "Digger Drill": [
        {
            "NO": 1739,
            "EN": "Digger Drill",
            "JP": "あなほりドリル",
            "FR": "Foreuse",
            "DE": "Einwegbohrer",
            "ES": "Taladro",
            "IT": "Trivella",
            "KOR": "구멍파기드릴",
            "CHS": "挖洞钻",
            "CHT": "挖洞鑽"
        }
    ],
    "Kanto Slate": [
        {
            "NO": 1740,
            "EN": "Kanto Slate",
            "JP": "カントーのせきばん",
            "FR": "Tablette Kanto",
            "DE": "Kanto-Platte",
            "ES": "Losa Kanto",
            "IT": "Piastra di Kanto",
            "KOR": "관동의석판",
            "CHS": "关都石板",
            "CHT": "關都石板"
        }
    ],
    "Johto Slate": [
        {
            "NO": 1741,
            "EN": "Johto Slate",
            "JP": "ジョウトのせきばん",
            "FR": "Tablette Johto",
            "DE": "Johto-Platte",
            "ES": "Losa Johto",
            "IT": "Piastra di Johto",
            "KOR": "성도의석판",
            "CHS": "城都石板",
            "CHT": "城都石板"
        }
    ],
    "Soul Slate": [
        {
            "NO": 1742,
            "EN": "Soul Slate",
            "JP": "こころのせきばん",
            "FR": "Tablette Cœur",
            "DE": "Gefühlsplatte",
            "ES": "Losa Empatía",
            "IT": "Piastra del cuore",
            "KOR": "마음의석판",
            "CHS": "心之石板",
            "CHT": "心之石板"
        }
    ],
    "Rainbow Slate": [
        {
            "NO": 1743,
            "EN": "Rainbow Slate",
            "JP": "にじのせきばん",
            "FR": "Tablette Arc-en-ciel",
            "DE": "Regenbogenplatte",
            "ES": "Losa Arcoíris",
            "IT": "Piastra arcobaleno",
            "KOR": "무지개의석판",
            "CHS": "彩虹石板",
            "CHT": "彩虹石板"
        }
    ],
    "Squall Slate": [
        {
            "NO": 1744,
            "EN": "Squall Slate",
            "JP": "あらしのせきばん",
            "FR": "Tablette Tempête",
            "DE": "Sturmplatte",
            "ES": "Losa Tormenta",
            "IT": "Piastra dei venti",
            "KOR": "폭풍의석판",
            "CHS": "暴风石板",
            "CHT": "暴風石板"
        }
    ],
    "Oceanic Slate": [
        {
            "NO": 1745,
            "EN": "Oceanic Slate",
            "JP": "たいかいのせきばん",
            "FR": "Tablette Océans",
            "DE": "Meeresplatte",
            "ES": "Losa Mar",
            "IT": "Piastra dei mari",
            "KOR": "대해의석판",
            "CHS": "大海石板",
            "CHT": "大海石板"
        }
    ],
    "Tectonic Slate": [
        {
            "NO": 1746,
            "EN": "Tectonic Slate",
            "JP": "たいりくのせきばん",
            "FR": "Tablette Continents",
            "DE": "Kontinentplatte",
            "ES": "Losa Tierra",
            "IT": "Piastra delle terre",
            "KOR": "대륙의석판",
            "CHS": "大陆石板",
            "CHT": "大陸石板"
        }
    ],
    "Stratospheric Slate": [
        {
            "NO": 1747,
            "EN": "Stratospheric Slate",
            "JP": "てんくうのせきばん",
            "FR": "Tablette Cieux",
            "DE": "Himmelsplatte",
            "ES": "Losa Cielo",
            "IT": "Piastra dei cieli",
            "KOR": "천공의석판",
            "CHS": "天空石板",
            "CHT": "天空石板"
        }
    ],
    "Genome Slate": [
        {
            "NO": 1748,
            "EN": "Genome Slate",
            "JP": "いでんしのせきばん",
            "FR": "Tablette Génétique",
            "DE": "Genplatte",
            "ES": "Losa Genética",
            "IT": "Piastra del gene",
            "KOR": "유전자의석판",
            "CHS": "基因石板",
            "CHT": "基因石板"
        }
    ],
    "Discovery Slate": [
        {
            "NO": 1749,
            "EN": "Discovery Slate",
            "JP": "みちびきのせきばん",
            "FR": "Tablette Guides",
            "DE": "Weisungsplatte",
            "ES": "Losa Inicio",
            "IT": "Piastra degli esordi",
            "KOR": "인도의석판",
            "CHS": "引导石板",
            "CHT": "引導石板"
        }
    ],
    "Distortion Slate": [
        {
            "NO": 1750,
            "EN": "Distortion Slate",
            "JP": "やぶれたせきばん",
            "FR": "Tablette Distorsion",
            "DE": "Zerrplatte",
            "ES": "Losa Distorsión",
            "IT": "Piastra distorta",
            "KOR": "깨어진석판",
            "CHS": "毁坏石板",
            "CHT": "毀壞石板"
        }
    ],
    "DS Sounds": [
        {
            "NO": 1751,
            "EN": "DS Sounds",
            "JP": "ＤＳプレイヤー",
            "FR": "Lecteur DS",
            "DE": "DS-Player",
            "ES": "Reproductor DS",
            "IT": "Lettore DS",
            "KOR": "DS플레이어",
            "CHS": "ＤＳ播放器",
            "CHT": "ＤＳ播放器"
        }
    ],
    "Legend Plate": [
        {
            "NO": 1752,
            "EN": "Legend Plate",
            "JP": "レジェンドプレート",
            "FR": "Plaque Légende",
            "DE": "Legendentafel",
            "ES": "Tabla Legendaria",
            "IT": "Lastraleggenda",
            "KOR": "레전드플레이트",
            "CHS": "传说石板",
            "CHT": "傳說石板"
        }
    ],
    "Rotom Phone": [
        {
            "NO": 1753,
            "EN": "Rotom Phone",
            "JP": "スマホロトム",
            "FR": "Motismart",
            "DE": "Smart-Rotom",
            "ES": "SmartRotom",
            "IT": "Smart Rotom",
            "KOR": "스마트로토무",
            "CHS": "手机洛托姆",
            "CHT": "手機洛托姆"
        }
    ],
    "Sandwich": [
        {
            "NO": 1754,
            "EN": "Sandwich",
            "JP": "サンドウィッチ",
            "FR": "Sandwich",
            "DE": "Sandwich",
            "ES": "Bocadillo",
            "IT": "Panino",
            "KOR": "샌드위치",
            "CHS": "三明治",
            "CHT": "三明治"
        }
    ],
    "Koraidon’s Poké Ball": [
        {
            "NO": 1755,
            "EN": "Koraidon’s Poké Ball",
            "JP": "コライドンのボール",
            "FR": "Poké Ball de Koraidon",
            "DE": "Koraidons Pokéball",
            "ES": "Poké Ball de Koraidon",
            "IT": "Poké Ball Koraidon",
            "KOR": "코라이돈의 볼",
            "CHS": "故勒顿的球",
            "CHT": "故勒頓的球"
        }
    ],
    "Miraidon’s Poké Ball": [
        {
            "NO": 1756,
            "EN": "Miraidon’s Poké Ball",
            "JP": "ミライドンのボール",
            "FR": "Poké Ball de Miraidon",
            "DE": "Miraidons Pokéball",
            "ES": "Poké Ball de Miraidon",
            "IT": "Poké Ball Miraidon",
            "KOR": "미라이돈의 볼",
            "CHS": "密勒顿的球",
            "CHT": "密勒頓的球"
        }
    ],
    "Tera Orb": [
        {
            "NO": 1757,
            "EN": "Tera Orb",
            "JP": "テラスタルオーブ",
            "FR": "Orbe Téracristal",
            "DE": "Terakristall-Orb",
            "ES": "Orbe Teracristal",
            "IT": "Terasfera",
            "KOR": "테라스탈오브",
            "CHS": "太晶珠",
            "CHT": "太晶珠"
        }
    ],
    "Scarlet Book": [
        {
            "NO": 1758,
            "EN": "Scarlet Book",
            "JP": "スカーレットブック",
            "FR": "Livre Écarlate",
            "DE": "Karmesinbuch",
            "ES": "Libro Escarlata",
            "IT": "Libro scarlatto",
            "KOR": "스칼렛북",
            "CHS": "朱之书",
            "CHT": "朱之書"
        }
    ],
    "Violet Book": [
        {
            "NO": 1759,
            "EN": "Violet Book",
            "JP": "バイオレットブック",
            "FR": "Livre Violet",
            "DE": "Purpurbuch",
            "ES": "Libro Púrpura",
            "IT": "Libro violetto",
            "KOR": "바이올렛북",
            "CHS": "紫之书",
            "CHT": "紫之書"
        }
    ],
    "Kofu’s Wallet": [
        {
            "NO": 1760,
            "EN": "Kofu’s Wallet",
            "JP": "ハイダイのサイフ",
            "FR": "Portefeuille de Kombu",
            "DE": "Kombus Geldbörse",
            "ES": "Cartera de Fuco",
            "IT": "Portafogli di Algaro",
            "KOR": "곤포의 지갑",
            "CHS": "海岱的钱包",
            "CHT": "海岱的錢包"
        }
    ],
    "Tiny Bamboo Shoot": [
        {
            "NO": 1761,
            "EN": "Tiny Bamboo Shoot",
            "JP": "ちいさなタケノコ",
            "FR": "Petit Bambou",
            "DE": "Minibambusspross",
            "ES": "Bambú Pequeño",
            "IT": "Minibambù",
            "KOR": "작은죽순",
            "CHS": "小竹笋",
            "CHT": "小竹筍"
        }
    ],
    "Big Bamboo Shoot": [
        {
            "NO": 1762,
            "EN": "Big Bamboo Shoot",
            "JP": "おおきなタケノコ",
            "FR": "Gros Bambou",
            "DE": "Riesenbambusspross",
            "ES": "Bambú Grande",
            "IT": "Grande bambù",
            "KOR": "큰죽순",
            "CHS": "大竹笋",
            "CHT": "大竹筍"
        }
    ],
    "Scroll of Darkness": [
        {
            "NO": 1763,
            "EN": "Scroll of Darkness",
            "JP": "あくのかけじく",
            "FR": "Rouleau des Ténèbres",
            "DE": "Unlicht-Schriftrolle",
            "ES": "Manuscrito Sombras",
            "IT": "Rotolo del Buio",
            "KOR": "악의 족자",
            "CHS": "恶之挂轴",
            "CHT": "惡之掛軸"
        }
    ],
    "Scroll of Waters": [
        {
            "NO": 1764,
            "EN": "Scroll of Waters",
            "JP": "みずのかけじく",
            "FR": "Rouleau de l’Eau",
            "DE": "Wasser-Schriftrolle",
            "ES": "Manuscrito Aguas",
            "IT": "Rotolo dell’Acqua",
            "KOR": "물의 족자",
            "CHS": "水之挂轴",
            "CHT": "水之掛軸"
        }
    ],
    "Malicious Armor": [
        {
            "NO": 1765,
            "EN": "Malicious Armor",
            "JP": "ノロイノヨロイ",
            "FR": "Armure de la Rancune",
            "DE": "Fluchrüstung",
            "ES": "Armadura Maldita",
            "IT": "Armatura infausta",
            "KOR": "저주받은갑옷",
            "CHS": "咒术之铠",
            "CHT": "詛咒之鎧"
        }
    ],
    "Normal Tera Shard": [
        {
            "NO": 1766,
            "EN": "Normal Tera Shard",
            "JP": "テラピースノーマル",
            "FR": "Téra-Éclat Normal",
            "DE": "Tera-Stück (Normal)",
            "ES": "Teralito Normal",
            "IT": "Teralite Normale",
            "KOR": "테라피스 노말",
            "CHS": "一般太晶碎块",
            "CHT": "一般太晶碎塊"
        }
    ],
    "Fire Tera Shard": [
        {
            "NO": 1767,
            "EN": "Fire Tera Shard",
            "JP": "テラピースほのお",
            "FR": "Téra-Éclat Feu",
            "DE": "Tera-Stück (Feuer)",
            "ES": "Teralito Fuego",
            "IT": "Teralite Fuoco",
            "KOR": "테라피스 불꽃",
            "CHS": "火太晶碎块",
            "CHT": "火太晶碎塊"
        }
    ],
    "Water Tera Shard": [
        {
            "NO": 1768,
            "EN": "Water Tera Shard",
            "JP": "テラピースみず",
            "FR": "Téra-Éclat Eau",
            "DE": "Tera-Stück (Wasser)",
            "ES": "Teralito Agua",
            "IT": "Teralite Acqua",
            "KOR": "테라피스 물",
            "CHS": "水太晶碎块",
            "CHT": "水太晶碎塊"
        }
    ],
    "Electric Tera Shard": [
        {
            "NO": 1769,
            "EN": "Electric Tera Shard",
            "JP": "テラピースでんき",
            "FR": "Téra-Éclat Électrik",
            "DE": "Tera-Stück (Elektro)",
            "ES": "Teralito Eléctrico",
            "IT": "Teralite Elettro",
            "KOR": "테라피스 전기",
            "CHS": "电太晶碎块",
            "CHT": "電太晶碎塊"
        }
    ],
    "Grass Tera Shard": [
        {
            "NO": 1770,
            "EN": "Grass Tera Shard",
            "JP": "テラピースくさ",
            "FR": "Téra-Éclat Plante",
            "DE": "Tera-Stück (Pflanze)",
            "ES": "Teralito Planta",
            "IT": "Teralite Erba",
            "KOR": "테라피스 풀",
            "CHS": "草太晶碎块",
            "CHT": "草太晶碎塊"
        }
    ],
    "Ice Tera Shard": [
        {
            "NO": 1771,
            "EN": "Ice Tera Shard",
            "JP": "テラピースこおり",
            "FR": "Téra-Éclat Glace",
            "DE": "Tera-Stück (Eis)",
            "ES": "Teralito Hielo",
            "IT": "Teralite Ghiaccio",
            "KOR": "테라피스 얼음",
            "CHS": "冰太晶碎块",
            "CHT": "冰太晶碎塊"
        }
    ],
    "Fighting Tera Shard": [
        {
            "NO": 1772,
            "EN": "Fighting Tera Shard",
            "JP": "テラピースかくとう",
            "FR": "Téra-Éclat Combat",
            "DE": "Tera-Stück (Kampf)",
            "ES": "Teralito Lucha",
            "IT": "Teralite Lotta",
            "KOR": "테라피스 격투",
            "CHS": "格斗太晶碎块",
            "CHT": "格鬥太晶碎塊"
        }
    ],
    "Poison Tera Shard": [
        {
            "NO": 1773,
            "EN": "Poison Tera Shard",
            "JP": "テラピースどく",
            "FR": "Téra-Éclat Poison",
            "DE": "Tera-Stück (Gift)",
            "ES": "Teralito Veneno",
            "IT": "Teralite Veleno",
            "KOR": "테라피스 독",
            "CHS": "毒太晶碎块",
            "CHT": "毒太晶碎塊"
        }
    ],
    "Ground Tera Shard": [
        {
            "NO": 1774,
            "EN": "Ground Tera Shard",
            "JP": "テラピースじめん",
            "FR": "Téra-Éclat Sol",
            "DE": "Tera-Stück (Boden)",
            "ES": "Teralito Tierra",
            "IT": "Teralite Terra",
            "KOR": "테라피스 땅",
            "CHS": "地面太晶碎块",
            "CHT": "地面太晶碎塊"
        }
    ],
    "Flying Tera Shard": [
        {
            "NO": 1775,
            "EN": "Flying Tera Shard",
            "JP": "テラピースひこう",
            "FR": "Téra-Éclat Vol",
            "DE": "Tera-Stück (Flug)",
            "ES": "Teralito Volador",
            "IT": "Teralite Volante",
            "KOR": "테라피스 비행",
            "CHS": "飞行太晶碎块",
            "CHT": "飛行太晶碎塊"
        }
    ],
    "Psychic Tera Shard": [
        {
            "NO": 1776,
            "EN": "Psychic Tera Shard",
            "JP": "テラピースエスパー",
            "FR": "Téra-Éclat Psy",
            "DE": "Tera-Stück (Psycho)",
            "ES": "Teralito Psíquico",
            "IT": "Teralite Psico",
            "KOR": "테라피스 에스퍼",
            "CHS": "超能力太晶碎块",
            "CHT": "超能力太晶碎塊"
        }
    ],
    "Bug Tera Shard": [
        {
            "NO": 1777,
            "EN": "Bug Tera Shard",
            "JP": "テラピースむし",
            "FR": "Téra-Éclat Insecte",
            "DE": "Tera-Stück (Käfer)",
            "ES": "Teralito Bicho",
            "IT": "Teralite Coleottero",
            "KOR": "테라피스 벌레",
            "CHS": "虫太晶碎块",
            "CHT": "蟲太晶碎塊"
        }
    ],
    "Rock Tera Shard": [
        {
            "NO": 1778,
            "EN": "Rock Tera Shard",
            "JP": "テラピースいわ",
            "FR": "Téra-Éclat Roche",
            "DE": "Tera-Stück (Gestein)",
            "ES": "Teralito Roca",
            "IT": "Teralite Roccia",
            "KOR": "테라피스 바위",
            "CHS": "岩石太晶碎块",
            "CHT": "岩石太晶碎塊"
        }
    ],
    "Ghost Tera Shard": [
        {
            "NO": 1779,
            "EN": "Ghost Tera Shard",
            "JP": "テラピースゴースト",
            "FR": "Téra-Éclat Spectre",
            "DE": "Tera-Stück (Geist)",
            "ES": "Teralito Fantasma",
            "IT": "Teralite Spettro",
            "KOR": "테라피스 고스트",
            "CHS": "幽灵太晶碎块",
            "CHT": "幽靈太晶碎塊"
        }
    ],
    "Dragon Tera Shard": [
        {
            "NO": 1780,
            "EN": "Dragon Tera Shard",
            "JP": "テラピースドラゴン",
            "FR": "Téra-Éclat Dragon",
            "DE": "Tera-Stück (Drache)",
            "ES": "Teralito Dragón",
            "IT": "Teralite Drago",
            "KOR": "테라피스 드래곤",
            "CHS": "龙太晶碎块",
            "CHT": "龍太晶碎塊"
        }
    ],
    "Dark Tera Shard": [
        {
            "NO": 1781,
            "EN": "Dark Tera Shard",
            "JP": "テラピースあく",
            "FR": "Téra-Éclat Ténèbres",
            "DE": "Tera-Stück (Unlicht)",
            "ES": "Teralito Siniestro",
            "IT": "Teralite Buio",
            "KOR": "테라피스 악",
            "CHS": "恶太晶碎块",
            "CHT": "惡太晶碎塊"
        }
    ],
    "Steel Tera Shard": [
        {
            "NO": 1782,
            "EN": "Steel Tera Shard",
            "JP": "テラピースはがね",
            "FR": "Téra-Éclat Acier",
            "DE": "Tera-Stück (Stahl)",
            "ES": "Teralito Acero",
            "IT": "Teralite Acciaio",
            "KOR": "테라피스 강철",
            "CHS": "钢太晶碎块",
            "CHT": "鋼太晶碎塊"
        }
    ],
    "Fairy Tera Shard": [
        {
            "NO": 1783,
            "EN": "Fairy Tera Shard",
            "JP": "テラピースフェアリー",
            "FR": "Téra-Éclat Fée",
            "DE": "Tera-Stück (Fee)",
            "ES": "Teralito Hada",
            "IT": "Teralite Folletto",
            "KOR": "테라피스 페어리",
            "CHS": "妖精太晶碎块",
            "CHT": "妖精太晶碎塊"
        }
    ],
    "Booster Energy": [
        {
            "NO": 1784,
            "EN": "Booster Energy",
            "JP": "ブーストエナジー",
            "FR": "Énergie Booster",
            "DE": "Energiekapsel",
            "ES": "Energía Potenciadora",
            "IT": "Capsula energetica",
            "KOR": "부스트에너지",
            "CHS": "驱劲能量",
            "CHT": "驅勁能量"
        }
    ],
    "Ability Shield": [
        {
            "NO": 1785,
            "EN": "Ability Shield",
            "JP": "とくせいガード",
            "FR": "Garde-Talent",
            "DE": "Fähigkeitenschild",
            "ES": "Escudo Habilidad",
            "IT": "Scudo abilità",
            "KOR": "특성가드",
            "CHS": "特性护具",
            "CHT": "特性護具"
        }
    ],
    "Clear Amulet": [
        {
            "NO": 1786,
            "EN": "Clear Amulet",
            "JP": "クリアチャーム",
            "FR": "Talisman Sain",
            "DE": "Neutralschmuck",
            "ES": "Amuleto Puro",
            "IT": "Ciondolochiaro",
            "KOR": "클리어참",
            "CHS": "清净坠饰",
            "CHT": "清淨墜飾"
        }
    ],
    "Mirror Herb": [
        {
            "NO": 1787,
            "EN": "Mirror Herb",
            "JP": "ものまねハーブ",
            "FR": "Feuille Copieuse",
            "DE": "Kopierkraut",
            "ES": "Hierba Copia",
            "IT": "Foglia carbone",
            "KOR": "흉내허브",
            "CHS": "模仿香草",
            "CHT": "模仿香草"
        }
    ],
    "Punching Glove": [
        {
            "NO": 1788,
            "EN": "Punching Glove",
            "JP": "パンチグローブ",
            "FR": "Gant de Boxe",
            "DE": "Boxhandschuh",
            "ES": "Guante de Boxeo",
            "IT": "Guantone",
            "KOR": "펀치글러브",
            "CHS": "拳击手套",
            "CHT": "拳擊手套"
        }
    ],
    "Covert Cloak": [
        {
            "NO": 1789,
            "EN": "Covert Cloak",
            "JP": "おんみつマント",
            "FR": "Cape Obscure",
            "DE": "Tarnumhang",
            "ES": "Capa Furtiva",
            "IT": "Anonimanto",
            "KOR": "은밀망토",
            "CHS": "密探斗篷",
            "CHT": "密探斗篷"
        }
    ],
    "Loaded Dice": [
        {
            "NO": 1790,
            "EN": "Loaded Dice",
            "JP": "いかさまダイス",
            "FR": "Dé Pipé",
            "DE": "Gezinkter Würfel",
            "ES": "Dado Trucado",
            "IT": "Dado truccato",
            "KOR": "속임수주사위",
            "CHS": "机变骰子",
            "CHT": "老千骰子"
        }
    ],
    "Baguette": [
        {
            "NO": 1791,
            "EN": "Baguette",
            "JP": "バゲット",
            "FR": "Baguette",
            "DE": "Baguette",
            "ES": "Barra de Pan",
            "IT": "Filoncino",
            "KOR": "바게트",
            "CHS": "长棍面包",
            "CHT": "長棍麵包"
        }
    ],
    "Mayonnaise": [
        {
            "NO": 1792,
            "EN": "Mayonnaise",
            "JP": "マヨネーズ",
            "FR": "Mayonnaise",
            "DE": "Mayonnaise",
            "ES": "Mayonesa",
            "IT": "Maionese",
            "KOR": "마요네즈",
            "CHS": "蛋黄酱",
            "CHT": "美乃滋"
        }
    ],
    "Ketchup": [
        {
            "NO": 1793,
            "EN": "Ketchup",
            "JP": "ケチャップ",
            "FR": "Ketchup",
            "DE": "Ketchup",
            "ES": "Kétchup",
            "IT": "Ketchup",
            "KOR": "케첩",
            "CHS": "番茄酱",
            "CHT": "番茄醬"
        }
    ],
    "Mustard": [
        {
            "NO": 1794,
            "EN": "Mustard",
            "JP": "マスタード",
            "FR": "Moutarde",
            "DE": "Senf",
            "ES": "Mostaza",
            "IT": "Senape",
            "KOR": "머스터드",
            "CHS": "黄芥末酱",
            "CHT": "黃芥末醬"
        }
    ],
    "Butter": [
        {
            "NO": 1795,
            "EN": "Butter",
            "JP": "バター",
            "FR": "Beurre",
            "DE": "Butter",
            "ES": "Mantequilla",
            "IT": "Burro",
            "KOR": "버터",
            "CHS": "黄油",
            "CHT": "奶油"
        }
    ],
    "Peanut Butter": [
        {
            "NO": 1796,
            "EN": "Peanut Butter",
            "JP": "ピーナッツバター",
            "FR": "Beurre de Cacahuètes",
            "DE": "Erdnussbutter",
            "ES": "Crema de Cacahuete",
            "IT": "Burro di arachidi",
            "KOR": "땅콩버터",
            "CHS": "花生酱",
            "CHT": "花生醬"
        }
    ],
    "Chili Sauce": [
        {
            "NO": 1797,
            "EN": "Chili Sauce",
            "JP": "チリソース",
            "FR": "Sauce Piquante",
            "DE": "Chilisoße",
            "ES": "Salsa Picante",
            "IT": "Salsa piccante",
            "KOR": "칠리소스",
            "CHS": "辣酱",
            "CHT": "辣醬"
        }
    ],
    "Salt": [
        {
            "NO": 1798,
            "EN": "Salt",
            "JP": "ソルト",
            "FR": "Sel",
            "DE": "Salz",
            "ES": "Sal",
            "IT": "Sale",
            "KOR": "소금",
            "CHS": "盐",
            "CHT": "鹽"
        }
    ],
    "Pepper": [
        {
            "NO": 1799,
            "EN": "Pepper",
            "JP": "ペッパー",
            "FR": "Poivre",
            "DE": "Pfeffer",
            "ES": "Pimienta",
            "IT": "Pepe",
            "KOR": "후추",
            "CHS": "胡椒",
            "CHT": "胡椒"
        }
    ],
    "Yogurt": [
        {
            "NO": 1800,
            "EN": "Yogurt",
            "JP": "ヨーグルト",
            "FR": "Yaourt",
            "DE": "Joghurt",
            "ES": "Yogur",
            "IT": "Yogurt",
            "KOR": "요구르트",
            "CHS": "酸奶",
            "CHT": "優格"
        }
    ],
    "Whipped Cream": [
        {
            "NO": 1801,
            "EN": "Whipped Cream",
            "JP": "ホイップクリーム",
            "FR": "Crème Fouettée",
            "DE": "Schlagsahne",
            "ES": "Nata Montada",
            "IT": "Panna montata",
            "KOR": "휘핑크림",
            "CHS": "鲜奶油",
            "CHT": "鮮奶油"
        }
    ],
    "Cream Cheese": [
        {
            "NO": 1802,
            "EN": "Cream Cheese",
            "JP": "クリームチーズ",
            "FR": "Fromage Frais",
            "DE": "Frischkäse",
            "ES": "Queso Crema",
            "IT": "Formaggio cremoso",
            "KOR": "크림치즈",
            "CHS": "奶油芝士",
            "CHT": "奶油起司"
        }
    ],
    "Jam": [
        {
            "NO": 1803,
            "EN": "Jam",
            "JP": "ベリージャム",
            "FR": "Confiture de Baies",
            "DE": "Beerenkonfitüre",
            "ES": "Confitura de Bayas",
            "IT": "Confettura di bosco",
            "KOR": "베리잼",
            "CHS": "莓果酱",
            "CHT": "莓果醬"
        }
    ],
    "Marmalade": [
        {
            "NO": 1804,
            "EN": "Marmalade",
            "JP": "マーマレード",
            "FR": "Marmelade",
            "DE": "Marmelade",
            "ES": "Mermelada",
            "IT": "Marmellata",
            "KOR": "마멀레이드",
            "CHS": "橘子酱",
            "CHT": "橘子醬"
        }
    ],
    "Olive Oil": [
        {
            "NO": 1805,
            "EN": "Olive Oil",
            "JP": "オリーブオイル",
            "FR": "Huile d’Olive",
            "DE": "Olivenöl",
            "ES": "Aceite de Oliva",
            "IT": "Olio d’oliva",
            "KOR": "올리브오일",
            "CHS": "橄榄油",
            "CHT": "橄欖油"
        }
    ],
    "Vinegar": [
        {
            "NO": 1806,
            "EN": "Vinegar",
            "JP": "ビネガー",
            "FR": "Vinaigre",
            "DE": "Essig",
            "ES": "Vinagre",
            "IT": "Aceto",
            "KOR": "비니거",
            "CHS": "醋",
            "CHT": "醋"
        }
    ],
    "Sweet Herba Mystica": [
        {
            "NO": 1807,
            "EN": "Sweet Herba Mystica",
            "JP": "ひでん：あまスパイス",
            "FR": "Épice Secrète Sucrée",
            "DE": "Süßes Geheimgewürz",
            "ES": "Especia Oculta Dulce",
            "IT": "Spezia nascosta dolce",
            "KOR": "비전 달콤스파이스",
            "CHS": "秘传：甜味料",
            "CHT": "秘傳：甜味料"
        }
    ],
    "Salty Herba Mystica": [
        {
            "NO": 1808,
            "EN": "Salty Herba Mystica",
            "JP": "ひでん：しおスパイス",
            "FR": "Épice Secrète Salée",
            "DE": "Salziges Geheimgewürz",
            "ES": "Especia Oculta Salada",
            "IT": "Spezia nascosta salata",
            "KOR": "비전 짭짤스파이스",
            "CHS": "秘传：咸味料",
            "CHT": "秘傳：鹹味料"
        }
    ],
    "Sour Herba Mystica": [
        {
            "NO": 1809,
            "EN": "Sour Herba Mystica",
            "JP": "ひでん：すぱスパイス",
            "FR": "Épice Secrète Acide",
            "DE": "Saures Geheimgewürz",
            "ES": "Especia Oculta Ácida",
            "IT": "Spezia nascosta aspra",
            "KOR": "비전 새콤스파이스",
            "CHS": "秘传：酸味料",
            "CHT": "秘傳：酸味料"
        }
    ],
    "Bitter Herba Mystica": [
        {
            "NO": 1810,
            "EN": "Bitter Herba Mystica",
            "JP": "ひでん：にがスパイス",
            "FR": "Épice Secrète Amère",
            "DE": "Bitteres Geheimgewürz",
            "ES": "Especia Oculta Amarga",
            "IT": "Spezia nascosta amara",
            "KOR": "비전 쌉쌀스파이스",
            "CHS": "秘传：苦味料",
            "CHT": "秘傳：苦味料"
        }
    ],
    "Spicy Herba Mystica": [
        {
            "NO": 1811,
            "EN": "Spicy Herba Mystica",
            "JP": "ひでん：からスパイス",
            "FR": "Épice Secrète Corsée",
            "DE": "Scharfes Geheimgewürz",
            "ES": "Especia Oculta Picante",
            "IT": "Spezia nascosta pepata",
            "KOR": "비전 매콤스파이스",
            "CHS": "秘传：辣味料",
            "CHT": "秘傳：辣味料"
        }
    ],
    "Lettuce": [
        {
            "NO": 1812,
            "EN": "Lettuce",
            "JP": "レタス",
            "FR": "Laitue",
            "DE": "Salat",
            "ES": "Lechuga",
            "IT": "Lattuga",
            "KOR": "양상추",
            "CHS": "生菜",
            "CHT": "生菜"
        }
    ],
    "Tomato": [
        {
            "NO": 1813,
            "EN": "Tomato",
            "JP": "トマトスライス",
            "FR": "Tomate",
            "DE": "Tomate",
            "ES": "Tomate",
            "IT": "Pomodoro",
            "KOR": "토마토슬라이스",
            "CHS": "番茄片",
            "CHT": "番茄片"
        }
    ],
    "Cherry Tomatoes": [
        {
            "NO": 1814,
            "EN": "Cherry Tomatoes",
            "JP": "カットミニトマト",
            "FR": "Tomate Cerise",
            "DE": "Mini-Tomate",
            "ES": "Tomate Cherri",
            "IT": "Pomodorino",
            "KOR": "방울토마토슬라이스",
            "CHS": "小番茄块",
            "CHT": "小番茄塊"
        }
    ],
    "Cucumber": [
        {
            "NO": 1815,
            "EN": "Cucumber",
            "JP": "キュウリスライス",
            "FR": "Concombre",
            "DE": "Gurke",
            "ES": "Pepino",
            "IT": "Cetriolo",
            "KOR": "오이슬라이스",
            "CHS": "小黄瓜片",
            "CHT": "小黃瓜片"
        }
    ],
    "Pickle": [
        {
            "NO": 1816,
            "EN": "Pickle",
            "JP": "ピクルススライス",
            "FR": "Cornichon",
            "DE": "Gewürzgurke",
            "ES": "Pepinillo",
            "IT": "Sottaceto",
            "KOR": "피클슬라이스",
            "CHS": "酸黄瓜片",
            "CHT": "酸黃瓜片"
        }
    ],
    "Onion": [
        {
            "NO": 1817,
            "EN": "Onion",
            "JP": "たまねぎスライス",
            "FR": "Oignon",
            "DE": "Zwiebel",
            "ES": "Cebolla",
            "IT": "Cipolla",
            "KOR": "양파슬라이스",
            "CHS": "洋葱片",
            "CHT": "洋蔥片"
        }
    ],
    "Red Onion": [
        {
            "NO": 1818,
            "EN": "Red Onion",
            "JP": "アーリーレッド",
            "FR": "Oignon Rouge",
            "DE": "Rote Zwiebel",
            "ES": "Cebolla Roja",
            "IT": "Cipolla rossa",
            "KOR": "적양파",
            "CHS": "红洋葱",
            "CHT": "紅洋蔥"
        }
    ],
    "Green Bell Pepper": [
        {
            "NO": 1819,
            "EN": "Green Bell Pepper",
            "JP": "ピーマンスライス",
            "FR": "Poivron Vert",
            "DE": "Grüne Paprika",
            "ES": "Pimiento Verde",
            "IT": "Peperone verde",
            "KOR": "피망슬라이스",
            "CHS": "青椒片",
            "CHT": "青椒片"
        }
    ],
    "Red Bell Pepper": [
        {
            "NO": 1820,
            "EN": "Red Bell Pepper",
            "JP": "あかパプリカスライス",
            "FR": "Poivron Rouge",
            "DE": "Rote Paprika",
            "ES": "Pimiento Rojo",
            "IT": "Peperone rosso",
            "KOR": "빨간파프리카슬라이스",
            "CHS": "红椒片",
            "CHT": "紅椒片"
        }
    ],
    "Yellow Bell Pepper": [
        {
            "NO": 1821,
            "EN": "Yellow Bell Pepper",
            "JP": "きパプリカスライス",
            "FR": "Poivron Jaune",
            "DE": "Gelbe Paprika",
            "ES": "Pimiento Amarillo",
            "IT": "Peperone giallo",
            "KOR": "노란파프리카슬라이스",
            "CHS": "黄椒片",
            "CHT": "黃椒片"
        }
    ],
    "Avocado": [
        {
            "NO": 1822,
            "EN": "Avocado",
            "JP": "アボカド",
            "FR": "Avocat",
            "DE": "Avocado",
            "ES": "Aguacate",
            "IT": "Avocado",
            "KOR": "아보카도",
            "CHS": "牛油果",
            "CHT": "酪梨"
        }
    ],
    "Bacon": [
        {
            "NO": 1823,
            "EN": "Bacon",
            "JP": "やきベーコン",
            "FR": "Bacon",
            "DE": "Gebratener Speck",
            "ES": "Panceta",
            "IT": "Pancetta rosolata",
            "KOR": "구운베이컨",
            "CHS": "煎培根",
            "CHT": "煎培根"
        }
    ],
    "Ham": [
        {
            "NO": 1824,
            "EN": "Ham",
            "JP": "ハムスライス",
            "FR": "Jambon Blanc",
            "DE": "Kochschinken",
            "ES": "Jamón Cocido",
            "IT": "Prosciutto cotto",
            "KOR": "슬라이스햄",
            "CHS": "火腿片",
            "CHT": "火腿片"
        }
    ],
    "Prosciutto": [
        {
            "NO": 1825,
            "EN": "Prosciutto",
            "JP": "なまハム",
            "FR": "Jambon Cru",
            "DE": "Roher Schinken",
            "ES": "Jamón Serrano",
            "IT": "Prosciutto crudo",
            "KOR": "생햄",
            "CHS": "生火腿",
            "CHT": "生火腿"
        }
    ],
    "Chorizo": [
        {
            "NO": 1826,
            "EN": "Chorizo",
            "JP": "やきチョリソー",
            "FR": "Chorizo Grillé",
            "DE": "Chorizo",
            "ES": "Chorizo",
            "IT": "Chorizo rosolato",
            "KOR": "구운초리조",
            "CHS": "煎辣香肠",
            "CHT": "煎辣香腸"
        }
    ],
    "Herbed Sausage": [
        {
            "NO": 1827,
            "EN": "Herbed Sausage",
            "JP": "ハーブソーセージ",
            "FR": "Saucisse aux Herbes",
            "DE": "Kräuterwurst",
            "ES": "Butifarra",
            "IT": "Salsiccia alle erbe",
            "KOR": "허브소시지",
            "CHS": "香草香肠",
            "CHT": "香草香腸"
        }
    ],
    "Hamburger": [
        {
            "NO": 1828,
            "EN": "Hamburger",
            "JP": "ハンバーグ",
            "FR": "Steak Haché",
            "DE": "Frikadelle",
            "ES": "Hamburguesa",
            "IT": "Hamburger grigliato",
            "KOR": "햄버그",
            "CHS": "汉堡排",
            "CHT": "漢堡排"
        }
    ],
    "Klawf Stick": [
        {
            "NO": 1829,
            "EN": "Klawf Stick",
            "JP": "ガケガニスティック",
            "FR": "Bâtonnet de Craparoi",
            "DE": "Klibbe-Stick",
            "ES": "Surimi de Klawf",
            "IT": "Surimi di Klawf",
            "KOR": "절벼게맛살",
            "CHS": "毛崖蟹棒",
            "CHT": "毛崖蟹棒"
        }
    ],
    "Smoked Fillet": [
        {
            "NO": 1830,
            "EN": "Smoked Fillet",
            "JP": "スモークきりみ",
            "FR": "Filet Fumé",
            "DE": "Räucherfilet",
            "ES": "Filete Ahumado",
            "IT": "Filetto affumicato",
            "KOR": "훈제토막",
            "CHS": "烟熏鱼片",
            "CHT": "煙燻魚片"
        }
    ],
    "Fried Fillet": [
        {
            "NO": 1831,
            "EN": "Fried Fillet",
            "JP": "きりみフライ",
            "FR": "Filet Frit",
            "DE": "Frittierfilet",
            "ES": "Filete Frito",
            "IT": "Filetto impanato",
            "KOR": "튀긴토막",
            "CHS": "炸鱼片",
            "CHT": "炸魚片"
        }
    ],
    "Egg": [
        {
            "NO": 1832,
            "EN": "Egg",
            "JP": "スライスエッグ",
            "FR": "Œuf",
            "DE": "Ei",
            "ES": "Huevo Cocido",
            "IT": "Uovo bollito",
            "KOR": "에그슬라이스",
            "CHS": "水煮蛋片",
            "CHT": "水煮蛋片"
        }
    ],
    "Potato Tortilla": [
        {
            "NO": 1833,
            "EN": "Potato Tortilla",
            "JP": "トルティージャ",
            "FR": "Tortilla",
            "DE": "Tortilla",
            "ES": "Tortilla",
            "IT": "Tortilla",
            "KOR": "토르티야",
            "CHS": "烘蛋",
            "CHT": "烘蛋"
        }
    ],
    "Tofu": [
        {
            "NO": 1834,
            "EN": "Tofu",
            "JP": "トーフ",
            "FR": "Tofu",
            "DE": "Tofu",
            "ES": "Tofu",
            "IT": "Tofu",
            "KOR": "두부",
            "CHS": "豆腐",
            "CHT": "豆腐"
        }
    ],
    "Rice": [
        {
            "NO": 1835,
            "EN": "Rice",
            "JP": "ライス",
            "FR": "Riz",
            "DE": "Reis",
            "ES": "Arroz",
            "IT": "Riso",
            "KOR": "라이스",
            "CHS": "米饭",
            "CHT": "米飯"
        }
    ],
    "Noodles": [
        {
            "NO": 1836,
            "EN": "Noodles",
            "JP": "ヌードル",
            "FR": "Nouilles",
            "DE": "Nudeln",
            "ES": "Fideos",
            "IT": "Noodle",
            "KOR": "누들",
            "CHS": "面条",
            "CHT": "麵條"
        }
    ],
    "Potato Salad": [
        {
            "NO": 1837,
            "EN": "Potato Salad",
            "JP": "ポテトサラダ",
            "FR": "Salade de Patates",
            "DE": "Kartoffelsalat",
            "ES": "Ensaladilla",
            "IT": "Insalata di patate",
            "KOR": "감자샐러드",
            "CHS": "土豆沙拉",
            "CHT": "馬鈴薯沙拉"
        }
    ],
    "Cheese": [
        {
            "NO": 1838,
            "EN": "Cheese",
            "JP": "スライスチーズ",
            "FR": "Fromage",
            "DE": "Scheibenkäse",
            "ES": "Queso",
            "IT": "Formaggio",
            "KOR": "슬라이스치즈",
            "CHS": "芝士片",
            "CHT": "起司片"
        }
    ],
    "Banana": [
        {
            "NO": 1839,
            "EN": "Banana",
            "JP": "バナナスライス",
            "FR": "Banane",
            "DE": "Banane",
            "ES": "Plátano",
            "IT": "Banana",
            "KOR": "바나나슬라이스",
            "CHS": "香蕉片",
            "CHT": "香蕉片"
        }
    ],
    "Strawberry": [
        {
            "NO": 1840,
            "EN": "Strawberry",
            "JP": "いちごスライス",
            "FR": "Fraise",
            "DE": "Erdbeere",
            "ES": "Fresa",
            "IT": "Fragola",
            "KOR": "딸기슬라이스",
            "CHS": "草莓片",
            "CHT": "草莓片"
        }
    ],
    "Apple": [
        {
            "NO": 1841,
            "EN": "Apple",
            "JP": "わぎりリンゴ",
            "FR": "Pomme",
            "DE": "Apfel",
            "ES": "Manzana",
            "IT": "Mela",
            "KOR": "사과슬라이스",
            "CHS": "苹果片",
            "CHT": "蘋果片"
        }
    ],
    "Kiwi": [
        {
            "NO": 1842,
            "EN": "Kiwi",
            "JP": "わぎりキウイ",
            "FR": "Kiwi",
            "DE": "Kiwi",
            "ES": "Kiwi",
            "IT": "Kiwi",
            "KOR": "키위슬라이스",
            "CHS": "奇异果片",
            "CHT": "奇異果片"
        }
    ],
    "Pineapple": [
        {
            "NO": 1843,
            "EN": "Pineapple",
            "JP": "カットパイン",
            "FR": "Ananas",
            "DE": "Ananas",
            "ES": "Piña",
            "IT": "Ananas",
            "KOR": "파인애플슬라이스",
            "CHS": "凤梨片",
            "CHT": "鳳梨片"
        }
    ],
    "Jalapeño": [
        {
            "NO": 1844,
            "EN": "Jalapeño",
            "JP": "ハラペーニョ",
            "FR": "Piment",
            "DE": "Jalapeño",
            "ES": "Jalapeño",
            "IT": "Jalapeño",
            "KOR": "할라페뇨",
            "CHS": "小辣椒",
            "CHT": "小辣椒"
        }
    ],
    "Horseradish": [
        {
            "NO": 1845,
            "EN": "Horseradish",
            "JP": "ホースラディッシュ",
            "FR": "Raifort",
            "DE": "Meerrettich",
            "ES": "Rábano Picante",
            "IT": "Rafano",
            "KOR": "호스래디시",
            "CHS": "辣根",
            "CHT": "辣根"
        }
    ],
    "Curry Powder": [
        {
            "NO": 1846,
            "EN": "Curry Powder",
            "JP": "カレーパウダー",
            "FR": "Curry en Poudre",
            "DE": "Currypulver",
            "ES": "Curri en Polvo",
            "IT": "Curry in polvere",
            "KOR": "카레파우더",
            "CHS": "咖喱粉",
            "CHT": "咖哩粉"
        }
    ],
    "Wasabi": [
        {
            "NO": 1847,
            "EN": "Wasabi",
            "JP": "ワサビソース",
            "FR": "Sauce au Wasabi",
            "DE": "Wasabi",
            "ES": "Wasabi",
            "IT": "Wasabi",
            "KOR": "와사비소스",
            "CHS": "芥末酱",
            "CHT": "芥末醬"
        }
    ],
    "Watercress": [
        {
            "NO": 1848,
            "EN": "Watercress",
            "JP": "クレソン",
            "FR": "Cresson",
            "DE": "Kresse",
            "ES": "Berros",
            "IT": "Crescione",
            "KOR": "물냉이",
            "CHS": "豆瓣菜",
            "CHT": "豆瓣菜"
        }
    ],
    "Basil": [
        {
            "NO": 1849,
            "EN": "Basil",
            "JP": "バジル",
            "FR": "Basilic",
            "DE": "Basilikum",
            "ES": "Albahaca",
            "IT": "Basilico",
            "KOR": "바질",
            "CHS": "罗勒",
            "CHT": "羅勒"
        }
    ],
    "Venonat Fang": [
        {
            "NO": 1850,
            "EN": "Venonat Fang",
            "JP": "コンパンのキバ",
            "FR": "Croc de Mimitoss",
            "DE": "Bluzuk-Zahn",
            "ES": "Colmillo de Venonat",
            "IT": "Zanna di Venonat",
            "KOR": "콘팡의이빨",
            "CHS": "毛球的牙",
            "CHT": "毛球的牙"
        }
    ],
    "Diglett Dirt": [
        {
            "NO": 1851,
            "EN": "Diglett Dirt",
            "JP": "ディグダのつち",
            "FR": "Terre de Taupiqueur",
            "DE": "Digda-Erde",
            "ES": "Tierra de Diglett",
            "IT": "Terra di Diglett",
            "KOR": "디그다의흙",
            "CHS": "地鼠的土",
            "CHT": "地鼠的土"
        }
    ],
    "Meowth Fur": [
        {
            "NO": 1852,
            "EN": "Meowth Fur",
            "JP": "ニャースのけ",
            "FR": "Poils de Miaouss",
            "DE": "Mauzi-Haar",
            "ES": "Pelo de Meowth",
            "IT": "Pelo di Meowth",
            "KOR": "나옹의털",
            "CHS": "喵喵的毛",
            "CHT": "喵喵的毛"
        }
    ],
    "Psyduck Down": [
        {
            "NO": 1853,
            "EN": "Psyduck Down",
            "JP": "コダックのうもう",
            "FR": "Duvet de Psykokwak",
            "DE": "Enton-Daune",
            "ES": "Plumón de Psyduck",
            "IT": "Piuma di Psyduck",
            "KOR": "고라파덕의솜털",
            "CHS": "可达鸭的羽绒",
            "CHT": "可達鴨的羽絨"
        }
    ],
    "Mankey Fur": [
        {
            "NO": 1854,
            "EN": "Mankey Fur",
            "JP": "マンキーのけ",
            "FR": "Poils de Férosinge",
            "DE": "Menki-Haar",
            "ES": "Pelo de Mankey",
            "IT": "Pelo di Mankey",
            "KOR": "망키의털",
            "CHS": "猴怪的毛",
            "CHT": "猴怪的毛"
        }
    ],
    "Growlithe Fur": [
        {
            "NO": 1855,
            "EN": "Growlithe Fur",
            "JP": "ガーディのけ",
            "FR": "Poils de Caninos",
            "DE": "Fukano-Haar",
            "ES": "Pelo de Growlithe",
            "IT": "Pelo di Growlithe",
            "KOR": "가디의털",
            "CHS": "卡蒂狗的毛",
            "CHT": "卡蒂狗的毛"
        }
    ],
    "Slowpoke Claw": [
        {
            "NO": 1856,
            "EN": "Slowpoke Claw",
            "JP": "ヤドンのツメ",
            "FR": "Griffe de Ramoloss",
            "DE": "Flegmon-Kralle",
            "ES": "Garra de Slowpoke",
            "IT": "Artiglio di Slowpoke",
            "KOR": "야돈의발톱",
            "CHS": "呆呆兽的爪子",
            "CHT": "呆呆獸的爪子"
        }
    ],
    "Magnemite Screw": [
        {
            "NO": 1857,
            "EN": "Magnemite Screw",
            "JP": "コイルのねじ",
            "FR": "Vis de Magnéti",
            "DE": "Magnetilo-Schraube",
            "ES": "Tornillo de Magnemite",
            "IT": "Vite di Magnemite",
            "KOR": "코일의나사",
            "CHS": "小磁怪的螺丝",
            "CHT": "小磁怪的螺絲"
        }
    ],
    "Grimer Toxin": [
        {
            "NO": 1858,
            "EN": "Grimer Toxin",
            "JP": "ベトベターのどくそ",
            "FR": "Poison de Tadmorv",
            "DE": "Sleima-Toxin",
            "ES": "Toxinas de Grimer",
            "IT": "Tossine di Grimer",
            "KOR": "질퍽이의독소",
            "CHS": "臭泥的毒素",
            "CHT": "臭泥的毒素"
        }
    ],
    "Shellder Pearl": [
        {
            "NO": 1859,
            "EN": "Shellder Pearl",
            "JP": "シェルダーのしんじゅ",
            "FR": "Perle de Kokiyas",
            "DE": "Muschas-Perle",
            "ES": "Perla de Shellder",
            "IT": "Perla di Shellder",
            "KOR": "셀러의진주",
            "CHS": "大舌贝的珍珠",
            "CHT": "大舌貝的珍珠"
        }
    ],
    "Gastly Gas": [
        {
            "NO": 1860,
            "EN": "Gastly Gas",
            "JP": "ゴースのガス",
            "FR": "Gaz de Fantominus",
            "DE": "Nebulak-Gas",
            "ES": "Gas de Gastly",
            "IT": "Gas di Gastly",
            "KOR": "고오스의가스",
            "CHS": "鬼斯的气体",
            "CHT": "鬼斯的氣體"
        }
    ],
    "Drowzee Fur": [
        {
            "NO": 1861,
            "EN": "Drowzee Fur",
            "JP": "スリープのけ",
            "FR": "Poils de Soporifik",
            "DE": "Traumato-Haar",
            "ES": "Pelo de Drowzee",
            "IT": "Pelo di Drowzee",
            "KOR": "슬리프의털",
            "CHS": "催眠貘的毛",
            "CHT": "催眠貘的毛"
        }
    ],
    "Voltorb Sparks": [
        {
            "NO": 1862,
            "EN": "Voltorb Sparks",
            "JP": "ビリリダマのでんき",
            "FR": "Électricité de Voltorbe",
            "DE": "Voltobal-Strom",
            "ES": "Electricidad de Voltorb",
            "IT": "Elettricità di Voltorb",
            "KOR": "찌리리공의전기",
            "CHS": "霹雳电球的电力",
            "CHT": "霹靂電球的電力"
        }
    ],
    "Scyther Claw": [
        {
            "NO": 1863,
            "EN": "Scyther Claw",
            "JP": "ストライクのツメ",
            "FR": "Griffe d’Insécateur",
            "DE": "Sichlor-Kralle",
            "ES": "Garra de Scyther",
            "IT": "Artiglio di Scyther",
            "KOR": "스라크의발톱",
            "CHS": "飞天螳螂的爪子",
            "CHT": "飛天螳螂的爪子"
        }
    ],
    "Tauros Hair": [
        {
            "NO": 1864,
            "EN": "Tauros Hair",
            "JP": "ケンタロスのけ",
            "FR": "Poils de Tauros",
            "DE": "Tauros-Haar",
            "ES": "Pelo de Tauros",
            "IT": "Pelo di Tauros",
            "KOR": "켄타로스의털",
            "CHS": "肯泰罗的毛",
            "CHT": "肯泰羅的毛"
        }
    ],
    "Magikarp Scales": [
        {
            "NO": 1865,
            "EN": "Magikarp Scales",
            "JP": "コイキングのウロコ",
            "FR": "Écaille de Magicarpe",
            "DE": "Karpador-Schuppe",
            "ES": "Escama de Magikarp",
            "IT": "Squama di Magikarp",
            "KOR": "잉어킹의비늘",
            "CHS": "鲤鱼王的鳞片",
            "CHT": "鯉魚王的鱗片"
        }
    ],
    "Ditto Goo": [
        {
            "NO": 1866,
            "EN": "Ditto Goo",
            "JP": "メタモンのべたべた",
            "FR": "Substance de Métamorph",
            "DE": "Ditto-Glibber",
            "ES": "Pegote de Ditto",
            "IT": "Appiccicume di Ditto",
            "KOR": "메타몽의끈끈이",
            "CHS": "百变怪的黏糊",
            "CHT": "百變怪的黏糊"
        }
    ],
    "Eevee Fur": [
        {
            "NO": 1867,
            "EN": "Eevee Fur",
            "JP": "イーブイのけ",
            "FR": "Poils d’Évoli",
            "DE": "Evoli-Haar",
            "ES": "Pelo de Eevee",
            "IT": "Pelo di Eevee",
            "KOR": "이브이의털",
            "CHS": "伊布的毛",
            "CHT": "伊布的毛"
        }
    ],
    "Dratini Scales": [
        {
            "NO": 1868,
            "EN": "Dratini Scales",
            "JP": "ミニリュウのウロコ",
            "FR": "Écaille de Minidraco",
            "DE": "Dratini-Schuppe",
            "ES": "Escama de Dratini",
            "IT": "Squama di Dratini",
            "KOR": "미뇽의비늘",
            "CHS": "迷你龙的鳞片",
            "CHT": "迷你龍的鱗片"
        }
    ],
    "Pichu Fur": [
        {
            "NO": 1869,
            "EN": "Pichu Fur",
            "JP": "ピチューのけ",
            "FR": "Poils de Pichu",
            "DE": "Pichu-Haar",
            "ES": "Pelo de Pichu",
            "IT": "Pelo di Pichu",
            "KOR": "피츄의털",
            "CHS": "皮丘的毛",
            "CHT": "皮丘的毛"
        }
    ],
    "Igglybuff Fluff": [
        {
            "NO": 1870,
            "EN": "Igglybuff Fluff",
            "JP": "ププリンのけ",
            "FR": "Poils de Toudoudou",
            "DE": "Fluffeluff-Haar",
            "ES": "Pelo de Igglybuff",
            "IT": "Pelo di Igglybuff",
            "KOR": "푸푸린의털",
            "CHS": "宝宝丁的毛",
            "CHT": "寶寶丁的毛"
        }
    ],
    "Mareep Wool": [
        {
            "NO": 1871,
            "EN": "Mareep Wool",
            "JP": "メリープのけだま",
            "FR": "Laine de Wattouat",
            "DE": "Voltilamm-Wolle",
            "ES": "Lana de Mareep",
            "IT": "Lana di Mareep",
            "KOR": "메리프의털뭉치",
            "CHS": "咩利羊的毛球",
            "CHT": "咩利羊的毛球"
        }
    ],
    "Hoppip Leaf": [
        {
            "NO": 1872,
            "EN": "Hoppip Leaf",
            "JP": "ハネッコのはっぱ",
            "FR": "Feuille de Granivol",
            "DE": "Hoppspross-Blatt",
            "ES": "Hoja de Hoppip",
            "IT": "Foglia di Hoppip",
            "KOR": "통통코의잎",
            "CHS": "毽子草的叶片",
            "CHT": "毽子草的葉片"
        }
    ],
    "Sunkern Leaf": [
        {
            "NO": 1873,
            "EN": "Sunkern Leaf",
            "JP": "ヒマナッツのはっぱ",
            "FR": "Feuille de Tournegrin",
            "DE": "Sonnkern-Blatt",
            "ES": "Hoja de Sunkern",
            "IT": "Foglia di Sunkern",
            "KOR": "해너츠의잎",
            "CHS": "向日种子的叶片",
            "CHT": "向日種子的葉片"
        }
    ],
    "Murkrow Bauble": [
        {
            "NO": 1874,
            "EN": "Murkrow Bauble",
            "JP": "ヤミカラスのおたから",
            "FR": "Trésor de Cornèbre",
            "DE": "Kramurx-Schatz",
            "ES": "Tesoro de Murkrow",
            "IT": "Tesoro di Murkrow",
            "KOR": "니로우의보물",
            "CHS": "黑暗鸦的宝物",
            "CHT": "黑暗鴉的寶物"
        }
    ],
    "Misdreavus Tears": [
        {
            "NO": 1875,
            "EN": "Misdreavus Tears",
            "JP": "ムウマのなみだ",
            "FR": "Larme de Feuforêve",
            "DE": "Traunfugil-Träne",
            "ES": "Lágrima de Misdreavus",
            "IT": "Lacrime di Misdreavus",
            "KOR": "무우마의눈물",
            "CHS": "梦妖的眼泪",
            "CHT": "夢妖的眼淚"
        }
    ],
    "Girafarig Fur": [
        {
            "NO": 1876,
            "EN": "Girafarig Fur",
            "JP": "キリンリキのけ",
            "FR": "Poils de Girafarig",
            "DE": "Girafarig-Haar",
            "ES": "Pelo de Girafarig",
            "IT": "Pelo di Girafarig",
            "KOR": "키링키의털",
            "CHS": "麒麟奇的毛",
            "CHT": "麒麟奇的毛"
        }
    ],
    "Pineco Husk": [
        {
            "NO": 1877,
            "EN": "Pineco Husk",
            "JP": "クヌギダマのから",
            "FR": "Écorce de Pomdepik",
            "DE": "Tannza-Schale",
            "ES": "Corteza de Pineco",
            "IT": "Guscio di Pineco",
            "KOR": "피콘의껍데기",
            "CHS": "榛果球的壳",
            "CHT": "榛果球的殼"
        }
    ],
    "Dunsparce Scales": [
        {
            "NO": 1878,
            "EN": "Dunsparce Scales",
            "JP": "ノコッチのウロコ",
            "FR": "Écaille d’Insolourdo",
            "DE": "Dummisel-Schuppe",
            "ES": "Escama de Dunsparce",
            "IT": "Squama di Dunsparce",
            "KOR": "노고치의비늘",
            "CHS": "土龙弟弟的鳞片",
            "CHT": "土龍弟弟的鱗片"
        }
    ],
    "Qwilfish Spines": [
        {
            "NO": 1879,
            "EN": "Qwilfish Spines",
            "JP": "ハリーセンのトゲ",
            "FR": "Épine de Qwilfish",
            "DE": "Baldorfish-Stachel",
            "ES": "Púa de Qwilfish",
            "IT": "Aculeo di Qwilfish",
            "KOR": "침바루의가시",
            "CHS": "千针鱼的刺",
            "CHT": "千針魚的刺"
        }
    ],
    "Heracross Claw": [
        {
            "NO": 1880,
            "EN": "Heracross Claw",
            "JP": "ヘラクロスのツメ",
            "FR": "Griffe de Scarhino",
            "DE": "Skaraborn-Kralle",
            "ES": "Garra de Heracross",
            "IT": "Artiglio di Heracross",
            "KOR": "헤라크로스의발톱",
            "CHS": "赫拉克罗斯的爪子",
            "CHT": "赫拉克羅斯的爪子"
        }
    ],
    "Sneasel Claw": [
        {
            "NO": 1881,
            "EN": "Sneasel Claw",
            "JP": "ニューラのツメ",
            "FR": "Griffe de Farfuret",
            "DE": "Sniebel-Kralle",
            "ES": "Garra de Sneasel",
            "IT": "Artiglio di Sneasel",
            "KOR": "포푸니의손톱",
            "CHS": "狃拉的爪子",
            "CHT": "狃拉的爪子"
        }
    ],
    "Teddiursa Claw": [
        {
            "NO": 1882,
            "EN": "Teddiursa Claw",
            "JP": "ヒメグマのツメ",
            "FR": "Griffe de Teddiursa",
            "DE": "Teddiursa-Kralle",
            "ES": "Garra de Teddiursa",
            "IT": "Artiglio di Teddiursa",
            "KOR": "깜지곰의손톱",
            "CHS": "熊宝宝的爪子",
            "CHT": "熊寶寶的爪子"
        }
    ],
    "Delibird Parcel": [
        {
            "NO": 1883,
            "EN": "Delibird Parcel",
            "JP": "デリバードのにもつ",
            "FR": "Provisions de Cadoizo",
            "DE": "Botogel-Päckchen",
            "ES": "Paquete de Delibird",
            "IT": "Scorte di Delibird",
            "KOR": "딜리버드의짐",
            "CHS": "信使鸟的行李",
            "CHT": "信使鳥的行李"
        }
    ],
    "Houndour Fang": [
        {
            "NO": 1884,
            "EN": "Houndour Fang",
            "JP": "デルビルのキバ",
            "FR": "Croc de Malosse",
            "DE": "Hunduster-Zahn",
            "ES": "Colmillo de Houndour",
            "IT": "Zanna di Houndour",
            "KOR": "델빌의이빨",
            "CHS": "戴鲁比的牙",
            "CHT": "戴魯比的牙"
        }
    ],
    "Phanpy Nail": [
        {
            "NO": 1885,
            "EN": "Phanpy Nail",
            "JP": "ゴマゾウのツメ",
            "FR": "Ongle de Phanpy",
            "DE": "Phanpy-Kralle",
            "ES": "Uña de Phanpy",
            "IT": "Unghia di Phanpy",
            "KOR": "코코리의발톱",
            "CHS": "小小象的爪子",
            "CHT": "小小象的爪子"
        }
    ],
    "Stantler Hair": [
        {
            "NO": 1886,
            "EN": "Stantler Hair",
            "JP": "オドシシのけ",
            "FR": "Poils de Cerfrousse",
            "DE": "Damhirplex-Haar",
            "ES": "Pelo de Stantler",
            "IT": "Pelo di Stantler",
            "KOR": "노라키의털",
            "CHS": "惊角鹿的毛",
            "CHT": "驚角鹿的毛"
        }
    ],
    "Larvitar Claw": [
        {
            "NO": 1887,
            "EN": "Larvitar Claw",
            "JP": "ヨーギラスのツメ",
            "FR": "Griffe d’Embrylex",
            "DE": "Larvitar-Kralle",
            "ES": "Garra de Larvitar",
            "IT": "Artiglio di Larvitar",
            "KOR": "애버라스의발톱",
            "CHS": "幼基拉斯的爪子",
            "CHT": "幼基拉斯的爪子"
        }
    ],
    "Wingull Feather": [
        {
            "NO": 1888,
            "EN": "Wingull Feather",
            "JP": "キャモメのはね",
            "FR": "Plume de Goélise",
            "DE": "Wingull-Feder",
            "ES": "Pluma de Wingull",
            "IT": "Penna di Wingull",
            "KOR": "갈모매의깃털",
            "CHS": "长翅鸥的羽毛",
            "CHT": "長翅鷗的羽毛"
        }
    ],
    "Ralts Dust": [
        {
            "NO": 1889,
            "EN": "Ralts Dust",
            "JP": "ラルトスのおとしもの",
            "FR": "Babiole de Tarsal",
            "DE": "Trasla-Material",
            "ES": "Pertenencia de Ralts",
            "IT": "Oggetto di Ralts",
            "KOR": "랄토스의유실물",
            "CHS": "拉鲁拉丝的掉落物",
            "CHT": "拉魯拉絲的掉落物"
        }
    ],
    "Surskit Syrup": [
        {
            "NO": 1890,
            "EN": "Surskit Syrup",
            "JP": "アメタマのミツ",
            "FR": "Nectar d’Arakdo",
            "DE": "Gehweiher-Nektar",
            "ES": "Néctar de Surskit",
            "IT": "Sciroppo di Surskit",
            "KOR": "비구술의꿀",
            "CHS": "溜溜糖球的蜜",
            "CHT": "溜溜糖球的蜜"
        }
    ],
    "Shroomish Spores": [
        {
            "NO": 1891,
            "EN": "Shroomish Spores",
            "JP": "キノココのほうし",
            "FR": "Spores de Balignon",
            "DE": "Knilz-Spore",
            "ES": "Esporas de Shroomish",
            "IT": "Spore di Shroomish",
            "KOR": "버섯꼬의포자",
            "CHS": "蘑蘑菇的孢子",
            "CHT": "蘑蘑菇的孢子"
        }
    ],
    "Slakoth Fur": [
        {
            "NO": 1892,
            "EN": "Slakoth Fur",
            "JP": "ナマケロのけ",
            "FR": "Poils de Parecool",
            "DE": "Bummelz-Haar",
            "ES": "Pelo de Slakoth",
            "IT": "Pelo di Slakoth",
            "KOR": "게을로의털",
            "CHS": "懒人獭的毛",
            "CHT": "懶人獺的毛"
        }
    ],
    "Makuhita Sweat": [
        {
            "NO": 1893,
            "EN": "Makuhita Sweat",
            "JP": "マクノシタのあせ",
            "FR": "Sueur de Makuhita",
            "DE": "Makuhita-Schweiß",
            "ES": "Sudor de Makuhita",
            "IT": "Sudore di Makuhita",
            "KOR": "마크탕의땀",
            "CHS": "幕下力士的汗",
            "CHT": "幕下力士的汗"
        }
    ],
    "Azurill Fur": [
        {
            "NO": 1894,
            "EN": "Azurill Fur",
            "JP": "ルリリのけ",
            "FR": "Poils d’Azurill",
            "DE": "Azurill-Haar",
            "ES": "Pelo de Azurill",
            "IT": "Pelo di Azurill",
            "KOR": "루리리의털",
            "CHS": "露力丽的毛",
            "CHT": "露力麗的毛"
        }
    ],
    "Sableye Gem": [
        {
            "NO": 1895,
            "EN": "Sableye Gem",
            "JP": "ヤミラミのほうせき",
            "FR": "Joyau de Ténéfix",
            "DE": "Zobiris-Edelstein",
            "ES": "Gema de Sableye",
            "IT": "Gemma di Sableye",
            "KOR": "깜까미의보석",
            "CHS": "勾魂眼的宝石",
            "CHT": "勾魂眼的寶石"
        }
    ],
    "Meditite Sweat": [
        {
            "NO": 1896,
            "EN": "Meditite Sweat",
            "JP": "アサナンのあせ",
            "FR": "Sueur de Méditikka",
            "DE": "Meditie-Schweiß",
            "ES": "Sudor de Meditite",
            "IT": "Sudore di Meditite",
            "KOR": "요가랑의땀",
            "CHS": "玛沙那的汗",
            "CHT": "瑪沙那的汗"
        }
    ],
    "Gulpin Mucus": [
        {
            "NO": 1897,
            "EN": "Gulpin Mucus",
            "JP": "ゴクリンのねんえき",
            "FR": "Mucus de Gloupti",
            "DE": "Schluppuck-Schleim",
            "ES": "Secreción de Gulpin",
            "IT": "Muco di Gulpin",
            "KOR": "꼴깍몬의점액",
            "CHS": "溶食兽的黏液",
            "CHT": "溶食獸的黏液"
        }
    ],
    "Numel Lava": [
        {
            "NO": 1898,
            "EN": "Numel Lava",
            "JP": "ドンメルのようがん",
            "FR": "Lave de Chamallot",
            "DE": "Camaub-Lava",
            "ES": "Lava de Numel",
            "IT": "Lava di Numel",
            "KOR": "둔타의용암",
            "CHS": "呆火驼的熔岩",
            "CHT": "呆火駝的熔岩"
        }
    ],
    "Torkoal Coal": [
        {
            "NO": 1899,
            "EN": "Torkoal Coal",
            "JP": "コータスのせきたん",
            "FR": "Charbon de Chartor",
            "DE": "Qurtel-Kohle",
            "ES": "Carbón de Torkoal",
            "IT": "Carbone di Torkoal",
            "KOR": "코터스의석탄",
            "CHS": "煤炭龟的煤炭",
            "CHT": "煤炭龜的煤炭"
        }
    ],
    "Spoink Pearl": [
        {
            "NO": 1900,
            "EN": "Spoink Pearl",
            "JP": "バネブーのしんじゅ",
            "FR": "Perle de Spoink",
            "DE": "Spoink-Perle",
            "ES": "Perla de Spoink",
            "IT": "Perla di Spoink",
            "KOR": "피그점프의진주",
            "CHS": "跳跳猪的珍珠",
            "CHT": "跳跳豬的珍珠"
        }
    ],
    "Cacnea Needle": [
        {
            "NO": 1901,
            "EN": "Cacnea Needle",
            "JP": "サボネアのトゲ",
            "FR": "Épine de Cacnea",
            "DE": "Tuska-Stachel",
            "ES": "Espina de Cacnea",
            "IT": "Spina di Cacnea",
            "KOR": "선인왕의가시",
            "CHS": "刺球仙人掌的刺",
            "CHT": "刺球仙人掌的刺"
        }
    ],
    "Swablu Fluff": [
        {
            "NO": 1902,
            "EN": "Swablu Fluff",
            "JP": "チルットのはね",
            "FR": "Plume de Tylton",
            "DE": "Wablu-Feder",
            "ES": "Pluma de Swablu",
            "IT": "Piuma di Swablu",
            "KOR": "파비코의깃털",
            "CHS": "青绵鸟的羽毛",
            "CHT": "青綿鳥的羽毛"
        }
    ],
    "Zangoose Claw": [
        {
            "NO": 1903,
            "EN": "Zangoose Claw",
            "JP": "ザングースのツメ",
            "FR": "Griffe de Mangriff",
            "DE": "Sengo-Kralle",
            "ES": "Garra de Zangoose",
            "IT": "Artiglio di Zangoose",
            "KOR": "쟝고의발톱",
            "CHS": "猫鼬斩的爪子",
            "CHT": "貓鼬斬的爪子"
        }
    ],
    "Seviper Fang": [
        {
            "NO": 1904,
            "EN": "Seviper Fang",
            "JP": "ハブネークのキバ",
            "FR": "Croc de Séviper",
            "DE": "Vipitis-Zahn",
            "ES": "Colmillo de Seviper",
            "IT": "Zanna di Seviper",
            "KOR": "세비퍼의이빨",
            "CHS": "饭匙蛇的牙",
            "CHT": "飯匙蛇的牙"
        }
    ],
    "Barboach Slime": [
        {
            "NO": 1905,
            "EN": "Barboach Slime",
            "JP": "ドジョッチのねんえき",
            "FR": "Mucus de Barloche",
            "DE": "Schmerbe-Schleim",
            "ES": "Secreción de Barboach",
            "IT": "Muco di Barboach",
            "KOR": "미꾸리의점액",
            "CHS": "泥泥鳅的黏液",
            "CHT": "泥泥鰍的黏液"
        }
    ],
    "Shuppet Scrap": [
        {
            "NO": 1906,
            "EN": "Shuppet Scrap",
            "JP": "カゲボウズのきれはし",
            "FR": "Tissu de Polichombr",
            "DE": "Shuppet-Fetzen",
            "ES": "Retal de Shuppet",
            "IT": "Brandello di Shuppet",
            "KOR": "어둠대신의천조각",
            "CHS": "怨影娃娃的残片",
            "CHT": "怨影娃娃的殘片"
        }
    ],
    "Tropius Leaf": [
        {
            "NO": 1907,
            "EN": "Tropius Leaf",
            "JP": "トロピウスのはっぱ",
            "FR": "Feuille de Tropius",
            "DE": "Tropius-Blatt",
            "ES": "Hoja de Tropius",
            "IT": "Foglia di Tropius",
            "KOR": "트로피우스의잎",
            "CHS": "热带龙的叶片",
            "CHT": "熱帶龍的葉片"
        }
    ],
    "Snorunt Fur": [
        {
            "NO": 1908,
            "EN": "Snorunt Fur",
            "JP": "ユキワラシのけ",
            "FR": "Poils de Stalgamin",
            "DE": "Schneppke-Haar",
            "ES": "Pelo de Snorunt",
            "IT": "Pelo di Snorunt",
            "KOR": "눈꼬마의털",
            "CHS": "雪童子的毛",
            "CHT": "雪童子的毛"
        }
    ],
    "Luvdisc Scales": [
        {
            "NO": 1909,
            "EN": "Luvdisc Scales",
            "JP": "ラブカスのウロコ",
            "FR": "Écaille de Lovdisc",
            "DE": "Liebiskus-Schuppe",
            "ES": "Escama de Luvdisc",
            "IT": "Squama di Luvdisc",
            "KOR": "사랑동이의비늘",
            "CHS": "爱心鱼的鳞片",
            "CHT": "愛心魚的鱗片"
        }
    ],
    "Bagon Scales": [
        {
            "NO": 1910,
            "EN": "Bagon Scales",
            "JP": "タツベイのウロコ",
            "FR": "Écaille de Draby",
            "DE": "Kindwurm-Schuppe",
            "ES": "Escama de Bagon",
            "IT": "Squama di Bagon",
            "KOR": "아공이의비늘",
            "CHS": "宝贝龙的鳞片",
            "CHT": "寶貝龍的鱗片"
        }
    ],
    "Starly Feather": [
        {
            "NO": 1911,
            "EN": "Starly Feather",
            "JP": "ムックルのはね",
            "FR": "Plume d’Étourmi",
            "DE": "Staralili-Feder",
            "ES": "Pluma de Starly",
            "IT": "Penna di Starly",
            "KOR": "찌르꼬의깃털",
            "CHS": "姆克儿的羽毛",
            "CHT": "姆克兒的羽毛"
        }
    ],
    "Kricketot Shell": [
        {
            "NO": 1912,
            "EN": "Kricketot Shell",
            "JP": "コロボーシのぬけがら",
            "FR": "Mue de Crikzik",
            "DE": "Zirpurze-Häutungsrest",
            "ES": "Muda de Kricketot",
            "IT": "Esuvia di Kricketot",
            "KOR": "귀뚤뚜기의허물",
            "CHS": "圆法师的蜕壳",
            "CHT": "圓法師的蛻殼"
        }
    ],
    "Shinx Fang": [
        {
            "NO": 1913,
            "EN": "Shinx Fang",
            "JP": "コリンクのキバ",
            "FR": "Croc de Lixy",
            "DE": "Sheinux-Zahn",
            "ES": "Colmillo de Shinx",
            "IT": "Zanna di Shinx",
            "KOR": "꼬링크의이빨",
            "CHS": "小猫怪的牙",
            "CHT": "小貓怪的牙"
        }
    ],
    "Combee Honey": [
        {
            "NO": 1914,
            "EN": "Combee Honey",
            "JP": "ミツハニーのミツ",
            "FR": "Nectar d’Apitrini",
            "DE": "Wadribie-Honig",
            "ES": "Miel de Combee",
            "IT": "Nettare di Combee",
            "KOR": "세꿀버리의꿀",
            "CHS": "三蜜蜂的蜜",
            "CHT": "三蜜蜂的蜜"
        }
    ],
    "Pachirisu Fur": [
        {
            "NO": 1915,
            "EN": "Pachirisu Fur",
            "JP": "パチリスのけ",
            "FR": "Poils de Pachirisu",
            "DE": "Pachirisu-Haar",
            "ES": "Pelo de Pachirisu",
            "IT": "Pelo di Pachirisu",
            "KOR": "파치리스의털",
            "CHS": "帕奇利兹的毛",
            "CHT": "帕奇利茲的毛"
        }
    ],
    "Buizel Fur": [
        {
            "NO": 1916,
            "EN": "Buizel Fur",
            "JP": "ブイゼルのけ",
            "FR": "Poils de Mustébouée",
            "DE": "Bamelin-Haar",
            "ES": "Pelo de Buizel",
            "IT": "Pelo di Buizel",
            "KOR": "브이젤의털",
            "CHS": "泳圈鼬的毛",
            "CHT": "泳圈鼬的毛"
        }
    ],
    "Shellos Mucus": [
        {
            "NO": 1917,
            "EN": "Shellos Mucus",
            "JP": "カラナクシのねんえき",
            "FR": "Mucus de Sancoki",
            "DE": "Schalellos-Schleim",
            "ES": "Secreción de Shellos",
            "IT": "Bava di Shellos",
            "KOR": "깝질무의점액",
            "CHS": "无壳海兔的黏液",
            "CHT": "無殼海兔的黏液"
        }
    ],
    "Drifloon Gas": [
        {
            "NO": 1918,
            "EN": "Drifloon Gas",
            "JP": "フワンテのガス",
            "FR": "Gaz de Baudrive",
            "DE": "Driftlon-Gas",
            "ES": "Gas de Drifloon",
            "IT": "Gas di Drifloon",
            "KOR": "흔들풍손의가스",
            "CHS": "飘飘球的气体",
            "CHT": "飄飄球的氣體"
        }
    ],
    "Stunky Fur": [
        {
            "NO": 1919,
            "EN": "Stunky Fur",
            "JP": "スカンプーのけ",
            "FR": "Poils de Moufouette",
            "DE": "Skunkapuh-Haar",
            "ES": "Pelo de Stunky",
            "IT": "Pelo di Stunky",
            "KOR": "스컹뿡의털",
            "CHS": "臭鼬噗的毛",
            "CHT": "臭鼬噗的毛"
        }
    ],
    "Bronzor Fragment": [
        {
            "NO": 1920,
            "EN": "Bronzor Fragment",
            "JP": "ドーミラーのかけら",
            "FR": "Fragment d’Archéomire",
            "DE": "Bronzel-Splitter",
            "ES": "Fragmento de Bronzor",
            "IT": "Frammento di Bronzor",
            "KOR": "동미러의조각",
            "CHS": "铜镜怪的碎片",
            "CHT": "銅鏡怪的碎片"
        }
    ],
    "Bonsly Tears": [
        {
            "NO": 1921,
            "EN": "Bonsly Tears",
            "JP": "ウソハチのなみだ",
            "FR": "Larme de Manzaï",
            "DE": "Mobai-Träne",
            "ES": "Lágrima de Bonsly",
            "IT": "Lacrime di Bonsly",
            "KOR": "꼬지지의눈물",
            "CHS": "盆才怪的眼泪",
            "CHT": "盆才怪的眼淚"
        }
    ],
    "Happiny Dust": [
        {
            "NO": 1922,
            "EN": "Happiny Dust",
            "JP": "ピンプクのおとしもの",
            "FR": "Babiole de Ptiravi",
            "DE": "Wonneira-Material",
            "ES": "Pertenencia de Happiny",
            "IT": "Oggetto di Happiny",
            "KOR": "핑복의유실물",
            "CHS": "小福蛋的掉落物",
            "CHT": "小福蛋的掉落物"
        }
    ],
    "Spiritomb Fragment": [
        {
            "NO": 1923,
            "EN": "Spiritomb Fragment",
            "JP": "ミカルゲのかけら",
            "FR": "Fragment de Spiritomb",
            "DE": "Kryppuk-Splitter",
            "ES": "Fragmento de Spiritomb",
            "IT": "Frammento di Spiritomb",
            "KOR": "화강돌의조각",
            "CHS": "花岩怪的碎片",
            "CHT": "花岩怪的碎片"
        }
    ],
    "Gible Scales": [
        {
            "NO": 1924,
            "EN": "Gible Scales",
            "JP": "フカマルのウロコ",
            "FR": "Écaille de Griknot",
            "DE": "Kaumalat-Schuppe",
            "ES": "Escama de Gible",
            "IT": "Squama di Gible",
            "KOR": "딥상어동의비늘",
            "CHS": "圆陆鲨的鳞片",
            "CHT": "圓陸鯊的鱗片"
        }
    ],
    "Riolu Fur": [
        {
            "NO": 1925,
            "EN": "Riolu Fur",
            "JP": "リオルのけ",
            "FR": "Poils de Riolu",
            "DE": "Riolu-Haar",
            "ES": "Pelo de Riolu",
            "IT": "Pelo di Riolu",
            "KOR": "리오르의털",
            "CHS": "利欧路的毛",
            "CHT": "利歐路的毛"
        }
    ],
    "Hippopotas Sand": [
        {
            "NO": 1926,
            "EN": "Hippopotas Sand",
            "JP": "ヒポポタスのすな",
            "FR": "Sable d’Hippopotas",
            "DE": "Hippopotas-Sand",
            "ES": "Arena de Hippopotas",
            "IT": "Sabbia di Hippopotas",
            "KOR": "히포포타스의모래",
            "CHS": "沙河马的沙",
            "CHT": "沙河馬的沙"
        }
    ],
    "Croagunk Poison": [
        {
            "NO": 1927,
            "EN": "Croagunk Poison",
            "JP": "グレッグルのどくそ",
            "FR": "Poison de Cradopaud",
            "DE": "Glibunkel-Toxin",
            "ES": "Toxinas de Croagunk",
            "IT": "Tossine di Croagunk",
            "KOR": "삐딱구리의독소",
            "CHS": "不良蛙的毒素",
            "CHT": "不良蛙的毒素"
        }
    ],
    "Finneon Scales": [
        {
            "NO": 1928,
            "EN": "Finneon Scales",
            "JP": "ケイコウオのウロコ",
            "FR": "Écaille d’Écayon",
            "DE": "Finneon-Schuppe",
            "ES": "Escama de Finneon",
            "IT": "Squama di Finneon",
            "KOR": "형광어의비늘",
            "CHS": "荧光鱼的鳞片",
            "CHT": "螢光魚的鱗片"
        }
    ],
    "Snover Berries": [
        {
            "NO": 1929,
            "EN": "Snover Berries",
            "JP": "ユキカブリのみ",
            "FR": "Baie de Blizzi",
            "DE": "Shnebedeck-Beere",
            "ES": "Baya de Snover",
            "IT": "Bacca di Snover",
            "KOR": "눈쓰개의열매",
            "CHS": "雪笠怪的果实",
            "CHT": "雪笠怪的果實"
        }
    ],
    "Rotom Sparks": [
        {
            "NO": 1930,
            "EN": "Rotom Sparks",
            "JP": "ロトムのでんき",
            "FR": "Électricité de Motisma",
            "DE": "Rotom-Strom",
            "ES": "Electricidad de Rotom",
            "IT": "Elettricità di Rotom",
            "KOR": "로토무의전기",
            "CHS": "洛托姆的电力",
            "CHT": "洛托姆的電力"
        }
    ],
    "Petilil Leaf": [
        {
            "NO": 1931,
            "EN": "Petilil Leaf",
            "JP": "チュリネのはっぱ",
            "FR": "Feuille de Chlorobule",
            "DE": "Lilminip-Blatt",
            "ES": "Hoja de Petilil",
            "IT": "Foglia di Petilil",
            "KOR": "치릴리의잎",
            "CHS": "百合根娃娃的叶片",
            "CHT": "百合根娃娃的葉片"
        }
    ],
    "Basculin Fang": [
        {
            "NO": 1932,
            "EN": "Basculin Fang",
            "JP": "バスラオのキバ",
            "FR": "Croc de Bargantua",
            "DE": "Barschuft-Zahn",
            "ES": "Colmillo de Basculin",
            "IT": "Dente di Basculin",
            "KOR": "배쓰나이의이빨",
            "CHS": "野蛮鲈鱼的牙",
            "CHT": "野蠻鱸魚的牙"
        }
    ],
    "Sandile Claw": [
        {
            "NO": 1933,
            "EN": "Sandile Claw",
            "JP": "メグロコのツメ",
            "FR": "Griffe de Mascaïman",
            "DE": "Ganovil-Kralle",
            "ES": "Garra de Sandile",
            "IT": "Artiglio di Sandile",
            "KOR": "깜눈크의발톱",
            "CHS": "黑眼鳄的爪子",
            "CHT": "黑眼鱷的爪子"
        }
    ],
    "Zorua Fur": [
        {
            "NO": 1934,
            "EN": "Zorua Fur",
            "JP": "ゾロアのけ",
            "FR": "Poils de Zorua",
            "DE": "Zorua-Haar",
            "ES": "Pelo de Zorua",
            "IT": "Pelo di Zorua",
            "KOR": "조로아의털",
            "CHS": "索罗亚的毛",
            "CHT": "索羅亞的毛"
        }
    ],
    "Gothita Eyelash": [
        {
            "NO": 1935,
            "EN": "Gothita Eyelash",
            "JP": "ゴチムのまつげ",
            "FR": "Cils de Scrutella",
            "DE": "Mollimorba-Wimper",
            "ES": "Pestaña de Gothita",
            "IT": "Ciglia di Gothita",
            "KOR": "고디탱의속눈썹",
            "CHS": "哥德宝宝的睫毛",
            "CHT": "哥德寶寶的睫毛"
        }
    ],
    "Deerling Hair": [
        {
            "NO": 1936,
            "EN": "Deerling Hair",
            "JP": "シキジカのけ",
            "FR": "Poils de Vivaldaim",
            "DE": "Sesokitz-Haar",
            "ES": "Pelo de Deerling",
            "IT": "Pelo di Deerling",
            "KOR": "사철록의털",
            "CHS": "四季鹿的毛",
            "CHT": "四季鹿的毛"
        }
    ],
    "Foongus Spores": [
        {
            "NO": 1937,
            "EN": "Foongus Spores",
            "JP": "タマゲタケのほうし",
            "FR": "Spores de Trompignon",
            "DE": "Tarnpignon-Spore",
            "ES": "Esporas de Foongus",
            "IT": "Spore di Foongus",
            "KOR": "깜놀버슬의포자",
            "CHS": "哎呀球菇的孢子",
            "CHT": "哎呀球菇的孢子"
        }
    ],
    "Alomomola Mucus": [
        {
            "NO": 1938,
            "EN": "Alomomola Mucus",
            "JP": "ママンボウのねんえき",
            "FR": "Mucus de Mamanbo",
            "DE": "Mamolida-Schleim",
            "ES": "Secreción de Alomomola",
            "IT": "Muco di Alomomola",
            "KOR": "맘복치의점액",
            "CHS": "保姆曼波的黏液",
            "CHT": "保母曼波的黏液"
        }
    ],
    "Tynamo Slime": [
        {
            "NO": 1939,
            "EN": "Tynamo Slime",
            "JP": "シビシラスのねんえき",
            "FR": "Mucus d’Anchwatt",
            "DE": "Zapplardin-Schleim",
            "ES": "Secreción de Tynamo",
            "IT": "Muco di Tynamo",
            "KOR": "저리어의점액",
            "CHS": "麻麻小鱼的黏液",
            "CHT": "麻麻小魚的黏液"
        }
    ],
    "Axew Scales": [
        {
            "NO": 1940,
            "EN": "Axew Scales",
            "JP": "キバゴのウロコ",
            "FR": "Écaille de Coupenotte",
            "DE": "Milza-Schuppe",
            "ES": "Escama de Axew",
            "IT": "Squama di Axew",
            "KOR": "터검니의비늘",
            "CHS": "牙牙的鳞片",
            "CHT": "牙牙的鱗片"
        }
    ],
    "Cubchoo Fur": [
        {
            "NO": 1941,
            "EN": "Cubchoo Fur",
            "JP": "クマシュンのけ",
            "FR": "Poils de Polarhume",
            "DE": "Petznief-Haar",
            "ES": "Pelo de Cubchoo",
            "IT": "Pelo di Cubchoo",
            "KOR": "코고미의털",
            "CHS": "喷嚏熊的毛",
            "CHT": "噴嚏熊的毛"
        }
    ],
    "Cryogonal Ice": [
        {
            "NO": 1942,
            "EN": "Cryogonal Ice",
            "JP": "フリージオのこおり",
            "FR": "Glace d’Hexagel",
            "DE": "Frigometri-Eis",
            "ES": "Hielo de Cryogonal",
            "IT": "Ghiaccio di Cryogonal",
            "KOR": "프리지오의얼음",
            "CHS": "几何雪花的冰",
            "CHT": "幾何雪花的冰"
        }
    ],
    "Pawniard Blade": [
        {
            "NO": 1943,
            "EN": "Pawniard Blade",
            "JP": "コマタナのやいば",
            "FR": "Lame de Scalpion",
            "DE": "Gladiantri-Klinge",
            "ES": "Cuchilla de Pawniard",
            "IT": "Lama di Pawniard",
            "KOR": "자망칼의칼날",
            "CHS": "驹刀小兵的刀",
            "CHT": "駒刀小兵的刀"
        }
    ],
    "Rufflet Feather": [
        {
            "NO": 1944,
            "EN": "Rufflet Feather",
            "JP": "ワシボンのはね",
            "FR": "Plume de Furaiglon",
            "DE": "Geronimatz-Feder",
            "ES": "Pluma de Rufflet",
            "IT": "Penna di Rufflet",
            "KOR": "수리둥보의깃털",
            "CHS": "毛头小鹰的羽毛",
            "CHT": "毛頭小鷹的羽毛"
        }
    ],
    "Deino Scales": [
        {
            "NO": 1945,
            "EN": "Deino Scales",
            "JP": "モノズのウロコ",
            "FR": "Écaille de Solochi",
            "DE": "Kapuno-Schuppe",
            "ES": "Escama de Deino",
            "IT": "Squama di Deino",
            "KOR": "모노두의비늘",
            "CHS": "单首龙的鳞片",
            "CHT": "單首龍的鱗片"
        }
    ],
    "Larvesta Fuzz": [
        {
            "NO": 1946,
            "EN": "Larvesta Fuzz",
            "JP": "メラルバのけ",
            "FR": "Poils de Pyronille",
            "DE": "Ignivor-Haar",
            "ES": "Pelo de Larvesta",
            "IT": "Pelo di Larvesta",
            "KOR": "활화르바의털",
            "CHS": "燃烧虫的毛",
            "CHT": "燃燒蟲的毛"
        }
    ],
    "Fletchling Feather": [
        {
            "NO": 1947,
            "EN": "Fletchling Feather",
            "JP": "ヤヤコマのはね",
            "FR": "Plume de Passerouge",
            "DE": "Dartiri-Feder",
            "ES": "Pluma de Fletchling",
            "IT": "Penna di Fletchling",
            "KOR": "화살꼬빈의깃털",
            "CHS": "小箭雀的羽毛",
            "CHT": "小箭雀的羽毛"
        }
    ],
    "Scatterbug Powder": [
        {
            "NO": 1948,
            "EN": "Scatterbug Powder",
            "JP": "コフキムシのこな",
            "FR": "Poudre de Lépidonille",
            "DE": "Purmel-Puder",
            "ES": "Polvo de Scatterbug",
            "IT": "Polvere di Scatterbug",
            "KOR": "분이벌레의가루",
            "CHS": "粉蝶虫的粉",
            "CHT": "粉蝶蟲的粉"
        }
    ],
    "Litleo Tuft": [
        {
            "NO": 1949,
            "EN": "Litleo Tuft",
            "JP": "シシコのたてがみ",
            "FR": "Crinière d’Hélionceau",
            "DE": "Leufeo-Mähnenhaar",
            "ES": "Mechón de Litleo",
            "IT": "Crine di Litleo",
            "KOR": "레오꼬의갈기",
            "CHS": "小狮狮的鬃毛",
            "CHT": "小獅獅的鬃毛"
        }
    ],
    "Flabébé Pollen": [
        {
            "NO": 1950,
            "EN": "Flabébé Pollen",
            "JP": "フラベベのかふん",
            "FR": "Pollen de Flabébé",
            "DE": "Flabébé-Pollen",
            "ES": "Polen de Flabébé",
            "IT": "Polline di Flabébé",
            "KOR": "플라베베의꽃가루",
            "CHS": "花蓓蓓的花粉",
            "CHT": "花蓓蓓的花粉"
        }
    ],
    "Skiddo Leaf": [
        {
            "NO": 1951,
            "EN": "Skiddo Leaf",
            "JP": "メェークルのはっぱ",
            "FR": "Feuille de Cabriolaine",
            "DE": "Mähikel-Blatt",
            "ES": "Hoja de Skiddo",
            "IT": "Foglia di Skiddo",
            "KOR": "메이클의잎",
            "CHS": "坐骑小羊的叶片",
            "CHT": "坐騎小羊的葉片"
        }
    ],
    "Skrelp Kelp": [
        {
            "NO": 1952,
            "EN": "Skrelp Kelp",
            "JP": "クズモーのもくず",
            "FR": "Algue de Venalgue",
            "DE": "Algitt-Alge",
            "ES": "Alga de Skrelp",
            "IT": "Alga di Skrelp",
            "KOR": "수레기의해초",
            "CHS": "垃垃藻的碎藻",
            "CHT": "垃垃藻的碎藻"
        }
    ],
    "Clauncher Claw": [
        {
            "NO": 1953,
            "EN": "Clauncher Claw",
            "JP": "ウデッポウのハサミ",
            "FR": "Pince de Flingouste",
            "DE": "Scampisto-Schere",
            "ES": "Pinza de Clauncher",
            "IT": "Chela di Clauncher",
            "KOR": "완철포의집게",
            "CHS": "铁臂枪虾的钳子",
            "CHT": "鐵臂槍蝦的鉗子"
        }
    ],
    "Hawlucha Down": [
        {
            "NO": 1954,
            "EN": "Hawlucha Down",
            "JP": "ルチャブルのうもう",
            "FR": "Duvet de Brutalibré",
            "DE": "Resladero-Daune",
            "ES": "Plumón de Hawlucha",
            "IT": "Piuma di Hawlucha",
            "KOR": "루차불의솜털",
            "CHS": "摔角鹰人的羽绒",
            "CHT": "摔角鷹人的羽絨"
        }
    ],
    "Dedenne Fur": [
        {
            "NO": 1955,
            "EN": "Dedenne Fur",
            "JP": "デデンネのけ",
            "FR": "Poils de Dedenne",
            "DE": "Dedenne-Haar",
            "ES": "Pelo de Dedenne",
            "IT": "Pelo di Dedenne",
            "KOR": "데덴네의털",
            "CHS": "咚咚鼠的毛",
            "CHT": "咚咚鼠的毛"
        }
    ],
    "Goomy Goo": [
        {
            "NO": 1956,
            "EN": "Goomy Goo",
            "JP": "ヌメラのねんえき",
            "FR": "Mucus de Mucuscule",
            "DE": "Viscora-Schleim",
            "ES": "Secreción de Goomy",
            "IT": "Bava di Goomy",
            "KOR": "미끄메라의점액",
            "CHS": "黏黏宝的黏液",
            "CHT": "黏黏寶的黏液"
        }
    ],
    "Klefki Key": [
        {
            "NO": 1957,
            "EN": "Klefki Key",
            "JP": "クレッフィのかぎ",
            "FR": "Clé de Trousselin",
            "DE": "Clavion-Schlüssel",
            "ES": "Llave de Klefki",
            "IT": "Chiave di Klefki",
            "KOR": "클레피의열쇠",
            "CHS": "钥圈儿的钥匙",
            "CHT": "鑰圈兒的鑰匙"
        }
    ],
    "Bergmite Ice": [
        {
            "NO": 1958,
            "EN": "Bergmite Ice",
            "JP": "カチコールのこおり",
            "FR": "Glace de Grelaçon",
            "DE": "Arktip-Eis",
            "ES": "Hielo de Bergmite",
            "IT": "Ghiaccio di Bergmite",
            "KOR": "꽁어름의얼음",
            "CHS": "冰宝的冰",
            "CHT": "冰寶的冰"
        }
    ],
    "Noibat Fur": [
        {
            "NO": 1959,
            "EN": "Noibat Fur",
            "JP": "オンバットのけ",
            "FR": "Poils de Sonistrelle",
            "DE": "eF-eM-Haar",
            "ES": "Pelo de Noibat",
            "IT": "Pelo di Noibat",
            "KOR": "음뱃의털",
            "CHS": "嗡蝠的毛",
            "CHT": "嗡蝠的毛"
        }
    ],
    "Yungoos Fur": [
        {
            "NO": 1960,
            "EN": "Yungoos Fur",
            "JP": "ヤングースのけ",
            "FR": "Poils de Manglouton",
            "DE": "Mangunior-Haar",
            "ES": "Pelo de Yungoos",
            "IT": "Pelo di Yungoos",
            "KOR": "영구스의털",
            "CHS": "猫鼬少的毛",
            "CHT": "貓鼬少的毛"
        }
    ],
    "Crabrawler Shell": [
        {
            "NO": 1961,
            "EN": "Crabrawler Shell",
            "JP": "マケンカニのから",
            "FR": "Carapace de Crabagarre",
            "DE": "Krabbox-Schale",
            "ES": "Cáscara de Crabrawler",
            "IT": "Carapace di Crabrawler",
            "KOR": "오기지게의껍데기",
            "CHS": "好胜蟹的壳",
            "CHT": "好勝蟹的殼"
        }
    ],
    "Oricorio Feather": [
        {
            "NO": 1962,
            "EN": "Oricorio Feather",
            "JP": "オドリドリのはね",
            "FR": "Plume de Plumeline",
            "DE": "Choreogel-Feder",
            "ES": "Pluma de Oricorio",
            "IT": "Penna di Oricorio",
            "KOR": "춤추새의깃털",
            "CHS": "花舞鸟的羽毛",
            "CHT": "花舞鳥的羽毛"
        }
    ],
    "Rockruff Rock": [
        {
            "NO": 1963,
            "EN": "Rockruff Rock",
            "JP": "イワンコのいわ",
            "FR": "Roche de Rocabot",
            "DE": "Wuffels-Stein",
            "ES": "Roca de Rockruff",
            "IT": "Roccia di Rockruff",
            "KOR": "암멍이의바위",
            "CHS": "岩狗狗的岩石",
            "CHT": "岩狗狗的岩石"
        }
    ],
    "Mareanie Spike": [
        {
            "NO": 1964,
            "EN": "Mareanie Spike",
            "JP": "ヒドイデのトゲ",
            "FR": "Épine de Vorastérie",
            "DE": "Garstella-Stachel",
            "ES": "Aguijón de Mareanie",
            "IT": "Aculeo di Mareanie",
            "KOR": "시마사리의가시",
            "CHS": "好坏星的刺",
            "CHT": "好壞星的刺"
        }
    ],
    "Mudbray Mud": [
        {
            "NO": 1965,
            "EN": "Mudbray Mud",
            "JP": "ドロバンコのどろ",
            "FR": "Boue de Tiboudet",
            "DE": "Pampuli-Schlamm",
            "ES": "Lodo de Mudbray",
            "IT": "Fango di Mudbray",
            "KOR": "머드나기의진흙",
            "CHS": "泥驴仔的泥巴",
            "CHT": "泥驢仔的泥巴"
        }
    ],
    "Fomantis Leaf": [
        {
            "NO": 1966,
            "EN": "Fomantis Leaf",
            "JP": "カリキリのはっぱ",
            "FR": "Feuille de Mimantis",
            "DE": "Imantis-Blatt",
            "ES": "Hoja de Fomantis",
            "IT": "Foglia di Fomantis",
            "KOR": "짜랑랑의잎",
            "CHS": "伪螳草的叶片",
            "CHT": "偽螳草的葉片"
        }
    ],
    "Salandit Gas": [
        {
            "NO": 1967,
            "EN": "Salandit Gas",
            "JP": "ヤトウモリのガス",
            "FR": "Gaz de Tritox",
            "DE": "Molunk-Gas",
            "ES": "Gas de Salandit",
            "IT": "Gas di Salandit",
            "KOR": "야도뇽의가스",
            "CHS": "夜盗火蜥的气体",
            "CHT": "夜盜火蜥的氣體"
        }
    ],
    "Bounsweet Sweat": [
        {
            "NO": 1968,
            "EN": "Bounsweet Sweat",
            "JP": "アマカジのあせ",
            "FR": "Sueur de Croquine",
            "DE": "Frubberl-Schweiß",
            "ES": "Sudor de Bounsweet",
            "IT": "Sudore di Bounsweet",
            "KOR": "달콤아의땀",
            "CHS": "甜竹竹的汗",
            "CHT": "甜竹竹的汗"
        }
    ],
    "Oranguru Fur": [
        {
            "NO": 1969,
            "EN": "Oranguru Fur",
            "JP": "ヤレユータンのけ",
            "FR": "Poils de Gouroutan",
            "DE": "Kommandutan-Haar",
            "ES": "Pelo de Oranguru",
            "IT": "Pelo di Oranguru",
            "KOR": "하랑우탄의털",
            "CHS": "智挥猩的毛",
            "CHT": "智揮猩的毛"
        }
    ],
    "Passimian Fur": [
        {
            "NO": 1970,
            "EN": "Passimian Fur",
            "JP": "ナゲツケサルのけ",
            "FR": "Poils de Quartermac",
            "DE": "Quartermak-Haar",
            "ES": "Pelo de Passimian",
            "IT": "Pelo di Passimian",
            "KOR": "내던숭이의털",
            "CHS": "投掷猴的毛",
            "CHT": "投擲猴的毛"
        }
    ],
    "Sandygast Sand": [
        {
            "NO": 1971,
            "EN": "Sandygast Sand",
            "JP": "スナバァのすな",
            "FR": "Sable de Bacabouh",
            "DE": "Sankabuh-Sand",
            "ES": "Arena de Sandygast",
            "IT": "Sabbia di Sandygast",
            "KOR": "모래꿍의모래",
            "CHS": "沙丘娃的沙",
            "CHT": "沙丘娃的沙"
        }
    ],
    "Komala Claw": [
        {
            "NO": 1972,
            "EN": "Komala Claw",
            "JP": "ネッコアラのツメ",
            "FR": "Griffe de Dodoala",
            "DE": "Koalelu-Kralle",
            "ES": "Garra de Komala",
            "IT": "Artiglio di Komala",
            "KOR": "자말라의발톱",
            "CHS": "树枕尾熊的爪子",
            "CHT": "樹枕尾熊的爪子"
        }
    ],
    "Mimikyu Scrap": [
        {
            "NO": 1973,
            "EN": "Mimikyu Scrap",
            "JP": "ミミッキュのきれはし",
            "FR": "Tissu de Mimiqui",
            "DE": "Mimigma-Fetzen",
            "ES": "Retal de Mimikyu",
            "IT": "Brandello di Mimikyu",
            "KOR": "따라큐의천조각",
            "CHS": "谜拟丘的残片",
            "CHT": "謎擬Ｑ的殘片"
        }
    ],
    "Bruxish Tooth": [
        {
            "NO": 1974,
            "EN": "Bruxish Tooth",
            "JP": "ハギギシリのは",
            "FR": "Dent de Denticrisse",
            "DE": "Knirfish-Zahn",
            "ES": "Diente de Bruxish",
            "IT": "Dente di Bruxish",
            "KOR": "치갈기의이빨",
            "CHS": "磨牙彩皮鱼的牙齿",
            "CHT": "磨牙彩皮魚的牙齒"
        }
    ],
    "Chewtle Claw": [
        {
            "NO": 1975,
            "EN": "Chewtle Claw",
            "JP": "カムカメのツメ",
            "FR": "Griffe de Khélocrok",
            "DE": "Kamehaps-Kralle",
            "ES": "Garra de Chewtle",
            "IT": "Unghia di Chewtle",
            "KOR": "깨물부기의발톱",
            "CHS": "咬咬龟的爪子",
            "CHT": "咬咬龜的爪子"
        }
    ],
    "Skwovet Fur": [
        {
            "NO": 1976,
            "EN": "Skwovet Fur",
            "JP": "ホシガリスのけ",
            "FR": "Poils de Rongourmand",
            "DE": "Raffel-Haar",
            "ES": "Pelo de Skwovet",
            "IT": "Pelo di Skwovet",
            "KOR": "탐리스의털",
            "CHS": "贪心栗鼠的毛",
            "CHT": "貪心栗鼠的毛"
        }
    ],
    "Arrokuda Scales": [
        {
            "NO": 1977,
            "EN": "Arrokuda Scales",
            "JP": "サシカマスのウロコ",
            "FR": "Écaille d’Embrochet",
            "DE": "Pikuda-Schuppe",
            "ES": "Escama de Arrokuda",
            "IT": "Squama di Arrokuda",
            "KOR": "찌로꼬치의비늘",
            "CHS": "刺梭鱼的鳞片",
            "CHT": "刺梭魚的鱗片"
        }
    ],
    "Rookidee Feather": [
        {
            "NO": 1978,
            "EN": "Rookidee Feather",
            "JP": "ココガラのはね",
            "FR": "Plume de Minisange",
            "DE": "Meikro-Feder",
            "ES": "Pluma de Rookidee",
            "IT": "Penna di Rookidee",
            "KOR": "파라꼬의깃털",
            "CHS": "稚山雀的羽毛",
            "CHT": "稚山雀的羽毛"
        }
    ],
    "Toxel Sparks": [
        {
            "NO": 1979,
            "EN": "Toxel Sparks",
            "JP": "エレズンのでんき",
            "FR": "Électricité de Toxizap",
            "DE": "Toxel-Strom",
            "ES": "Electricidad de Toxel",
            "IT": "Elettricità di Toxel",
            "KOR": "일레즌의전기",
            "CHS": "电音婴的电力",
            "CHT": "毒電嬰的電力"
        }
    ],
    "Falinks Sweat": [
        {
            "NO": 1980,
            "EN": "Falinks Sweat",
            "JP": "タイレーツのあせ",
            "FR": "Sueur d’Hexadron",
            "DE": "Legios-Schweiß",
            "ES": "Sudor de Falinks",
            "IT": "Sudore di Falinks",
            "KOR": "대여르의땀",
            "CHS": "列阵兵的汗",
            "CHT": "列陣兵的汗"
        }
    ],
    "Cufant Tarnish": [
        {
            "NO": 1981,
            "EN": "Cufant Tarnish",
            "JP": "ゾウドウのさび",
            "FR": "Rouille de Charibari",
            "DE": "Kupfanti-Patina",
            "ES": "Óxido de Cufant",
            "IT": "Ruggine di Cufant",
            "KOR": "끼리동의녹",
            "CHS": "铜象的锈",
            "CHT": "銅象的鏽"
        }
    ],
    "Rolycoly Coal": [
        {
            "NO": 1982,
            "EN": "Rolycoly Coal",
            "JP": "タンドンのせきたん",
            "FR": "Charbon de Charbi",
            "DE": "Klonkett-Kohle",
            "ES": "Carbón de Rolycoly",
            "IT": "Carbone di Rolycoly",
            "KOR": "탄동의석탄",
            "CHS": "小炭仔的煤炭",
            "CHT": "小炭仔的煤炭"
        }
    ],
    "Silicobra Sand": [
        {
            "NO": 1983,
            "EN": "Silicobra Sand",
            "JP": "スナヘビのすな",
            "FR": "Sable de Dunaja",
            "DE": "Salanga-Sand",
            "ES": "Arena de Silicobra",
            "IT": "Sabbia di Silicobra",
            "KOR": "모래뱀의모래",
            "CHS": "沙包蛇的沙",
            "CHT": "沙包蛇的沙"
        }
    ],
    "Indeedee Fur": [
        {
            "NO": 1984,
            "EN": "Indeedee Fur",
            "JP": "イエッサンのけ",
            "FR": "Poils de Wimessir",
            "DE": "Servol-Haar",
            "ES": "Pelo de Indeedee",
            "IT": "Pelo di Indeedee",
            "KOR": "에써르의털",
            "CHS": "爱管侍的毛",
            "CHT": "愛管侍的毛"
        }
    ],
    "Pincurchin Spines": [
        {
            "NO": 1985,
            "EN": "Pincurchin Spines",
            "JP": "バチンウニのはり",
            "FR": "Épine de Wattapik",
            "DE": "Britzigel-Stachel",
            "ES": "Púa de Pincurchin",
            "IT": "Aculeo di Pincurchin",
            "KOR": "찌르성게의가시",
            "CHS": "啪嚓海胆的针",
            "CHT": "啪嚓海膽的針"
        }
    ],
    "Snom Thread": [
        {
            "NO": 1986,
            "EN": "Snom Thread",
            "JP": "ユキハミのいと",
            "FR": "Fil de Frissonille",
            "DE": "Snomnom-Faden",
            "ES": "Hilo de Snom",
            "IT": "Filo di Snom",
            "KOR": "누니머기의실",
            "CHS": "雪吞虫的丝",
            "CHT": "雪吞蟲的絲"
        }
    ],
    "Impidimp Hair": [
        {
            "NO": 1987,
            "EN": "Impidimp Hair",
            "JP": "ベロバーのけ",
            "FR": "Poils de Grimalin",
            "DE": "Bähmon-Haar",
            "ES": "Pelo de Impidimp",
            "IT": "Pelo di Impidimp",
            "KOR": "메롱꿍의털",
            "CHS": "捣蛋小妖的毛",
            "CHT": "搗蛋小妖的毛"
        }
    ],
    "Applin Juice": [
        {
            "NO": 1988,
            "EN": "Applin Juice",
            "JP": "カジッチュのかじゅう",
            "FR": "Jus de Verpom",
            "DE": "Knapfel-Fruchtsaft",
            "ES": "Zumo de Applin",
            "IT": "Succo di Applin",
            "KOR": "과사삭벌레의과즙",
            "CHS": "啃果虫的果汁",
            "CHT": "啃果蟲的果汁"
        }
    ],
    "Sinistea Chip": [
        {
            "NO": 1989,
            "EN": "Sinistea Chip",
            "JP": "ヤバチャのかけら",
            "FR": "Fragment de Théffroi",
            "DE": "Fatalitee-Splitter",
            "ES": "Fragmento de Sinistea",
            "IT": "Coccio di Sinistea",
            "KOR": "데인차의조각",
            "CHS": "来悲茶的碎片",
            "CHT": "來悲茶的碎片"
        }
    ],
    "Hatenna Dust": [
        {
            "NO": 1990,
            "EN": "Hatenna Dust",
            "JP": "ミブリムのおとしもの",
            "FR": "Babiole de Bibichut",
            "DE": "Brimova-Material",
            "ES": "Pertenencia de Hatenna",
            "IT": "Oggetto di Hatenna",
            "KOR": "몸지브림의유실물",
            "CHS": "迷布莉姆的掉落物",
            "CHT": "迷布莉姆的掉落物"
        }
    ],
    "Stonjourner Stone": [
        {
            "NO": 1991,
            "EN": "Stonjourner Stone",
            "JP": "イシヘンジンのいわ",
            "FR": "Roche de Dolman",
            "DE": "Humanolith-Stein",
            "ES": "Roca de Stonjourner",
            "IT": "Roccia di Stonjourner",
            "KOR": "돌헨진의바위",
            "CHS": "巨石丁的岩石",
            "CHT": "巨石丁的岩石"
        }
    ],
    "Eiscue Down": [
        {
            "NO": 1992,
            "EN": "Eiscue Down",
            "JP": "コオリッポのうもう",
            "FR": "Duvet de Bekaglaçon",
            "DE": "Kubuin-Daune",
            "ES": "Plumón de Eiscue",
            "IT": "Piuma di Eiscue",
            "KOR": "빙큐보의솜털",
            "CHS": "冰砌鹅的羽绒",
            "CHT": "冰砌鵝的羽絨"
        }
    ],
    "Dreepy Powder": [
        {
            "NO": 1993,
            "EN": "Dreepy Powder",
            "JP": "ドラメシヤのこな",
            "FR": "Poudre de Fantyrm",
            "DE": "Grolldra-Puder",
            "ES": "Polvo de Dreepy",
            "IT": "Polvere di Dreepy",
            "KOR": "드라꼰의가루",
            "CHS": "多龙梅西亚的粉",
            "CHT": "多龍梅西亞的粉"
        }
    ],
    "Lechonk Hair": [
        {
            "NO": 1994,
            "EN": "Lechonk Hair",
            "JP": "グルトンのけ",
            "FR": "Poils de Gourmelet",
            "DE": "Ferkuli-Haar",
            "ES": "Pelo de Lechonk",
            "IT": "Pelo di Lechonk",
            "KOR": "맛보돈의털",
            "CHS": "爱吃豚的毛",
            "CHT": "愛吃豚的毛"
        }
    ],
    "Tarountula Thread": [
        {
            "NO": 1995,
            "EN": "Tarountula Thread",
            "JP": "タマンチュラのいと",
            "FR": "Fil de Tissenboule",
            "DE": "Tarundel-Faden",
            "ES": "Hilo de Tarountula",
            "IT": "Filo di Tarountula",
            "KOR": "타랜툴라의실",
            "CHS": "团珠蛛的丝",
            "CHT": "團珠蛛的絲"
        }
    ],
    "Nymble Claw": [
        {
            "NO": 1996,
            "EN": "Nymble Claw",
            "JP": "マメバッタのツメ",
            "FR": "Griffe de Lilliterelle",
            "DE": "Micrick-Kralle",
            "ES": "Garra de Nymble",
            "IT": "Artiglio di Nymble",
            "KOR": "콩알뚜기의발톱",
            "CHS": "豆蟋蟀的爪子",
            "CHT": "豆蟋蟀的爪子"
        }
    ],
    "Rellor Mud": [
        {
            "NO": 1997,
            "EN": "Rellor Mud",
            "JP": "シガロコのどろ",
            "FR": "Boue de Léboulérou",
            "DE": "Relluk-Schlamm",
            "ES": "Barro de Rellor",
            "IT": "Fango di Rellor",
            "KOR": "구르데의진흙",
            "CHS": "虫滚泥的泥巴",
            "CHT": "蟲滾泥的泥巴"
        }
    ],
    "Greavard Wax": [
        {
            "NO": 1998,
            "EN": "Greavard Wax",
            "JP": "ボチのろう",
            "FR": "Cire de Toutombe",
            "DE": "Gruff-Wachs",
            "ES": "Cera de Greavard",
            "IT": "Cera di Greavard",
            "KOR": "망망이의촛농",
            "CHS": "墓仔狗的蜡",
            "CHT": "墓仔狗的蠟"
        }
    ],
    "Flittle Down": [
        {
            "NO": 1999,
            "EN": "Flittle Down",
            "JP": "ヒラヒナのうもう",
            "FR": "Duvet de Flotillon",
            "DE": "Flattutu-Daune",
            "ES": "Plumón de Flittle",
            "IT": "Piuma di Flittle",
            "KOR": "하느라기의솜털",
            "CHS": "飘飘雏的羽绒",
            "CHT": "飄飄雛的羽絨"
        }
    ],
    "Wiglett Sand": [
        {
            "NO": 2000,
            "EN": "Wiglett Sand",
            "JP": "ウミディグダのすな",
            "FR": "Sable de Taupikeau",
            "DE": "Schligda-Sand",
            "ES": "Arena de Wiglett",
            "IT": "Sabbia di Wiglett",
            "KOR": "바다그다의모래",
            "CHS": "海地鼠的沙",
            "CHT": "海地鼠的沙"
        }
    ],
    "Dondozo Whisker": [
        {
            "NO": 2001,
            "EN": "Dondozo Whisker",
            "JP": "ヘイラッシャのヒゲ",
            "FR": "Barbillon d’Oyacata",
            "DE": "Heerashai-Bartel",
            "ES": "Bigote de Dondozo",
            "IT": "Barbiglio di Dondozo",
            "KOR": "어써러셔의수염",
            "CHS": "吃吼霸的胡须",
            "CHT": "吃吼霸的鬍鬚"
        }
    ],
    "Veluza Fillet": [
        {
            "NO": 2002,
            "EN": "Veluza Fillet",
            "JP": "ミガルーサのきりみ",
            "FR": "Chair de Délestin",
            "DE": "Agiluza-Filet",
            "ES": "Carne de Veluza",
            "IT": "Filetto di Veluza",
            "KOR": "가비루사의토막",
            "CHS": "轻身鳕的鱼片",
            "CHT": "輕身鱈的魚片"
        }
    ],
    "Finizen Mucus": [
        {
            "NO": 2003,
            "EN": "Finizen Mucus",
            "JP": "ナミイルカのねんえき",
            "FR": "Mucus de Dofin",
            "DE": "Normifin-Schleim",
            "ES": "Secreción de Finizen",
            "IT": "Muco di Finizen",
            "KOR": "맨돌핀의점액",
            "CHS": "波普海豚的黏液",
            "CHT": "波普海豚的黏液"
        }
    ],
    "Smoliv Oil": [
        {
            "NO": 2004,
            "EN": "Smoliv Oil",
            "JP": "ミニーブのオイル",
            "FR": "Huile d’Olivini",
            "DE": "Olini-Öl",
            "ES": "Aceite de Smoliv",
            "IT": "Olio di Smoliv",
            "KOR": "미니브의오일",
            "CHS": "迷你芙的油",
            "CHT": "迷你芙的油"
        }
    ],
    "Capsakid Seed": [
        {
            "NO": 2005,
            "EN": "Capsakid Seed",
            "JP": "カプサイジのたね",
            "FR": "Graine de Pimito",
            "DE": "Chilingel-Samen",
            "ES": "Semilla de Capsakid",
            "IT": "Seme di Capsakid",
            "KOR": "캡싸이의씨앗",
            "CHS": "热辣娃的种子",
            "CHT": "熱辣娃的種子"
        }
    ],
    "Tadbulb Mucus": [
        {
            "NO": 2006,
            "EN": "Tadbulb Mucus",
            "JP": "ズピカのねんえき",
            "FR": "Mucus de Têtampoule",
            "DE": "Blipp-Schleim",
            "ES": "Secreción de Tadbulb",
            "IT": "Muco di Tadbulb",
            "KOR": "빈나두의점액",
            "CHS": "光蚪仔的黏液",
            "CHT": "光蚪仔的黏液"
        }
    ],
    "Varoom Fume": [
        {
            "NO": 2007,
            "EN": "Varoom Fume",
            "JP": "ブロロンのガス",
            "FR": "Gaz de Vrombi",
            "DE": "Knattox-Gas",
            "ES": "Gas de Varoom",
            "IT": "Gas di Varoom",
            "KOR": "부르롱의가스",
            "CHS": "噗隆隆的气体",
            "CHT": "噗隆隆的氣體"
        }
    ],
    "Orthworm Tarnish": [
        {
            "NO": 2008,
            "EN": "Orthworm Tarnish",
            "JP": "ミミズズのさび",
            "FR": "Rouille de Ferdeter",
            "DE": "Schlurm-Patina",
            "ES": "Óxido de Orthworm",
            "IT": "Ruggine di Orthworm",
            "KOR": "꿈트렁의녹",
            "CHS": "拖拖蚓的锈",
            "CHT": "拖拖蚓的鏽"
        }
    ],
    "Tandemaus Fur": [
        {
            "NO": 2009,
            "EN": "Tandemaus Fur",
            "JP": "ワッカネズミのけ",
            "FR": "Poils de Compagnol",
            "DE": "Zwieps-Haar",
            "ES": "Pelo de Tandemaus",
            "IT": "Pelo di Tandemaus",
            "KOR": "두리쥐의털",
            "CHS": "一对鼠的毛",
            "CHT": "一對鼠的毛"
        }
    ],
    "Cetoddle Grease": [
        {
            "NO": 2010,
            "EN": "Cetoddle Grease",
            "JP": "アルクジラのあぶら",
            "FR": "Graisse de Piétacé",
            "DE": "Flaniwal-Fett",
            "ES": "Grasa de Cetoddle",
            "IT": "Grasso di Cetoddle",
            "KOR": "터벅고래의기름",
            "CHS": "走鲸的油脂",
            "CHT": "走鯨的油脂"
        }
    ],
    "Frigibax Scales": [
        {
            "NO": 2011,
            "EN": "Frigibax Scales",
            "JP": "セビエのウロコ",
            "FR": "Écaille de Frigodo",
            "DE": "Frospino-Schuppe",
            "ES": "Escama de Frigibax",
            "IT": "Squama di Frigibax",
            "KOR": "드니차의비늘",
            "CHS": "凉脊龙的鳞片",
            "CHT": "涼脊龍的鱗片"
        }
    ],
    "Tatsugiri Scales": [
        {
            "NO": 2012,
            "EN": "Tatsugiri Scales",
            "JP": "シャリタツのウロコ",
            "FR": "Écaille de Nigirigon",
            "DE": "Nigiragi-Schuppe",
            "ES": "Escama de Tatsugiri",
            "IT": "Squama di Tatsugiri",
            "KOR": "싸리용의비늘",
            "CHS": "米立龙的鳞片",
            "CHT": "米立龍的鱗片"
        }
    ],
    "Cyclizar Scales": [
        {
            "NO": 2013,
            "EN": "Cyclizar Scales",
            "JP": "モトトカゲのウロコ",
            "FR": "Écaille de Motorizard",
            "DE": "Mopex-Schuppe",
            "ES": "Escama de Cyclizar",
            "IT": "Squama di Cyclizar",
            "KOR": "모토마의비늘",
            "CHS": "摩托蜥的鳞片",
            "CHT": "摩托蜥的鱗片"
        }
    ],
    "Pawmi Fur": [
        {
            "NO": 2014,
            "EN": "Pawmi Fur",
            "JP": "パモのけ",
            "FR": "Poils de Pohm",
            "DE": "Pamo-Haar",
            "ES": "Pelo de Pawmi",
            "IT": "Pelo di Pawmi",
            "KOR": "빠모의털",
            "CHS": "布拨的毛",
            "CHT": "布撥的毛"
        }
    ],
    "Wattrel Feather": [
        {
            "NO": 2015,
            "EN": "Wattrel Feather",
            "JP": "カイデンのはね",
            "FR": "Plume de Zapétrel",
            "DE": "Voltrel-Feder",
            "ES": "Pluma de Wattrel",
            "IT": "Penna di Wattrel",
            "KOR": "찌리비의깃털",
            "CHS": "电海燕的羽毛",
            "CHT": "電海燕的羽毛"
        }
    ],
    "Bombirdier Feather": [
        {
            "NO": 2016,
            "EN": "Bombirdier Feather",
            "JP": "オトシドリのはね",
            "FR": "Plume de Lestombaile",
            "DE": "Adebom-Feder",
            "ES": "Pluma de Bombirdier",
            "IT": "Penna di Bombirdier",
            "KOR": "떨구새의깃털",
            "CHS": "下石鸟的羽毛",
            "CHT": "下石鳥的羽毛"
        }
    ],
    "Squawkabilly Feather": [
        {
            "NO": 2017,
            "EN": "Squawkabilly Feather",
            "JP": "イキリンコのはね",
            "FR": "Plume de Tapatoès",
            "DE": "Krawalloro-Feder",
            "ES": "Pluma de Squawkabilly",
            "IT": "Penna di Squawkabilly",
            "KOR": "시비꼬의깃털",
            "CHS": "怒鹦哥的羽毛",
            "CHT": "怒鸚哥的羽毛"
        }
    ],
    "Flamigo Down": [
        {
            "NO": 2018,
            "EN": "Flamigo Down",
            "JP": "カラミンゴのうもう",
            "FR": "Duvet de Flamenroule",
            "DE": "Flaminkno-Daune",
            "ES": "Plumón de Flamigo",
            "IT": "Piuma di Flamigo",
            "KOR": "꼬이밍고의솜털",
            "CHS": "缠红鹤的羽绒",
            "CHT": "纏紅鶴的羽絨"
        }
    ],
    "Klawf Claw": [
        {
            "NO": 2019,
            "EN": "Klawf Claw",
            "JP": "ガケガニのハサミ",
            "FR": "Pince de Craparoi",
            "DE": "Klibbe-Schere",
            "ES": "Pinza de Klawf",
            "IT": "Chela di Klawf",
            "KOR": "절벼게의집게",
            "CHS": "毛崖蟹的钳子",
            "CHT": "毛崖蟹的鉗子"
        }
    ],
    "Nacli Salt": [
        {
            "NO": 2020,
            "EN": "Nacli Salt",
            "JP": "コジオのしお",
            "FR": "Sel de Selutin",
            "DE": "Geosali-Salz",
            "ES": "Sal de Nacli",
            "IT": "Sale di Nacli",
            "KOR": "베베솔트의소금",
            "CHS": "盐石宝的盐",
            "CHT": "鹽石寶的鹽"
        }
    ],
    "Glimmet Crystal": [
        {
            "NO": 2021,
            "EN": "Glimmet Crystal",
            "JP": "キラーメのけっしょう",
            "FR": "Cristal de Germéclat",
            "DE": "Lumispross-Kristall",
            "ES": "Cristal de Glimmet",
            "IT": "Cristallo di Glimmet",
            "KOR": "초롱순의결정",
            "CHS": "晶光芽的结晶",
            "CHT": "晶光芽的結晶"
        }
    ],
    "Shroodle Ink": [
        {
            "NO": 2022,
            "EN": "Shroodle Ink",
            "JP": "シルシュルーのインク",
            "FR": "Encre de Gribouraigne",
            "DE": "Sproxi-Tinte",
            "ES": "Tinta de Shroodle",
            "IT": "Inchiostro di Shroodle",
            "KOR": "땃쭈르의잉크",
            "CHS": "滋汁鼹的墨汁",
            "CHT": "滋汁鼴的墨汁"
        }
    ],
    "Fidough Fur": [
        {
            "NO": 2023,
            "EN": "Fidough Fur",
            "JP": "パピモッチのけ",
            "FR": "Poils de Pâtachiot",
            "DE": "Hefel-Haar",
            "ES": "Pelo de Fidough",
            "IT": "Pelo di Fidough",
            "KOR": "쫀도기의털",
            "CHS": "狗仔包的毛",
            "CHT": "狗仔包的毛"
        }
    ],
    "Maschiff Fang": [
        {
            "NO": 2024,
            "EN": "Maschiff Fang",
            "JP": "オラチフのキバ",
            "FR": "Croc de Grondogue",
            "DE": "Mobtiff-Zahn",
            "ES": "Colmillo de Maschiff",
            "IT": "Zanna di Maschiff",
            "KOR": "오라티프의이빨",
            "CHS": "偶叫獒的牙",
            "CHT": "偶叫獒的牙"
        }
    ],
    "Bramblin Twig": [
        {
            "NO": 2025,
            "EN": "Bramblin Twig",
            "JP": "アノクサのえだ",
            "FR": "Branche de Virovent",
            "DE": "Weherba-Zweig",
            "ES": "Rama de Bramblin",
            "IT": "Ramoscello di Bramblin",
            "KOR": "그푸리의가지",
            "CHS": "纳噬草的枝条",
            "CHT": "納噬草的枝條"
        }
    ],
    "Gimmighoul Coin": [
        {
            "NO": 2026,
            "EN": "Gimmighoul Coin",
            "JP": "コレクレーのコイン",
            "FR": "Pièce de Mordudor",
            "DE": "Gierspenst-Münze",
            "ES": "Moneda de Gimmighoul",
            "IT": "Moneta di Gimmighoul",
            "KOR": "모으령의코인",
            "CHS": "索财灵的硬币",
            "CHT": "索財靈的硬幣"
        }
    ],
    "Tinkatink Hair": [
        {
            "NO": 2027,
            "EN": "Tinkatink Hair",
            "JP": "カヌチャンのけ",
            "FR": "Poils de Forgerette",
            "DE": "Forgita-Haar",
            "ES": "Pelo de Tinkatink",
            "IT": "Pelo di Tinkatink",
            "KOR": "어리짱의털",
            "CHS": "小锻匠的毛",
            "CHT": "小鍛匠的毛"
        }
    ],
    "Charcadet Soot": [
        {
            "NO": 2028,
            "EN": "Charcadet Soot",
            "JP": "カルボウのすす",
            "FR": "Suie de Charbambin",
            "DE": "Knarbon-Ruß",
            "ES": "Hollín de Charcadet",
            "IT": "Fuliggine di Charcadet",
            "KOR": "카르본의검댕",
            "CHS": "炭小侍的煤灰",
            "CHT": "炭小侍的煤灰"
        }
    ],
    "Toedscool Flaps": [
        {
            "NO": 2029,
            "EN": "Toedscool Flaps",
            "JP": "ノノクラゲのヒラヒラ",
            "FR": "Membrane de Terracool",
            "DE": "Tentagra-Lamelle",
            "ES": "Pliegue de Toedscool",
            "IT": "Pieghe di Toedscool",
            "KOR": "들눈해의갓",
            "CHS": "原野水母的薄片",
            "CHT": "原野水母的薄片"
        }
    ],
    "Wooper Slime": [
        {
            "NO": 2030,
            "EN": "Wooper Slime",
            "JP": "ウパーのねんえき",
            "FR": "Mucus d’Axoloto",
            "DE": "Felino-Schleim",
            "ES": "Secreción de Wooper",
            "IT": "Muco di Wooper",
            "KOR": "우파의점액",
            "CHS": "乌波的黏液",
            "CHT": "烏波的黏液"
        }
    ],
    "TM101": [
        {
            "NO": 2032,
            "EN": "TM101",
            "JP": "わざマシン１０１",
            "FR": "CT101",
            "DE": "TM101",
            "ES": "MT101",
            "IT": "MT101",
            "KOR": "기술머신101",
            "CHS": "招式学习器１０１",
            "CHT": "招式學習器１０１"
        }
    ],
    "TM102": [
        {
            "NO": 2033,
            "EN": "TM102",
            "JP": "わざマシン１０２",
            "FR": "CT102",
            "DE": "TM102",
            "ES": "MT102",
            "IT": "MT102",
            "KOR": "기술머신102",
            "CHS": "招式学习器１０２",
            "CHT": "招式學習器１０２"
        }
    ],
    "TM103": [
        {
            "NO": 2034,
            "EN": "TM103",
            "JP": "わざマシン１０３",
            "FR": "CT103",
            "DE": "TM103",
            "ES": "MT103",
            "IT": "MT103",
            "KOR": "기술머신103",
            "CHS": "招式学习器１０３",
            "CHT": "招式學習器１０３"
        }
    ],
    "TM104": [
        {
            "NO": 2035,
            "EN": "TM104",
            "JP": "わざマシン１０４",
            "FR": "CT104",
            "DE": "TM104",
            "ES": "MT104",
            "IT": "MT104",
            "KOR": "기술머신104",
            "CHS": "招式学习器１０４",
            "CHT": "招式學習器１０４"
        }
    ],
    "TM105": [
        {
            "NO": 2036,
            "EN": "TM105",
            "JP": "わざマシン１０５",
            "FR": "CT105",
            "DE": "TM105",
            "ES": "MT105",
            "IT": "MT105",
            "KOR": "기술머신105",
            "CHS": "招式学习器１０５",
            "CHT": "招式學習器１０５"
        }
    ],
    "TM106": [
        {
            "NO": 2037,
            "EN": "TM106",
            "JP": "わざマシン１０６",
            "FR": "CT106",
            "DE": "TM106",
            "ES": "MT106",
            "IT": "MT106",
            "KOR": "기술머신106",
            "CHS": "招式学习器１０６",
            "CHT": "招式學習器１０６"
        }
    ],
    "TM107": [
        {
            "NO": 2038,
            "EN": "TM107",
            "JP": "わざマシン１０７",
            "FR": "CT107",
            "DE": "TM107",
            "ES": "MT107",
            "IT": "MT107",
            "KOR": "기술머신107",
            "CHS": "招式学习器１０７",
            "CHT": "招式學習器１０７"
        }
    ],
    "TM108": [
        {
            "NO": 2039,
            "EN": "TM108",
            "JP": "わざマシン１０８",
            "FR": "CT108",
            "DE": "TM108",
            "ES": "MT108",
            "IT": "MT108",
            "KOR": "기술머신108",
            "CHS": "招式学习器１０８",
            "CHT": "招式學習器１０８"
        }
    ],
    "TM109": [
        {
            "NO": 2040,
            "EN": "TM109",
            "JP": "わざマシン１０９",
            "FR": "CT109",
            "DE": "TM109",
            "ES": "MT109",
            "IT": "MT109",
            "KOR": "기술머신109",
            "CHS": "招式学习器１０９",
            "CHT": "招式學習器１０９"
        }
    ],
    "TM110": [
        {
            "NO": 2041,
            "EN": "TM110",
            "JP": "わざマシン１１０",
            "FR": "CT110",
            "DE": "TM110",
            "ES": "MT110",
            "IT": "MT110",
            "KOR": "기술머신110",
            "CHS": "招式学习器１１０",
            "CHT": "招式學習器１１０"
        }
    ],
    "TM111": [
        {
            "NO": 2042,
            "EN": "TM111",
            "JP": "わざマシン１１１",
            "FR": "CT111",
            "DE": "TM111",
            "ES": "MT111",
            "IT": "MT111",
            "KOR": "기술머신111",
            "CHS": "招式学习器１１１",
            "CHT": "招式學習器１１１"
        }
    ],
    "TM112": [
        {
            "NO": 2043,
            "EN": "TM112",
            "JP": "わざマシン１１２",
            "FR": "CT112",
            "DE": "TM112",
            "ES": "MT112",
            "IT": "MT112",
            "KOR": "기술머신112",
            "CHS": "招式学习器１１２",
            "CHT": "招式學習器１１２"
        }
    ],
    "TM113": [
        {
            "NO": 2044,
            "EN": "TM113",
            "JP": "わざマシン１１３",
            "FR": "CT113",
            "DE": "TM113",
            "ES": "MT113",
            "IT": "MT113",
            "KOR": "기술머신113",
            "CHS": "招式学习器１１３",
            "CHT": "招式學習器１１３"
        }
    ],
    "TM114": [
        {
            "NO": 2045,
            "EN": "TM114",
            "JP": "わざマシン１１４",
            "FR": "CT114",
            "DE": "TM114",
            "ES": "MT114",
            "IT": "MT114",
            "KOR": "기술머신114",
            "CHS": "招式学习器１１４",
            "CHT": "招式學習器１１４"
        }
    ],
    "TM115": [
        {
            "NO": 2046,
            "EN": "TM115",
            "JP": "わざマシン１１５",
            "FR": "CT115",
            "DE": "TM115",
            "ES": "MT115",
            "IT": "MT115",
            "KOR": "기술머신115",
            "CHS": "招式学习器１１５",
            "CHT": "招式學習器１１５"
        }
    ],
    "TM116": [
        {
            "NO": 2047,
            "EN": "TM116",
            "JP": "わざマシン１１６",
            "FR": "CT116",
            "DE": "TM116",
            "ES": "MT116",
            "IT": "MT116",
            "KOR": "기술머신116",
            "CHS": "招式学习器１１６",
            "CHT": "招式學習器１１６"
        }
    ],
    "TM117": [
        {
            "NO": 2048,
            "EN": "TM117",
            "JP": "わざマシン１１７",
            "FR": "CT117",
            "DE": "TM117",
            "ES": "MT117",
            "IT": "MT117",
            "KOR": "기술머신117",
            "CHS": "招式学习器１１７",
            "CHT": "招式學習器１１７"
        }
    ],
    "TM118": [
        {
            "NO": 2049,
            "EN": "TM118",
            "JP": "わざマシン１１８",
            "FR": "CT118",
            "DE": "TM118",
            "ES": "MT118",
            "IT": "MT118",
            "KOR": "기술머신118",
            "CHS": "招式学习器１１８",
            "CHT": "招式學習器１１８"
        }
    ],
    "TM119": [
        {
            "NO": 2050,
            "EN": "TM119",
            "JP": "わざマシン１１９",
            "FR": "CT119",
            "DE": "TM119",
            "ES": "MT119",
            "IT": "MT119",
            "KOR": "기술머신119",
            "CHS": "招式学习器１１９",
            "CHT": "招式學習器１１９"
        }
    ],
    "TM120": [
        {
            "NO": 2051,
            "EN": "TM120",
            "JP": "わざマシン１２０",
            "FR": "CT120",
            "DE": "TM120",
            "ES": "MT120",
            "IT": "MT120",
            "KOR": "기술머신120",
            "CHS": "招式学习器１２０",
            "CHT": "招式學習器１２０"
        }
    ],
    "TM121": [
        {
            "NO": 2052,
            "EN": "TM121",
            "JP": "わざマシン１２１",
            "FR": "CT121",
            "DE": "TM121",
            "ES": "MT121",
            "IT": "MT121",
            "KOR": "기술머신121",
            "CHS": "招式学习器１２１",
            "CHT": "招式學習器１２１"
        }
    ],
    "TM122": [
        {
            "NO": 2053,
            "EN": "TM122",
            "JP": "わざマシン１２２",
            "FR": "CT122",
            "DE": "TM122",
            "ES": "MT122",
            "IT": "MT122",
            "KOR": "기술머신122",
            "CHS": "招式学习器１２２",
            "CHT": "招式學習器１２２"
        }
    ],
    "TM123": [
        {
            "NO": 2054,
            "EN": "TM123",
            "JP": "わざマシン１２３",
            "FR": "CT123",
            "DE": "TM123",
            "ES": "MT123",
            "IT": "MT123",
            "KOR": "기술머신123",
            "CHS": "招式学习器１２３",
            "CHT": "招式學習器１２３"
        }
    ],
    "TM124": [
        {
            "NO": 2055,
            "EN": "TM124",
            "JP": "わざマシン１２４",
            "FR": "CT124",
            "DE": "TM124",
            "ES": "MT124",
            "IT": "MT124",
            "KOR": "기술머신124",
            "CHS": "招式学习器１２４",
            "CHT": "招式學習器１２４"
        }
    ],
    "TM125": [
        {
            "NO": 2056,
            "EN": "TM125",
            "JP": "わざマシン１２５",
            "FR": "CT125",
            "DE": "TM125",
            "ES": "MT125",
            "IT": "MT125",
            "KOR": "기술머신125",
            "CHS": "招式学习器１２５",
            "CHT": "招式學習器１２５"
        }
    ],
    "TM126": [
        {
            "NO": 2057,
            "EN": "TM126",
            "JP": "わざマシン１２６",
            "FR": "CT126",
            "DE": "TM126",
            "ES": "MT126",
            "IT": "MT126",
            "KOR": "기술머신126",
            "CHS": "招式学习器１２６",
            "CHT": "招式學習器１２６"
        }
    ],
    "TM127": [
        {
            "NO": 2058,
            "EN": "TM127",
            "JP": "わざマシン１２７",
            "FR": "CT127",
            "DE": "TM127",
            "ES": "MT127",
            "IT": "MT127",
            "KOR": "기술머신127",
            "CHS": "招式学习器１２７",
            "CHT": "招式學習器１２７"
        }
    ],
    "TM128": [
        {
            "NO": 2059,
            "EN": "TM128",
            "JP": "わざマシン１２８",
            "FR": "CT128",
            "DE": "TM128",
            "ES": "MT128",
            "IT": "MT128",
            "KOR": "기술머신128",
            "CHS": "招式学习器１２８",
            "CHT": "招式學習器１２８"
        }
    ],
    "TM129": [
        {
            "NO": 2060,
            "EN": "TM129",
            "JP": "わざマシン１２９",
            "FR": "CT129",
            "DE": "TM129",
            "ES": "MT129",
            "IT": "MT129",
            "KOR": "기술머신129",
            "CHS": "招式学习器１２９",
            "CHT": "招式學習器１２９"
        }
    ],
    "TM130": [
        {
            "NO": 2061,
            "EN": "TM130",
            "JP": "わざマシン１３０",
            "FR": "CT130",
            "DE": "TM130",
            "ES": "MT130",
            "IT": "MT130",
            "KOR": "기술머신130",
            "CHS": "招式学习器１３０",
            "CHT": "招式學習器１３０"
        }
    ],
    "TM131": [
        {
            "NO": 2062,
            "EN": "TM131",
            "JP": "わざマシン１３１",
            "FR": "CT131",
            "DE": "TM131",
            "ES": "MT131",
            "IT": "MT131",
            "KOR": "기술머신131",
            "CHS": "招式学习器１３１",
            "CHT": "招式學習器１３１"
        }
    ],
    "TM132": [
        {
            "NO": 2063,
            "EN": "TM132",
            "JP": "わざマシン１３２",
            "FR": "CT132",
            "DE": "TM132",
            "ES": "MT132",
            "IT": "MT132",
            "KOR": "기술머신132",
            "CHS": "招式学习器１３２",
            "CHT": "招式學習器１３２"
        }
    ],
    "TM133": [
        {
            "NO": 2064,
            "EN": "TM133",
            "JP": "わざマシン１３３",
            "FR": "CT133",
            "DE": "TM133",
            "ES": "MT133",
            "IT": "MT133",
            "KOR": "기술머신133",
            "CHS": "招式学习器１３３",
            "CHT": "招式學習器１３３"
        }
    ],
    "TM134": [
        {
            "NO": 2065,
            "EN": "TM134",
            "JP": "わざマシン１３４",
            "FR": "CT134",
            "DE": "TM134",
            "ES": "MT134",
            "IT": "MT134",
            "KOR": "기술머신134",
            "CHS": "招式学习器１３４",
            "CHT": "招式學習器１３４"
        }
    ],
    "TM135": [
        {
            "NO": 2066,
            "EN": "TM135",
            "JP": "わざマシン１３５",
            "FR": "CT135",
            "DE": "TM135",
            "ES": "MT135",
            "IT": "MT135",
            "KOR": "기술머신135",
            "CHS": "招式学习器１３５",
            "CHT": "招式學習器１３５"
        }
    ],
    "TM136": [
        {
            "NO": 2067,
            "EN": "TM136",
            "JP": "わざマシン１３６",
            "FR": "CT136",
            "DE": "TM136",
            "ES": "MT136",
            "IT": "MT136",
            "KOR": "기술머신136",
            "CHS": "招式学习器１３６",
            "CHT": "招式學習器１３６"
        }
    ],
    "TM137": [
        {
            "NO": 2068,
            "EN": "TM137",
            "JP": "わざマシン１３７",
            "FR": "CT137",
            "DE": "TM137",
            "ES": "MT137",
            "IT": "MT137",
            "KOR": "기술머신137",
            "CHS": "招式学习器１３７",
            "CHT": "招式學習器１３７"
        }
    ],
    "TM138": [
        {
            "NO": 2069,
            "EN": "TM138",
            "JP": "わざマシン１３８",
            "FR": "CT138",
            "DE": "TM138",
            "ES": "MT138",
            "IT": "MT138",
            "KOR": "기술머신138",
            "CHS": "招式学习器１３８",
            "CHT": "招式學習器１３８"
        }
    ],
    "TM139": [
        {
            "NO": 2070,
            "EN": "TM139",
            "JP": "わざマシン１３９",
            "FR": "CT139",
            "DE": "TM139",
            "ES": "MT139",
            "IT": "MT139",
            "KOR": "기술머신139",
            "CHS": "招式学习器１３９",
            "CHT": "招式學習器１３９"
        }
    ],
    "TM140": [
        {
            "NO": 2071,
            "EN": "TM140",
            "JP": "わざマシン１４０",
            "FR": "CT140",
            "DE": "TM140",
            "ES": "MT140",
            "IT": "MT140",
            "KOR": "기술머신140",
            "CHS": "招式学习器１４０",
            "CHT": "招式學習器１４０"
        }
    ],
    "TM141": [
        {
            "NO": 2072,
            "EN": "TM141",
            "JP": "わざマシン１４１",
            "FR": "CT141",
            "DE": "TM141",
            "ES": "MT141",
            "IT": "MT141",
            "KOR": "기술머신141",
            "CHS": "招式学习器１４１",
            "CHT": "招式學習器１４１"
        }
    ],
    "TM142": [
        {
            "NO": 2073,
            "EN": "TM142",
            "JP": "わざマシン１４２",
            "FR": "CT142",
            "DE": "TM142",
            "ES": "MT142",
            "IT": "MT142",
            "KOR": "기술머신142",
            "CHS": "招式学习器１４２",
            "CHT": "招式學習器１４２"
        }
    ],
    "TM143": [
        {
            "NO": 2074,
            "EN": "TM143",
            "JP": "わざマシン１４３",
            "FR": "CT143",
            "DE": "TM143",
            "ES": "MT143",
            "IT": "MT143",
            "KOR": "기술머신143",
            "CHS": "招式学习器１４３",
            "CHT": "招式學習器１４３"
        }
    ],
    "TM144": [
        {
            "NO": 2075,
            "EN": "TM144",
            "JP": "わざマシン１４４",
            "FR": "CT144",
            "DE": "TM144",
            "ES": "MT144",
            "IT": "MT144",
            "KOR": "기술머신144",
            "CHS": "招式学习器１４４",
            "CHT": "招式學習器１４４"
        }
    ],
    "TM145": [
        {
            "NO": 2076,
            "EN": "TM145",
            "JP": "わざマシン１４５",
            "FR": "CT145",
            "DE": "TM145",
            "ES": "MT145",
            "IT": "MT145",
            "KOR": "기술머신145",
            "CHS": "招式学习器１４５",
            "CHT": "招式學習器１４５"
        }
    ],
    "TM146": [
        {
            "NO": 2077,
            "EN": "TM146",
            "JP": "わざマシン１４６",
            "FR": "CT146",
            "DE": "TM146",
            "ES": "MT146",
            "IT": "MT146",
            "KOR": "기술머신146",
            "CHS": "招式学习器１４６",
            "CHT": "招式學習器１４６"
        }
    ],
    "TM147": [
        {
            "NO": 2078,
            "EN": "TM147",
            "JP": "わざマシン１４７",
            "FR": "CT147",
            "DE": "TM147",
            "ES": "MT147",
            "IT": "MT147",
            "KOR": "기술머신147",
            "CHS": "招式学习器１４７",
            "CHT": "招式學習器１４７"
        }
    ],
    "TM148": [
        {
            "NO": 2079,
            "EN": "TM148",
            "JP": "わざマシン１４８",
            "FR": "CT148",
            "DE": "TM148",
            "ES": "MT148",
            "IT": "MT148",
            "KOR": "기술머신148",
            "CHS": "招式学习器１４８",
            "CHT": "招式學習器１４８"
        }
    ],
    "TM149": [
        {
            "NO": 2080,
            "EN": "TM149",
            "JP": "わざマシン１４９",
            "FR": "CT149",
            "DE": "TM149",
            "ES": "MT149",
            "IT": "MT149",
            "KOR": "기술머신149",
            "CHS": "招式学习器１４９",
            "CHT": "招式學習器１４９"
        }
    ],
    "TM150": [
        {
            "NO": 2081,
            "EN": "TM150",
            "JP": "わざマシン１５０",
            "FR": "CT150",
            "DE": "TM150",
            "ES": "MT150",
            "IT": "MT150",
            "KOR": "기술머신150",
            "CHS": "招式学习器１５０",
            "CHT": "招式學習器１５０"
        }
    ],
    "TM151": [
        {
            "NO": 2082,
            "EN": "TM151",
            "JP": "わざマシン１５１",
            "FR": "CT151",
            "DE": "TM151",
            "ES": "MT151",
            "IT": "MT151",
            "KOR": "기술머신151",
            "CHS": "招式学习器１５１",
            "CHT": "招式學習器１５１"
        }
    ],
    "TM152": [
        {
            "NO": 2083,
            "EN": "TM152",
            "JP": "わざマシン１５２",
            "FR": "CT152",
            "DE": "TM152",
            "ES": "MT152",
            "IT": "MT152",
            "KOR": "기술머신152",
            "CHS": "招式学习器１５２",
            "CHT": "招式學習器１５２"
        }
    ],
    "TM153": [
        {
            "NO": 2084,
            "EN": "TM153",
            "JP": "わざマシン１５３",
            "FR": "CT153",
            "DE": "TM153",
            "ES": "MT153",
            "IT": "MT153",
            "KOR": "기술머신153",
            "CHS": "招式学习器１５３",
            "CHT": "招式學習器１５３"
        }
    ],
    "TM154": [
        {
            "NO": 2085,
            "EN": "TM154",
            "JP": "わざマシン１５４",
            "FR": "CT154",
            "DE": "TM154",
            "ES": "MT154",
            "IT": "MT154",
            "KOR": "기술머신154",
            "CHS": "招式学习器１５４",
            "CHT": "招式學習器１５４"
        }
    ],
    "TM155": [
        {
            "NO": 2086,
            "EN": "TM155",
            "JP": "わざマシン１５５",
            "FR": "CT155",
            "DE": "TM155",
            "ES": "MT155",
            "IT": "MT155",
            "KOR": "기술머신155",
            "CHS": "招式学习器１５５",
            "CHT": "招式學習器１５５"
        }
    ],
    "TM156": [
        {
            "NO": 2087,
            "EN": "TM156",
            "JP": "わざマシン１５６",
            "FR": "CT156",
            "DE": "TM156",
            "ES": "MT156",
            "IT": "MT156",
            "KOR": "기술머신156",
            "CHS": "招式学习器１５６",
            "CHT": "招式學習器１５６"
        }
    ],
    "TM157": [
        {
            "NO": 2088,
            "EN": "TM157",
            "JP": "わざマシン１５７",
            "FR": "CT157",
            "DE": "TM157",
            "ES": "MT157",
            "IT": "MT157",
            "KOR": "기술머신157",
            "CHS": "招式学习器１５７",
            "CHT": "招式學習器１５７"
        }
    ],
    "TM158": [
        {
            "NO": 2089,
            "EN": "TM158",
            "JP": "わざマシン１５８",
            "FR": "CT158",
            "DE": "TM158",
            "ES": "MT158",
            "IT": "MT158",
            "KOR": "기술머신158",
            "CHS": "招式学习器１５８",
            "CHT": "招式學習器１５８"
        }
    ],
    "TM159": [
        {
            "NO": 2090,
            "EN": "TM159",
            "JP": "わざマシン１５９",
            "FR": "CT159",
            "DE": "TM159",
            "ES": "MT159",
            "IT": "MT159",
            "KOR": "기술머신159",
            "CHS": "招式学习器１５９",
            "CHT": "招式學習器１５９"
        }
    ],
    "TM160": [
        {
            "NO": 2091,
            "EN": "TM160",
            "JP": "わざマシン１６０",
            "FR": "CT160",
            "DE": "TM160",
            "ES": "MT160",
            "IT": "MT160",
            "KOR": "기술머신160",
            "CHS": "招式学习器１６０",
            "CHT": "招式學習器１６０"
        }
    ],
    "TM161": [
        {
            "NO": 2092,
            "EN": "TM161",
            "JP": "わざマシン１６１",
            "FR": "CT161",
            "DE": "TM161",
            "ES": "MT161",
            "IT": "MT161",
            "KOR": "기술머신161",
            "CHS": "招式学习器１６１",
            "CHT": "招式學習器１６１"
        }
    ],
    "TM162": [
        {
            "NO": 2093,
            "EN": "TM162",
            "JP": "わざマシン１６２",
            "FR": "CT162",
            "DE": "TM162",
            "ES": "MT162",
            "IT": "MT162",
            "KOR": "기술머신162",
            "CHS": "招式学习器１６２",
            "CHT": "招式學習器１６２"
        }
    ],
    "TM163": [
        {
            "NO": 2094,
            "EN": "TM163",
            "JP": "わざマシン１６３",
            "FR": "CT163",
            "DE": "TM163",
            "ES": "MT163",
            "IT": "MT163",
            "KOR": "기술머신163",
            "CHS": "招式学习器１６３",
            "CHT": "招式學習器１６３"
        }
    ],
    "TM164": [
        {
            "NO": 2095,
            "EN": "TM164",
            "JP": "わざマシン１６４",
            "FR": "CT164",
            "DE": "TM164",
            "ES": "MT164",
            "IT": "MT164",
            "KOR": "기술머신164",
            "CHS": "招式学习器１６４",
            "CHT": "招式學習器１６４"
        }
    ],
    "TM165": [
        {
            "NO": 2096,
            "EN": "TM165",
            "JP": "わざマシン１６５",
            "FR": "CT165",
            "DE": "TM165",
            "ES": "MT165",
            "IT": "MT165",
            "KOR": "기술머신165",
            "CHS": "招式学习器１６５",
            "CHT": "招式學習器１６５"
        }
    ],
    "TM166": [
        {
            "NO": 2097,
            "EN": "TM166",
            "JP": "わざマシン１６６",
            "FR": "CT166",
            "DE": "TM166",
            "ES": "MT166",
            "IT": "MT166",
            "KOR": "기술머신166",
            "CHS": "招式学习器１６６",
            "CHT": "招式學習器１６６"
        }
    ],
    "TM167": [
        {
            "NO": 2098,
            "EN": "TM167",
            "JP": "わざマシン１６７",
            "FR": "CT167",
            "DE": "TM167",
            "ES": "MT167",
            "IT": "MT167",
            "KOR": "기술머신167",
            "CHS": "招式学习器１６７",
            "CHT": "招式學習器１６７"
        }
    ],
    "TM168": [
        {
            "NO": 2099,
            "EN": "TM168",
            "JP": "わざマシン１６８",
            "FR": "CT168",
            "DE": "TM168",
            "ES": "MT168",
            "IT": "MT168",
            "KOR": "기술머신168",
            "CHS": "招式学习器１６８",
            "CHT": "招式學習器１６８"
        }
    ],
    "TM169": [
        {
            "NO": 2100,
            "EN": "TM169",
            "JP": "わざマシン１６９",
            "FR": "CT169",
            "DE": "TM169",
            "ES": "MT169",
            "IT": "MT169",
            "KOR": "기술머신169",
            "CHS": "招式学习器１６９",
            "CHT": "招式學習器１６９"
        }
    ],
    "TM170": [
        {
            "NO": 2101,
            "EN": "TM170",
            "JP": "わざマシン１７０",
            "FR": "CT170",
            "DE": "TM170",
            "ES": "MT170",
            "IT": "MT170",
            "KOR": "기술머신170",
            "CHS": "招式学习器１７０",
            "CHT": "招式學習器１７０"
        }
    ],
    "TM171": [
        {
            "NO": 2102,
            "EN": "TM171",
            "JP": "わざマシン１７１",
            "FR": "CT171",
            "DE": "TM171",
            "ES": "MT171",
            "IT": "MT171",
            "KOR": "기술머신171",
            "CHS": "招式学习器１７１",
            "CHT": "招式學習器１７１"
        }
    ],
    "Picnic Set": [
        {
            "NO": 2103,
            "EN": "Picnic Set",
            "JP": "ピクニックセット",
            "FR": "Set de Pique-Nique",
            "DE": "Picknick-Set",
            "ES": "Kit de Pícnic",
            "IT": "Set da picnic",
            "KOR": "피크닉세트",
            "CHS": "野餐组合",
            "CHT": "野餐組合"
        }
    ],
    "Academy Bottle": [
        {
            "NO": 2104,
            "EN": "Academy Bottle",
            "JP": "スクールボトル",
            "FR": "Gourde de l’Académie",
            "DE": "Akademie-Flasche",
            "ES": "Termo Academia",
            "IT": "Borraccia accademia",
            "KOR": "스쿨 보틀",
            "CHS": "校园水壶",
            "CHT": "校園水壺"
        },
        {
            "NO": 2105,
            "EN": "Academy Bottle",
            "JP": "スクールボトル",
            "FR": "Gourde de l’Académie",
            "DE": "Akademie-Flasche",
            "ES": "Termo Academia",
            "IT": "Borraccia accademia",
            "KOR": "스쿨 보틀",
            "CHS": "校园水壶",
            "CHT": "校園水壺"
        }
    ],
    "Polka-Dot Bottle": [
        {
            "NO": 2106,
            "EN": "Polka-Dot Bottle",
            "JP": "みずたまボトル",
            "FR": "Gourde à Pois",
            "DE": "Punkte-Flasche",
            "ES": "Termo Lunares",
            "IT": "Borraccia a pois",
            "KOR": "물방울 보틀",
            "CHS": "圆点水壶",
            "CHT": "圓點水壺"
        }
    ],
    "Striped Bottle": [
        {
            "NO": 2107,
            "EN": "Striped Bottle",
            "JP": "ストライプボトル",
            "FR": "Gourde à Rayures",
            "DE": "Streifen-Flasche",
            "ES": "Termo Rayas",
            "IT": "Borraccia a righe",
            "KOR": "줄무늬 보틀",
            "CHS": "条纹水壶",
            "CHT": "條紋水壺"
        }
    ],
    "Diamond Bottle": [
        {
            "NO": 2108,
            "EN": "Diamond Bottle",
            "JP": "ダイヤボトル",
            "FR": "Gourde à Losanges",
            "DE": "Rauten-Flasche",
            "ES": "Termo Rombos",
            "IT": "Borraccia a rombi",
            "KOR": "다이아 보틀",
            "CHS": "菱纹水壶",
            "CHT": "菱紋水壺"
        }
    ],
    "Academy Cup": [
        {
            "NO": 2109,
            "EN": "Academy Cup",
            "JP": "スクールカップ",
            "FR": "Tasse de l’Académie",
            "DE": "Akademie-Tasse",
            "ES": "Taza Academia",
            "IT": "Tazza accademia",
            "KOR": "스쿨 컵",
            "CHS": "校园水杯",
            "CHT": "校園水杯"
        },
        {
            "NO": 2110,
            "EN": "Academy Cup",
            "JP": "スクールカップ",
            "FR": "Tasse de l’Académie",
            "DE": "Akademie-Tasse",
            "ES": "Taza Academia",
            "IT": "Tazza accademia",
            "KOR": "스쿨 컵",
            "CHS": "校园水杯",
            "CHT": "校園水杯"
        }
    ],
    "Striped Cup": [
        {
            "NO": 2111,
            "EN": "Striped Cup",
            "JP": "たてストライプカップ",
            "FR": "Tasse à Rayures Jaunes",
            "DE": "Längsstreifen-Tasse",
            "ES": "Taza Raya Vertical",
            "IT": "Tazza a righe verticali",
            "KOR": "세로 줄무늬 컵",
            "CHS": "直条纹水杯",
            "CHT": "直條紋水杯"
        }
    ],
    "Polka-Dot Cup": [
        {
            "NO": 2112,
            "EN": "Polka-Dot Cup",
            "JP": "みずたまカップ",
            "FR": "Tasse à Pois",
            "DE": "Punkte-Tasse",
            "ES": "Taza Lunares",
            "IT": "Tazza a pois",
            "KOR": "물방울 컵",
            "CHS": "圆点水杯",
            "CHT": "圓點水杯"
        }
    ],
    "Flower Pattern Cup": [
        {
            "NO": 2113,
            "EN": "Flower Pattern Cup",
            "JP": "フラワーカップ",
            "FR": "Tasse à Fleurs",
            "DE": "Blümchen-Tasse",
            "ES": "Taza Flores",
            "IT": "Tazza a fiori",
            "KOR": "플라워 컵",
            "CHS": "花朵水杯",
            "CHT": "花朵水杯"
        }
    ],
    "Academy Tablecloth": [
        {
            "NO": 2114,
            "EN": "Academy Tablecloth",
            "JP": "スクールクロス",
            "FR": "Nappe de l’Académie",
            "DE": "Akademie-Tischtuch",
            "ES": "Mantel Academia",
            "IT": "Tovaglia accademia",
            "KOR": "스쿨 테이블보",
            "CHS": "校园桌巾",
            "CHT": "校園桌巾"
        },
        {
            "NO": 2115,
            "EN": "Academy Tablecloth",
            "JP": "スクールクロス",
            "FR": "Nappe de l’Académie",
            "DE": "Akademie-Tischtuch",
            "ES": "Mantel Academia",
            "IT": "Tovaglia accademia",
            "KOR": "스쿨 테이블보",
            "CHS": "校园桌巾",
            "CHT": "校園桌巾"
        }
    ],
    "Whimsical Tablecloth": [
        {
            "NO": 2116,
            "EN": "Whimsical Tablecloth",
            "JP": "ファンシークロス",
            "FR": "Nappe Fantaisie",
            "DE": "Zauber-Tischtuch",
            "ES": "Mantel Cuco",
            "IT": "Tovaglia carina",
            "KOR": "팬시 테이블보",
            "CHS": "幻彩桌巾",
            "CHT": "幻彩桌巾"
        }
    ],
    "Leafy Tablecloth": [
        {
            "NO": 2117,
            "EN": "Leafy Tablecloth",
            "JP": "ネイチャークロス",
            "FR": "Nappe Verdoyante",
            "DE": "Natur-Tischtuch",
            "ES": "Mantel Naturaleza",
            "IT": "Tovaglia natura",
            "KOR": "네이처 테이블보",
            "CHS": "大自然桌巾",
            "CHT": "大自然桌巾"
        }
    ],
    "Spooky Tablecloth": [
        {
            "NO": 2118,
            "EN": "Spooky Tablecloth",
            "JP": "うらめしクロス",
            "FR": "Nappe Hantée",
            "DE": "Groll-Tischtuch",
            "ES": "Mantel Espectral",
            "IT": "Tovaglia dispetto",
            "KOR": "원망 테이블보",
            "CHS": "鬼祟桌巾",
            "CHT": "鬼祟桌巾"
        }
    ],
    "Academy Ball": [
        {
            "NO": 2119,
            "EN": "Academy Ball",
            "JP": "スクールボール",
            "FR": "Ballon de l’Académie",
            "DE": "Akademie-Ball",
            "ES": "Pelota Academia",
            "IT": "Palla accademia",
            "KOR": "스쿨볼",
            "CHS": "校园球",
            "CHT": "校園球"
        },
        {
            "NO": 2120,
            "EN": "Academy Ball",
            "JP": "スクールボール",
            "FR": "Ballon de l’Académie",
            "DE": "Akademie-Ball",
            "ES": "Pelota Academia",
            "IT": "Palla accademia",
            "KOR": "스쿨볼",
            "CHS": "校园球",
            "CHT": "校園球"
        }
    ],
    "Marill Ball": [
        {
            "NO": 2121,
            "EN": "Marill Ball",
            "JP": "マリルボール",
            "FR": "Ballon Marill",
            "DE": "Marill-Ball",
            "ES": "Pelota Marill",
            "IT": "Palla Marill",
            "KOR": "마릴볼",
            "CHS": "玛力露球",
            "CHT": "瑪力露球"
        }
    ],
    "Yarn Ball": [
        {
            "NO": 2122,
            "EN": "Yarn Ball",
            "JP": "けいとボール",
            "FR": "Pelote de Laine",
            "DE": "Woll-Ball",
            "ES": "Pelota Ovillo",
            "IT": "Palla gomitolo",
            "KOR": "털실볼",
            "CHS": "毛线球",
            "CHT": "毛線球"
        }
    ],
    "Cyber Ball": [
        {
            "NO": 2123,
            "EN": "Cyber Ball",
            "JP": "ゲーミングボール",
            "FR": "Ballon Gaming",
            "DE": "Cyber-Ball",
            "ES": "Pelota Cibernética",
            "IT": "Palla gaming",
            "KOR": "게이밍볼",
            "CHS": "电竞球",
            "CHT": "電競球"
        }
    ],
    "Gold Pick": [
        {
            "NO": 2124,
            "EN": "Gold Pick",
            "JP": "ゴールドピック",
            "FR": "Pique Dorée",
            "DE": "Gold-Pikser",
            "ES": "Palillo Dorado",
            "IT": "Stecchino oro",
            "KOR": "골드 픽",
            "CHS": "金色三明治签",
            "CHT": "金色三明治籤"
        }
    ],
    "Silver Pick": [
        {
            "NO": 2125,
            "EN": "Silver Pick",
            "JP": "シルバーピック",
            "FR": "Pique Argentée",
            "DE": "Silber-Pikser",
            "ES": "Palillo Plateado",
            "IT": "Stecchino argento",
            "KOR": "실버 픽",
            "CHS": "银色三明治签",
            "CHT": "銀色三明治籤"
        }
    ],
    "Red-Flag Pick": [
        {
            "NO": 2126,
            "EN": "Red-Flag Pick",
            "JP": "あかいはたピック",
            "FR": "Pique à Fanion Rouge",
            "DE": "Rotfahnen-Pikser",
            "ES": "Palillo Bandera Roja",
            "IT": "Bandierina rossa",
            "KOR": "빨강 깃발 픽",
            "CHS": "红旗子三明治签",
            "CHT": "紅旗子三明治籤"
        }
    ],
    "Blue-Flag Pick": [
        {
            "NO": 2127,
            "EN": "Blue-Flag Pick",
            "JP": "あおいはたピック",
            "FR": "Pique à Fanion Bleu",
            "DE": "Blaufahnen-Pikser",
            "ES": "Palillo Bandera Azul",
            "IT": "Bandierina blu",
            "KOR": "파랑 깃발 픽",
            "CHS": "蓝旗子三明治签",
            "CHT": "藍旗子三明治籤"
        }
    ],
    "Pika-Pika Pick": [
        {
            "NO": 2128,
            "EN": "Pika-Pika Pick",
            "JP": "ピカピカピック",
            "FR": "Pique Pikapika",
            "DE": "Pikapika-Pikser",
            "ES": "Palillo Pikachu",
            "IT": "Stecchino Pikachu",
            "KOR": "피카피카 픽",
            "CHS": "皮卡丘三明治签",
            "CHT": "皮卡丘三明治籤"
        }
    ],
    "Winking Pika Pick": [
        {
            "NO": 2129,
            "EN": "Winking Pika Pick",
            "JP": "パチピカピック",
            "FR": "Pique à Chu Fripon",
            "DE": "Zwinker-Pika-Pikser",
            "ES": "Palillo Pikaguiño",
            "IT": "Stecchino pikapika",
            "KOR": "윙크피카 픽",
            "CHS": "眨眼皮卡丘三明治签",
            "CHT": "眨眼皮卡丘三明治籤"
        }
    ],
    "Vee-Vee Pick": [
        {
            "NO": 2130,
            "EN": "Vee-Vee Pick",
            "JP": "ブイブイピック",
            "FR": "Pique Volivoli",
            "DE": "Volivoli-Pikser",
            "ES": "Palillo Eevee",
            "IT": "Stecchino Eevee",
            "KOR": "브이브이 픽",
            "CHS": "伊布三明治签",
            "CHT": "伊布三明治籤"
        }
    ],
    "Smiling Vee Pick": [
        {
            "NO": 2131,
            "EN": "Smiling Vee Pick",
            "JP": "ニコブイピック",
            "FR": "Pique Évo Rit",
            "DE": "Kicher-Voli-Pikser",
            "ES": "Palillo Eevee Feliz",
            "IT": "Stecchino veevee",
            "KOR": "방긋브이 픽",
            "CHS": "笑脸伊布三明治签",
            "CHT": "笑臉伊布三明治籤"
        }
    ],
    "Blue Poké Ball Pick": [
        {
            "NO": 2132,
            "EN": "Blue Poké Ball Pick",
            "JP": "あおボールピック",
            "FR": "Pique à Ball Bleue",
            "DE": "Blauball-Pikser",
            "ES": "Palillo Ball Azul",
            "IT": "Stecchino Ball blu",
            "KOR": "파랑 볼 픽",
            "CHS": "蓝珠珠三明治签",
            "CHT": "藍珠珠三明治籤"
        }
    ],
    "Auspicious Armor": [
        {
            "NO": 2133,
            "EN": "Auspicious Armor",
            "JP": "イワイノヨロイ",
            "FR": "Armure de la Fortune",
            "DE": "Glorienrüstung",
            "ES": "Armadura Auspiciosa",
            "IT": "Armatura fausta",
            "KOR": "축복받은갑옷",
            "CHS": "庆祝之铠",
            "CHT": "慶祝之鎧"
        }
    ],
    "Leader’s Crest": [
        {
            "NO": 2134,
            "EN": "Leader’s Crest",
            "JP": "かしらのしるし",
            "FR": "Emblème du Général",
            "DE": "Anführersymbol",
            "ES": "Distintivo de Líder",
            "IT": "Simbolo del capo",
            "KOR": "대장의징표",
            "CHS": "头领凭证",
            "CHT": "頭領憑證"
        }
    ],
    "Pink Bottle": [
        {
            "NO": 2135,
            "EN": "Pink Bottle",
            "JP": "ピンクボトル",
            "FR": "Gourde Rose",
            "DE": "Pinke Flasche",
            "ES": "Termo Rosa",
            "IT": "Borraccia rosa",
            "KOR": "핑크 보틀",
            "CHS": "粉红水壶",
            "CHT": "粉紅水壺"
        }
    ],
    "Blue Bottle": [
        {
            "NO": 2136,
            "EN": "Blue Bottle",
            "JP": "ブルーボトル",
            "FR": "Gourde Bleue",
            "DE": "Blaue Flasche",
            "ES": "Termo Azul",
            "IT": "Borraccia celeste",
            "KOR": "블루 보틀",
            "CHS": "蓝色水壶",
            "CHT": "藍色水壺"
        }
    ],
    "Yellow Bottle": [
        {
            "NO": 2137,
            "EN": "Yellow Bottle",
            "JP": "イエローボトル",
            "FR": "Gourde Jaune",
            "DE": "Gelbe Flasche",
            "ES": "Termo Amarillo",
            "IT": "Borraccia gialla",
            "KOR": "옐로 보틀",
            "CHS": "黄色水壶",
            "CHT": "黃色水壺"
        }
    ],
    "Steel Bottle (R)": [
        {
            "NO": 2138,
            "EN": "Steel Bottle (R)",
            "JP": "Rステンレスボトル",
            "FR": "Gourde Inox (Rouge)",
            "DE": "Edelstahlflasche (R)",
            "ES": "Termo Metal Rojo",
            "IT": "Borraccia inox R",
            "KOR": "R 스테인리스 보틀",
            "CHS": "红纹不锈钢水壶",
            "CHT": "紅紋不鏽鋼水壺"
        }
    ],
    "Steel Bottle (Y)": [
        {
            "NO": 2139,
            "EN": "Steel Bottle (Y)",
            "JP": "Yステンレスボトル",
            "FR": "Gourde Inox (Jaune)",
            "DE": "Edelstahlflasche (G)",
            "ES": "Termo Metal Amarillo",
            "IT": "Borraccia inox G",
            "KOR": "Y 스테인리스 보틀",
            "CHS": "黄纹不锈钢水壶",
            "CHT": "黃紋不鏽鋼水壺"
        }
    ],
    "Steel Bottle (B)": [
        {
            "NO": 2140,
            "EN": "Steel Bottle (B)",
            "JP": "Bステンレスボトル",
            "FR": "Gourde Inox (Bleu)",
            "DE": "Edelstahlflasche (B)",
            "ES": "Termo Metal Azul",
            "IT": "Borraccia inox B",
            "KOR": "B 스테인리스 보틀",
            "CHS": "蓝纹不锈钢水壶",
            "CHT": "藍紋不鏽鋼水壺"
        }
    ],
    "Silver Bottle": [
        {
            "NO": 2141,
            "EN": "Silver Bottle",
            "JP": "シルバーチタンボトル",
            "FR": "Gourde Titane (Argent)",
            "DE": "Silber-Titanflasche",
            "ES": "Termo Plateado",
            "IT": "Borraccia argento",
            "KOR": "실버 티탄 보틀",
            "CHS": "银钛水壶",
            "CHT": "銀鈦水壺"
        }
    ],
    "Barred Cup": [
        {
            "NO": 2142,
            "EN": "Barred Cup",
            "JP": "よこストライプカップ",
            "FR": "Tasse à Rayures Bleues",
            "DE": "Querstreifen-Tasse",
            "ES": "Taza Raya Horizontal",
            "IT": "Tazza a righe orizzontali",
            "KOR": "가로 줄무늬 컵",
            "CHS": "横条纹水杯",
            "CHT": "橫條紋水杯"
        }
    ],
    "Diamond Pattern Cup": [
        {
            "NO": 2143,
            "EN": "Diamond Pattern Cup",
            "JP": "ダイヤカップ",
            "FR": "Tasse à Losanges",
            "DE": "Rauten-Tasse",
            "ES": "Taza Rombos",
            "IT": "Tazza a rombi",
            "KOR": "다이아 컵",
            "CHS": "菱纹水杯",
            "CHT": "菱紋水杯"
        }
    ],
    "Fire Pattern Cup": [
        {
            "NO": 2144,
            "EN": "Fire Pattern Cup",
            "JP": "ファイヤーカップ",
            "FR": "Tasse à Flammes",
            "DE": "Flammen-Tasse",
            "ES": "Taza Llamas",
            "IT": "Tazza con fiamme",
            "KOR": "파이어 컵",
            "CHS": "火焰水杯",
            "CHT": "火焰水杯"
        }
    ],
    "Pink Cup": [
        {
            "NO": 2145,
            "EN": "Pink Cup",
            "JP": "ピンクカップ",
            "FR": "Tasse Rose",
            "DE": "Pinke Tasse",
            "ES": "Taza Rosa",
            "IT": "Tazza rosa",
            "KOR": "핑크 컵",
            "CHS": "粉红水杯",
            "CHT": "粉紅水杯"
        }
    ],
    "Blue Cup": [
        {
            "NO": 2146,
            "EN": "Blue Cup",
            "JP": "ブルーカップ",
            "FR": "Tasse Bleue",
            "DE": "Blaue Tasse",
            "ES": "Taza Azul",
            "IT": "Tazza celeste",
            "KOR": "블루 컵",
            "CHS": "蓝色水杯",
            "CHT": "藍色水杯"
        }
    ],
    "Yellow Cup": [
        {
            "NO": 2147,
            "EN": "Yellow Cup",
            "JP": "イエローカップ",
            "FR": "Tasse Jaune",
            "DE": "Gelbe Tasse",
            "ES": "Taza Amarilla",
            "IT": "Tazza gialla",
            "KOR": "옐로 컵",
            "CHS": "黄色水杯",
            "CHT": "黃色水杯"
        }
    ],
    "Pikachu Cup": [
        {
            "NO": 2148,
            "EN": "Pikachu Cup",
            "JP": "ピカチュウカップ",
            "FR": "Tasse Pikachu",
            "DE": "Pikachu-Tasse",
            "ES": "Taza Pikachu",
            "IT": "Tazza Pikachu",
            "KOR": "피카츄 컵",
            "CHS": "皮卡丘水杯",
            "CHT": "皮卡丘水杯"
        }
    ],
    "Eevee Cup": [
        {
            "NO": 2149,
            "EN": "Eevee Cup",
            "JP": "イーブイカップ",
            "FR": "Tasse Évoli",
            "DE": "Evoli-Tasse",
            "ES": "Taza Eevee",
            "IT": "Tazza Eevee",
            "KOR": "이브이 컵",
            "CHS": "伊布水杯",
            "CHT": "伊布水杯"
        }
    ],
    "Slowpoke Cup": [
        {
            "NO": 2150,
            "EN": "Slowpoke Cup",
            "JP": "ヤドンカップ",
            "FR": "Tasse Ramoloss",
            "DE": "Flegmon-Tasse",
            "ES": "Taza Slowpoke",
            "IT": "Tazza Slowpoke",
            "KOR": "야돈 컵",
            "CHS": "呆呆兽水杯",
            "CHT": "呆呆獸水杯"
        }
    ],
    "Silver Cup": [
        {
            "NO": 2151,
            "EN": "Silver Cup",
            "JP": "シルバーチタンカップ",
            "FR": "Tasse Titane (Argent)",
            "DE": "Silber-Titantasse",
            "ES": "Taza Plateada",
            "IT": "Tazza argento",
            "KOR": "실버 티탄 컵",
            "CHS": "银钛水杯",
            "CHT": "銀鈦水杯"
        }
    ],
    "Exercise Ball": [
        {
            "NO": 2152,
            "EN": "Exercise Ball",
            "JP": "バランスボール",
            "FR": "Ballon d’Exercice",
            "DE": "Gymnastik-Ball",
            "ES": "Pelota Pilates",
            "IT": "Palla fitness",
            "KOR": "밸런스볼",
            "CHS": "瑜珈球",
            "CHT": "瑜珈球"
        }
    ],
    "Plaid Tablecloth (Y)": [
        {
            "NO": 2153,
            "EN": "Plaid Tablecloth (Y)",
            "JP": "きいろチェッククロス",
            "FR": "Nappe Tartan Jaune",
            "DE": "Gelbkaro-Tischtuch",
            "ES": "Mantel Cuadros Ámbar",
            "IT": "Tovaglia a quadri gialla",
            "KOR": "옐로 체크 테이블보",
            "CHS": "黄色格子桌巾",
            "CHT": "黃色格子桌巾"
        }
    ],
    "Plaid Tablecloth (B)": [
        {
            "NO": 2154,
            "EN": "Plaid Tablecloth (B)",
            "JP": "あおチェッククロス",
            "FR": "Nappe Tartan Bleue",
            "DE": "Blaukaro-Tischtuch",
            "ES": "Mantel Cuadros Azul",
            "IT": "Tovaglia a quadri viola",
            "KOR": "블루 체크 테이블보",
            "CHS": "蓝色格子桌巾",
            "CHT": "藍色格子桌巾"
        }
    ],
    "Plaid Tablecloth (R)": [
        {
            "NO": 2155,
            "EN": "Plaid Tablecloth (R)",
            "JP": "あかチェッククロス",
            "FR": "Nappe Tartan Rouge",
            "DE": "Rotkaro-Tischtuch",
            "ES": "Mantel Cuadros Rojo",
            "IT": "Tovaglia a quadri rossa",
            "KOR": "레드 체크 테이블보",
            "CHS": "红色格子桌巾",
            "CHT": "紅色格子桌巾"
        }
    ],
    "B&W Grass Tablecloth": [
        {
            "NO": 2156,
            "EN": "B&W Grass Tablecloth",
            "JP": "くさむらモノクロス",
            "FR": "Nappe Hautes Herbes",
            "DE": "Retro-Gras-Tischtuch",
            "ES": "Mantel Hierba Alta",
            "IT": "Tovaglia erba alta",
            "KOR": "풀숲 흑백 테이블보",
            "CHS": "黑白草丛桌巾",
            "CHT": "黑白草叢桌巾"
        }
    ],
    "Battle Tablecloth": [
        {
            "NO": 2157,
            "EN": "Battle Tablecloth",
            "JP": "しょうぶクロス",
            "FR": "Nappe Combat Pokémon",
            "DE": "Action-Tischtuch",
            "ES": "Mantel Combate",
            "IT": "Tovaglia sfida",
            "KOR": "배틀 테이블보",
            "CHS": "对决桌巾",
            "CHT": "對決桌巾"
        }
    ],
    "Monstrous Tablecloth": [
        {
            "NO": 2158,
            "EN": "Monstrous Tablecloth",
            "JP": "かいじゅうクロス",
            "FR": "Nappe Kaiju",
            "DE": "Ungeheuer-Tischtuch",
            "ES": "Mantel Monstruoso",
            "IT": "Tovaglia mostruosa",
            "KOR": "괴수 테이블보",
            "CHS": "怪兽桌巾",
            "CHT": "怪獸桌巾"
        }
    ],
    "Striped Tablecloth": [
        {
            "NO": 2159,
            "EN": "Striped Tablecloth",
            "JP": "ストライプクロス",
            "FR": "Nappe à Rayures",
            "DE": "Streifen-Tischtuch",
            "ES": "Mantel Rayas",
            "IT": "Tovaglia a righe",
            "KOR": "줄무늬 테이블보",
            "CHS": "条纹桌巾",
            "CHT": "條紋桌巾"
        }
    ],
    "Diamond Tablecloth": [
        {
            "NO": 2160,
            "EN": "Diamond Tablecloth",
            "JP": "ダイヤクロス",
            "FR": "Nappe à Losanges",
            "DE": "Rauten-Tischtuch",
            "ES": "Mantel Rombos",
            "IT": "Tovaglia a rombi",
            "KOR": "다이아 테이블보",
            "CHS": "菱纹桌巾",
            "CHT": "菱紋桌巾"
        }
    ],
    "Polka-Dot Tablecloth": [
        {
            "NO": 2161,
            "EN": "Polka-Dot Tablecloth",
            "JP": "みずたまクロス",
            "FR": "Nappe à Pois",
            "DE": "Punkte-Tischtuch",
            "ES": "Mantel Lunares",
            "IT": "Tovaglia a pois",
            "KOR": "물방울 테이블보",
            "CHS": "圆点桌巾",
            "CHT": "圓點桌巾"
        }
    ],
    "Lilac Tablecloth": [
        {
            "NO": 2162,
            "EN": "Lilac Tablecloth",
            "JP": "パープルクロス",
            "FR": "Nappe Mauve",
            "DE": "Violettes Tischtuch",
            "ES": "Mantel Malva",
            "IT": "Tovaglia lilla",
            "KOR": "퍼플 테이블보",
            "CHS": "紫色桌巾",
            "CHT": "紫色桌巾"
        }
    ],
    "Mint Tablecloth": [
        {
            "NO": 2163,
            "EN": "Mint Tablecloth",
            "JP": "ミントクロス",
            "FR": "Nappe Menthe",
            "DE": "Türkises Tischtuch",
            "ES": "Mantel Menta",
            "IT": "Tovaglia menta",
            "KOR": "민트 테이블보",
            "CHS": "浅绿桌巾",
            "CHT": "淺綠桌巾"
        }
    ],
    "Peach Tablecloth": [
        {
            "NO": 2164,
            "EN": "Peach Tablecloth",
            "JP": "ベージュクロス",
            "FR": "Nappe Beige",
            "DE": "Beiges Tischtuch",
            "ES": "Mantel Beis",
            "IT": "Tovaglia pesca",
            "KOR": "베이지 테이블보",
            "CHS": "米色桌巾",
            "CHT": "米色桌巾"
        }
    ],
    "Yellow Tablecloth": [
        {
            "NO": 2165,
            "EN": "Yellow Tablecloth",
            "JP": "イエロークロス",
            "FR": "Nappe Jaune",
            "DE": "Gelbes Tischtuch",
            "ES": "Mantel Amarillo",
            "IT": "Tovaglia gialla",
            "KOR": "옐로 테이블보",
            "CHS": "黄色桌巾",
            "CHT": "黃色桌巾"
        }
    ],
    "Blue Tablecloth": [
        {
            "NO": 2166,
            "EN": "Blue Tablecloth",
            "JP": "ブルークロス",
            "FR": "Nappe Bleue",
            "DE": "Blaues Tischtuch",
            "ES": "Mantel Azul",
            "IT": "Tovaglia blu",
            "KOR": "블루 테이블보",
            "CHS": "蓝色桌巾",
            "CHT": "藍色桌巾"
        }
    ],
    "Pink Tablecloth": [
        {
            "NO": 2167,
            "EN": "Pink Tablecloth",
            "JP": "ピンククロス",
            "FR": "Nappe Rose",
            "DE": "Pinkes Tischtuch",
            "ES": "Mantel Rosa",
            "IT": "Tovaglia rosa",
            "KOR": "핑크 테이블보",
            "CHS": "粉红桌巾",
            "CHT": "粉紅桌巾"
        }
    ],
    "Gold Bottle": [
        {
            "NO": 2168,
            "EN": "Gold Bottle",
            "JP": "ゴールドチタンボトル",
            "FR": "Gourde Titane (Or)",
            "DE": "Gold-Titanflasche",
            "ES": "Termo Dorado",
            "IT": "Borraccia oro",
            "KOR": "골드 티탄 보틀",
            "CHS": "金钛水壶",
            "CHT": "金鈦水壺"
        }
    ],
    "Bronze Bottle": [
        {
            "NO": 2169,
            "EN": "Bronze Bottle",
            "JP": "ブロンズチタンボトル",
            "FR": "Gourde Titane (Bronze)",
            "DE": "Bronze-Titanflasche",
            "ES": "Termo Bronceado",
            "IT": "Borraccia bronzo",
            "KOR": "브론즈 티탄 보틀",
            "CHS": "铜钛水壶",
            "CHT": "銅鈦水壺"
        }
    ],
    "Gold Cup": [
        {
            "NO": 2170,
            "EN": "Gold Cup",
            "JP": "ゴールドチタンカップ",
            "FR": "Tasse Titane (Or)",
            "DE": "Gold-Titantasse",
            "ES": "Taza Dorada",
            "IT": "Tazza oro",
            "KOR": "골드 티탄 컵",
            "CHS": "金钛水杯",
            "CHT": "金鈦水杯"
        }
    ],
    "Bronze Cup": [
        {
            "NO": 2171,
            "EN": "Bronze Cup",
            "JP": "ブロンズチタンカップ",
            "FR": "Tasse Titane (Bronze)",
            "DE": "Bronze-Titantasse",
            "ES": "Taza Bronceada",
            "IT": "Tazza bronzo",
            "KOR": "브론즈 티탄 컵",
            "CHS": "铜钛水杯",
            "CHT": "銅鈦水杯"
        }
    ],
    "Green Poké Ball Pick": [
        {
            "NO": 2172,
            "EN": "Green Poké Ball Pick",
            "JP": "みどりボールピック",
            "FR": "Pique à Ball Verte",
            "DE": "Grünball-Pikser",
            "ES": "Palillo Ball Verde",
            "IT": "Stecchino Ball verde",
            "KOR": "초록 볼 픽",
            "CHS": "绿珠珠三明治签",
            "CHT": "綠珠珠三明治籤"
        }
    ],
    "Red Poké Ball Pick": [
        {
            "NO": 2173,
            "EN": "Red Poké Ball Pick",
            "JP": "あかボールピック",
            "FR": "Pique à Ball Rouge",
            "DE": "Rotball-Pikser",
            "ES": "Palillo Ball Roja",
            "IT": "Stecchino Ball rosso",
            "KOR": "빨강 볼 픽",
            "CHS": "红珠珠三明治签",
            "CHT": "紅珠珠三明治籤"
        }
    ],
    "Party Sparkler Pick": [
        {
            "NO": 2174,
            "EN": "Party Sparkler Pick",
            "JP": "おいわいはなびピック",
            "FR": "Pique Feu d’Artifice",
            "DE": "Wunderkerzen-Pikser",
            "ES": "Palillo Bengala",
            "IT": "Stecchino scintille",
            "KOR": "축하 폭죽 픽",
            "CHS": "烟花祝庆三明治签",
            "CHT": "煙火祝慶三明治籤"
        }
    ],
    "Heroic Sword Pick": [
        {
            "NO": 2175,
            "EN": "Heroic Sword Pick",
            "JP": "ゆうしゃのけんピック",
            "FR": "Pique Épée du Héros",
            "DE": "Heldenschwert-Pikser",
            "ES": "Palillo Heroico",
            "IT": "Stecchino spadone",
            "KOR": "용사의 검 픽",
            "CHS": "勇者之剑三明治签",
            "CHT": "勇者之劍三明治籤"
        }
    ],
    "Magical Star Pick": [
        {
            "NO": 2176,
            "EN": "Magical Star Pick",
            "JP": "マジカルスターピック",
            "FR": "Pique Étoile Magique",
            "DE": "Zauberstern-Pikser",
            "ES": "Palillo Estrella",
            "IT": "Stecchino magistella",
            "KOR": "매지컬 스타 픽",
            "CHS": "魔法星星三明治签",
            "CHT": "魔法星星三明治籤"
        }
    ],
    "Magical Heart Pick": [
        {
            "NO": 2177,
            "EN": "Magical Heart Pick",
            "JP": "マジカルハートピック",
            "FR": "Pique Cœur Magique",
            "DE": "Zauberherz-Pikser",
            "ES": "Palillo Corazón",
            "IT": "Stecchino magicuore",
            "KOR": "매지컬 하트 픽",
            "CHS": "魔法甜心三明治签",
            "CHT": "魔法甜心三明治籤"
        }
    ],
    "Parasol Pick": [
        {
            "NO": 2178,
            "EN": "Parasol Pick",
            "JP": "パラソルピック",
            "FR": "Pique Parasol",
            "DE": "Schirmchen-Pikser",
            "ES": "Palillo Sombrilla",
            "IT": "Ombrellino",
            "KOR": "파라솔 픽",
            "CHS": "阳伞三明治签",
            "CHT": "陽傘三明治籤"
        }
    ],
    "Blue-Sky Flower Pick": [
        {
            "NO": 2179,
            "EN": "Blue-Sky Flower Pick",
            "JP": "あおぞらおはなピック",
            "FR": "Pique Fleur d’Azur",
            "DE": "Mittagsblumen-Pikser",
            "ES": "Palillo Flor Azul",
            "IT": "Stecchino fiore blu",
            "KOR": "푸른하늘 꽃 픽",
            "CHS": "晴空花三明治签",
            "CHT": "晴空花三明治籤"
        }
    ],
    "Sunset Flower Pick": [
        {
            "NO": 2180,
            "EN": "Sunset Flower Pick",
            "JP": "ゆうやけおはなピック",
            "FR": "Pique Fleur du Ponant",
            "DE": "Abendblumen-Pikser",
            "ES": "Palillo Flor Naranja",
            "IT": "Stecchino fiore arancio",
            "KOR": "저녁노을 꽃 픽",
            "CHS": "夕阳花三明治签",
            "CHT": "夕陽花三明治籤"
        }
    ],
    "Sunrise Flower Pick": [
        {
            "NO": 2181,
            "EN": "Sunrise Flower Pick",
            "JP": "あさやけおはなピック",
            "FR": "Pique Fleur du Levant",
            "DE": "Morgenblumen-Pikser",
            "ES": "Palillo Flor Rosa",
            "IT": "Stecchino fiore rosso",
            "KOR": "아침노을 꽃 픽",
            "CHS": "朝霞花三明治签",
            "CHT": "朝霞花三明治籤"
        }
    ],
    "Blue Dish": [
        {
            "NO": 2182,
            "EN": "Blue Dish",
            "JP": "ブループレート",
            "FR": "Assiette Bleue",
            "DE": "Blauer Teller",
            "ES": "Plato Azul",
            "IT": "Piatto celeste",
            "KOR": "블루 플레이트",
            "CHS": "蓝色盘子",
            "CHT": "藍色盤子"
        }
    ],
    "Green Dish": [
        {
            "NO": 2183,
            "EN": "Green Dish",
            "JP": "グリーンプレート",
            "FR": "Assiette Verte",
            "DE": "Grüner Teller",
            "ES": "Plato Verde",
            "IT": "Piatto verde",
            "KOR": "그린 플레이트",
            "CHS": "绿色盘子",
            "CHT": "綠色盤子"
        }
    ],
    "Orange Dish": [
        {
            "NO": 2184,
            "EN": "Orange Dish",
            "JP": "オレンジプレート",
            "FR": "Assiette Orange",
            "DE": "Oranger Teller",
            "ES": "Plato Naranja",
            "IT": "Piatto arancione",
            "KOR": "오렌지 플레이트",
            "CHS": "橘色盘子",
            "CHT": "橘色盤子"
        }
    ],
    "Red Dish": [
        {
            "NO": 2185,
            "EN": "Red Dish",
            "JP": "レッドプレート",
            "FR": "Assiette Rouge",
            "DE": "Roter Teller",
            "ES": "Plato Rojo",
            "IT": "Piatto rosso",
            "KOR": "레드 플레이트",
            "CHS": "红色盘子",
            "CHT": "紅色盤子"
        }
    ],
    "White Dish": [
        {
            "NO": 2186,
            "EN": "White Dish",
            "JP": "ホワイトプレート",
            "FR": "Assiette Blanche",
            "DE": "Weißer Teller",
            "ES": "Plato Blanco",
            "IT": "Piatto bianco",
            "KOR": "화이트 플레이트",
            "CHS": "白色盘子",
            "CHT": "白色盤子"
        }
    ],
    "Yellow Dish": [
        {
            "NO": 2187,
            "EN": "Yellow Dish",
            "JP": "イエロープレート",
            "FR": "Assiette Jaune",
            "DE": "Gelber Teller",
            "ES": "Plato Amarillo",
            "IT": "Piatto giallo",
            "KOR": "옐로 플레이트",
            "CHS": "黄色盘子",
            "CHT": "黃色盤子"
        }
    ]
}